(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirefccd"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirefccd"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lbIEO", function(module, exports) {
parcelRequire("lkhm9");
parcelRequire("3wTG3");
parcelRequire("aITai");
parcelRequire("9jmJF");
parcelRequire("76V10");
parcelRequire("gg9zr");
parcelRequire("fEeKn");

});
parcelRegister("lkhm9", function(module, exports) {
/*
 * Stretchy: Form element autosizing, the way it should be.
 * by Lea Verou http://lea.verou.me
 * MIT license
 */ (function() {
    if (!self.Element) return; // super old browser
    if (!Element.prototype.matches) Element.prototype.matches = Element.prototype.webkitMatchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || null;
    if (!Element.prototype.matches) return;
    function $$(expr, con) {
        return expr instanceof Node || expr instanceof Window ? [
            expr
        ] : [].slice.call(typeof expr == "string" ? (con || document).querySelectorAll(expr) : expr || []);
    }
    var _ = self.Stretchy = {
        selectors: {
            base: 'textarea, select:not([size]), input:not([type]), input[type="' + "text url email tel".split(" ").join('"], input[type="') + '"]',
            filter: "*"
        },
        // Script element this was included with, if any
        script: document.currentScript || $$("script").pop(),
        // Autosize one element. The core of Stretchy.
        resize: function(element) {
            if (!_.resizes(element)) return;
            var cs = getComputedStyle(element);
            var offset = 0;
            if (!element.value && element.placeholder) {
                var empty = true;
                element.value = element.placeholder;
            }
            var type = element.nodeName.toLowerCase();
            if (type == "textarea") {
                element.style.height = "0";
                if (cs.boxSizing == "border-box") offset = element.offsetHeight;
                else if (cs.boxSizing == "content-box") offset = -element.clientHeight;
                element.style.height = element.scrollHeight + offset + "px";
            } else if (type == "input") {
                element.style.width = "0";
                if (cs.boxSizing == "border-box") offset = element.offsetWidth;
                else if (cs.boxSizing == "padding-box") offset = element.clientWidth;
                // Safari misreports scrollWidth, so we will instead set scrollLeft to a
                // huge number, and read that back to see what it was clipped to
                element.scrollLeft = 1e+10;
                var width = Math.max(element.scrollLeft + offset, element.scrollWidth - element.clientWidth);
                element.style.width = width + "px";
            } else if (type == "select") {
                var selectedIndex = element.selectedIndex > 0 ? element.selectedIndex : 0;
                // Need to use dummy element to measure :(
                var option = document.createElement("_");
                option.textContent = element.options[selectedIndex].textContent;
                element.parentNode.insertBefore(option, element.nextSibling);
                // The name of the appearance property, as it might be prefixed
                var appearance;
                for(var property in cs)if (!/^(width|webkitLogicalWidth)$/.test(property)) {
                    //console.log(property, option.offsetWidth, cs[property]);
                    option.style[property] = cs[property];
                    if (/appearance$/i.test(property)) appearance = property;
                }
                option.style.width = "";
                if (option.offsetWidth > 0) {
                    element.style.width = option.offsetWidth + "px";
                    if (!cs[appearance] || cs[appearance] !== "none") // Account for arrow
                    element.style.width = "calc(" + element.style.width + " + 2em)";
                }
                option.parentNode.removeChild(option);
                option = null;
            }
            if (empty) element.value = "";
        },
        // Autosize multiple elements
        resizeAll: function(elements) {
            $$(elements || _.selectors.base).forEach(function(element) {
                _.resize(element);
            });
        },
        active: true,
        // Will stretchy do anything for this element?
        resizes: function(element) {
            return element && element.parentNode && element.matches && element.matches(_.selectors.base) && element.matches(_.selectors.filter);
        },
        init: function() {
            _.selectors.filter = _.script.getAttribute("data-filter") || ($$("[data-stretchy-filter]").pop() || document.body).getAttribute("data-stretchy-filter") || Stretchy.selectors.filter || "*";
            _.resizeAll();
        },
        $$: $$
    };
    // Autosize all elements once the DOM is loaded
    // DOM already loaded?
    if (document.readyState !== "loading") _.init();
    else // Wait for it
    document.addEventListener("DOMContentLoaded", _.init);
    // Listen for changes
    var listener = function(evt) {
        if (_.active) _.resize(evt.target);
    };
    document.documentElement.addEventListener("input", listener);
    // Firefox fires a change event instead of an input event
    document.documentElement.addEventListener("change", listener);
    // Listen for new elements
    if (self.MutationObserver) new MutationObserver(function(mutations) {
        if (_.active) mutations.forEach(function(mutation) {
            if (mutation.type == "childList") Stretchy.resizeAll(mutation.addedNodes);
        });
    }).observe(document.documentElement, {
        childList: true,
        subtree: true
    });
})();

});

parcelRegister("3wTG3", function(module, exports) {
/***
@module up
 */ (function() {
    window.up = {
        version: "0.62.1"
    };
}).call(module.exports);
/***
Utility functions
=================

The `up.util` module contains functions to facilitate the work with basic JavaScript
values like lists, strings or functions.

You will recognize many functions form other utility libraries like [Lodash](https://lodash.com/).
While feature parity with Lodash is not a goal of `up.util`, you might find it sufficient
to not include another library in your asset bundle.

@module up.util
 */ (function() {
    var slice = [].slice, hasProp = {}.hasOwnProperty;
    up.util = function() {
        /***
    A function that does nothing.
    
    @function up.util.noop
    @experimental
     */ var ESCAPE_HTML_ENTITY_MAP, always, arrayToSet, assign, assignPolyfill, asyncNoop, compact, contains, copy, deepCopy, each, eachIterator, endsWith, escapeHtml, escapePressed, escapeRegexp, evalOption, every, except, extractCallback, extractLastArg, extractOptions, fail, filterList, findInList, findResult, flatMap, flatten, horizontalScreenHalf, identity, intersect, isArguments, isArray, isBasicObjectProperty, isBlank, isBoolean, isCrossDomain, isDefined, isElement, isEqual, isEqualList, isFormData, isFunction, isGiven, isHTMLCollection, isJQuery, isList, isMissing, isNodeList, isNull, isNumber, isObject, isOptions, isPresent, isPromise, isStandardPort, isString, isTruthy, isUndefined, isUnmodifiedKeyEvent, isUnmodifiedMouseEvent, iteratee, last, map, mapObject, memoize, merge, methodAllowsPayload, muteRejection, newDeferred, newOptions, nextUid, noop, normalizeMethod, normalizeUrl, objectValues, only, parseUrl, partial, pluckKey, presence, previewable, queueMicrotask, queueTask, reject, rejectOnError, remove, renameKey, scheduleTimer, sequence, setToArray, simpleEase, some, splitValues, sum, times, toArray, uid, uniq, uniqBy, unresolvablePromise, valuesPolyfill, wrapList, wrapValue;
        noop = function() {};
        /***
    A function that returns a resolved promise.
    
    @function up.util.asyncNoop
    @internal
     */ asyncNoop = function() {
            return Promise.resolve();
        };
        /***
    Ensures that the given function can only be called a single time.
    Subsequent calls will return the return value of the first call.
    
    Note that this is a simple implementation that
    doesn't distinguish between argument lists.
    
    @function up.util.memoize
    @internal
     */ memoize = function(func) {
            var cached, cachedValue;
            cachedValue = void 0;
            cached = false;
            return function() {
                var args;
                args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
                if (cached) return cachedValue;
                else {
                    cached = true;
                    return cachedValue = func.apply(null, args);
                }
            };
        };
        /***
    Returns if the given port is the default port for the given protocol.
    
    @function up.util.isStandardPort
    @internal
     */ isStandardPort = function(protocol, port) {
            port = port.toString();
            return (port === "" || port === "80") && protocol === "http:" || port === "443" && protocol === "https:";
        };
        /***
    Normalizes relative paths and absolute paths to a full URL
    that can be checked for equality with other normalized URLs.
    
    By default hashes are ignored, search queries are included.
    
    @function up.util.normalizeUrl
    @param {boolean} [options.hash=false]
      Whether to include an `#hash` anchor in the normalized URL
    @param {boolean} [options.search=true]
      Whether to include a `?query` string in the normalized URL
    @param {boolean} [options.stripTrailingSlash=false]
      Whether to strip a trailing slash from the pathname
    @internal
     */ normalizeUrl = function(urlOrAnchor, options) {
            var normalized, parts, pathname;
            parts = parseUrl(urlOrAnchor);
            normalized = parts.protocol + "//" + parts.hostname;
            if (!isStandardPort(parts.protocol, parts.port)) normalized += ":" + parts.port;
            pathname = parts.pathname;
            if ((options != null ? options.stripTrailingSlash : void 0) === true) pathname = pathname.replace(/\/$/, "");
            normalized += pathname;
            if ((options != null ? options.search : void 0) !== false) normalized += parts.search;
            if ((options != null ? options.hash : void 0) === true) normalized += parts.hash;
            return normalized;
        };
        isCrossDomain = function(targetUrl) {
            var currentUrl;
            currentUrl = parseUrl(location.href);
            targetUrl = parseUrl(targetUrl);
            return currentUrl.protocol !== targetUrl.protocol || currentUrl.hostname !== targetUrl.hostname;
        };
        /***
    Parses the given URL into components such as hostname and path.
    
    If the given URL is not fully qualified, it is assumed to be relative
    to the current page.
    
    @function up.util.parseUrl
    @return {Object}
      The parsed URL as an object with
      `protocol`, `hostname`, `port`, `pathname`, `search` and `hash`
      properties.
    @stable
     */ parseUrl = function(urlOrLink) {
            var link;
            if (isJQuery(urlOrLink)) link = up.element.get(urlOrLink);
            else if (urlOrLink.pathname) link = urlOrLink;
            else {
                link = document.createElement("a");
                link.href = urlOrLink;
            }
            if (!link.hostname) link.href = link.href;
            if (link.pathname[0] !== "/") {
                link = only(link, "protocol", "hostname", "port", "pathname", "search", "hash");
                link.pathname = "/" + link.pathname;
            }
            return link;
        };
        /***
    @function up.util.normalizeMethod
    @internal
     */ normalizeMethod = function(method) {
            if (method) return method.toUpperCase();
            else return "GET";
        };
        /***
    @function up.util.methodAllowsPayload
    @internal
     */ methodAllowsPayload = function(method) {
            return method !== "GET" && method !== "HEAD";
        };
        assignPolyfill = function() {
            var i, key, len, source, sources, target, value;
            target = arguments[0], sources = 2 <= arguments.length ? slice.call(arguments, 1) : [];
            for(i = 0, len = sources.length; i < len; i++){
                source = sources[i];
                for(key in source){
                    if (!hasProp.call(source, key)) continue;
                    value = source[key];
                    target[key] = value;
                }
            }
            return target;
        };
        /***
    Merge the own properties of one or more `sources` into the `target` object.
    
    @function up.util.assign
    @param {Object} target
    @param {Array<Object>} sources...
    @stable
     */ assign = Object.assign || assignPolyfill;
        valuesPolyfill = function(object) {
            var key, results, value;
            results = [];
            for(key in object){
                value = object[key];
                results.push(value);
            }
            return results;
        };
        /***
    Returns an array of values of the given object.
    
    @function up.util.values
    @param {Object} object
    @return {Array<string>}
    @stable
     */ objectValues = Object.values || valuesPolyfill;
        iteratee = function(block) {
            if (isString(block)) return function(item) {
                return item[block];
            };
            else return block;
        };
        /***
    Translate all items in an array to new array of items.
    
    @function up.util.map
    @param {Array} array
    @param {Function(element, index): any|String} block
      A function that will be called with each element and (optional) iteration index.
    
      You can also pass a property name as a String,
      which will be collected from each item in the array.
    @return {Array}
      A new array containing the result of each function call.
    @stable
     */ map = function(array, block) {
            var i, index, item, len, results;
            if (array.length === 0) return [];
            block = iteratee(block);
            results = [];
            for(index = i = 0, len = array.length; i < len; index = ++i){
                item = array[index];
                results.push(block(item, index));
            }
            return results;
        };
        /***
    @function up.util.mapObject
    @internal
     */ mapObject = function(array, pairer) {
            var merger;
            merger = function(object, pair) {
                object[pair[0]] = pair[1];
                return object;
            };
            return map(array, pairer).reduce(merger, {});
        };
        /***
    Calls the given function for each element (and, optional, index)
    of the given array.
    
    @function up.util.each
    @param {Array} array
    @param {Function(element, index)} block
      A function that will be called with each element and (optional) iteration index.
    @stable
     */ each = map;
        eachIterator = function(iterator, callback) {
            var entry, results;
            results = [];
            while((entry = iterator.next()) && !entry.done)results.push(callback(entry.value));
            return results;
        };
        /***
    Calls the given function for the given number of times.
    
    @function up.util.times
    @param {number} count
    @param {Function()} block
    @stable
     */ times = function(count, block) {
            var i, iteration, ref, results;
            results = [];
            for(iteration = i = 0, ref = count - 1; 0 <= ref ? i <= ref : i >= ref; iteration = 0 <= ref ? ++i : --i)results.push(block(iteration));
            return results;
        };
        /***
    Returns whether the given argument is `null`.
    
    @function up.util.isNull
    @param object
    @return {boolean}
    @stable
     */ isNull = function(object) {
            return object === null;
        };
        /***
    Returns whether the given argument is `undefined`.
    
    @function up.util.isUndefined
    @param object
    @return {boolean}
    @stable
     */ isUndefined = function(object) {
            return object === void 0;
        };
        /***
    Returns whether the given argument is not `undefined`.
    
    @function up.util.isDefined
    @param object
    @return {boolean}
    @stable
     */ isDefined = function(object) {
            return !isUndefined(object);
        };
        /***
    Returns whether the given argument is either `undefined` or `null`.
    
    Note that empty strings or zero are *not* considered to be "missing".
    
    For the opposite of `up.util.isMissing()` see [`up.util.isGiven()`](/up.util.isGiven).
    
    @function up.util.isMissing
    @param object
    @return {boolean}
    @stable
     */ isMissing = function(object) {
            return isUndefined(object) || isNull(object);
        };
        /***
    Returns whether the given argument is neither `undefined` nor `null`.
    
    Note that empty strings or zero *are* considered to be "given".
    
    For the opposite of `up.util.isGiven()` see [`up.util.isMissing()`](/up.util.isMissing).
    
    @function up.util.isGiven
    @param object
    @return {boolean}
    @stable
     */ isGiven = function(object) {
            return !isMissing(object);
        };
        /***
    Return whether the given argument is considered to be blank.
    
    By default, this function returns `true` for:
    
    - `undefined`
    - `null`
    - Empty strings
    - Empty arrays
    - A plain object without own enumerable properties
    
    All other arguments return `false`.
    
    To check implement blank-ness checks for user-defined classes,
    see `up.util.isBlank.key`.
    
    @function up.util.isBlank
    @param value
      The value is to check.
    @return {boolean}
      Whether the value is blank.
    @stable
     */ isBlank = function(value) {
            if (isMissing(value)) return true;
            if (isObject(value) && value[isBlank.key]) return value[isBlank.key]();
            if (isString(value) || isList(value)) return value.length === 0;
            if (isOptions(value)) return Object.keys(value).length === 0;
            return false;
        };
        /***
    This property contains the name of a method that user-defined classes
    may implement to hook into the `up.util.isBlank()` protocol.
    
    \#\#\# Example
    
    We have a user-defined `Account` class that we want to use with `up.util.isBlank()`:
    
    ```
    class Account {
      constructor(email) {
        this.email = email
      }
    
      [up.util.isBlank.key]() {
        return up.util.isBlank(this.email)
      }
    }
    ```
    
    Note that the protocol method is not actually named `'up.util.isBlank.key'`.
    Instead it is named after the *value* of the `up.util.isBlank.key` property.
    To do so, the code sample above is using a
    [computed property name](https://medium.com/front-end-weekly/javascript-object-creation-356e504173a8)
    in square brackets.
    
    We may now use `Account` instances with `up.util.isBlank()`:
    
    ```
    foo = new Account('foo@foo.com')
    bar = new Account('')
    
    console.log(up.util.isBlank(foo)) // prints false
    console.log(up.util.isBlank(bar)) // prints true
    ```
    
    @property up.util.isBlank.key
    @experimental
     */ isBlank.key = "up.util.isBlank";
        /***
    Returns the given argument if the argument is [present](/up.util.isPresent),
    otherwise returns `undefined`.
    
    @function up.util.presence
    @param value
    @param {Function(value): boolean} [tester=up.util.isPresent]
      The function that will be used to test whether the argument is present.
    @return {any|undefined}
    @stable
     */ presence = function(value, tester) {
            if (tester == null) tester = isPresent;
            if (tester(value)) return value;
            else return void 0;
        };
        /***
    Returns whether the given argument is not [blank](/up.util.isBlank).
    
    @function up.util.isPresent
    @param object
    @return {boolean}
    @stable
     */ isPresent = function(object) {
            return !isBlank(object);
        };
        /***
    Returns whether the given argument is a function.
    
    @function up.util.isFunction
    @param object
    @return {boolean}
    @stable
     */ isFunction = function(object) {
            return typeof object === "function";
        };
        /***
    Returns whether the given argument is a string.
    
    @function up.util.isString
    @param object
    @return {boolean}
    @stable
     */ isString = function(object) {
            return typeof object === "string" || object instanceof String;
        };
        /***
    Returns whether the given argument is a boolean value.
    
    @function up.util.isBoolean
    @param object
    @return {boolean}
    @stable
     */ isBoolean = function(object) {
            return typeof object === "boolean" || object instanceof Boolean;
        };
        /***
    Returns whether the given argument is a number.
    
    Note that this will check the argument's *type*.
    It will return `false` for a string like `"123"`.
    
    @function up.util.isNumber
    @param object
    @return {boolean}
    @stable
     */ isNumber = function(object) {
            return typeof object === "number" || object instanceof Number;
        };
        /***
    Returns whether the given argument is an options hash,
    
    Differently from [`up.util.isObject()`], this returns false for
    functions, jQuery collections, promises, `FormData` instances and arrays.
    
    @function up.util.isOptions
    @param object
    @return {boolean}
    @internal
     */ isOptions = function(object) {
            return typeof object === "object" && !isNull(object) && (isUndefined(object.constructor) || object.constructor === Object);
        };
        /***
    Returns whether the given argument is an object.
    
    This also returns `true` for functions, which may behave like objects in JavaScript.
    
    @function up.util.isObject
    @param object
    @return {boolean}
    @stable
     */ isObject = function(object) {
            var typeOfResult;
            typeOfResult = typeof object;
            return typeOfResult === "object" && !isNull(object) || typeOfResult === "function";
        };
        /***
    Returns whether the given argument is a [DOM element](https://developer.mozilla.org/de/docs/Web/API/Element).
    
    @function up.util.isElement
    @param object
    @return {boolean}
    @stable
     */ isElement = function(object) {
            return object instanceof Element;
        };
        /***
    Returns whether the given argument is a [jQuery collection](https://learn.jquery.com/using-jquery-core/jquery-object/).
    
    @function up.util.isJQuery
    @param object
    @return {boolean}
    @stable
     */ isJQuery = function(object) {
            return !!(object != null ? object.jquery : void 0);
        };
        /***
    Returns whether the given argument is an object with a `then` method.
    
    @function up.util.isPromise
    @param object
    @return {boolean}
    @stable
     */ isPromise = function(object) {
            return isObject(object) && isFunction(object.then);
        };
        /***
    Returns whether the given argument is an array.
    
    @function up.util.isArray
    @param object
    @return {boolean}
    @stable
     */ isArray = Array.isArray;
        /***
    Returns whether the given argument is a `FormData` instance.
    
    Always returns `false` in browsers that don't support `FormData`.
    
    @function up.util.isFormData
    @param object
    @return {boolean}
    @internal
     */ isFormData = function(object) {
            return object instanceof FormData;
        };
        /***
    Converts the given [array-like value](/up.util.isList) into an array.
    
    If the given value is already an array, it is returned unchanged.
    
    @function up.util.toArray
    @param object
    @return {Array}
    @stable
     */ toArray = function(value) {
            if (isArray(value)) return value;
            else return Array.prototype.slice.call(value);
        };
        /****
    Returns whether the given argument is an array-like value.
    
    Return true for `Array`, a
    [`NodeList`](https://developer.mozilla.org/en-US/docs/Web/API/NodeList),
     the [arguments object](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/arguments)
     or a jQuery collection.
    
    Use [`up.util.isArray()`](/up.util.isArray) to test whether a value is an actual `Array`.
    
    @function up.util.isList
    @param value
    @return {Boolean}
    @experimental
     */ isList = function(value) {
            return isArray(value) || isNodeList(value) || isArguments(value) || isJQuery(value) || isHTMLCollection(value);
        };
        /***
    Returns whether the given value is a [`NodeList`](https://developer.mozilla.org/en-US/docs/Web/API/NodeList).
    
    `NodeLists` are array-like objects returned by [`document.querySelectorAll()`](https://developer.mozilla.org/en-US/docs/Web/API/Element/querySelectorAll).
    
    @function up.util.isNodeList
    @param value
    @return {Boolean}
    @internal
     */ isNodeList = function(value) {
            return value instanceof NodeList;
        };
        isHTMLCollection = function(value) {
            return value instanceof HTMLCollection;
        };
        /***
    Returns whether the given value is an [arguments object](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/arguments).
    
    @function up.util.isArguments
    @param value
    @return {Boolean}
    @internal
     */ isArguments = function(value) {
            return Object.prototype.toString.call(value) === "[object Arguments]";
        };
        /***
    @function up.util.wrapList
    @return {Array|NodeList|jQuery}
    @internal
     */ wrapList = function(value) {
            if (isList(value)) return value;
            else if (isMissing(value)) return [];
            else return [
                value
            ];
        };
        /***
    Returns a shallow copy of the given value.
    
    \#\#\# Copying protocol
    
    - By default `up.util.copy()` can copy [array-like values](/up.util.isList),
      plain objects and `Date` instances.
    - Array-like objects are copied into new arrays.
    - Unsupported types of values are returned unchanged.
    - To make the copying protocol work with user-defined class,
      see `up.util.copy.key`.
    - Immutable objects, like strings or numbers, do not need to be copied.
    
    @function up.util.copy
    @param {any} object
    @return {any}
    @stable
     */ copy = function(value, deep) {
            var copied, k, v;
            if (isObject(value) && value[copy.key]) value = value[copy.key]();
            else if (isList(value)) {
                value = Array.prototype.slice.call(value);
                copied = true;
            } else if (isOptions(value)) {
                value = assign({}, value);
                copied = true;
            }
            if (copied && deep) for(k in value){
                v = value[k];
                value[k] = copy(v, true);
            }
            return value;
        };
        /***
    This property contains the name of a method that user-defined classes
    may implement to hook into the `up.util.copy()` protocol.
    
    \#\#\# Example
    
    We have a user-defined `Account` class that we want to use with `up.util.copy()`:
    
    ```
    class Account {
      constructor(email) {
        this.email = email
      }
    
      [up.util.copy.key]() {
        return new Account(this.email)
      }
    }
    ```
    
    Note that the protocol method is not actually named `'up.util.copy.key'`.
    Instead it is named after the *value* of the `up.util.copy.key` property.
    To do so, the code sample above is using a
    [computed property name](https://medium.com/front-end-weekly/javascript-object-creation-356e504173a8)
    in square brackets.
    
    We may now use `Account` instances with `up.util.copy()`:
    
    ```
    original = new User('foo@foo.com')
    
    copy = up.util.copy(original)
    console.log(copy.email) // prints 'foo@foo.com'
    
    original.email = 'bar@bar.com' // change the original
    console.log(copy.email) // still prints 'foo@foo.com'
    ```
    
    @property up.util.copy.key
    @param {string} key
    @experimental
     */ copy.key = "up.util.copy";
        Date.prototype[copy.key] = function() {
            return new Date(+this);
        };
        /***
    Returns a deep copy of the given array or object.
    
    @function up.util.deepCopy
    @param {Object|Array} object
    @return {Object|Array}
    @internal
     */ deepCopy = function(object) {
            return copy(object, true);
        };
        /***
    Creates a new object by merging together the properties from the given objects.
    
    @function up.util.merge
    @param {Array<Object>} sources...
    @return Object
    @stable
     */ merge = function() {
            var sources;
            sources = 1 <= arguments.length ? slice.call(arguments, 0) : [];
            return assign.apply(null, [
                {}
            ].concat(slice.call(sources)));
        };
        /***
    Creates an options hash from the given argument and some defaults.
    
    The semantics of this function are confusing.
    We want to get rid of this in the future.
    
    @function up.util.options
    @param {Object} object
    @param {Object} [defaults]
    @return {Object}
    @internal
     */ newOptions = function(object, defaults) {
            if (defaults) return merge(defaults, object);
            else if (object) return copy(object);
            else return {};
        };
        /***
    Passes each element in the given [array-like value](/up.util.isList) to the given function.
    Returns the first element for which the function returns a truthy value.
    
    If no object matches, returns `undefined`.
    
    @function up.util.find
    @param {List<T>} list
    @param {Function(value): boolean} tester
    @return {T|undefined}
    @stable
     */ findInList = function(list, tester) {
            var element, i, len, match;
            match = void 0;
            for(i = 0, len = list.length; i < len; i++){
                element = list[i];
                if (tester(element)) {
                    match = element;
                    break;
                }
            }
            return match;
        };
        /***
    Returns whether the given function returns a truthy value
    for any element in the given [array-like value](/up.util.isList).
    
    @function up.util.some
    @param {List} list
    @param {Function(value, index): boolean} tester
      A function that will be called with each element and (optional) iteration index.
    
    @return {boolean}
    @stable
     */ some = function(list, tester) {
            return !!findResult(list, tester);
        };
        /***
    Consecutively calls the given function which each element
    in the given array. Returns the first truthy return value.
    
    Returned `undefined` iff the function does not return a truthy
    value for any element in the array.
    
    @function up.util.findResult
    @param {Array} array
    @param {Function(element): any} tester
      A function that will be called with each element and (optional) iteration index.
    
    @return {any|undefined}
    @experimental
     */ findResult = function(array, tester) {
            var element, i, index, len, result;
            tester = iteratee(tester);
            for(index = i = 0, len = array.length; i < len; index = ++i){
                element = array[index];
                if (result = tester(element, index)) return result;
            }
            return void 0;
        };
        /***
    Returns whether the given function returns a truthy value
    for all elements in the given [array-like value](/up.util.isList).
    
    @function up.util.every
    @param {List} list
    @param {Function(element, index): boolean} tester
      A function that will be called with each element and (optional) iteration index.
    
    @return {boolean}
    @experimental
     */ every = function(list, tester) {
            var element, i, index, len, match;
            tester = iteratee(tester);
            match = true;
            for(index = i = 0, len = list.length; i < len; index = ++i){
                element = list[index];
                if (!tester(element, index)) {
                    match = false;
                    break;
                }
            }
            return match;
        };
        /***
    Returns all elements from the given array that are
    neither `null` or `undefined`.
    
    @function up.util.compact
    @param {Array<T>} array
    @return {Array<T>}
    @stable
     */ compact = function(array) {
            return filterList(array, isGiven);
        };
        /***
    Returns the given array without duplicates.
    
    @function up.util.uniq
    @param {Array<T>} array
    @return {Array<T>}
    @stable
     */ uniq = function(array) {
            if (array.length < 2) return array;
            return setToArray(arrayToSet(array));
        };
        /***
    This function is like [`uniq`](/up.util.uniq), accept that
    the given function is invoked for each element to generate the value
    for which uniquness is computed.
    
    @function up.util.uniqBy
    @param {Array} array
    @param {Function(value): any} array
    @return {Array}
    @experimental
     */ uniqBy = function(array, mapper) {
            var set;
            if (array.length < 2) return array;
            mapper = iteratee(mapper);
            set = new Set();
            return filterList(array, function(elem, index) {
                var mapped;
                mapped = mapper(elem, index);
                if (set.has(mapped)) return false;
                else {
                    set.add(mapped);
                    return true;
                }
            });
        };
        /***
    @function up.util.setToArray
    @internal
     */ setToArray = function(set) {
            var array;
            array = [];
            set.forEach(function(elem) {
                return array.push(elem);
            });
            return array;
        };
        /***
    @function up.util.arrayToSet
    @internal
     */ arrayToSet = function(array) {
            var set;
            set = new Set();
            array.forEach(function(elem) {
                return set.add(elem);
            });
            return set;
        };
        /***
    Returns all elements from the given [array-like value](/up.util.isList) that return
    a truthy value when passed to the given function.
    
    @function up.util.filter
    @param {List} list
    @param {Function(value, index): boolean} tester
    @return {Array}
    @stable
     */ filterList = function(list, tester) {
            var matches;
            tester = iteratee(tester);
            matches = [];
            each(list, function(element, index) {
                if (tester(element, index)) return matches.push(element);
            });
            return matches;
        };
        /***
    Returns all elements from the given [array-like value](/up.util.isList) that do not return
    a truthy value when passed to the given function.
    
    @function up.util.reject
    @param {List} list
    @param {Function(element, index): boolean} tester
    @return {Array}
    @stable
     */ reject = function(list, tester) {
            tester = iteratee(tester);
            return filterList(list, function(element, index) {
                return !tester(element, index);
            });
        };
        /***
    Returns the intersection of the given two arrays.
    
    Implementation is not optimized. Don't use it for large arrays.
    
    @function up.util.intersect
    @internal
     */ intersect = function(array1, array2) {
            return filterList(array1, function(element) {
                return contains(array2, element);
            });
        };
        /***
    Waits for the given number of milliseconds, the runs the given callback.
    
    Instead of `up.util.timer(0, fn)` you can also use [`up.util.task(fn)`](/up.util.task).
    
    @function up.util.timer
    @param {number} millis
    @param {Function()} callback
    @stable
     */ scheduleTimer = function(millis, callback) {
            return setTimeout(callback, millis);
        };
        /***
    Pushes the given function to the [JavaScript task queue](https://jakearchibald.com/2015/tasks-microtasks-queues-and-schedules/) (also "macrotask queue").
    
    Equivalent to calling `setTimeout(fn, 0)`.
    
    Also see `up.util.microtask()`.
    
    @function up.util.task
    @param {Function()} block
    @stable
     */ queueTask = function(block) {
            return setTimeout(block, 0);
        };
        /***
    Pushes the given function to the [JavaScript microtask queue](https://jakearchibald.com/2015/tasks-microtasks-queues-and-schedules/).
    
    @function up.util.microtask
    @param {Function()} task
    @return {Promise}
    @experimental
     */ queueMicrotask = function(task) {
            return Promise.resolve().then(task);
        };
        /***
    Returns the last element of the given array.
    
    @function up.util.last
    @param {Array<T>} array
    @return {T}
     */ last = function(array) {
            return array[array.length - 1];
        };
        /***
    Returns whether the given keyboard event involved the ESC key.
    
    @function up.util.escapePressed
    @internal
     */ escapePressed = function(event) {
            var key;
            key = event.key;
            return key === "Escape" || key === "Esc";
        };
        /***
    Returns whether the given array or string contains the given element or substring.
    
    @function up.util.contains
    @param {Array|string} arrayOrString
    @param elementOrSubstring
    @stable
     */ contains = function(arrayOrString, elementOrSubstring) {
            return arrayOrString.indexOf(elementOrSubstring) >= 0;
        };
        /***
    Returns a copy of the given object that only contains
    the given properties.
    
    @function up.util.only
    @param {Object} object
    @param {Array} keys...
    @stable
     */ only = function() {
            var filtered, i, len, object, properties, property;
            object = arguments[0], properties = 2 <= arguments.length ? slice.call(arguments, 1) : [];
            filtered = {};
            for(i = 0, len = properties.length; i < len; i++){
                property = properties[i];
                if (property in object) filtered[property] = object[property];
            }
            return filtered;
        };
        /***
    Returns a copy of the given object that contains all except
    the given properties.
    
    @function up.util.except
    @param {Object} object
    @param {Array} keys...
    @stable
     */ except = function() {
            var filtered, i, len, object, properties, property;
            object = arguments[0], properties = 2 <= arguments.length ? slice.call(arguments, 1) : [];
            filtered = copy(object);
            for(i = 0, len = properties.length; i < len; i++){
                property = properties[i];
                delete filtered[property];
            }
            return filtered;
        };
        /***
    @function up.util.isUnmodifiedKeyEvent
    @internal
     */ isUnmodifiedKeyEvent = function(event) {
            return !(event.metaKey || event.shiftKey || event.ctrlKey);
        };
        /***
    @function up.util.isUnmodifiedMouseEvent
    @internal
     */ isUnmodifiedMouseEvent = function(event) {
            var isLeftButton;
            isLeftButton = isUndefined(event.button) || event.button === 0;
            return isLeftButton && isUnmodifiedKeyEvent(event);
        };
        /***
    Returns a promise that will never be resolved.
    
    @function up.util.unresolvablePromise
    @internal
     */ unresolvablePromise = function() {
            return new Promise(noop);
        };
        /***
    Removes the given element from the given array.
    
    This changes the given array.
    
    @function up.util.remove
    @param {Array<T>} array
    @param {T} element
    @stable
     */ remove = function(array, element) {
            var index;
            index = array.indexOf(element);
            if (index >= 0) {
                array.splice(index, 1);
                return element;
            }
        };
        /***
    If the given `value` is a function, calls the function with the given `args`.
    Otherwise it just returns `value`.
    
    @function up.util.evalOption
    @internal
     */ evalOption = function() {
            var args, value;
            value = arguments[0], args = 2 <= arguments.length ? slice.call(arguments, 1) : [];
            if (isFunction(value)) return value.apply(null, args);
            else return value;
        };
        /***
    Throws a [JavaScript error](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error)
    with the given message.
    
    The message will also be printed to the [error log](/up.log.error). Also a notification will be shown at the bottom of the screen.
    
    The message may contain [substitution marks](https://developer.mozilla.org/en-US/docs/Web/API/console#Using_string_substitutions).
    
    \#\#\# Examples
    
        up.fail('Division by zero')
        up.fail('Unexpected result %o', result)
    
    @function up.fail
    @param {string} message
      A message with details about the error.
    
      The message can contain [substitution marks](https://developer.mozilla.org/en-US/docs/Web/API/console#Using_string_substitutions)
      like `%s` or `%o`.
    @param {Array<string>} vars...
      A list of variables to replace any substitution marks in the error message.
    @experimental
     */ fail = function() {
            var args, asString, messageArgs, ref, ref1, toastOptions;
            args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
            if (isArray(args[0])) {
                messageArgs = args[0];
                toastOptions = args[1] || {};
            } else {
                messageArgs = args;
                toastOptions = {};
            }
            (ref = up.log).error.apply(ref, messageArgs);
            up.event.onReady(function() {
                return up.toast.open(messageArgs, toastOptions);
            });
            asString = (ref1 = up.log).sprintf.apply(ref1, messageArgs);
            throw new Error(asString);
        };
        ESCAPE_HTML_ENTITY_MAP = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;"
        };
        /***
    Escapes the given string of HTML by replacing control chars with their HTML entities.
    
    @function up.util.escapeHtml
    @param {string} string
      The text that should be escaped
    @stable
     */ escapeHtml = function(string) {
            return string.replace(/[&<>"]/g, function(char) {
                return ESCAPE_HTML_ENTITY_MAP[char];
            });
        };
        /***
    @function up.util.escapeRegexp
    @internal
     */ escapeRegexp = function(string) {
            return string.replace(/[\\^$*+?.()|[\]{}]/g, "\\$&");
        };
        pluckKey = function(object, key) {
            var value;
            value = object[key];
            delete object[key];
            return value;
        };
        renameKey = function(object, oldKey, newKey) {
            return object[newKey] = pluckKey(object, oldKey);
        };
        extractLastArg = function(args, tester) {
            var lastArg;
            lastArg = last(args);
            if (tester(lastArg)) return args.pop();
        };
        extractCallback = function(args) {
            return extractLastArg(args, isFunction);
        };
        extractOptions = function(args) {
            return extractLastArg(args, isOptions) || {};
        };
        partial = function() {
            var fixedArgs, fn;
            fn = arguments[0], fixedArgs = 2 <= arguments.length ? slice.call(arguments, 1) : [];
            return function() {
                var callArgs;
                callArgs = 1 <= arguments.length ? slice.call(arguments, 0) : [];
                return fn.apply(this, fixedArgs.concat(callArgs));
            };
        };
        identity = function(arg) {
            return arg;
        };
        /***
    Given a function that will return a promise, returns a proxy function
    with an additional `.promise` attribute.
    
    When the proxy is called, the inner function is called.
    The proxy's `.promise` attribute is available even before the function is called
    and will resolve when the inner function's returned promise resolves.
    
    If the inner function does not return a promise, the proxy's `.promise` attribute
    will resolve as soon as the inner function returns.
    
    @function up.util.previewable
    @internal
     */ previewable = function(fun) {
            var deferred, preview;
            deferred = newDeferred();
            preview = function() {
                var args, funValue;
                args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
                funValue = fun.apply(null, args);
                deferred.resolve(funValue);
                return funValue;
            };
            preview.promise = deferred.promise();
            return preview;
        };
        /***
    @function up.util.sequence
    @param {Array<Function()>} functions
    @return {Function()}
      A function that will call all `functions` if called.
    
    @internal
     */ sequence = function(functions) {
            if (functions.length === 1) return functions[0];
            else return function() {
                return map(functions, function(f) {
                    return f();
                });
            };
        };
        /***
    Returns `'left'` if the center of the given element is in the left 50% of the screen.
    Otherwise returns `'right'`.
    
    @function up.util.horizontalScreenHalf
    @internal
     */ horizontalScreenHalf = function(element) {
            var elementDims, elementMid, screenMid;
            elementDims = element.getBoundingClientRect();
            elementMid = elementDims.left + 0.5 * elementDims.width;
            screenMid = 0.5 * up.viewport.rootWidth();
            if (elementMid < screenMid) return "left";
            else return "right";
        };
        /***
    Flattens the given `array` a single level deep.
    
    @function up.util.flatten
    @param {Array} array
      An array which might contain other arrays
    @return {Array}
      The flattened array
    @experimental
     */ flatten = function(array) {
            var flattened, i, len, object;
            flattened = [];
            for(i = 0, len = array.length; i < len; i++){
                object = array[i];
                if (isList(object)) flattened.push.apply(flattened, object);
                else flattened.push(object);
            }
            return flattened;
        };
        /***
    Maps each element using a mapping function,
    then flattens the result into a new array.
    
    @function up.util.flatMap
    @param {Array} array
    @param {Function(element)} mapping
    @return {Array}
    @experimental
     */ flatMap = function(array, block) {
            return flatten(map(array, block));
        };
        /***
    Returns whether the given value is truthy.
    
    @function up.util.isTruthy
    @internal
     */ isTruthy = function(object) {
            return !!object;
        };
        /***
    Sets the given callback as both fulfillment and rejection handler for the given promise.
    
    @function up.util.always
    @internal
     */ always = function(promise, callback) {
            return promise.then(callback, callback);
        };
        /***
     * Registers an empty rejection handler with the given promise.
     * This prevents browsers from printing "Uncaught (in promise)" to the error
     * console when the promise is rejection.
     *
     * This is helpful for event handlers where it is clear that no rejection
     * handler will be registered:
     *
     *     up.on('submit', 'form[up-target]', (event, $form) => {
     *       promise = up.submit($form)
     *       up.util.muteRejection(promise)
     *     })
     *
     * Does nothing if passed a missing value.
     *
     * @function up.util.muteRejection
     * @param {Promise|undefined|null} promise
     * @return {Promise}
     */ muteRejection = function(promise) {
            return promise != null ? promise["catch"](noop) : void 0;
        };
        /***
    @function up.util.newDeferred
    @internal
     */ /***
    @function up.util.newDeferred
    @internal
     */ newDeferred = function() {
            var nativePromise, rejectFn, resolveFn;
            resolveFn = void 0;
            rejectFn = void 0;
            nativePromise = new Promise(function(givenResolve, givenReject) {
                resolveFn = givenResolve;
                return rejectFn = givenReject;
            });
            nativePromise.resolve = resolveFn;
            nativePromise.reject = rejectFn;
            nativePromise.promise = function() {
                return nativePromise;
            };
            return nativePromise;
        };
        /***
    Calls the given block. If the block throws an exception,
    a rejected promise is returned instead.
    
    @function up.util.rejectOnError
    @internal
     */ rejectOnError = function(block) {
            var error;
            try {
                return block();
            } catch (error1) {
                error = error1;
                return Promise.reject(error);
            }
        };
        sum = function(list, block) {
            var entry, entryValue, i, len, totalValue;
            block = iteratee(block);
            totalValue = 0;
            for(i = 0, len = list.length; i < len; i++){
                entry = list[i];
                entryValue = block(entry);
                if (isGiven(entryValue)) totalValue += entryValue;
            }
            return totalValue;
        };
        isBasicObjectProperty = function(k) {
            return Object.prototype.hasOwnProperty(k);
        };
        /***
    Returns whether the two arguments are equal by value.
    
    \#\#\# Comparison protocol
    
    - By default `up.util.isEqual()` can compare strings, numbers,
      [array-like values](/up.util.isList), plain objects and `Date` objects.
    - To make the copying protocol work with user-defined classes,
      see `up.util.isEqual.key`.
    - Objects without a defined comparison protocol are
      defined by reference (`===`).
    
    @function up.util.isEqual
    @param {any} a
    @param {any} b
    @return {boolean}
      Whether the arguments are equal by value.
    @experimental
     */ isEqual = function(a, b) {
            var aKeys, bKeys;
            if (a != null ? a.valueOf : void 0) a = a.valueOf();
            if (b != null ? b.valueOf : void 0) b = b.valueOf();
            if (typeof a !== typeof b) return false;
            else if (isList(a) && isList(b)) return isEqualList(a, b);
            else if (isObject(a) && a[isEqual.key]) return a[isEqual.key](b);
            else if (isOptions(a) && isOptions(b)) {
                aKeys = Object.keys(a);
                bKeys = Object.keys(b);
                if (isEqualList(aKeys, bKeys)) return every(aKeys, function(aKey) {
                    return isEqual(a[aKey], b[aKey]);
                });
                else return false;
            } else return a === b;
        };
        /***
    This property contains the name of a method that user-defined classes
    may implement to hook into the `up.util.isEqual()` protocol.
    
    \#\#\# Example
    
    We have a user-defined `Account` class that we want to use with `up.util.isEqual()`:
    
    ```
    class Account {
      constructor(email) {
        this.email = email
      }
    
      [up.util.isEqual.key](other) {
        return this.email === other.email;
      }
    }
    ```
    
    Note that the protocol method is not actually named `'up.util.isEqual.key'`.
    Instead it is named after the *value* of the `up.util.isEqual.key` property.
    To do so, the code sample above is using a
    [computed property name](https://medium.com/front-end-weekly/javascript-object-creation-356e504173a8)
    in square brackets.
    
    We may now use `Account` instances with `up.util.isEqual()`:
    
    ```
    one = new User('foo@foo.com')
    two = new User('foo@foo.com')
    three = new User('bar@bar.com')
    
    isEqual = up.util.isEqual(one, two)
    // isEqual is now true
    
    isEqual = up.util.isEqual(one, three)
    // isEqual is now false
    ```
    
    @property up.util.isEqual.key
    @param {string} key
    @experimental
     */ isEqual.key = "up.util.isEqual";
        isEqualList = function(a, b) {
            return a.length === b.length && every(a, function(elem, index) {
                return isEqual(elem, b[index]);
            });
        };
        splitValues = function(value, separator) {
            var values;
            if (separator == null) separator = " ";
            values = value.split(separator);
            values = map(values, function(v) {
                return v.trim();
            });
            values = filterList(values, isPresent);
            return values;
        };
        endsWith = function(string, search) {
            if (search.length > string.length) return false;
            else return string.substring(string.length - search.length) === search;
        };
        simpleEase = function(x) {
            if (x < 0.5) return 2 * x * x;
            else return x * (4 - x * 2) - 1;
        };
        wrapValue = function(object, constructor) {
            if (object instanceof constructor) return object;
            else return new constructor(object);
        };
        nextUid = 0;
        uid = function() {
            return nextUid++;
        };
        return {
            parseUrl: parseUrl,
            normalizeUrl: normalizeUrl,
            normalizeMethod: normalizeMethod,
            methodAllowsPayload: methodAllowsPayload,
            assign: assign,
            assignPolyfill: assignPolyfill,
            copy: copy,
            deepCopy: deepCopy,
            merge: merge,
            options: newOptions,
            fail: fail,
            each: each,
            eachIterator: eachIterator,
            map: map,
            flatMap: flatMap,
            mapObject: mapObject,
            times: times,
            findResult: findResult,
            some: some,
            any: function() {
                up.legacy.warn("up.util.any() has been renamed to up.util.some()");
                return some.apply(null, arguments);
            },
            every: every,
            all: function() {
                up.legacy.warn("up.util.all() has been renamed to up.util.every()");
                return every.apply(null, arguments);
            },
            detect: function() {
                up.legacy.warn("up.util.find() has been renamed to up.util.find()");
                return findInList.apply(null, arguments);
            },
            find: findInList,
            select: function() {
                up.legacy.warn("up.util.select() has been renamed to up.util.filter()");
                return filterList.apply(null, arguments);
            },
            filter: filterList,
            reject: reject,
            intersect: intersect,
            compact: compact,
            uniq: uniq,
            uniqBy: uniqBy,
            last: last,
            isNull: isNull,
            isDefined: isDefined,
            isUndefined: isUndefined,
            isGiven: isGiven,
            isMissing: isMissing,
            isPresent: isPresent,
            isBlank: isBlank,
            presence: presence,
            isObject: isObject,
            isFunction: isFunction,
            isString: isString,
            isBoolean: isBoolean,
            isNumber: isNumber,
            isElement: isElement,
            isJQuery: isJQuery,
            isPromise: isPromise,
            isOptions: isOptions,
            isArray: isArray,
            isFormData: isFormData,
            isNodeList: isNodeList,
            isArguments: isArguments,
            isList: isList,
            isUnmodifiedKeyEvent: isUnmodifiedKeyEvent,
            isUnmodifiedMouseEvent: isUnmodifiedMouseEvent,
            timer: scheduleTimer,
            setTimer: function() {
                up.legacy.warn("up.util.setTimer() has been renamed to up.util.timer()");
                return scheduleTimer.apply(null, arguments);
            },
            escapePressed: escapePressed,
            contains: contains,
            toArray: toArray,
            only: only,
            except: except,
            unresolvablePromise: unresolvablePromise,
            remove: remove,
            memoize: memoize,
            error: fail,
            pluckKey: pluckKey,
            renameKey: renameKey,
            extractOptions: extractOptions,
            extractCallback: extractCallback,
            noop: noop,
            asyncNoop: asyncNoop,
            identity: identity,
            escapeHtml: escapeHtml,
            escapeRegexp: escapeRegexp,
            sequence: sequence,
            previewable: previewable,
            evalOption: evalOption,
            horizontalScreenHalf: horizontalScreenHalf,
            flatten: flatten,
            isTruthy: isTruthy,
            newDeferred: newDeferred,
            always: always,
            muteRejection: muteRejection,
            rejectOnError: rejectOnError,
            isBasicObjectProperty: isBasicObjectProperty,
            isCrossDomain: isCrossDomain,
            selectorForElement: function() {
                up.legacy.warn("up.util.selectorForElement() has been renamed to up.element.toSelector()");
                return up.element.toSelector.apply(null, arguments);
            },
            nextFrame: function() {
                up.legacy.warn("up.util.nextFrame() has been renamed to up.util.task()");
                return queueTask.apply(null, arguments);
            },
            task: queueTask,
            microtask: queueMicrotask,
            isEqual: isEqual,
            splitValues: splitValues,
            endsWith: endsWith,
            sum: sum,
            wrapList: wrapList,
            wrapValue: wrapValue,
            simpleEase: simpleEase,
            values: objectValues,
            partial: partial,
            arrayToSet: arrayToSet,
            setToArray: setToArray,
            uid: uid
        };
    }();
    up.fail = up.util.fail;
}).call(module.exports);
(function() {
    var u, slice = [].slice;
    u = up.util;
    up.legacy = function() {
        var fixKey, renamedModule, warn, warnedMessages;
        fixKey = function(object, oldKey, newKey) {
            if (oldKey in object) {
                warn("Property { %s } has been renamed to { %s } (found in %o)", oldKey, newKey, object);
                return u.renameKey(object, oldKey, newKey);
            }
        };
        renamedModule = function(oldName, newName) {
            return Object.defineProperty(up, oldName, {
                get: function() {
                    warn("up." + oldName + " has been renamed to up." + newName);
                    return up[newName];
                }
            });
        };
        warnedMessages = {};
        warn = function() {
            var args, message, ref;
            message = arguments[0], args = 2 <= arguments.length ? slice.call(arguments, 1) : [];
            message = "[DEPRECATION] " + message;
            message = (ref = up.log).sprintf.apply(ref, [
                message
            ].concat(slice.call(args)));
            if (!warnedMessages[message]) {
                warnedMessages[message] = true;
                return up.warn(message);
            }
        };
        return {
            renamedModule: renamedModule,
            fixKey: fixKey,
            warn: warn
        };
    }();
}).call(module.exports);
/***
Browser support
===============

Unpoly supports all modern browsers.

Chrome, Firefox, Edge, Safari
: Full support

Internet Explorer 11
: Full support with a `Promise` polyfill like [es6-promise](https://github.com/stefanpenner/es6-promise) (2.4 KB).

Internet Explorer 10 or lower
: Unpoly prevents itself from booting itself, leaving you with a classic server-side application.

@module up.browser
 */ (function() {
    var slice = [].slice;
    up.browser = function() {
        var callJQuery, canAnimationFrame, canConsole, canControlScrollRestoration, canCssTransition, canCustomElements, canDOMParser, canFormData, canInputEvent, canInspectFormData, canJQuery, canPromise, canPushState, isIE10OrWorse, isIE11, isSupported, navigate, popCookie, submitForm, u, url, whenConfirmed;
        u = up.util;
        /***
    @method up.browser.navigate
    @param {string} url
    @param {string} [options.method='get']
    @param {object|Array|FormData|string} [options.params]
    @internal
     */ navigate = function(url, options) {
            var request, requestOpts;
            requestOpts = u.merge(options, {
                url: url
            });
            request = new up.Request(requestOpts);
            return request.navigate();
        };
        /***
    For mocking in specs.
    
    @method submitForm
     */ submitForm = function(form) {
            return form.submit();
        };
        url = function() {
            return location.href;
        };
        isIE10OrWorse = u.memoize(function() {
            return !window.atob;
        });
        isIE11 = u.memoize(function() {
            return "ActiveXObject" in window;
        });
        /***
    Returns whether this browser supports manipulation of the current URL
    via [`history.pushState`](https://developer.mozilla.org/en-US/docs/Web/API/History/pushState).
    
    When `pushState`  (e.g. through [`up.follow()`](/up.follow)), it will gracefully
    fall back to a full page load.
    
    Note that Unpoly will not use `pushState` if the initial page was loaded with
    a request method other than GET.
    
    @function up.browser.canPushState
    @return {boolean}
    @experimental
     */ canPushState = function() {
            return u.isDefined(history.pushState) && up.protocol.initialRequestMethod() === "get";
        };
        /***
    Returns whether this browser supports animation using
    [CSS transitions](https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Transitions).
    
    When Unpoly is asked to animate history on a browser that doesn't support
    CSS transitions (e.g. through [`up.animate()`](/up.animate)), it will skip the
    animation by instantly jumping to the last frame.
    
    @function up.browser.canCssTransition
    @return {boolean}
    @internal
     */ canCssTransition = u.memoize(function() {
            return "transition" in document.documentElement.style;
        });
        /***
    Returns whether this browser supports the DOM event [`input`](https://developer.mozilla.org/de/docs/Web/Events/input).
    
    @function up.browser.canInputEvent
    @return {boolean}
    @internal
     */ canInputEvent = u.memoize(function() {
            return "oninput" in document.createElement("input");
        });
        /***
    Returns whether this browser supports promises.
    
    @function up.browser.canPromise
    @return {boolean}
    @internal
     */ canPromise = u.memoize(function() {
            return !!window.Promise;
        });
        /***
    Returns whether this browser supports the [`FormData`](https://developer.mozilla.org/en-US/docs/Web/API/FormData)
    interface.
    
    @function up.browser.canFormData
    @return {boolean}
    @experimental
     */ canFormData = u.memoize(function() {
            return !!window.FormData;
        });
        /***
    @function up.browser.canInspectFormData
    @return {boolean}
    @internal
     */ canInspectFormData = u.memoize(function() {
            return canFormData() && !!FormData.prototype.entries;
        });
        /***
    Returns whether this browser supports the [`DOMParser`](https://developer.mozilla.org/en-US/docs/Web/API/DOMParser)
    interface.
    
    @function up.browser.canDOMParser
    @return {boolean}
    @internal
     */ canDOMParser = u.memoize(function() {
            return !!window.DOMParser;
        });
        /***
    Returns whether this browser supports the [`debugging console`](https://developer.mozilla.org/en-US/docs/Web/API/Console).
    
    @function up.browser.canConsole
    @return {boolean}
    @internal
     */ canConsole = u.memoize(function() {
            return window.console && console.debug && console.info && console.warn && console.error && console.group && console.groupCollapsed && console.groupEnd;
        });
        canCustomElements = u.memoize(function() {
            return !!window.customElements;
        });
        canAnimationFrame = u.memoize(function() {
            return "requestAnimationFrame" in window;
        });
        canControlScrollRestoration = u.memoize(function() {
            return "scrollRestoration" in history;
        });
        canJQuery = function() {
            return !!window.jQuery;
        };
        popCookie = function(name) {
            var ref, value;
            value = (ref = document.cookie.match(new RegExp(name + "=(\\w+)"))) != null ? ref[1] : void 0;
            if (u.isPresent(value)) document.cookie = name + "=; expires=Thu, 01-Jan-70 00:00:01 GMT; path=/";
            return value;
        };
        /***
    @function up,browser.whenConfirmed
    @return {Promise}
    @param {string} options.confirm
    @param {boolean} options.preload
    @internal
     */ whenConfirmed = function(options) {
            if (options.preload || u.isBlank(options.confirm) || window.confirm(options.confirm)) return Promise.resolve();
            else return Promise.reject(new Error("User canceled action"));
        };
        /***
    Returns whether Unpoly supports the current browser.
    
    If this returns `false` Unpoly will prevent itself from [booting](/up.boot)
    and ignores all registered [event handlers](/up.on) and [compilers](/up.compiler).
    This leaves you with a classic server-side application.
    This is usually a better fallback than loading incompatible Javascript and causing
    many errors on load.
    
    @function up.browser.isSupported
    @stable
     */ isSupported = function() {
            return !isIE10OrWorse() && canConsole() && canDOMParser() && canFormData() && canCssTransition() && canInputEvent() && canPromise() && canAnimationFrame();
        };
        callJQuery = function() {
            var args;
            args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
            canJQuery() || up.fail("jQuery must be published as window.jQuery");
            return jQuery.apply(null, args);
        };
        return {
            url: url,
            navigate: navigate,
            submitForm: submitForm,
            canPushState: canPushState,
            canFormData: canFormData,
            canInspectFormData: canInspectFormData,
            canCustomElements: canCustomElements,
            canControlScrollRestoration: canControlScrollRestoration,
            canJQuery: canJQuery,
            whenConfirmed: whenConfirmed,
            isSupported: isSupported,
            popCookie: popCookie,
            jQuery: callJQuery,
            isIE11: isIE11
        };
    }();
}).call(module.exports);
(function() {
    var u;
    u = up.util;
    up.Selector = function() {
        var CSS_HAS_SUFFIX_PATTERN, MATCH_FN_NAME;
        CSS_HAS_SUFFIX_PATTERN = new RegExp("\\:has\\(([^\\)]+)\\)$");
        MATCH_FN_NAME = up.browser.isIE11() ? "msMatchesSelector" : "matches";
        function Selector(selector1, filterFn) {
            this.selector = selector1;
            this.filterFn = filterFn;
        }
        Selector.prototype.matches = function(element) {
            var doesMatch;
            doesMatch = element[MATCH_FN_NAME](this.selector);
            if (this.filterFn) doesMatch && (doesMatch = this.filterFn(element));
            return doesMatch;
        };
        Selector.prototype.descendants = function(root) {
            var matches;
            matches = root.querySelectorAll(this.selector);
            if (this.filterFn) matches = u.filter(matches, this.filterFn);
            return matches;
        };
        Selector.prototype.descendant = function(root) {
            var candidates;
            if (!this.filterFn) return root.querySelector(this.selector);
            else {
                candidates = root.querySelectorAll(this.selector);
                return u.find(candidates, this.filterFn);
            }
        };
        Selector.prototype.subtree = function(root) {
            var matches;
            matches = [];
            if (this.matches(root)) matches.push(root);
            matches.push.apply(matches, this.descendants(root));
            return matches;
        };
        Selector.prototype.closest = function(root) {
            if (root.closest && !this.filterFn) return root.closest(this.selector);
            else return this.closestPolyfill(root);
        };
        Selector.prototype.closestPolyfill = function(root) {
            if (this.matches(root, this.selector)) return root;
            else return this.ancestor(root);
        };
        Selector.prototype.ancestor = function(element) {
            var parentElement;
            if (parentElement = element.parentElement) {
                if (this.matches(parentElement)) return parentElement;
                else return this.ancestor(parentElement);
            }
        };
        Selector.parse = function(selector) {
            var filter;
            filter = null;
            selector = selector.replace(CSS_HAS_SUFFIX_PATTERN, function(match, descendantSelector) {
                filter = function(element) {
                    return element.querySelector(descendantSelector);
                };
                return "";
            });
            return new this(selector, filter);
        };
        return Selector;
    }();
}).call(module.exports);
/***
DOM helpers
===========

The `up.element` module offers functions for DOM manipulation and traversal.

It complements [native `Element` methods](https://www.w3schools.com/jsref/dom_obj_all.asp) and works across all [supported browsers](/up.browser).

@module up.element
 */ (function() {
    var slice = [].slice;
    up.element = function() {
        var CSS_LENGTH_PROPS, NONE, affix, all, ancestor, attributeSelector, booleanAttr, booleanOrStringAttr, closest, computedStyle, computedStyleNumber, concludeCssTransition, createDocumentFromHtml, createFromHtml, createFromSelector, cssLength, elementTagName, extractFromStyleObject, first, fixedToAbsolute, getList, getOne, getRoot, hasCssTransition, hide, inlineStyle, insertBefore, isSingleton, isVisible, jsonAttr, matches, metaContent, nonUpClasses, normalizeStyleValueForWrite, numberAttr, paint, parseSelector, remove, replace, resolveSelector, setAttrs, setInlineStyle, setMissingAttrs, setTemporaryStyle, show, subtree, toSelector, toggle, toggleClass, u, unwrap, valueToList;
        u = up.util;
        /***
    Returns a null-object that mostly behaves like an `Element`.
    
    @function up.element.none()
    @internal
     */ NONE = {
            getAttribute: function() {
                return void 0;
            }
        };
        /***
    Matches all elements that have a descendant matching the given selector.
    
    \#\#\# Example
    
    `up.element.all('div:has(span)')`  matches all `<div>` elements with at least one `<span>` among its descendants:
    
    ```html
    <div>
      <span>Will be matched</span>
    </div>
    <div>
      Will NOT be matched
    </div>
    <div>
      <span>Will be matched</span>
    </div>
    ```
    
    \#\#\# Compatibility
    
    `:has()` is supported by all Unpoly functions (like `up.element.all()`) and
     selectors (like `a[up-target]`).
    
    As a [level 4 CSS selector](https://drafts.csswg.org/selectors-4/#relational),
    `:has()` [has yet to be implemented](https://caniuse.com/#feat=css-has)
    in native browser functions like [`document.querySelectorAll()`](https://developer.mozilla.org/en-US/docs/Web/API/Element/querySelectorAll).
    
    You can also use [`:has()` in jQuery](https://api.jquery.com/has-selector/).
    
    @selector :has()
    @experimental
     */ parseSelector = function(selector) {
            return up.Selector.parse(selector);
        };
        /***
    Returns the first descendant element matching the given selector.
    
    It is similar to [`element.querySelector()`](https://developer.mozilla.org/en-US/docs/Web/API/Document/querySelector),
    but also supports the [`:has()`](/has) selector.
    
    @function up.element.first
    @param {Element} [parent=document]
      The parent element whose descendants to search.
    
      If omitted, all elements in the `document` will be searched.
    @param {string} selector
      The CSS selector to match.
    @return {Element|undefined|null}
      The first element matching the selector.
    
      Returns `null` or `undefined` if no element macthes.
    @experimental
     */ first = function() {
            var args, parent, ref, selector;
            args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
            selector = args.pop();
            parent = (ref = args[0]) != null ? ref : document;
            return parseSelector(selector).descendant(parent);
        };
        /***
    Returns all descendant elements matching the given selector.
    
    @function up.element.all
    @param {Element} [parent=document]
      The parent element whose descendants to search.
    
      If omitted, all elements in the `document` will be searched.
    @param {string} selector
      The CSS selector to match.
    @return {NodeList<Element>|Array<Element>}
      A list of all elements matching the selector.
    
      Returns an empty list if there are no matches.
    @experimental
     */ all = function() {
            var args, parent, ref, selector;
            args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
            selector = args.pop();
            parent = (ref = args[0]) != null ? ref : document;
            return parseSelector(selector).descendants(parent);
        };
        /***
    Returns a list of the given parent's descendants matching the given selector.
    The list will also include the parent element if it matches the selector itself.
    
    @function up.element.subtree
    @param {Element} parent
      The parent element for the search.
    @param {string} selector
      The CSS selector to match.
    @return {NodeList<Element>|Array<Element>}
      A list of all matching elements.
    @experimental
     */ subtree = function(root, selector) {
            return parseSelector(selector).subtree(root);
        };
        /***
    Returns the first element that matches the selector by testing the element itself
    and traversing up through its ancestors in the DOM tree.
    
    @function up.element.closest
    @param {Element} element
      The element on which to start the search.
    @param {string} selector
      The CSS selector to match.
    @return {Element|null|undefined} element
      The matching element.
    
      Returns `null` or `undefined` if no element matches.
    @experimental
     */ closest = function(element, selector) {
            return parseSelector(selector).closest(element);
        };
        /***
    Returns whether the given element matches the given CSS selector.
    
    @function up.element.matches
    @param {Element} element
      The element to check.
    @param {string} selector
      The CSS selector to match.
    @return {boolean}
      Whether `element` matches `selector`.
    @experimental
     */ matches = function(element, selector) {
            return parseSelector(selector).matches(element);
        };
        /***
    @function up.element.ancestor
    @internal
     */ ancestor = function(element, selector) {
            return parseSelector(selector).ancestor(element);
        };
        /***
    Casts the given value to a native [Element](https://developer.mozilla.org/en-US/docs/Web/API/Element).
    
    This is useful when working with jQuery values, or to allow callers to pass CSS selectors
    instead of elements.
    
    \#\#\# Casting rules
    
    - If given an element, returns that element.
    - If given a CSS selector string, returns the [first element matching](/up.element.first) that selector.
    - If given a jQuery collection , returns the first element in the collection.
      Throws an error if the collection contains more than one element.
    - If given any other argument (`undefined`, `null`, `document`, `window`…), returns the argument unchanged.
    
    @function up.element.get
    @param {Element|jQuery|string} value
      The value to cast.
    @return {Element}
      The obtained `Element`.
    @experimental
     */ getOne = function(value) {
            if (u.isElement(value)) return value;
            else if (u.isString(value)) return first(value);
            else if (u.isJQuery(value)) {
                if (value.length > 1) up.fail("up.element.get(): Cannot cast multiple elements (%o) to a single element", value);
                return value[0];
            } else return value;
        };
        /***
    Composes a list of elements from the given arguments.
    
    \#\#\# Casting rules
    
    - If given a string, returns the all elements matching that string.
    - If given any other argument, returns the argument [wrapped as a list](/up.util.wrapList).
    
    \#\#\# Example
    
    ```javascript
    $jquery = $('.jquery')                          // returns jQuery (2) [div.jquery, div.jquery]
    nodeList = document.querySelectorAll('.node')   // returns NodeList (2) [div.node, div.node]
    element = document.querySelector('.element')    // returns Element div.element
    selector = '.selector'                          // returns String '.selector'
    
    elements = up.element.list($jquery, nodeList, undefined, element, selector)
    // returns [div.jquery, div.jquery, div.node, div.node, div.element, div.selector]
    ```
    
    @function up.element.list
    @param {Array<jQuery|Element|Array<Element>|String|undefined|null>} ...args
    @return {Array<Element>}
    @internal
     */ getList = function() {
            var args;
            args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
            return u.flatMap(args, valueToList);
        };
        valueToList = function(value) {
            if (u.isString(value)) return all(value);
            else return u.wrapList(value);
        };
        /***
    Removes the given element from the DOM tree.
    
    If you don't need IE11 support you may also use the built-in
    [`Element#remove()`](https://developer.mozilla.org/en-US/docs/Web/API/ChildNode/remove) to the same effect.
    
    @function up.element.remove
    @param {Element} element
      The element to remove.
    @experimental
     */ remove = function(element) {
            var parent;
            if (element.remove) return element.remove();
            else if (parent = element.parentNode) return parent.removeChild(element);
        };
        /***
    Hides the given element.
    
    The element is hidden by setting an [inline style](https://www.codecademy.com/articles/html-inline-styles)
    of `{ display: none }`.
    
    Also see `up.element.show()`.
    
    @function up.element.hide
    @param {Element} element
    @experimental
     */ hide = function(element) {
            return element.style.display = "none";
        };
        /***
    Shows the given element.
    
    Also see `up.element.hide()`.
    
    \#\#\# Limitations
    
    The element is shown by setting an [inline style](https://www.codecademy.com/articles/html-inline-styles)
    of `{ display: '' }`.
    
    You might have CSS rules causing the element to remain hidden after calling `up.element.show(element)`.
    Unpoly will not handle such cases in order to keep this function performant. As a workaround, you may
    manually set the `element.style.display` property. Also see discussion
    in jQuery issues [#88](https://github.com/jquery/jquery.com/issues/88),
    [#2057](https://github.com/jquery/jquery/issues/2057) and
    [this WHATWG mailing list post](http://lists.w3.org/Archives/Public/public-whatwg-archive/2014Apr/0094.html).
    
    @function up.element.show
    @experimental
     */ show = function(element) {
            return element.style.display = "";
        };
        /***
    Display or hide the given element, depending on its current visibility.
    
    @function up.element.toggle
    @param {Element} element
    @param {Boolean} [newVisible]
      Pass `true` to show the element or `false` to hide it.
    
      If omitted, the element will be hidden if shown and shown if hidden.
    @experimental
     */ toggle = function(element, newVisible) {
            if (newVisible == null) newVisible = !isVisible(element);
            if (newVisible) return show(element);
            else return hide(element);
        };
        /***
    Adds or removes the given class from the given element.
    
    If you don't need IE11 support you may also use the built-in
    [`Element#classList.toggle(className)`](https://developer.mozilla.org/en-US/docs/Web/API/Element/classList) to the same effect.
    
    @function up.element.toggleClass
    @param {Element} element
      The element for which to add or remove the class.
    @param {String} className
      A boolean value to determine whether the class should be added or removed.
    @param {String} state
      If omitted, the class will be added if missing and removed if present.
    @experimental
     */ toggleClass = function(element, klass, newPresent) {
            var list;
            list = element.classList;
            if (newPresent == null) newPresent = !list.contains(klass);
            if (newPresent) return list.add(klass);
            else return list.remove(klass);
        };
        /***
    Sets all key/values from the given object as attributes on the given element.
    
    \#\#\# Example
    
        up.element.setAttrs(element, { title: 'Tooltip', tabindex: 1 })
    
    @function up.element.setAttrs
    @param {Element} element
      The element on which to set attributes.
    @param {object} attributes
      An object of attributes to set.
    @experimental
     */ setAttrs = function(element, attributes) {
            var key, results, value;
            results = [];
            for(key in attributes){
                value = attributes[key];
                results.push(element.setAttribute(key, value));
            }
            return results;
        };
        /***
    @function up.element.metaContent
    @internal
     */ metaContent = function(name) {
            var ref, selector;
            selector = "meta" + attributeSelector("name", name);
            return (ref = first(selector)) != null ? ref.getAttribute("content") : void 0;
        };
        /***
    @function up.element.insertBefore
    @internal
     */ insertBefore = function(existingElement, newElement) {
            return existingElement.insertAdjacentElement("beforebegin", newElement);
        };
        /***
    Replaces the given old element with the given new element.
    
    The old element will be removed from the DOM tree.
    
    If you don't need IE11 support you may also use the built-in
    [`Element#replaceWith()`](https://developer.mozilla.org/en-US/docs/Web/API/ChildNode/replaceWith) to the same effect.
    
    @function up.element.replace
    @param {Element} oldElement
    @param {Element} newElement
    @experimental
     */ replace = function(oldElement, newElement) {
            return oldElement.parentElement.replaceChild(newElement, oldElement);
        };
        /***
    Creates an element matching the given CSS selector.
    
    The created element will not yet be attached to the DOM tree.
    Attach it with [`Element#appendChild()`](https://developer.mozilla.org/en-US/docs/Web/API/Node/appendChild)
    or use `up.element.affix()` to create an attached element.
    
    \#\#\# Examples
    
    To create an element with a given tag name:
    
        element = up.element.createFromSelector('span')
        // element is <span></span>
    
    To create an element with a given class:
    
        element = up.element.createFromSelector('.klass')
        // element is <div class="klass"></div>
    
    To create an element with a given ID:
    
        element = up.element.createFromSelector('#foo')
        // element is <div id="foo"></div>
    
    To create an element with a given boolean attribute:
    
        element = up.element.createFromSelector('[attr]')
        // element is <div attr></div>
    
    To create an element with a given attribute value:
    
        element = up.element.createFromSelector('[attr="value"]')
        // element is <div attr="value"></div>
    
    You may also pass an object of attribute names/values as a second argument:
    
        element = up.element.createFromSelector('div', { attr: 'value' })
        // element is <div attr="value"></div>
    
    You may set the element's inner text by passing a `{ text }` option:
    
        element = up.element.createFromSelector('div', { text: 'inner text' })
        // element is <div>inner text</div>
    
    You may set inline styles by passing an object of CSS properties as a second argument:
    
        element = up.element.createFromSelector('div', { style: { color: 'red' }})
        // element is <div style="color: red"></div>
    
    @function up.element.createFromSelector
    @param {string} selector
      The CSS selector from which to create an element.
    @param {Object} [attrs]
      An object of attributes to set on the created element.
    @param {Object} [attrs.text]
      The [text content](https://developer.mozilla.org/en-US/docs/Web/API/Node/textContent) of the created element.
    @param {Object} [attrs.style]
      An object of CSS properties that will be set as the inline style
      of the created element.
    @return {Element}
      The created element.
    @experimental
     */ createFromSelector = function(selector, attrs) {
            var attrValues, classValue, depthElement, depthSelector, depths, i, j, klass, len, len1, previousElement, ref, rootElement, selectorWithoutAttrValues, styleValue, tagName, textValue;
            attrValues = [];
            selectorWithoutAttrValues = selector.replace(/\[([\w-]+)(?:=(["'])?([^"'\]]*?)\2)?\]/g, function(_match, attrName, _quote, attrValue) {
                attrValues.push(attrValue || "");
                return "[" + attrName + "]";
            });
            depths = selectorWithoutAttrValues.split(/[ >]+/);
            rootElement = void 0;
            depthElement = void 0;
            previousElement = void 0;
            for(i = 0, len = depths.length; i < len; i++){
                depthSelector = depths[i];
                tagName = void 0;
                depthSelector = depthSelector.replace(/^[\w-]+/, function(match) {
                    tagName = match;
                    return "";
                });
                depthElement = document.createElement(tagName || "div");
                rootElement || (rootElement = depthElement);
                depthSelector = depthSelector.replace(/\#([\w-]+)/, function(_match, id) {
                    depthElement.id = id;
                    return "";
                });
                depthSelector = depthSelector.replace(/\.([\w-]+)/g, function(_match, className) {
                    depthElement.classList.add(className);
                    return "";
                });
                if (attrValues.length) depthSelector = depthSelector.replace(/\[([\w-]+)\]/g, function(_match, attrName) {
                    depthElement.setAttribute(attrName, attrValues.shift());
                    return "";
                });
                if (depthSelector !== "") throw new Error("Cannot parse selector: " + selector);
                if (previousElement != null) previousElement.appendChild(depthElement);
                previousElement = depthElement;
            }
            if (attrs) {
                if (classValue = u.pluckKey(attrs, "class")) {
                    ref = u.wrapList(classValue);
                    for(j = 0, len1 = ref.length; j < len1; j++){
                        klass = ref[j];
                        rootElement.classList.add(klass);
                    }
                }
                if (styleValue = u.pluckKey(attrs, "style")) setInlineStyle(rootElement, styleValue);
                if (textValue = u.pluckKey(attrs, "text")) rootElement.innerText = textValue;
                setAttrs(rootElement, attrs);
            }
            return rootElement;
        };
        /***
    Creates an element matching the given CSS selector and attaches it to the given parent element.
    
    To create a detached element from a selector,
    see `up.element.createFromSelector()`.
    
    \#\#\# Example
    
        element = up.element.affix(document.body, '.klass')
        element.parentElement // returns document.body
        element.className // returns 'klass'
    
    @function up.element.affix
    @param {Element} parent
      The parent to which to attach the created element.
    @param {string} selector
      The CSS selector from which to create an element.
    @param {Object} attrs
      An object of attributes to set on the created element.
    @param {Object} attrs.text
      The [text content](https://developer.mozilla.org/en-US/docs/Web/API/Node/textContent) of the created element.
    @param {Object} attrs.style
      An object of CSS properties that will be set as the inline style
      of the created element.
    @return {Element}
      The created element.
    @experimental
     */ affix = function(parent, selector, attributes) {
            var element;
            element = createFromSelector(selector, attributes);
            parent.appendChild(element);
            return element;
        };
        /***
    Returns a CSS selector that matches the given element as good as possible.
    
    To build the selector, the following element properties are used in decreasing
    order of priority:
    
    - The element's `[up-id]` attribute
    - The element's `[id]` attribute
    - The element's `[name]` attribute
    - The element's `[class]` names
    - The element's [`[aria-label]`](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-label_attribute) attribute
    - The element's tag name
    
    \#\#\# Example
    
        element = document.createElement('span')
        element.className = 'klass'
        selector = up.element.toSelector(element) // returns '.klass'
    
    @function up.element.toSelector
    @param {string|Element|jQuery}
      The element for which to create a selector.
    @experimental
     */ toSelector = function(element) {
            var ariaLabel, classes, i, id, klass, len, name, selector, upId;
            if (u.isString(element)) return element;
            element = getOne(element);
            selector = void 0;
            if (isSingleton(element)) selector = elementTagName(element);
            else if (upId = element.getAttribute("up-id")) selector = attributeSelector("up-id", upId);
            else if (id = element.getAttribute("id")) {
                if (id.match(/^[a-z0-9\-_]+$/i)) selector = "#" + id;
                else selector = attributeSelector("id", id);
            } else if (name = element.getAttribute("name")) selector = elementTagName(element) + attributeSelector("name", name);
            else if (classes = u.presence(nonUpClasses(element))) {
                selector = "";
                for(i = 0, len = classes.length; i < len; i++){
                    klass = classes[i];
                    selector += "." + klass;
                }
            } else if (ariaLabel = element.getAttribute("aria-label")) selector = attributeSelector("aria-label", ariaLabel);
            else selector = elementTagName(element);
            return selector;
        };
        /***
    Sets an unique identifier for this element.
    
    This identifier is used by `up.element.toSelector()`
    to create a CSS selector that matches this element precisely.
    
    If the element already has other attributes that make a good identifier,
    like a `[id]`, `[class]` or `[aria-label]`, it is not necessary to
    set `[up-id]`.
    
    \#\#\# Example
    
    Take this element:
    
        <a href="/">Homepage</a>
    
    Unpoly cannot generate a good CSS selector for this element:
    
        up.element.toSelector(element)
        // returns 'a'
    
    We can improve this by assigning an `[up-id]`:
    
        <a href="/" up-id="link-to-home">Open user 4</a>
    
    The attribute value is used to create a better selector:
    
        up.element.toSelector(element)
        // returns '[up-id="link-to-home"]'
    
    @selector [up-id]
    @param {string} up-id
      A string that uniquely identifies this element.
    @stable
     */ /***
    @function up.element.isSingleton
    @internal
     */ isSingleton = function(element) {
            return matches(element, "html, body, head, title");
        };
        elementTagName = function(element) {
            return element.tagName.toLowerCase();
        };
        /***
    @function up.element.attributeSelector
    @internal
     */ attributeSelector = function(attribute, value) {
            value = value.replace(/"/g, '\\"');
            return "[" + attribute + '="' + value + '"]';
        };
        nonUpClasses = function(element) {
            var classString, classes;
            classString = element.className;
            classes = u.splitValues(classString);
            return u.reject(classes, function(klass) {
                return klass.match(/^up-/);
            });
        };
        /***
    @function up.element.createDocumentFromHtml
    @internal
     */ createDocumentFromHtml = function(html) {
            var parser;
            parser = new DOMParser();
            return parser.parseFromString(html, "text/html");
        };
        /***
    Creates an element from the given HTML fragment.
    
    \#\#\# Example
    
        element = up.element.createFromHtml('<div class="foo"><span>text</span></div>')
        element.className // returns 'foo'
        element.children[0] // returns <span> element
        element.children[0].textContent // returns 'text'
    
    @function up.element.createFromHtml
    @experimental
     */ createFromHtml = function(html) {
            var doc;
            doc = createDocumentFromHtml(html);
            return doc.body.children[0];
        };
        /***
    @function up.element.root
    @internal
     */ getRoot = function() {
            return document.documentElement;
        };
        /***
    Forces the browser to paint the given element now.
    
    @function up.element.paint
    @internal
     */ paint = function(element) {
            return element.offsetHeight;
        };
        /***
    @function up.element.concludeCssTransition
    @internal
     */ concludeCssTransition = function(element) {
            var undo;
            undo = setTemporaryStyle(element, {
                transition: "none"
            });
            paint(element);
            return undo;
        };
        /***
    Returns whether the given element has a CSS transition set.
    
    @function up.element.hasCssTransition
    @return {boolean}
    @internal
     */ hasCssTransition = function(elementOrStyleHash) {
            var duration, noTransition, prop, styleHash;
            if (u.isOptions(elementOrStyleHash)) styleHash = elementOrStyleHash;
            else styleHash = computedStyle(elementOrStyleHash);
            prop = styleHash.transitionProperty;
            duration = styleHash.transitionDuration;
            noTransition = prop === "none" || prop === "all" && duration === 0;
            return !noTransition;
        };
        /***
    @function up.element.fixedToAbsolute
    @internal
     */ fixedToAbsolute = function(element) {
            var elementRectAsFixed, offsetParentRect;
            elementRectAsFixed = element.getBoundingClientRect();
            element.style.position = "absolute";
            offsetParentRect = element.offsetParent.getBoundingClientRect();
            return setInlineStyle(element, {
                left: elementRectAsFixed.left - computedStyleNumber(element, "margin-left") - offsetParentRect.left,
                top: elementRectAsFixed.top - computedStyleNumber(element, "margin-top") - offsetParentRect.top,
                right: "",
                bottom: ""
            });
        };
        /***
    On the given element, set attributes that are still missing.
    
    @function up.element.setMissingAttrs
    @internal
     */ setMissingAttrs = function(element, attrs) {
            var key, results, value;
            results = [];
            for(key in attrs){
                value = attrs[key];
                if (u.isMissing(element.getAttribute(key))) results.push(element.setAttribute(key, value));
                else results.push(void 0);
            }
            return results;
        };
        /***
    @function up.element.unwrap
    @internal
     */ unwrap = function(wrapper) {
            var parent, wrappedNodes;
            parent = wrapper.parentNode;
            wrappedNodes = u.toArray(wrapper.childNodes);
            u.each(wrappedNodes, function(wrappedNode) {
                return parent.insertBefore(wrappedNode, wrapper);
            });
            return parent.removeChild(wrapper);
        };
        /***
    Returns the value of the given attribute on the given element, cast as a boolean value.
    
    If the attribute value cannot be cast to `true` or `false`, `undefined` is returned.
    
    \#\#\# Casting rules
    
    This function deviates from the
    [HTML Standard for boolean attributes](https://html.spec.whatwg.org/multipage/common-microsyntaxes.html#boolean-attributes)
    in order to allow `undefined` values. When an attribute is missing, Unpoly considers the value to be `undefined`
    (where the standard would assume `false`).
    
    Unpoly also allows `"true"` and `"false"` as attribute values.
    
    The table below shows return values for `up.element.booleanAttr(element, 'foo')` given different elements:
    
    | Element             | Return value |
    |---------------------|--------------|
    | `<div foo>`         | `true`       |
    | `<div foo="foo">`   | `true`       |
    | `<div foo="true">`  | `true`       |
    | `<div foo="">`      | `true`       |
    | `<div foo="false">` | `false`      |
    | `<div>`             | `undefined`  |
    | `<div foo="bar">`   | `undefined`  |
    
    @function up.element.booleanAttr
    @param {Element} element
      The element from which to retrieve the attribute value.
    @param {String} attribute
      The attribute name.
    @return {boolean|undefined}
      The cast attribute value.
    @experimental
     */ booleanAttr = function(element, attribute, pass) {
            var value;
            value = element.getAttribute(attribute);
            switch(value){
                case "false":
                    return false;
                case "true":
                case "":
                case attribute:
                    return true;
                default:
                    if (pass) return value;
            }
        };
        /***
    Returns the given attribute value cast as boolean.
    
    If the attribute value cannot be cast, returns the attribute value unchanged.
    
    @internal
     */ booleanOrStringAttr = function(element, attribute) {
            return booleanAttr(element, attribute, true);
        };
        /***
    Returns the value of the given attribute on the given element, cast to a number.
    
    If the attribute value cannot be cast to a number, `undefined` is returned.
    
    @function up.element.numberAttr
    @param {Element} element
      The element from which to retrieve the attribute value.
    @param {String} attribute
      The attribute name.
    @return {number|undefined}
      The cast attribute value.
    @experimental
     */ numberAttr = function(element, attribute) {
            var value;
            value = element.getAttribute(attribute);
            if (value != null ? value.match(/^[\d\.]+$/) : void 0) return parseFloat(value);
        };
        /***
    Reads the given attribute from the element, parsed as [JSON](https://www.json.org/).
    
    Returns `undefined` if the attribute value is [blank](/up.util.isBlank).
    
    Throws a `SyntaxError` if the attribute value is an invalid JSON string.
    
    @function up.element.jsonAttr
    @param {Element} element
      The element from which to retrieve the attribute value.
    @param {String} attribute
      The attribute name.
    @return {Object|undefined}
      The cast attribute value.
    @experimental
     */ jsonAttr = function(element, attribute) {
            var json, ref;
            if (json = typeof element.getAttribute === "function" ? (ref = element.getAttribute(attribute)) != null ? ref.trim() : void 0 : void 0) return JSON.parse(json);
        };
        /***
    Temporarily sets the inline CSS styles on the given element.
    
    Returns a function that restores the original inline styles when called.
    
    \#\#\# Example
    
        element = document.querySelector('div')
        unhide = up.element.setTemporaryStyle(element, { 'visibility': 'hidden' })
        // do things while element is invisible
        unhide()
        // element is visible again
    
    @function up.element.setTemporaryStyle
    @param {Element} element
      The element to style.
    @param {Object} styles
      An object of CSS property names and values.
    @return {Function()}
      A function that restores the original inline styles when called.
    @internal
     */ setTemporaryStyle = function(element, newStyles, block) {
            var oldStyles;
            oldStyles = inlineStyle(element, Object.keys(newStyles));
            setInlineStyle(element, newStyles);
            return function() {
                return setInlineStyle(element, oldStyles);
            };
        };
        /***
    Receives [computed CSS styles](https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle)
    for the given element.
    
    \#\#\# Examples
    
    When requesting a single CSS property, its value will be returned as a string:
    
        value = up.element.style(element, 'font-size')
        // value is '16px'
    
    When requesting multiple CSS properties, the function returns an object of property names and values:
    
        value = up.element.style(element, ['font-size', 'margin-top'])
        // value is { 'font-size': '16px', 'margin-top': '10px' }
    
    @function up.element.style
    @param {Element} element
    @param {String|Array} propOrProps
      One or more CSS property names in kebab-case or camelCase.
    @return {string|object}
    @experimental
     */ computedStyle = function(element, props) {
            var style;
            style = window.getComputedStyle(element);
            return extractFromStyleObject(style, props);
        };
        /***
    Receives a [computed CSS property value](https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle)
    for the given element, casted as a number.
    
    The value is casted by removing the property's [unit](https://www.w3schools.com/cssref/css_units.asp) (which is usually `px` for computed properties).
    The result is then parsed as a floating point number.
    
    Returns `undefined` if the property value is missing, or if it cannot
    be parsed as a number.
    
    \#\#\# Examples
    
    When requesting a single CSS property, its value will be returned as a string:
    
        value = up.element.style(element, 'font-size')
        // value is '16px'
    
        value = up.element.styleNumber(element, 'font-size')
        // value is 16
    
    @function up.element.styleNumber
    @param {Element} element
    @param {String} prop
      A single property name in kebab-case or camelCase.
    @return {number|undefined}
    @experimental
     */ computedStyleNumber = function(element, prop) {
            var rawValue;
            rawValue = computedStyle(element, prop);
            if (u.isGiven(rawValue)) return parseFloat(rawValue);
            else return void 0;
        };
        /***
    Gets the given inline style(s) from the given element's `[style]` attribute.
    
    @function up.element.inlineStyle
    @param {Element} element
    @param {String|Array} propOrProps
      One or more CSS property names in kebab-case or camelCase.
    @return {string|object}
    @internal
     */ inlineStyle = function(element, props) {
            var style;
            style = element.style;
            return extractFromStyleObject(style, props);
        };
        extractFromStyleObject = function(style, keyOrKeys) {
            if (u.isString(keyOrKeys)) return style[keyOrKeys];
            else return u.only.apply(u, [
                style
            ].concat(slice.call(keyOrKeys)));
        };
        /***
    Sets the given CSS properties as inline styles on the given element.
    
    @function up.element.setStyle
    @param {Element} element
    @param {Object} props
      One or more CSS properties with kebab-case keys or camelCase keys.
    @return {string|object}
    @experimental
     */ setInlineStyle = function(element, props) {
            var key, results, style, value;
            style = element.style;
            results = [];
            for(key in props){
                value = props[key];
                value = normalizeStyleValueForWrite(key, value);
                results.push(style[key] = value);
            }
            return results;
        };
        normalizeStyleValueForWrite = function(key, value) {
            if (u.isMissing(value)) value = "";
            else if (CSS_LENGTH_PROPS.has(key.toLowerCase().replace(/-/, ""))) value = cssLength(value);
            return value;
        };
        CSS_LENGTH_PROPS = u.arrayToSet([
            "top",
            "right",
            "bottom",
            "left",
            "padding",
            "paddingtop",
            "paddingright",
            "paddingbottom",
            "paddingleft",
            "margin",
            "margintop",
            "marginright",
            "marginbottom",
            "marginleft",
            "borderwidth",
            "bordertopwidth",
            "borderrightwidth",
            "borderbottomwidth",
            "borderleftwidth",
            "width",
            "height",
            "maxwidth",
            "maxheight",
            "minwidth",
            "minheight"
        ]);
        /***
    Converts the given value to a CSS length value, adding a `px` unit if required.
    
    @function cssLength
    @internal
     */ cssLength = function(obj) {
            if (u.isNumber(obj) || u.isString(obj) && /^\d+$/.test(obj)) return obj.toString() + "px";
            else return obj;
        };
        /***
    Resolves the given CSS selector (which might contain `&` references)
    to a full CSS selector without ampersands.
    
    If passed an `Element` or `jQuery` element, returns a CSS selector string
    for that element.
    
    @function up.element.resolveSelector
    @param {string|Element|jQuery} selectorOrElement
    @param {string|Element|jQuery} origin
      The element that this selector resolution is relative to.
      That element's selector will be substituted for `&` ([like in Sass](https://sass-lang.com/documentation/file.SASS_REFERENCE.html#parent-selector)).
    @return {string}
    @internal
     */ resolveSelector = function(selectorOrElement, origin) {
            var originSelector, selector;
            if (u.isString(selectorOrElement)) {
                selector = selectorOrElement;
                if (u.contains(selector, "&")) {
                    if (u.isPresent(origin)) {
                        originSelector = toSelector(origin);
                        selector = selector.replace(/\&/, originSelector);
                    } else up.fail("Found origin reference (%s) in selector %s, but no origin was given", "&", selector);
                }
            } else selector = toSelector(selectorOrElement);
            return selector;
        };
        /***
    Returns whether the given element is currently visible.
    
    An element is considered visible if it consumes space in the document.
    Elements with `{ visibility: hidden }` or `{ opacity: 0 }` are considered visible, since they still consume space in the layout.
    
    Elements not attached to the DOM are considered hidden.
    
    @function up.element.isVisible
    @param {Element} element
      The element to check.
    @experimental
     */ isVisible = function(element) {
            return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
        };
        return {
            first: first,
            all: all,
            subtree: subtree,
            closest: closest,
            matches: matches,
            ancestor: ancestor,
            get: getOne,
            list: getList,
            remove: remove,
            toggle: toggle,
            toggleClass: toggleClass,
            hide: hide,
            show: show,
            metaContent: metaContent,
            replace: replace,
            insertBefore: insertBefore,
            createFromSelector: createFromSelector,
            setAttrs: setAttrs,
            affix: affix,
            toSelector: toSelector,
            isSingleton: isSingleton,
            attributeSelector: attributeSelector,
            createDocumentFromHtml: createDocumentFromHtml,
            createFromHtml: createFromHtml,
            root: getRoot,
            paint: paint,
            concludeCssTransition: concludeCssTransition,
            hasCssTransition: hasCssTransition,
            fixedToAbsolute: fixedToAbsolute,
            setMissingAttrs: setMissingAttrs,
            unwrap: unwrap,
            booleanAttr: booleanAttr,
            numberAttr: numberAttr,
            jsonAttr: jsonAttr,
            booleanOrStringAttr: booleanOrStringAttr,
            setTemporaryStyle: setTemporaryStyle,
            style: computedStyle,
            styleNumber: computedStyleNumber,
            inlineStyle: inlineStyle,
            setStyle: setInlineStyle,
            resolveSelector: resolveSelector,
            none: function() {
                return NONE;
            },
            isVisible: isVisible
        };
    }();
}).call(module.exports);
(function() {
    var e;
    e = up.element;
    up.BodyShifter = function() {
        function BodyShifter() {
            this.unshiftFns = [];
        }
        BodyShifter.prototype.shift = function() {
            var anchor, body, bodyRightPadding, bodyRightShift, elementRight, elementRightShift, i, len, overflowElement, ref, results, rootHadVerticalScrollbar, scrollbarWidth;
            rootHadVerticalScrollbar = up.viewport.rootHasVerticalScrollbar();
            overflowElement = up.viewport.rootOverflowElement();
            this.unshiftFns.push(e.setTemporaryStyle(overflowElement, {
                overflowY: "hidden"
            }));
            if (rootHadVerticalScrollbar) {
                body = document.body;
                scrollbarWidth = up.viewport.scrollbarWidth();
                bodyRightPadding = e.styleNumber(body, "paddingRight");
                bodyRightShift = scrollbarWidth + bodyRightPadding;
                this.unshiftFns.push(e.setTemporaryStyle(body, {
                    paddingRight: bodyRightShift
                }));
                ref = up.viewport.anchoredRight();
                results = [];
                for(i = 0, len = ref.length; i < len; i++){
                    anchor = ref[i];
                    elementRight = e.styleNumber(anchor, "right");
                    elementRightShift = scrollbarWidth + elementRight;
                    results.push(this.unshiftFns.push(e.setTemporaryStyle(anchor, {
                        right: elementRightShift
                    })));
                }
                return results;
            }
        };
        BodyShifter.prototype.unshift = function() {
            var results, unshiftFn;
            results = [];
            while(unshiftFn = this.unshiftFns.pop())results.push(unshiftFn());
            return results;
        };
        return BodyShifter;
    }();
}).call(module.exports);
(function() {
    var u, bind = function(fn, me) {
        return function() {
            return fn.apply(me, arguments);
        };
    }, slice = [].slice;
    u = up.util;
    /***
  @class up.Cache
  @internal
   */ up.Cache = function() {
        /***
    @constructor
    @param {number|Function(): number} [config.size]
      Maximum number of cache entries.
      Set to `undefined` to not limit the cache size.
    @param {number|Function(): number} [config.expiry]
      The number of milliseconds after which a cache entry
      will be discarded.
    @param {string} [config.logPrefix]
      A prefix for log entries printed by this cache object.
    @param {Function(entry): string} [config.key]
      A function that takes an argument and returns a string key
      for storage. If omitted, `toString()` is called on the argument.
    @param {Function(entry): boolean} [config.cachable]
      A function that takes a potential cache entry and returns whether
      this entry  can be stored in the hash. If omitted, all entries are considered
      cachable.
     */ function Cache(config) {
            this.config = config != null ? config : {};
            this.get = bind(this.get, this);
            this.isFresh = bind(this.isFresh, this);
            this.remove = bind(this.remove, this);
            this.set = bind(this.set, this);
            this.timestamp = bind(this.timestamp, this);
            this.alias = bind(this.alias, this);
            this.makeRoomForAnotherKey = bind(this.makeRoomForAnotherKey, this);
            this.keys = bind(this.keys, this);
            this.log = bind(this.log, this);
            this.clear = bind(this.clear, this);
            this.isCachable = bind(this.isCachable, this);
            this.isEnabled = bind(this.isEnabled, this);
            this.normalizeStoreKey = bind(this.normalizeStoreKey, this);
            this.expiryMillis = bind(this.expiryMillis, this);
            this.maxKeys = bind(this.maxKeys, this);
            this.store = this.config.store || new up.store.Memory();
        }
        Cache.prototype.maxKeys = function() {
            return u.evalOption(this.config.size);
        };
        Cache.prototype.expiryMillis = function() {
            return u.evalOption(this.config.expiry);
        };
        Cache.prototype.normalizeStoreKey = function(key) {
            if (this.config.key) return this.config.key(key);
            else return key.toString();
        };
        Cache.prototype.isEnabled = function() {
            return this.maxKeys() !== 0 && this.expiryMillis() !== 0;
        };
        Cache.prototype.isCachable = function(key) {
            if (this.config.cachable) return this.config.cachable(key);
            else return true;
        };
        Cache.prototype.clear = function() {
            return this.store.clear();
        };
        Cache.prototype.log = function() {
            var args;
            args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
            if (this.config.logPrefix) {
                args[0] = "[" + this.config.logPrefix + "] " + args[0];
                return up.puts.apply(up, args);
            }
        };
        Cache.prototype.keys = function() {
            return this.store.keys();
        };
        Cache.prototype.makeRoomForAnotherKey = function() {
            var max, oldestKey, oldestTimestamp, storeKeys;
            storeKeys = u.copy(this.keys());
            max = this.maxKeys();
            if (max && storeKeys.length >= max) {
                oldestKey = void 0;
                oldestTimestamp = void 0;
                u.each(storeKeys, function(_this) {
                    return function(key) {
                        var entry, timestamp;
                        entry = _this.store.get(key);
                        timestamp = entry.timestamp;
                        if (!oldestTimestamp || oldestTimestamp > timestamp) {
                            oldestKey = key;
                            return oldestTimestamp = timestamp;
                        }
                    };
                }(this));
                if (oldestKey) return this.store.remove(oldestKey);
            }
        };
        Cache.prototype.alias = function(oldKey, newKey) {
            var value;
            value = this.get(oldKey, {
                silent: true
            });
            if (u.isDefined(value)) return this.set(newKey, value);
        };
        Cache.prototype.timestamp = function() {
            return new Date().valueOf();
        };
        Cache.prototype.set = function(key, value) {
            var storeKey, timestampedValue;
            if (this.isEnabled() && this.isCachable(key)) {
                this.makeRoomForAnotherKey();
                storeKey = this.normalizeStoreKey(key);
                this.log("Setting entry %o to %o", storeKey, value);
                timestampedValue = {
                    timestamp: this.timestamp(),
                    value: value
                };
                return this.store.set(storeKey, timestampedValue);
            }
        };
        Cache.prototype.remove = function(key) {
            var storeKey;
            if (this.isCachable(key)) {
                storeKey = this.normalizeStoreKey(key);
                return this.store.remove(storeKey);
            }
        };
        Cache.prototype.isFresh = function(entry) {
            var millis, timeSinceTouch;
            millis = this.expiryMillis();
            if (millis) {
                timeSinceTouch = this.timestamp() - entry.timestamp;
                return timeSinceTouch < millis;
            } else return true;
        };
        Cache.prototype.get = function(key, options) {
            var entry;
            if (options == null) options = {};
            if (this.isCachable(key) && (entry = this.store.get(this.normalizeStoreKey(key)))) {
                if (this.isFresh(entry)) {
                    if (!options.silent) this.log("Cache hit for '%s'", key);
                    return entry.value;
                } else {
                    if (!options.silent) this.log("Discarding stale cache entry for '%s'", key);
                    this.remove(key);
                    return void 0;
                }
            } else {
                if (!options.silent) this.log("Cache miss for '%s'", key);
                return void 0;
            }
        };
        return Cache;
    }();
}).call(module.exports);
(function() {
    var u, slice = [].slice;
    u = up.util;
    up.Record = function() {
        Record.prototype.fields = function() {
            throw "Return an array of property names";
        };
        function Record(options) {
            u.assign(this, this.attributes(options));
        }
        Record.prototype.attributes = function(source) {
            if (source == null) source = this;
            return u.only.apply(u, [
                source
            ].concat(slice.call(this.fields())));
        };
        Record.prototype["" + u.copy.key] = function() {
            return this.variant();
        };
        Record.prototype.variant = function(changes) {
            var attributesWithChanges;
            if (changes == null) changes = {};
            attributesWithChanges = u.merge(this.attributes(), changes);
            return new this.constructor(attributesWithChanges);
        };
        Record.prototype["" + u.isEqual.key] = function(other) {
            return other && this.constructor === other.constructor && u.isEqual(this.attributes(), other.attributes());
        };
        return Record;
    }();
}).call(module.exports);
(function() {
    var e, u, bind = function(fn, me) {
        return function() {
            return fn.apply(me, arguments);
        };
    };
    u = up.util;
    e = up.element;
    up.CompilePass = function() {
        function CompilePass(root, compilers, options) {
            this.root = root;
            this.compilers = compilers;
            if (options == null) options = {};
            this.isInSkippedSubtree = bind(this.isInSkippedSubtree, this);
            this.skipSubtrees = options.skip;
            if (!(this.skipSubtrees.length && this.root.querySelector("[up-keep]"))) this.skipSubtrees = void 0;
        }
        CompilePass.prototype.compile = function() {
            return up.log.group("Compiling fragment %o", this.root, function(_this) {
                return function() {
                    var compiler, i, len, ref, results;
                    ref = _this.compilers;
                    results = [];
                    for(i = 0, len = ref.length; i < len; i++){
                        compiler = ref[i];
                        results.push(_this.runCompiler(compiler));
                    }
                    return results;
                };
            }(this));
        };
        CompilePass.prototype.runCompiler = function(compiler) {
            var matches;
            matches = this.select(compiler.selector);
            if (!matches.length) return;
            return up.log.group(!compiler.isDefault ? "Compiling '%s' on %d element(s)" : void 0, compiler.selector, matches.length, function(_this) {
                return function() {
                    var i, j, keepValue, len, len1, match, results, value;
                    if (compiler.batch) _this.compileBatch(compiler, matches);
                    else for(i = 0, len = matches.length; i < len; i++){
                        match = matches[i];
                        _this.compileOneElement(compiler, match);
                    }
                    if (keepValue = compiler.keep) {
                        value = u.isString(keepValue) ? keepValue : "";
                        results = [];
                        for(j = 0, len1 = matches.length; j < len1; j++){
                            match = matches[j];
                            results.push(match.setAttribute("up-keep", value));
                        }
                        return results;
                    }
                };
            }(this));
        };
        CompilePass.prototype.compileOneElement = function(compiler, element) {
            var compileArgs, data, destructorOrDestructors, elementArg, result;
            elementArg = compiler.jQuery ? up.browser.jQuery(element) : element;
            compileArgs = [
                elementArg
            ];
            if (compiler.length !== 1) {
                data = up.syntax.data(element);
                compileArgs.push(data);
            }
            result = compiler.apply(element, compileArgs);
            if (destructorOrDestructors = this.destructorPresence(result)) return up.destructor(element, destructorOrDestructors);
        };
        CompilePass.prototype.compileBatch = function(compiler, elements) {
            var compileArgs, dataList, elementsArgs, result;
            elementsArgs = compiler.jQuery ? up.browser.jQuery(elements) : elements;
            compileArgs = [
                elementsArgs
            ];
            if (compiler.length !== 1) {
                dataList = u.map(elements, up.syntax.data);
                compileArgs.push(dataList);
            }
            result = compiler.apply(elements, compileArgs);
            if (this.destructorPresence(result)) return up.fail("Compilers with { batch: true } cannot return destructors");
        };
        CompilePass.prototype.destructorPresence = function(result) {
            if (u.isFunction(result) || u.isArray(result) && u.every(result, u.isFunction)) return result;
        };
        CompilePass.prototype.select = function(selector) {
            var matches;
            if (u.isFunction(selector)) selector = selector();
            matches = e.subtree(this.root, selector);
            if (this.skipSubtrees) matches = u.reject(matches, this.isInSkippedSubtree);
            return matches;
        };
        CompilePass.prototype.isInSkippedSubtree = function(element) {
            var parent;
            if (u.contains(this.skipSubtrees, element)) return true;
            else if (parent = element.parentElement) return this.isInSkippedSubtree(parent);
            else return false;
        };
        return CompilePass;
    }();
}).call(module.exports);
(function() {
    var u;
    u = up.util;
    up.Config = function() {
        function Config(blueprint) {
            this.blueprint = blueprint;
            this.reset();
        }
        Config.prototype.reset = function() {
            return u.assign(this, u.deepCopy(this.blueprint));
        };
        return Config;
    }();
}).call(module.exports);
(function() {
    var e, u, bind = function(fn, me) {
        return function() {
            return fn.apply(me, arguments);
        };
    };
    u = up.util;
    e = up.element;
    up.CssTransition = function() {
        function CssTransition(element, lastFrameKebab, options) {
            this.element = element;
            this.lastFrameKebab = lastFrameKebab;
            this.startMotion = bind(this.startMotion, this);
            this.resumeOldTransition = bind(this.resumeOldTransition, this);
            this.pauseOldTransition = bind(this.pauseOldTransition, this);
            this.finish = bind(this.finish, this);
            this.onTransitionEnd = bind(this.onTransitionEnd, this);
            this.listenToTransitionEnd = bind(this.listenToTransitionEnd, this);
            this.stopFallbackTimer = bind(this.stopFallbackTimer, this);
            this.startFallbackTimer = bind(this.startFallbackTimer, this);
            this.onFinishEvent = bind(this.onFinishEvent, this);
            this.listenToFinishEvent = bind(this.listenToFinishEvent, this);
            this.start = bind(this.start, this);
            this.lastFrameKeysKebab = Object.keys(this.lastFrameKebab);
            if (u.some(this.lastFrameKeysKebab, function(key) {
                return key.match(/A-Z/);
            })) up.fail("Animation keys must be kebab-case");
            this.finishEvent = options.finishEvent;
            this.duration = options.duration;
            this.delay = options.delay;
            this.totalDuration = this.delay + this.duration;
            this.easing = options.easing;
            this.finished = false;
        }
        CssTransition.prototype.start = function() {
            if (this.lastFrameKeysKebab.length === 0) {
                this.finished = true;
                return Promise.resolve();
            }
            this.deferred = u.newDeferred();
            this.pauseOldTransition();
            this.startTime = new Date();
            this.startFallbackTimer();
            this.listenToFinishEvent();
            this.listenToTransitionEnd();
            this.startMotion();
            return this.deferred.promise();
        };
        CssTransition.prototype.listenToFinishEvent = function() {
            if (this.finishEvent) return this.stopListenToFinishEvent = this.element.addEventListener(this.finishEvent, this.onFinishEvent);
        };
        CssTransition.prototype.onFinishEvent = function(event) {
            event.stopPropagation();
            return this.finish();
        };
        CssTransition.prototype.startFallbackTimer = function() {
            var timingTolerance;
            timingTolerance = 100;
            return this.fallbackTimer = u.timer(this.totalDuration + timingTolerance, function(_this) {
                return function() {
                    return _this.finish();
                };
            }(this));
        };
        CssTransition.prototype.stopFallbackTimer = function() {
            return clearTimeout(this.fallbackTimer);
        };
        CssTransition.prototype.listenToTransitionEnd = function() {
            return this.stopListenToTransitionEnd = up.on(this.element, "transitionend", this.onTransitionEnd);
        };
        CssTransition.prototype.onTransitionEnd = function(event) {
            var completedPropertyKebab, elapsed;
            if (event.target !== this.element) return;
            elapsed = new Date() - this.startTime;
            if (!(elapsed > 0.25 * this.totalDuration)) return;
            completedPropertyKebab = event.propertyName;
            if (!u.contains(this.lastFrameKeysKebab, completedPropertyKebab)) return;
            return this.finish();
        };
        CssTransition.prototype.finish = function() {
            if (this.finished) return;
            this.finished = true;
            this.stopFallbackTimer();
            if (typeof this.stopListenToFinishEvent === "function") this.stopListenToFinishEvent();
            if (typeof this.stopListenToTransitionEnd === "function") this.stopListenToTransitionEnd();
            e.concludeCssTransition(this.element);
            this.resumeOldTransition();
            return this.deferred.resolve();
        };
        CssTransition.prototype.pauseOldTransition = function() {
            var oldTransition, oldTransitionFrameKebab, oldTransitionProperties;
            oldTransition = e.style(this.element, [
                "transitionProperty",
                "transitionDuration",
                "transitionDelay",
                "transitionTimingFunction"
            ]);
            if (e.hasCssTransition(oldTransition)) {
                if (oldTransition.transitionProperty !== "all") {
                    oldTransitionProperties = oldTransition.transitionProperty.split(/\s*,\s*/);
                    oldTransitionFrameKebab = e.style(this.element, oldTransitionProperties);
                    this.setOldTransitionTargetFrame = e.setTemporaryStyle(this.element, oldTransitionFrameKebab);
                }
                return this.setOldTransition = e.concludeCssTransition(this.element);
            }
        };
        CssTransition.prototype.resumeOldTransition = function() {
            if (typeof this.setOldTransitionTargetFrame === "function") this.setOldTransitionTargetFrame();
            return typeof this.setOldTransition === "function" ? this.setOldTransition() : void 0;
        };
        CssTransition.prototype.startMotion = function() {
            e.setStyle(this.element, {
                transitionProperty: Object.keys(this.lastFrameKebab).join(", "),
                transitionDuration: this.duration + "ms",
                transitionDelay: this.delay + "ms",
                transitionTimingFunction: this.easing
            });
            return e.setStyle(this.element, this.lastFrameKebab);
        };
        return CssTransition;
    }();
}).call(module.exports);
(function() {
    var u, bind = function(fn, me) {
        return function() {
            return fn.apply(me, arguments);
        };
    }, slice = [].slice;
    u = up.util;
    /***
  A linear task queue whose (2..n)th tasks can be changed at any time.
  
  @function up.DivertibleChain
  @internal
   */ up.DivertibleChain = function() {
        function DivertibleChain() {
            this.asap = bind(this.asap, this);
            this.poke = bind(this.poke, this);
            this.allTasks = bind(this.allTasks, this);
            this.promise = bind(this.promise, this);
            this.reset = bind(this.reset, this);
            this.reset();
        }
        DivertibleChain.prototype.reset = function() {
            this.queue = [];
            return this.currentTask = void 0;
        };
        DivertibleChain.prototype.promise = function() {
            var lastTask;
            lastTask = u.last(this.allTasks());
            return (lastTask != null ? lastTask.promise : void 0) || Promise.resolve();
        };
        DivertibleChain.prototype.allTasks = function() {
            var tasks;
            tasks = [];
            if (this.currentTask) tasks.push(this.currentTask);
            tasks = tasks.concat(this.queue);
            return tasks;
        };
        DivertibleChain.prototype.poke = function() {
            var promise;
            if (!this.currentTask) {
                if (this.currentTask = this.queue.shift()) {
                    promise = this.currentTask();
                    return u.always(promise, function(_this) {
                        return function() {
                            _this.currentTask = void 0;
                            return _this.poke();
                        };
                    }(this));
                }
            }
        };
        DivertibleChain.prototype.asap = function() {
            var newTasks;
            newTasks = 1 <= arguments.length ? slice.call(arguments, 0) : [];
            this.queue = u.map(newTasks, u.previewable);
            this.poke();
            return this.promise();
        };
        return DivertibleChain;
    }();
}).call(module.exports);
(function() {
    var e, u, bind = function(fn, me) {
        return function() {
            return fn.apply(me, arguments);
        };
    };
    u = up.util;
    e = up.element;
    up.EventListener = function() {
        function EventListener(element1, eventName1, selector1, callback1, options) {
            this.element = element1;
            this.eventName = eventName1;
            this.selector = selector1;
            this.callback = callback1;
            if (options == null) options = {};
            this.nativeCallback = bind(this.nativeCallback, this);
            this.unbind = bind(this.unbind, this);
            this.jQuery = options.jQuery;
            this.key = this.constructor.key(this.eventName, this.selector, this.callback);
            this.isDefault = up.framework.isBooting();
        }
        EventListener.prototype.bind = function() {
            var base, map;
            map = (base = this.element).upEventListeners || (base.upEventListeners = {});
            if (map[this.key]) up.fail("up.on(): The %o callback %o cannot be registered more than once", this.eventName, this.callback);
            map[this.key] = this;
            return this.element.addEventListener(this.eventName, this.nativeCallback);
        };
        EventListener.prototype.unbind = function() {
            var map;
            if (map = this.element.upEventListeners) delete map[this.key];
            return this.element.removeEventListener(this.eventName, this.nativeCallback);
        };
        EventListener.prototype.nativeCallback = function(event) {
            var args, data, element, elementArg, expectedArgCount;
            element = event.target;
            if (this.selector) element = e.closest(element, this.selector);
            if (element) {
                elementArg = this.jQuery ? up.browser.jQuery(element) : element;
                args = [
                    event,
                    elementArg
                ];
                expectedArgCount = this.callback.length;
                if (!(expectedArgCount === 1 || expectedArgCount === 2)) {
                    data = up.syntax.data(element);
                    args.push(data);
                }
                return this.callback.apply(element, args);
            }
        };
        /*
    Parses the following arg variants into an object:
    
    - [elements, eventNames, selector, callback]
    - [elements, eventNames,           callback]
    - [          eventNames, selector, callback]
    - [          eventNames,           callback]
    
    @function up.EventListener#parseArgs
    @internal
     */ EventListener.parseArgs = function(args) {
            var callback, elements, eventNames, selector;
            args = u.copy(args);
            callback = args.pop();
            callback.upUid || (callback.upUid = u.uid());
            if (args[0].addEventListener) elements = [
                args.shift()
            ];
            else if (u.isJQuery(args[0]) || u.isList(args[0]) && args[0][0].addEventListener) elements = args.shift();
            else elements = [
                document
            ];
            eventNames = u.splitValues(args.shift());
            selector = args[0];
            return {
                elements: elements,
                eventNames: eventNames,
                selector: selector,
                callback: callback
            };
        };
        EventListener.bind = function(args, options) {
            var element, eventName, i, j, len, len1, listener, parsed, ref, ref1, unbindFns;
            parsed = this.parseArgs(args);
            unbindFns = [];
            ref = parsed.elements;
            for(i = 0, len = ref.length; i < len; i++){
                element = ref[i];
                ref1 = parsed.eventNames;
                for(j = 0, len1 = ref1.length; j < len1; j++){
                    eventName = ref1[j];
                    listener = new this(element, eventName, parsed.selector, parsed.callback, options);
                    listener.bind();
                    unbindFns.push(listener.unbind);
                }
            }
            return u.sequence(unbindFns);
        };
        EventListener.key = function(eventName, selector, callback) {
            return [
                eventName,
                selector,
                callback.upUid
            ].join("|");
        };
        EventListener.unbind = function(args) {
            var element, eventName, i, key, len, listener, map, parsed, ref, results;
            parsed = this.parseArgs(args);
            ref = parsed.elements;
            results = [];
            for(i = 0, len = ref.length; i < len; i++){
                element = ref[i];
                map = element.upEventListeners;
                results.push((function() {
                    var j, len1, ref1, results1;
                    ref1 = parsed.eventNames;
                    results1 = [];
                    for(j = 0, len1 = ref1.length; j < len1; j++){
                        eventName = ref1[j];
                        key = this.key(eventName, parsed.selector, parsed.callback);
                        if (map && (listener = map[key])) results1.push(listener.unbind());
                        else results1.push(void 0);
                    }
                    return results1;
                }).call(this));
            }
            return results;
        };
        EventListener.unbindNonDefault = function(element) {
            var i, len, listener, listeners, map, results;
            if (map = element.upEventListeners) {
                listeners = u.values(map);
                results = [];
                for(i = 0, len = listeners.length; i < len; i++){
                    listener = listeners[i];
                    if (!listener.isDefault) results.push(listener.unbind());
                    else results.push(void 0);
                }
                return results;
            }
        };
        return EventListener;
    }();
}).call(module.exports);
(function() {
    var u, bind = function(fn, me) {
        return function() {
            return fn.apply(me, arguments);
        };
    };
    u = up.util;
    up.ExtractCascade = function() {
        function ExtractCascade(selectorOrElement, options) {
            this.oldPlanNotFound = bind(this.oldPlanNotFound, this);
            this.matchingPlanNotFound = bind(this.matchingPlanNotFound, this);
            this.bestMatchingSteps = bind(this.bestMatchingSteps, this);
            this.bestPreflightSelector = bind(this.bestPreflightSelector, this);
            this.detectPlan = bind(this.detectPlan, this);
            this.matchingPlan = bind(this.matchingPlan, this);
            this.newPlan = bind(this.newPlan, this);
            this.oldPlan = bind(this.oldPlan, this);
            var base, base1;
            this.options = u.options(options, {
                humanizedTarget: "selector",
                layer: "auto"
            });
            if ((base = this.options).transition == null) base.transition = this.options.animation;
            if ((base1 = this.options).hungry == null) base1.hungry = true;
            this.candidates = this.buildCandidates(selectorOrElement);
            this.plans = u.map(this.candidates, function(_this) {
                return function(candidate, i) {
                    var planOptions, ref;
                    planOptions = u.copy(_this.options);
                    if (i > 0) planOptions.transition = (ref = up.fragment.config.fallbackTransition) != null ? ref : _this.options.transition;
                    return new up.ExtractPlan(candidate, planOptions);
                };
            }(this));
        }
        ExtractCascade.prototype.buildCandidates = function(selector) {
            var candidates;
            candidates = [
                selector,
                this.options.fallback,
                up.fragment.config.fallbacks
            ];
            candidates = u.flatten(candidates);
            candidates = u.filter(candidates, u.isTruthy);
            candidates = u.uniq(candidates);
            if (this.options.fallback === false || this.options.provideTarget) candidates = [
                candidates[0]
            ];
            return candidates;
        };
        ExtractCascade.prototype.oldPlan = function() {
            return this.detectPlan("oldExists");
        };
        ExtractCascade.prototype.newPlan = function() {
            return this.detectPlan("newExists");
        };
        ExtractCascade.prototype.matchingPlan = function() {
            return this.detectPlan("matchExists");
        };
        ExtractCascade.prototype.detectPlan = function(checker) {
            return u.find(this.plans, function(plan) {
                return plan[checker]();
            });
        };
        ExtractCascade.prototype.bestPreflightSelector = function() {
            var plan;
            if (this.options.provideTarget) plan = this.plans[0];
            else plan = this.oldPlan();
            if (plan) {
                plan.resolveNesting();
                return plan.selector();
            } else return this.oldPlanNotFound();
        };
        ExtractCascade.prototype.bestMatchingSteps = function() {
            var plan;
            if (plan = this.matchingPlan()) {
                plan.addHungrySteps();
                plan.resolveNesting();
                return plan.steps;
            } else return this.matchingPlanNotFound();
        };
        ExtractCascade.prototype.matchingPlanNotFound = function() {
            var inspectAction, message;
            if (this.newPlan()) return this.oldPlanNotFound();
            else {
                if (this.oldPlan()) message = "Could not find " + this.options.humanizedTarget + " in response";
                else message = "Could not match " + this.options.humanizedTarget + " in current page and response";
                if (this.options.inspectResponse) inspectAction = {
                    label: "Open response",
                    callback: this.options.inspectResponse
                };
                return up.fail([
                    message + " (tried %o)",
                    this.candidates
                ], {
                    action: inspectAction
                });
            }
        };
        ExtractCascade.prototype.oldPlanNotFound = function() {
            var layerProse;
            layerProse = this.options.layer;
            if (layerProse === "auto") layerProse = "page, modal or popup";
            return up.fail("Could not find " + this.options.humanizedTarget + " in current " + layerProse + " (tried %o)", this.candidates);
        };
        return ExtractCascade;
    }();
}).call(module.exports);
(function() {
    var e, u, bind = function(fn, me) {
        return function() {
            return fn.apply(me, arguments);
        };
    };
    u = up.util;
    e = up.element;
    up.ExtractPlan = function() {
        function ExtractPlan(selector, options) {
            this.addHungrySteps = bind(this.addHungrySteps, this);
            this.parseSteps = bind(this.parseSteps, this);
            this.selector = bind(this.selector, this);
            this.resolveNesting = bind(this.resolveNesting, this);
            this.addSteps = bind(this.addSteps, this);
            this.matchExists = bind(this.matchExists, this);
            this.newExists = bind(this.newExists, this);
            this.oldExists = bind(this.oldExists, this);
            this.findNew = bind(this.findNew, this);
            this.findOld = bind(this.findOld, this);
            var originalSelector;
            this.reveal = options.reveal;
            this.origin = options.origin;
            this.hungry = options.hungry;
            this.transition = options.transition;
            this.response = options.response;
            this.oldLayer = options.layer;
            originalSelector = e.resolveSelector(selector, this.origin);
            this.parseSteps(originalSelector);
        }
        ExtractPlan.prototype.findOld = function() {
            return u.each(this.steps, function(_this) {
                return function(step) {
                    return step.oldElement = up.fragment.first(step.selector, {
                        layer: _this.oldLayer
                    });
                };
            }(this));
        };
        ExtractPlan.prototype.findNew = function() {
            return u.each(this.steps, function(_this) {
                return function(step) {
                    return step.newElement = _this.response.first(step.selector);
                };
            }(this));
        };
        ExtractPlan.prototype.oldExists = function() {
            this.findOld();
            return u.every(this.steps, function(step) {
                return step.oldElement;
            });
        };
        ExtractPlan.prototype.newExists = function() {
            this.findNew();
            return u.every(this.steps, function(step) {
                return step.newElement;
            });
        };
        ExtractPlan.prototype.matchExists = function() {
            return this.oldExists() && this.newExists();
        };
        ExtractPlan.prototype.addSteps = function(steps) {
            return this.steps = this.steps.concat(steps);
        };
        ExtractPlan.prototype.resolveNesting = function() {
            var compressed;
            if (this.steps.length < 2) return;
            compressed = u.copy(this.steps);
            compressed = u.uniqBy(compressed, function(step) {
                return step.oldElement;
            });
            compressed = u.filter(compressed, function(_this) {
                return function(candidateStep, candidateIndex) {
                    return u.every(compressed, function(rivalStep, rivalIndex) {
                        var candidateElement, rivalElement;
                        if (rivalIndex === candidateIndex) return true;
                        else {
                            candidateElement = candidateStep.oldElement;
                            rivalElement = rivalStep.oldElement;
                            return rivalStep.pseudoClass || !rivalElement.contains(candidateElement);
                        }
                    });
                };
            }(this));
            compressed[0].reveal = this.steps[0].reveal;
            return this.steps = compressed;
        };
        ExtractPlan.prototype.selector = function() {
            return u.map(this.steps, "expression").join(", ");
        };
        ExtractPlan.prototype.parseSteps = function(originalSelector) {
            var comma, disjunction;
            comma = /\ *,\ */;
            this.steps = [];
            disjunction = originalSelector.split(comma);
            return u.each(disjunction, function(_this) {
                return function(expression, i) {
                    var doReveal, expressionParts, pseudoClass, selector;
                    expressionParts = expression.match(/^(.+?)(?:\:(before|after))?$/);
                    expressionParts || up.fail('Could not parse selector literal "%s"', expression);
                    selector = expressionParts[1];
                    if (selector === "html") selector = "body";
                    pseudoClass = expressionParts[2];
                    doReveal = i === 0 ? _this.reveal : false;
                    return _this.steps.push({
                        expression: expression,
                        selector: selector,
                        pseudoClass: pseudoClass,
                        transition: _this.transition,
                        origin: _this.origin,
                        reveal: doReveal
                    });
                };
            }(this));
        };
        ExtractPlan.prototype.addHungrySteps = function() {
            var hungries, hungry, hungrySteps, j, len, newHungry, ref, selector, transition;
            hungrySteps = [];
            if (this.hungry) {
                hungries = e.all(up.radio.hungrySelector());
                transition = (ref = up.radio.config.hungryTransition) != null ? ref : this.transition;
                for(j = 0, len = hungries.length; j < len; j++){
                    hungry = hungries[j];
                    selector = e.toSelector(hungry);
                    if (newHungry = this.response.first(selector)) hungrySteps.push({
                        selector: selector,
                        oldElement: hungry,
                        newElement: newHungry,
                        transition: transition,
                        reveal: false,
                        origin: null
                    });
                }
            }
            return this.addSteps(hungrySteps);
        };
        return ExtractPlan;
    }();
}).call(module.exports);
(function() {
    var e, u, bind = function(fn, me) {
        return function() {
            return fn.apply(me, arguments);
        };
    };
    u = up.util;
    e = up.element;
    up.FieldObserver = function() {
        function FieldObserver(fieldOrFields, options, callback) {
            this.callback = callback;
            this.check = bind(this.check, this);
            this.readFieldValues = bind(this.readFieldValues, this);
            this.requestCallback = bind(this.requestCallback, this);
            this.isNewValues = bind(this.isNewValues, this);
            this.scheduleValues = bind(this.scheduleValues, this);
            this.scheduleTimer = bind(this.scheduleTimer, this);
            this.cancelTimer = bind(this.cancelTimer, this);
            this.stop = bind(this.stop, this);
            this.start = bind(this.start, this);
            this.fields = e.list(fieldOrFields);
            this.delay = options.delay;
            this.batch = options.batch;
        }
        FieldObserver.prototype.start = function() {
            this.scheduledValues = null;
            this.processedValues = this.readFieldValues();
            this.currentTimer = void 0;
            this.callbackRunning = false;
            return this.unbind = up.on(this.fields, "input change", this.check);
        };
        FieldObserver.prototype.stop = function() {
            this.unbind();
            return this.cancelTimer();
        };
        FieldObserver.prototype.cancelTimer = function() {
            clearTimeout(this.currentTimer);
            return this.currentTimer = void 0;
        };
        FieldObserver.prototype.scheduleTimer = function() {
            this.cancelTimer();
            return this.currentTimer = u.timer(this.delay, function(_this) {
                return function() {
                    _this.currentTimer = void 0;
                    return _this.requestCallback();
                };
            }(this));
        };
        FieldObserver.prototype.scheduleValues = function(values) {
            this.scheduledValues = values;
            return this.scheduleTimer();
        };
        FieldObserver.prototype.isNewValues = function(values) {
            return !u.isEqual(values, this.processedValues) && !u.isEqual(this.scheduledValues, values);
        };
        FieldObserver.prototype.requestCallback = function() {
            var callbackReturnValues, callbacksDone, diff, name, value;
            if (this.scheduledValues !== null && !this.currentTimer && !this.callbackRunning) {
                diff = this.changedValues(this.processedValues, this.scheduledValues);
                this.processedValues = this.scheduledValues;
                this.scheduledValues = null;
                this.callbackRunning = true;
                callbackReturnValues = [];
                if (this.batch) callbackReturnValues.push(this.callback(diff));
                else for(name in diff){
                    value = diff[name];
                    callbackReturnValues.push(this.callback(value, name));
                }
                callbacksDone = Promise.all(callbackReturnValues);
                return u.always(callbacksDone, function(_this) {
                    return function() {
                        _this.callbackRunning = false;
                        return _this.requestCallback();
                    };
                }(this));
            }
        };
        FieldObserver.prototype.changedValues = function(previous, next) {
            var changes, i, key, keys, len, nextValue, previousValue;
            changes = {};
            keys = Object.keys(previous);
            keys = keys.concat(Object.keys(next));
            keys = u.uniq(keys);
            for(i = 0, len = keys.length; i < len; i++){
                key = keys[i];
                previousValue = previous[key];
                nextValue = next[key];
                if (!u.isEqual(previousValue, nextValue)) changes[key] = nextValue;
            }
            return changes;
        };
        FieldObserver.prototype.readFieldValues = function() {
            return up.Params.fromFields(this.fields).toObject();
        };
        FieldObserver.prototype.check = function() {
            var values;
            values = this.readFieldValues();
            if (this.isNewValues(values)) return this.scheduleValues(values);
        };
        return FieldObserver;
    }();
}).call(module.exports);
(function() {}).call(module.exports);
(function() {
    var e, u, bind = function(fn, me) {
        return function() {
            return fn.apply(me, arguments);
        };
    }, slice = [].slice;
    u = up.util;
    e = up.element;
    up.FollowVariant = function() {
        function FollowVariant(selector, options) {
            this.matchesLink = bind(this.matchesLink, this);
            this.followLink = bind(this.followLink, this);
            this.fullSelector = bind(this.fullSelector, this);
            this.onMousedown = bind(this.onMousedown, this);
            this.onClick = bind(this.onClick, this);
            this.followNow = options.follow;
            this.preloadLink = options.preload;
            this.selectors = u.splitValues(selector, ",");
        }
        FollowVariant.prototype.onClick = function(event, link) {
            if (up.link.shouldProcessEvent(event, link)) {
                if (e.matches(link, "[up-instant]") && link.upInstantSupported) {
                    up.event.halt(event);
                    link.upInstantSupported = false;
                } else {
                    up.event.consumeAction(event);
                    return this.followLink(link);
                }
            } else return up.link.allowDefault(event);
        };
        FollowVariant.prototype.onMousedown = function(event, link) {
            if (up.link.shouldProcessEvent(event, link)) {
                link.upInstantSupported = true;
                up.event.consumeAction(event);
                return this.followLink(link);
            }
        };
        FollowVariant.prototype.fullSelector = function(additionalClause) {
            var parts;
            if (additionalClause == null) additionalClause = "";
            parts = [];
            this.selectors.forEach(function(variantSelector) {
                var i, len, ref, results, tagSelector;
                ref = [
                    "a",
                    "[up-href]"
                ];
                results = [];
                for(i = 0, len = ref.length; i < len; i++){
                    tagSelector = ref[i];
                    results.push(parts.push("" + tagSelector + variantSelector + additionalClause));
                }
                return results;
            });
            return parts.join(", ");
        };
        FollowVariant.prototype.registerEvents = function() {
            up.on("click", this.fullSelector(), function(_this) {
                return function() {
                    var args;
                    args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
                    return u.muteRejection(_this.onClick.apply(_this, args));
                };
            }(this));
            return up.on("mousedown", this.fullSelector("[up-instant]"), function(_this) {
                return function() {
                    var args;
                    args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
                    return u.muteRejection(_this.onMousedown.apply(_this, args));
                };
            }(this));
        };
        FollowVariant.prototype.followLink = function(link, options) {
            var promise;
            if (options == null) options = {};
            promise = up.event.whenEmitted("up:link:follow", {
                log: "Following link",
                target: link
            });
            promise = promise.then(function(_this) {
                return function() {
                    if (!options.preload) up.feedback.start(link);
                    return _this.followNow(link, options);
                };
            }(this));
            if (!options.preload) u.always(promise, function() {
                return up.feedback.stop(link);
            });
            return promise;
        };
        FollowVariant.prototype.matchesLink = function(link) {
            return e.matches(link, this.fullSelector());
        };
        return FollowVariant;
    }();
}).call(module.exports);
(function() {
    var e, u;
    u = up.util;
    e = up.element;
    up.HtmlParser = function() {
        function HtmlParser(html) {
            this.html = html;
            this.wrapNoscriptInHtml();
            this.parsedDoc = e.createDocumentFromHtml(this.html);
        }
        HtmlParser.prototype.title = function() {
            var ref;
            return (ref = this.parsedDoc.querySelector("head title")) != null ? ref.textContent : void 0;
        };
        HtmlParser.prototype.first = function(selector) {
            return e.first(this.parsedDoc, selector);
        };
        HtmlParser.prototype.prepareForInsertion = function(element) {
            return this.unwrapNoscriptInElement(element);
        };
        HtmlParser.prototype.wrapNoscriptInHtml = function() {
            var noscriptPattern;
            noscriptPattern = /<noscript[^>]*>((.|\s)*?)<\/noscript>/ig;
            return this.html = this.html.replace(noscriptPattern, function(_this) {
                return function(match, content) {
                    _this.didWrapNoscript = true;
                    return '<div class="up-noscript" data-html="' + u.escapeHtml(content) + '"></div>';
                };
            }(this));
        };
        HtmlParser.prototype.unwrapNoscriptInElement = function(element) {
            var i, len, noscript, results, wrappedContent, wrappedNoscript, wrappedNoscripts;
            if (!this.didWrapNoscript) return;
            wrappedNoscripts = element.querySelectorAll(".up-noscript");
            results = [];
            for(i = 0, len = wrappedNoscripts.length; i < len; i++){
                wrappedNoscript = wrappedNoscripts[i];
                wrappedContent = wrappedNoscript.getAttribute("data-html");
                noscript = document.createElement("noscript");
                noscript.textContent = wrappedContent;
                results.push(wrappedNoscript.parentNode.replaceChild(noscript, wrappedNoscript));
            }
            return results;
        };
        return HtmlParser;
    }();
}).call(module.exports);
(function() {
    var e, u, bind = function(fn, me) {
        return function() {
            return fn.apply(me, arguments);
        };
    };
    u = up.util;
    e = up.element;
    up.MotionController = function() {
        function MotionController(name) {
            this.reset = bind(this.reset, this);
            this.whileForwardingFinishEvent = bind(this.whileForwardingFinishEvent, this);
            this.unmarkCluster = bind(this.unmarkCluster, this);
            this.markCluster = bind(this.markCluster, this);
            this.whenElementFinished = bind(this.whenElementFinished, this);
            this.emitFinishEvent = bind(this.emitFinishEvent, this);
            this.finishOneElement = bind(this.finishOneElement, this);
            this.isActive = bind(this.isActive, this);
            this.expandFinishRequest = bind(this.expandFinishRequest, this);
            this.finish = bind(this.finish, this);
            this.startFunction = bind(this.startFunction, this);
            this.activeClass = "up-" + name;
            this.dataKey = "up-" + name + "-finished";
            this.selector = "." + this.activeClass;
            this.finishEvent = "up:" + name + ":finish";
            this.finishCount = 0;
            this.clusterCount = 0;
        }
        /***
    Finishes all animations in the given elements' ancestors and
    descendants, then calls the given function.
    
    The function is expected to return a promise that is fulfilled when
    the animation ends. The function is also expected to listen to
    `this.finishEvent` and instantly skip to the last frame
    when the event is observed.
    
    The animation is tracked so it can be
    [`finished`](/up.MotionController.finish) later.
    
    @method startFunction
    @param {Element|List<Element>} cluster
      A list of elements that will be affected by the motion.
    @param {Function(): Promise} startMotion
    @param {Object} [memory.trackMotion=true]
    @return {Promise}
      A promise that is fulfilled when the animation ends.
     */ MotionController.prototype.startFunction = function(cluster, startMotion, memory) {
            var mutedAnimator, ref;
            if (memory == null) memory = {};
            cluster = e.list(cluster);
            mutedAnimator = function() {
                return u.muteRejection(startMotion());
            };
            memory.trackMotion = (ref = memory.trackMotion) != null ? ref : up.motion.isEnabled();
            if (memory.trackMotion === false) return u.microtask(mutedAnimator);
            else {
                memory.trackMotion = false;
                return this.finish(cluster).then(function(_this) {
                    return function() {
                        var promise;
                        promise = _this.whileForwardingFinishEvent(cluster, mutedAnimator);
                        promise = promise.then(function() {
                            return _this.unmarkCluster(cluster);
                        });
                        _this.markCluster(cluster, promise);
                        return promise;
                    };
                }(this));
            }
        };
        /**
    Finishes all animations in the given elements' ancestors and
    descendants, then calls `motion.start()`.
    
    Also listens to `this.finishEvent` on the given elements.
    When this event is observed, calls `motion.finish()`.
    
    @method startMotion
    @param {Element|List<Element>} cluster
    @param {up.Motion} motion
    @param {Object} [memory.trackMotion=true]
     */ MotionController.prototype.startMotion = function(cluster, motion, memory) {
            var finish, promise, start, unbindFinish;
            if (memory == null) memory = {};
            start = function() {
                return motion.start();
            };
            finish = function() {
                return motion.finish();
            };
            unbindFinish = up.on(cluster, this.finishEvent, finish);
            promise = this.startFunction(cluster, start, memory);
            promise = promise.then(unbindFinish);
            return promise;
        };
        /***
    @method finish
    @param {List<Element>} [elements]
      If no element is given, finishes all animations in the documnet.
      If an element is given, only finishes animations in its subtree and ancestors.
    @return {Promise} A promise that is fulfilled when animations have finished.
     */ MotionController.prototype.finish = function(elements) {
            var allFinished;
            this.finishCount++;
            if (this.clusterCount === 0 || !up.motion.isEnabled()) return Promise.resolve();
            elements = this.expandFinishRequest(elements);
            allFinished = u.map(elements, this.finishOneElement);
            return Promise.all(allFinished);
        };
        MotionController.prototype.expandFinishRequest = function(elements) {
            if (elements) return u.flatMap(elements, function(_this) {
                return function(el) {
                    return e.list(e.closest(el, _this.selector), e.all(el, _this.selector));
                };
            }(this));
            else return e.all(this.selector);
        };
        MotionController.prototype.isActive = function(element) {
            return element.classList.contains(this.activeClass);
        };
        MotionController.prototype.finishOneElement = function(element) {
            this.emitFinishEvent(element);
            return this.whenElementFinished(element);
        };
        MotionController.prototype.emitFinishEvent = function(element, eventAttrs) {
            if (eventAttrs == null) eventAttrs = {};
            eventAttrs = u.merge({
                target: element,
                log: false
            }, eventAttrs);
            return up.emit(this.finishEvent, eventAttrs);
        };
        MotionController.prototype.whenElementFinished = function(element) {
            return element[this.dataKey] || Promise.resolve();
        };
        MotionController.prototype.markCluster = function(cluster, promise) {
            var element, i, len, results;
            this.clusterCount++;
            results = [];
            for(i = 0, len = cluster.length; i < len; i++){
                element = cluster[i];
                element.classList.add(this.activeClass);
                results.push(element[this.dataKey] = promise);
            }
            return results;
        };
        MotionController.prototype.unmarkCluster = function(cluster) {
            var element, i, len, results;
            this.clusterCount--;
            results = [];
            for(i = 0, len = cluster.length; i < len; i++){
                element = cluster[i];
                element.classList.remove(this.activeClass);
                results.push(delete element[this.dataKey]);
            }
            return results;
        };
        MotionController.prototype.whileForwardingFinishEvent = function(cluster, fn) {
            var doForward, unbindFinish;
            if (cluster.length < 2) return fn();
            doForward = function(_this) {
                return function(event) {
                    if (!event.forwarded) return u.each(cluster, function(element) {
                        if (element !== event.target && _this.isActive(element)) return _this.emitFinishEvent(element, {
                            forwarded: true
                        });
                    });
                };
            }(this);
            unbindFinish = up.on(cluster, this.finishEvent, doForward);
            return fn().then(unbindFinish);
        };
        MotionController.prototype.reset = function() {
            return this.finish().then(function(_this) {
                return function() {
                    _this.finishCount = 0;
                    return _this.clusterCount = 0;
                };
            }(this));
        };
        return MotionController;
    }();
}).call(module.exports);
(function() {
    var e, u, bind = function(fn, me) {
        return function() {
            return fn.apply(me, arguments);
        };
    };
    u = up.util;
    e = up.element;
    /***
  The `up.Params` class offers a consistent API to read and manipulate request parameters
  independent of their type.
  
  Request parameters are used in [form submissions](/up.Params#fromForm) and
  [URLs](/up.Params#fromURL). Methods like `up.submit()` or `up.replace()` accept
  request parameters as a `{ params }` option.
  
  \#\#\# Supported parameter types
  
  The following types of parameter representation are supported:
  
  1. An object like `{ email: 'foo@bar.com' }`
  2. A query string like `'email=foo%40bar.com'`
  3. An array of `{ name, value }` objects like `[{ name: 'email', value: 'foo@bar.com' }]`
  4. A [FormData](https://developer.mozilla.org/en-US/docs/Web/API/FormData) object.
     On IE 11 and Edge, `FormData` payloads require a [polyfill for `FormData#entries()`](https://github.com/jimmywarting/FormData).
  
  @class up.Params
   */ up.Params = function() {
        /***
    Constructs a new `up.Params` instance.
    
    @constructor up.Params
    @param {Object|Array|string|up.Params} [params]
      An existing list of params with which to initialize the new `up.Params` object.
    
      The given params value may be of any [supported type](/up.Params).
    @return {up.Params}
    @experimental
     */ function Params(raw) {
            this.arrayEntryToQuery = bind(this.arrayEntryToQuery, this);
            this.clear();
            this.addAll(raw);
        }
        /***
    Removes all params from this object.
    
    @method up.Params#clear
    @experimental
     */ Params.prototype.clear = function() {
            return this.entries = [];
        };
        Params.prototype["" + u.copy.key] = function() {
            return new up.Params(this);
        };
        /***
    Returns an object representation of this `up.Params` instance.
    
    The returned value is a simple JavaScript object with properties
    that correspond to the key/values in the given `params`.
    
    \#\#\# Example
    
        var params = new up.Params('foo=bar&baz=bam')
        var object = params.toObject()
    
        // object is now: {
        //   foo: 'bar',
        //   baz: 'bam'
        // ]
    
    @function up.Params#toObject
    @return {Object}
    @experimental
     */ Params.prototype.toObject = function() {
            var entry, i, len, name, obj, ref, value;
            obj = {};
            ref = this.entries;
            for(i = 0, len = ref.length; i < len; i++){
                entry = ref[i];
                name = entry.name, value = entry.value;
                if (!u.isBasicObjectProperty(name)) {
                    if (this.isArrayKey(name)) {
                        obj[name] || (obj[name] = []);
                        obj[name].push(value);
                    } else obj[name] = value;
                }
            }
            return obj;
        };
        /***
    Returns an array representation of this `up.Params` instance.
    
    The returned value is a JavaScript array with elements that are objects with
    `{ key }` and `{ value }` properties.
    
    \#\#\# Example
    
        var params = new up.Params('foo=bar&baz=bam')
        var array = params.toArray()
    
        // array is now: [
        //   { name: 'foo', value: 'bar' },
        //   { name: 'baz', value: 'bam' }
        // ]
    
    @function up.Params#toArray
    @return {Array}
    @experimental
     */ Params.prototype.toArray = function() {
            return this.entries;
        };
        /***
    Returns a [`FormData`](https://developer.mozilla.org/en-US/docs/Web/API/FormData) representation
    of this `up.Params` instance.
    
    \#\#\# Example
    
        var params = new up.Params('foo=bar&baz=bam')
        var formData = params.toFormData()
    
        formData.get('foo') // 'bar'
        formData.get('baz') // 'bam'
    
    @function up.Params#toFormData
    @return {FormData}
    @experimental
     */ Params.prototype.toFormData = function() {
            var entry, formData, i, len, ref;
            formData = new FormData();
            ref = this.entries;
            for(i = 0, len = ref.length; i < len; i++){
                entry = ref[i];
                formData.append(entry.name, entry.value);
            }
            return formData;
        };
        /***
    Returns an [query string](https://en.wikipedia.org/wiki/Query_string) for this `up.Params` instance.
    
    The keys and values in the returned query string will be [percent-encoded](https://developer.mozilla.org/en-US/docs/Glossary/percent-encoding).
    Non-primitive values (like [`File`](https://developer.mozilla.org/en-US/docs/Web/API/File) will be omitted from
    the retuned query string.
    
    \#\#\# Example
    
        var params = new up.Params({ foo: 'bar', baz: 'bam' })
        var query = params.toQuery()
    
        // query is now: 'foo=bar&baz=bam'
    
    @function up.Params#toQuery
    @param {Object|FormData|string|Array|undefined} params
      the params to convert
    @return {string}
      a query string built from the given params
    @experimental
     */ Params.prototype.toQuery = function() {
            var parts;
            parts = u.map(this.entries, this.arrayEntryToQuery);
            parts = u.compact(parts);
            return parts.join("&");
        };
        Params.prototype.arrayEntryToQuery = function(entry) {
            var query, value;
            value = entry.value;
            if (!this.isPrimitiveValue(value)) return void 0;
            query = encodeURIComponent(entry.name);
            if (u.isGiven(value)) {
                query += "=";
                query += encodeURIComponent(value);
            }
            return query;
        };
        /***
    Returns whether the given value can be encoded into a query string.
    
    We will have `File` values in our params when we serialize a form with a file input.
    These entries will be filtered out when converting to a query string.
    
    @function up.Params#isPrimitiveValue
    @internal
     */ Params.prototype.isPrimitiveValue = function(value) {
            return u.isMissing(value) || u.isString(value) || u.isNumber(value) || u.isBoolean(value);
        };
        /***
    Builds an URL string from the given base URL and
    this `up.Params` instance as a [query string](/up.Params.toString).
    
    The base URL may or may not already contain a query string. The
    additional query string will be joined with an `&` or `?` character accordingly.
    
    @function up.Params#toURL
    @param {string} base
      The base URL that will be prepended to this `up.Params` object as a [query string](/up.Params.toString).
    @return {string}
      The built URL.
    @experimental
     */ Params.prototype.toURL = function(base) {
            var parts, separator;
            parts = [
                base,
                this.toQuery()
            ];
            parts = u.filter(parts, u.isPresent);
            separator = u.contains(base, "?") ? "&" : "?";
            return parts.join(separator);
        };
        /***
    Adds a new entry with the given `name` and `value`.
    
    An `up.Params` instance can hold multiple entries with the same name.
    To overwrite all existing entries with the given `name`, use `up.Params#set()` instead.
    
    \#\#\# Example
    
        var params = new up.Params()
        params.add('foo', 'fooValue')
    
        var foo = params.get('foo')
        // foo is now 'fooValue'
    
    @function up.Params#add
    @param {string} name
      The name of the new entry.
    @param {any} value
      The value of the new entry.
    @experimental
     */ Params.prototype.add = function(name, value) {
            return this.entries.push({
                name: name,
                value: value
            });
        };
        /***
    Adds all entries from the given list of params.
    
    The given params value may be of any [supported type](/up.Params).
    
    @function up.Params#addAll
    @param {Object|Array|string|up.Params|undefined} params
    @experimental
     */ Params.prototype.addAll = function(raw) {
            var ref, ref1;
            if (u.isMissing(raw)) ;
            else if (raw instanceof this.constructor) (ref = this.entries).push.apply(ref, raw.entries);
            else if (u.isArray(raw)) (ref1 = this.entries).push.apply(ref1, raw);
            else if (u.isString(raw)) this.addAllFromQuery(raw);
            else if (u.isFormData(raw)) this.addAllFromFormData(raw);
            else if (u.isObject(raw)) this.addAllFromObject(raw);
            else up.fail("Unsupport params type: %o", raw);
            return this;
        };
        Params.prototype.addAllFromObject = function(object) {
            var key, results, value, valueElement, valueElements;
            results = [];
            for(key in object){
                value = object[key];
                valueElements = u.isArray(value) ? value : [
                    value
                ];
                results.push((function() {
                    var i, len, results1;
                    results1 = [];
                    for(i = 0, len = valueElements.length; i < len; i++){
                        valueElement = valueElements[i];
                        results1.push(this.add(key, valueElement));
                    }
                    return results1;
                }).call(this));
            }
            return results;
        };
        Params.prototype.addAllFromQuery = function(query) {
            var i, len, name, part, ref, ref1, results, value;
            ref = query.split("&");
            results = [];
            for(i = 0, len = ref.length; i < len; i++){
                part = ref[i];
                if (part) {
                    ref1 = part.split("="), name = ref1[0], value = ref1[1];
                    name = decodeURIComponent(name);
                    if (u.isGiven(value)) value = decodeURIComponent(value);
                    else value = null;
                    results.push(this.add(name, value));
                } else results.push(void 0);
            }
            return results;
        };
        Params.prototype.addAllFromFormData = function(formData) {
            return u.eachIterator(formData.entries(), function(_this) {
                return function(value) {
                    return _this.add.apply(_this, value);
                };
            }(this));
        };
        /***
    Sets the `value` for the entry with given `name`.
    
    An `up.Params` instance can hold multiple entries with the same name.
    All existing entries with the given `name` are [deleted](/up.Params#delete) before the
    new entry is set. To add a new entry even if the `name` is taken, use `up.Params#add()`.
    
    @function up.Params#set
    @param {string} name
      The name of the entry to set.
    @param {any} value
      The new value of the entry.
    @experimental
     */ Params.prototype.set = function(name, value) {
            this["delete"](name);
            return this.add(name, value);
        };
        /***
    Deletes all entries with the given `name`.
    
    @function up.Params#delete
    @param {string} name
    @experimental
     */ Params.prototype["delete"] = function(name) {
            return this.entries = u.reject(this.entries, this.matchEntryFn(name));
        };
        Params.prototype.matchEntryFn = function(name) {
            return function(entry) {
                return entry.name === name;
            };
        };
        /***
    Returns the first param value with the given `name` from the given `params`.
    
    Returns `undefined` if no param value with that name is set.
    
    If the `name` denotes an array field (e.g. `foo[]`), *all* param values with the given `name`
    are returned as an array. If no param value with that array name is set, an empty
    array is returned.
    
    To always return a single value use `up.Params#getFirst()` instead.
    To always return an array of values use `up.Params#getAll()` instead.
    
    \#\#\# Example
    
        var params = new up.Params({ foo: 'fooValue', bar: 'barValue' })
        var params = new up.Params([
          { name: 'foo', value: 'fooValue' }
          { name: 'bar[]', value: 'barValue1' }
          { name: 'bar[]', value: 'barValue2' })
        ]})
    
        var foo = params.get('foo')
        // foo is now 'fooValue'
    
        var bar = params.get('bar')
        // bar is now ['barValue1', 'barValue2']
    
    @function up.Params#get
    @param {string} name
    @experimental
     */ Params.prototype.get = function(name) {
            if (this.isArrayKey(name)) return this.getAll(name);
            else return this.getFirst(name);
        };
        /***
    Returns the first param value with the given `name`.
    
    Returns `undefined` if no param value with that name is set.
    
    @function up.Params#getFirst
    @param {string} name
    @return {any}
      The value of the param with the given name.
     */ Params.prototype.getFirst = function(name) {
            var entry;
            entry = u.find(this.entries, this.matchEntryFn(name));
            return entry != null ? entry.value : void 0;
        };
        /***
    Returns an array of all param values with the given `name`.
    
    Returns an empty array if no param value with that name is set.
    
    @function up.Params#getAll
    @param {string} name
    @return {Array}
      An array of all values with the given name.
     */ Params.prototype.getAll = function(name) {
            var entries;
            if (this.isArrayKey(name)) return this.getAll(name);
            else {
                entries = u.map(this.entries, this.matchEntryFn(name));
                return u.map(entries, "value");
            }
        };
        Params.prototype.isArrayKey = function(key) {
            return u.endsWith(key, "[]");
        };
        Params.prototype["" + u.isBlank.key] = function() {
            return this.entries.length === 0;
        };
        /***
    Constructs a new `up.Params` instance from the given `<form>`.
    
    The returned params may be passed as `{ params }` option to
    [`up.request()`](/up.request) or [`up.replace()`](/up.replace).
    
    The constructed `up.Params` will include exactly those form values that would be
    included in a regular form submission. In particular:
    
    - All `<input>` types are suppported
    - Field values are usually strings, but an `<input type="file">` will produce
      [`File`](https://developer.mozilla.org/en-US/docs/Web/API/File) values.
    - An `<input type="radio">` or `<input type="checkbox">` will only be added if they are `[checked]`.
    - An `<select>` will only be added if at least one value is `[checked]`.
    - If passed a `<select multiple>` or `<input type="file" multiple>`, all selected values are added.
      If passed a `<select multiple>`, all selected values are added.
    - Fields that are `[disabled]` are ignored
    - Fields without a `[name]` attribute are ignored.
    - The serialized params will include the form's submit button, if that
      button as a `name` attribute.
    
    \#\#\# Example
    
    Given this HTML form:
    
        <form>
          <input type="text" name="email" value="foo@bar.com">
          <input type="password" name="pass" value="secret">
        </form>
    
    This would serialize the form into an array representation:
    
        var params = up.Params.fromForm('input[name=email]')
        var email = params.get('email') // email is now 'foo@bar.com'
        var pass = params.get('pass') // pass is now 'secret'
    
    @function up.Params.fromForm
    @param {Element|jQuery|string} form
      A `<form>` element or a selector that matches a `<form>` element.
    @return {up.Params}
      A new `up.Params` instance with values from the given form.
    @experimental
     */ Params.fromForm = function(form) {
            var fields;
            if (form = e.get(form)) {
                fields = up.form.submissionFields(form);
                return this.fromFields(fields);
            }
        };
        /***
    Constructs a new `up.Params` instance from one or more
    [HTML form field](https://www.w3schools.com/html/html_form_elements.asp).
    
    The constructed `up.Params` will include exactly those form values that would be
    included for the given fields in a regular form submission. If a given field wouldn't
    submit a value (like an unchecked `<input type="checkbox">`, nothing will be added.
    
    See `up.Params.fromForm()` for more details and examples.
    
    @function up.Params.fromFields
    @param {Element|List<Element>|jQuery} fields
    @return {up.Params}
    @experimental
     */ Params.fromFields = function(fields) {
            var field, i, len, params, ref;
            params = new this();
            ref = u.wrapList(fields);
            for(i = 0, len = ref.length; i < len; i++){
                field = ref[i];
                params.addField(field);
            }
            return params;
        };
        /***
    Adds params from the given [HTML form field](https://www.w3schools.com/html/html_form_elements.asp).
    
    The added params will include exactly those form values that would be
    included for the given field in a regular form submission. If the given field wouldn't
      submit a value (like an unchecked `<input type="checkbox">`, nothing will be added.
    
    See `up.Params.fromForm()` for more details and examples.
    
    @function up.Params#addField
    @param {Element|jQuery} field
    @experimental
     */ Params.prototype.addField = function(field) {
            var file, i, j, len, len1, name, option, params, ref, ref1, results, results1, tagName, type;
            params = new this.constructor();
            if ((field = e.get(field)) && (name = field.name) && !field.disabled) {
                tagName = field.tagName;
                type = field.type;
                if (tagName === "SELECT") {
                    ref = field.querySelectorAll("option");
                    results = [];
                    for(i = 0, len = ref.length; i < len; i++){
                        option = ref[i];
                        if (option.selected) results.push(this.add(name, option.value));
                        else results.push(void 0);
                    }
                    return results;
                } else if (type === "checkbox" || type === "radio") {
                    if (field.checked) return this.add(name, field.value);
                } else if (type === "file") {
                    ref1 = field.files;
                    results1 = [];
                    for(j = 0, len1 = ref1.length; j < len1; j++){
                        file = ref1[j];
                        results1.push(this.add(name, file));
                    }
                    return results1;
                } else return this.add(name, field.value);
            }
        };
        Params.prototype["" + u.isEqual.key] = function(other) {
            return other && this.constructor === other.constructor && u.isEqual(this.entries, other.entries);
        };
        /***
    Constructs a new `up.Params` instance from the given URL's
    [query string](https://en.wikipedia.org/wiki/Query_string).
    
    Constructs an empty `up.Params` instance if the given URL has no query string.
    
    \#\#\# Example
    
        var params = up.Params.fromURL('http://foo.com?foo=fooValue&bar=barValue')
        var foo = params.get('foo')
        // foo is now: 'fooValue'
    
    @function up.Params.fromURL
    @param {string} url
      The URL from which to extract the query string.
    @return {string|undefined}
      The given URL's query string, or `undefined` if the URL has no query component.
    @experimental
     */ Params.fromURL = function(url) {
            var params, query, urlParts;
            params = new this();
            urlParts = u.parseUrl(url);
            if (query = urlParts.search) {
                query = query.replace(/^\?/, "");
                params.addAll(query);
            }
            return params;
        };
        /***
    Returns the given URL without its [query string](https://en.wikipedia.org/wiki/Query_string).
    
    \#\#\# Example
    
        var url = up.Params.stripURL('http://foo.com?key=value')
        // url is now: 'http://foo.com'
    
    @function up.Params.stripURL
    @param {string} url
      A URL (with or without a query string).
    @return {string}
      The given URL without its query string.
    @experimental
     */ Params.stripURL = function(url) {
            return u.normalizeUrl(url, {
                search: false
            });
        };
        /***
    If passed an `up.Params` instance, it is returned unchanged.
    Otherwise constructs an `up.Params` instance from the given value.
    
    The given params value may be of any [supported type](/up.Params)
    The return value is always an `up.Params` instance.
    
    @function up.Params.wrap
    @param {Object|Array|string|up.Params|undefined} params
    @return {up.Params}
     */ Params.wrap = function(value) {
            return u.wrapValue(value, this);
        };
        return Params;
    }();
}).call(module.exports);
(function() {
    var u = up.util;
    up.Rect = function(props) {
        u.assign(this, u.only(props, "left", "top", "width", "height"));
    };
    up.Rect.prototype = {
        get bottom () {
            return this.top + this.height;
        },
        get right () {
            return this.left + this.width;
        }
    };
    up.Rect.fromElement = function(element) {
        return new up.Rect(element.getBoundingClientRect());
    };
})();
(function() {
    var e, u, bind = function(fn, me) {
        return function() {
            return fn.apply(me, arguments);
        };
    }, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    u = up.util;
    e = up.element;
    /***
  Instances of `up.Request` normalizes properties of an [`AJAX request`](/up.request)
  such as the requested URL, form parameters and HTTP method.
  
  @class up.Request
   */ up.Request = function(superClass) {
        extend(Request, superClass);
        /***
    The HTTP method for the request.
    
    @property up.Request#method
    @param {string} method
    @stable
     */ /***
    The URL for the request.
    
    @property up.Request#url
    @param {string} url
    @stable
     */ /***
    [Parameters](/up.Params) that should be sent as the request's payload.
    
    @property up.Request#params
    @param {Object|FormData|string|Array} params
    @stable
     */ /***
    The CSS selector that will be sent as an [`X-Up-Target` header](/up.protocol#optimizing-responses).
    
    @property up.Request#target
    @param {string} target
    @stable
     */ /***
    The CSS selector that will be sent as an [`X-Up-Fail-Target` header](/up.protocol#optimizing-responses).
    
    @property up.Request#failTarget
    @param {string} failTarget
    @stable
     */ /***
    An object of additional HTTP headers.
    
    @property up.Request#headers
    @param {Object} headers
    @stable
     */ /***
    A timeout in milliseconds.
    
    If [`up.proxy.config.maxRequests`](/up.proxy.config#config.maxRequests) is set,
    the timeout will not include the time spent waiting in the queue.
    
    @property up.Request#timeout
    @param {Object|undefined} timeout
    @stable
     */ Request.prototype.fields = function() {
            return [
                "method",
                "url",
                "params",
                "target",
                "failTarget",
                "headers",
                "timeout",
                "preload",
                "cache"
            ];
        };
        /***
    Creates a new `up.Request` object.
    
    This will not actually send the request over the network. For that use `up.request()`.
    
    @constructor up.Request
    @param {string} attrs.url
    @param {string} [attrs.method='get']
    @param {up.Params|string|Object|Array} [attrs.params]
    @param {string} [attrs.target]
    @param {string} [attrs.failTarget]
    @param {Object<string, string>} [attrs.headers]
    @param {number} [attrs.timeout]
    @internal
     */ function Request(options) {
            this.cacheKey = bind(this.cacheKey, this);
            this.isCachable = bind(this.isCachable, this);
            this.buildResponse = bind(this.buildResponse, this);
            this.isCrossDomain = bind(this.isCrossDomain, this);
            this.csrfToken = bind(this.csrfToken, this);
            this.navigate = bind(this.navigate, this);
            this.send = bind(this.send, this);
            this.isSafe = bind(this.isSafe, this);
            this.transferSearchToParams = bind(this.transferSearchToParams, this);
            this.transferParamsToUrl = bind(this.transferParamsToUrl, this);
            this.extractHashFromUrl = bind(this.extractHashFromUrl, this);
            this.normalize = bind(this.normalize, this);
            up.legacy.fixKey(options, "data", "params");
            Request.__super__.constructor.call(this, options);
            this.normalize();
        }
        Request.prototype.normalize = function() {
            this.params = new up.Params(this.params);
            this.method = u.normalizeMethod(this.method);
            this.headers || (this.headers = {});
            this.extractHashFromUrl();
            if (!u.methodAllowsPayload(this.method)) return this.transferParamsToUrl();
        };
        Request.prototype.extractHashFromUrl = function() {
            var urlParts;
            urlParts = u.parseUrl(this.url);
            this.hash = u.presence(urlParts.hash);
            return this.url = u.normalizeUrl(urlParts, {
                hash: false
            });
        };
        Request.prototype.transferParamsToUrl = function() {
            if (!u.isBlank(this.params)) {
                this.url = this.params.toURL(this.url);
                return this.params.clear();
            }
        };
        Request.prototype.transferSearchToParams = function() {
            var paramsFromQuery;
            paramsFromQuery = up.Params.fromURL(this.url);
            if (!u.isBlank(paramsFromQuery)) {
                this.params.addAll(paramsFromQuery);
                return this.url = u.normalizeUrl(this.url, {
                    search: false
                });
            }
        };
        Request.prototype.isSafe = function() {
            return up.proxy.isSafeMethod(this.method);
        };
        Request.prototype.send = function() {
            return new Promise(function(_this) {
                return function(resolve, reject) {
                    var csrfToken, header, pc, resolveWithResponse, value, xhr, xhrHeaders, xhrMethod, xhrParams, xhrPayload, xhrUrl;
                    xhr = new XMLHttpRequest();
                    xhrHeaders = u.copy(_this.headers);
                    xhrUrl = _this.url;
                    xhrParams = u.copy(_this.params);
                    xhrMethod = up.proxy.wrapMethod(_this.method, xhrParams);
                    xhrPayload = null;
                    if (!u.isBlank(xhrParams)) {
                        delete xhrHeaders["Content-Type"];
                        xhrPayload = xhrParams.toFormData();
                    }
                    pc = up.protocol.config;
                    if (_this.target) xhrHeaders[pc.targetHeader] = _this.target;
                    if (_this.failTarget) xhrHeaders[pc.failTargetHeader] = _this.failTarget;
                    if (!_this.isCrossDomain()) xhrHeaders["X-Requested-With"] || (xhrHeaders["X-Requested-With"] = "XMLHttpRequest");
                    if (csrfToken = _this.csrfToken()) xhrHeaders[pc.csrfHeader] = csrfToken;
                    xhr.open(xhrMethod, xhrUrl);
                    for(header in xhrHeaders){
                        value = xhrHeaders[header];
                        xhr.setRequestHeader(header, value);
                    }
                    resolveWithResponse = function() {
                        var response;
                        response = _this.buildResponse(xhr);
                        if (response.isSuccess()) return resolve(response);
                        else return reject(response);
                    };
                    xhr.onload = resolveWithResponse;
                    xhr.onerror = resolveWithResponse;
                    xhr.ontimeout = resolveWithResponse;
                    if (_this.timeout) xhr.timeout = _this.timeout;
                    return xhr.send(xhrPayload);
                };
            }(this));
        };
        Request.prototype.navigate = function() {
            var addField, csrfParam, csrfToken, form, formMethod;
            this.transferSearchToParams();
            form = e.affix(document.body, "form.up-page-loader");
            addField = function(attrs) {
                return e.affix(form, "input[type=hidden]", attrs);
            };
            if (this.method === "GET") formMethod = "GET";
            else {
                addField({
                    name: up.protocol.config.methodParam,
                    value: this.method
                });
                formMethod = "POST";
            }
            e.setAttrs(form, {
                method: formMethod,
                action: this.url
            });
            if ((csrfParam = up.protocol.csrfParam()) && (csrfToken = this.csrfToken())) addField({
                name: csrfParam,
                value: csrfToken
            });
            u.each(this.params.toArray(), addField);
            e.hide(form);
            return up.browser.submitForm(form);
        };
        Request.prototype.csrfToken = function() {
            if (!this.isSafe() && !this.isCrossDomain()) return up.protocol.csrfToken();
        };
        Request.prototype.isCrossDomain = function() {
            return u.isCrossDomain(this.url);
        };
        Request.prototype.buildResponse = function(xhr) {
            var ref, responseAttrs, urlFromServer;
            responseAttrs = {
                method: this.method,
                url: this.url,
                text: xhr.responseText,
                status: xhr.status,
                request: this,
                xhr: xhr
            };
            if (urlFromServer = up.protocol.locationFromXhr(xhr)) {
                responseAttrs.url = urlFromServer;
                responseAttrs.method = (ref = up.protocol.methodFromXhr(xhr)) != null ? ref : "GET";
            }
            responseAttrs.title = up.protocol.titleFromXhr(xhr);
            return new up.Response(responseAttrs);
        };
        Request.prototype.isCachable = function() {
            return this.isSafe() && !u.isFormData(this.params);
        };
        Request.prototype.cacheKey = function() {
            return [
                this.url,
                this.method,
                this.params.toQuery(),
                this.target
            ].join("|");
        };
        Request.wrap = function(value) {
            return u.wrapValue(value, this);
        };
        return Request;
    }(up.Record);
}).call(module.exports);
(function() {
    var u, bind = function(fn, me) {
        return function() {
            return fn.apply(me, arguments);
        };
    }, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    u = up.util;
    /***
  Instances of `up.Response` describe the server response to an [`AJAX request`](/up.request).
  
  \#\#\# Example
  
      up.request('/foo').then(function(response) {
        console.log(response.status) // 200
        console.log(response.text)   // "<html><body>..."
      })
  
  @class up.Response
   */ up.Response = function(superClass) {
        extend(Response, superClass);
        /***
    The HTTP method used for the response.
    
    This is usually the HTTP method used by the request.
    However, after a redirect the server should signal a `GET` method using
    an [`X-Up-Method: GET` header](/up.protocol#redirect-detection).
    
    @property up.Response#method
    @param {string} method
    @stable
     */ /***
    The URL used for the response.
    
    This is usually the requested URL.
    However, after a redirect the server should signal a the new URL
    using an [`X-Up-Location: /new-url` header](/up.protocol#redirect-detection).
    
    @property up.Response#url
    @param {string} method
    @stable
     */ /***
    The response body as a `string`.
    
    @property up.Response#text
    @param {string} text
    @stable
     */ /***
    The response's
    [HTTP status code](https://en.wikipedia.org/wiki/List_of_HTTP_status_codes)
    as a `number`.
    
    A successful response will usually have a `200` or `201' status code.
    
    @property up.Response#status
    @param {number} status
    @stable
     */ /***
    The [request](/up.Request) that triggered this response.
    
    @property up.Response#request
    @param {up.Request} request
    @experimental
     */ /***
    The [`XMLHttpRequest`](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest)
    object that was used to create this response.
    
    @property up.Response#xhr
    @param {XMLHttpRequest} xhr
    @experimental
     */ /***
    A [document title pushed by the server](/up.protocol#pushing-a-document-title-to-the-client).
    
    If the server pushed no title via HTTP header, this will be `undefined`.
    
    @property up.Response#title
    @param {string} [title]
    @stable
     */ Response.prototype.fields = function() {
            return [
                "method",
                "url",
                "text",
                "status",
                "request",
                "xhr",
                "title"
            ];
        };
        /***
    @constructor up.Response
    @internal
     */ function Response(options) {
            this.getHeader = bind(this.getHeader, this);
            this.isFatalError = bind(this.isFatalError, this);
            this.isError = bind(this.isError, this);
            this.isSuccess = bind(this.isSuccess, this);
            Response.__super__.constructor.call(this, options);
        }
        /***
    Returns whether the server responded with a 2xx HTTP status.
    
    @function up.Response#isSuccess
    @return {boolean}
    @experimental
     */ Response.prototype.isSuccess = function() {
            return this.status && this.status >= 200 && this.status <= 299;
        };
        /***
    Returns whether the response was not [successful](/up.Request.prototype.isSuccess).
    
    This also returns `true` when the request encountered a [fatal error](/up.Request.prototype.isFatalError)
    like a timeout or loss of network connectivity.
    
    @function up.Response#isError
    @return {boolean}
    @experimental
     */ Response.prototype.isError = function() {
            return !this.isSuccess();
        };
        /***
    Returns whether the request encountered a [fatal error](/up.Request.prototype.isFatalError)
    like a timeout or loss of network connectivity.
    
    When the server produces an error message with an HTTP status like `500`,
    this is not considered a fatal error and `false` is returned.
    
    @function up.Response#isFatalError
    @return {boolean}
    @experimental
     */ Response.prototype.isFatalError = function() {
            return this.isError() && u.isBlank(this.text);
        };
        /***
    Returns the HTTP header value with the given name.
    
    The search for the header name is case-insensitive.
    
    Returns `undefined` if the given header name was not included in the response.
    
    @function up.Response#getHeader
    @param {string} name
    @return {string|undefined} value
    @experimental
     */ Response.prototype.getHeader = function(name) {
            return this.xhr.getResponseHeader(name);
        };
        return Response;
    }(up.Record);
}).call(module.exports);
(function() {
    var e;
    e = up.element;
    up.RevealMotion = function() {
        function RevealMotion(element, options) {
            var layoutConfig, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, snapDefault;
            this.element = element;
            if (options == null) options = {};
            layoutConfig = up.viewport.config;
            this.viewport = (ref = options.viewport) != null ? ref : up.viewport.closest(this.element);
            up.legacy.fixKey(layoutConfig, "snap", "revealSnap");
            snapDefault = layoutConfig.revealSnap;
            this.snap = (ref1 = (ref2 = options.snap) != null ? ref2 : options.revealSnap) != null ? ref1 : snapDefault;
            if (this.snap === false) this.snap = 0;
            else if (this.snap === true) this.snap = snapDefault;
            this.padding = (ref3 = (ref4 = options.padding) != null ? ref4 : options.revealPadding) != null ? ref3 : layoutConfig.revealPadding;
            this.top = options.top;
            this.fixedTop = (ref5 = options.fixedTop) != null ? ref5 : layoutConfig.fixedTop;
            this.fixedBottom = (ref6 = options.fixedBottom) != null ? ref6 : layoutConfig.fixedBottom;
            this.speed = (ref7 = (ref8 = options.speed) != null ? ref8 : options.scrollSpeed) != null ? ref7 : layoutConfig.scrollSpeed;
            this.behavior = (ref9 = options.behavior) != null ? ref9 : options.scrollBehavior;
        }
        RevealMotion.prototype.start = function() {
            var diff, elementRect, newScrollTop, originalScrollTop, viewportRect;
            elementRect = up.Rect.fromElement(this.element);
            viewportRect = this.getViewportRect(this.viewport);
            this.addPadding(elementRect);
            this.substractObstructions(viewportRect);
            if (viewportRect.height <= 0) return Promise.reject(new Error("Viewport has no visible area"));
            originalScrollTop = this.viewport.scrollTop;
            newScrollTop = originalScrollTop;
            if (this.top || elementRect.height > viewportRect.height) {
                diff = elementRect.top - viewportRect.top;
                newScrollTop += diff;
            } else if (elementRect.top < viewportRect.top) newScrollTop -= viewportRect.top - elementRect.top;
            else if (elementRect.bottom > viewportRect.bottom) newScrollTop += elementRect.bottom - viewportRect.bottom;
            if (newScrollTop < this.snap && elementRect.top < 0.5 * viewportRect.height) newScrollTop = 0;
            if (newScrollTop !== originalScrollTop) return this.scrollTo(newScrollTop);
            else return Promise.resolve();
        };
        RevealMotion.prototype.scrollTo = function(newScrollTop) {
            var scrollOptions;
            scrollOptions = {
                speed: this.speed,
                behavior: this.behavior
            };
            this.scrollMotion = new up.ScrollMotion(this.viewport, newScrollTop, scrollOptions);
            return this.scrollMotion.start();
        };
        RevealMotion.prototype.getViewportRect = function() {
            if (up.viewport.isRoot(this.viewport)) return new up.Rect({
                left: 0,
                top: 0,
                width: up.viewport.rootWidth(),
                height: up.viewport.rootHeight()
            });
            else return up.Rect.fromElement(this.viewport);
        };
        RevealMotion.prototype.addPadding = function(elementRect) {
            elementRect.top -= this.padding;
            return elementRect.height += 2 * this.padding;
        };
        RevealMotion.prototype.substractObstructions = function(viewportRect) {
            var diff, i, j, len, len1, obstruction, obstructionRect, ref, ref1, results;
            ref = e.list.apply(e, this.fixedTop);
            for(i = 0, len = ref.length; i < len; i++){
                obstruction = ref[i];
                obstructionRect = up.Rect.fromElement(obstruction);
                diff = obstructionRect.bottom - viewportRect.top;
                if (diff > 0) {
                    viewportRect.top += diff;
                    viewportRect.height -= diff;
                }
            }
            ref1 = e.list.apply(e, this.fixedBottom);
            results = [];
            for(j = 0, len1 = ref1.length; j < len1; j++){
                obstruction = ref1[j];
                obstructionRect = up.Rect.fromElement(obstruction);
                diff = viewportRect.bottom - obstructionRect.top;
                if (diff > 0) results.push(viewportRect.height -= diff);
                else results.push(void 0);
            }
            return results;
        };
        RevealMotion.prototype.finish = function() {
            var ref;
            return (ref = this.scrollMotion) != null ? ref.finish() : void 0;
        };
        return RevealMotion;
    }();
}).call(module.exports);
(function() {
    var u, bind = function(fn, me) {
        return function() {
            return fn.apply(me, arguments);
        };
    };
    u = up.util;
    up.ScrollMotion = function() {
        var SPEED_CALIBRATION;
        SPEED_CALIBRATION = 0.065;
        function ScrollMotion(scrollable, targetTop, options) {
            var ref, ref1, ref2, ref3;
            this.scrollable = scrollable;
            this.targetTop = targetTop;
            if (options == null) options = {};
            this.finish = bind(this.finish, this);
            this.cancel = bind(this.cancel, this);
            this.animationFrame = bind(this.animationFrame, this);
            this.start = bind(this.start, this);
            this.behavior = (ref = (ref1 = options.behavior) != null ? ref1 : options.scrollBehavior) != null ? ref : "auto";
            this.speed = ((ref2 = (ref3 = options.speed) != null ? ref3 : options.scrollSpeed) != null ? ref2 : up.viewport.config.scrollSpeed) * SPEED_CALIBRATION;
        }
        ScrollMotion.prototype.start = function() {
            return new Promise(function(_this) {
                return function(resolve, reject) {
                    _this.resolve = resolve;
                    _this.reject = reject;
                    if (_this.behavior === "smooth" && up.motion.isEnabled()) return _this.startAnimation();
                    else return _this.finish();
                };
            }(this));
        };
        ScrollMotion.prototype.startAnimation = function() {
            this.startTime = Date.now();
            this.startTop = this.scrollable.scrollTop;
            this.topDiff = this.targetTop - this.startTop;
            this.duration = Math.sqrt(Math.abs(this.topDiff)) / this.speed;
            return requestAnimationFrame(this.animationFrame);
        };
        ScrollMotion.prototype.animationFrame = function() {
            var currentTime, timeElapsed, timeFraction;
            if (this.settled) return;
            if (this.frameTop && Math.abs(this.frameTop - this.scrollable.scrollTop) > 1.5) this.cancel("Animation aborted due to user intervention");
            currentTime = Date.now();
            timeElapsed = currentTime - this.startTime;
            timeFraction = Math.min(timeElapsed / this.duration, 1);
            this.frameTop = this.startTop + u.simpleEase(timeFraction) * this.topDiff;
            if (Math.abs(this.targetTop - this.frameTop) < 0.3) return this.finish();
            else {
                this.scrollable.scrollTop = this.frameTop;
                return requestAnimationFrame(this.animationFrame);
            }
        };
        ScrollMotion.prototype.cancel = function(reason) {
            this.settled = true;
            return this.reject(new Error(reason));
        };
        ScrollMotion.prototype.finish = function() {
            this.settled = true;
            this.scrollable.scrollTop = this.targetTop;
            return this.resolve();
        };
        return ScrollMotion;
    }();
}).call(module.exports);
(function() {
    var u, bind = function(fn, me) {
        return function() {
            return fn.apply(me, arguments);
        };
    };
    up.store || (up.store = {});
    u = up.util;
    up.store.Memory = function() {
        function Memory() {
            this.values = bind(this.values, this);
            this.keys = bind(this.keys, this);
            this.remove = bind(this.remove, this);
            this.set = bind(this.set, this);
            this.get = bind(this.get, this);
            this.clear = bind(this.clear, this);
            this.clear();
        }
        Memory.prototype.clear = function() {
            return this.data = {};
        };
        Memory.prototype.get = function(key) {
            return this.data[key];
        };
        Memory.prototype.set = function(key, value) {
            return this.data[key] = value;
        };
        Memory.prototype.remove = function(key) {
            return delete this.data[key];
        };
        Memory.prototype.keys = function() {
            return Object.keys(this.data);
        };
        Memory.prototype.values = function() {
            return u.values(this.data);
        };
        return Memory;
    }();
}).call(module.exports);
(function() {
    var u, bind = function(fn, me) {
        return function() {
            return fn.apply(me, arguments);
        };
    }, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    u = up.util;
    up.store.Session = function(superClass) {
        extend(Session, superClass);
        function Session(rootKey) {
            this.saveToSessionStorage = bind(this.saveToSessionStorage, this);
            this.loadFromSessionStorage = bind(this.loadFromSessionStorage, this);
            this.remove = bind(this.remove, this);
            this.set = bind(this.set, this);
            this.clear = bind(this.clear, this);
            this.rootKey = rootKey;
            this.loadFromSessionStorage();
        }
        Session.prototype.clear = function() {
            Session.__super__.clear.call(this);
            return this.saveToSessionStorage();
        };
        Session.prototype.set = function(key, value) {
            Session.__super__.set.call(this, key, value);
            return this.saveToSessionStorage();
        };
        Session.prototype.remove = function(key) {
            Session.__super__.remove.call(this, key);
            return this.saveToSessionStorage();
        };
        Session.prototype.loadFromSessionStorage = function() {
            var raw;
            try {
                if (raw = typeof sessionStorage !== "undefined" && sessionStorage !== null ? sessionStorage.getItem(this.rootKey) : void 0) this.data = JSON.parse(raw);
            } catch (error) {}
            return this.data || (this.data = {});
        };
        Session.prototype.saveToSessionStorage = function() {
            var json;
            json = JSON.stringify(this.data);
            try {
                return typeof sessionStorage !== "undefined" && sessionStorage !== null ? sessionStorage.setItem(this.rootKey, json) : void 0;
            } catch (error) {}
        };
        return Session;
    }(up.store.Memory);
}).call(module.exports);
(function() {
    var e, u, bind = function(fn, me) {
        return function() {
            return fn.apply(me, arguments);
        };
    };
    u = up.util;
    e = up.element;
    up.Tether = function() {
        function Tether(options) {
            this.sync = bind(this.sync, this);
            this.scheduleSync = bind(this.scheduleSync, this);
            var ref;
            this.anchor = options.anchor;
            ref = options.position.split("-"), this.position = ref[0], this.align = ref[1];
            if (this.align) up.legacy.warn("The position value %o is deprecated. Use %o instead.", options.position, this.describeConstraints());
            else this.align = options.align;
            this.alignAxis = this.position === "top" || this.position === "bottom" ? "horizontal" : "vertical";
            this.viewport = up.viewport.closest(this.anchor);
            this.parent = this.viewport === e.root() ? document.body : this.viewport;
            this.syncOnScroll = !this.viewport.contains(this.anchor.offsetParent);
            this.root = e.affix(this.parent, ".up-bounds");
            this.setBoundsOffset(0, 0);
            this.changeEventSubscription("on");
        }
        Tether.prototype.destroy = function() {
            e.remove(this.root);
            return this.changeEventSubscription("off");
        };
        Tether.prototype.changeEventSubscription = function(fn) {
            up[fn](window, "resize", this.scheduleSync);
            if (this.syncOnScroll) return up[fn](this.viewport, "scroll", this.scheduleSync);
        };
        Tether.prototype.scheduleSync = function() {
            clearTimeout(this.syncTimer);
            return this.syncTimer = u.task(this.sync);
        };
        Tether.prototype.sync = function() {
            var anchorBox, left, rootBox, top;
            rootBox = this.root.getBoundingClientRect();
            anchorBox = this.anchor.getBoundingClientRect();
            left = void 0;
            top = void 0;
            switch(this.alignAxis){
                case "horizontal":
                    top = (function() {
                        switch(this.position){
                            case "top":
                                return anchorBox.top - rootBox.height;
                            case "bottom":
                                return anchorBox.top + anchorBox.height;
                        }
                    }).call(this);
                    left = (function() {
                        switch(this.align){
                            case "left":
                                return anchorBox.left;
                            case "center":
                                return anchorBox.left + 0.5 * (anchorBox.width - rootBox.width);
                            case "right":
                                return anchorBox.left + anchorBox.width - rootBox.width;
                        }
                    }).call(this);
                    break;
                case "vertical":
                    top = (function() {
                        switch(this.align){
                            case "top":
                                return anchorBox.top;
                            case "center":
                                return anchorBox.top + 0.5 * (anchorBox.height - rootBox.height);
                            case "bottom":
                                return anchorBox.top + anchorBox.height - rootBox.height;
                        }
                    }).call(this);
                    left = (function() {
                        switch(this.position){
                            case "left":
                                return anchorBox.left - rootBox.width;
                            case "right":
                                return anchorBox.left + anchorBox.width;
                        }
                    }).call(this);
            }
            if (u.isDefined(left) || u.isDefined(top)) return this.moveTo(left, top);
            else return up.fail("Invalid tether constraints: %o", this.describeConstraints());
        };
        Tether.prototype.describeConstraints = function() {
            return {
                position: this.position,
                align: this.align
            };
        };
        Tether.prototype.moveTo = function(targetLeft, targetTop) {
            var rootBox;
            rootBox = this.root.getBoundingClientRect();
            return this.setBoundsOffset(targetLeft - rootBox.left + this.offsetLeft, targetTop - rootBox.top + this.offsetTop);
        };
        Tether.prototype.setBoundsOffset = function(left, top) {
            this.offsetLeft = left;
            this.offsetTop = top;
            return e.setStyle(this.root, {
                left: left,
                top: top
            });
        };
        return Tether;
    }();
}).call(module.exports);
(function() {
    var u, bind = function(fn, me) {
        return function() {
            return fn.apply(me, arguments);
        };
    };
    u = up.util;
    up.UrlSet = function() {
        function UrlSet(urls, options) {
            this.urls = urls;
            if (options == null) options = {};
            this["" + u.isEqual.key] = bind(this["" + u.isEqual.key], this);
            this.matchesAny = bind(this.matchesAny, this);
            this.doesMatchPattern = bind(this.doesMatchPattern, this);
            this.doesMatchFully = bind(this.doesMatchFully, this);
            this.matches = bind(this.matches, this);
            this.normalizeUrl = options.normalizeUrl || u.normalizeUrl;
            this.urls = u.map(this.urls, this.normalizeUrl);
            this.urls = u.compact(this.urls);
        }
        UrlSet.prototype.matches = function(testUrl) {
            if (testUrl.indexOf("*") >= 0) return this.doesMatchPattern(testUrl);
            else return this.doesMatchFully(testUrl);
        };
        UrlSet.prototype.doesMatchFully = function(testUrl) {
            return u.contains(this.urls, testUrl);
        };
        UrlSet.prototype.doesMatchPattern = function(pattern) {
            var placeholder;
            placeholder = "__ASTERISK__";
            pattern = pattern.replace(/\*/g, placeholder);
            pattern = u.escapeRegexp(pattern);
            pattern = pattern.replace(new RegExp(placeholder, "g"), ".*?");
            pattern = new RegExp("^" + pattern + "$");
            return u.find(this.urls, function(url) {
                return pattern.test(url);
            });
        };
        UrlSet.prototype.matchesAny = function(testUrls) {
            return u.find(testUrls, this.matches);
        };
        UrlSet.prototype["" + u.isEqual.key] = function(otherSet) {
            return u.isEqual(this.urls, otherSet != null ? otherSet.urls : void 0);
        };
        return UrlSet;
    }();
}).call(module.exports);
/***
@module up.framework
 */ (function() {
    up.framework = function() {
        var boot, emitReset, isBooting, u;
        u = up.util;
        isBooting = true;
        /***
    Resets Unpoly to the state when it was booted.
    All custom event handlers, animations, etc. that have been registered
    will be discarded.
    
    Emits event [`up:framework:reset`](/up:framework:reset).
    
    @function up.framework.reset
    @internal
     */ emitReset = function() {
            return up.emit("up:framework:reset", {
                log: "Resetting framework"
            });
        };
        /***
    This event is [emitted](/up.emit) when Unpoly is [reset](/up.framework.reset) during unit tests.
    
    @event up:framework:reset
    @internal
     */ /***
    Boots the Unpoly framework.
    
    **This is called automatically** by including the Unpoly JavaScript files.
    
    Unpoly will not boot if the current browser is [not supported](/up.browser.isSupported).
    This leaves you with a classic server-side application on legacy browsers.
    
    @function up.boot
    @internal
     */ boot = function() {
            if (up.browser.isSupported()) {
                up.emit("up:framework:booted", {
                    log: "Framework booted"
                });
                isBooting = false;
                return up.event.onReady(function() {
                    return u.task(function() {
                        up.emit("up:app:boot", {
                            log: "Booting user application"
                        });
                        return up.emit("up:app:booted", {
                            log: "User application booted"
                        });
                    });
                });
            } else return typeof console.log === "function" ? console.log("Unpoly doesn't support this browser. Framework was not booted.") : void 0;
        };
        return {
            reset: emitReset,
            boot: boot,
            isBooting: function() {
                return isBooting;
            }
        };
    }();
}).call(module.exports);
/***
Events
======

Most Unpoly interactions emit DOM events that are prefixed with `up:`.

    document.addEventListener('up:modal:opened', (event) => {
      console.log('A new modal has just opened!')
    })

Events often have both present and past forms. For example,
`up:modal:open` is emitted before a modal starts to open.
`up:modal:opened` is emitted when the modal has finished its
opening animation.

\#\#\# Preventing events

You can prevent most present form events by calling `preventDefault()`:

    document.addEventListener('up:modal:open', (event) => {
      if (event.url == '/evil') {
        // Prevent the modal from opening
        event.preventDefault()
      }
    })


\#\#\# A better way to bind event listeners

Instead of using [`Element#addEventListener()`](https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener),
you may find it convenient to use [`up.on()`](/up.on) instead:

    up.on('click', 'button', function(event, button, data) {
      // button is the clicked element
      // data is the parsed [`up-data`](/up-data) attribute
    })

There are some advantages to using `up.on()`:

  - You may pass a selector for [event delegation](https://davidwalsh.name/event-delegate).
  - The event target is automatically passed as a second argument.
  - You may register a listener to multiple events by passing a space-separated list of event name (e.g. `"click mousedown"`).
  - You may register a listener to multiple elements in a single `up.on()` call, by passing a [list](/up.util.isList) of elements.
  - You may use an [`[up-data]`](/up-data) attribute to [attach structured data](/up.on#attaching-structured-data)
    to observed elements. If an `[up-data]` attribute is set, its value will automatically be
    parsed as JSON and passed as a third argument.
  - Event listeners on [unsupported browsers](/up.browser.isSupported) are silently discarded,
    leaving you with an application without JavaScript. This is typically preferable to
    a soup of randomly broken JavaScript in ancient browsers.

@module up.event
 */ (function() {
    var slice = [].slice;
    up.event = function() {
        var $bind, bind, bindNow, buildEvent, consumeAction, e, emit, halt, logEmission, nobodyPrevents, onEscape, onReady, reset, u, unbind, whenEmitted;
        u = up.util;
        e = up.element;
        reset = function() {
            var element, i, len, ref, results;
            ref = [
                window,
                document,
                document.documentElement,
                document.body
            ];
            results = [];
            for(i = 0, len = ref.length; i < len; i++){
                element = ref[i];
                results.push(up.EventListener.unbindNonDefault(element));
            }
            return results;
        };
        /***
    Listens to a [DOM event](https://developer.mozilla.org/en-US/docs/Web/API/Document_Object_Model/Events)
    on `document` or a given element.
    
    `up.on()` has some quality of life improvements over
    [`Element#addEventListener()`](https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener):
    
    - You may pass a selector for [event delegation](https://davidwalsh.name/event-delegate).
    - The event target is automatically passed as a second argument.
    - You may register a listener to multiple events by passing a space-separated list of event name (e.g. `"click mousedown"`)
    - You may register a listener to multiple elements in a single `up.on()` call, by passing a [list](/up.util.isList) of elements.
    - You use an [`[up-data]`](/up-data) attribute to [attach structured data](/up.on#attaching-structured-data)
      to observed elements. If an `[up-data]` attribute is set, its value will automatically be
      parsed as JSON and passed as a third argument.
    - Event listeners on [unsupported browsers](/up.browser.isSupported) are silently discarded,
      leaving you with an application without JavaScript. This is typically preferable to
      a soup of randomly broken JavaScript in ancient browsers.
    
    \#\#\# Examples
    
    The code below will call the listener when a `<a>` is clicked
    anywhere in the `document`:
    
        up.on('click', 'a', function(event, element) {
          console.log("Click on a link %o", element)
        })
    
    You may also bind the listener to a given element instead of `document`:
    
        var form = document.querySelector('form')
        up.on(form, 'click', function(event, form) {
          console.log("Click within %o", form)
        })
    
    You may also pass both an element and a selector
    for [event delegation](https://davidwalsh.name/event-delegate):
    
        var form = document.querySelector('form')
        up.on(form, 'click', 'a', function(event, link) {
          console.log("Click on a link %o within %o", link, form)
        })
    
    \#\#\# Attaching structured data
    
    In case you want to attach structured data to the event you're observing,
    you can serialize the data to JSON and put it into an `[up-data]` attribute:
    
        <span class='person' up-data='{ "age": 18, "name": "Bob" }'>Bob</span>
        <span class='person' up-data='{ "age": 22, "name": "Jim" }'>Jim</span>
    
    The JSON will be parsed and handed to your event handler as a third argument:
    
        up.on('click', '.person', function(event, element, data) {
          console.log("This is %o who is %o years old", data.name, data.age)
        })
    
    \#\#\# Unbinding an event listener
    
    `up.on()` returns a function that unbinds the event listeners when called:
    
        // Define the listener
        var listener =  function(event) { ... }
    
        // Binding the listener returns an unbind function
        var unbind = up.on('click', listener)
    
        // Unbind the listener
        unbind()
    
    There is also a function [`up.off()`](/up.off) which you can use for the same purpose:
    
        // Define the listener
        var listener =  function(event) { ... }
    
        // Bind the listener
        up.on('click', listener)
    
        // Unbind the listener
        up.off('click', listener)
    
    @function up.on
    @param {Element|jQuery} [element=document]
      The element on which to register the event listener.
    
      If no element is given, the listener is registered on the `document`.
    @param {string} events
      A space-separated list of event names to bind to.
    @param {string} [selector]
      The selector of an element on which the event must be triggered.
      Omit the selector to listen to all events with that name, regardless
      of the event target.
    @param {Function(event, [element], [data])} listener
      The listener function that should be called.
    
      The function takes the affected element as the first argument).
      If the element has an [`up-data`](/up-data) attribute, its value is parsed as JSON
      and passed as a second argument.
    @return {Function()}
      A function that unbinds the event listeners when called.
    @stable
     */ bind = function() {
            var args;
            args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
            return bindNow(args);
        };
        /***
    Listens to an event on `document` or a given element.
    The event handler is called with the event target as a
    [jQuery collection](https://learn.jquery.com/using-jquery-core/jquery-object/).
    
    If you're not using jQuery, use `up.on()` instead, which calls
    event handlers with a native element.
    
    \#\#\# Example
    
    ```
    up.$on('click', 'a', function(event, $link) {
      console.log("Click on a link with destination %s", $element.attr('href'))
    })
    ```
    
    @function up.$on
    @param {Element|jQuery} [element=document]
      The element on which to register the event listener.
    
      If no element is given, the listener is registered on the `document`.
    @param {string} events
      A space-separated list of event names to bind to.
    @param {string} [selector]
      The selector of an element on which the event must be triggered.
      Omit the selector to listen to all events with that name, regardless
      of the event target.
    @param {Function(event, [element], [data])} listener
      The listener function that should be called.
    
      The function takes the affected element as the first argument).
      If the element has an [`up-data`](/up-data) attribute, its value is parsed as JSON
      and passed as a second argument.
    @return {Function()}
      A function that unbinds the event listeners when called.
    @stable
     */ $bind = function() {
            var args;
            args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
            return bindNow(args, {
                jQuery: true
            });
        };
        bindNow = function(args, options) {
            if (!up.browser.isSupported()) return function() {};
            return up.EventListener.bind(args, options);
        };
        /***
    Unbinds an event listener previously bound with [`up.on()`](/up.on).
    
    \#\#\# Example
    
    Let's say you are listing to clicks on `.button` elements:
    
        var listener = function() { ... }
        up.on('click', '.button', listener)
    
    You can stop listening to these events like this:
    
        up.off('click', '.button', listener)
    
    Note that you need to pass `up.off()` a reference to the same listener function
    that was passed to `up.on()` earlier.
    
    @function up.off
    @stable
     */ unbind = function() {
            var args;
            args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
            return up.EventListener.unbind(args);
        };
        /***
    Emits a event with the given name and properties.
    
    The event will be triggered as an event on `document` or on the given element.
    
    Other code can subscribe to events with that name using
    [`Element#addEventListener()`](https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener)
    or [`up.on()`](/up.on).
    
    \#\#\# Example
    
        up.on('my:event', function(event) {
          console.log(event.foo)
        })
    
        up.emit('my:event', { foo: 'bar' })
        // Prints "bar" to the console
    
    @function up.emit
    @param {Element|jQuery} [target=document]
      The element on which the event is triggered.
    
      If omitted, the event will be emitted on the `document`.
    @param {string} eventName
      The name of the event.
    @param {Object} [eventProps={}]
      A list of properties to become part of the event object
      that will be passed to listeners. Note that the event object
      will by default include properties like `preventDefault()`
      or `stopPropagation()`.
    @param {string|Array} [eventProps.log=false]
      A message to print to the console when the event is emitted.
    
      Pass `true` to print a default message
    @param {Element|jQuery} [eventProps.target=document]
      The element on which the event is triggered.
    @stable
     */ emit = function() {
            var args, event, eventName, eventProps, target, targetFromProps;
            args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
            if (args[0].addEventListener) target = args.shift();
            else if (u.isJQuery(args[0])) target = e.get(args.shift());
            eventName = args[0];
            eventProps = args[1] || {};
            if (targetFromProps = u.pluckKey(eventProps, "target")) target = targetFromProps;
            if (target == null) target = document;
            logEmission(eventName, eventProps);
            event = buildEvent(eventName, eventProps);
            target.dispatchEvent(event);
            return event;
        };
        buildEvent = function(name, props) {
            var event;
            event = document.createEvent("Event");
            event.initEvent(name, true, true);
            u.assign(event, props);
            if (up.browser.isIE11()) event.preventDefault = function() {
                return Object.defineProperty(event, "defaultPrevented", {
                    get: function() {
                        return true;
                    }
                });
            };
            return event;
        };
        logEmission = function(eventName, eventProps) {
            var message, messageArgs, ref;
            if (!up.log.isEnabled()) return;
            message = u.pluckKey(eventProps, "log");
            if (u.isArray(message)) ref = message, message = ref[0], messageArgs = 2 <= ref.length ? slice.call(ref, 1) : [];
            else messageArgs = [];
            if (u.isString(message)) {
                if (u.isPresent(eventProps)) return up.puts.apply(up, [
                    message + " (%s (%o))"
                ].concat(slice.call(messageArgs), [
                    eventName
                ], [
                    eventProps
                ]));
                else return up.puts.apply(up, [
                    message + " (%s)"
                ].concat(slice.call(messageArgs), [
                    eventName
                ]));
            } else if (message === true) {
                if (u.isPresent(eventProps)) return up.puts("Event %s (%o)", eventName, eventProps);
                else return up.puts("Event %s", eventName);
            }
        };
        /***
    [Emits an event](/up.emit) and returns whether no listener
    has prevented the default action.
    
    @function up.event.nobodyPrevents
    @param {string} eventName
    @param {Object} eventProps
    @param {string|Array} [eventProps.log]
    @return {boolean}
      whether no listener has prevented the default action
    @experimental
     */ nobodyPrevents = function() {
            var args, event;
            args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
            event = emit.apply(null, args);
            return !event.defaultPrevented;
        };
        /***
    [Emits](/up.emit) the given event and returns a promise
    that will be fulfilled if no listener has prevented the default action.
    
    If any listener prevented the default listener
    the returned promise will never be resolved.
    
    @function up.event.whenEmitted
    @param {string} eventName
    @param {Object} eventProps
    @param {string|Array} [eventProps.message]
    @return {Promise}
    @internal
     */ whenEmitted = function() {
            var args;
            args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
            return new Promise(function(resolve, reject) {
                if (nobodyPrevents.apply(null, args)) return resolve();
                else return reject(new Error("Event " + args[0] + " was prevented"));
            });
        };
        /***
    Registers an event listener to be called when the user
    presses the `Escape` key.
    
    @function up.event.onEscape
    @param {Function(event)} listener
      The listener function to register.
    @return {Function()}
      A function that unbinds the event listeners when called.
    @experimental
     */ onEscape = function(listener) {
            return bind("keydown", "body", function(event) {
                if (u.escapePressed(event)) return listener(event);
            });
        };
        /***
    Prevents the event from bubbling up the DOM.
    Also prevents other event handlers bound on the same element.
    Also prevents the event's default action.
    
    \#\#\# Example
    
        up.on('click', 'link.disabled', function(event) {
          up.event.halt(event)
        })
    
    @function up.event.halt
    @param {Event} event
    @experimental
     */ halt = function(event) {
            event.stopImmediatePropagation();
            return event.preventDefault();
        };
        /***
    @function up.event.consumeAction
    @internal
     */ consumeAction = function(event) {
            halt(event);
            if (event.type !== "up:action:consumed") return emit(event.target, "up:action:consumed", {
                log: false
            });
        };
        onReady = function(callback) {
            if (document.readyState !== "loading") return callback();
            else return document.addEventListener("DOMContentLoaded", callback);
        };
        bind("up:framework:reset", reset);
        return {
            on: bind,
            $on: $bind,
            off: unbind,
            emit: emit,
            nobodyPrevents: nobodyPrevents,
            whenEmitted: whenEmitted,
            onEscape: onEscape,
            halt: halt,
            consumeAction: consumeAction,
            onReady: onReady
        };
    }();
    up.on = up.event.on;
    up.$on = up.event.$on;
    up.off = up.event.off;
    up.$off = up.event.off;
    up.emit = up.event.emit;
    up.legacy.renamedModule("bus", "event");
}).call(module.exports);
(function() {}).call(module.exports);
/***
Server protocol
===============

You rarely need to change server-side code
in order to use Unpoly. There is no need to provide a JSON API, or add
extra routes for AJAX requests. The server simply renders a series
of full HTML pages, just like it would without Unpoly.

That said, there is an **optional** protocol your server can use to
exchange additional information when Unpoly is [updating fragments](/up.link).

While the protocol can help you optimize performance and handle some
edge cases, implementing it is **entirely optional**. For instance,
`unpoly.com` itself is a static site that uses Unpoly on the frontend
and doesn't even have a server component.

## Existing implementations

You should be able to implement the protocol in a very short time.
There are existing implementations for various web frameworks:

- [Ruby on Rails](/install/rails)
- [Roda](https://github.com/adam12/roda-unpoly)
- [Rack](https://github.com/adam12/rack-unpoly) (Sinatra, Padrino, Hanami, Cuba, ...)
- [Phoenix](https://elixirforum.com/t/unpoly-a-framework-like-turbolinks/3614/15) (Elixir)


## Protocol details

\#\#\# Redirect detection for IE11

On Internet Explorer 11, Unpoly cannot detect the final URL after a redirect.
You can fix this edge case by delivering an additional HTTP header
with the *last* response in a series of redirects:

```http
X-Up-Location: /current-url
```

The **simplest implementation** is to set these headers for every request.


\#\#\# Optimizing responses

When [updating a fragment](/up.link), Unpoly will send an
additional HTTP header containing the CSS selector that is being replaced:

```http
X-Up-Target: .user-list
```

Server-side code is free to **optimize its response** by only returning HTML
that matches the selector. For example, you might prefer to not render an
expensive sidebar if the sidebar is not targeted.

Unpoly will often update a different selector in case the request fails.
This selector is also included as a HTTP header:

```
X-Up-Fail-Target: body
```


\#\#\# Pushing a document title to the client

When [updating a fragment](/up.link), Unpoly will by default
extract the `<title>` from the server response and update the document title accordingly.

The server can also force Unpoly to set a document title by passing a HTTP header:

```http
X-Up-Title: My server-pushed title
```

This is useful when you [optimize your response](#optimizing-responses) and not render
the application layout unless it is targeted. Since your optimized response
no longer includes a `<title>`, you can instead use the HTTP header to pass the document title.


\#\#\# Signaling failed form submissions

When [submitting a form via AJAX](/form-up-target)
Unpoly needs to know whether the form submission has failed (to update the form with
validation errors) or succeeded (to update the `up-target` selector).

For Unpoly to be able to detect a failed form submission, the response must be
return a non-200 HTTP status code. We recommend to use either
400 (bad request) or 422 (unprocessable entity).

To do so in [Ruby on Rails](http://rubyonrails.org/), pass a [`:status` option to `render`](http://guides.rubyonrails.org/layouts_and_rendering.html#the-status-option):

    class UsersController < ApplicationController

      def create
        user_params = params[:user].permit(:email, :password)
        @user = User.new(user_params)
        if @user.save?
          sign_in @user
        else
          render 'form', status: :bad_request
        end
      end

    end


\#\#\# Detecting live form validations

When [validating a form](/input-up-validate), Unpoly will
send an additional HTTP header containing a CSS selector for the form that is
being updated:

```http
X-Up-Validate: .user-form
```

When detecting a validation request, the server is expected to **validate (but not save)**
the form submission and render a new copy of the form with validation errors.

Below you will an example for a writing route that is aware of Unpoly's live form
validations. The code is for [Ruby on Rails](http://rubyonrails.org/),
but you can adapt it for other languages:

    class UsersController < ApplicationController

      def create
        user_params = params[:user].permit(:email, :password)
        @user = User.new(user_params)
        if request.headers['X-Up-Validate']
          @user.valid?  # run validations, but don't save to the database
          render 'form' # render form with error messages
        elsif @user.save?
          sign_in @user
        else
          render 'form', status: :bad_request
        end
      end

    end


\#\#\# Signaling the initial request method

If the initial page was loaded  with a non-`GET` HTTP method, Unpoly prefers to make a full
page load when you try to update a fragment. Once the next page was loaded with a `GET` method,
Unpoly will restore its standard behavior.

This fixes two edge cases you might or might not care about:

1. Unpoly replaces the initial page state so it can later restore it when the user
   goes back to that initial URL. However, if the initial request was a POST,
   Unpoly will wrongly assume that it can restore the state by reloading with GET.
2. Some browsers have a bug where the initial request method is used for all
   subsequently pushed states. That means if the user reloads the page on a later
   GET state, the browser will wrongly attempt a POST request.
   This issue affects Safari 9-12 (last tested in 2019-03).
   Modern Firefoxes, Chromes and IE10+ don't have this behavior.

In order to allow Unpoly to detect the HTTP method of the initial page load,
the server must set a cookie:

```http
Set-Cookie: _up_method=POST
```

When Unpoly boots, it will look for this cookie and configure its behavior accordingly.
The cookie is then deleted in order to not affect following requests.

The **simplest implementation** is to set this cookie for every request that is neither
`GET` nor contains an [`X-Up-Target` header](/#optimizing-responses). For all other requests
an existing cookie should be deleted.


@module up.protocol
 */ (function() {
    up.protocol = function() {
        var config, csrfParam, csrfToken, e, initialRequestMethod, locationFromXhr, methodFromXhr, reset, titleFromXhr, u;
        u = up.util;
        e = up.element;
        /***
    @function up.protocol.locationFromXhr
    @internal
     */ locationFromXhr = function(xhr) {
            return xhr.getResponseHeader(config.locationHeader) || xhr.responseURL;
        };
        /***
    @function up.protocol.titleFromXhr
    @internal
     */ titleFromXhr = function(xhr) {
            return xhr.getResponseHeader(config.titleHeader);
        };
        /***
    @function up.protocol.methodFromXhr
    @internal
     */ methodFromXhr = function(xhr) {
            var method;
            if (method = xhr.getResponseHeader(config.methodHeader)) return u.normalizeMethod(method);
        };
        /***
    Server-side companion libraries like unpoly-rails set this cookie so we
    have a way to detect the request method of the initial page load.
    There is no JavaScript API for this.
    
    @function up.protocol.initialRequestMethod
    @internal
     */ initialRequestMethod = u.memoize(function() {
            var methodFromServer;
            methodFromServer = up.browser.popCookie(config.methodCookie);
            return (methodFromServer || "get").toLowerCase();
        });
        up.on("up:framework:booted", initialRequestMethod);
        /***
    Configures strings used in the optional [server protocol](/up.protocol).
    
    @property up.protocol.config
    @param {String} [config.targetHeader='X-Up-Target']
    @param {String} [config.failTargetHeader='X-Up-Fail-Target']
    @param {String} [config.locationHeader='X-Up-Location']
    @param {String} [config.titleHeader='X-Up-Title']
    @param {String} [config.validateHeader='X-Up-Validate']
    @param {String} [config.methodHeader='X-Up-Method']
    @param {String} [config.methodCookie='_up_method']
      The name of the optional cookie the server can send to
      [signal the initial request method](/up.protocol#signaling-the-initial-request-method).
    @param {String} [config.methodParam='_method']
      The name of the POST parameter when [wrapping HTTP methods](/up.proxy.config#config.wrapMethods)
      in a `POST` request.
    @param {String} [config.csrfHeader='X-CSRF-Token']
      The name of the HTTP header that will include the
      [CSRF token](https://en.wikipedia.org/wiki/Cross-site_request_forgery#Synchronizer_token_pattern)
      for AJAX requests.
    @param {string|Function(): string} [config.csrfParam]
      The `name` of the hidden `<input>` used for sending a
      [CSRF token](https://en.wikipedia.org/wiki/Cross-site_request_forgery#Synchronizer_token_pattern) when
      submitting a default, non-AJAX form. For AJAX request the token is sent as an HTTP header instead.
    
      The parameter name can be configured as a string or as function that returns the parameter name.
      If no name is set, no token will be sent.
    
      Defaults to the `content` attribute of a `<meta>` tag named `csrf-param`:
    
          <meta name="csrf-param" content="authenticity_token" />
    
    @param {string|Function(): string} [config.csrfToken]
      The [CSRF token](https://en.wikipedia.org/wiki/Cross-site_request_forgery#Synchronizer_token_pattern)
      to send for unsafe requests. The token will be sent as either a HTTP header (for AJAX requests)
      or hidden form `<input>` (for default, non-AJAX form submissions).
    
      The token can either be configured as a string or as function that returns the token.
      If no token is set, no token will be sent.
    
      Defaults to the `content` attribute of a `<meta>` tag named `csrf-token`:
    
          <meta name='csrf-token' content='secret12345'>
    
    @experimental
     */ config = new up.Config({
            targetHeader: "X-Up-Target",
            failTargetHeader: "X-Up-Fail-Target",
            locationHeader: "X-Up-Location",
            validateHeader: "X-Up-Validate",
            titleHeader: "X-Up-Title",
            methodHeader: "X-Up-Method",
            methodCookie: "_up_method",
            methodParam: "_method",
            csrfParam: function() {
                return e.metaContent("csrf-param");
            },
            csrfToken: function() {
                return e.metaContent("csrf-token");
            },
            csrfHeader: "X-CSRF-Token"
        });
        csrfParam = function() {
            return u.evalOption(config.csrfParam);
        };
        csrfToken = function() {
            return u.evalOption(config.csrfToken);
        };
        reset = function() {
            return config.reset();
        };
        up.on("up:framework:reset", reset);
        return {
            config: config,
            reset: reset,
            locationFromXhr: locationFromXhr,
            titleFromXhr: titleFromXhr,
            methodFromXhr: methodFromXhr,
            csrfParam: csrfParam,
            csrfToken: csrfToken,
            initialRequestMethod: initialRequestMethod
        };
    }();
}).call(module.exports);
/***
Logging
=======

Unpoly can print debugging information to the developer console, e.g.:

- Which [events](/up.event) are called
- When we're [making requests to the network](/up.proxy)
- Which [compilers](/up.syntax) are applied to which elements

You can activate logging by calling [`up.log.enable()`](/up.log.enable).
The output can be configured using the [`up.log.config`](/up.log.config) property.

@module up.log
 */ (function() {
    var slice = [].slice;
    up.log = function() {
        var CONSOLE_PLACEHOLDERS, b, callConsole, config, debug, disable, enable, error, group, prefix, printBanner, puts, reset, sessionStore, setEnabled, sprintf, sprintfWithFormattedArgs, stringifyArg, u, warn;
        u = up.util;
        b = up.browser;
        sessionStore = new up.store.Session("up.log");
        /***
    Configures the logging output on the developer console.
    
    @property up.log.config
    @param {boolean} [options.enabled=false]
      Whether Unpoly will print debugging information to the developer console.
    
      Debugging information includes which elements are being [compiled](/up.syntax)
      and which [events](/up.event) are being emitted.
      Note that errors will always be printed, regardless of this setting.
    @param {boolean} [options.collapse=false]
      Whether debugging information is printed as a collapsed tree.
    
      Set this to `true` if you are overwhelmed by the debugging information Unpoly
      prints to the developer console.
    @param {string} [options.prefix='[UP] ']
      A string to prepend to Unpoly's logging messages so you can distinguish it from your own messages.
    @stable
     */ config = new up.Config({
            prefix: "[UP] ",
            enabled: sessionStore.get("enabled"),
            collapse: false
        });
        reset = function() {
            return config.reset();
        };
        prefix = function(message) {
            return "" + config.prefix + message;
        };
        /***
    A cross-browser way to interact with `console.log`, `console.error`, etc.
    
    This function falls back to `console.log` if the output stream is not implemented.
    It also prints substitution strings (e.g. `console.log("From %o to %o", "a", "b")`)
    as a single string if the browser console does not support substitution strings.
    
    \#\#\# Example
    
        up.browser.puts('log', 'Hi world')
        up.browser.puts('error', 'There was an error in %o', obj)
    
    @function up.browser.puts
    @internal
     */ callConsole = function() {
            var args, stream;
            stream = arguments[0], args = 2 <= arguments.length ? slice.call(arguments, 1) : [];
            return console[stream].apply(console, args);
        };
        CONSOLE_PLACEHOLDERS = /\%[odisf]/g;
        stringifyArg = function(arg) {
            var attr, closer, j, len, maxLength, ref, string, value;
            maxLength = 200;
            closer = "";
            if (u.isString(arg)) {
                string = arg.replace(/[\n\r\t ]+/g, " ");
                string = string.replace(/^[\n\r\t ]+/, "");
                string = string.replace(/[\n\r\t ]$/, "");
                string = '"' + string + '"';
                closer = '"';
            } else if (u.isUndefined(arg)) string = "undefined";
            else if (u.isNumber(arg) || u.isFunction(arg)) string = arg.toString();
            else if (u.isArray(arg)) {
                string = "[" + u.map(arg, stringifyArg).join(", ") + "]";
                closer = "]";
            } else if (u.isJQuery(arg)) {
                string = "$(" + u.map(arg, stringifyArg).join(", ") + ")";
                closer = ")";
            } else if (u.isElement(arg)) {
                string = "<" + arg.tagName.toLowerCase();
                ref = [
                    "id",
                    "name",
                    "class"
                ];
                for(j = 0, len = ref.length; j < len; j++){
                    attr = ref[j];
                    if (value = arg.getAttribute(attr)) string += " " + attr + '="' + value + '"';
                }
                string += ">";
                closer = ">";
            } else string = JSON.stringify(arg);
            if (string.length > maxLength) {
                string = string.substr(0, maxLength) + " \u2026";
                string += closer;
            }
            return string;
        };
        /***
    See https://developer.mozilla.org/en-US/docs/Web/API/Console#Using_string_substitutions
    
    @function up.browser.sprintf
    @internal
     */ sprintf = function() {
            var args, message;
            message = arguments[0], args = 2 <= arguments.length ? slice.call(arguments, 1) : [];
            return sprintfWithFormattedArgs.apply(null, [
                u.identity,
                message
            ].concat(slice.call(args)));
        };
        /***
    @function up.browser.sprintfWithFormattedArgs
    @internal
     */ sprintfWithFormattedArgs = function() {
            var args, formatter, i, message;
            formatter = arguments[0], message = arguments[1], args = 3 <= arguments.length ? slice.call(arguments, 2) : [];
            if (u.isBlank(message)) return "";
            i = 0;
            return message.replace(CONSOLE_PLACEHOLDERS, function() {
                var arg;
                arg = args[i];
                arg = formatter(stringifyArg(arg));
                i += 1;
                return arg;
            });
        };
        /***
    Prints a debugging message to the browser console.
    
    @function up.log.debug
    @param {string} message
    @param {Array} ...args
    @internal
     */ debug = function() {
            var args, message;
            message = arguments[0], args = 2 <= arguments.length ? slice.call(arguments, 1) : [];
            if (config.enabled && message) return console.debug.apply(console, [
                prefix(message)
            ].concat(slice.call(args)));
        };
        /***
    Prints a logging message to the browser console.
    
    @function up.puts
    @param {string} message
    @param {Array} ...args
    @internal
     */ puts = function() {
            var args, message;
            message = arguments[0], args = 2 <= arguments.length ? slice.call(arguments, 1) : [];
            if (config.enabled && message) return console.log.apply(console, [
                prefix(message)
            ].concat(slice.call(args)));
        };
        /***
    @function up.warn
    @internal
     */ warn = function() {
            var args, message;
            message = arguments[0], args = 2 <= arguments.length ? slice.call(arguments, 1) : [];
            if (message) return console.warn.apply(console, [
                prefix(message)
            ].concat(slice.call(args)));
        };
        /***
    - Makes sure the group always closes
    - Does not make a group if the message is nil
    
    @function up.log.group
    @internal
     */ group = function() {
            var args, block, fn, message;
            message = arguments[0], args = 2 <= arguments.length ? slice.call(arguments, 1) : [];
            block = args.pop();
            if (config.enabled && message) {
                fn = config.collapse ? "groupCollapsed" : "group";
                console[fn].apply(console, [
                    prefix(message)
                ].concat(slice.call(args)));
                try {
                    return block();
                } finally{
                    if (message) console.groupEnd();
                }
            } else return block();
        };
        /***
    @function up.log.error
    @internal
     */ error = function() {
            var args, message;
            message = arguments[0], args = 2 <= arguments.length ? slice.call(arguments, 1) : [];
            if (message) return console.error.apply(console, [
                prefix(message)
            ].concat(slice.call(args)));
        };
        printBanner = function() {
            var banner;
            banner = " __ _____  ___  ___  / /_ __\n" + ("/ // / _ \\/ _ \\/ _ \\/ / // /  " + up.version + "\n") + "\\___/_//_/ .__/\\___/_/\\_. / \n" + "        / /            / /\n" + "\n";
            if (config.enabled) banner += "Call `up.log.disable()` to disable logging for this session.";
            else banner += "Call `up.log.enable()` to enable logging for this session.";
            return console.log(banner);
        };
        up.on("up:framework:booted", printBanner);
        up.on("up:framework:reset", reset);
        setEnabled = function(value) {
            sessionStore.set("enabled", value);
            return config.enabled = value;
        };
        /***
    Makes future Unpoly events print vast amounts of debugging information to the developer console.
    
    Debugging information includes which elements are being [compiled](/up.syntax)
    and which [events](/up.event) are being emitted.
    
    @function up.log.enable
    @stable
     */ enable = function() {
            return setEnabled(true);
        };
        /***
    Prevents future Unpoly events from printing vast amounts of debugging information to the developer console.
    
    Errors will still be printed, even with logging disabled.
    
    @function up.log.disable
    @stable
     */ disable = function() {
            return setEnabled(false);
        };
        return {
            puts: puts,
            sprintf: sprintf,
            sprintfWithFormattedArgs: sprintfWithFormattedArgs,
            puts: puts,
            debug: debug,
            error: error,
            warn: warn,
            group: group,
            config: config,
            enable: enable,
            disable: disable,
            isEnabled: function() {
                return config.enabled;
            }
        };
    }();
    up.puts = up.log.puts;
    up.warn = up.log.warn;
}).call(module.exports);
/***
Toast alerts
============

@module up.toast
 */ (function() {
    var slice = [].slice;
    up.toast = function() {
        var VARIABLE_FORMATTER, addAction, close, e, isOpen, messageToHtml, open, reset, state, u;
        u = up.util;
        e = up.element;
        VARIABLE_FORMATTER = function(arg) {
            return "<span class='up-toast-variable'>" + u.escapeHtml(arg) + "</span>";
        };
        state = new up.Config({
            element: null
        });
        reset = function() {
            close();
            return state.reset();
        };
        messageToHtml = function(message) {
            var ref;
            if (u.isArray(message)) {
                message[0] = u.escapeHtml(message[0]);
                message = (ref = up.log).sprintfWithFormattedArgs.apply(ref, [
                    VARIABLE_FORMATTER
                ].concat(slice.call(message)));
            } else message = u.escapeHtml(message);
            return message;
        };
        isOpen = function() {
            return !!state.element;
        };
        addAction = function(label, callback) {
            var action, actions;
            actions = state.element.querySelector(".up-toast-actions");
            action = e.affix(actions, ".up-toast-action");
            action.innerText = label;
            return action.addEventListener("click", callback);
        };
        open = function(message, options) {
            var action;
            if (options == null) options = {};
            close();
            message = messageToHtml(message);
            state.element = e.createFromHtml('<div class="up-toast">\n  <div class="up-toast-message">' + message + '</div>\n  <div class="up-toast-actions"></div>\n</div>');
            if (action = options.action || options.inspect) addAction(action.label, action.callback);
            addAction("Close", close);
            return document.body.appendChild(state.element);
        };
        close = function() {
            if (isOpen()) {
                e.remove(state.element);
                return state.element = null;
            }
        };
        up.on("up:framework:reset", reset);
        return {
            open: open,
            close: close,
            reset: reset,
            isOpen: isOpen
        };
    }();
}).call(module.exports);
/***
Custom JavaScript
=================

Every app needs a way to pair JavaScript snippets with certain HTML elements,
in order to integrate libraries or implement custom behavior.

Unpoly lets you organize your JavaScript snippets using [compilers](/up.compiler).

For instance, to activate the [Masonry](http://masonry.desandro.com/) library for every element
with a `grid` class, use this compiler:

    up.compiler('.grid', function(element) {
      new Masonry(element, { itemSelector: '.grid--item' })
    })

The compiler function will be called on matching elements when the page loads
or when a matching fragment is [inserted via AJAX](/up.link) later.

@module up.syntax
 */ (function() {
    var slice = [].slice;
    up.syntax = function() {
        var SYSTEM_MACRO_PRIORITIES, buildCompiler, clean, compile, compilers, detectSystemMacroPriority, e, insertCompiler, macros, parseCompilerArgs, readData, registerCompiler, registerDestructor, registerJQueryCompiler, registerJQueryMacro, registerMacro, reset, u;
        u = up.util;
        e = up.element;
        SYSTEM_MACRO_PRIORITIES = {
            "[up-back]": -100,
            "[up-drawer]": -200,
            "[up-dash]": -200,
            "[up-expand]": -300,
            "[data-method]": -400,
            "[data-confirm]": -400
        };
        compilers = [];
        macros = [];
        /***
    Registers a function to be called when an element with
    the given selector is inserted into the DOM.
    
    Use compilers to activate your custom Javascript behavior on matching
    elements.
    
    You should migrate your [`DOMContentLoaded`](https://api.jquery.com/ready/)
    callbacks to compilers. This will make sure they run both at page load and
    when [a new fragment is inserted later](/a-up-target).
    It will also organize your JavaScript snippets by selector of affected elements.
    
    
    \#\#\# Example
    
    This jQuery compiler will insert the current time into a
    `<div class='current-time'></div>`:
    
        up.compiler('.current-time', function(element) {
          var now = new Date()
          element.textContent = now.toString()
        })
    
    The compiler function will be called once for each matching element when
    the page loads, or when a matching fragment is [inserted](/up.replace) later.
    
    
    \#\#\# Integrating JavaScript libraries
    
    `up.compiler()` is a great way to integrate JavaScript libraries.
    Let's say your JavaScript plugin wants you to call `lightboxify()`
    on links that should open a lightbox. You decide to
    do this for all links with an `lightbox` class:
    
        <a href="river.png" class="lightbox">River</a>
        <a href="ocean.png" class="lightbox">Ocean</a>
    
    This JavaScript will do exactly that:
    
        up.compiler('a.lightbox', function(element) {
          lightboxify(element)
        })
    
    \#\#\# Cleaning up after yourself
    
    If your compiler returns a function, Unpoly will use this as a *destructor* to
    clean up if the element leaves the DOM. Note that in Unpoly the same DOM and JavaScript environment
    will persist through many page loads, so it's important to not create
    [memory leaks](https://makandracards.com/makandra/31325-how-to-create-memory-leaks-in-jquery).
    
    You should clean up after yourself whenever your compilers have global
    side effects, like a [`setInterval`](https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/setInterval)
    or [event handlers bound to the document root](/up.on).
    
    Here is a version of `.current-time` that updates
    the time every second, and cleans up once it's done. Note how it returns
    a function that calls `clearInterval`:
    
        up.compiler('.current-time', function(element) {
    
          function update() {
            var now = new Date()
            element.textContent = now.toString()
          }
    
          setInterval(update, 1000)
    
          return function() {
            clearInterval(update)
          };
    
        })
    
    If we didn't clean up after ourselves, we would have many ticking intervals
    operating on detached DOM elements after we have created and removed a couple
    of `<clock>` elements.
    
    
    \#\#\# Attaching structured data
    
    In case you want to attach structured data to the event you're observing,
    you can serialize the data to JSON and put it into an `[up-data]` attribute.
    For instance, a container for a [Google Map](https://developers.google.com/maps/documentation/javascript/tutorial)
    might attach the location and names of its marker pins:
    
        <div class='google-map' up-data='[
          { "lat": 48.36, "lng": 10.99, "title": "Friedberg" },
          { "lat": 48.75, "lng": 11.45, "title": "Ingolstadt" }
        ]'></div>
    
    The JSON will be parsed and handed to your compiler as a second argument:
    
        up.compiler('.google-map', function(element, pins) {
          var map = new google.maps.Map(element)
    
          pins.forEach(function(pin) {
            var position = new google.maps.LatLng(pin.lat, pin.lng)
            new google.maps.Marker({
              position: position,
              map: map,
              title: pin.title
            })
          })
        })
    
    
    @function up.compiler
    @param {string} selector
      The selector to match.
    @param {number} [options.priority=0]
      The priority of this compiler.
      Compilers with a higher priority are run first.
      Two compilers with the same priority are run in the order they were registered.
    @param {boolean} [options.batch=false]
      If set to `true` and a fragment insertion contains multiple
      elements matching the selector, `compiler` is only called once
      with a jQuery collection containing all matching elements. 
    @param {boolean} [options.keep=false]
      If set to `true` compiled fragment will be [persisted](/up-keep) during
      [page updates](/a-up-target).
    
      This has the same effect as setting an `up-keep` attribute on the element.
    @param {Function(element, data)} compiler
      The function to call when a matching element is inserted.
    
      The function takes the new element as the first argument.
      If the element has an [`up-data`](/up-data) attribute, its value is parsed as JSON
      and passed as a second argument.
    
      The function may return a destructor function that cleans the compiled
      object before it is removed from the DOM. The destructor is supposed to
      [clear global state](/up.compiler#cleaning-up-after-yourself)
      such as timeouts and event handlers bound to the document.
      The destructor is *not* expected to remove the element from the DOM, which
      is already handled by [`up.destroy()`](/up.destroy).
    @stable
     */ registerCompiler = function() {
            var args, compiler;
            args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
            compiler = buildCompiler(args);
            return insertCompiler(compilers, compiler);
        };
        /***
    Registers a function to be called when an element with
    the given selector is inserted into the DOM. The function is called
    with each matching element as a
    [jQuery object](https://learn.jquery.com/using-jquery-core/jquery-object/).
    
    If you're not using jQuery, use `up.compiler()` instead, which calls
    the compiler function with a native element.
    
    \#\#\# Example
    
    This jQuery compiler will insert the current time into a
    `<div class='current-time'></div>`:
    
        up.$compiler('.current-time', function($element) {
          var now = new Date()
          $element.text(now.toString())
        })
    
    @function up.$compiler
    @param {string} selector
      The selector to match.
    @param {Object} [options]
      See [`options` argument for `up.compiler()`](/up.compiler#parameters).
    @param {Function($element, data)} compiler
      The function to call when a matching element is inserted.
    
      See [`compiler` argument for `up.compiler()`](/up.compiler#parameters).
      @stable
     */ registerJQueryCompiler = function() {
            var args, compiler;
            args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
            compiler = registerCompiler.apply(null, args);
            compiler.jQuery = true;
            return compiler;
        };
        /***
    Registers a [compiler](/up.compiler) that is run before all other compilers.
    
    Use `up.macro()` to register a compiler that sets multiple Unpoly attributes.
    
    \#\#\# Example
    
    You will sometimes find yourself setting the same combination of UJS attributes again and again:
    
        <a href="/page1" up-target=".content" up-transition="cross-fade" up-duration="300">Page 1</a>
        <a href="/page2" up-target=".content" up-transition="cross-fade" up-duration="300">Page 2</a>
        <a href="/page3" up-target=".content" up-transition="cross-fade" up-duration="300">Page 3</a>
    
    We would much rather define a new `[content-link]` attribute that let's us
    write the same links like this:
    
        <a href="/page1" content-link>Page 1</a>
        <a href="/page2" content-link>Page 2</a>
        <a href="/page3" content-link>Page 3</a>
    
    We can define the `[content-link]` attribute by registering a macro that
    sets the `[up-target]`, `[up-transition]` and `[up-duration]` attributes for us:
    
        up.macro('[content-link]', function(link) {
          link.setAttribute('up-target', '.content')
          link.setAttribute('up-transition', 'cross-fade')
          link.setAttribute('up-duration', '300')
        })
    
    Examples for built-in macros are [`a[up-dash]`](/a-up-dash) and [`[up-expand]`](/up-expand).
    
    @function up.macro
    @param {string} selector
      The selector to match.
    @param {Object} options
      See options for [`up.compiler()`](/up.compiler).
    @param {Function(element, data)} macro
      The function to call when a matching element is inserted.
    
      See [`up.compiler()`](/up.compiler#parameters) for details.
    @stable
     */ registerMacro = function() {
            var args, macro;
            args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
            macro = buildCompiler(args);
            if (up.framework.isBooting()) macro.priority = detectSystemMacroPriority(macro.selector) || up.fail("Unregistered priority for system macro %o", macro.selector);
            return insertCompiler(macros, macro);
        };
        /***
    Registers a [compiler](/up.compiler) that is run before all other compilers.
    The compiler function is called with each matching element as a
    [jQuery object](https://learn.jquery.com/using-jquery-core/jquery-object/).
    
    If you're not using jQuery, use `up.macro()` instead, which calls
    the macro function with a native element.
    
    \#\#\# Example
    
        up.$macro('[content-link]', function($link) {
          $link.attr(
            'up-target': '.content',
            'up-transition': 'cross-fade',
            'up-duration':'300'
          )
        })
    
    @function up.$macro
    @param {string} selector
      The selector to match.
    @param {Object} options
      See [`options` argument for `up.compiler()`](/up.compiler#parameters).
    @param {Function(element, data)} macro
      The function to call when a matching element is inserted.
    
      See [`compiler` argument for `up.compiler()`](/up.compiler#parameters).
    @stable
     */ registerJQueryMacro = function() {
            var args, macro;
            args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
            macro = registerMacro.apply(null, args);
            macro.jQuery = true;
            return macro;
        };
        detectSystemMacroPriority = function(macroSelector) {
            var priority, substr;
            for(substr in SYSTEM_MACRO_PRIORITIES){
                priority = SYSTEM_MACRO_PRIORITIES[substr];
                if (macroSelector.indexOf(substr) >= 0) return priority;
            }
        };
        parseCompilerArgs = function(args) {
            var callback, options, selector;
            selector = args.shift();
            callback = args.pop();
            options = u.extractOptions(args);
            return [
                selector,
                options,
                callback
            ];
        };
        buildCompiler = function(args) {
            var callback, options, ref, selector;
            ref = parseCompilerArgs(args), selector = ref[0], options = ref[1], callback = ref[2];
            options = u.options(options, {
                selector: selector,
                isDefault: up.framework.isBooting(),
                priority: 0,
                batch: false,
                keep: false,
                jQuery: false
            });
            return u.assign(callback, options);
        };
        insertCompiler = function(queue, newCompiler) {
            var existingCompiler, index;
            index = 0;
            while((existingCompiler = queue[index]) && existingCompiler.priority >= newCompiler.priority)index += 1;
            queue.splice(index, 0, newCompiler);
            return newCompiler;
        };
        /***
    Applies all compilers on the given element and its descendants.
    Unlike [`up.hello()`](/up.hello), this doesn't emit any events.
    
    @function up.syntax.compile
    @param {Array<Element>} [options.skip]
      A list of elements whose subtrees should not be compiled.
    @internal
     */ compile = function(fragment, options) {
            var compileRun, orderedCompilers;
            orderedCompilers = macros.concat(compilers);
            compileRun = new up.CompilePass(fragment, orderedCompilers, options);
            return compileRun.compile();
        };
        /***
    Registers a function to be called when the given element
    is [destroyed](/up.destroy).
    
    The preferred way to register a destructor function is to `return`
    it from a [compiler function](/up.compiler).
    
    @function up.destructor
    @param {Element} element
    @param {Function|Array<Function>} destructor
      One or more destructor functions
    @internal
     */ registerDestructor = function(element, destructor) {
            var destructors;
            if (!(destructors = element.upDestructors)) {
                destructors = [];
                element.upDestructors = destructors;
                element.classList.add("up-can-clean");
            }
            if (u.isArray(destructor)) return destructors.push.apply(destructors, destructor);
            else return destructors.push(destructor);
        };
        /***
    Runs any destructor on the given fragment and its descendants.
    Unlike [`up.destroy()`](/up.destroy), this doesn't emit any events
    and does not remove the element from the DOM.
    
    @function up.syntax.clean
    @internal
     */ clean = function(fragment) {
            var cleanables;
            cleanables = e.subtree(fragment, ".up-can-clean");
            return u.each(cleanables, function(cleanable) {
                var destructor, destructors, i, len;
                if (destructors = u.pluckKey(cleanable, "upDestructors")) for(i = 0, len = destructors.length; i < len; i++){
                    destructor = destructors[i];
                    destructor();
                }
                return cleanable.classList.remove("up-can-clean");
            });
        };
        /***
    Checks if the given element has an [`up-data`](/up-data) attribute.
    If yes, parses the attribute value as JSON and returns the parsed object.
    
    Returns `undefined` if the element has no `up-data` attribute.
    
    \#\#\# Example
    
    You have an element with JSON data serialized into an `up-data` attribute:
    
        <span class='person' up-data='{ "age": 18, "name": "Bob" }'>Bob</span>
    
    Calling `up.syntax.data()` will deserialize the JSON string into a JavaScript object:
    
        up.syntax.data('.person') // returns { age: 18, name: 'Bob' }
    
    @function up.syntax.data
    @param {string|Element|jQuery} elementOrSelector
    @return
      The JSON-decoded value of the `up-data` attribute.
    
      Returns `undefined` if the element has no (or an empty) `up-data` attribute.
    @experimental
     */ /***
    If an element with an `up-data` attribute enters the DOM,
    Unpoly will parse the JSON and pass the resulting object to any matching
    [`up.compiler()`](/up.compiler) handlers.
    
    For instance, a container for a [Google Map](https://developers.google.com/maps/documentation/javascript/tutorial)
    might attach the location and names of its marker pins:
    
        <div class='google-map' up-data='[
          { "lat": 48.36, "lng": 10.99, "title": "Friedberg" },
          { "lat": 48.75, "lng": 11.45, "title": "Ingolstadt" }
        ]'></div>
    
    The JSON will be parsed and handed to your compiler as a second argument:
    
        up.compiler('.google-map', function(element, pins) {
          var map = new google.maps.Map(element)
          pins.forEach(function(pin) {
            var position = new google.maps.LatLng(pin.lat, pin.lng)
            new google.maps.Marker({
              position: position,
              map: map,
              title: pin.title
            })
          })
        })
    
    Similarly, when an event is triggered on an element annotated with
    [`up-data`], the parsed object will be passed to any matching
    [`up.on()`](/up.on) handlers.
    
        up.on('click', '.google-map', function(event, element, pins) {
          console.log("There are %d pins on the clicked map", pins.length)
        })
    
    @selector [up-data]
    @param {JSON} up-data
      A serialized JSON string
    @stable
     */ readData = function(elementOrSelector) {
            var element;
            element = e.get(elementOrSelector);
            return e.jsonAttr(element, "up-data") || {};
        };
        /***
    Resets the list of registered compiler directives to the
    moment when the framework was booted.
    
    @internal
     */ reset = function() {
            compilers = u.filter(compilers, "isDefault");
            return macros = u.filter(macros, "isDefault");
        };
        up.on("up:framework:reset", reset);
        return {
            compiler: registerCompiler,
            macro: registerMacro,
            $compiler: registerJQueryCompiler,
            $macro: registerJQueryMacro,
            destructor: registerDestructor,
            compile: compile,
            clean: clean,
            data: readData
        };
    }();
    up.compiler = up.syntax.compiler;
    up.$compiler = up.syntax.$compiler;
    up.destructor = up.syntax.destructor;
    up.macro = up.syntax.macro;
    up.$macro = up.syntax.$macro;
}).call(module.exports);
/***
History
========

In an Unpoly app, every page has an URL.

[Fragment updates](/up.link) automatically update the URL.

@module up.history
 */ (function() {
    up.history = function() {
        var buildState, config, currentUrl, e, isCurrentUrl, manipulate, nextPreviousUrl, normalizeUrl, observeNewUrl, pop, previousUrl, push, replace, reset, restoreStateOnPop, u;
        u = up.util;
        e = up.element;
        /***
    Configures behavior when the user goes back or forward in browser history.
    
    @property up.history.config
    @param {Array} [config.popTargets=['body']]
      An array of CSS selectors to replace when the user goes
      back in history.
    @param {boolean} [config.restoreScroll=true]
      Whether to restore the known scroll positions
      when the user goes back or forward in history.
    @stable
     */ config = new up.Config({
            enabled: true,
            popTargets: [
                "body"
            ],
            restoreScroll: true
        });
        /***
    Returns the previous URL in the browser history.
    
    Note that this will only work reliably for history changes that
    were applied by [`up.history.push()`](/up.history.replace) or
    [`up.history.replace()`](/up.history.replace).
    
    @function up.history.previousUrl
    @internal
     */ previousUrl = void 0;
        nextPreviousUrl = void 0;
        reset = function() {
            config.reset();
            previousUrl = void 0;
            return nextPreviousUrl = void 0;
        };
        normalizeUrl = function(url, normalizeOptions) {
            normalizeOptions || (normalizeOptions = {});
            normalizeOptions.hash = true;
            return u.normalizeUrl(url, normalizeOptions);
        };
        /***
    Returns a normalized URL for the current history entry.
    
    @function up.history.url
    @experimental
     */ currentUrl = function(normalizeOptions) {
            return normalizeUrl(up.browser.url(), normalizeOptions);
        };
        isCurrentUrl = function(url) {
            var normalizeOptions;
            normalizeOptions = {
                stripTrailingSlash: true
            };
            return normalizeUrl(url, normalizeOptions) === currentUrl(normalizeOptions);
        };
        /***
    Remembers the given URL so we can offer `up.history.previousUrl()`.
    
    @function observeNewUrl
    @internal
     */ observeNewUrl = function(url) {
            if (nextPreviousUrl) {
                previousUrl = nextPreviousUrl;
                nextPreviousUrl = void 0;
            }
            return nextPreviousUrl = url;
        };
        /***
    Replaces the current history entry and updates the
    browser's location bar with the given URL.
    
    When the user navigates to the replaced history entry at a later time,
    Unpoly will [`replace`](/up.replace) the document body with
    the body from that URL.
    
    Note that functions like [`up.replace()`](/up.replace) or
    [`up.submit()`](/up.submit) will automatically update the
    browser's location bar for you.
    
    @function up.history.replace
    @param {string} url
    @internal
     */ replace = function(url) {
            if (manipulate("replaceState", url)) return up.emit("up:history:replaced", {
                url: url
            });
        };
        /***
    Adds a new history entry and updates the browser's
    address bar with the given URL.
    
    When the user navigates to the added  history entry at a later time,
    Unpoly will [`replace`](/up.replace) the document body with
    the body from that URL.
    
    Note that functions like [`up.replace()`](/up.replace) or
    [`up.submit()`](/up.submit) will automatically update the
    browser's location bar for you.
    
    Emits events [`up:history:push`](/up:history:push) and [`up:history:pushed`](/up:history:pushed).
    
    @function up.history.push
    @param {string} url
      The URL for the history entry to be added.
    @experimental
     */ push = function(url, options) {
            options = u.options(options, {
                force: false
            });
            url = normalizeUrl(url);
            if ((options.force || !isCurrentUrl(url)) && up.event.nobodyPrevents("up:history:push", {
                url: url,
                log: "Adding history entry for " + url
            })) {
                if (manipulate("pushState", url)) return up.emit("up:history:pushed", {
                    url: url,
                    log: "Advanced to location " + url
                });
                else return up.emit("up:history:muted", {
                    url: url,
                    log: "Did not advance to " + url + " (history is unavailable)"
                });
            }
        };
        /***
    This event is [emitted](/up.emit) before a new history entry is added.
    
    @event up:history:push
    @param {string} event.url
      The URL for the history entry that is going to be added.
    @param event.preventDefault()
      Event listeners may call this method to prevent the history entry from being added.
    @experimental
     */ /***
    This event is [emitted](/up.emit) after a new history entry has been added.
    
    @event up:history:pushed
    @param {string} event.url
      The URL for the history entry that has been added.
    @experimental
     */ manipulate = function(method, url) {
            var state;
            if (up.browser.canPushState() && config.enabled) {
                state = buildState();
                window.history[method](state, "", url);
                observeNewUrl(currentUrl());
                return true;
            } else return false;
        };
        buildState = function() {
            return {
                fromUp: true
            };
        };
        restoreStateOnPop = function(state) {
            var popSelector, replaced, url;
            if (state != null ? state.fromUp : void 0) {
                url = currentUrl();
                up.emit("up:history:restore", {
                    url: url,
                    log: "Restoring location " + url
                });
                popSelector = config.popTargets.join(", ");
                replaced = up.replace(popSelector, url, {
                    history: false,
                    title: true,
                    reveal: false,
                    saveScroll: false,
                    restoreScroll: config.restoreScroll,
                    layer: "page"
                });
                return replaced.then(function() {
                    url = currentUrl();
                    return up.emit("up:history:restored", {
                        url: url,
                        log: "Restored location " + url
                    });
                });
            } else return up.puts("Ignoring a state not pushed by Unpoly (%o)", state);
        };
        pop = function(event) {
            var state;
            observeNewUrl(currentUrl());
            up.viewport.saveScroll({
                url: previousUrl
            });
            state = event.state;
            return restoreStateOnPop(state);
        };
        /***
    This event is [emitted](/up.emit) before a history entry will be restored.
    
    History entries are restored when the user uses the *Back* or *Forward* button.
    
    @event up:history:restore
    @param {string} event.url
      The URL for the history entry that has been restored.
    @internal
     */ /***
    This event is [emitted](/up.emit) after a history entry has been restored.
    
    History entries are restored when the user uses the *Back* or *Forward* button.
    
    @event up:history:restored
    @param {string} event.url
      The URL for the history entry that has been restored.
    @experimental
     */ up.on("up:app:boot", function() {
            var register;
            if (up.browser.canPushState()) {
                register = function() {
                    if (up.browser.canControlScrollRestoration()) window.history.scrollRestoration = "manual";
                    window.addEventListener("popstate", pop);
                    return replace(currentUrl(), {
                        force: true
                    });
                };
                if (typeof jasmine !== "undefined" && jasmine !== null) return register();
                else return setTimeout(register, 100);
            }
        });
        /***
    Changes the link's destination so it points to the previous URL.
    
    Note that this will *not* call `location.back()`, but will set
    the link's `up-href` attribute to the actual, previous URL.
    
    If no previous URL is known, the link will not be changed.
    
    \#\#\# Example
    
    This link ...
    
        <a href="/default" up-back>
          Go back
        </a>
    
    ... will be transformed to:
    
        <a href="/default" up-href="/previous-page" up-restore-scroll up-follow>
          Go back
        </a>
    
    @selector a[up-back]
    @stable
     */ up.macro("a[up-back], [up-href][up-back]", function(link) {
            if (u.isPresent(previousUrl)) {
                e.setMissingAttrs(link, {
                    "up-href": previousUrl,
                    "up-restore-scroll": ""
                });
                link.removeAttribute("up-back");
                return up.link.makeFollowable(link);
            }
        });
        up.on("up:framework:reset", reset);
        return {
            config: config,
            push: push,
            replace: replace,
            url: currentUrl,
            isUrl: isCurrentUrl,
            previousUrl: function() {
                return previousUrl;
            },
            normalizeUrl: normalizeUrl
        };
    }();
}).call(module.exports);
/***
Scrolling viewports
===================

The `up.viewport` module controls the scroll position of scrollable containers ("viewports").

The default viewport for any web application is the main document. An application may
define additional viewports by giving the CSS property `{ overflow-y: scroll }` to any `<div>`.


\#\#\# Revealing new content

When following a [link to a fragment](/a-up-target) Unpoly will automatically
scroll the document's viewport to [reveal](/up.viewport) the updated content.

You should [make Unpoly aware](/up.viewport.config#config.fixedTop) of fixed elements in your
layout, such as navigation bars or headers. Unpoly will respect these sticky
elements when [revealing updated fragments](/up.reveal).

You should also [tell Unpoly](/up.viewport.config#config.viewports) when your application has more than one viewport,
so Unpoly can pick the right viewport to scroll for each fragment update.


\#\#\# Bootstrap integration

When using Bootstrap integration (`unpoly-bootstrap3.js` and `unpoly-bootstrap3.css`)
Unpoly will automatically be aware of sticky Bootstrap components such as
[fixed navbar](https://getbootstrap.com/examples/navbar-fixed-top/).

@module up.viewport
 */ (function() {
    var slice = [].slice;
    up.viewport = function() {
        var absolutize, allSelector, anchoredRight, closest, config, e, finishScrolling, firstHashTarget, fixedElements, getAll, getAround, getRoot, getSubtree, isRoot, lastScrollTops, measureObstruction, pureHash, reset, restoreScroll, reveal, revealHash, rootHasVerticalScrollbar, rootHeight, rootOverflowElement, rootSelector, rootWidth, saveScroll, scroll, scrollAfterInsertFragment, scrollTopKey, scrollTops, scrollbarWidth, scrollingController, u, wasChosenAsOverflowingElement;
        u = up.util;
        e = up.element;
        /***
    Configures the application layout.
    
    @property up.viewport.config
    @param {Array} [config.viewports]
      An array of CSS selectors that find viewports
      (containers that scroll their contents).
    @param {Array} [config.fixedTop]
      An array of CSS selectors that find elements fixed to the
      top edge of the screen (using `position: fixed`).
      See [`[up-fixed="top"]`](/up-fixed-top) for details.
    @param {Array} [config.fixedBottom]
      An array of CSS selectors that find elements fixed to the
      bottom edge of the screen (using `position: fixed`).
      See [`[up-fixed="bottom"]`](/up-fixed-bottom) for details.
    @param {Array} [config.anchoredRight]
      An array of CSS selectors that find elements anchored to the
      right edge of the screen (using `right:0` with `position: fixed` or `position: absolute`).
      See [`[up-anchored="right"]`](/up-anchored-right) for details.
    @param {number} [config.revealSnap=50]
      When [revealing](/up.reveal) elements, Unpoly will scroll an viewport
      to the top when the revealed element is closer to the top than `config.revealSnap`.
    @param {number} [config.revealPadding=0]
      The desired padding between a [revealed](/up.reveal) element and the
      closest [viewport](/up.viewport) edge (in pixels).
    @param {number} [config.scrollSpeed=1]
      The speed of the scrolling motion when [scrolling](/up.scroll) with `{ behavior: 'smooth' }`.
    
      The default value (`1`) roughly corresponds to the speed of Chrome's
      [native smooth scrolling](https://developer.mozilla.org/en-US/docs/Web/API/ScrollToOptions/behavior).
    @stable
     */ config = new up.Config({
            duration: 0,
            viewports: [
                ".up-modal-viewport",
                "[up-viewport]",
                "[up-fixed]"
            ],
            fixedTop: [
                "[up-fixed~=top]"
            ],
            fixedBottom: [
                "[up-fixed~=bottom]"
            ],
            anchoredRight: [
                "[up-anchored~=right]",
                "[up-fixed~=top]",
                "[up-fixed~=bottom]",
                "[up-fixed~=right]"
            ],
            revealSnap: 50,
            revealPadding: 0,
            scrollSpeed: 1
        });
        lastScrollTops = new up.Cache({
            size: 30,
            key: up.history.normalizeUrl
        });
        scrollingController = new up.MotionController("scrolling");
        reset = function() {
            config.reset();
            lastScrollTops.clear();
            return scrollingController.reset();
        };
        /***
    Scrolls the given viewport to the given Y-position.
    
    A "viewport" is an element that has scrollbars, e.g. `<body>` or
    a container with `overflow-x: scroll`.
    
    \#\#\# Example
    
    This will scroll a `<div class="main">...</div>` to a Y-position of 100 pixels:
    
        up.scroll('.main', 100)
    
    \#\#\# Animating the scrolling motion
    
    The scrolling can (optionally) be animated.
    
        up.scroll('.main', 100, { behavior: 'smooth' })
    
    If the given viewport is already in a scroll animation when `up.scroll()`
    is called a second time, the previous animation will instantly jump to the
    last frame before the next animation is started.
    
    @function up.scroll
    @param {string|Element|jQuery} viewport
      The container element to scroll.
    @param {number} scrollPos
      The absolute number of pixels to set the scroll position to.
    @param {string}[options.behavior='auto']
      When set to `'auto'`, this will immediately scroll to the new position.
    
      When set to `'smooth'`, this will scroll smoothly to the new position.
    @param {number}[options.speed]
      The speed of the scrolling motion when scrolling with `{ behavior: 'smooth' }`.
    
      Defaults to `up.viewport.config.scrollSpeed`.
    @return {Promise}
      A promise that will be fulfilled when the scrolling ends.
    @experimental
     */ scroll = function(viewport, scrollTop, options) {
            var motion;
            motion = new up.ScrollMotion(viewport, scrollTop, options);
            return scrollingController.startMotion(viewport, motion, options);
        };
        /***
    Finishes scrolling animations in the given element, its ancestors or its descendants.
    
    @function up.viewport.finishScrolling
    @param {string|Element|jQuery}
    @return {Promise}
    @internal
     */ finishScrolling = function(element) {
            var scrollable;
            if (!up.motion.isEnabled()) return Promise.resolve();
            scrollable = closest(element);
            return scrollingController.finish(scrollable);
        };
        /***
    @function up.viewport.anchoredRight
    @internal
     */ anchoredRight = function() {
            var selector;
            selector = config.anchoredRight.join(",");
            return e.all(selector);
        };
        /***
    @function measureObstruction
    @return {Object}
    @internal
     */ measureObstruction = function(viewportHeight) {
            var bottomObstructions, bottomObstructors, composeHeight, measureBottomObstructor, measureTopObstructor, topObstructions, topObstructors;
            composeHeight = function(obstructor, distanceFromEdgeProps) {
                var distanceFromEdge;
                distanceFromEdge = u.sum(distanceFromEdgeProps, function(prop) {
                    return e.styleNumber(obstructor, prop);
                }) || 0;
                return distanceFromEdge + obstructor.offsetHeight;
            };
            measureTopObstructor = function(obstructor) {
                return composeHeight(obstructor, [
                    "top",
                    "margin-top"
                ]);
            };
            measureBottomObstructor = function(obstructor) {
                return composeHeight(obstructor, [
                    "bottom",
                    "margin-bottom"
                ]);
            };
            topObstructors = e.all(config.fixedTop.join(", "));
            bottomObstructors = e.all(config.fixedBottom.join(", "));
            topObstructions = u.map(topObstructors, measureTopObstructor);
            bottomObstructions = u.map(bottomObstructors, measureBottomObstructor);
            return {
                top: Math.max.apply(Math, [
                    0
                ].concat(slice.call(topObstructions))),
                bottom: Math.max.apply(Math, [
                    0
                ].concat(slice.call(bottomObstructions)))
            };
        };
        /***
    Scroll's the given element's viewport so the first rows of the
    element are visible for the user.
    
    By default Unpoly will always reveal an element before
    updating it with JavaScript functions like [`up.replace()`](/up.replace)
    or UJS behavior like [`[up-target]`](/a-up-target).
    
    \#\#\# How Unpoly finds the viewport
    
    The viewport (the container that is going to be scrolled)
    is the closest parent of the element that is either:
    
    - the currently open [modal](/up.modal)
    - an element with the attribute `[up-viewport]`
    - the `<body>` element
    - an element matching the selector you have configured using `up.viewport.config.viewports.push('my-custom-selector')`
    
    \#\#\# Fixed elements obstruction the viewport
    
    Many applications have a navigation bar fixed to the top or bottom,
    obstructing the view on an element.
    
    You can make `up.reveal()` aware of these fixed elements
    so it can scroll the viewport far enough so the revealed element is fully visible.
    To make `up.reveal()` aware fixed elements you can either:
    
    - give the element an attribute [`up-fixed="top"`](/up-fixed-top) or [`up-fixed="bottom"`](up-fixed-bottom)
    - [configure default options](/up.viewport.config) for `fixedTop` or `fixedBottom`
    
    @function up.reveal
    @param {string|Element|jQuery} element
    @param {number} [options.speed]
    @param {string} [options.snap]
    @param {string|Element|jQuery} [options.viewport]
    @param {boolean} [options.top=false]
      Whether to scroll the viewport so that the first element row aligns
      with the top edge of the viewport.
    @param {string}[options.behavior='auto']
      When set to `'auto'`, this will immediately scroll to the new position.
    
      When set to `'smooth'`, this will scroll smoothly to the new position.
    @param {number}[options.speed]
      The speed of the scrolling motion when scrolling with `{ behavior: 'smooth' }`.
    
      Defaults to `up.viewport.config.scrollSpeed`.
    @param {number} [config.padding=0]
      The desired padding between the revealed element and the
      closest [viewport](/up.viewport) edge (in pixels).
    @param {number|boolean} [config.snap]
      Whether to snap to the top of the viewport if the new scroll position
      after revealing the element is close to the top edge.
    
      You may pass a maximum number of pixels under which to snap to the top.
    
      Passing `false` will disable snapping.
    
      Passing `true` will use the snap pixel value from `up.viewport.config.revealSnap`.
    @return {Promise}
      A promise that fulfills when the element is revealed.
    @stable
     */ reveal = function(elementOrSelector, options) {
            var element, motion;
            element = e.get(elementOrSelector);
            motion = new up.RevealMotion(element, options);
            return scrollingController.startMotion(element, motion, options);
        };
        /***
    @function up.viewport.scrollAfterInsertFragment
    @param {boolean|object} [options.restoreScroll]
    @param {boolean|string|jQuery|Element} [options.reveal]
    @param {boolean|string} [options.reveal]
    @return {Promise}
      A promise that is fulfilled when the scrolling has finished.
    @internal
     */ scrollAfterInsertFragment = function(element, options) {
            var givenTops, hashOpt, restoreScrollOpt, revealOpt, scrollOptions, selector;
            if (options == null) options = {};
            hashOpt = options.hash;
            revealOpt = options.reveal;
            restoreScrollOpt = options.restoreScroll;
            scrollOptions = u.only(options, "scrollBehavior", "scrollSpeed");
            if (restoreScrollOpt) {
                givenTops = u.presence(restoreScrollOpt, u.isObject);
                return restoreScroll({
                    around: element,
                    scrollTops: givenTops
                });
            } else if (hashOpt && revealOpt === true) return revealHash(hashOpt, scrollOptions);
            else if (revealOpt) {
                if (u.isElement(revealOpt) || u.isJQuery(revealOpt)) element = e.get(revealOpt);
                else if (u.isString(revealOpt)) {
                    selector = e.resolveSelector(revealOpt, options.origin);
                    element = up.fragment.first(selector);
                }
                if (element) return reveal(element, scrollOptions);
            } else return Promise.resolve();
        };
        /***
    [Reveals](/up.reveal) an element matching the given `#hash` anchor.
    
    Other than the default behavior found in browsers, `up.revealHash` works with
    [multiple viewports](/up-viewport) and honors [fixed elements](/up-fixed-top) obstructing the user's
    view of the viewport.
    
    When the page loads initially, this function is automatically called with the hash from
    the current URL.
    
    If no element matches the given `#hash` anchor, a resolved promise is returned.
    
    \#\#\# Example
    
        up.revealHash('#chapter2')
    
    @function up.viewport.revealHash
    @param {string} hash
    
    @return {Promise}
      A promise that is fulfilled when scroll position has changed to match the location hash.
    @experimental
     */ revealHash = function(hash) {
            var match;
            if (hash && (match = firstHashTarget(hash))) return reveal(match, {
                top: true
            });
            else return Promise.resolve();
        };
        allSelector = function() {
            return [
                rootSelector()
            ].concat(slice.call(config.viewports)).join(",");
        };
        /***
    Returns the scrolling container for the given element.
    
    Returns the [document's scrolling element](/up.viewport.root)
    if no closer viewport exists.
    
    @function up.viewport.closest
    @param {string|Element|jQuery} selectorOrElement
    @return {Element}
    @experimental
     */ closest = function(selectorOrElement) {
            var element;
            element = e.get(selectorOrElement);
            return e.closest(element, allSelector());
        };
        /***
    Returns a jQuery collection of all the viewports contained within the
    given selector or element.
    
    @function up.viewport.subtree
    @param {string|Element|jQuery} selectorOrElement
    @return List<Element>
    @internal
     */ getSubtree = function(selectorOrElement) {
            var element;
            element = e.get(selectorOrElement);
            return e.subtree(element, allSelector());
        };
        getAround = function(selectorOrElement) {
            var element;
            element = e.get(selectorOrElement);
            return e.list(closest(element), getSubtree(element));
        };
        /***
    Returns a list of all the viewports on the screen.
    
    @function up.viewport.all
    @internal
     */ getAll = function() {
            return e.all(allSelector());
        };
        rootSelector = function() {
            var element;
            if (element = document.scrollingElement) return element.tagName;
            else return "html";
        };
        /***
    Return the [scrolling element](https://developer.mozilla.org/en-US/docs/Web/API/document/scrollingElement)
    for the browser's main content area.
    
    @function up.viewport.root
    @return {Element}
    @experimental
     */ getRoot = function() {
            return document.querySelector(rootSelector());
        };
        rootWidth = function() {
            return e.root().clientWidth;
        };
        rootHeight = function() {
            return e.root().clientHeight;
        };
        isRoot = function(element) {
            return e.matches(element, rootSelector());
        };
        /***
    Returns whether the given element is currently showing a vertical scrollbar.
    
    @function up.viewport.rootHasVerticalScrollbar
    @internal
     */ rootHasVerticalScrollbar = function() {
            return window.innerWidth > document.documentElement.offsetWidth;
        };
        /***
    Returns the element that controls the `overflow-y` behavior for the
    [document viewport](/up.viewport.root()).
    
    @function up.viewport.rootOverflowElement
    @internal
     */ rootOverflowElement = function() {
            var body, element, html;
            body = document.body;
            html = document.documentElement;
            element = u.find([
                html,
                body
            ], wasChosenAsOverflowingElement);
            return element || getRoot();
        };
        /***
    Returns whether the given element was chosen as the overflowing
    element by the developer.
    
    We have no control whether developers set the property on <body> or
    <html>. The developer also won't know what is going to be the
    [scrolling element](/up.viewport.root()) on the user's brower.
    
    @function wasChosenAsOverflowingElement
    @internal
     */ wasChosenAsOverflowingElement = function(element) {
            var overflowY;
            overflowY = e.style(element, "overflow-y");
            return overflowY === "auto" || overflowY === "scroll";
        };
        /***
    Returns the width of a scrollbar.
    
    This only runs once per page load.
    
    @function up.viewport.scrollbarWidth
    @internal
     */ scrollbarWidth = u.memoize(function() {
            var outer, outerStyle, width;
            outerStyle = {
                position: "absolute",
                top: "0",
                left: "0",
                width: "100px",
                height: "100px",
                overflowY: "scroll"
            };
            outer = up.element.affix(document.body, "[up-viewport]", {
                style: outerStyle
            });
            width = outer.offsetWidth - outer.clientWidth;
            up.element.remove(outer);
            return width;
        });
        scrollTopKey = function(viewport) {
            return e.toSelector(viewport);
        };
        /***
    Returns a hash with scroll positions.
    
    Each key in the hash is a viewport selector. The corresponding
    value is the viewport's top scroll position:
    
        up.viewport.scrollTops()
        => { '.main': 0, '.sidebar': 73 }
    
    @function up.viewport.scrollTops
    @return Object<string, number>
    @internal
     */ scrollTops = function() {
            return u.mapObject(getAll(), function(viewport) {
                return [
                    scrollTopKey(viewport),
                    viewport.scrollTop
                ];
            });
        };
        /***
    @function up.viewport.fixedElements
    @internal
     */ fixedElements = function(root) {
            var queryParts;
            if (root == null) root = document;
            queryParts = [
                "[up-fixed]"
            ].concat(config.fixedTop).concat(config.fixedBottom);
            return root.querySelectorAll(queryParts.join(","));
        };
        /***
    Saves the top scroll positions of all the
    viewports configured in [`up.viewport.config.viewports`](/up.viewport.config).
    
    The scroll positions will be associated with the current URL.
    They can later be restored by calling [`up.viewport.restoreScroll()`](/up.viewport.restoreScroll)
    at the same URL, or by following a link with an [`[up-restore-scroll]`](/a-up-follow#up-restore-scroll)
    attribute.
    
    Unpoly automatically saves scroll positions before a [fragment update](/up.replace)
    you will rarely need to call this function yourself.
    
    \#\#\# Examples
    
    Should you need to save the current scroll positions outside of a [fragment update](/up.replace),
    you may call:
    
        up.viewport.saveScroll()
    
    Instead of saving the current scroll positions for the current URL, you may also pass another
    url or vertical scroll positionsfor each viewport:
    
        up.viewport.saveScroll({
          url: '/inbox',
          tops: {
            'body': 0,
            '.sidebar', 100,
            '.main', 320
          }
        })
    
    @function up.viewport.saveScroll
    @param {string} [options.url]
      The URL for which to save scroll positions.
      If omitted, the current browser location is used.
    @param {Object<string, number>} [options.tops]
      An object mapping viewport selectors to vertical scroll positions in pixels.
    @experimental
     */ saveScroll = function(options) {
            var ref, ref1, tops, url;
            if (options == null) options = {};
            url = (ref = options.url) != null ? ref : up.history.url();
            tops = (ref1 = options.tops) != null ? ref1 : scrollTops();
            return lastScrollTops.set(url, tops);
        };
        /***
    Restores [previously saved](/up.viewport.saveScroll) scroll positions of viewports
    viewports configured in [`up.viewport.config.viewports`](/up.viewport.config).
    
    Unpoly automatically restores scroll positions when the user presses the back button.
    You can disable this behavior by setting [`up.history.config.restoreScroll = false`](/up.history.config).
    
    @function up.viewport.restoreScroll
    @param {Element} [options.around]
      If set, only restores viewports that are either an ancestor
      or descendant of the given element.
    @return {Promise}
      A promise that will be fulfilled once scroll positions have been restored.
    @experimental
     */ restoreScroll = function(options) {
            var scrollTopsForUrl, url, viewports;
            if (options == null) options = {};
            url = up.history.url();
            viewports = options.around ? getAround(options.around) : getAll();
            scrollTopsForUrl = options.scrollTops || lastScrollTops.get(url) || {};
            return up.log.group("Restoring scroll positions for URL %s to %o", url, scrollTopsForUrl, function() {
                var allScrollPromises;
                allScrollPromises = u.map(viewports, function(viewport) {
                    var key, scrollTop;
                    key = scrollTopKey(viewport);
                    scrollTop = scrollTopsForUrl[key] || 0;
                    return scroll(viewport, scrollTop, {
                        duration: 0
                    });
                });
                return Promise.all(allScrollPromises);
            });
        };
        /***
    @internal
     */ absolutize = function(elementOrSelector, options) {
            var bounds, boundsRect, element, moveBounds, newElementRect, originalRect, viewport, viewportRect;
            if (options == null) options = {};
            element = e.get(elementOrSelector);
            viewport = up.viewport.closest(element);
            viewportRect = viewport.getBoundingClientRect();
            originalRect = element.getBoundingClientRect();
            boundsRect = new up.Rect({
                left: originalRect.left - viewportRect.left,
                top: originalRect.top - viewportRect.top,
                width: originalRect.width,
                height: originalRect.height
            });
            if (typeof options.afterMeasure === "function") options.afterMeasure();
            e.setStyle(element, {
                position: element.style.position === "static" ? "static" : "relative",
                top: "auto",
                right: "auto",
                bottom: "auto",
                left: "auto",
                width: "100%",
                height: "100%"
            });
            bounds = e.createFromSelector(".up-bounds");
            e.insertBefore(element, bounds);
            bounds.appendChild(element);
            moveBounds = function(diffX, diffY) {
                boundsRect.left += diffX;
                boundsRect.top += diffY;
                return e.setStyle(bounds, boundsRect);
            };
            moveBounds(0, 0);
            newElementRect = element.getBoundingClientRect();
            moveBounds(originalRect.left - newElementRect.left, originalRect.top - newElementRect.top);
            u.each(fixedElements(element), e.fixedToAbsolute);
            return {
                bounds: bounds,
                moveBounds: moveBounds
            };
        };
        /***
    Marks this element as a scrolling container ("viewport").
    
    Apply this attribute if your app uses a custom panel layout with fixed positioning
    instead of scrolling `<body>`. As an alternative you can also push a selector
    matching your custom viewport to the [`up.viewport.config.viewports`](/up.viewport.config) array.
    
    [`up.reveal()`](/up.reveal) will always try to scroll the viewport closest
    to the element that is being revealed. By default this is the `<body>` element.
    
    \#\#\# Example
    
    Here is an example for a layout for an e-mail client, showing a list of e-mails
    on the left side and the e-mail text on the right side:
    
        .side {
          position: fixed;
          top: 0;
          bottom: 0;
          left: 0;
          width: 100px;
          overflow-y: scroll;
        }
    
        .main {
          position: fixed;
          top: 0;
          bottom: 0;
          left: 100px;
          right: 0;
          overflow-y: scroll;
        }
    
    This would be the HTML (notice the `up-viewport` attribute):
    
        <div class=".side" up-viewport>
          <a href="/emails/5001" up-target=".main">Re: Your invoice</a>
          <a href="/emails/2023" up-target=".main">Quote for services</a>
          <a href="/emails/9002" up-target=".main">Fwd: Room reservation</a>
        </div>
    
        <div class="main" up-viewport>
          <h1>Re: Your Invoice</h1>
          <p>
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr.
            Stet clita kasd gubergren, no sea takimata sanctus est.
          </p>
        </div>
    
    @selector [up-viewport]
    @stable
     */ /***
    Marks this element as being fixed to the top edge of the screen
    using `position: fixed`.
    
    When [following a fragment link](/a-up-target), the viewport is scrolled
    so the targeted element becomes visible. By using this attribute you can make
    Unpoly aware of fixed elements that are obstructing the viewport contents.
    Unpoly will then scroll the viewport far enough that the revealed element is fully visible.
    
    Instead of using this attribute,
    you can also configure a selector in [`up.viewport.config.fixedTop`](/up.viewport.config#config.fixedTop).
    
    \#\#\# Example
    
        <div class="top-nav" up-fixed="top">...</div>
    
    @selector [up-fixed=top]
    @stable
     */ /***
    Marks this element as being fixed to the bottom edge of the screen
    using `position: fixed`.
    
    When [following a fragment link](/a-up-target), the viewport is scrolled
    so the targeted element becomes visible. By using this attribute you can make
    Unpoly aware of fixed elements that are obstructing the viewport contents.
    Unpoly will then scroll the viewport far enough that the revealed element is fully visible.
    
    Instead of using this attribute,
    you can also configure a selector in [`up.viewport.config.fixedBottom`](/up.viewport.config#config.fixedBottom).
    
    \#\#\# Example
    
        <div class="bottom-nav" up-fixed="bottom">...</div>
    
    @selector [up-fixed=bottom]
    @stable
     */ /***
    Marks this element as being anchored to the right edge of the screen,
    typically fixed navigation bars.
    
    Since [modal dialogs](/up.modal) hide the document scroll bar,
    elements anchored to the right appear to jump when the dialog opens or
    closes. Applying this attribute to anchored elements will make Unpoly
    aware of the issue and adjust the `right` property accordingly.
    
    You should give this attribute to layout elements
    with a CSS of `right: 0` with `position: fixed` or `position:absolute`.
    
    Instead of giving this attribute to any affected element,
    you can also configure a selector in [`up.viewport.config.anchoredRight`](/up.viewport.config#config.anchoredRight).
    
    \#\#\# Example
    
    Here is the CSS for a navigation bar that is anchored to the top edge of the screen:
    
        .top-nav {
           position: fixed;
           top: 0;
           left: 0;
           right: 0;
         }
    
    By adding an `up-anchored="right"` attribute to the element, we can prevent the
    `right` edge from jumping when a [modal dialog](/up.modal) opens or closes:
    
        <div class="top-nav" up-anchored="right">...</div>
    
    @selector [up-anchored=right]
    @stable
     */ /***
    @function up.viewport.firstHashTarget
    @internal
     */ firstHashTarget = function(hash) {
            var selector;
            if (hash = pureHash(hash)) {
                selector = [
                    e.attributeSelector("up-id", hash),
                    e.attributeSelector("id", hash),
                    "a" + e.attributeSelector("name", hash)
                ].join(",");
                return up.fragment.first(selector);
            }
        };
        /***
    Returns `'foo'` if the hash is `'#foo'`.
    
    Returns undefined if the hash is `'#'`, `''` or `undefined`.
    
    @function pureHash
    @internal
     */ pureHash = function(value) {
            if (value && value[0] === "#") value = value.substr(1);
            return u.presence(value);
        };
        up.on("up:app:booted", function() {
            return revealHash(location.hash);
        });
        up.on("up:framework:reset", reset);
        return {
            reveal: reveal,
            revealHash: revealHash,
            firstHashTarget: firstHashTarget,
            scroll: scroll,
            config: config,
            closest: closest,
            subtree: getSubtree,
            around: getAround,
            all: getAll,
            rootSelector: rootSelector,
            root: getRoot,
            rootWidth: rootWidth,
            rootHeight: rootHeight,
            rootHasVerticalScrollbar: rootHasVerticalScrollbar,
            rootOverflowElement: rootOverflowElement,
            isRoot: isRoot,
            scrollbarWidth: scrollbarWidth,
            scrollTops: scrollTops,
            saveScroll: saveScroll,
            restoreScroll: restoreScroll,
            scrollAfterInsertFragment: scrollAfterInsertFragment,
            anchoredRight: anchoredRight,
            fixedElements: fixedElements,
            absolutize: absolutize
        };
    }();
    up.scroll = up.viewport.scroll;
    up.reveal = up.viewport.reveal;
    up.revealHash = up.viewport.revealHash;
    up.legacy.renamedModule("layout", "viewport");
}).call(module.exports);
/***
Fragment update API
===================
  
The `up.fragment` module exposes a high-level Javascript API to [update](/up.replace) or
[destroy](/up.destroy) page fragments.

Fragments are [compiled](/up.compiler) elements that can be updated from a server URL.
They also exist on a layer (page, modal, popup).

Most of Unpoly's functionality (like [fragment links](/up.link) or [modals](/up.modal))
is built from `up.fragment` functions. You may use them to extend Unpoly from your
[custom Javascript](/up.syntax).

@module up.fragment
 */ (function() {
    var slice = [].slice;
    up.fragment = function() {
        var bestMatchingSteps, bestPreflightSelector, config, createPlaceholder, destroy, e, emitFragmentDestroyed, emitFragmentInserted, emitFragmentKept, extract, findKeepPlan, first, firstInLayer, firstInPriority, hello, isRealElement, layerOf, markElementAsDestroying, matchesLayer, processResponse, reload, replace, reset, setSource, shouldExtractTitle, shouldLogDestruction, source, swapElements, transferKeepableElements, u, updateHistoryAndTitle;
        u = up.util;
        e = up.element;
        /***
    Configures defaults for fragment insertion.
    
    @property up.fragment.config
    @param {string} [options.fallbacks=['body']]
      When a fragment updates cannot find the requested element, Unpoly will try this list of alternative selectors.
    
      The first selector that matches an element in the current page (or response) will be used.
      If the response contains none of the selectors, an error message will be shown.
    
      It is recommend to always keep `'body'` as the last selector in the last in the case
      your server or load balancer renders an error message that does not contain your
      application layout.
    @param {string} [options.fallbackTransition=null]
      The transition to use when using a [fallback target](/#options.fallbacks).
    
      By default this is not set and the original replacement's transition is used.
    @stable
     */ config = new up.Config({
            fallbacks: [
                "body"
            ],
            fallbackTransition: null
        });
        reset = function() {
            return config.reset();
        };
        setSource = function(element, sourceUrl) {
            if (sourceUrl !== false) {
                if (u.isPresent(sourceUrl)) sourceUrl = u.normalizeUrl(sourceUrl);
                return element.setAttribute("up-source", sourceUrl);
            }
        };
        /***
    Returns the URL the given element was retrieved from.
    
    @method up.fragment.source
    @param {string|Element|jQuery} selectorOrElement
    @experimental
     */ source = function(selectorOrElement) {
            var element;
            element = e.get(selectorOrElement);
            if (element = e.closest(element, "[up-source]")) return element.getAttribute("up-source");
            else return up.browser.url();
        };
        /***
    Replaces elements on the current page with corresponding elements
    from a new page fetched from the server.
    
    The current and new elements must both match the given CSS selector.
    
    The unobtrusive variant of this is the [`a[up-target]`](/a-up-target) selector.
    
    \#\#\# Example
    
    Let's say your current HTML looks like this:
    
        <div class="one">old one</div>
        <div class="two">old two</div>
    
    We now replace the second `<div>`:
    
        up.replace('.two', '/new')
    
    The server renders a response for `/new`:
    
        <div class="one">new one</div>
        <div class="two">new two</div>
    
    Unpoly looks for the selector `.two` in the response and [implants](/up.extract) it into
    the current page. The current page now looks like this:
    
        <div class="one">old one</div>
        <div class="two">new two</div>
    
    Note how only `.two` has changed. The update for `.one` was
    discarded, since it didn't match the selector.
    
    \#\#\# Appending or prepending instead of replacing
    
    By default Unpoly will replace the given selector with the same
    selector from a freshly fetched page. Instead of replacing you
    can *append* the loaded content to the existing content by using the
    `:after` pseudo selector. In the same fashion, you can use `:before`
    to indicate that you would like the *prepend* the loaded content.
    
    A practical example would be a paginated list of items:
    
        <ul class="tasks">
          <li>Wash car</li>
          <li>Purchase supplies</li>
          <li>Fix tent</li>
        </ul>
    
    In order to append more items from a URL, replace into
    the `.tasks:after` selector:
    
        up.replace('.tasks:after', '/page/2')
    
    \#\#\# Setting the window title from the server
    
    If the `replace` call changes history, the document title will be set
    to the contents of a `<title>` tag in the response.
    
    The server can also change the document title by setting
    an `X-Up-Title` header in the response.
    
    \#\#\# Optimizing response rendering
    
    The server is free to optimize Unpoly requests by only rendering the HTML fragment
    that is being updated. The request's `X-Up-Target` header will contain
    the CSS selector for the updating fragment.
    
    If you are using the `unpoly-rails` gem you can also access the selector via
    `up.target` in all controllers, views and helpers.
    
    \#\#\# Events
    
    Unpoly will emit [`up:fragment:destroyed`](/up:fragment:destroyed) on the element
    that was replaced and [`up:fragment:inserted`](/up:fragment:inserted) on the new
    element that replaces it.
    
    @function up.replace
    @param {string|Element|jQuery} selectorOrElement
      The CSS selector to update. You can also pass a DOM element or jQuery element
      here, in which case a selector will be inferred from the element's class and ID.
    @param {string} url
      The URL to fetch from the server.
    @param {string} [options.failTarget]
      The CSS selector to update if the server sends a non-200 status code.
    @param {string} [options.fallback]
      The selector to update when the original target was not found in the page.
    @param {string} [options.title]
      The document title after the replacement.
    
      If the call pushes an history entry and this option is missing, the title is extracted from the response's `<title>` tag.
      You can also pass `false` to explicitly prevent the title from being updated.
    @param {string} [options.method='get']
      The HTTP method to use for the request.
    @param {Object|FormData|string|Array} [options.params]
      [Parameters](/up.Params) that should be sent as the request's payload.
    @param {string} [options.transition='none']
    @param {string|boolean} [options.history=true]
      If a string is given, it is used as the URL the browser's location bar and history.
      If omitted or true, the `url` argument will be used.
      If set to `false`, the history will remain unchanged.
    @param {boolean|string} [options.source=true]
    @param {boolean|string} [options.reveal=false]
      Whether to [reveal](/up.reveal) the new fragment.
    
      You can also pass a CSS selector for the element to reveal.
    @param {boolean|string} [options.failReveal=false]
      Whether to [reveal](/up.reveal) the new fragment when the server responds with an error.
    
      You can also pass a CSS selector for the element to reveal.
    @param {number} [options.revealPadding]
    
    @param {boolean} [options.restoreScroll=false]
      If set to true, Unpoly will try to restore the scroll position
      of all the viewports around or below the updated element. The position
      will be reset to the last known top position before a previous
      history change for the current URL.
    @param {boolean} [options.cache]
      Whether to use a [cached response](/up.proxy) if available.
    @param {string} [options.historyMethod='push']
    @param {Object} [options.headers={}]
      An object of additional header key/value pairs to send along
      with the request.
    @param {Element|jQuery} [options.origin]
      The element that triggered the replacement.
    
      The element's selector will be substituted for the `&` shorthand in the target selector ([like in Sass](https://sass-lang.com/documentation/file.SASS_REFERENCE.html#parent-selector)).
    @param {string} [options.layer='auto']
      The name of the layer that ought to be updated. Valid values are
      `'auto'`, `'page'`, `'modal'` and `'popup'`.
    
      If set to `'auto'` (default), Unpoly will try to find a match in the
      same layer as the element that triggered the replacement (see `options.origin`).
      If that element is not known, or no match was found in that layer,
      Unpoly will search in other layers, starting from the topmost layer.
    @param {string} [options.failLayer='auto']
      The name of the layer that ought to be updated if the server sends a non-200 status code.
    @param {boolean} [options.keep=true]
      Whether this replacement will preserve [`[up-keep]`](/up-keep) elements.
    @param {boolean} [options.hungry=true]
      Whether this replacement will update [`[up-hungry]`](/up-hungry) elements.
    
    @return {Promise}
      A promise that will be fulfilled when the page has been updated.
    @stable
     */ replace = function(selectorOrElement, url, options) {
            var error, failureOptions, fullLoad, improvedFailTarget, improvedTarget, onFailure, onSuccess, promise, request, requestAttrs, successOptions;
            options = u.options(options);
            options.inspectResponse = fullLoad = function() {
                return up.browser.navigate(url, u.only(options, "method", "params"));
            };
            if (!up.browser.canPushState() && options.history !== false) {
                if (!options.preload) fullLoad();
                return u.unresolvablePromise();
            }
            successOptions = u.merge(options, {
                humanizedTarget: "target"
            });
            failureOptions = u.merge(options, {
                humanizedTarget: "failure target",
                provideTarget: void 0,
                restoreScroll: false
            });
            u.renameKey(failureOptions, "failTransition", "transition");
            u.renameKey(failureOptions, "failLayer", "layer");
            u.renameKey(failureOptions, "failReveal", "reveal");
            try {
                improvedTarget = bestPreflightSelector(selectorOrElement, successOptions);
                improvedFailTarget = bestPreflightSelector(options.failTarget, failureOptions);
            } catch (error1) {
                error = error1;
                return Promise.reject(error);
            }
            requestAttrs = u.only(options, "method", "data", "params", "cache", "preload", "headers", "timeout");
            u.assign(requestAttrs, {
                url: url,
                target: improvedTarget,
                failTarget: improvedFailTarget
            });
            request = new up.Request(requestAttrs);
            onSuccess = function(response) {
                return processResponse(true, improvedTarget, request, response, successOptions);
            };
            onFailure = function(response) {
                var promise, rejection;
                rejection = function() {
                    return Promise.reject(response);
                };
                if (response.isFatalError()) return rejection();
                else {
                    promise = processResponse(false, improvedFailTarget, request, response, failureOptions);
                    return u.always(promise, rejection);
                }
            };
            promise = up.request(request);
            if (!options.preload) promise = promise.then(onSuccess, onFailure);
            return promise;
        };
        /***
    @internal
     */ processResponse = function(isSuccess, selector, request, response, options) {
            var hash, historyUrl, isReloadable, sourceUrl;
            sourceUrl = response.url;
            historyUrl = sourceUrl;
            if (hash = request.hash) {
                options.hash = hash;
                historyUrl += hash;
            }
            isReloadable = response.method === "GET";
            if (isSuccess) {
                if (isReloadable) {
                    if (!(options.history === false || u.isString(options.history))) options.history = historyUrl;
                    if (!(options.source === false || u.isString(options.source))) options.source = sourceUrl;
                } else {
                    if (!u.isString(options.history)) options.history = false;
                    if (!u.isString(options.source)) options.source = "keep";
                }
            } else if (isReloadable) {
                if (options.history !== false) options.history = historyUrl;
                if (options.source !== false) options.source = sourceUrl;
            } else {
                options.history = false;
                options.source = "keep";
            }
            if (shouldExtractTitle(options) && response.title) options.title = response.title;
            return extract(selector, response.text, options);
        };
        shouldExtractTitle = function(options) {
            return !(options.title === false || u.isString(options.title) || options.history === false && options.title !== true);
        };
        /***
    Updates a selector on the current page with the
    same selector from the given HTML string.
    
    \#\#\# Example
    
    Let's say your current HTML looks like this:
    
        <div class="one">old one</div>
        <div class="two">old two</div>
    
    We now replace the second `<div>`, using an HTML string
    as the source:
    
        html = '<div class="one">new one</div>' +
               '<div class="two">new two</div>';
    
        up.extract('.two', html)
    
    Unpoly looks for the selector `.two` in the strings and updates its
    contents in the current page. The current page now looks like this:
    
        <div class="one">old one</div>
        <div class="two">new two</div>
    
    Note how only `.two` has changed. The update for `.one` was
    discarded, since it didn't match the selector.
    
    @function up.extract
    @param {string|Element|jQuery} selectorOrElement
    @param {string} html
    @param {Object} [options]
      See options for [`up.replace()`](/up.replace).
    @return {Promise}
      A promise that will be fulfilled then the selector was updated
      and all animation has finished.
    @stable
     */ extract = function(selectorOrElement, html, options) {
            return up.log.group("Extracting %s from %d bytes of HTML", selectorOrElement, html != null ? html.length : void 0, function() {
                options = u.options(options, {
                    historyMethod: "push",
                    keep: true,
                    layer: "auto"
                });
                if (options.saveScroll !== false) up.viewport.saveScroll();
                return u.rejectOnError(function() {
                    var extractSteps, i, len, responseDoc, responseTitle, step, swapPromises;
                    if (typeof options.provideTarget === "function") options.provideTarget();
                    responseDoc = new up.HtmlParser(html);
                    extractSteps = bestMatchingSteps(selectorOrElement, responseDoc, options);
                    if (shouldExtractTitle(options) && (responseTitle = responseDoc.title())) options.title = responseTitle;
                    updateHistoryAndTitle(options);
                    swapPromises = [];
                    for(i = 0, len = extractSteps.length; i < len; i++){
                        step = extractSteps[i];
                        up.log.group("Swapping fragment %s", step.selector, function() {
                            var swapOptions, swapPromise;
                            swapOptions = u.merge(options, u.only(step, "origin", "reveal"));
                            responseDoc.prepareForInsertion(step.newElement);
                            swapPromise = swapElements(step.oldElement, step.newElement, step.pseudoClass, step.transition, swapOptions);
                            return swapPromises.push(swapPromise);
                        });
                    }
                    return Promise.all(swapPromises);
                });
            });
        };
        bestPreflightSelector = function(selectorOrElement, options) {
            var cascade;
            cascade = new up.ExtractCascade(selectorOrElement, options);
            return cascade.bestPreflightSelector();
        };
        bestMatchingSteps = function(selectorOrElement, response, options) {
            var cascade;
            options = u.merge(options, {
                response: response
            });
            cascade = new up.ExtractCascade(selectorOrElement, options);
            return cascade.bestMatchingSteps();
        };
        updateHistoryAndTitle = function(options) {
            options = u.options(options, {
                historyMethod: "push"
            });
            if (options.history) up.history[options.historyMethod](options.history);
            if (u.isString(options.title)) return document.title = options.title;
        };
        swapElements = function(oldElement, newElement, pseudoClass, transition, options) {
            var child, childNode, i, keepPlan, len, morphOptions, parent, promise, ref, wrapper;
            transition || (transition = "none");
            if (options.source === "keep") options = u.merge(options, {
                source: source(oldElement)
            });
            setSource(newElement, options.source);
            if (pseudoClass) {
                wrapper = e.createFromSelector(".up-insertion");
                while(childNode = newElement.firstChild)wrapper.appendChild(childNode);
                if (pseudoClass === "before") oldElement.insertAdjacentElement("afterbegin", wrapper);
                else oldElement.insertAdjacentElement("beforeend", wrapper);
                ref = wrapper.children;
                for(i = 0, len = ref.length; i < len; i++){
                    child = ref[i];
                    hello(child, options);
                }
                promise = up.viewport.scrollAfterInsertFragment(wrapper, options);
                promise = u.always(promise, up.animate(wrapper, transition, options));
                promise = promise.then(function() {
                    return e.unwrap(wrapper);
                });
                return promise;
            } else if (keepPlan = findKeepPlan(oldElement, newElement, options)) {
                emitFragmentKept(keepPlan);
                return Promise.resolve();
            } else {
                options.keepPlans = transferKeepableElements(oldElement, newElement, options);
                parent = oldElement.parentNode;
                morphOptions = u.merge(options, {
                    beforeStart: function() {
                        return markElementAsDestroying(oldElement);
                    },
                    afterInsert: function() {
                        return up.hello(newElement, options);
                    },
                    beforeDetach: function() {
                        return up.syntax.clean(oldElement);
                    },
                    afterDetach: function() {
                        e.remove(oldElement);
                        return emitFragmentDestroyed(oldElement, {
                            parent: parent,
                            log: false
                        });
                    }
                });
                return up.morph(oldElement, newElement, transition, morphOptions);
            }
        };
        transferKeepableElements = function(oldElement, newElement, options) {
            var i, keepPlans, keepable, keepableClone, len, plan, ref;
            keepPlans = [];
            if (options.keep) {
                ref = oldElement.querySelectorAll("[up-keep]");
                for(i = 0, len = ref.length; i < len; i++){
                    keepable = ref[i];
                    if (plan = findKeepPlan(keepable, newElement, u.merge(options, {
                        descendantsOnly: true
                    }))) {
                        keepableClone = keepable.cloneNode(true);
                        e.replace(keepable, keepableClone);
                        e.replace(plan.newElement, keepable);
                        keepPlans.push(plan);
                    }
                }
            }
            return keepPlans;
        };
        findKeepPlan = function(element, newElement, options) {
            var keepEventArgs, keepable, partner, partnerSelector, plan;
            if (options.keep) {
                keepable = element;
                if (partnerSelector = e.booleanOrStringAttr(keepable, "up-keep")) {
                    u.isString(partnerSelector) || (partnerSelector = "&");
                    partnerSelector = e.resolveSelector(partnerSelector, keepable);
                    if (options.descendantsOnly) partner = e.first(newElement, partnerSelector);
                    else partner = e.subtree(newElement, partnerSelector)[0];
                    if (partner && e.matches(partner, "[up-keep]")) {
                        plan = {
                            oldElement: keepable,
                            newElement: partner,
                            newData: up.syntax.data(partner)
                        };
                        keepEventArgs = {
                            target: keepable,
                            newFragment: partner,
                            newData: plan.newData,
                            log: [
                                "Keeping element %o",
                                keepable
                            ]
                        };
                        if (up.event.nobodyPrevents("up:fragment:keep", keepEventArgs)) return plan;
                    }
                }
            }
        };
        /***
    Elements with an `up-keep` attribute will be persisted during
    [fragment updates](/a-up-target).
    
    For example:
    
        <audio up-keep src="song.mp3"></audio>
    
    The element you're keeping should have an umambiguous class name, ID or `up-id`
    attribute so Unpoly can find its new position within the page update.
    
    Emits events [`up:fragment:keep`](/up:fragment:keep) and [`up:fragment:kept`](/up:fragment:kept).
    
    \#\#\# Controlling if an element will be kept
    
    Unpoly will **only** keep an existing element if:
    
    - The existing element has an `up-keep` attribute
    - The response contains an element matching the CSS selector of the existing element
    - The matching element *also* has an `up-keep` attribute
    - The [`up:fragment:keep`](/up:fragment:keep) event that is [emitted](/up.emit) on the existing element
      is not prevented by a event listener.
    
    Let's say we want only keep an `<audio>` element as long as it plays
    the same song (as identified by the tag's `src` attribute).
    
    On the client we can achieve this by listening to an `up:keep:fragment` event
    and preventing it if the `src` attribute of the old and new element differ:
    
        up.compiler('audio', function(element) {
          element.addEventListener('up:fragment:keep', function(event) {
            if element.getAttribute('src') !== event.newElement.getAttribute('src') {
              event.preventDefault()
            }
          })
        })
    
    If we don't want to solve this on the client, we can achieve the same effect
    on the server. By setting the value of the `up-keep` attribute we can
    define the CSS selector used for matching elements.
    
        <audio up-keep="audio[src='song.mp3']" src="song.mp3"></audio>
    
    Now, if a response no longer contains an `<audio src="song.mp3">` tag, the existing
    element will be destroyed and replaced by a fragment from the response.
    
    @selector [up-keep]
    @stable
     */ /***
    This event is [emitted](/up.emit) before an existing element is [kept](/up-keep) during
    a page update.
    
    Event listeners can call `event.preventDefault()` on an `up:fragment:keep` event
    to prevent the element from being persisted. If the event is prevented, the element
    will be replaced by a fragment from the response.
    
    @event up:fragment:keep
    @param event.preventDefault()
      Event listeners may call this method to prevent the element from being preserved.
    @param {Element} event.target
      The fragment that will be kept.
    @param {Element} event.newFragment
      The discarded element.
    @param {Object} event.newData
      The value of the [`up-data`](/up-data) attribute of the discarded element,
      parsed as a JSON object.
    @stable
     */ /***
    This event is [emitted](/up.emit) when an existing element has been [kept](/up-keep)
    during a page update.
    
    Event listeners can inspect the discarded update through `event.newElement`
    and `event.newData` and then modify the preserved element when necessary.
    
    @event up:fragment:kept
    @param {Element} event.target
      The fragment that has been kept.
    @param {Element} event.newFragment
      The discarded fragment.
    @param {Object} event.newData
      The value of the [`up-data`](/up-data) attribute of the discarded fragment,
      parsed as a JSON object.
    @stable
     */ /***
    Compiles a page fragment that has been inserted into the DOM
    by external code.
    
    **As long as you manipulate the DOM using Unpoly, you will never
    need to call this method.** You only need to use `up.hello()` if the
    DOM is manipulated without Unpoly' involvement, e.g. by setting
    the `innerHTML` property or calling jQuery methods like
    `html`, `insertAfter` or `appendTo`:
    
        element = document.createElement('div')
        element.innerHTML = '... HTML that needs to be activated ...'
        up.hello(element)
    
    This function emits the [`up:fragment:inserted`](/up:fragment:inserted)
    event.
    
    @function up.hello
    @param {string|Element|jQuery} selectorOrElement
    @param {string|Element|jQuery} [options.origin]
    @param {string|Element|jQuery} [options.kept]
    @return {Element}
      The compiled element
    @stable
     */ hello = function(selectorOrElement, options) {
            var element, i, keptElements, len, plan, ref;
            element = e.get(selectorOrElement);
            options = u.options(options, {
                keepPlans: []
            });
            keptElements = [];
            ref = options.keepPlans;
            for(i = 0, len = ref.length; i < len; i++){
                plan = ref[i];
                emitFragmentKept(plan);
                keptElements.push(plan.oldElement);
            }
            up.syntax.compile(element, {
                skip: keptElements
            });
            emitFragmentInserted(element, options);
            return element;
        };
        /***
    When any page fragment has been [inserted or updated](/up.replace),
    this event is [emitted](/up.emit) on the fragment.
    
    If you're looking to run code when a new fragment matches
    a selector, use `up.compiler()` instead.
    
    \#\#\# Example
    
        up.on('up:fragment:inserted', function(event, fragment) {
          console.log("Looks like we have a new %o!", fragment)
        })
    
    @event up:fragment:inserted
    @param {Element} event.target
      The fragment that has been inserted or updated.
    @stable
     */ emitFragmentInserted = function(element, options) {
            return up.emit(element, "up:fragment:inserted", {
                log: [
                    "Inserted fragment %o",
                    element
                ],
                origin: options.origin
            });
        };
        emitFragmentKept = function(keepPlan) {
            var eventAttrs, keptElement;
            keptElement = keepPlan.oldElement;
            eventAttrs = {
                target: keptElement,
                newFragment: keepPlan.newElement,
                newData: keepPlan.newData,
                log: [
                    "Kept fragment %o",
                    keptElement
                ]
            };
            return up.emit("up:fragment:kept", eventAttrs);
        };
        emitFragmentDestroyed = function(fragment, options) {
            var log, parent;
            if (shouldLogDestruction(fragment, options)) log = [
                "Destroyed fragment %o",
                fragment
            ];
            parent = options.parent || up.fail("Missing { parent } option");
            return up.emit(parent, "up:fragment:destroyed", {
                fragment: fragment,
                parent: parent,
                log: log
            });
        };
        isRealElement = function(element) {
            return !e.closest(element, ".up-destroying");
        };
        /***
    Returns the first element matching the given selector, but
    ignores elements that are being [destroyed](/up.destroy) or that are being
    removed by a [transition](/up.morph).
    
    Returns `undefined` if no element matches these conditions.
    
    \#\#\# Example
    
    To select the first element with the selector `.foo`:
    
        var fooInModal = up.fragment.first('.foo')
    
    You may also pass a `{ layer }` option to only match elements witin a layer:
    
        var fooInModal = up.fragment.first('.foo', { layer: 'modal' })
    
    You may also pass a root element as a first argument:
    
        var container = up.fragment.first('.container')
        var fooInContainer = up.fragment.first(container, '.foo')
    
    \#\#\# Similar features
    
    - The [`.up-destroying`](/up-destroying) class is assigned to elements during their removal animation.
    - The [`up.element.first()`](/up.element.first) function simply returns the first element matching a selector
      without further filtering.
    
    @function up.fragment.first
    @param {Element|jQuery} [root=document]
      The root element for the search. Only the root's children will be matched.
    
      May be omitted to search through all elements in the `document`.
    @param {string} selector
      The selector to match
    @param {string} [options.layer='auto']
      The name of the layer in which to find the element.
    
      Valid values are `'auto'`, `'page'`, `'modal'` and `'popup'`.
    @param {string|Element|jQuery} [options.origin]
      An second element or selector that can be referenced as `&` in the first selector:
    
          var input = document.querySelector('input.email')
          up.fragment.first('fieldset:has(&)', { origin: input }) // returns the <fieldset> containing input
    @return {Element|undefined}
      The first element that is neither a ghost or being destroyed,
      or `undefined` if no such element was found.
    @experimental
     */ first = function() {
            var args, layer, options, origin, ref, root, selector;
            args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
            options = u.extractOptions(args);
            selector = args.pop();
            root = args[0] || document;
            layer = (ref = options.layer) != null ? ref : "auto";
            origin = options.origin;
            selector = e.resolveSelector(selector, origin);
            if (layer === "auto") return firstInPriority(root, selector, origin);
            else return firstInLayer(root, selector, layer);
        };
        firstInPriority = function(parent, selector, origin) {
            var layers, originLayer;
            layers = [
                "popup",
                "modal",
                "page"
            ];
            if (origin) {
                originLayer = layerOf(origin);
                u.remove(layers, originLayer);
                layers.unshift(originLayer);
            }
            return u.findResult(layers, function(layer) {
                return firstInLayer(parent, selector, layer);
            });
        };
        firstInLayer = function(parent, selector, layer) {
            var elements;
            elements = e.all(parent, selector);
            return u.findResult(elements, function(element) {
                if (isRealElement(element) && matchesLayer(element, layer)) return element;
            });
        };
        /***
    @function up.fragment.layerOf
    @internal
     */ layerOf = function(element) {
            if (up.popup.contains(element)) return "popup";
            else if (up.modal.contains(element)) return "modal";
            else return "page";
        };
        matchesLayer = function(element, layer) {
            return !layer || layerOf(element) === layer;
        };
        /***
    @function up.fragment.createPlaceHolder
    @internal
     */ createPlaceholder = function(selector, container) {
            if (container == null) container = document.body;
            return e.affix(container, selector, {
                "class": "up-placeholder"
            });
        };
        /***
    Destroys the given element or selector.
    
    Takes care that all [`up.compiler()`](/up.compiler) destructors, if any, are called.
    
    The element is removed from the DOM.
    Note that if you choose to animate the element removal using `options.animate`,
    the element won't be removed until after the animation has completed.
    
    Emits events [`up:fragment:destroyed`](/up:fragment:destroyed).
    
    @function up.destroy
    @param {string|Element|jQuery} selectorOrElement
    @param {string} [options.history]
      A URL that will be pushed as a new history entry when the element begins destruction.
    @param {string} [options.title]
      The document title to set when the element begins destruction.
    @param {string|Function(element, options): Promise} [options.animation='none']
      The animation to use before the element is removed from the DOM.
    @param {number} [options.duration]
      The duration of the animation. See [`up.animate()`](/up.animate).
    @param {number} [options.delay]
      The delay before the animation starts. See [`up.animate()`](/up.animate).
    @param {string} [options.easing]
      The timing function that controls the animation's acceleration. [`up.animate()`](/up.animate).
    @return {Promise}
      A promise that will be fulfilled once the element has been removed from the DOM.
    @stable
     */ destroy = function(selectorOrElement, options) {
            var animate, element, wipe;
            element = e.get(selectorOrElement);
            options = u.options(options, {
                animation: false
            });
            if (!element) return Promise.resolve();
            markElementAsDestroying(element);
            updateHistoryAndTitle(options);
            animate = function() {
                var animateOptions;
                animateOptions = up.motion.animateOptions(options);
                return up.motion.animate(element, options.animation, animateOptions);
            };
            wipe = function() {
                var parent;
                parent = element.parentNode;
                up.syntax.clean(element);
                if (up.browser.canJQuery()) jQuery(element).remove();
                else e.remove(element);
                return emitFragmentDestroyed(element, {
                    parent: parent,
                    log: options.log
                });
            };
            return animate().then(wipe);
        };
        shouldLogDestruction = function(element, options) {
            return options.log !== false && !e.matches(element, ".up-placeholder, .up-tooltip, .up-modal, .up-popup");
        };
        /***
    Elements are assigned the `.up-destroying` class before they are [destroyed](/up.destroy)
    or while they are being removed by a [transition](/up.morph).
    
    If the removal is animated, the class is assigned before the animation starts.
    
    To select an element while ignoring elements that are being destroyed,
    see the [`up.fragment.first()`](/up.fragment.first) function.
    
    @selector .up-destroying
    @stable
     */ markElementAsDestroying = function(element) {
            element.classList.add("up-destroying");
            return element.setAttribute("aria-hidden", "true");
        };
        /***
    This event is [emitted](/up.emit) after a page fragment was [destroyed](/up.destroy) and removed from the DOM.
    
    If the destruction is animated, this event is emitted after the animation has ended.
    
    The event is emitted on the parent element of the fragment that was removed.
    
    @event up:fragment:destroyed
    @param {Element} event.fragment
      The detached element that has been removed from the DOM.
    @param {Element} event.parent
      The former parent element of the fragment that has now been detached from the DOM.
    @param {Element} event.target
      The former parent element of the fragment that has now been detached from the DOM.
    @stable
     */ /***
    Replaces the given element with a fresh copy fetched from the server.
    
    \#\#\# Example
    
        up.on('new-mail', function() { up.reload('.inbox') })
    
    Unpoly remembers the URL from which a fragment was loaded, so you
    don't usually need to give an URL when reloading.
    
    @function up.reload
    @param {string|Element|jQuery} selectorOrElement
    @param {Object} [options]
      See options for [`up.replace()`](/up.replace)
    @param {string} [options.url]
      The URL from which to reload the fragment.
      This defaults to the URL from which the fragment was originally loaded.
    @stable
     */ reload = function(selectorOrElement, options) {
            var sourceUrl;
            options = u.options(options, {
                cache: false
            });
            sourceUrl = options.url || source(selectorOrElement);
            return replace(selectorOrElement, sourceUrl, options);
        };
        up.on("up:app:boot", function() {
            var body;
            body = document.body;
            setSource(body, up.browser.url());
            return hello(body);
        });
        up.on("up:framework:reset", reset);
        return {
            createPlaceholder: createPlaceholder,
            replace: replace,
            reload: reload,
            destroy: destroy,
            extract: extract,
            first: first,
            source: source,
            hello: hello,
            config: config,
            layerOf: layerOf
        };
    }();
    up.replace = up.fragment.replace;
    up.extract = up.fragment.extract;
    up.reload = up.fragment.reload;
    up.destroy = up.fragment.destroy;
    up.hello = up.fragment.hello;
    up.first = function() {
        var args, ref;
        args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
        up.legacy.warn("up.first() has been renamed to up.fragment.first()");
        return (ref = up.fragment).first.apply(ref, args);
    };
    up.legacy.renamedModule("flow", "fragment");
    up.legacy.renamedModule("dom", "fragment");
}).call(module.exports);
/***
Animation
=========
  
Whenever you [update a page fragment](/up.link) you can animate the change.

Let's say you are using an [`up-target`](/a-up-target) link to update an element
with content from the server. You can add an attribute [`up-transition`](/a-up-target#up-transition)
to smoothly fade out the old element while fading in the new element:

    <a href="/users" up-target=".list" up-transition="cross-fade">Show users</a>

\#\#\# Transitions vs. animations

When we morph between an old and a new element, we call it a *transition*.
In contrast, when we animate a new element without simultaneously removing an
old element, we call it an *animation*.

An example for an animation is opening a new dialog. We can animate the appearance
of the dialog by adding an [`[up-animation]`](/a-up-modal#up-animation) attribute to the opening link:

    <a href="/users" up-modal=".list" up-animation="move-from-top">Show users</a>

\#\#\# Which animations are available?

Unpoly ships with a number of [predefined transitions](/up.morph#named-transitions)
and [predefined animations](/up.animate#named-animations).

You can define custom animations using [`up.transition()`](/up.transition) and
[`up.animation()`](/up.animation).

@module up.motion
 */ (function() {
    var slice = [].slice;
    up.motion = function() {
        var animCount, animate, animateNow, animateOptions, composeTransitionFn, config, defaultNamedAnimations, defaultNamedTransitions, e, findAnimationFn, findNamedAnimation, findTransitionFn, finish, isEnabled, isNone, morph, motionController, namedAnimations, namedTransitions, registerAnimation, registerTransition, reset, skipAnimate, snapshot, swapElementsDirectly, translateCss, u, willAnimate;
        u = up.util;
        e = up.element;
        namedAnimations = {};
        defaultNamedAnimations = {};
        namedTransitions = {};
        defaultNamedTransitions = {};
        motionController = new up.MotionController("motion");
        /***
    Sets default options for animations and transitions.
    
    @property up.motion.config
    @param {number} [config.duration=300]
      The default duration for all animations and transitions (in milliseconds).
    @param {number} [config.delay=0]
      The default delay for all animations and transitions (in milliseconds).
    @param {string} [config.easing='ease']
      The default timing function that controls the acceleration of animations and transitions.
    
      See [W3C documentation](http://www.w3.org/TR/css3-transitions/#transition-timing-function)
      for a list of pre-defined timing functions.
    @param {boolean} [config.enabled=true]
      Whether animation is enabled.
    
      Set this to `false` to disable animation globally.
      This can be useful in full-stack integration tests like a Selenium test suite.
    
      Regardless of this setting, all animations will be skipped on browsers
      that do not support [CSS transitions](https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Transitions/Using_CSS_transitions).
    @stable
     */ config = new up.Config({
            duration: 300,
            delay: 0,
            easing: "ease",
            enabled: true
        });
        reset = function() {
            motionController.reset();
            namedAnimations = u.copy(defaultNamedAnimations);
            namedTransitions = u.copy(defaultNamedTransitions);
            return config.reset();
        };
        /***
    Returns whether Unpoly will perform animations.
    
    Set [`up.motion.config.enabled`](/up.motion.config) `false` in order to disable animations globally.
    
    @function up.motion.isEnabled
    @return {boolean}
    @stable
     */ isEnabled = function() {
            return config.enabled;
        };
        /***
    Applies the given animation to the given element.
    
    \#\#\# Example
    
        up.animate('.warning', 'fade-in')
    
    You can pass additional options:
    
        up.animate('.warning', 'fade-in', {
          delay: 1000,
          duration: 250,
          easing: 'linear'
        })
    
    \#\#\# Named animations
    
    The following animations are pre-defined:
    
    | `fade-in`          | Changes the element's opacity from 0% to 100% |
    | `fade-out`         | Changes the element's opacity from 100% to 0% |
    | `move-to-top`      | Moves the element upwards until it exits the screen at the top edge |
    | `move-from-top`    | Moves the element downwards from beyond the top edge of the screen until it reaches its current position |
    | `move-to-bottom`   | Moves the element downwards until it exits the screen at the bottom edge |
    | `move-from-bottom` | Moves the element upwards from beyond the bottom edge of the screen until it reaches its current position |
    | `move-to-left`     | Moves the element leftwards until it exists the screen at the left edge  |
    | `move-from-left`   | Moves the element rightwards from beyond the left edge of the screen until it reaches its current position |
    | `move-to-right`    | Moves the element rightwards until it exists the screen at the right edge  |
    | `move-from-right`  | Moves the element leftwards from beyond the right  edge of the screen until it reaches its current position |
    | `none`             | An animation that has no visible effect. Sounds useless at first, but can save you a lot of `if` statements. |
    
    You can define additional named animations using [`up.animation()`](/up.animation).
    
    \#\#\# Animating CSS properties directly
    
    By passing an object instead of an animation name, you can animate
    the CSS properties of the given element:
    
        var warning = document.querySelector('.warning')
        warning.style.opacity = 0
        up.animate(warning, { opacity: 1 })
    
    CSS properties must be given in `kebab-case`, not `camelCase`.
    
    \#\#\# Multiple animations on the same element
    
    Unpoly doesn't allow more than one concurrent animation on the same element.
    
    If you attempt to animate an element that is already being animated,
    the previous animation will instantly jump to its last frame before
    the new animation begins.
    
    @function up.animate
    @param {Element|jQuery|string} elementOrSelector
      The element to animate.
    @param {string|Function(element, options): Promise|Object} animation
      Can either be:
    
      - The animation's name
      - A function performing the animation
      - An object of CSS attributes describing the last frame of the animation (using kebeb-case property names)
    @param {number} [options.duration=300]
      The duration of the animation, in milliseconds.
    @param {number} [options.delay=0]
      The delay before the animation starts, in milliseconds.
    @param {string} [options.easing='ease']
      The timing function that controls the animation's acceleration.
    
      See [W3C documentation](http://www.w3.org/TR/css3-transitions/#transition-timing-function)
      for a list of pre-defined timing functions.
    @return {Promise}
      A promise for the animation's end.
    @stable
     */ animate = function(elementOrSelector, animation, options) {
            var animationFn, element, runNow, willRun;
            element = e.get(elementOrSelector);
            options = animateOptions(options);
            animationFn = findAnimationFn(animation);
            willRun = willAnimate(element, animation, options);
            if (willRun) {
                runNow = function() {
                    return animationFn(element, options);
                };
                return motionController.startFunction(element, runNow, options);
            } else return skipAnimate(element, animation);
        };
        willAnimate = function(element, animationOrTransition, options) {
            options = animateOptions(options);
            return isEnabled() && !isNone(animationOrTransition) && options.duration > 0 && !e.isSingleton(element);
        };
        skipAnimate = function(element, animation) {
            if (u.isOptions(animation)) e.setStyle(element, animation);
            return Promise.resolve();
        };
        animCount = 0;
        /***
    Animates the given element's CSS properties using CSS transitions.
    
    Does not track the animation, nor does it finishes existing animations
    (use `up.motion.animate()` for that). It does, however, listen to the motionController's
    finish event.
    
    @function animateNow
    @param {Element|jQuery|string} elementOrSelector
      The element to animate.
    @param {Object} lastFrame
      The CSS properties that should be transitioned to.
    @param {number} [options.duration=300]
      The duration of the animation, in milliseconds.
    @param {number} [options.delay=0]
      The delay before the animation starts, in milliseconds.
    @param {string} [options.easing='ease']
      The timing function that controls the animation's acceleration.
      See [W3C documentation](http://www.w3.org/TR/css3-transitions/#transition-timing-function)
      for a list of pre-defined timing functions.
    @return {Promise}
      A promise that fulfills when the animation ends.
    @internal
     */ animateNow = function(element, lastFrame, options) {
            var cssTransition;
            options = u.merge(options, {
                finishEvent: motionController.finishEvent
            });
            cssTransition = new up.CssTransition(element, lastFrame, options);
            return cssTransition.start();
        };
        /***
    Extracts animation-related options from the given options hash.
    If `element` is given, also inspects the element for animation-related
    attributes like `up-easing` or `up-duration`.
    
    @param {Object} userOptions
    @param {Element|jQuery} [element]
    @param {Object} [moduleDefaults]
    @function up.motion.animateOptions
    @internal
     */ animateOptions = function() {
            var args, consolidatedOptions, element, moduleDefaults, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, userOptions;
            args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
            userOptions = (ref = args.shift()) != null ? ref : {};
            moduleDefaults = u.extractOptions(args);
            element = args.pop() || e.none();
            consolidatedOptions = {};
            consolidatedOptions.easing = (ref1 = (ref2 = (ref3 = userOptions.easing) != null ? ref3 : element.getAttribute("up-easing")) != null ? ref2 : moduleDefaults.easing) != null ? ref1 : config.easing;
            consolidatedOptions.duration = (ref4 = (ref5 = (ref6 = userOptions.duration) != null ? ref6 : e.numberAttr(element, "up-duration")) != null ? ref5 : moduleDefaults.duration) != null ? ref4 : config.duration;
            consolidatedOptions.delay = (ref7 = (ref8 = (ref9 = userOptions.delay) != null ? ref9 : e.numberAttr(element, "up-delay")) != null ? ref8 : moduleDefaults.delay) != null ? ref7 : config.delay;
            consolidatedOptions.trackMotion = userOptions.trackMotion;
            return consolidatedOptions;
        };
        findNamedAnimation = function(name) {
            return namedAnimations[name] || up.fail("Unknown animation %o", name);
        };
        /***
    Completes [animations](/up.animate) and [transitions](/up.morph).
    
    If called without arguments, all animations on the screen are completed.
    If given an element (or selector), animations on that element and its children
    are completed.
    
    Animations are completed by jumping to the last animation frame instantly.
    Promises returned by animation and transition functions instantly settle.
    
    Emits the `up:motion:finish` event that is already handled by `up.animate()`.
    
    Does nothing if there are no animation to complete.
    
    @function up.motion.finish
    @param {Element|jQuery|string} [elementOrSelector]
    @return {Promise}
      A promise that fulfills when animations and transitions have finished.
    @stable
     */ finish = function(elementOrSelector) {
            return motionController.finish(elementOrSelector);
        };
        /***
    This event is emitted on an [animating](/up.animating) element by `up.motion.finish()` to
    request the animation to instantly finish and skip to the last frame.
    
    Promises returned by completed animation functions are expected to settle.
    
    Animations started by `up.animate()` already handle this event.
    
    @event up:motion:finish
    @param {Element} event.target
      The animating element.
    @experimental
     */ /***
    Performs an animated transition between the `source` and `target` elements.
    
    Transitions are implement by performing two animations in parallel,
    causing `source` to disappear and the `target` to appear.
    
    - `target` is [inserted before](https://developer.mozilla.org/en-US/docs/Web/API/Node/insertBefore) `source`
    - `source` is removed from the [document flow](https://developer.mozilla.org/en-US/docs/Learn/CSS/CSS_layout/Positioning) with `position: absolute`.
       It will be positioned over its original place in the flow that is now occupied by `target`.
    - Both `source` and `target` are animated in parallel
    - `source` is removed from the DOM
    
    \#\#\# Named transitions
    
    The following transitions are pre-defined:
    
    | `cross-fade` | Fades out the first element. Simultaneously fades in the second element. |
    | `move-up`    | Moves the first element upwards until it exits the screen at the top edge. Simultaneously moves the second element upwards from beyond the bottom edge of the screen until it reaches its current position. |
    | `move-down`  | Moves the first element downwards until it exits the screen at the bottom edge. Simultaneously moves the second element downwards from beyond the top edge of the screen until it reaches its current position. |
    | `move-left`  | Moves the first element leftwards until it exists the screen at the left edge. Simultaneously moves the second element leftwards from beyond the right  edge of the screen until it reaches its current position. |
    | `move-right` | Moves the first element rightwards until it exists the screen at the right edge. Simultaneously moves the second element rightwards from beyond the left edge of the screen until it reaches its current position. |
    | `none`       | A transition that has no visible effect. Sounds useless at first, but can save you a lot of `if` statements. |
    
    You can define additional named transitions using [`up.transition()`](/up.transition).
    
    You can also compose a transition from two [named animations](/named-animations).
    separated by a slash character (`/`):
    
    - `move-to-bottom/fade-in`
    - `move-to-left/move-from-top`
    
    \#\#\# Implementation details
    
    During a transition both the old and new element occupy
    the same position on the screen.
    
    Since the CSS layout flow will usually not allow two elements to
    overlay the same space, Unpoly:
    
    - The old and new elements are cloned
    - The old element is removed from the layout flow using `display: hidden`
    - The new element is hidden, but still leaves space in the layout flow by setting `visibility: hidden`
    - The clones are [absolutely positioned](https://developer.mozilla.org/en-US/docs/Web/CSS/position#Absolute_positioning)
      over the original elements.
    - The transition is applied to the cloned elements.
      At no point will the hidden, original elements be animated.
    - When the transition has finished, the clones are removed from the DOM and the new element is shown.
      The old element remains hidden in the DOM.
    
    @function up.morph
    @param {Element|jQuery|string} source
    @param {Element|jQuery|string} target
    @param {Function(oldElement, newElement)|string} transition
    @param {number} [options.duration=300]
      The duration of the animation, in milliseconds.
    @param {number} [options.delay=0]
      The delay before the animation starts, in milliseconds.
    @param {string} [options.easing='ease']
      The timing function that controls the transition's acceleration.
    
      See [W3C documentation](http://www.w3.org/TR/css3-transitions/#transition-timing-function)
      for a list of pre-defined timing functions.
    @param {boolean} [options.reveal=false]
      Whether to reveal the new element by scrolling its parent viewport.
    @return {Promise}
      A promise that fulfills when the transition ends.
    @stable
     */ morph = function(oldElement, newElement, transitionObject, options) {
            var afterDetach, afterInsert, beforeDetach, beforeStart, oldRemote, promise, scrollNew, scrollTopBeforeReveal, trackable, transitionFn, viewport, willMorph;
            options = u.options(options);
            u.assign(options, animateOptions(options));
            oldElement = e.get(oldElement);
            newElement = e.get(newElement);
            transitionFn = findTransitionFn(transitionObject);
            willMorph = willAnimate(oldElement, transitionFn, options);
            beforeStart = u.pluckKey(options, "beforeStart") || u.noop;
            afterInsert = u.pluckKey(options, "afterInsert") || u.noop;
            beforeDetach = u.pluckKey(options, "beforeDetach") || u.noop;
            afterDetach = u.pluckKey(options, "afterDetach") || u.noop;
            beforeStart();
            scrollNew = function() {
                var scrollOptions;
                scrollOptions = u.merge(options, {
                    scrollBehavior: "auto"
                });
                return up.viewport.scrollAfterInsertFragment(newElement, scrollOptions);
            };
            if (willMorph) {
                if (motionController.isActive(oldElement) && options.trackMotion === false) return transitionFn(oldElement, newElement, options);
                up.puts("Morphing %o to %o with transition %o", oldElement, newElement, transitionObject);
                viewport = up.viewport.closest(oldElement);
                scrollTopBeforeReveal = viewport.scrollTop;
                oldRemote = up.viewport.absolutize(oldElement, {
                    afterMeasure: function() {
                        e.insertBefore(oldElement, newElement);
                        return afterInsert();
                    }
                });
                trackable = function() {
                    var promise;
                    promise = scrollNew();
                    promise = promise.then(function() {
                        var scrollTopAfterReveal;
                        scrollTopAfterReveal = viewport.scrollTop;
                        oldRemote.moveBounds(0, scrollTopAfterReveal - scrollTopBeforeReveal);
                        return transitionFn(oldElement, newElement, options);
                    });
                    promise = promise.then(function() {
                        beforeDetach();
                        e.remove(oldRemote.bounds);
                        return afterDetach();
                    });
                    return promise;
                };
                return motionController.startFunction([
                    oldElement,
                    newElement
                ], trackable, options);
            } else {
                beforeDetach();
                swapElementsDirectly(oldElement, newElement);
                afterInsert();
                afterDetach();
                promise = scrollNew();
                return promise;
            }
        };
        findTransitionFn = function(object) {
            var namedTransition;
            if (isNone(object)) return void 0;
            else if (u.isFunction(object)) return object;
            else if (u.isArray(object)) return composeTransitionFn.apply(null, object);
            else if (u.isString(object)) {
                if (object.indexOf("/") >= 0) return composeTransitionFn.apply(null, object.split("/"));
                else if (namedTransition = namedTransitions[object]) return findTransitionFn(namedTransition);
            } else return up.fail("Unknown transition %o", object);
        };
        composeTransitionFn = function(oldAnimation, newAnimation) {
            var newAnimationFn, oldAnimationFn;
            if (isNone(oldAnimation) && isNone(oldAnimation)) return void 0;
            else {
                oldAnimationFn = findAnimationFn(oldAnimation) || u.asyncNoop;
                newAnimationFn = findAnimationFn(newAnimation) || u.asyncNoop;
                return function(oldElement, newElement, options) {
                    return Promise.all([
                        oldAnimationFn(oldElement, options),
                        newAnimationFn(newElement, options)
                    ]);
                };
            }
        };
        findAnimationFn = function(object) {
            if (isNone(object)) return void 0;
            else if (u.isFunction(object)) return object;
            else if (u.isString(object)) return findNamedAnimation(object);
            else if (u.isOptions(object)) return function(element, options) {
                return animateNow(element, object, options);
            };
            else return up.fail("Unknown animation %o", object);
        };
        swapElementsDirectly = function(oldElement, newElement) {
            return e.replace(oldElement, newElement);
        };
        /***
    Defines a named transition that [morphs](/up.element) from one element to another.
    
    \#\#\# Example
    
    Here is the definition of the pre-defined `cross-fade` animation:
    
        up.transition('cross-fade', (oldElement, newElement, options) ->
          Promise.all([
            up.animate(oldElement, 'fade-out', options),
            up.animate(newElement, 'fade-in', options)
          ])
        )
    
    It is recommended that your transitions use [`up.animate()`](/up.animate),
    passing along the `options` that were passed to you.
    
    If you choose to *not* use `up.animate()` and roll your own
    logic instead, your code must honor the following contract:
    
    1. It must honor the options `{ delay, duration, easing }` if given.
    2. It must *not* remove any of the given elements from the DOM.
    3. It returns a promise that is fulfilled when the transition has ended.
    4. If during the animation an event `up:motion:finish` is emitted on
       either element, the transition instantly jumps to the last frame
       and resolves the returned promise.
    
    Calling [`up.animate()`](/up.animate) with an object argument
    will take care of all these points.
    
    @function up.transition
    @param {string} name
    @param {Function(oldElement, newElement, options): Promise|Array} transition
    @stable
     */ registerTransition = function(name, transition) {
            return namedTransitions[name] = findTransitionFn(transition);
        };
        /***
    Defines a named animation.
    
    Here is the definition of the pre-defined `fade-in` animation:
    
        up.animation('fade-in', function(element, options) {
          element.style.opacity = 0
          up.animate(element, { opacity: 1 }, options)
        })
    
    It is recommended that your definitions always end by calling
    calling [`up.animate()`](/up.animate) with an object argument, passing along
    the `options` that were passed to you.
    
    If you choose to *not* use `up.animate()` and roll your own
    animation code instead, your code must honor the following contract:
    
    1. It must honor the options `{ delay, duration, easing }` if given
    2. It must *not* remove any of the given elements from the DOM.
    3. It returns a promise that is fulfilled when the transition has ended
    4. If during the animation an event `up:motion:finish` is emitted on
       the given element, the transition instantly jumps to the last frame
       and resolves the returned promise.
    
    Calling [`up.animate()`](/up.animate) with an object argument
    will take care of all these points.
    
    @function up.animation
    @param {string} name
    @param {Function(element, options): Promise} animation
    @stable
     */ registerAnimation = function(name, animation) {
            return namedAnimations[name] = findAnimationFn(animation);
        };
        snapshot = function() {
            defaultNamedAnimations = u.copy(namedAnimations);
            return defaultNamedTransitions = u.copy(namedTransitions);
        };
        /***
    Returns whether the given animation option will cause the animation
    to be skipped.
    
    @function up.motion.isNone
    @internal
     */ isNone = function(animationOrTransition) {
            return !animationOrTransition || animationOrTransition === "none" || u.isBlank(animationOrTransition);
        };
        registerAnimation("fade-in", function(element, options) {
            e.setStyle(element, {
                opacity: 0
            });
            return animateNow(element, {
                opacity: 1
            }, options);
        });
        registerAnimation("fade-out", function(element, options) {
            e.setStyle(element, {
                opacity: 1
            });
            return animateNow(element, {
                opacity: 0
            }, options);
        });
        translateCss = function(x, y) {
            return {
                transform: "translate(" + x + "px, " + y + "px)"
            };
        };
        registerAnimation("move-to-top", function(element, options) {
            var box, travelDistance;
            e.setStyle(element, translateCss(0, 0));
            box = element.getBoundingClientRect();
            travelDistance = box.top + box.height;
            return animateNow(element, translateCss(0, -travelDistance), options);
        });
        registerAnimation("move-from-top", function(element, options) {
            var box, travelDistance;
            e.setStyle(element, translateCss(0, 0));
            box = element.getBoundingClientRect();
            travelDistance = box.top + box.height;
            e.setStyle(element, translateCss(0, -travelDistance));
            return animateNow(element, translateCss(0, 0), options);
        });
        registerAnimation("move-to-bottom", function(element, options) {
            var box, travelDistance;
            e.setStyle(element, translateCss(0, 0));
            box = element.getBoundingClientRect();
            travelDistance = e.root().clientHeight - box.top;
            return animateNow(element, translateCss(0, travelDistance), options);
        });
        registerAnimation("move-from-bottom", function(element, options) {
            var box, travelDistance;
            e.setStyle(element, translateCss(0, 0));
            box = element.getBoundingClientRect();
            travelDistance = up.viewport.rootHeight() - box.top;
            e.setStyle(element, translateCss(0, travelDistance));
            return animateNow(element, translateCss(0, 0), options);
        });
        registerAnimation("move-to-left", function(element, options) {
            var box, travelDistance;
            e.setStyle(element, translateCss(0, 0));
            box = element.getBoundingClientRect();
            travelDistance = box.left + box.width;
            return animateNow(element, translateCss(-travelDistance, 0), options);
        });
        registerAnimation("move-from-left", function(element, options) {
            var box, travelDistance;
            e.setStyle(element, translateCss(0, 0));
            box = element.getBoundingClientRect();
            travelDistance = box.left + box.width;
            e.setStyle(element, translateCss(-travelDistance, 0));
            return animateNow(element, translateCss(0, 0), options);
        });
        registerAnimation("move-to-right", function(element, options) {
            var box, travelDistance;
            e.setStyle(element, translateCss(0, 0));
            box = element.getBoundingClientRect();
            travelDistance = up.viewport.rootWidth() - box.left;
            return animateNow(element, translateCss(travelDistance, 0), options);
        });
        registerAnimation("move-from-right", function(element, options) {
            var box, travelDistance;
            e.setStyle(element, translateCss(0, 0));
            box = element.getBoundingClientRect();
            travelDistance = up.viewport.rootWidth() - box.left;
            e.setStyle(element, translateCss(travelDistance, 0));
            return animateNow(element, translateCss(0, 0), options);
        });
        registerAnimation("roll-down", function(element, options) {
            var deferred, previousHeightStr, styleMemo;
            previousHeightStr = e.style(element, "height");
            styleMemo = e.setTemporaryStyle(element, {
                height: "0px",
                overflow: "hidden"
            });
            deferred = animate(element, {
                height: previousHeightStr
            }, options);
            deferred.then(styleMemo);
            return deferred;
        });
        registerTransition("move-left", [
            "move-to-left",
            "move-from-right"
        ]);
        registerTransition("move-right", [
            "move-to-right",
            "move-from-left"
        ]);
        registerTransition("move-up", [
            "move-to-top",
            "move-from-bottom"
        ]);
        registerTransition("move-down", [
            "move-to-bottom",
            "move-from-top"
        ]);
        registerTransition("cross-fade", [
            "fade-out",
            "fade-in"
        ]);
        up.on("up:framework:booted", snapshot);
        up.on("up:framework:reset", reset);
        return {
            morph: morph,
            animate: animate,
            animateOptions: animateOptions,
            finish: finish,
            finishCount: function() {
                return motionController.finishCount;
            },
            transition: registerTransition,
            animation: registerAnimation,
            config: config,
            isEnabled: isEnabled,
            isNone: isNone
        };
    }();
    up.transition = up.motion.transition;
    up.animation = up.motion.animation;
    up.morph = up.motion.morph;
    up.animate = up.motion.animate;
}).call(module.exports);
/***
AJAX acceleration
=================

Unpoly comes with a number of tricks to shorten the latency between browser and server.

\#\#\# Server responses are cached by default

Unpoly caches server responses for a few minutes,
making requests to these URLs return instantly.
All Unpoly functions and selectors go through this cache, unless
you explicitly pass a `{ cache: false }` option or set an `up-cache="false"` attribute.

The cache holds up to 70 responses for 5 minutes. You can configure the cache size and expiry using
[`up.proxy.config`](/up.proxy.config), or clear the cache manually using [`up.proxy.clear()`](/up.proxy.clear).

Also the entire cache is cleared with every non-`GET` request (like `POST` or `PUT`).

If you need to make cache-aware requests from your [custom JavaScript](/up.syntax),
use [`up.request()`](/up.request).

\#\#\# Preloading links

Unpoly also lets you speed up reaction times by [preloading
links](/a-up-preload) when the user hovers over the click area (or puts the mouse/finger
down). This way the response will already be cached when
the user releases the mouse/finger.

\#\#\# Spinners

You can listen to the [`up:proxy:slow`](/up:proxy:slow) event to implement a spinner
that appears during a long-running request.

\#\#\# More acceleration

Other Unpoly modules contain even more tricks to outsmart network latency:

- [Instantaneous feedback for links that are currently loading](/a.up-active)
- [Follow links on `mousedown` instead of `click`](/a-up-instant)

@module up.proxy
 */ (function() {
    var slice = [].slice;
    up.proxy = function() {
        var ajax, alias, cache, cancelPreloadDelay, cancelSlowDelay, clear, config, e, get, isBusy, isIdle, isSafeMethod, load, loadEnded, loadOrQueue, loadStarted, makeRequest, pendingCount, pokeQueue, preload, preloadAfterDelay, preloadDelayTimer, queue, queuedLoaders, registerAliasForRedirect, remove, reset, responseReceived, set, slowDelayTimer, slowEventEmitted, startPreloadDelay, stopPreload, u, waitingLink, wrapMethod;
        u = up.util;
        e = up.element;
        waitingLink = void 0;
        preloadDelayTimer = void 0;
        slowDelayTimer = void 0;
        pendingCount = void 0;
        slowEventEmitted = void 0;
        queuedLoaders = [];
        /***
    @property up.proxy.config
    @param {number} [config.preloadDelay=75]
      The number of milliseconds to wait before [`[up-preload]`](/a-up-preload)
      starts preloading.
    @param {number} [config.cacheSize=70]
      The maximum number of responses to cache.
      If the size is exceeded, the oldest items will be dropped from the cache.
    @param {number} [config.cacheExpiry=300000]
      The number of milliseconds until a cache entry expires.
      Defaults to 5 minutes.
    @param {number} [config.slowDelay=300]
      How long the proxy waits until emitting the [`up:proxy:slow` event](/up:proxy:slow).
      Use this to prevent flickering of spinners.
    @param {number} [config.maxRequests=4]
      The maximum number of concurrent requests to allow before additional
      requests are queued. This currently ignores preloading requests.
    
      You might find it useful to set this to `1` in full-stack integration
      tests (e.g. Selenium).
    
      Note that your browser might [impose its own request limit](http://www.browserscope.org/?category=network)
      regardless of what you configure here.
    @param {Array<string>} [config.wrapMethods]
      An array of uppercase HTTP method names. AJAX requests with one of these methods
      will be converted into a `POST` request and carry their original method as a `_method`
      parameter. This is to [prevent unexpected redirect behavior](https://makandracards.com/makandra/38347).
    @param {Array<string>} [config.safeMethods]
      An array of uppercase HTTP method names that are considered [safe](https://www.w3.org/Protocols/rfc2616/rfc2616-sec9.html#sec9.1.1).
      The proxy cache will only cache safe requests and will clear the entire
      cache after an unsafe request.
    @stable
     */ config = new up.Config({
            slowDelay: 300,
            preloadDelay: 75,
            cacheSize: 70,
            cacheExpiry: 300000,
            maxRequests: 4,
            wrapMethods: [
                "PATCH",
                "PUT",
                "DELETE"
            ],
            safeMethods: [
                "GET",
                "OPTIONS",
                "HEAD"
            ]
        });
        cache = new up.Cache({
            size: function() {
                return config.cacheSize;
            },
            expiry: function() {
                return config.cacheExpiry;
            },
            key: function(request) {
                return up.Request.wrap(request).cacheKey();
            },
            cachable: function(request) {
                return up.Request.wrap(request).isCachable();
            }
        });
        /***
    Returns a cached response for the given request.
    
    Returns `undefined` if the given request is not currently cached.
    
    @function up.proxy.get
    @return {Promise<up.Response>}
      A promise for the response.
    @experimental
     */ get = function(request) {
            var candidate, candidates, i, len, requestForBody, requestForHtml, response;
            request = up.Request.wrap(request);
            candidates = [
                request
            ];
            if (request.target !== "html") {
                requestForHtml = request.variant({
                    target: "html"
                });
                candidates.push(requestForHtml);
                if (request.target !== "body") {
                    requestForBody = request.variant({
                        target: "body"
                    });
                    candidates.push(requestForBody);
                }
            }
            for(i = 0, len = candidates.length; i < len; i++){
                candidate = candidates[i];
                if (response = cache.get(candidate)) return response;
            }
        };
        cancelPreloadDelay = function() {
            clearTimeout(preloadDelayTimer);
            return preloadDelayTimer = null;
        };
        cancelSlowDelay = function() {
            clearTimeout(slowDelayTimer);
            return slowDelayTimer = null;
        };
        reset = function() {
            waitingLink = null;
            cancelPreloadDelay();
            cancelSlowDelay();
            pendingCount = 0;
            config.reset();
            cache.clear();
            slowEventEmitted = false;
            return queuedLoaders = [];
        };
        reset();
        /***
    Makes an AJAX request to the given URL.
    
    \#\#\# Example
    
        up.request('/search', { params: { query: 'sunshine' } }).then(function(response) {
          console.log('The response text is %o', response.text)
        }).catch(function() {
          console.error('The request failed')
        })
    
    \#\#\# Caching
    
    All responses are cached by default. If requesting a URL with a non-`GET` method, the response will
    not be cached and the entire cache will be cleared.
    
    You can configure caching with the [`up.proxy.config`](/up.proxy.config) property.
    
    \#\#\# Events
    
    If a network connection is attempted, the proxy will emit
    a [`up:proxy:load`](/up:proxy:load) event with the `request` as its argument.
    Once the response is received, a [`up:proxy:loaded`](/up:proxy:loaded) event will
    be emitted.
    
    @function up.request
    @param {string} [url]
      The URL for the request.
    
      Instead of passing the URL as a string argument, you can also pass it as an `{ url }` option.
    @param {string} [options.url]
      You can omit the first string argument and pass the URL as
      a `request` property instead.
    @param {string} [options.method='GET']
      The HTTP method for the options.
    @param {boolean} [options.cache]
      Whether to use a cached response for [safe](https://www.w3.org/Protocols/rfc2616/rfc2616-sec9.html#sec9.1.1)
      requests, if available. If set to `false` a network connection will always be attempted.
    @param {Object} [options.headers={}]
      An object of additional HTTP headers.
    @param {Object|FormData|string|Array} [options.params={}]
      [Parameters](/up.Params) that should be sent as the request's payload.
    @param {string} [options.timeout]
      A timeout in milliseconds.
    
      If [`up.proxy.config.maxRequests`](/up.proxy.config#config.maxRequests) is set, the timeout
      will not include the time spent waiting in the queue.
    @param {string} [options.target='body']
      The CSS selector that will be sent as an [`X-Up-Target` header](/up.protocol#optimizing-responses).
    @param {string} [options.failTarget='body']
      The CSS selector that will be sent as an [`X-Up-Fail-Target` header](/up.protocol#optimizing-responses).
    @return {Promise<up.Response>}
      A promise for the response.
    @stable
     */ makeRequest = function() {
            var args, ignoreCache, promise, request, requestOrOptions, url;
            args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
            if (u.isString(args[0])) url = args.shift();
            requestOrOptions = args.shift() || {};
            if (url) requestOrOptions.url = url;
            request = up.Request.wrap(requestOrOptions);
            if (!request.isSafe()) clear();
            ignoreCache = request.cache === false;
            if (!ignoreCache && (promise = get(request))) up.puts("Re-using cached response for %s %s", request.method, request.url);
            else {
                promise = loadOrQueue(request);
                set(request, promise);
                promise["catch"](function() {
                    return remove(request);
                });
            }
            if (!request.preload) {
                loadStarted();
                u.always(promise, loadEnded);
            }
            return promise;
        };
        /***
    Makes an AJAX request to the given URL and caches the response.
    
    The function returns a promise that fulfills with the response text.
    
    \#\#\# Example
    
        up.request('/search', { params: { query: 'sunshine' } }).then(function(text) {
          console.log('The response text is %o', text)
        }).catch(function() {
          console.error('The request failed')
        })
    
    @function up.ajax
    @param {string} [url]
      The URL for the request.
    
      Instead of passing the URL as a string argument, you can also pass it as an `{ url }` option.
    @param {string} [request.url]
      You can omit the first string argument and pass the URL as
      a `request` property instead.
    @param {string} [request.method='GET']
      The HTTP method for the request.
    @param {boolean} [request.cache]
      Whether to use a cached response for [safe](https://www.w3.org/Protocols/rfc2616/rfc2616-sec9.html#sec9.1.1)
      requests, if available. If set to `false` a network connection will always be attempted.
    @param {Object} [request.headers={}]
      An object of additional header key/value pairs to send along
      with the request.
    @param {Object|FormData|string|Array} [options.params]
      [Parameters](/up.Params) that should be sent as the request's payload.
    
      On IE 11 and Edge, `FormData` payloads require a [polyfill for `FormData#entries()`](https://github.com/jimmywarting/FormData).
    @param {string} [request.timeout]
      A timeout in milliseconds for the request.
    
      If [`up.proxy.config.maxRequests`](/up.proxy.config#config.maxRequests) is set, the timeout
      will not include the time spent waiting in the queue.
    @return {Promise<string>}
      A promise for the response text.
    @deprecated
      Use [`up.request()`](/up.request) instead.
     */ ajax = function() {
            var args;
            args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
            up.legacy.warn("up.ajax() has been deprecated. Use up.request() instead.");
            return new Promise(function(resolve, reject) {
                var pickResponseText;
                pickResponseText = function(response) {
                    return resolve(response.text);
                };
                return makeRequest.apply(null, args).then(pickResponseText, reject);
            });
        };
        /***
    Returns `true` if the proxy is not currently waiting
    for a request to finish. Returns `false` otherwise.
    
    @function up.proxy.isIdle
    @return {boolean}
      Whether the proxy is idle
    @experimental
     */ isIdle = function() {
            return pendingCount === 0;
        };
        /***
    Returns `true` if the proxy is currently waiting
    for a request to finish. Returns `false` otherwise.
    
    @function up.proxy.isBusy
    @return {boolean}
      Whether the proxy is busy
    @experimental
     */ isBusy = function() {
            return pendingCount > 0;
        };
        loadStarted = function() {
            var emission;
            pendingCount += 1;
            if (!slowDelayTimer) {
                emission = function() {
                    if (isBusy()) {
                        up.emit("up:proxy:slow", {
                            log: "Proxy is slow to respond"
                        });
                        return slowEventEmitted = true;
                    }
                };
                return slowDelayTimer = u.timer(config.slowDelay, emission);
            }
        };
        /***
    This event is [emitted](/up.emit) when [AJAX requests](/up.request)
    are taking long to finish.
    
    By default Unpoly will wait 300 ms for an AJAX request to finish
    before emitting `up:proxy:slow`. You can configure this time like this:
    
        up.proxy.config.slowDelay = 150;
    
    Once all responses have been received, an [`up:proxy:recover`](/up:proxy:recover)
    will be emitted.
    
    Note that if additional requests are made while Unpoly is already busy
    waiting, **no** additional `up:proxy:slow` events will be triggered.
    
    
    \#\#\# Spinners
    
    You can [listen](/up.on) to the `up:proxy:slow`
    and [`up:proxy:recover`](/up:proxy:recover) events to implement a spinner
    that appears during a long-running request,
    and disappears once the response has been received:
    
        <div class="spinner">Please wait!</div>
    
    Here is the JavaScript to make it alive:
    
        up.compiler('.spinner', function(element) {
          show = () => { up.element.show(element) }
          hide = () => { up.element.hide(element) }
    
          hide()
    
          return [
            up.on('up:proxy:slow', show),
            up.on('up:proxy:recover', hide)
          ]
        })
    
    The `up:proxy:slow` event will be emitted after a delay of 300 ms
    to prevent the spinner from flickering on and off.
    You can change (or remove) this delay by [configuring `up.proxy`](/up.proxy.config) like this:
    
        up.proxy.config.slowDelay = 150;
    
    
    @event up:proxy:slow
    @stable
     */ loadEnded = function() {
            pendingCount -= 1;
            if (isIdle()) {
                cancelSlowDelay();
                if (slowEventEmitted) {
                    up.emit("up:proxy:recover", {
                        log: "Proxy has recovered from slow response"
                    });
                    return slowEventEmitted = false;
                }
            }
        };
        /***
    This event is [emitted](/up.emit) when [AJAX requests](/up.request)
    have [taken long to finish](/up:proxy:slow), but have finished now.
    
    See [`up:proxy:slow`](/up:proxy:slow) for more documentation on
    how to use this event for implementing a spinner that shows during
    long-running requests.
    
    @event up:proxy:recover
    @stable
     */ loadOrQueue = function(request) {
            if (pendingCount < config.maxRequests) return load(request);
            else return queue(request);
        };
        queue = function(request) {
            var loader;
            up.puts("Queuing request for %s %s", request.method, request.url);
            loader = function() {
                return load(request);
            };
            loader = u.previewable(loader);
            queuedLoaders.push(loader);
            return loader.promise;
        };
        load = function(request) {
            var eventProps, responsePromise;
            eventProps = {
                request: request,
                log: [
                    "Loading %s %s",
                    request.method,
                    request.url
                ]
            };
            if (up.event.nobodyPrevents("up:proxy:load", eventProps)) {
                responsePromise = request.send();
                u.always(responsePromise, responseReceived);
                u.always(responsePromise, pokeQueue);
                return responsePromise;
            } else {
                u.microtask(pokeQueue);
                return Promise.reject(new Error("Event up:proxy:load was prevented"));
            }
        };
        /***
    This event is [emitted](/up.emit) before an [AJAX request](/up.request)
    is sent over the network.
    
    @event up:proxy:load
    @param {up.Request} event.request
    @param event.preventDefault()
      Event listeners may call this method to prevent the request from being sent.
    @experimental
     */ registerAliasForRedirect = function(response) {
            var newRequest, request;
            request = response.request;
            if (response.url && request.url !== response.url) {
                newRequest = request.variant({
                    method: response.method,
                    url: response.url
                });
                return up.proxy.alias(request, newRequest);
            }
        };
        responseReceived = function(response) {
            if (response.isFatalError()) return up.emit("up:proxy:fatal", {
                log: "Fatal error during request",
                request: response.request,
                response: response
            });
            else {
                if (!response.isError()) registerAliasForRedirect(response);
                return up.emit("up:proxy:loaded", {
                    log: [
                        "Server responded with HTTP %d (%d bytes)",
                        response.status,
                        response.text.length
                    ],
                    request: response.request,
                    response: response
                });
            }
        };
        /***
    This event is [emitted](/up.emit) when the response to an
    [AJAX request](/up.request) has been received.
    
    Note that this event will also be emitted when the server signals an
    error with an HTTP status like `500`. Only if the request
    encounters a fatal error (like a loss of network connectivity),
    [`up:proxy:fatal`](/up:proxy:fatal) is emitted instead.
    
    @event up:proxy:loaded
    @param {up.Request} event.request
    @param {up.Response} event.response
    @experimental
     */ /***
    This event is [emitted](/up.emit) when an [AJAX request](/up.request)
    encounters fatal error like a timeout or loss of network connectivity.
    
    Note that this event will *not* be emitted when the server produces an
    error message with an HTTP status like `500`. When the server can produce
    any response, [`up:proxy:loaded`](/up:proxy:loaded) is emitted instead.
    
    @event up:proxy:fatal
     */ pokeQueue = function() {
            var base;
            if (typeof (base = queuedLoaders.shift()) === "function") base();
            return void 0;
        };
        /***
    Makes the proxy assume that `newRequest` has the same response as the
    already cached `oldRequest`.
    
    Unpoly uses this internally when the user redirects from `/old` to `/new`.
    In that case, both `/old` and `/new` will cache the same response from `/new`.
    
    @function up.proxy.alias
    @param {Object} oldRequest
    @param {Object} newRequest
    @experimental
     */ alias = cache.alias;
        /***
    Manually stores a promise for the response to the given request.
    
    @function up.proxy.set
    @param {string} request.url
    @param {string} [request.method='GET']
    @param {string} [request.target='body']
    @param {Promise<up.Response>} response
      A promise for the response.
    @experimental
     */ set = cache.set;
        /***
    Manually removes the given request from the cache.
    
    You can also [configure](/up.proxy.config) when the proxy
    automatically removes cache entries.
    
    @function up.proxy.remove
    @param {string} request.url
    @param {string} [request.method='GET']
    @param {string} [request.target='body']
    @experimental
     */ remove = cache.remove;
        /***
    Removes all cache entries.
    
    Unpoly also automatically clears the cache whenever it processes
    a request with an [unsafe](https://www.w3.org/Protocols/rfc2616/rfc2616-sec9.html#sec9.1.1)
    HTTP method like `POST`.
    
    @function up.proxy.clear
    @stable
     */ clear = cache.clear;
        preloadAfterDelay = function(link) {
            var curriedPreload, delay;
            delay = e.numberAttr(link, "up-delay") || config.preloadDelay;
            if (link !== waitingLink) {
                waitingLink = link;
                cancelPreloadDelay();
                curriedPreload = function() {
                    u.muteRejection(preload(link));
                    return waitingLink = null;
                };
                return startPreloadDelay(curriedPreload, delay);
            }
        };
        startPreloadDelay = function(block, delay) {
            return preloadDelayTimer = setTimeout(block, delay);
        };
        stopPreload = function(link) {
            if (link === waitingLink) {
                waitingLink = void 0;
                return cancelPreloadDelay();
            }
        };
        /***
    Preloads the given link.
    
    When the link is clicked later, the response will already be cached,
    making the interaction feel instant.
    
    @function up.proxy.preload
    @param {string|Element|jQuery} linkOrSelector
      The element whose destination should be preloaded.
    @param {Object} options
      Options that will be passed to the function making the HTTP requests.
    @return
      A promise that will be fulfilled when the request was loaded and cached
    @experimental
     */ preload = function(linkOrSelector, options) {
            var link, preloadEventAttrs;
            link = e.get(linkOrSelector);
            if (up.link.isSafe(link)) {
                preloadEventAttrs = {
                    log: [
                        "Preloading link %o",
                        link
                    ],
                    target: link
                };
                return up.event.whenEmitted("up:link:preload", preloadEventAttrs).then(function() {
                    var variant;
                    variant = up.link.followVariantForLink(link);
                    return variant.preloadLink(link, options);
                });
            } else return Promise.reject(new Error("Won't preload unsafe link"));
        };
        /***
    This event is [emitted](/up.emit) before a link is [preloaded](/up.preload).
    
    @event up:link:preload
    @param {Element} event.target
      The link element that will be preloaded.
    @param event.preventDefault()
      Event listeners may call this method to prevent the link from being preloaded.
    @stable
     */ /***
    @internal
     */ isSafeMethod = function(method) {
            return u.contains(config.safeMethods, method);
        };
        /***
    @internal
     */ wrapMethod = function(method, params) {
            if (u.contains(config.wrapMethods, method)) {
                params.add(up.protocol.config.methodParam, method);
                method = "POST";
            }
            return method;
        };
        /***
    Links with an `up-preload` attribute will silently fetch their target
    when the user hovers over the click area, or when the user puts her
    mouse/finger down (before releasing).
    
    When the link is clicked later, the response will already be cached,
    making the interaction feel instant.   
    
    @selector a[up-preload]
    @param [up-delay=75]
      The number of milliseconds to wait between hovering
      and preloading. Increasing this will lower the load in your server,
      but will also make the interaction feel less instant.
    @stable
     */ up.compiler("a[up-preload], [up-href][up-preload]", function(link) {
            if (up.link.isSafe(link)) {
                link.addEventListener("mouseenter", function(event) {
                    if (up.link.shouldProcessEvent(event, link)) return preloadAfterDelay(link);
                });
                return link.addEventListener("mouseleave", function() {
                    return stopPreload(link);
                });
            }
        });
        up.on("up:framework:reset", reset);
        return {
            preload: preload,
            ajax: ajax,
            request: makeRequest,
            get: get,
            alias: alias,
            clear: clear,
            remove: remove,
            isIdle: isIdle,
            isBusy: isBusy,
            isSafeMethod: isSafeMethod,
            wrapMethod: wrapMethod,
            config: config
        };
    }();
    up.ajax = up.proxy.ajax;
    up.request = up.proxy.request;
}).call(module.exports);
/***
Linking to fragments
====================

The `up.link` module lets you build links that update fragments instead of entire pages.

\#\#\# Motivation

In a traditional web application, the entire page is destroyed and re-created when the
user follows a link:

![Traditional page flow](/images/tutorial/fragment_flow_vanilla.svg){:width="620" class="picture has_border is_sepia has_padding"}

This makes for an unfriendly experience:

- State changes caused by AJAX updates get lost during the page transition.
- Unsaved form changes get lost during the page transition.
- The JavaScript VM is reset during the page transition.
- If the page layout is composed from multiple scrollable containers
  (e.g. a pane view), the scroll positions get lost during the page transition.
- The user sees a "flash" as the browser loads and renders the new page,
  even if large portions of the old and new page are the same (navigation, layout, etc.).

Unpoly fixes this by letting you annotate links with an [`up-target`](/a-up-target)
attribute. The value of this attribute is a CSS selector that indicates which page
fragment to update. The server **still renders full HTML pages**, but we only use
the targeted fragments and discard the rest:

![Unpoly page flow](/images/tutorial/fragment_flow_unpoly.svg){:width="620" class="picture has_border is_sepia has_padding"}

With this model, following links feels smooth. All transient DOM changes outside the updated fragment are preserved.
Pages also load much faster since the DOM, CSS and Javascript environments do not need to be
destroyed and recreated for every request.


\#\#\# Example

Let's say we are rendering three pages with a tabbed navigation to switch between screens:

Your HTML could look like this:

```
<nav>
  <a href="/pages/a">A</a>
  <a href="/pages/b">B</a>
  <a href="/pages/b">C</a>
</nav>

<article>
  Page A
</article>
```

Since we only want to update the `<article>` tag, we annotate the links
with an `up-target` attribute:

```
<nav>
  <a href="/pages/a" up-target="article">A</a>
  <a href="/pages/b" up-target="article">B</a>
  <a href="/pages/b" up-target="article">C</a>
</nav>
```

Note that instead of `article` you can use any other CSS selector like `#main .article`.

With these [`up-target`](/a-up-target) annotations Unpoly only updates the targeted part of the screen.
The JavaScript environment will persist and the user will not see a white flash while the
new page is loading.

@module up.link
 */ (function() {
    up.link = function() {
        var DEFAULT_FOLLOW_VARIANT, addFollowVariant, allowDefault, defaultFollow, defaultPreload, e, follow, followMethod, followVariantForLink, followVariants, isFollowable, isSafe, makeFollowable, shouldProcessEvent, u, visit;
        u = up.util;
        e = up.element;
        /***
    Fetches this given URL with JavaScript and [replaces](/up.replace) the
    current `<body>` element with the response's `<body>` element.
    
    \#\#\# Example
    
    This would replace the current page with the response for `/users`:
    
        up.visit('/users')
    
    @function up.visit
    @param {string} url
      The URL to visit.
    @param {string} [options.target='body']
      The selector to replace.
    @param {Object} [options]
      See options for [`up.replace()`](/up.replace)
    @stable
     */ visit = function(url, options) {
            var ref, selector;
            if (options == null) options = {};
            selector = (ref = options.target) != null ? ref : "body";
            return up.replace(selector, url, options);
        };
        /***
    Fetches the given link's `[href]` with JavaScript and [replaces](/up.replace) the current page with HTML from the response.
    
    By default the page's `<body>` element will be replaced.
    If the link has an attribute like `a[up-target]`
    or `a[up-modal]`, the respective Unpoly behavior will be used.
    
    Emits the event `up:link:follow`.
    
    \#\#\# Examples
    
    Assume we have a link with an `a[up-target]` attribute:
    
        <a href="/users" up-target=".main">Users</a>
    
    Calling `up.follow()` with this link will replace the page's `.main` fragment
    as if the user had clicked on the link:
    
        var link = document.querySelector('a')
        up.follow(link)
    
    @function up.follow
    @param {Element|jQuery|string} linkOrSelector
      An element or selector which is either an `<a>` tag or any element with an `[up-href]` attribute.
    @param {string} [options.target]
      The selector to replace.
    
      Defaults to the link's `[up-target]`, `[up-modal]` or `[up-popup]` attribute.
      If no target is given, the `<body>` element will be replaced.
    @param {String} [options.url]
      The URL to navigate to.
    
      Defaults to the link's `[up-href]` or `[href]` attribute.
    @param {boolean|string} [options.reveal=true]
      Whether to [reveal](/up.reveal) the target fragment after it was replaced.
    
      You can also pass a CSS selector for the element to reveal.
    @param {boolean|string} [options.failReveal=true]
      Whether to [reveal](/up.reveal) the target fragment when the server responds with an error.
    
      You can also pass a CSS selector for the element to reveal.
    @return {Promise}
      A promise that will be fulfilled when the link destination
      has been loaded and rendered.
    @stable
     */ follow = function(linkOrSelector, options) {
            var link, variant;
            link = e.get(linkOrSelector);
            variant = followVariantForLink(link);
            return variant.followLink(link, options);
        };
        /***
    This event is [emitted](/up.emit) when a link is [followed](/up.follow) through Unpoly.
    
    The event is emitted on the `<a>` element that is being followed.
    
    @event up:link:follow
    @param {Element} event.target
      The link element that will be followed.
    @param event.preventDefault()
      Event listeners may call this method to prevent the link from being followed.
    @stable
     */ /***
    @function defaultFollow
    @internal
     */ defaultFollow = function(link, options) {
            var ref, ref1, ref2, ref3, ref4, target, url;
            options = u.options(options);
            url = (ref = (ref1 = options.url) != null ? ref1 : link.getAttribute("up-href")) != null ? ref : link.getAttribute("href");
            target = (ref2 = options.target) != null ? ref2 : link.getAttribute("up-target");
            if (options.failTarget == null) options.failTarget = link.getAttribute("up-fail-target");
            if (options.fallback == null) options.fallback = link.getAttribute("up-fallback");
            if (options.transition == null) options.transition = e.booleanOrStringAttr(link, "up-transition");
            if (options.failTransition == null) options.failTransition = e.booleanOrStringAttr(link, "up-fail-transition");
            if (options.history == null) options.history = e.booleanOrStringAttr(link, "up-history");
            if (options.reveal == null) options.reveal = (ref3 = e.booleanOrStringAttr(link, "up-reveal")) != null ? ref3 : true;
            if (options.failReveal == null) options.failReveal = (ref4 = e.booleanOrStringAttr(link, "up-fail-reveal")) != null ? ref4 : true;
            if (options.cache == null) options.cache = e.booleanAttr(link, "up-cache");
            if (options.restoreScroll == null) options.restoreScroll = e.booleanAttr(link, "up-restore-scroll");
            options.method = followMethod(link, options);
            if (options.origin == null) options.origin = link;
            if (options.layer == null) options.layer = link.getAttribute("up-layer");
            if (options.failLayer == null) options.failLayer = link.getAttribute("up-fail-layer");
            if (options.confirm == null) options.confirm = link.getAttribute("up-confirm");
            if (options.scrollBehavior == null) options.scrollBehavior = link.getAttribute("up-scroll-behavior");
            if (options.scrollSpeed == null) options.scrollSpeed = link.getAttribute("up-scroll-speed");
            options = u.merge(options, up.motion.animateOptions(options, link));
            return up.browser.whenConfirmed(options).then(function() {
                return up.replace(target, url, options);
            });
        };
        defaultPreload = function(link, options) {
            options = u.options(options);
            options.preload = true;
            return defaultFollow(link, options);
        };
        /***
    Returns the HTTP method that should be used when following the given link.
    
    Looks at the link's `up-method` or `data-method` attribute.
    Defaults to `"get"`.
    
    @function up.link.followMethod
    @param link
    @param options.method {string}
    @internal
     */ followMethod = function(link, options) {
            var rawMethod, ref, ref1, ref2;
            if (options == null) options = {};
            rawMethod = (ref = (ref1 = (ref2 = options.method) != null ? ref2 : link.getAttribute("up-method")) != null ? ref1 : link.getAttribute("data-method")) != null ? ref : "GET";
            return rawMethod.toUpperCase();
        };
        /***
    No-op that is called when we allow a browser's default action to go through,
    so we can spy on it in unit tests. See `link_spec.js`.
    
    @function allowDefault
    @internal
     */ allowDefault = function(event) {};
        followVariants = [];
        /***
    Registers the given handler for links with the given selector.
    
    This does more than a simple `click` handler:
    
    - It also handles `[up-instant]`
    - It also handles `[up-href]`
    
    @function up.link.addFollowVariant
    @param {string} simplifiedSelector
      A selector without `a` or `[up-href]`, e.g. `[up-target]`
    @param {Function(element, options)} options.follow
    @param {Function(element, options)} options.preload
    @internal
     */ addFollowVariant = function(simplifiedSelector, options) {
            var variant;
            variant = new up.FollowVariant(simplifiedSelector, options);
            followVariants.push(variant);
            variant.registerEvents();
            return variant;
        };
        /***
    Returns whether the given link will be [followed](/up.follow) by Unpoly
    instead of making a full page load.
    
    A link will be followed by Unpoly if it has an attribute
    like `a[up-target]` or `a[up-modal]`.
    
    @function up.link.isFollowable
    @param {Element|jQuery|string} linkOrSelector
      The link to check.
    @experimental
     */ isFollowable = function(linkOrSelector) {
            linkOrSelector = e.get(linkOrSelector);
            return !!followVariantForLink(linkOrSelector, {
                "default": false
            });
        };
        /***
    Returns the handler function that can be used to follow the given link.
    E.g. it wil return a handler calling `up.modal.follow` if the link is a `[up-modal]`,
    but a handler calling `up.link.follow` if the links is `[up-target]`.
    
    @param {Element} link
    @return {Object}
    @internal
     */ followVariantForLink = function(link, options) {
            var variant;
            if (options == null) options = {};
            variant = u.find(followVariants, function(variant) {
                return variant.matchesLink(link);
            });
            if (options["default"] !== false) variant || (variant = DEFAULT_FOLLOW_VARIANT);
            return variant;
        };
        /***
    Makes sure that the given link will be [followed](/up.follow)
    by Unpoly instead of making a full page load.
    
    This is done by giving the link an `a[up-follow]` attribute
    unless it already have it an attribute like `a[up-target]` or `a[up-modal]`.
    
    @function up.link.makeFollowable
    @param {Element|jQuery|string} linkOrSelector
      The link to process.
    @experimental
     */ makeFollowable = function(link) {
            if (!isFollowable(link)) return link.setAttribute("up-follow", "");
        };
        shouldProcessEvent = function(event, link) {
            var betterTarget, betterTargetSelector, target;
            target = event.target;
            if (!u.isUnmodifiedMouseEvent(event)) return false;
            if (target === link) return true;
            betterTargetSelector = "a, [up-href], " + up.form.fieldSelector();
            betterTarget = e.closest(target, betterTargetSelector);
            return !betterTarget || betterTarget === link;
        };
        /***
    Returns whether the given link has a [safe](https://www.w3.org/Protocols/rfc2616/rfc2616-sec9.html#sec9.1.1)
    HTTP method like `GET`.
    
    @function up.link.isSafe
    @experimental
     */ isSafe = function(selectorOrLink, options) {
            var method;
            method = followMethod(selectorOrLink, options);
            return up.proxy.isSafeMethod(method);
        };
        /***
    [Follows](/up.follow) this link with JavaScript and replaces a CSS selector
    on the current page with a corresponding element from the response.
    
    \#\#\# Example
    
    This will update the fragment `<div class="main">` with the same element
    fetched from `/posts/5`:
    
        <a href="/posts/5" up-target=".main">Read post</a>
    
    \#\#\# Updating multiple fragments
    
    You can update multiple fragments from a single request by separating
    separators with a comma (like in CSS).
    
    For instance, if opening a post should
    also update a bubble showing the number of unread posts, you might
    do this:
    
        <a href="/posts/5" up-target=".main, .unread-count">Read post</a>
    
    \#\#\# Appending or prepending content
    
    By default Unpoly will replace the given selector with the same
    selector from the server response. Instead of replacing you
    can *append* the loaded content to the existing content by using the
    `:after` pseudo selector. In the same fashion, you can use `:before`
    to indicate that you would like the *prepend* the loaded content.
    
    A practical example would be a paginated list of items. Below the list is
    a button to load the next page. You can append to the existing list
    by using `:after` in the `up-target` selector like this:
    
        <ul class="tasks">
          <li>Wash car</li>
          <li>Purchase supplies</li>
          <li>Fix tent</li>
        </ul>
    
        <a href="/page/2" class="next-page" up-target=".tasks:after, .next-page">
          Load more tasks
        </a>
    
    \#\#\# Following elements that are no links
    
    You can also use `[up-target]` to turn an arbitrary element into a link.
    In this case, put the link's destination into the `[up-href]` attribute:
    
        <button up-target=".main" up-href="/foo/bar">Go</button>
    
    Note that using any element other than `<a>` will prevent users from
    opening the destination in a new tab.
    
    @selector a[up-target]
    @param {string} up-target
      The CSS selector to replace
    
      Inside the CSS selector you may refer to this link as `&` ([like in Sass](https://sass-lang.com/documentation/file.SASS_REFERENCE.html#parent-selector)).
    @param {string} [up-method='get']
      The HTTP method to use for the request.
    @param {string} [up-transition='none']
      The [transition](/up.motion) to use for morphing between the old and new elements.
    @param [up-fail-target='body']
      The CSS selector to replace if the server responds with an error.
    
      Inside the CSS selector you may refer to this link as `&` ([like in Sass](https://sass-lang.com/documentation/file.SASS_REFERENCE.html#parent-selector)).
    @param {string} [up-fail-transition='none']
      The [transition](/up.motion) to use for morphing between the old and new elements
      when the server responds with an error.
    @param {string} [up-fallback]
      The selector to update when the original target was not found in the page.
    @param {string} [up-href]
      The destination URL to follow.
      If omitted, the the link's `href` attribute will be used.
    @param {string} [up-confirm]
      A message that will be displayed in a cancelable confirmation dialog
      before the link is followed.
    @param {string} [up-reveal='true']
      Whether to reveal the target element after it was replaced.
    
      You can also pass a CSS selector for the element to reveal.
      Inside the CSS selector you may refer to this link as `&` ([like in Sass](https://sass-lang.com/documentation/file.SASS_REFERENCE.html#parent-selector)).
    @param {string} [up-fail-reveal='true']
      Whether to reveal the target element when the server responds with an error.
    
      You can also pass a CSS selector for the element to reveal.
      Inside the CSS selector you may refer to this link as `&` ([like in Sass](https://sass-lang.com/documentation/file.SASS_REFERENCE.html#parent-selector)).
    @param {string} [up-restore-scroll='false']
      Whether to restore previously known scroll position of all viewports
      within the target selector.
    @param {string} [up-cache]
      Whether to force the use of a cached response (`true`)
      or never use the cache (`false`)
      or make an educated guess (default).
    @param {string} [up-layer='auto']
      The name of the layer that ought to be updated. Valid values are
      `'auto'`, `'page'`, `'modal'` and `'popup'`.
    
      If set to `'auto'` (default), Unpoly will try to find a match in the link's layer.
      If no match was found in that layer,
      Unpoly will search in other layers, starting from the topmost layer.
    @param {string} [up-fail-layer='auto']
      The name of the layer that ought to be updated if the server sends a
      non-200 status code.
    @param [up-history]
      Whether to push an entry to the browser history when following the link.
    
      Set this to `'false'` to prevent the URL bar from being updated.
      Set this to a URL string to update the history with the given URL.
    @stable
     */ DEFAULT_FOLLOW_VARIANT = addFollowVariant("[up-target], [up-follow]", {
            follow: function(link, options) {
                return defaultFollow(link, options);
            },
            preload: function(link, options) {
                return defaultPreload(link, options);
            }
        });
        /***
    Fetches this link's `[href]` with JavaScript and [replaces](/up.replace) the
    current `<body>` element with the response's `<body>` element.
    
    To only update a fragment instead of the entire `<body>`, see `a[up-target]`.
    
    \#\#\# Example
    
        <a href="/users" up-follow>User list</a>
    
    \#\#\# Turn any element into a link
    
    You can also use `[up-follow]` to turn an arbitrary element into a link.
    In this case, put the link's destination into the `up-href` attribute:
    
        <span up-follow up-href="/foo/bar">Go</span>
    
    Note that using any element other than `<a>` will prevent users from
    opening the destination in a new tab.
    
    @selector a[up-follow]
    
    @param {string} [up-method='get']
      The HTTP method to use for the request.
    @param [up-fail-target='body']
      The selector to replace if the server responds with an error.
    @param {string} [up-fallback]
      The selector to update when the original target was not found in the page.
    @param {string} [up-transition='none']
      The [transition](/up.motion) to use for morphing between the old and new elements.
    @param {string} [up-fail-transition='none']
      The [transition](/up.motion) to use for morphing between the old and new elements
      when the server responds with an error.
    @param [up-href]
      The destination URL to follow.
      If omitted, the the link's `href` attribute will be used.
    @param {string} [up-confirm]
      A message that will be displayed in a cancelable confirmation dialog
      before the link is followed.
    @param {string} [up-history]
      Whether to push an entry to the browser history when following the link.
    
      Set this to `'false'` to prevent the URL bar from being updated.
      Set this to a URL string to update the history with the given URL.
    @param [up-restore-scroll='false']
      Whether to restore the scroll position of all viewports
      within the response.
    @stable
     */ /***
    By adding an `up-instant` attribute to a link, the destination will be
    fetched on `mousedown` instead of `click` (`mouseup`).
    
        <a href="/users" up-target=".main" up-instant>User list</a>
    
    This will save precious milliseconds that otherwise spent
    on waiting for the user to release the mouse button. Since an
    AJAX request will be triggered right way, the interaction will
    appear faster.
    
    Note that using `[up-instant]` will prevent a user from canceling a
    click by moving the mouse away from the link. However, for
    navigation actions this isn't needed. E.g. popular operation
    systems switch tabs on `mousedown` instead of `click`.
    
    `[up-instant]` will also work for links that open [modals](/up.modal) or [popups](/up.popup).
    
    @selector a[up-instant]
    @stable
     */ /***
    [Follows](/up.follow) this link *as fast as possible*.
    
    This is done by:
    
    - [Following the link through AJAX](/a-up-target) instead of a full page load
    - [Preloading the link's destination URL](/a-up-preload)
    - [Triggering the link on `mousedown`](/a-up-instant) instead of on `click`
    
    \#\#\# Example
    
    Use `up-dash` like this:
    
        <a href="/users" up-dash=".main">User list</a>
    
    This is shorthand for:
    
        <a href="/users" up-target=".main" up-instant up-preload>User list</a>
    
    @selector a[up-dash]
    @param {string} [up-dash='body']
      The CSS selector to replace
    
      Inside the CSS selector you may refer to this link as `&` ([like in Sass](https://sass-lang.com/documentation/file.SASS_REFERENCE.html#parent-selector)).
    @stable
     */ up.macro("[up-dash]", function(element) {
            var newAttrs, target;
            target = e.booleanOrStringAttr(element, "up-dash");
            element.removeAttribute("up-dash");
            newAttrs = {
                "up-preload": "",
                "up-instant": ""
            };
            if (target === true) makeFollowable(element);
            else newAttrs["up-target"] = target;
            return e.setMissingAttrs(element, newAttrs);
        });
        /***
    Add an `[up-expand]` attribute to any element to enlarge the click area of a
    descendant link.
    
    `[up-expand]` honors all the Unppoly attributes in expanded links, like
    `a[up-target]`, `a[up-instant]` or `a[up-preload]`.
    It also expands links that open [modals](/up.modal) or [popups](/up.popup).
    
    
    \#\#\# Example
    
        <div class="notification" up-expand>
          Record was saved!
          <a href="/records">Close</a>
        </div>
    
    In the example above, clicking anywhere within `.notification` element
    would [follow](/up.follow) the *Close* link.
    
    \#\#\# Elements with multiple contained links
    
    If a container contains more than one link, you can set the value of the
    `up-expand` attribute to a CSS selector to define which link should be expanded:
    
        <div class="notification" up-expand=".close">
          Record was saved!
          <a class="details" href="/records/5">Details</a>
          <a class="close" href="/records">Close</a>
        </div>
    
    \#\#\# Limitations
    
    `[up-expand]` has some limitations for advanced browser users:
    
    - Users won't be able to right-click the expanded area to open a context menu
    - Users won't be able to `CTRL`+click the expanded area to open a new tab
    
    To overcome these limitations, consider nesting the entire clickable area in an actual `<a>` tag.
    [It's OK to put block elements inside an anchor tag](https://makandracards.com/makandra/43549-it-s-ok-to-put-block-elements-inside-an-a-tag).
    
    @selector [up-expand]
    @param {string} [up-expand]
      A CSS selector that defines which containing link should be expanded.
    
      If omitted, the first link in this element will be expanded.
    @stable
     */ up.macro("[up-expand]", function(area) {
            var attribute, childLink, childLinks, i, len, name, newAttrs, ref, selector, upAttributePattern;
            selector = area.getAttribute("up-expand") || "a, [up-href]";
            childLinks = e.all(area, selector);
            if (childLink = childLinks[0]) {
                upAttributePattern = /^up-/;
                newAttrs = {};
                newAttrs["up-href"] = childLink.getAttribute("href");
                ref = childLink.attributes;
                for(i = 0, len = ref.length; i < len; i++){
                    attribute = ref[i];
                    name = attribute.name;
                    if (name.match(upAttributePattern)) newAttrs[name] = attribute.value;
                }
                e.setMissingAttrs(area, newAttrs);
                area.removeAttribute("up-expand");
                return makeFollowable(area);
            }
        });
        return {
            visit: visit,
            follow: follow,
            makeFollowable: makeFollowable,
            isSafe: isSafe,
            isFollowable: isFollowable,
            shouldProcessEvent: shouldProcessEvent,
            followMethod: followMethod,
            addFollowVariant: addFollowVariant,
            followVariantForLink: followVariantForLink,
            allowDefault: allowDefault
        };
    }();
    up.visit = up.link.visit;
    up.follow = up.link.follow;
}).call(module.exports);
/***
Forms
=====
  
Unpoly comes with functionality to [submit](/form-up-target) and [validate](/input-up-validate)
forms without leaving the current page. This means you can replace page fragments,
open dialogs with sub-forms, etc. all without losing form state.

@module up.form
 */ (function() {
    var slice = [].slice;
    up.form = function() {
        var autosubmit, closestContainer, config, e, fieldSelector, findFields, findSubmissionFields, findSwitcherForTarget, findValidateTarget, observe, observeCallbackFromElement, reset, submit, submitButtonSelector, submittingButton, switchTarget, switchTargets, switcherValues, u, validate;
        u = up.util;
        e = up.element;
        /***
    Sets default options for form submission and validation.
    
    @property up.form.config
    @param {number} [config.observeDelay=0]
      The number of miliseconds to wait before [`up.observe()`](/up.observe) runs the callback
      after the input value changes. Use this to limit how often the callback
      will be invoked for a fast typist.
    @param {Array} [config.validateTargets=['[up-fieldset]:has(&)', 'fieldset:has(&)', 'label:has(&)', 'form:has(&)']]
      An array of CSS selectors that are searched around a form field
      that wants to [validate](/up.validate). The first matching selector
      will be updated with the validation messages from the server.
    
      By default this looks for a `<fieldset>`, `<label>` or `<form>`
      around the validating input field.
    @param {string} [config.fields]
      An array of CSS selectors that represent form fields, such as `input` or `select`.
    @param {string} [config.submitButtons]
      An array of CSS selectors that represent submit buttons, such as `input[type=submit]`.
    @stable
     */ config = new up.Config({
            validateTargets: [
                "[up-fieldset]:has(&)",
                "fieldset:has(&)",
                "label:has(&)",
                "form:has(&)"
            ],
            fields: [
                "select",
                "input:not([type=submit]):not([type=image])",
                "button[type]:not([type=submit])",
                "textarea"
            ],
            submitButtons: [
                "input[type=submit]",
                "input[type=image]",
                "button[type=submit]",
                "button:not([type])"
            ],
            observeDelay: 0
        });
        reset = function() {
            return config.reset();
        };
        /***
    @function up.form.fieldSelector
    @internal
     */ fieldSelector = function(suffix) {
            if (suffix == null) suffix = "";
            return config.fields.map(function(field) {
                return field + suffix;
            }).join(",");
        };
        /***
    Returns a list of form fields within the given element.
    
    You can configure what Unpoly considers a form field by adding CSS selectors to the
    [`up.form.config.fields`](/up.form.config#config.fields) array.
    
    If the given element is itself a form field, a list of that given element is returned.
    
    @function up.form.fields
    @param {Element|jQuery} root
      The element to scan for contained form fields.
    
      If the element is itself a form field, a list of that element is returned.
    @return {NodeList<Element>|Array<Element>}
    @experimental
     */ findFields = function(root) {
            var fields, outsideFieldSelector, outsideFields;
            root = e.get(root);
            fields = e.subtree(root, fieldSelector());
            if (e.matches(root, "form[id]")) {
                outsideFieldSelector = fieldSelector(e.attributeSelector("form", root.id));
                outsideFields = e.all(outsideFieldSelector);
                fields.push.apply(fields, outsideFields);
                fields = u.uniq(fields);
            }
            return fields;
        };
        /****
    @function up.form.submissionFields
    @internal
     */ findSubmissionFields = function(root) {
            var button, fields;
            fields = findFields(root);
            if (button = submittingButton(root)) {
                fields = u.toArray(fields);
                fields.push(button);
            }
            return fields;
        };
        /***
    @function up.form.submittingButton
    @internal
     */ submittingButton = function(form) {
            var focusedElement, selector;
            selector = submitButtonSelector();
            focusedElement = document.activeElement;
            if (focusedElement && e.matches(focusedElement, selector) && form.contains(focusedElement)) return focusedElement;
            else return e.first(form, selector);
        };
        /***
    @function up.form.submitButtonSelector
    @internal
     */ submitButtonSelector = function() {
            return config.submitButtons.join(",");
        };
        /***
    Submits a form via AJAX and updates a page fragment with the response.
    
        up.submit('form.new-user', { target: '.main' })
    
    Instead of loading a new page, the form is submitted via AJAX.
    The response is parsed for a CSS selector and the matching elements will
    replace corresponding elements on the current page.
    
    The unobtrusive variant of this is the [`form[up-target]`](/form-up-target) selector.
    See the documentation for [`form[up-target]`](/form-up-target) for more
    information on how AJAX form submissions work in Unpoly.
    
    Emits the event [`up:form:submit`](/up:form:submit).
    
    @function up.submit
    @param {Element|jQuery|string} formOrSelector
      A reference or selector for the form to submit.
      If the argument points to an element that is not a form,
      Unpoly will search its ancestors for the closest form.
    @param {string} [options.url]
      The URL where to submit the form.
      Defaults to the form's `action` attribute, or to the current URL of the browser window.
    @param {string} [options.method='post']
      The HTTP method used for the form submission.
      Defaults to the form's `up-method`, `data-method` or `method` attribute, or to `'post'`
      if none of these attributes are given.
    @param {string} [options.target]
      The CSS selector to update when the form submission succeeds (server responds with status 200).
      Defaults to the form's `up-target` attribute.
    
      Inside the CSS selector you may refer to the form as `&` ([like in Sass](https://sass-lang.com/documentation/file.SASS_REFERENCE.html#parent-selector)).
    @param {string} [options.failTarget]
      The CSS selector to update when the form submission fails (server responds with non-200 status).
      Defaults to the form's `up-fail-target` attribute, or to an auto-generated
      selector that matches the form itself.
    
      Inside the CSS selector you may refer to the form as `&` ([like in Sass](https://sass-lang.com/documentation/file.SASS_REFERENCE.html#parent-selector)).
    @param {string} [options.fallback]
      The selector to update when the original target was not found in the page.
      Defaults to the form's `up-fallback` attribute.
    @param {boolean|string} [options.history=true]
      Successful form submissions will add a history entry and change the browser's
      location bar if the form either uses the `GET` method or the response redirected
      to another page (this requires the `unpoly-rails` gem).
      If you want to prevent history changes in any case, set this to `false`.
      If you pass a string, it is used as the URL for the browser history.
    @param {string} [options.transition='none']
      The transition to use when a successful form submission updates the `options.target` selector.
      Defaults to the form's `up-transition` attribute, or to `'none'`.
    @param {string} [options.failTransition='none']
      The transition to use when a failed form submission updates the `options.failTarget` selector.
      Defaults to the form's `up-fail-transition` attribute, or to `options.transition`, or to `'none'`.
    @param {number} [options.duration]
      The duration of the transition. See [`up.morph()`](/up.morph).
    @param {number} [options.delay]
      The delay before the transition starts. See [`up.morph()`](/up.morph).
    @param {string} [options.easing]
      The timing function that controls the transition's acceleration. [`up.morph()`](/up.morph).
    @param {Element|string} [options.reveal=true]
      Whether to reveal the target fragment after it was replaced.
    
      You can also pass a CSS selector for the element to reveal.
    @param {boolean|string} [options.failReveal=true]
      Whether to [reveal](/up.reveal) the target fragment when the server responds with an error.
    
      You can also pass a CSS selector for the element to reveal.
    @param {boolean} [options.restoreScroll]
      If set to `true`, this will attempt to [`restore scroll positions`](/up.restoreScroll)
      previously seen on the destination URL.
    @param {boolean} [options.cache]
      Whether to force the use of a cached response (`true`)
      or never use the cache (`false`)
      or make an educated guess (`undefined`).
    
      By default only responses to `GET` requests are cached
      for a few minutes.
    @param {Object} [options.headers={}]
      An object of additional header key/value pairs to send along
      with the request.
    @param {string} [options.layer='auto']
      The name of the layer that ought to be updated. Valid values are
      `'auto'`, `'page'`, `'modal'` and `'popup'`.
    
      If set to `'auto'` (default), Unpoly will try to find a match in the form's layer.
    @param {string} [options.failLayer='auto']
      The name of the layer that ought to be updated if the server sends a non-200 status code.
    @param {Object|FormData|string|Array|up.Params} [options.params]
      Extra form [parameters](/up.Params) that will be submitted in addition to
      the parameters from the form.
    @return {Promise}
      A promise for the successful form submission.
    @stable
     */ submit = function(formOrSelector, options) {
            var form, ref, ref1, ref10, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, target, url;
            options = u.options(options);
            form = e.get(formOrSelector);
            form = e.closest(form, "form");
            target = (ref = (ref1 = options.target) != null ? ref1 : form.getAttribute("up-target")) != null ? ref : "body";
            if (options.failTarget == null) options.failTarget = (ref2 = form.getAttribute("up-fail-target")) != null ? ref2 : e.toSelector(form);
            if (options.reveal == null) options.reveal = (ref3 = e.booleanOrStringAttr(form, "up-reveal")) != null ? ref3 : true;
            if (options.failReveal == null) options.failReveal = (ref4 = e.booleanOrStringAttr(form, "up-fail-reveal")) != null ? ref4 : true;
            if (options.fallback == null) options.fallback = form.getAttribute("up-fallback");
            if (options.history == null) options.history = (ref5 = e.booleanOrStringAttr(form, "up-history")) != null ? ref5 : true;
            if (options.transition == null) options.transition = e.booleanOrStringAttr(form, "up-transition");
            if (options.failTransition == null) options.failTransition = e.booleanOrStringAttr(form, "up-fail-transition");
            if (options.method == null) options.method = u.normalizeMethod((ref6 = (ref7 = (ref8 = form.getAttribute("up-method")) != null ? ref8 : form.getAttribute("data-method")) != null ? ref7 : form.getAttribute("method")) != null ? ref6 : "post");
            if (options.cache == null) options.cache = e.booleanAttr(form, "up-cache");
            if (options.restoreScroll == null) options.restoreScroll = e.booleanAttr(form, "up-restore-scroll");
            if (options.origin == null) options.origin = form;
            if (options.layer == null) options.layer = form.getAttribute("up-layer");
            if (options.failLayer == null) options.failLayer = form.getAttribute("up-fail-layer");
            options.params = up.Params.fromForm(form).addAll(options.params);
            options = u.merge(options, up.motion.animateOptions(options, form));
            if (options.validate) {
                options.headers || (options.headers = {});
                options.transition = false;
                options.failTransition = false;
                options.headers[up.protocol.config.validateHeader] = options.validate;
            }
            url = (ref9 = (ref10 = options.url) != null ? ref10 : form.getAttribute("action")) != null ? ref9 : up.browser.url();
            if (options.method === "GET") url = up.Params.stripURL(url);
            return up.event.whenEmitted("up:form:submit", {
                log: "Submitting form",
                target: form
            }).then(function() {
                var promise;
                up.feedback.start(form);
                if (!(up.browser.canPushState() || options.history === false)) {
                    form.submit();
                    return u.unresolvablePromise();
                }
                promise = up.replace(target, url, options);
                u.always(promise, function() {
                    return up.feedback.stop(form);
                });
                return promise;
            });
        };
        /***
    This event is [emitted](/up.emit) when a form is [submitted](/up.submit) through Unpoly.
    
    The event is emitted on the`<form>` element.
    
    @event up:form:submit
    @param {Element} event.target
      The `<form>` element that will be submitted.
    @param event.preventDefault()
      Event listeners may call this method to prevent the form from being submitted.
    @stable
     */ /***
    Observes form fields and runs a callback when a value changes.
    
    This is useful for observing text fields while the user is typing.
    
    The unobtrusive variant of this is the [`[up-observe]`](/up-observe) attribute.
    
    \#\#\# Example
    
    The following would print to the console whenever an input field changes:
    
        up.observe('input.query', function(value) {
          console.log('Query is now %o', value)
        })
    
    Instead of a single form field, you can also pass multiple fields,
    a `<form>` or any container that contains form fields.
    The callback will be run if any of the given fields change:
    
        up.observe('form', function(value, name) {
          console.log('The value of %o is now %o', name, value)
        })
    
    You may also pass the `{ batch: true }` option to receive all
    changes since the last callback in a single object:
    
        up.observe('form', { batch: true }, function(diff) {
          console.log('Observed one or more changes: %o', diff)
        })
    
    @function up.observe
    @param {string|Element|Array<Element>|jQuery} elements
      The form fields that will be observed.
    
      You can pass one or more fields, a `<form>` or any container that contains form fields.
      The callback will be run if any of the given fields change.
    @param {boolean} [options.batch=false]
      If set to `true`, the `onChange` callback will receive multiple
      detected changes in a single diff object as its argument.
    @param {number} [options.delay=up.form.config.observeDelay]
      The number of miliseconds to wait before executing the callback
      after the input value changes. Use this to limit how often the callback
      will be invoked for a fast typist.
    @param {Function(value, name): string} onChange
      The callback to run when the field's value changes.
    
      If given as a function, it receives two arguments (`value`, `name`).
      `value` is a string with the new attribute value and `string` is the name
      of the form field that changed.
    
      If given as a string, it will be evaled as JavaScript code in a context where
      (`value`, `name`) are set.
    @return {Function()}
      A destructor function that removes the observe watch when called.
    @stable
     */ observe = function() {
            var args, callback, elements, fields, observer, options, ref, ref1, ref2, ref3;
            elements = arguments[0], args = 2 <= arguments.length ? slice.call(arguments, 1) : [];
            elements = e.list(elements);
            fields = u.flatMap(elements, findFields);
            callback = (ref = (ref1 = u.extractCallback(args)) != null ? ref1 : observeCallbackFromElement(elements[0])) != null ? ref : up.fail("up.observe: No change callback given");
            options = u.extractOptions(args);
            options.delay = (ref2 = (ref3 = options.delay) != null ? ref3 : e.numberAttr(elements[0], "up-delay")) != null ? ref2 : config.observeDelay;
            observer = new up.FieldObserver(fields, options, callback);
            observer.start();
            return observer.stop;
        };
        observeCallbackFromElement = function(element) {
            var rawCallback;
            if (rawCallback = element.getAttribute("up-observe")) return new Function("value", "name", rawCallback);
        };
        /***
    [Observes](/up.observe) a field or form and submits the form when a value changes.
    
    Both the form and the changed field will be assigned a CSS class [`form-up-active`](/form-up-active)
    while the autosubmitted form is processing.
    
    The unobtrusive variant of this is the [`up-autosubmit`](/form-up-autosubmit) attribute.
    
    @function up.autosubmit
    @param {string|Element|jQuery} selectorOrElement
      The field or form to observe.
    @param {Object} [options]
      See options for [`up.observe()`](/up.observe)
    @return {Function()}
      A destructor function that removes the observe watch when called.
    @stable
     */ autosubmit = function(selectorOrElement, options) {
            return observe(selectorOrElement, options, function() {
                return submit(selectorOrElement);
            });
        };
        findValidateTarget = function(field, options) {
            var option, ref;
            option = (ref = options.target) != null ? ref : field.getAttribute("up-validate");
            option || (option = u.findResult(config.validateTargets, function(defaultTarget) {
                var resolvedDefault;
                resolvedDefault = e.resolveSelector(defaultTarget, options.origin);
                if (e.first(resolvedDefault)) return resolvedDefault;
            }));
            if (!option) up.fail("Could not find validation target for %o (tried defaults %o)", field, config.validateTargets);
            return e.resolveSelector(option, options.origin);
        };
        /***
    Performs a server-side validation of a form field.
    
    `up.validate()` submits the given field's form with an additional `X-Up-Validate`
    HTTP header. Upon seeing this header, the server is expected to validate (but not save)
    the form submission and render a new copy of the form with validation errors.
    
    The unobtrusive variant of this is the [`input[up-validate]`](/input-up-validate) selector.
    See the documentation for [`input[up-validate]`](/input-up-validate) for more information
    on how server-side validation works in Unpoly.
    
    \#\#\# Example
    
        up.validate('input[name=email]', { target: '.email-errors' })
    
    @function up.validate
    @param {string|Element|jQuery} fieldOrSelector
    
    @param {string|Element|jQuery} [options.target]
    @return {Promise}
      A promise that is fulfilled when the server-side
      validation is received and the form was updated.
    @stable
     */ validate = function(fieldOrSelector, options) {
            var field, promise, ref;
            field = e.get(fieldOrSelector);
            options = u.options(options);
            options.origin = field;
            options.target = findValidateTarget(field, options);
            options.failTarget = options.target;
            if (options.reveal == null) options.reveal = (ref = e.booleanOrStringAttr(field, "up-reveal")) != null ? ref : false;
            options.history = false;
            options.validate = field.getAttribute("name") || ":none";
            options = u.merge(options, up.motion.animateOptions(options, field));
            promise = up.submit(field, options);
            return promise;
        };
        switcherValues = function(field) {
            var checkedButton, form, groupName, meta, value, values;
            value = void 0;
            meta = void 0;
            if (e.matches(field, "input[type=checkbox]")) {
                if (field.checked) {
                    value = field.value;
                    meta = ":checked";
                } else meta = ":unchecked";
            } else if (e.matches(field, "input[type=radio]")) {
                form = closestContainer(field);
                groupName = field.getAttribute("name");
                checkedButton = form.querySelector("input[type=radio]" + e.attributeSelector("name", groupName) + ":checked");
                if (checkedButton) {
                    meta = ":checked";
                    value = checkedButton.value;
                } else meta = ":unchecked";
            } else value = field.value;
            values = [];
            if (u.isPresent(value)) {
                values.push(value);
                values.push(":present");
            } else values.push(":blank");
            if (u.isPresent(meta)) values.push(meta);
            return values;
        };
        /***
    Shows or hides a target selector depending on the value.
    
    See [`input[up-switch]`](/input-up-switch) for more documentation and examples.
    
    This function does not currently have a very useful API outside
    of our use for `up-switch`'s UJS behavior, that's why it's currently
    still marked `@internal`.
    
    @function up.form.switchTargets
    @param {Element} switcher
    @param {string} [options.target]
      The target selectors to switch.
      Defaults to an `[up-switch]` attribute on the given field.
    @internal
     */ switchTargets = function(switcher, options) {
            var fieldValues, form, ref, targetSelector;
            if (options == null) options = {};
            targetSelector = (ref = options.target) != null ? ref : switcher.getAttribute("up-switch");
            form = closestContainer(switcher);
            u.isPresent(targetSelector) || up.fail("No switch target given for %o", switcher);
            fieldValues = switcherValues(switcher);
            return u.each(e.all(form, targetSelector), function(target) {
                return switchTarget(target, fieldValues);
            });
        };
        /***
    @internal
     */ switchTarget = function(target, fieldValues) {
            var hideValues, show, showValues;
            fieldValues || (fieldValues = switcherValues(findSwitcherForTarget(target)));
            if (hideValues = target.getAttribute("up-hide-for")) {
                hideValues = u.splitValues(hideValues);
                show = u.intersect(fieldValues, hideValues).length === 0;
            } else {
                if (showValues = target.getAttribute("up-show-for")) showValues = u.splitValues(showValues);
                else showValues = [
                    ":present",
                    ":checked"
                ];
                show = u.intersect(fieldValues, showValues).length > 0;
            }
            e.toggle(target, show);
            return target.classList.add("up-switched");
        };
        /***
    @internal
     */ findSwitcherForTarget = function(target) {
            var form, switcher, switchers;
            form = closestContainer(target);
            switchers = e.all(form, "[up-switch]");
            switcher = u.find(switchers, function(switcher) {
                var targetSelector;
                targetSelector = switcher.getAttribute("up-switch");
                return e.matches(target, targetSelector);
            });
            return switcher || u.fail("Could not find [up-switch] field for %o", target);
        };
        closestContainer = function(element) {
            return e.closest(element, "form, body");
        };
        /***
    Forms with an `up-target` attribute are [submitted via AJAX](/up.submit)
    instead of triggering a full page reload.
    
        <form method="post" action="/users" up-target=".main">
          ...
        </form>
    
    The server response is searched for the selector given in `up-target`.
    The selector content is then [replaced](/up.replace) in the current page.
    
    The programmatic variant of this is the [`up.submit()`](/up.submit) function.
    
    \#\#\# Failed submission
    
    When the server was unable to save the form due to invalid params,
    it will usually re-render an updated copy of the form with
    validation messages.
    
    For Unpoly to be able to detect a failed form submission,
    the form must be re-rendered with a non-200 HTTP status code.
    We recommend to use either 400 (bad request) or
    422 (unprocessable entity).
    
    In Ruby on Rails, you can pass a
    [`:status` option to `render`](http://guides.rubyonrails.org/layouts_and_rendering.html#the-status-option)
    for this:
    
        class UsersController < ApplicationController
    
          def create
            user_params = params[:user].permit(:email, :password)
            @user = User.new(user_params)
            if @user.save?
              sign_in @user
            else
              render 'form', status: :bad_request
            end
          end
    
        end
    
    Note that you can also use
    [`input[up-validate]`](/input-up-validate) to perform server-side
    validations while the user is completing fields.
    
    \#\#\# Redirects
    
    Unpoly requires an additional response header to detect redirects,
    which are otherwise undetectable for an AJAX client.
    
    After the form's action performs a redirect, the next response should echo
    the new request's URL as a response header `X-Up-Location`.
    
    If you are using Unpoly via the `unpoly-rails` gem, these headers
    are set automatically for every request.
    
    \#\#\# Giving feedback while the form is processing
    
    The `<form>` element will be assigned a CSS class [`up-active`](/form.up-active) while
    the submission is loading.
    
    You can also [implement a spinner](/up.proxy/#spinners)
    by [listening](/up.on) to the [`up:proxy:slow`](/up:proxy:slow)
    and [`up:proxy:recover`](/up:proxy:recover) events.
    
    @selector form[up-target]
    @param {string} up-target
      The CSS selector to [replace](/up.replace) if the form submission is successful (200 status code).
    
      Inside the CSS selector you may refer to this form as `&` ([like in Sass](https://sass-lang.com/documentation/file.SASS_REFERENCE.html#parent-selector)).
    @param {string} [up-fail-target]
      The CSS selector to [replace](/up.replace) if the form submission is not successful (non-200 status code).
    
      Inside the CSS selector you may refer to this form as `&` ([like in Sass](https://sass-lang.com/documentation/file.SASS_REFERENCE.html#parent-selector)).
    
      If omitted, Unpoly will replace the `<form>` tag itself, assuming that the server has echoed the form with validation errors.
    @param [up-fallback]
      The selector to replace if the server responds with an error.
    @param {string} [up-transition]
      The animation to use when the form is replaced after a successful submission.
    @param {string} [up-fail-transition]
      The animation to use when the form is replaced after a failed submission.
    @param [up-history]
      Whether to push a browser history entry after a successful form submission.
    
      By default the form's target URL is used. If the form redirects to another URL,
      the redirect target will be used.
    
      Set this to `'false'` to prevent the URL bar from being updated.
      Set this to a URL string to update the history with the given URL.
    @param {string} [up-method]
      The HTTP method to be used to submit the form (`get`, `post`, `put`, `delete`, `patch`).
      Alternately you can use an attribute `data-method`
      ([Rails UJS](https://github.com/rails/jquery-ujs/wiki/Unobtrusive-scripting-support-for-jQuery))
      or `method` (vanilla HTML) for the same purpose.
    @param {string} [up-layer='auto']
      The name of the layer that ought to be updated. Valid values are
      `'auto'`, `'page'`, `'modal'` and `'popup'`.
    
      If set to `'auto'` (default), Unpoly will try to find a match in the form's layer.
      If no match was found in that layer,
      Unpoly will search in other layers, starting from the topmost layer.
    @param {string} [up-fail-layer='auto']
      The name of the layer that ought to be updated if the server sends a
      non-200 status code.
    @param {string} [up-reveal='true']
      Whether to reveal the target element after it was replaced.
    
      You can also pass a CSS selector for the element to reveal.
      Inside the CSS selector you may refer to the form as `&` ([like in Sass](https://sass-lang.com/documentation/file.SASS_REFERENCE.html#parent-selector)).
    @param {string} [up-fail-reveal='true']
      Whether to reveal the target element when the server responds with an error.
    
      You can also pass a CSS selector for the element to reveal. You may use this, for example,
      to reveal the first validation error message:
    
          <form up-target=".content" up-fail-reveal=".error">
            ...
          </form>
    
      Inside the CSS selector you may refer to the form as `&` ([like in Sass](https://sass-lang.com/documentation/file.SASS_REFERENCE.html#parent-selector)).
    @param {string} [up-restore-scroll='false']
      Whether to restore previously known scroll position of all viewports
      within the target selector.
    @param {string} [up-cache]
      Whether to force the use of a cached response (`true`)
      or never use the cache (`false`)
      or make an educated guess (`undefined`).
    
      By default only responses to `GET` requests are cached for a few minutes.
    @stable
     */ up.on("submit", "form[up-target]", function(event, form) {
            up.event.consumeAction(event);
            return u.muteRejection(submit(form));
        });
        /***
    When a form field with this attribute is changed, the form is validated on the server
    and is updated with validation messages.
    
    To validate the form, Unpoly will submit the form with an additional `X-Up-Validate` HTTP header.
    When seeing this header, the server is expected to validate (but not save)
    the form submission and render a new copy of the form with validation errors.
    
    The programmatic variant of this is the [`up.validate()`](/up.validate) function.
    
    \#\#\# Example
    
    Let's look at a standard registration form that asks for an e-mail and password:
    
        <form action="/users">
    
          <label>
            E-mail: <input type="text" name="email" />
          </label>
    
          <label>
            Password: <input type="password" name="password" />
          </label>
    
          <button type="submit">Register</button>
    
        </form>
    
    When the user changes the `email` field, we want to validate that
    the e-mail address is valid and still available. Also we want to
    change the `password` field for the minimum required password length.
    We can do this by giving both fields an `up-validate` attribute:
    
        <form action="/users">
    
          <label>
            E-mail: <input type="text" name="email" up-validate />
          </label>
    
          <label>
            Password: <input type="password" name="password" up-validate />
          </label>
    
          <button type="submit">Register</button>
    
        </form>
    
    Whenever a field with `up-validate` changes, the form is POSTed to
    `/users` with an additional `X-Up-Validate` HTTP header.
    When seeing this header, the server is expected to validate (but not save)
    the form submission and render a new copy of the form with validation errors.
    
    In Ruby on Rails the processing action should behave like this:
    
        class UsersController < ApplicationController
    
           * This action handles POST /users
          def create
            user_params = params[:user].permit(:email, :password)
            @user = User.new(user_params)
            if request.headers['X-Up-Validate']
              @user.valid?  # run validations, but don't save to the database
              render 'form' # render form with error messages
            elsif @user.save?
              sign_in @user
            else
              render 'form', status: :bad_request
            end
          end
    
        end
    
    Note that if you're using the `unpoly-rails` gem you can simply say `up.validate?`
    instead of manually checking for `request.headers['X-Up-Validate']`.
    
    The server now renders an updated copy of the form with eventual validation errors:
    
        <form action="/users">
    
          <label class="has-error">
            E-mail: <input type="text" name="email" value="foo@bar.com" />
            Has already been taken!
          </label>
    
          <button type="submit">Register</button>
    
        </form>
    
    The `<label>` around the e-mail field is now updated to have the `has-error`
    class and display the validation message.
    
    \#\#\# How validation results are displayed
    
    Although the server will usually respond to a validation with a complete,
    fresh copy of the form, Unpoly will by default not update the entire form.
    This is done in order to preserve volatile state such as the scroll position
    of `<textarea>` elements.
    
    By default Unpoly looks for a `<fieldset>`, `<label>` or `<form>`
    around the validating input field, or any element with an
    `up-fieldset` attribute.
    With the Bootstrap bindings, Unpoly will also look
    for a container with the `form-group` class.
    
    You can change this default behavior by setting [`up.form.config.validateTargets`](/up.form.config#config.validateTargets):
    
        // Always update the entire form containing the current field ("&")
        up.form.config.validateTargets = ['form &']
    
    You can also individually override what to update by setting the `up-validate`
    attribute to a CSS selector:
    
        <input type="text" name="email" up-validate=".email-errors">
        <span class="email-errors"></span>
    
    \#\#\# Updating dependent fields
    
    The `[up-validate]` behavior is also a great way to partially update a form
    when one fields depends on the value of another field.
    
    Let's say you have a form with one `<select>` to pick a department (sales, engineering, ...)
    and another `<select>` to pick an employeee from the selected department:
    
        <form action="/contracts">
          <select name="department">...</select> <!-- options for all departments -->
          <select name="employeed">...</select> <!-- options for employees of selected department -->
        </form>
    
    The list of employees needs to be updated as the appartment changes:
    
        <form action="/contracts">
          <select name="department" up-validate="[name=employee]">...</select>
          <select name="employee">...</select>
        </form>
    
    In order to update the `department` field in addition to the `employee` field, you could say
    `up-validate="&, [name=employee]"`, or simply `up-validate="form"` to update the entire form.
    
    @selector input[up-validate]
    @param {string} up-validate
      The CSS selector to update with the server response.
    
      This defaults to a fieldset or form group around the validating field.
    @stable
     */ /***
    Performs [server-side validation](/input-up-validate) when any fieldset within this form changes.
    
    You can configure what Unpoly considers a fieldset by adding CSS selectors to the
    [`up.form.config.validateTargets`](/up.form.config#config.validateTargets) array.
    
    @selector form[up-validate]
    @stable
     */ up.on("change", "[up-validate]", function(event) {
            var field;
            field = findFields(event.target)[0];
            return u.muteRejection(validate(field));
        });
        /***
    Show or hide elements when a `<select>` or `<input>` has a given value.
    
    \#\#\# Example: Select options
    
    The controlling form field gets an `up-switch` attribute with a selector for the elements to show or hide:
    
        <select name="advancedness" up-switch=".target">
          <option value="basic">Basic parts</option>
          <option value="advanced">Advanced parts</option>
          <option value="very-advanced">Very advanced parts</option>
        </select>
    
    The target elements can use [`[up-show-for]`](/up-show-for) and [`[up-hide-for]`](/up-hide-for)
    attributes to indicate for which values they should be shown or hidden:
    
        <div class="target" up-show-for="basic">
          only shown for advancedness = basic
        </div>
    
        <div class="target" up-hide-for="basic">
          hidden for advancedness = basic
        </div>
    
        <div class="target" up-show-for="advanced very-advanced">
          shown for advancedness = advanced or very-advanced
        </div>
    
    \#\#\# Example: Text field
    
    The controlling `<input>` gets an `up-switch` attribute with a selector for the elements to show or hide:
    
        <input type="text" name="user" up-switch=".target">
    
        <div class="target" up-show-for="alice">
          only shown for user alice
        </div>
    
    You can also use the pseudo-values `:blank` to match an empty input value,
    or `:present` to match a non-empty input value:
    
        <input type="text" name="user" up-switch=".target">
    
        <div class="target" up-show-for=":blank">
          please enter a username
        </div>
    
    \#\#\# Example: Checkbox
    
    For checkboxes you can match against the pseudo-values `:checked` or `:unchecked`:
    
        <input type="checkbox" name="flag" up-switch=".target">
    
        <div class="target" up-show-for=":checked">
          only shown when checkbox is checked
        </div>
    
        <div class="target" up-show-for=":cunhecked">
          only shown when checkbox is unchecked
        </div>
    
    Of course you can also match against the `value` property of the checkbox element:
    
        <input type="checkbox" name="flag" value="active" up-switch=".target">
    
        <div class="target" up-show-for="active">
          only shown when checkbox is checked
        </div>
    
    @selector input[up-switch]
    @param {string} up-switch
      A CSS selector for elements whose visibility depends on this field's value.
    @stable
     */ /***
    Only shows this element if an input field with [`[up-switch]`](/input-up-switch) has one of the given values.
    
    See [`input[up-switch]`](/input-up-switch) for more documentation and examples.
    
    @selector [up-show-for]
    @param {string} [up-show-for]
      A space-separated list of input values for which this element should be shown.
    @stable
     */ /***
    Hides this element if an input field with [`[up-switch]`](/input-up-switch) has one of the given values.
    
    See [`input[up-switch]`](/input-up-switch) for more documentation and examples.
    
    @selector [up-hide-for]
    @param {string} [up-hide-for]
      A space-separated list of input values for which this element should be hidden.
    @stable
     */ up.compiler("[up-switch]", function(switcher) {
            return switchTargets(switcher);
        });
        up.on("change", "[up-switch]", function(event, switcher) {
            return switchTargets(switcher);
        });
        up.compiler("[up-show-for]:not(.up-switched), [up-hide-for]:not(.up-switched)", function(element) {
            return switchTarget(element);
        });
        /***
    Observes this field and runs a callback when a value changes.
    
    This is useful for observing text fields while the user is typing.
    If you want to submit the form after a change see [`input[up-autosubmit]`](/input-up-autosubmit).
    
    The programmatic variant of this is the [`up.observe()`](/up.observe) function.
    
    \#\#\# Example
    
    The following would run a global `showSuggestions(value)` function
    whenever the `<input>` changes:
    
        <input name="query" up-observe="showSuggestions(value)">
    
    \#\#\# Callback context
    
    The script given to `[up-observe]` runs with the following context:
    
    | Name     | Type      | Description                           |
    | -------- | --------- | ------------------------------------- |
    | `value`  | `string`  | The current value of the field        |
    | `this`   | `Element` | The form field                        |
    | `$field` | `jQuery`  | The form field as a jQuery collection |
    
    \#\#\# Observing radio buttons
    
    Multiple radio buttons with the same `[name]` (a radio button group)
    produce a single value for the form.
    
    To observe radio buttons group, use the `[up-observe]` attribute on an
    element that contains all radio button elements with a given name:
    
        <div up-observe="formatSelected(value)">
          <input type="radio" name="format" value="html"> HTML format
          <input type="radio" name="format" value="pdf"> PDF format
          <input type="radio" name="format" value="txt"> Text format
        </div>
    
    @selector input[up-observe]
    @param {string} up-observe
      The code to run when the field's value changes.
    @param {string} up-delay
      The number of miliseconds to wait after a change before the code is run.
    @stable
     */ /***
    Observes this form and runs a callback when any field changes.
    
    This is useful for observing text fields while the user is typing.
    If you want to submit the form after a change see [`input[up-autosubmit]`](/input-up-autosubmit).
    
    The programmatic variant of this is the [`up.observe()`](/up.observe) function.
    
    \#\#\# Example
    
    The would call a function `somethingChanged(value)`
    when any `<input>` within the `<form>` changes:
    
        <form up-observe="somethingChanged(value)">
          <input name="foo">
          <input name="bar">
        </form>
    
    \#\#\# Callback context
    
    The script given to `up-observe` runs with the following context:
    
    | Name     | Type      | Description                           |
    | -------- | --------- | ------------------------------------- |
    | `value`  | `string`  | The current value of the field        |
    | `this`   | `Element` | The form field                        |
    | `$field` | `jQuery`  | The form field as a jQuery collection |
    
    @selector form[up-observe]
    @param {string} up-observe
      The code to run when any field's value changes.
    @param {string} up-delay
      The number of miliseconds to wait after a change before the code is run.
    @stable
     */ up.compiler("[up-observe]", function(formOrField) {
            return observe(formOrField);
        });
        /***
    Submits this field's form when this field changes its values.
    
    Both the form and the changed field will be assigned a CSS class [`up-active`](/form-up-active)
    while the autosubmitted form is loading.
    
    The programmatic variant of this is the [`up.autosubmit()`](/up.autosubmit) function.
    
    \#\#\# Example
    
    The following would automatically submit the form when the query is changed:
    
        <form method="GET" action="/search">
          <input type="search" name="query" up-autosubmit>
          <input type="checkbox" name="archive"> Include archive
        </form>
    
    \#\#\# Auto-submitting radio buttons
    
    Multiple radio buttons with the same `[name]` (a radio button group)
    produce a single value for the form.
    
    To auto-submit radio buttons group, use the `[up-submit]` attribute on an
    element that contains all radio button elements with a given name:
    
        <div up-autosubmit>
          <input type="radio" name="format" value="html"> HTML format
          <input type="radio" name="format" value="pdf"> PDF format
          <input type="radio" name="format" value="txt"> Text format
        </div>
    
    @selector input[up-autosubmit]
    @param {string} up-delay
      The number of miliseconds to wait after a change before the form is submitted.
    @stable
     */ /***
    Submits the form when *any* field changes.
    
    Both the form and the field will be assigned a CSS class [`up-active`](/form-up-active)
    while the autosubmitted form is loading.
    
    The programmatic variant of this is the [`up.autosubmit()`](/up.autosubmit) function.
    
    \#\#\# Example
    
    This will submit the form when either query or checkbox was changed:
    
        <form method="GET" action="/search" up-autosubmit>
          <input type="search" name="query">
          <input type="checkbox" name="archive"> Include archive
        </form>
    
    @selector form[up-autosubmit]
    @param {string} up-delay
      The number of miliseconds to wait after a change before the form is submitted.
    @stable
     */ up.compiler("[up-autosubmit]", function(formOrField) {
            return autosubmit(formOrField);
        });
        up.compiler("[autofocus]", {
            batch: true
        }, function(inputs) {
            return u.last(inputs).focus();
        });
        up.on("up:framework:reset", reset);
        return {
            config: config,
            submit: submit,
            observe: observe,
            validate: validate,
            autosubmit: autosubmit,
            fieldSelector: fieldSelector,
            fields: findFields,
            submissionFields: findSubmissionFields
        };
    }();
    up.submit = up.form.submit;
    up.observe = up.form.observe;
    up.autosubmit = up.form.autosubmit;
    up.validate = up.form.validate;
}).call(module.exports);
/***
Pop-up overlays
===============

Instead of [linking to a page fragment](/up.link), you can choose
to show a fragment in a popup overlay that rolls down from an anchoring element.

To open a popup, add an [`up-popup` attribute](/a-up-popup) to a link:

    <a href="/options" up-popup=".menu">Show options</a>

When this link is clicked, Unpoly will request the path `/options` and extract
an element matching the selector `.menu` from the response. The matching element
will then be placed in the popup overlay.


\#\#\# Closing behavior

The popup closes when the user clicks anywhere outside the popup area.

The popup also closes *when a link within the popup changes a fragment behind the popup*.
This is useful to have the popup interact with the page that
opened it, e.g. by updating parts of a larger form.

To disable this behavior, give the opening link an [`up-sticky`](/a-up-popup#up-sticky) attribute.


\#\#\# Customizing the popup design

Popups have a minimal default design:

- Popup contents are displayed in a white box
- There is a a subtle box shadow around the popup
- The box will grow to fit the popup contents

The easiest way to change how the popup looks is to override the
[default CSS styles](https://github.com/unpoly/unpoly/blob/master/lib/assets/stylesheets/unpoly/popup.sass).

The HTML of a popup element looks like this:

    <div class="up-popup">
      <div class="up-popup-content">
        Fragment content here
      </div>
    </div>

The popup element is appended to the [viewport](/up.viewport) of the anchor element.

@module up.popup
 */ (function() {
    up.popup = function() {
        var attachAsap, attachNow, autoclose, chain, closeAsap, closeNow, config, contains, createHiddenFrame, discardHistory, e, isOpen, preloadNow, reset, state, syncPosition, toggleAsap, u, unveilFrame;
        u = up.util;
        e = up.element;
        /***
    Sets default options for future popups.
    
    @property up.popup.config
    @param {string} [config.position='bottom']
      Defines on which side of the opening element the popup is attached.
    
      Valid values are `'top'`, `'right'`, `'bottom'` and `'left'`.
    @param {string} [config.align='left']
      Defines the alignment of the popup along its side.
    
      When the popup's `{ position }` is `'top'` or `'bottom'`, valid `{ align }` values are `'left'`, `center'` and `'right'`.
      When the popup's `{ position }` is `'left'` or `'right'`, valid `{ align }` values are `top'`, `center'` and `bottom'`.
    @param {string} [config.history=false]
      Whether opening a popup will add a browser history entry.
    @param {string} [config.openAnimation='fade-in']
      The animation used to open a popup.
    @param {string} [config.closeAnimation='fade-out']
      The animation used to close a popup.
    @param {string} [config.openDuration]
      The duration of the open animation (in milliseconds).
    @param {string} [config.closeDuration]
      The duration of the close animation (in milliseconds).
    @param {string} [config.openEasing]
      The timing function controlling the acceleration of the opening animation.
    @param {string} [config.closeEasing]
      The timing function controlling the acceleration of the closing animation.
    @param {boolean} [options.sticky=false]
      If set to `true`, the popup remains
      open even it changes the page in the background.
    @stable
     */ config = new up.Config({
            openAnimation: "fade-in",
            closeAnimation: "fade-out",
            openDuration: 150,
            closeDuration: 100,
            openEasing: null,
            closeEasing: null,
            position: "bottom",
            align: "left",
            history: false
        });
        /***
    Returns the URL from which the current popup's contents were loaded.
    
    Returns `undefined` if no  popup is open.
    
    @function up.popup.url
    @return {string}
      the source URL
    @stable
     */ /***
    Returns the URL of the page or modal behind the popup.
    
    @function up.popup.coveredUrl
    @return {string}
    @experimental
     */ state = new up.Config({
            phase: "closed",
            anchor: null,
            popup: null,
            content: null,
            tether: null,
            position: null,
            align: null,
            sticky: null,
            url: null,
            coveredUrl: null,
            coveredTitle: null
        });
        chain = new up.DivertibleChain();
        reset = function() {
            var ref;
            if ((ref = state.tether) != null) ref.destroy();
            state.reset();
            chain.reset();
            return config.reset();
        };
        discardHistory = function() {
            state.coveredTitle = null;
            return state.coveredUrl = null;
        };
        createHiddenFrame = function(targetSelector) {
            state.tether = new up.Tether(u.only(state, "anchor", "position", "align"));
            state.popup = e.affix(state.tether.root, ".up-popup", {
                "up-position": state.position,
                "up-align": state.align
            });
            state.content = e.affix(state.popup, ".up-popup-content");
            up.fragment.createPlaceholder(targetSelector, state.content);
            return e.hide(state.popup);
        };
        unveilFrame = function() {
            return e.show(state.popup);
        };
        /***
    Forces the popup to update its position relative to its anchor element.
    
    Unpoly automatically keep popups aligned when
    the document is resized or scrolled. Complex layout changes may make
    it necessary to call this function.
    
    @function up.popup.sync
    @experimental
     */ syncPosition = function() {
            var ref;
            return (ref = state.tether) != null ? ref.sync() : void 0;
        };
        /***
    Returns whether popup modal is currently open.
    
    @function up.popup.isOpen
    @return {boolean}
    @stable
     */ isOpen = function() {
            return state.phase === "opened" || state.phase === "opening";
        };
        /***
    Attaches a popup overlay to the given element or selector.
    
    Emits events [`up:popup:open`](/up:popup:open) and [`up:popup:opened`](/up:popup:opened).
    
    @function up.popup.attach
    @param {Element|jQuery|string} anchor
      The element to which the popup will be attached.
    @param {string} [options.url]
      The URL from which to fetch the popup contents.
    
      If omitted, the `href` or `up-href` attribute of the anchor element will be used.
    
      Will be ignored if `options.html` is given.
    @param {string} [options.target]
      A CSS selector that will be extracted from the response and placed into the popup.
    @param {string} [options.position='bottom']
      Defines on which side of the opening element the popup is attached.
    
      Valid values are `'top'`, `'right'`, `'bottom'` and `'left'`.
    @param {string} [options.align='left']
      Defines the alignment of the popup along its side.
    
      When the popup's `{ position }` is `'top'` or `'bottom'`, valid `{ align }` values are `'left'`, `center'` and `'right'`.
      When the popup's `{ position }` is `'left'` or `'right'`, valid `{ align }` values are `top'`, `center'` and `bottom'`.
    @param {string} [options.html]
      A string of HTML from which to extract the popup contents. No network request will be made.
    @param {string} [options.confirm]
      A message that will be displayed in a cancelable confirmation dialog
      before the modal is being opened.
    @param {string} [options.animation]
      The animation to use when opening the popup.
    @param {number} [options.duration]
      The duration of the animation. See [`up.animate()`](/up.animate).
    @param {number} [options.delay]
      The delay before the animation starts. See [`up.animate()`](/up.animate).
    @param {string} [options.easing]
      The timing function that controls the animation's acceleration. [`up.animate()`](/up.animate).
    @param {string} [options.method="GET"]
      Override the request method.
    @param {boolean} [options.sticky=false]
      If set to `true`, the popup remains
      open even if the page changes in the background.
    @param {boolean} [options.history=false]
    @return {Promise}
      A promise that will be fulfilled when the popup has been loaded and
      the opening animation has completed.
    @stable
     */ attachAsap = function(elementOrSelector, options) {
            return chain.asap(closeNow, function() {
                return attachNow(elementOrSelector, options);
            });
        };
        attachNow = function(elementOrSelector, options) {
            var align, anchor, animateOptions, extractOptions, html, position, ref, ref1, ref10, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, target, url;
            anchor = e.get(elementOrSelector);
            if (options == null) options = {};
            url = (ref = (ref1 = u.pluckKey(options, "url")) != null ? ref1 : anchor.getAttribute("up-href")) != null ? ref : anchor.getAttribute("href");
            html = u.pluckKey(options, "html");
            url || html || up.fail("up.popup.attach() requires either an { url } or { html } option");
            target = (ref2 = u.pluckKey(options, "target")) != null ? ref2 : anchor.getAttribute("up-popup") || up.fail("No target selector given for [up-popup]");
            position = (ref3 = (ref4 = options.position) != null ? ref4 : anchor.getAttribute("up-position")) != null ? ref3 : config.position;
            align = (ref5 = (ref6 = options.align) != null ? ref6 : anchor.getAttribute("up-align")) != null ? ref5 : config.align;
            if (options.animation == null) options.animation = (ref7 = anchor.getAttribute("up-animation")) != null ? ref7 : config.openAnimation;
            if (options.sticky == null) options.sticky = (ref8 = e.booleanAttr(anchor, "up-sticky")) != null ? ref8 : config.sticky;
            options.history = up.browser.canPushState() ? (ref9 = (ref10 = options.history) != null ? ref10 : e.booleanOrStringAttr(anchor, "up-history")) != null ? ref9 : config.history : false;
            if (options.confirm == null) options.confirm = anchor.getAttribute("up-confirm");
            options.method = up.link.followMethod(anchor, options);
            options.layer = "popup";
            if (options.failTarget == null) options.failTarget = anchor.getAttribute("up-fail-target");
            if (options.failLayer == null) options.failLayer = anchor.getAttribute("up-fail-layer");
            options.provideTarget = function() {
                return createHiddenFrame(target);
            };
            animateOptions = up.motion.animateOptions(options, anchor, {
                duration: config.openDuration,
                easing: config.openEasing
            });
            extractOptions = u.merge(options, {
                animation: false
            });
            if (options.preload && url) return up.replace(target, url, options);
            return up.browser.whenConfirmed(options).then(function() {
                return up.event.whenEmitted("up:popup:open", {
                    url: url,
                    anchor: anchor,
                    log: "Opening popup"
                }).then(function() {
                    var promise;
                    state.phase = "opening";
                    state.anchor = anchor;
                    state.position = position;
                    state.align = align;
                    if (options.history) {
                        state.coveredUrl = up.browser.url();
                        state.coveredTitle = document.title;
                    }
                    state.sticky = options.sticky;
                    if (html) promise = up.extract(target, html, extractOptions);
                    else promise = up.replace(target, url, extractOptions);
                    promise = promise.then(function() {
                        unveilFrame();
                        syncPosition();
                        return up.animate(state.popup, options.animation, animateOptions);
                    });
                    promise = promise.then(function() {
                        state.phase = "opened";
                        return up.emit(state.popup, "up:popup:opened", {
                            anchor: state.anchor,
                            log: "Popup opened"
                        });
                    });
                    return promise;
                });
            });
        };
        /***
    This event is [emitted](/up.emit) when a popup is starting to open.
    
    @event up:popup:open
    @param {Element} event.anchor
      The element to which the popup will be attached.
    @param event.preventDefault()
      Event listeners may call this method to prevent the popup from opening.
    @stable
     */ /***
    This event is [emitted](/up.emit) when a popup has finished opening.
    
    @event up:popup:opened
    @param {Element} event.anchor
      The element to which the popup was attached.
    @stable
     */ /***
    Closes a currently opened popup overlay.
    
    Does nothing if no popup is currently open.
    
    Emits events [`up:popup:close`](/up:popup:close) and [`up:popup:closed`](/up:popup:closed).
    
    @function up.popup.close
    @param {Object} options
      See options for [`up.animate()`](/up.animate).
    @return {Promise}
      A promise that will be fulfilled once the modal's close
      animation has finished.
    @stable
     */ closeAsap = function(options) {
            return chain.asap(function() {
                return closeNow(options);
            });
        };
        closeNow = function(options) {
            var animateOptions;
            if (!isOpen()) return Promise.resolve();
            options = u.options(options, {
                animation: config.closeAnimation,
                history: state.coveredUrl,
                title: state.coveredTitle
            });
            animateOptions = up.motion.animateOptions(options, {
                duration: config.closeDuration,
                easing: config.closeEasing
            });
            u.assign(options, animateOptions);
            return up.event.whenEmitted("up:popup:close", {
                anchor: state.anchor,
                log: "Closing popup"
            }).then(function() {
                state.phase = "closing";
                state.url = null;
                state.coveredUrl = null;
                state.coveredTitle = null;
                return up.destroy(state.popup, options).then(function() {
                    state.phase = "closed";
                    state.tether.destroy();
                    state.tether = null;
                    state.popup = null;
                    state.content = null;
                    state.anchor = null;
                    state.sticky = null;
                    return up.emit("up:popup:closed", {
                        anchor: state.anchor,
                        log: "Popup closed"
                    });
                });
            });
        };
        preloadNow = function(link, options) {
            options = u.options(options);
            options.preload = true;
            return attachNow(link, options);
        };
        toggleAsap = function(link, options) {
            if (link.classList.contains("up-current")) return closeAsap();
            else return attachAsap(link, options);
        };
        /***
    This event is [emitted](/up.emit) when a popup dialog
    is starting to [close](/up.popup.close).
    
    @event up:popup:close
    @param {Element} event.anchor
      The element to which the popup is attached.
    @param event.preventDefault()
      Event listeners may call this method to prevent the popup from closing.
    @stable
     */ /***
    This event is [emitted](/up.emit) when a popup dialog
    is done [closing](/up.popup.close).
    
    @event up:popup:closed
    @param {Element} event.anchor
      The element to which the popup was attached.
    @stable
     */ autoclose = function() {
            if (!state.sticky) {
                discardHistory();
                return closeAsap();
            }
        };
        /***
    Returns whether the given element or selector is contained
    within the current popup.
    
    @methods up.popup.contains
    @param {string} elementOrSelector
      The element to test
    @return {boolean}
    @stable
     */ contains = function(elementOrSelector) {
            var element;
            element = e.get(elementOrSelector);
            return !!e.closest(element, ".up-popup");
        };
        /***
    Opens this link's destination of in a popup overlay:
    
        <a href="/decks" up-popup=".deck_list">Switch deck</a>
    
    If the `up-sticky` attribute is set, the dialog does not auto-close
    if a page fragment behind the popup overlay updates:
    
        <a href="/decks" up-popup=".deck_list">Switch deck</a>
        <a href="/settings" up-popup=".options" up-sticky>Settings</a>
    
    @selector a[up-popup]
    @param {string} up-popup
      The CSS selector that will be extracted from the response and
      displayed in a popup overlay.
    @param {string} [up-position]
      Defines on which side of the opening element the popup is attached.
    
      Valid values are `'top'`, `'right'`, `'bottom'` and `'left'`.
    @param {string} [up-align]
      Defines the alignment of the popup along its side.
    
      When the popup's `{ position }` is `'top'` or `'bottom'`, valid `{ align }` values are `'left'`, `center'` and `'right'`.
      When the popup's `{ position }` is `'left'` or `'right'`, valid `{ align }` values are `top'`, `center'` and `bottom'`.
    @param {string} [up-confirm]
      A message that will be displayed in a cancelable confirmation dialog
      before the popup is opened.
    @param {string} [up-method='GET']
      Override the request method.
    @param [up-sticky]
      If set to `true`, the popup remains
      open even if the page changes in the background.
    @param {string} [up-history='false']
      Whether to push an entry to the browser history for the popup's source URL.
    
      Set this to `'false'` to prevent the URL bar from being updated.
      Set this to a URL string to update the history with the given URL.
    
    @stable
     */ up.link.addFollowVariant("[up-popup]", {
            follow: function(link, options) {
                return toggleAsap(link, options);
            },
            preload: function(link, options) {
                return preloadNow(link, options);
            }
        });
        up.on("click up:action:consumed", function(event) {
            var target;
            target = event.target;
            if (!e.closest(target, ".up-popup, [up-popup]")) return u.muteRejection(closeAsap());
        });
        up.on("up:fragment:inserted", function(event, fragment) {
            var newSource;
            if (contains(fragment)) {
                if (newSource = fragment.getAttribute("up-source")) return state.url = newSource;
            } else if (event.origin && contains(event.origin)) return u.muteRejection(autoclose());
        });
        up.event.onEscape(function() {
            return u.muteRejection(closeAsap());
        });
        /***
    When this element is clicked, a currently open [popup](/up.popup) is closed.
    
    Does nothing if no popup is currently open.
    
    \#\#\# Example
    
    Clickin on this `<span>` will close a currently open popup:
    
        <span class='up-close'>Close this popup</span>
    
    When a popup changes the current URL, you might need to deal with content being displayed
    as either a popup or a full page.
    
    To make a link that closes the current popup, but follows to
    a fallback destination if no popup is open:
    
        <a href="/fallback" up-close>Okay</a>
    
    @selector .up-popup [up-close]
    @stable
     */ up.on("click", ".up-popup [up-close]", function(event) {
            u.muteRejection(closeAsap());
            return up.event.consumeAction(event);
        });
        up.on("up:history:restore", function() {
            return u.muteRejection(closeAsap());
        });
        up.on("up:framework:reset", reset);
        return {
            attach: attachAsap,
            close: closeAsap,
            url: function() {
                return state.url;
            },
            coveredUrl: function() {
                return state.coveredUrl;
            },
            config: config,
            contains: contains,
            isOpen: isOpen,
            sync: syncPosition
        };
    }();
}).call(module.exports);
/***
Modal dialogs
=============

Instead of [linking to a page fragment](/up.link), you can choose to show a fragment
in a modal dialog. The existing page will remain open in the background.

To open a modal, add an [`[up-modal]`](/a-up-modal) attribute to a link:

    <a href="/blogs" up-modal=".blog-list">Switch blog</a>

When this link is clicked, Unpoly will request the path `/blogs` and extract
an element matching the selector `.blog-list` from the response. The matching element
will then be placed in a modal dialog.


\#\#\# Closing behavior

By default the dialog automatically closes
*when a link inside a modal changes a fragment behind the modal*.
This is useful to have the dialog interact with the page that
opened it, e.g. by updating parts of a larger form.

To disable this behavior, give the opening link an [`up-sticky`](/a-up-modal#up-sticky) attribute:


\#\#\# Customizing the dialog design

Dialogs have a minimal default design:

- Contents are displayed in a white box with a subtle box shadow
- The box will grow to fit the dialog contents, but never grow larger than the screen
- The box is placed over a semi-transparent backdrop to dim the rest of the page
- There is a button to close the dialog in the top-right corner

The easiest way to change how the dialog looks is to override the
[default CSS styles](https://github.com/unpoly/unpoly/blob/master/lib/assets/stylesheets/unpoly/modal.sass).

By default the dialog uses the following DOM structure:

    <div class="up-modal">
      <div class="up-modal-backdrop">
      <div class="up-modal-viewport">
        <div class="up-modal-dialog">
          <div class="up-modal-content">
            <!-- the matching element will be placed here -->
          </div>
          <div class="up-modal-close" up-close>X</div>
        </div>
      </div>
    </div>

You can change this structure by setting [`up.modal.config.template`](/up.modal.config#config.template) to a new template string
or function.


@module up.modal
 */ (function() {
    up.modal = function() {
        var animate, autoclose, bodyShifter, chain, closeAsap, closeNow, config, contains, createHiddenFrame, discardHistory, e, extractAsap, flavor, flavorDefault, flavorOverrides, flavors, followAsap, isOpen, markAsAnimating, openAsap, openNow, part, preloadNow, reset, state, templateHtml, u, unveilFrame, validateTarget, visitAsap;
        u = up.util;
        e = up.element;
        /***
    Sets default options for future modals.
    
    @property up.modal.config
    @param {string} [config.history=true]
      Whether opening a modal will add a browser history entry.
    @param {number} [config.width]
      The width of the dialog as a CSS value like `'400px'` or `'50%'`.
    
      Defaults to `undefined`, meaning that the dialog will grow to fit its contents
      until it reaches `config.maxWidth`. Leaving this as `undefined` will
      also allow you to control the width using CSS on `.up-modal-dialog´.
    @param {number} [config.maxWidth]
      The width of the dialog as a CSS value like `'400px'` or `50%`.
      You can set this to `undefined` to make the dialog fit its contents.
      Be aware however, that e.g. Bootstrap stretches input elements
      to `width: 100%`, meaning the dialog will also stretch to the full
      width of the screen.
    @param {number} [config.height='auto']
      The height of the dialog in pixels.
      Defaults to `undefined`, meaning that the dialog will grow to fit its contents.
    @param {string|Function(config): string} [config.template]
      A string containing the HTML structure of the modal.
      You can supply an alternative template string, but make sure that it
      defines tag with the classes `up-modal`, `up-modal-dialog` and  `up-modal-content`.
    
      You can also supply a function that returns a HTML string.
      The function will be called with the modal options (merged from these defaults
      and any per-open overrides) whenever a modal opens.
    @param {string} [config.closeLabel='×']
      The label of the button that closes the dialog.
    @param {boolean} [config.closable=true]
      When `true`, the modal will render a close icon and close when the user
      clicks on the backdrop or presses Escape.
    
      When `false`, you need to either supply an element with `[up-close]` or
      close the modal manually with `up.modal.close()`.
    @param {string} [config.openAnimation='fade-in']
      The animation used to open the viewport around the dialog.
    @param {string} [config.closeAnimation='fade-out']
      The animation used to close the viewport the dialog.
    @param {string} [config.backdropOpenAnimation='fade-in']
      The animation used to open the backdrop that dims the page below the dialog.
    @param {string} [config.backdropCloseAnimation='fade-out']
      The animation used to close the backdrop that dims the page below the dialog.
    @param {number} [config.openDuration]
      The duration of the open animation (in milliseconds).
    @param {number} [config.closeDuration]
      The duration of the close animation (in milliseconds).
    @param {string} [config.openEasing]
      The timing function controlling the acceleration of the opening animation.
    @param {string} [config.closeEasing]
      The timing function controlling the acceleration of the closing animation.
    @param {boolean} [options.sticky=false]
      If set to `true`, the modal remains
      open even it changes the page in the background.
    @param {string} [options.flavor='default']
      The default [flavor](/up.modal.flavors).
    @stable
     */ config = new up.Config({
            maxWidth: null,
            width: null,
            height: null,
            history: true,
            openAnimation: "fade-in",
            closeAnimation: "fade-out",
            openDuration: null,
            closeDuration: null,
            openEasing: null,
            closeEasing: null,
            backdropOpenAnimation: "fade-in",
            backdropCloseAnimation: "fade-out",
            closeLabel: "\xd7",
            closable: true,
            sticky: false,
            flavor: "default",
            position: null,
            template: function(options) {
                return '<div class="up-modal">\n  <div class="up-modal-backdrop"></div>\n  <div class="up-modal-viewport">\n    <div class="up-modal-dialog">\n      <div class="up-modal-content"></div>\n      <div class="up-modal-close" up-close>' + options.closeLabel + "</div>\n    </div>\n  </div>\n</div>";
            }
        });
        /***
    Define modal variants with their own default configuration, CSS or HTML template.
    
    \#\#\# Example
    
    Unpoly's [`[up-drawer]`](/a-up-drawer) is implemented as a modal flavor:
    
        up.modal.flavors.drawer = {
          openAnimation: 'move-from-right',
          closeAnimation: 'move-to-right'
        }
    
    Modals with that flavor will have a container with an `up-flavor` attribute:
    
        <div class='up-modal' up-flavor='drawer'>
          ...
        </div>
    
    We can target the `up-flavor` attribute to override the default dialog styles:
    
        .up-modal[up-flavor='drawer'] {
    
          .up-modal-dialog {
            margin: 0;         // Remove margin so drawer starts at the screen edge
            max-width: 350px;  // Set drawer size
          }
    
          .up-modal-content {
            min-height: 100vh; // Stretch background to full window height
          }
        }
    
    @property up.modal.flavors
    @param {Object} flavors
      An object where the keys are flavor names (e.g. `'drawer') and
      the values are the respective default configurations.
    @experimental
     */ flavors = new up.Config({
            "default": {}
        });
        /***
    Returns the source URL for the fragment displayed in the current modal overlay,
    or `undefined` if no modal is currently open.
    
    @function up.modal.url
    @return {string}
      the source URL
    @stable
     */ /***
    Returns the URL of the page behind the modal overlay.
    
    @function up.modal.coveredUrl
    @return {string}
    @experimental
     */ state = new up.Config({
            phase: "closed",
            anchorElement: null,
            modalElement: null,
            sticky: null,
            closable: null,
            flavor: null,
            url: null,
            coveredUrl: null,
            coveredTitle: null,
            position: null
        });
        bodyShifter = new up.BodyShifter();
        chain = new up.DivertibleChain();
        reset = function() {
            if (state.modalElement) e.remove(state.modalElement);
            bodyShifter.unshift();
            state.reset();
            chain.reset();
            config.reset();
            return flavors.reset();
        };
        templateHtml = function() {
            var template;
            template = flavorDefault("template");
            return u.evalOption(template, {
                closeLabel: flavorDefault("closeLabel")
            });
        };
        discardHistory = function() {
            state.coveredTitle = null;
            return state.coveredUrl = null;
        };
        part = function(name) {
            var selector;
            selector = ".up-modal-" + name;
            return state.modalElement.querySelector(selector);
        };
        createHiddenFrame = function(target, options) {
            var closeElement, contentElement, dialogStyles, html, modalElement;
            html = templateHtml();
            state.modalElement = modalElement = e.createFromHtml(html);
            modalElement.setAttribute("aria-modal", "true");
            modalElement.setAttribute("up-flavor", state.flavor);
            if (u.isPresent(state.position)) modalElement.setAttribute("up-position", state.position);
            dialogStyles = u.only(options, "width", "maxWidth", "height");
            e.setStyle(part("dialog"), dialogStyles);
            if (!state.closable) {
                closeElement = part("close");
                e.remove(closeElement);
            }
            contentElement = part("content");
            up.fragment.createPlaceholder(target, contentElement);
            e.hide(modalElement);
            return document.body.appendChild(modalElement);
        };
        unveilFrame = function() {
            return e.show(state.modalElement);
        };
        /***
    Returns whether a modal is currently open.
    
    This also returns `true` if the modal is in an opening or closing animation.
    
    @function up.modal.isOpen
    @return {boolean}
    @stable
     */ isOpen = function() {
            return state.phase === "opened" || state.phase === "opening";
        };
        /***
    Opens the given link's destination in a modal overlay:
    
        var link = document.querySelector('a')
        up.modal.follow(link)
    
    Any option attributes for [`a[up-modal]`](/a-up-modal) will be honored.
    
    Emits events [`up:modal:open`](/up:modal:open) and [`up:modal:opened`](/up:modal:opened).
    
    @function up.modal.follow
    @param {Element|jQuery|string} linkOrSelector
      The link to follow.
    @param {string} [options.target]
      The selector to extract from the response and open in a modal dialog.
    @param {number} [options.width]
      The width of the dialog in pixels.
      By [default](/up.modal.config) the dialog will grow to fit its contents.
    @param {number} [options.height]
      The width of the dialog in pixels.
      By [default](/up.modal.config) the dialog will grow to fit its contents.
    @param {boolean} [options.sticky=false]
      If set to `true`, the modal remains
      open even it changes the page in the background.
    @param {boolean} [config.closable=true]
      When `true`, the modal will render a close icon and close when the user
      clicks on the backdrop or presses Escape.
    
      When `false`, you need to either supply an element with `[up-close]` or
      close the modal manually with `up.modal.close()`.
    @param {string} [options.confirm]
      A message that will be displayed in a cancelable confirmation dialog
      before the modal is being opened.
    @param {string} [options.method="GET"]
      Override the request method.
    @param {boolean} [options.history=true]
      Whether to add a browser history entry for the modal's source URL.
    @param {string} [options.animation]
      The animation to use when opening the modal.
    @param {number} [options.duration]
      The duration of the animation. See [`up.animate()`](/up.animate).
    @param {number} [options.delay]
      The delay before the animation starts. See [`up.animate()`](/up.animate).
    @param {string} [options.easing]
      The timing function that controls the animation's acceleration. [`up.animate()`](/up.animate).
    @return {Promise}
      A promise that will be fulfilled when the modal has been loaded and
      the opening animation has completed.
    @stable
     */ followAsap = function(linkOrSelector, options) {
            options = u.options(options);
            options.link = e.get(linkOrSelector);
            return openAsap(options);
        };
        preloadNow = function(link, options) {
            options = u.options(options);
            options.link = link;
            options.preload = true;
            return openNow(options);
        };
        /***
    Opens a modal for the given URL.
    
    \#\#\# Example
    
        up.modal.visit('/foo', { target: '.list' })
    
    This will request `/foo`, extract the `.list` selector from the response
    and open the selected container in a modal dialog.
    
    Emits events [`up:modal:open`](/up:modal:open) and [`up:modal:opened`](/up:modal:opened).
    
    @function up.modal.visit
    @param {string} url
      The URL to load.
    @param {string} options.target
      The CSS selector to extract from the response.
      The extracted content will be placed into the dialog window.
    @param {Object} options
      See options for [`up.modal.follow()`](/up.modal.follow).
    @return {Promise}
      A promise that will be fulfilled when the modal has been loaded and the opening
      animation has completed.
    @stable
     */ visitAsap = function(url, options) {
            options = u.options(options);
            options.url = url;
            return openAsap(options);
        };
        /***
    [Extracts](/up.extract) the given CSS selector from the given HTML string and
    opens the results in a modal.
    
    \#\#\# Example
    
        var html = 'before <div class="content">inner</div> after';
        up.modal.extract('.content', html)
    
    The would open a modal with the following contents:
    
        <div class="content">inner</div>
    
    Emits events [`up:modal:open`](/up:modal:open) and [`up:modal:opened`](/up:modal:opened).
    
    @function up.modal.extract
    @param {string} selector
      The CSS selector to extract from the HTML.
    @param {string} html
      The HTML containing the modal content.
    @param {Object} options
      See options for [`up.modal.follow()`](/up.modal.follow).
    @return {Promise}
      A promise that will be fulfilled when the modal has been opened and the opening
      animation has completed.
    @stable
     */ extractAsap = function(selector, html, options) {
            options = u.options(options);
            options.html = html;
            if (options.history == null) options.history = false;
            options.target = selector;
            return openAsap(options);
        };
        openAsap = function(options) {
            return chain.asap(closeNow, function() {
                return openNow(options);
            });
        };
        openNow = function(options) {
            var animateOptions, html, link, ref, ref1, ref10, ref11, ref12, ref13, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, target, url;
            options = u.options(options);
            link = u.pluckKey(options, "link") || e.none();
            url = (ref = (ref1 = u.pluckKey(options, "url")) != null ? ref1 : link.getAttribute("up-href")) != null ? ref : link.getAttribute("href");
            html = u.pluckKey(options, "html");
            target = (ref2 = u.pluckKey(options, "target")) != null ? ref2 : link.getAttribute("up-modal");
            validateTarget(target);
            if (options.flavor == null) options.flavor = (ref3 = link.getAttribute("up-flavor")) != null ? ref3 : config.flavor;
            if (options.position == null) options.position = (ref4 = link.getAttribute("up-position")) != null ? ref4 : flavorDefault("position", options.flavor);
            options.position = u.evalOption(options.position, {
                link: link
            });
            if (options.width == null) options.width = (ref5 = link.getAttribute("up-width")) != null ? ref5 : flavorDefault("width", options.flavor);
            if (options.maxWidth == null) options.maxWidth = (ref6 = link.getAttribute("up-max-width")) != null ? ref6 : flavorDefault("maxWidth", options.flavor);
            if (options.height == null) options.height = (ref7 = link.getAttribute("up-height")) != null ? ref7 : flavorDefault("height");
            if (options.animation == null) options.animation = (ref8 = link.getAttribute("up-animation")) != null ? ref8 : flavorDefault("openAnimation", options.flavor);
            options.animation = u.evalOption(options.animation, {
                position: options.position
            });
            if (options.backdropAnimation == null) options.backdropAnimation = (ref9 = link.getAttribute("up-backdrop-animation")) != null ? ref9 : flavorDefault("backdropOpenAnimation", options.flavor);
            options.backdropAnimation = u.evalOption(options.backdropAnimation, {
                position: options.position
            });
            if (options.sticky == null) options.sticky = (ref10 = e.booleanAttr(link, "up-sticky")) != null ? ref10 : flavorDefault("sticky", options.flavor);
            if (options.closable == null) options.closable = (ref11 = e.booleanAttr(link, "up-closable")) != null ? ref11 : flavorDefault("closable", options.flavor);
            if (options.confirm == null) options.confirm = link.getAttribute("up-confirm");
            options.method = up.link.followMethod(link, options);
            options.layer = "modal";
            if (options.failTarget == null) options.failTarget = link.getAttribute("up-fail-target");
            if (options.failLayer == null) options.failLayer = (ref12 = link.getAttribute("up-fail-layer")) != null ? ref12 : "auto";
            if (options.cache == null) options.cache = e.booleanAttr(link, "up-cache");
            animateOptions = up.motion.animateOptions(options, link, {
                duration: flavorDefault("openDuration", options.flavor),
                easing: flavorDefault("openEasing", options.flavor)
            });
            if (options.history == null) options.history = (ref13 = e.booleanOrStringAttr(link, "up-history")) != null ? ref13 : flavorDefault("history", options.flavor);
            if (!up.browser.canPushState()) options.history = false;
            options.provideTarget = function() {
                return createHiddenFrame(target, options);
            };
            if (options.preload) return up.replace(target, url, options);
            return up.browser.whenConfirmed(options).then(function() {
                return up.event.whenEmitted("up:modal:open", {
                    url: url,
                    log: "Opening modal"
                }).then(function() {
                    var extractOptions, promise;
                    state.phase = "opening";
                    state.flavor = options.flavor;
                    state.sticky = options.sticky;
                    state.closable = options.closable;
                    state.position = options.position;
                    if (options.history) {
                        state.coveredUrl = up.browser.url();
                        state.coveredTitle = document.title;
                    }
                    extractOptions = u.merge(options, {
                        animation: false
                    });
                    if (html) promise = up.extract(target, html, extractOptions);
                    else promise = up.replace(target, url, extractOptions);
                    promise = promise.then(function() {
                        bodyShifter.shift();
                        unveilFrame();
                        return animate(options.animation, options.backdropAnimation, animateOptions);
                    });
                    promise = promise.then(function() {
                        state.phase = "opened";
                        return up.emit("up:modal:opened", {
                            log: "Modal opened"
                        });
                    });
                    return promise;
                });
            });
        };
        validateTarget = function(target) {
            if (u.isBlank(target)) return up.fail("Cannot open a modal without a target selector");
            else if (target === "body") return up.fail("Cannot open the <body> in a modal");
        };
        /***
    This event is [emitted](/up.emit) when a modal dialog is starting to open.
    
    @event up:modal:open
    @param event.preventDefault()
      Event listeners may call this method to prevent the modal from opening.
    @stable
     */ /***
    This event is [emitted](/up.emit) when a modal dialog has finished opening.
    
    @event up:modal:opened
    @stable
     */ /***
    Closes a currently opened modal overlay.
    
    Does nothing if no modal is currently open.
    
    Emits events [`up:modal:close`](/up:modal:close) and [`up:modal:closed`](/up:modal:closed).
    
    @function up.modal.close
    @param {Object} options
      See options for [`up.animate()`](/up.animate)
    @return {Promise}
      A promise that will be fulfilled once the modal's close
      animation has finished.
    @stable
     */ closeAsap = function(options) {
            return chain.asap(function() {
                return closeNow(options);
            });
        };
        closeNow = function(options) {
            var animateOptions, backdropCloseAnimation, destroyOptions, ref, ref1, viewportCloseAnimation;
            options = u.options(options);
            if (!isOpen()) return Promise.resolve();
            viewportCloseAnimation = (ref = options.animation) != null ? ref : flavorDefault("closeAnimation");
            viewportCloseAnimation = u.evalOption(viewportCloseAnimation, {
                position: state.position
            });
            backdropCloseAnimation = (ref1 = options.backdropAnimation) != null ? ref1 : flavorDefault("backdropCloseAnimation");
            backdropCloseAnimation = u.evalOption(backdropCloseAnimation, {
                position: state.position
            });
            animateOptions = up.motion.animateOptions(options, {
                duration: flavorDefault("closeDuration"),
                easing: flavorDefault("closeEasing")
            });
            destroyOptions = u.options(u.except(options, "animation", "duration", "easing", "delay"), {
                history: state.coveredUrl,
                title: state.coveredTitle
            });
            return up.event.whenEmitted(state.modalElement, "up:modal:close", {
                log: "Closing modal"
            }).then(function() {
                var promise;
                state.phase = "closing";
                state.url = null;
                state.coveredUrl = null;
                state.coveredTitle = null;
                promise = animate(viewportCloseAnimation, backdropCloseAnimation, animateOptions);
                promise = promise.then(function() {
                    return up.destroy(state.modalElement, destroyOptions);
                });
                promise = promise.then(function() {
                    bodyShifter.unshift();
                    state.phase = "closed";
                    state.modalElement = null;
                    state.flavor = null;
                    state.sticky = null;
                    state.closable = null;
                    state.position = null;
                    return up.emit("up:modal:closed", {
                        log: "Modal closed"
                    });
                });
                return promise;
            });
        };
        markAsAnimating = function(isAnimating) {
            if (isAnimating == null) isAnimating = true;
            return e.toggleClass(state.modalElement, "up-modal-animating", isAnimating);
        };
        animate = function(viewportAnimation, backdropAnimation, animateOptions) {
            var promise;
            if (up.motion.isNone(viewportAnimation)) return Promise.resolve();
            else {
                markAsAnimating();
                promise = Promise.all([
                    up.animate(part("viewport"), viewportAnimation, animateOptions),
                    up.animate(part("backdrop"), backdropAnimation, animateOptions)
                ]);
                promise = promise.then(function() {
                    return markAsAnimating(false);
                });
                return promise;
            }
        };
        /***
    This event is [emitted](/up.emit) when a modal dialog
    is starting to [close](/up.modal.close).
    
    @event up:modal:close
    @param event.preventDefault()
      Event listeners may call this method to prevent the modal from closing.
    @stable
     */ /***
    This event is [emitted](/up.emit) when a modal dialog
    is done [closing](/up.modal.close).
    
    @event up:modal:closed
    @stable
     */ autoclose = function() {
            if (!state.sticky) {
                discardHistory();
                return closeAsap();
            }
        };
        /***
    Returns whether the given element or selector is contained
    within the current modal.
    
    @function up.modal.contains
    @param {string} elementOrSelector
      The element to test
    @return {boolean}
    @stable
     */ contains = function(elementOrSelector) {
            var element;
            element = e.get(elementOrSelector);
            return !!e.closest(element, ".up-modal");
        };
        flavor = function(name, overrideConfig) {
            if (overrideConfig == null) overrideConfig = {};
            up.legacy.warn("up.modal.flavor() is deprecated. Use the up.modal.flavors property instead.");
            return u.assign(flavorOverrides(name), overrideConfig);
        };
        /***
    Returns a config object for the given flavor.
    Properties in that config should be preferred to the defaults in
    [`/up.modal.config`](/up.modal.config).
    
    @function flavorOverrides
    @internal
     */ flavorOverrides = function(flavor) {
            return flavors[flavor] || (flavors[flavor] = {});
        };
        /***
    Returns the config option for the current flavor.
    
    @function flavorDefault
    @internal
     */ flavorDefault = function(key, flavorName) {
            var value;
            if (flavorName == null) flavorName = state.flavor;
            if (flavorName) value = flavorOverrides(flavorName)[key];
            if (u.isMissing(value)) value = config[key];
            return value;
        };
        /***
    Clicking this link will load the destination via AJAX and open
    the given selector in a modal dialog.
    
    \#\#\# Example
    
        <a href="/blogs" up-modal=".blog-list">Switch blog</a>
    
    Clicking would request the path `/blog` and select `.blog-list` from
    the HTML response. Unpoly will dim the page
    and place the matching `.blog-list` tag in
    a modal dialog.
    
    @selector a[up-modal]
    @param {string} up-modal
      The CSS selector that will be extracted from the response and displayed in a modal dialog.
    @param {string} [up-confirm]
      A message that will be displayed in a cancelable confirmation dialog
      before the modal is opened.
    @param {string} [up-method='GET']
      Override the request method.
    @param {string} [up-sticky]
      If set to `"true"`, the modal remains
      open even if the page changes in the background.
    @param {boolean} [up-closable]
      When `true`, the modal will render a close icon and close when the user
      clicks on the backdrop or presses Escape.
    
      When `false`, you need to either supply an element with `[up-close]` or
      close the modal manually with `up.modal.close()`.
    @param {string} [up-animation]
      The animation to use when opening the viewport containing the dialog.
    @param {string} [up-backdrop-animation]
      The animation to use when opening the backdrop that dims the page below the dialog.
    @param {string} [up-height]
      The width of the dialog in pixels.
      By [default](/up.modal.config) the dialog will grow to fit its contents.
    @param {string} [up-width]
      The width of the dialog in pixels.
      By [default](/up.modal.config) the dialog will grow to fit its contents.
    @param {string} [up-history]
      Whether to push an entry to the browser history for the modal's source URL.
    
      Set this to `'false'` to prevent the URL bar from being updated.
      Set this to a URL string to update the history with the given URL.
    
    @stable
     */ up.link.addFollowVariant("[up-modal]", {
            follow: function(link, options) {
                return followAsap(link, options);
            },
            preload: function(link, options) {
                return preloadNow(link, options);
            }
        });
        up.on("click", ".up-modal", function(event) {
            var target;
            if (!state.closable) return;
            target = event.target;
            if (!(e.closest(target, ".up-modal-dialog") || e.closest(target, "[up-modal]"))) {
                up.event.consumeAction(event);
                return u.muteRejection(closeAsap());
            }
        });
        up.on("up:fragment:inserted", function(event, fragment) {
            var newSource;
            if (contains(fragment)) {
                if (newSource = fragment.getAttribute("up-source")) return state.url = newSource;
            } else if (event.origin && contains(event.origin) && !up.popup.contains(fragment)) return u.muteRejection(autoclose());
        });
        up.event.onEscape(function() {
            if (state.closable) return u.muteRejection(closeAsap());
        });
        /***
    When this element is clicked, closes a currently open dialog.
    
    Does nothing if no modal is currently open.
    
    To make a link that closes the current modal, but follows to
    a fallback destination if no modal is open:
    
        <a href="/fallback" up-close>Okay</a>
    
    @selector .up-modal [up-close]
    @stable
     */ up.on("click", ".up-modal [up-close]", function(event) {
            u.muteRejection(closeAsap());
            return up.event.consumeAction(event);
        });
        /***
    Clicking this link will load the destination via AJAX and open
    the given selector in a modal drawer that slides in from the edge of the screen.
    
    You can configure drawers using the [`up.modal.flavors.drawer`](/up.modal.flavors.drawer) property.
    
    \#\#\# Example
    
        <a href="/blogs" up-drawer=".blog-list">Switch blog</a>
    
    Clicking would request the path `/blog` and select `.blog-list` from
    the HTML response. Unpoly will dim the page
    and place the matching `.blog-list` tag will be placed in
    a modal drawer.
    
    @selector a[up-drawer]
    @param {string} up-drawer
      The CSS selector to extract from the response and open in the drawer.
    @param {string} [up-position='auto']
      The side from which the drawer slides in.
    
      Valid values are `'left'`, `'right'` and `'auto'`. If set to `'auto'`, the
      drawer will slide in from left if the opening link is on the left half of the screen.
      Otherwise it will slide in from the right.
    @stable
     */ up.macro("a[up-drawer], [up-href][up-drawer]", function(link) {
            var target;
            target = link.getAttribute("up-drawer");
            return e.setAttrs(link, {
                "up-modal": target,
                "up-flavor": "drawer"
            });
        });
        /***
    Sets default options for future drawers.
    
    @property up.modal.flavors.drawer
    @param {Object} config
      Default options for future drawers.
    
      See [`up.modal.config`](/up.modal.config) for available options.
    @experimental
     */ flavors.drawer = {
            openAnimation: function(options) {
                switch(options.position){
                    case "left":
                        return "move-from-left";
                    case "right":
                        return "move-from-right";
                }
            },
            closeAnimation: function(options) {
                switch(options.position){
                    case "left":
                        return "move-to-left";
                    case "right":
                        return "move-to-right";
                }
            },
            position: function(options) {
                if (u.isPresent(options.link)) return u.horizontalScreenHalf(options.link);
                else return "left";
            }
        };
        up.on("up:history:restore", function() {
            return u.muteRejection(closeAsap());
        });
        up.on("up:framework:reset", reset);
        return {
            visit: visitAsap,
            follow: followAsap,
            extract: extractAsap,
            close: closeAsap,
            url: function() {
                return state.url;
            },
            coveredUrl: function() {
                return state.coveredUrl;
            },
            config: config,
            flavors: flavors,
            contains: contains,
            isOpen: isOpen,
            flavor: flavor
        };
    }();
}).call(module.exports);
/***
Tooltips
========

Unpoly comes with a basic tooltip implementation.

Add an [`up-tooltip`](/up-tooltip) attribute to any HTML tag to show a tooltip whenever
the user hovers over the element:

      <a href="/decks" up-tooltip="Show all decks">Decks</a>


\#\#\# Styling

The default styles
render a tooltip with white text on a gray background.
A gray triangle points to the element.

To change the styling, simply override the [CSS rules](https://github.com/unpoly/unpoly/blob/master/lib/assets/stylesheets/unpoly/tooltip.sass) for the `.up-tooltip` selector and its `:after`
selector that is used for the triangle.

The HTML of a tooltip element looks like this:

    <div class="up-tooltip">
      <div class="up-tooltip-content">
        Tooltip text here
      </div>
    </div>

The tooltip element is appended to the [viewport](/up.viewport) of the anchor element.

@module up.tooltip
 */ (function() {
    up.tooltip = function() {
        var attachAsap, attachNow, chain, closeAsap, closeNow, config, createElement, e, isOpen, reset, state, syncPosition, u;
        u = up.util;
        e = up.element;
        /***
    Configures defaults for future tooltips.
    
    @property up.tooltip.config
    @param {string} [config.position]
      The default position of tooltips relative to the opening element.
    
      Valid values are `'top'`, `'right'`, `'bottom'` or `'left'`.
    @param {string} [config.align]
      Defines the alignment of the tooltip along its side.
    
      When the tooltip's `{ position }` is `'top'` or `'bottom'`, valid `{ align }` values are `'left'`, `center'` and `'right'`.
      When the tooltip's `{ position }` is `'left'` or `'right'`, valid `{ align }` values are `top'`, `center'` and `bottom'`.
    @param {string} [config.openAnimation='fade-in']
      The animation used to open a tooltip.
    @param {string} [config.closeAnimation='fade-out']
      The animation used to close a tooltip.
    @param {number} [config.openDuration]
      The duration of the open animation (in milliseconds).
    @param {number} [config.closeDuration]
      The duration of the close animation (in milliseconds).
    @param {string} [config.openEasing]
      The timing function controlling the acceleration of the opening animation.
    @param {string} [config.closeEasing]
      The timing function controlling the acceleration of the closing animation.
    @stable
     */ config = new up.Config({
            position: "top",
            align: "center",
            openAnimation: "fade-in",
            closeAnimation: "fade-out",
            openDuration: 100,
            closeDuration: 50,
            openEasing: null,
            closeEasing: null
        });
        state = new up.Config({
            phase: "closed",
            anchor: null,
            tooltip: null,
            content: null,
            tether: null,
            position: null,
            align: null
        });
        chain = new up.DivertibleChain();
        reset = function() {
            var ref;
            if ((ref = state.tether) != null) ref.destroy();
            state.reset();
            chain.reset();
            return config.reset();
        };
        createElement = function(options) {
            state.tether = new up.Tether(u.only(state, "anchor", "position", "align"));
            state.tooltip = e.affix(state.tether.root, ".up-tooltip", {
                "up-position": state.position,
                "up-align": state.align
            });
            state.content = e.affix(state.tooltip, ".up-tooltip-content");
            if (options.text) return state.content.innerText = options.text;
            else return state.content.innerHTML = options.html;
        };
        /***
    Forces the tooltip to update its position relative to its anchor element.
    
    Unpoly will automatically keep tooltips aligned when
    the document is resized or scrolled. Complex layout changes may make
    it necessary to call this function.
    
    @function up.tooltip.sync
    @experimental
     */ syncPosition = function() {
            var ref;
            return (ref = state.tether) != null ? ref.sync() : void 0;
        };
        /***
    Opens a tooltip over the given element.
    
    The unobtrusive variant of this is the [`[up-tooltip]`](/up-tooltip) selector.
    
    \#\#\# Examples
    
    In order to attach a tooltip to a `<span class="help">?</span>`:
    
        up.tooltip.attach('.help', { text: 'Useful info' })
    
    @function up.tooltip.attach
    @param {Element|jQuery|string} elementOrSelector
    @param {string} [options.text]
      The text to display in the tooltip.
    
      Any HTML control characters will be escaped.
      If you need to use HTML formatting in the tooltip, use `options.html` instead.
    @param {string} [options.html]
      The HTML to display in the tooltip unescaped.
    
      Make sure to escape any user-provided text before passing it as this option,
      or use `options.text` (which automatically escapes).
    @param {string} [options.position]
      The tooltip's position relative to the opening element.
    
      Valid values are `'top'`, `'right'`, `'bottom'` or `'left'`.
    @param {string} [options.align]
      Defines the alignment of the tooltip along its side.
    
      When the tooltip's `{ position }` is `'top'` or `'bottom'`, valid `{ align }` values are `'left'`, `center'` and `'right'`.
      When the tooltip's `{ position }` is `'left'` or `'right'`, valid `{ align }` values are `top'`, `center'` and `bottom'`.
    @param {string} [options.animation]
      The [animation](/up.motion) to use when opening the tooltip.
    @return {Promise}
      A promise that will be fulfilled when the tooltip's opening animation has finished.
    @stable
     */ attachAsap = function(elementOrSelector, options) {
            return chain.asap(closeNow, function() {
                return attachNow(elementOrSelector, options);
            });
        };
        attachNow = function(elementOrSelector, options) {
            var align, anchor, animateOptions, animation, html, position, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, text;
            if (options == null) options = {};
            anchor = e.get(elementOrSelector);
            html = (ref = options.html) != null ? ref : anchor.getAttribute("up-tooltip-html");
            text = (ref1 = options.text) != null ? ref1 : anchor.getAttribute("up-tooltip");
            position = (ref2 = (ref3 = options.position) != null ? ref3 : anchor.getAttribute("up-position")) != null ? ref2 : config.position;
            align = (ref4 = (ref5 = options.align) != null ? ref5 : anchor.getAttribute("up-align")) != null ? ref4 : config.align;
            animation = (ref6 = (ref7 = options.animation) != null ? ref7 : e.booleanOrStringAttr(anchor, "up-animation")) != null ? ref6 : config.openAnimation;
            animateOptions = up.motion.animateOptions(options, anchor, {
                duration: config.openDuration,
                easing: config.openEasing
            });
            state.phase = "opening";
            state.anchor = anchor;
            state.position = position;
            state.align = align;
            createElement({
                text: text,
                html: html
            });
            syncPosition();
            return up.animate(state.tooltip, animation, animateOptions).then(function() {
                return state.phase = "opened";
            });
        };
        /***
    Closes a currently shown tooltip.
    
    Does nothing if no tooltip is currently shown.
    
    @function up.tooltip.close
    @param {Object} options
      See options for [`up.animate()`](/up.animate).
    @return {Promise}
      A promise for the end of the closing animation.
    @stable
     */ closeAsap = function(options) {
            return chain.asap(function() {
                return closeNow(options);
            });
        };
        closeNow = function(options) {
            var animateOptions;
            if (!isOpen()) return Promise.resolve();
            options = u.options(options, {
                animation: config.closeAnimation
            });
            animateOptions = up.motion.animateOptions(options, {
                duration: config.closeDuration,
                easing: config.closeEasing
            });
            u.assign(options, animateOptions);
            state.phase = "closing";
            return up.destroy(state.tooltip, options).then(function() {
                state.phase = "closed";
                state.tether.destroy();
                state.tether = null;
                state.tooltip = null;
                state.content = null;
                return state.anchor = null;
            });
        };
        /***
    Returns whether a tooltip is currently showing.
    
    @function up.tooltip.isOpen
    @stable
     */ isOpen = function() {
            return state.phase === "opening" || state.phase === "opened";
        };
        /***
    Displays a tooltip with text content when hovering the mouse over this element.
    
    \#\#\# Example
    
        <a href="/decks" up-tooltip="Show all decks">Decks</a>
    
    To make the tooltip appear below the element instead of above the element,
    add an `up-position` attribute:
    
        <a href="/decks" up-tooltip="Show all decks" up-position="bottom">Decks</a>
    
    @selector [up-tooltip]
    @param {string} [up-animation]
      The animation used to open the tooltip.
      Defaults to [`up.tooltip.config.openAnimation`](/up.tooltip.config).
    @param {string} [up-position]
      The tooltip's position relative to the opening element.
    
      Valid values are `'top'`, `'right'`, `'bottom'` or `'left'`.
    @param {string} [up-align]
      Defines the alignment of the tooltip along its side.
    
      When the tooltip's `{ position }` is `'top'` or `'bottom'`, valid `{ align }` values are `'left'`, `center'` and `'right'`.
      When the tooltip's `{ position }` is `'left'` or `'right'`, valid `{ align }` values are `top'`, `center'` and `bottom'`.
    @stable
     */ /***
    Displays a tooltip with HTML content when hovering the mouse over this element:
    
        <a href="/decks" up-tooltip-html="Show &lt;b&gt;all&lt;/b&gt; decks">Decks</a>
    
    @selector [up-tooltip-html]
    @stable
     */ up.compiler("[up-tooltip], [up-tooltip-html]", function(opener) {
            opener.addEventListener("mouseenter", function() {
                return attachAsap(opener);
            });
            return opener.addEventListener("mouseleave", function() {
                return closeAsap();
            });
        });
        up.on("click up:action:consumed", function(_event) {
            return closeAsap();
        });
        up.on("up:framework:reset", reset);
        up.event.onEscape(function() {
            return closeAsap();
        });
        return {
            config: config,
            attach: attachAsap,
            isOpen: isOpen,
            close: closeAsap,
            sync: syncPosition
        };
    }();
}).call(module.exports);
/***
Navigation feedback
===================

The `up.feedback` module adds useful CSS classes to links while they are loading,
or when they point to the current URL. By styling these classes you may
provide instant feedback to user interactions. This improves the perceived speed of your interface.


\#\#\# Example

Let's say we have an navigation bar with two links, pointing to `/foo` and `/bar` respectively:

    <div up-nav>
      <a href="/foo" up-follow>Foo</a>
      <a href="/bar" up-follow>Bar</a>
    </div>

If the current URL is `/foo`, the first link is automatically marked with an [`.up-current`](/a.up-current) class:

    <div up-nav>
      <a href="/foo" up-follow class="up-current">Foo</a>
      <a href="/bar" up-follow>Bar</a>
    </div>

When the user clicks on the `/bar` link, the link will receive the [`up-active`](/a.up-active) class while it is waiting
for the server to respond:

    <div up-nav>
      <a href="/foo" up-follow class="up-current">Foo</a>
      <a href="/bar" up-follow class="up-active">Bar</a>
    </div>

Once the response is received the URL will change to `/bar` and the `up-active` class is removed:

    <div up-nav>
      <a href="/foo" up-follow>Foo</a>
      <a href="/bar" up-follow class="up-current">Bar</a>
    </div>


@module up.feedback
 */ (function() {
    up.feedback = function() {
        var CLASS_ACTIVE, SELECTOR_LINK, buildCurrentUrlSet, buildSectionUrls, config, currentUrlSet, e, findActivatableArea, navSelector, normalizeUrl, previousUrlSet, reset, sectionUrls, start, stop, u, updateAllNavigationSections, updateAllNavigationSectionsIfLocationChanged, updateCurrentClassForLinks, updateNavigationSectionsInNewFragment;
        u = up.util;
        e = up.element;
        /***
    Sets default options for this module.
    
    @property up.feedback.config
    @param {Array<string>} [config.currentClasses]
      An array of classes to set on [links that point the current location](/a.up-current).
    @param {Array<string>} [config.navs]
      An array of CSS selectors that match [navigation components](/up-nav).
    @stable
     */ config = new up.Config({
            currentClasses: [
                "up-current"
            ],
            navs: [
                "[up-nav]"
            ]
        });
        previousUrlSet = void 0;
        currentUrlSet = void 0;
        reset = function() {
            config.reset();
            previousUrlSet = void 0;
            return currentUrlSet = void 0;
        };
        CLASS_ACTIVE = "up-active";
        SELECTOR_LINK = "a, [up-href]";
        navSelector = function() {
            return config.navs.join(",");
        };
        normalizeUrl = function(url) {
            if (u.isPresent(url)) return u.normalizeUrl(url, {
                stripTrailingSlash: true
            });
        };
        sectionUrls = function(section) {
            var urls;
            if (!(urls = section.upNormalizedUrls)) {
                urls = buildSectionUrls(section);
                section.upNormalizedUrls = urls;
            }
            return urls;
        };
        buildSectionUrls = function(section) {
            var attr, i, j, len, len1, ref, ref1, url, urls, value;
            urls = [];
            if (up.link.isSafe(section)) {
                ref = [
                    "href",
                    "up-href",
                    "up-alias"
                ];
                for(i = 0, len = ref.length; i < len; i++){
                    attr = ref[i];
                    if (value = section.getAttribute(attr)) {
                        ref1 = u.splitValues(value);
                        for(j = 0, len1 = ref1.length; j < len1; j++){
                            url = ref1[j];
                            if (url !== "#") {
                                url = normalizeUrl(url);
                                urls.push(url);
                            }
                        }
                    }
                }
            }
            return urls;
        };
        buildCurrentUrlSet = function() {
            var urls;
            urls = [
                up.browser.url(),
                up.modal.url(),
                up.modal.coveredUrl(),
                up.popup.url(),
                up.popup.coveredUrl()
            ];
            return new up.UrlSet(urls, {
                normalizeUrl: normalizeUrl
            });
        };
        updateAllNavigationSectionsIfLocationChanged = function() {
            previousUrlSet = currentUrlSet;
            currentUrlSet = buildCurrentUrlSet();
            if (!u.isEqual(currentUrlSet, previousUrlSet)) return updateAllNavigationSections(document.body);
        };
        updateAllNavigationSections = function(root) {
            var navs, sections;
            navs = e.subtree(root, navSelector());
            sections = u.flatMap(navs, function(nav) {
                return e.subtree(nav, SELECTOR_LINK);
            });
            return updateCurrentClassForLinks(sections);
        };
        updateNavigationSectionsInNewFragment = function(fragment) {
            var sections;
            if (e.closest(fragment, navSelector())) {
                sections = e.subtree(fragment, SELECTOR_LINK);
                return updateCurrentClassForLinks(sections);
            } else return updateAllNavigationSections(fragment);
        };
        updateCurrentClassForLinks = function(links) {
            currentUrlSet || (currentUrlSet = buildCurrentUrlSet());
            return u.each(links, function(link) {
                var classList, i, j, klass, len, len1, ref, ref1, results, results1, urls;
                urls = sectionUrls(link);
                classList = link.classList;
                if (currentUrlSet.matchesAny(urls)) {
                    ref = config.currentClasses;
                    results = [];
                    for(i = 0, len = ref.length; i < len; i++){
                        klass = ref[i];
                        results.push(classList.add(klass));
                    }
                    return results;
                } else {
                    ref1 = config.currentClasses;
                    results1 = [];
                    for(j = 0, len1 = ref1.length; j < len1; j++){
                        klass = ref1[j];
                        results1.push(classList.remove(klass));
                    }
                    return results1;
                }
            });
        };
        /***
    @function findActivatableArea
    @param {string|Element|jQuery} elementOrSelector
    @internal
     */ findActivatableArea = function(element) {
            element = e.get(element);
            return e.ancestor(element, SELECTOR_LINK) || element;
        };
        /***
    Marks the given element as currently loading, by assigning the CSS class [`up-active`](/a.up-active).
    
    This happens automatically when following links or submitting forms through the Unpoly API.
    Use this function if you make custom network calls from your own JavaScript code.
    
    If the given element is a link within an [expanded click area](/up-expand),
    the class will be assigned to the expanded area.
    
    \#\#\# Example
    
        var button = document.querySelector('button')
    
        button.addEventListener('click', () => {
          up.feedback.start(button)
          up.request(...).then(() => {
            up.feedback.stop(button)
          })
        })
    
    @method up.feedback.start
    @param {Element|jQuery|string} element
      The element to mark as active
    @internal
     */ start = function(element) {
            return findActivatableArea(element).classList.add(CLASS_ACTIVE);
        };
        /***
    Links that are currently [loading through Unpoly](/form-up-target)
    are assigned the `up-active` class automatically.
    Style `.up-active` in your CSS to improve the perceived responsiveness
    of your user interface.
    
    The `up-active` class will be removed when the link is done loading.
    
    \#\#\# Example
    
    We have a link:
    
        <a href="/foo" up-follow>Foo</a>
    
    The user clicks on the link. While the request is loading,
    the link has the `up-active` class:
    
        <a href="/foo" up-follow class="up-active">Foo</a>
    
    Once the link destination has loaded and rendered, the `up-active` class
    is removed and the [`up-current`](/a.up-current) class is added:
    
        <a href="/foo" up-follow class="up-current">Foo</a>
    
    @selector a.up-active
    @stable
     */ /***
    Forms that are currently [loading through Unpoly](/a-up-target)
    are assigned the `up-active` class automatically.
    Style `.up-active` in your CSS to improve the perceived responsiveness
    of your user interface.
    
    The `up-active` class will be removed as soon as the response to the
    form submission has been received.
    
    \#\#\# Example
    
    We have a form:
    
        <form up-target=".foo">
          <button type="submit">Submit</button>
        </form>
    
    The user clicks on the submit button. While the form is being submitted
    and waiting for the server to respond, the form has the `up-active` class:
    
        <form up-target=".foo" class="up-active">
          <button type="submit">Submit</button>
        </form>
    
    Once the link destination has loaded and rendered, the `up-active` class
    is removed.
    
    @selector form.up-active
    @stable
     */ /***
    Marks the given element as no longer loading, by removing the CSS class [`up-active`](/a.up-active).
    
    This happens automatically when network requests initiated by the Unpoly API have completed.
    Use this function if you make custom network calls from your own JavaScript code.
    
    @function up.feedback.stop
    @param {Element|jQuery|string} element
      The link or form that has finished loading.
    @internal
     */ stop = function(element) {
            return findActivatableArea(element).classList.remove(CLASS_ACTIVE);
        };
        /***
    Marks this element as a navigation component, such as a menu or navigation bar.
    
    When a link within an `[up-nav]` element points to the current location, it is assigned the `.up-current` class. When the browser navigates to another location, the class is removed automatically.
    
    You may also assign `[up-nav]` to an individual link instead of an navigational container.
    
    If you don't want to manually add this attribute to every navigational element, you can configure selectors to automatically match your navigation components in [`up.feedback.config.navs`](/up.feedback.config#config.navs).
    
    
    \#\#\# Example
    
    Let's take a simple menu with two links. The menu has been marked with the `[up-nav]` attribute:
    
        <div up-nav>
          <a href="/foo">Foo</a>
          <a href="/bar">Bar</a>
        </div>
    
    If the browser location changes to `/foo`, the first link is marked as `.up-current`:
    
        <div up-nav>
          <a href="/foo" class="up-current">Foo</a>
          <a href="/bar">Bar</a>
        </div>
    
    If the browser location changes to `/bar`, the first link automatically loses its `.up-current` class. Now the second link is marked as `.up-current`:
    
        <div up-nav>
          <a href="/foo">Foo</a>
          <a href="/bar" class="up-current">Bar</a>
        </div>
    
    
    \#\#\# What is considered to be "current"?
    
    The current location is considered to be either:
    
    - the URL displayed in the browser window's location bar
    - the source URL of a [modal dialog](/up.modal)
    - the URL of the page behind a [modal dialog](/up.modal)
    - the source URL of a [popup overlay](/up.popup)
    - the URL of the content behind a [popup overlay](/up.popup)
    
    A link matches the current location (and is marked as `.up-current`) if it matches either:
    
    - the link's `href` attribute
    - the link's `up-href` attribute
    - a space-separated list of URLs in the link's `up-alias` attribute
    
    \#\#\# Matching URL by pattern
    
    You can mark a link as `.up-current` whenever the current URL matches a prefix or suffix.
    To do so, include an asterisk (`*`) in the `up-alias` attribute.
    
    For instance, the following `[up-nav]` link is highlighted for both `/reports` and `/reports/123`:
    
        <a up-nav href="/reports" up-alias="/reports/*">Reports</a>
    
    @selector [up-nav]
    @stable
     */ /***
    When a link within an `[up-nav]` element points to the current location, it is assigned the `.up-current` class.
    
    See [`[up-nav]`](/up-nav) for more documentation and examples.
    
    @selector [up-nav] a.up-current
    @stable
     */ up.on("up:history:pushed up:history:replaced up:history:restored up:modal:opened up:modal:closed up:popup:opened up:popup:closed", function(event) {
            return updateAllNavigationSectionsIfLocationChanged();
        });
        up.on("up:fragment:inserted", function(event, newFragment) {
            return updateNavigationSectionsInNewFragment(newFragment);
        });
        up.on("up:framework:reset", reset);
        return {
            config: config,
            start: start,
            stop: stop
        };
    }();
    up.legacy.renamedModule("navigation", "feedback");
}).call(module.exports);
/***
Passive updates
===============

This work-in-progress package will contain functionality to
passively receive updates from the server.

@module up.radio
 */ (function() {
    up.radio = function() {
        var config, hungrySelector, reset, u;
        u = up.util;
        /***
    Configures defaults for passive updates.
    
    @property up.radio.config
    @param {Array<string>} [options.hungry]
      An array of CSS selectors that is replaced whenever a matching element is found in a response.
      These elements are replaced even when they were not targeted directly.
    
      By default this contains the [`[up-hungry]`](/up-hungry) attribute.
    @param {string} [options.hungryTransition=null]
      The transition to use when a [hungry element](/up-hungry) is replacing itself
      while another target is replaced.
    
      By default this is not set and the original replacement's transition is used.
    @stable
     */ config = new up.Config({
            hungry: [
                "[up-hungry]"
            ],
            hungryTransition: null
        });
        reset = function() {
            return config.reset();
        };
        /***
    @function up.radio.hungrySelector
    @internal
     */ hungrySelector = function() {
            return config.hungry.join(",");
        };
        /***
    Elements with this attribute are [updated](/up.replace) whenever there is a
    matching element found in a successful response. The element is replaced even
    when it isn't [targeted](/a-up-target) directly.
    
    Use cases for this are unread message counters or notification flashes.
    Such elements often live in the layout, outside of the content area that is
    being replaced.
    
    @selector [up-hungry]
    @stable
     */ up.on("up:framework:reset", reset);
        return {
            config: config,
            hungrySelector: hungrySelector
        };
    }();
}).call(module.exports);
/***
Play nice with Rails UJS
========================
 */ (function() {
    up.rails = function() {
        var e, isRails, u;
        u = up.util;
        e = up.element;
        isRails = function() {
            var ref;
            return !!(window.Rails || ((ref = window.jQuery) != null ? ref.rails : void 0));
        };
        return u.each([
            "method",
            "confirm"
        ], function(feature) {
            var dataAttribute, upAttribute;
            dataAttribute = "data-" + feature;
            upAttribute = "up-" + feature;
            return up.macro("[" + dataAttribute + "]", function(element) {
                var replacement;
                if (isRails() && up.link.isFollowable(element)) {
                    replacement = {};
                    replacement[upAttribute] = element.getAttribute(dataAttribute);
                    e.setMissingAttrs(element, replacement);
                    return element.removeAttribute(dataAttribute);
                }
            });
        });
    }();
}).call(module.exports);
(function() {
    up.framework.boot();
}).call(module.exports);

});

parcelRegister("aITai", function(module, exports) {
parcelRequire("ipbTO");
parcelRequire("5xHX4");

});
parcelRegister("ipbTO", function(module, exports) {
/* eslint-disable */ 
var $l5cY7 = parcelRequire("l5cY7");
!function(v) {
    "use strict";
    var o = {
        tagClass: function(t) {
            var tags = "label label-info";
            if (t.salesHouseUser != null && !t.salesHouseUser) tags = tags + " not-sales-house-user";
            if (t.fake) tags = tags + " invalid-tag-input";
            return tags;
        },
        itemValue: function(t) {
            return t ? t.toString() : t;
        },
        itemText: function(t) {
            return this.itemValue(t);
        },
        itemTitle: function(t) {
            return null;
        },
        freeInput: !0,
        addOnBlur: !0,
        maxTags: void 0,
        maxChars: void 0,
        confirmKeys: [
            13,
            44
        ],
        delimiter: ",",
        delimiterRegex: null,
        cancelConfirmKeysOnEmpty: !0,
        onTagExists: function(t, e) {
            e.hide().fadeIn();
        },
        trimValue: !1,
        allowDuplicates: !1
    };
    function r(t, e) {
        this.itemsArray = [], this.$element = v(t), this.$element.hide(), this.isSelect = "SELECT" === t.tagName, this.multiple = this.isSelect && t.hasAttribute("multiple"), this.objectItems = e && e.itemValue, this.placeholderText = t.hasAttribute("placeholder") ? this.$element.attr("placeholder") : "", this.inputSize = Math.max(1, this.placeholderText.length), this.$container = v('<div class="bootstrap-tagsinput"></div>'), this.$input = v('<input type="text" placeholder="' + this.placeholderText + '"/>').appendTo(this.$container), this.$element.before(this.$container), this.build(e);
    }
    function s(t, e) {
        if ("function" != typeof t[e]) {
            var n = t[e];
            t[e] = function(t) {
                return t[n];
            };
        }
    }
    function l(t, e) {
        if ("function" != typeof t[e]) {
            var n = t[e];
            t[e] = function() {
                return n;
            };
        }
    }
    r.prototype = {
        constructor: r,
        add: function(t, e, n) {
            var i = this;
            if (!(i.options.maxTags && i.itemsArray.length >= i.options.maxTags) && (!1 === t || t)) {
                if ("string" == typeof t && i.options.trimValue && (t = v.trim(t)), "object" == typeof t && !i.objectItems) throw "Can't add objects when itemValue option is not set";
                if (!t.toString().match(/^\s*$/)) {
                    if (i.isSelect && !i.multiple && 0 < i.itemsArray.length && i.remove(i.itemsArray[0]), "string" == typeof t && "INPUT" === this.$element[0].tagName) {
                        var a = i.options.delimiterRegex ? i.options.delimiterRegex : i.options.delimiter, o = t.split(a);
                        if (1 < o.length) {
                            for(var r = 0; r < o.length; r++)this.add(o[r], !0);
                            return void (e || i.pushVal());
                        }
                    }
                    var s = i.options.itemValue(t), l = i.options.itemText(t), u = i.options.tagClass(t), p = i.options.itemTitle(t), c = v.grep(i.itemsArray, function(t) {
                        return i.options.itemValue(t) === s;
                    })[0];
                    if (!c || i.options.allowDuplicates) {
                        if (!(i.items().toString().length + t.length + 1 > i.options.maxInputLength)) {
                            var h = v.Event("beforeItemAdd", {
                                item: t,
                                cancel: !1,
                                options: n
                            });
                            if (i.$element.trigger(h), !h.cancel) {
                                i.itemsArray.push(t);
                                var m = v('<span class="tag ' + g(u) + (null !== p ? '" title="' + p : "") + '">' + g(l) + '<span data-role="remove"></span></span>');
                                if (m.data("item", t), i.findInputWrapper().before(m), m.after(" "), i.isSelect && !v('option[value="' + encodeURIComponent(s) + '"]', i.$element)[0]) {
                                    var f = v("<option selected>" + g(l) + "</option>");
                                    f.data("item", t), f.attr("value", s), i.$element.append(f);
                                }
                                e || i.pushVal(), i.options.maxTags !== i.itemsArray.length && i.items().toString().length !== i.options.maxInputLength || i.$container.addClass("bootstrap-tagsinput-max"), i.$element.trigger(v.Event("itemAdded", {
                                    item: t,
                                    options: n
                                }));
                            }
                        }
                    } else if (i.options.onTagExists) {
                        var d = v(".tag", i.$container).filter(function() {
                            return v(this).data("item") === c;
                        });
                        i.options.onTagExists(t, d);
                    }
                }
            }
        },
        remove: function(e, t, n) {
            var i = this;
            if (i.objectItems && (e = (e = "object" == typeof e ? v.grep(i.itemsArray, function(t) {
                return i.options.itemValue(t) == i.options.itemValue(e);
            }) : v.grep(i.itemsArray, function(t) {
                return i.options.itemValue(t) == e;
            }))[e.length - 1]), e) {
                var a = v.Event("beforeItemRemove", {
                    item: e,
                    cancel: !1,
                    options: n
                });
                if (i.$element.trigger(a), a.cancel) return;
                v(".tag", i.$container).filter(function() {
                    return v(this).data("item") === e;
                }).remove(), v("option", i.$element).filter(function() {
                    return v(this).data("item") === e;
                }).remove(), -1 !== v.inArray(e, i.itemsArray) && i.itemsArray.splice(v.inArray(e, i.itemsArray), 1);
            }
            t || i.pushVal(), i.options.maxTags > i.itemsArray.length && i.$container.removeClass("bootstrap-tagsinput-max"), i.$element.trigger(v.Event("itemRemoved", {
                item: e,
                options: n
            }));
        },
        removeAll: function() {
            var t = this;
            for(v(".tag", t.$container).remove(), v("option", t.$element).remove(); 0 < t.itemsArray.length;)t.itemsArray.pop();
            t.pushVal();
        },
        refresh: function() {
            var o = this;
            v(".tag", o.$container).each(function() {
                var t = v(this), e = t.data("item"), n = o.options.itemValue(e), i = o.options.itemText(e), a = o.options.tagClass(e);
                t.attr("class", null), t.addClass("tag " + g(a)), t.contents().filter(function() {
                    return 3 == this.nodeType;
                })[0].nodeValue = g(i), o.isSelect && v("option", o.$element).filter(function() {
                    return v(this).data("item") === e;
                }).attr("value", n);
            });
        },
        items: function() {
            return this.itemsArray;
        },
        pushVal: function() {
            var e = this, t = v.map(e.items(), function(t) {
                return e.options.itemValue(t).toString();
            });
            e.$element.val(t, !0).trigger("change");
        },
        build: function(t) {
            var u = this;
            if (u.options = v.extend({}, o, t), u.objectItems && (u.options.freeInput = !1), s(u.options, "itemValue"), s(u.options, "itemText"), l(u.options, "tagClass"), u.options.typeahead) {
                var i = u.options.typeahead || {};
                l(i, "source"), u.$input.typeahead(v.extend({}, i, {
                    source: function(t, a) {
                        function e(t) {
                            for(var e = [], n = 0; n < t.length; n++){
                                var i = u.options.itemText(t[n]);
                                o[i] = t[n], e.push(i);
                            }
                            a(e);
                        }
                        this.map = {};
                        var o = this.map, n = i.source(t);
                        v.isFunction(n.success) ? n.success(e) : v.isFunction(n.then) ? n.then(e) : v.when(n).then(e);
                    },
                    updater: function(t) {
                        return u.add(this.map[t]), this.map[t];
                    },
                    matcher: function(t) {
                        return -1 !== t.toLowerCase().indexOf(this.query.trim().toLowerCase());
                    },
                    sorter: function(t) {
                        return t.sort();
                    },
                    highlighter: function(t) {
                        var e = new RegExp("(" + this.query + ")", "gi");
                        return t.replace(e, "<strong>$1</strong>");
                    }
                }));
            }
            if (u.options.flaggingTagsInput) {
                u.$input.on("focusout", (e)=>{
                    if (u.$input.val() != null && u.$input.val().length != 0) u.add({
                        userId: -1,
                        name: u.$input.val(),
                        company: (0, $l5cY7.default).t("camashop.marking.asset.search.notUser"),
                        salesHouseUser: true,
                        fake: true
                    });
                    u.$input.val("");
                    u.pushVal();
                });
                u.$input.focusin((e)=>{
                    var p = u.itemsArray.filter((item)=>item.fake == true)[0];
                    console.log(e);
                    if (p) {
                        u.remove(p);
                        u.$input.val(p.name);
                    }
                });
            }
            if (u.options.typeaheadjs) {
                var e = null, n = {}, a = u.options.typeaheadjs;
                n = v.isArray(a) ? (e = a[0], a[1]) : a, u.$input.typeahead(e, n).on("typeahead:selected", v.proxy(function(t, e) {
                    n.valueKey ? u.add(e[n.valueKey]) : u.add(e), u.$input.typeahead("val", "");
                }, u));
            }
            u.$container.on("click", v.proxy(function(t) {
                console.log("Focus here2");
                console.log(t.target);
                console.log(t.target.className);
                if (!u.options.flaggingTagsInput || !t.target.className.includes("tt-suggestion")) u.$element.attr("disabled") || u.$input.removeAttr("disabled"), u.$input.focus();
            }, u)), u.options.addOnBlur && u.options.freeInput && u.$input.on("focusout", v.proxy(function(t) {
                0 === v(".typeahead, .twitter-typeahead", u.$container).length && (u.add(u.$input.val()), u.$input.val(""));
            }, u)), u.$container.on("keydown", "input", v.proxy(function(t) {
                var e = v(t.target), n = u.findInputWrapper();
                if (u.$element.attr("disabled")) u.$input.attr("disabled", "disabled");
                else {
                    switch(t.which){
                        case 8:
                            if (0 === p(e[0])) {
                                var i = n.prev();
                                i.length && u.remove(i.data("item"));
                            }
                            break;
                        case 46:
                            if (0 === p(e[0])) {
                                var a = n.next();
                                a.length && u.remove(a.data("item"));
                            }
                            break;
                        case 37:
                            var o = n.prev();
                            0 === e.val().length && o[0] && (o.before(n), e.focus());
                            break;
                        case 39:
                            var r = n.next();
                            0 === e.val().length && r[0] && (r.after(n), e.focus());
                    }
                    var s = e.val().length, l = s + Math.ceil(s / 5) + 1;
                    e.attr("size", Math.max(l, e.val().length));
                }
            }, u)), u.$container.on("keypress", "input", v.proxy(function(t) {
                var e = v(t.target);
                if (u.$element.attr("disabled")) u.$input.attr("disabled", "disabled");
                else {
                    var o, n, r, i = e.val(), a = u.options.maxChars && i.length >= u.options.maxChars;
                    u.options.freeInput && (o = t, n = u.options.confirmKeys, r = !1, v.each(n, function(t, e) {
                        if ("number" == typeof e && o.which === e) return r = !0, false;
                        if (o.which === e.which) {
                            var n = !e.hasOwnProperty("altKey") || o.altKey === e.altKey, i = !e.hasOwnProperty("shiftKey") || o.shiftKey === e.shiftKey, a = !e.hasOwnProperty("ctrlKey") || o.ctrlKey === e.ctrlKey;
                            if (n && i && a) return r = !0, false;
                        }
                    }), r || a) && (0 !== i.length && (u.add(a ? i.substr(0, u.options.maxChars) : i), e.val("")), !1 === u.options.cancelConfirmKeysOnEmpty && t.preventDefault());
                    var s = e.val().length, l = s + Math.ceil(s / 5) + 1;
                    e.attr("size", Math.max(l, e.val().length));
                }
            }, u)), u.$container.on("click", "[data-role=remove]", v.proxy(function(t) {
                u.$element.attr("disabled") || u.remove(v(t.target).closest(".tag").data("item"));
            }, u)), u.options.itemValue === o.itemValue && ("INPUT" === u.$element[0].tagName ? u.add(u.$element.val()) : v("option", u.$element).each(function() {
                u.add(v(this).attr("value"), !0);
            }));
        },
        destroy: function() {
            var t = this;
            t.$container.off("keypress", "input"), t.$container.off("click", "[role=remove]"), t.$container.remove(), t.$element.removeData("tagsinput"), t.$element.show();
        },
        focus: function() {
            this.$input.focus();
        },
        input: function() {
            return this.$input;
        },
        findInputWrapper: function() {
            for(var t = this.$input[0], e = this.$container[0]; t && t.parentNode !== e;)t = t.parentNode;
            return v(t);
        }
    }, v.fn.tagsinput = function(n, i, a) {
        var o = [];
        return this.each(function() {
            var t = v(this).data("tagsinput");
            if (t) {
                if (n || i) {
                    if (void 0 !== t[n]) {
                        if (3 === t[n].length && void 0 !== a) var e = t[n](i, null, a);
                        else e = t[n](i);
                        void 0 !== e && o.push(e);
                    }
                } else o.push(t);
            } else t = new r(this, n), v(this).data("tagsinput", t), o.push(t), "SELECT" === this.tagName && v("option", v(this)).attr("selected", "selected"), v(this).val(v(this).val());
        }), "string" != typeof n || 1 < o.length ? o : o[0];
    }, v.fn.tagsinput.Constructor = r;
    var e = v("<div />");
    function g(t) {
        return t ? e.text(t).html() : "";
    }
    function p(t) {
        var e = 0;
        if (document.selection) {
            t.focus();
            var n = document.selection.createRange();
            n.moveStart("character", -t.value.length), e = n.text.length;
        } else !t.selectionStart && "0" != t.selectionStart || (e = t.selectionStart);
        return e;
    }
    v(function() {
        v("input[data-role=tagsinput], select[multiple][data-role=tagsinput]").tagsinput();
    });
}(window.jQuery);

});
parcelRegister("l5cY7", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5941fe2585e9af7$export$2e2bcd8739ae039);
const $f5941fe2585e9af7$var$consoleLogger = {
    type: "logger",
    log (args) {
        this.output("log", args);
    },
    warn (args) {
        this.output("warn", args);
    },
    error (args) {
        this.output("error", args);
    },
    output (type, args) {
        if (console && console[type]) console[type].apply(console, args);
    }
};
class $f5941fe2585e9af7$var$Logger {
    constructor(concreteLogger){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.init(concreteLogger, options);
    }
    init(concreteLogger) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.prefix = options.prefix || "i18next:";
        this.logger = concreteLogger || $f5941fe2585e9af7$var$consoleLogger;
        this.options = options;
        this.debug = options.debug;
    }
    log() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return this.forward(args, "log", "", true);
    }
    warn() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return this.forward(args, "warn", "", true);
    }
    error() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        return this.forward(args, "error", "");
    }
    deprecate() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return this.forward(args, "warn", "WARNING DEPRECATED: ", true);
    }
    forward(args, lvl, prefix, debugOnly) {
        if (debugOnly && !this.debug) return null;
        if (typeof args[0] === "string") args[0] = `${prefix}${this.prefix} ${args[0]}`;
        return this.logger[lvl](args);
    }
    create(moduleName) {
        return new $f5941fe2585e9af7$var$Logger(this.logger, {
            prefix: `${this.prefix}:${moduleName}:`,
            ...this.options
        });
    }
    clone(options) {
        options = options || this.options;
        options.prefix = options.prefix || this.prefix;
        return new $f5941fe2585e9af7$var$Logger(this.logger, options);
    }
}
var $f5941fe2585e9af7$var$baseLogger = new $f5941fe2585e9af7$var$Logger();
class $f5941fe2585e9af7$var$EventEmitter {
    constructor(){
        this.observers = {};
    }
    on(events, listener) {
        events.split(" ").forEach((event)=>{
            this.observers[event] = this.observers[event] || [];
            this.observers[event].push(listener);
        });
        return this;
    }
    off(event, listener) {
        if (!this.observers[event]) return;
        if (!listener) {
            delete this.observers[event];
            return;
        }
        this.observers[event] = this.observers[event].filter((l)=>l !== listener);
    }
    emit(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (this.observers[event]) {
            const cloned = [].concat(this.observers[event]);
            cloned.forEach((observer)=>{
                observer(...args);
            });
        }
        if (this.observers["*"]) {
            const cloned = [].concat(this.observers["*"]);
            cloned.forEach((observer)=>{
                observer.apply(observer, [
                    event,
                    ...args
                ]);
            });
        }
    }
}
function $f5941fe2585e9af7$var$defer() {
    let res;
    let rej;
    const promise = new Promise((resolve, reject)=>{
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
}
function $f5941fe2585e9af7$var$makeString(object) {
    if (object == null) return "";
    return "" + object;
}
function $f5941fe2585e9af7$var$copy(a, s, t) {
    a.forEach((m)=>{
        if (s[m]) t[m] = s[m];
    });
}
function $f5941fe2585e9af7$var$getLastOfPath(object, path, Empty) {
    function cleanKey(key) {
        return key && key.indexOf("###") > -1 ? key.replace(/###/g, ".") : key;
    }
    function canNotTraverseDeeper() {
        return !object || typeof object === "string";
    }
    const stack = typeof path !== "string" ? [].concat(path) : path.split(".");
    while(stack.length > 1){
        if (canNotTraverseDeeper()) return {};
        const key = cleanKey(stack.shift());
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
    }
    if (canNotTraverseDeeper()) return {};
    return {
        obj: object,
        k: cleanKey(stack.shift())
    };
}
function $f5941fe2585e9af7$var$setPath(object, path, newValue) {
    const { obj: obj, k: k } = $f5941fe2585e9af7$var$getLastOfPath(object, path, Object);
    obj[k] = newValue;
}
function $f5941fe2585e9af7$var$pushPath(object, path, newValue, concat) {
    const { obj: obj, k: k } = $f5941fe2585e9af7$var$getLastOfPath(object, path, Object);
    obj[k] = obj[k] || [];
    if (concat) obj[k] = obj[k].concat(newValue);
    if (!concat) obj[k].push(newValue);
}
function $f5941fe2585e9af7$var$getPath(object, path) {
    const { obj: obj, k: k } = $f5941fe2585e9af7$var$getLastOfPath(object, path);
    if (!obj) return undefined;
    return obj[k];
}
function $f5941fe2585e9af7$var$getPathWithDefaults(data, defaultData, key) {
    const value = $f5941fe2585e9af7$var$getPath(data, key);
    if (value !== undefined) return value;
    return $f5941fe2585e9af7$var$getPath(defaultData, key);
}
function $f5941fe2585e9af7$var$deepExtend(target, source, overwrite) {
    for(const prop in source)if (prop !== "__proto__" && prop !== "constructor") {
        if (prop in target) {
            if (typeof target[prop] === "string" || target[prop] instanceof String || typeof source[prop] === "string" || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $f5941fe2585e9af7$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
}
function $f5941fe2585e9af7$var$regexEscape(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var $f5941fe2585e9af7$var$_entityMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
    "/": "&#x2F;"
};
function $f5941fe2585e9af7$var$escape(data) {
    if (typeof data === "string") return data.replace(/[&<>"'\/]/g, (s)=>$f5941fe2585e9af7$var$_entityMap[s]);
    return data;
}
const $f5941fe2585e9af7$var$chars = [
    " ",
    ",",
    "?",
    "!",
    ";"
];
function $f5941fe2585e9af7$var$looksLikeObjectPath(key, nsSeparator, keySeparator) {
    nsSeparator = nsSeparator || "";
    keySeparator = keySeparator || "";
    const possibleChars = $f5941fe2585e9af7$var$chars.filter((c)=>nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
    if (possibleChars.length === 0) return true;
    const r = new RegExp(`(${possibleChars.map((c)=>c === "?" ? "\\?" : c).join("|")})`);
    let matched = !r.test(key);
    if (!matched) {
        const ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
}
function $f5941fe2585e9af7$var$deepFind(obj, path) {
    let keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ".";
    if (!obj) return undefined;
    if (obj[path]) return obj[path];
    const paths = path.split(keySeparator);
    let current = obj;
    for(let i = 0; i < paths.length; ++i){
        if (!current) return undefined;
        if (typeof current[paths[i]] === "string" && i + 1 < paths.length) return undefined;
        if (current[paths[i]] === undefined) {
            let j = 2;
            let p = paths.slice(i, i + j).join(keySeparator);
            let mix = current[p];
            while(mix === undefined && paths.length > i + j){
                j++;
                p = paths.slice(i, i + j).join(keySeparator);
                mix = current[p];
            }
            if (mix === undefined) return undefined;
            if (mix === null) return null;
            if (path.endsWith(p)) {
                if (typeof mix === "string") return mix;
                if (p && typeof mix[p] === "string") return mix[p];
            }
            const joinedPath = paths.slice(i + j).join(keySeparator);
            if (joinedPath) return $f5941fe2585e9af7$var$deepFind(mix, joinedPath, keySeparator);
            return undefined;
        }
        current = current[paths[i]];
    }
    return current;
}
function $f5941fe2585e9af7$var$getCleanedCode(code) {
    if (code && code.indexOf("_") > 0) return code.replace("_", "-");
    return code;
}
class $f5941fe2585e9af7$var$ResourceStore extends $f5941fe2585e9af7$var$EventEmitter {
    constructor(data){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                "translation"
            ],
            defaultNS: "translation"
        };
        super();
        this.data = data || {};
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = ".";
        if (this.options.ignoreJSONStructure === undefined) this.options.ignoreJSONStructure = true;
    }
    addNamespaces(ns) {
        if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
    }
    removeNamespaces(ns) {
        const index = this.options.ns.indexOf(ns);
        if (index > -1) this.options.ns.splice(index, 1);
    }
    getResource(lng, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
        let path = [
            lng,
            ns
        ];
        if (key && typeof key !== "string") path = path.concat(key);
        if (key && typeof key === "string") path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.indexOf(".") > -1) path = lng.split(".");
        const result = $f5941fe2585e9af7$var$getPath(this.data, path);
        if (result || !ignoreJSONStructure || typeof key !== "string") return result;
        return $f5941fe2585e9af7$var$deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
    }
    addResource(lng, ns, key, value) {
        let options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            silent: false
        };
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let path = [
            lng,
            ns
        ];
        if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.indexOf(".") > -1) {
            path = lng.split(".");
            value = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        $f5941fe2585e9af7$var$setPath(this.data, path, value);
        if (!options.silent) this.emit("added", lng, ns, key, value);
    }
    addResources(lng, ns, resources) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
            silent: false
        };
        for(const m in resources)if (typeof resources[m] === "string" || Object.prototype.toString.apply(resources[m]) === "[object Array]") this.addResource(lng, ns, m, resources[m], {
            silent: true
        });
        if (!options.silent) this.emit("added", lng, ns, resources);
    }
    addResourceBundle(lng, ns, resources, deep, overwrite) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
            silent: false
        };
        let path = [
            lng,
            ns
        ];
        if (lng.indexOf(".") > -1) {
            path = lng.split(".");
            deep = resources;
            resources = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        let pack = $f5941fe2585e9af7$var$getPath(this.data, path) || {};
        if (deep) $f5941fe2585e9af7$var$deepExtend(pack, resources, overwrite);
        else pack = {
            ...pack,
            ...resources
        };
        $f5941fe2585e9af7$var$setPath(this.data, path, pack);
        if (!options.silent) this.emit("added", lng, ns, resources);
    }
    removeResourceBundle(lng, ns) {
        if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
        this.removeNamespaces(ns);
        this.emit("removed", lng, ns);
    }
    hasResourceBundle(lng, ns) {
        return this.getResource(lng, ns) !== undefined;
    }
    getResourceBundle(lng, ns) {
        if (!ns) ns = this.options.defaultNS;
        if (this.options.compatibilityAPI === "v1") return {
            ...this.getResource(lng, ns)
        };
        return this.getResource(lng, ns);
    }
    getDataByLanguage(lng) {
        return this.data[lng];
    }
    hasLanguageSomeTranslations(lng) {
        const data = this.getDataByLanguage(lng);
        const n = data && Object.keys(data) || [];
        return !!n.find((v)=>data[v] && Object.keys(data[v]).length > 0);
    }
    toJSON() {
        return this.data;
    }
}
var $f5941fe2585e9af7$var$postProcessor = {
    processors: {},
    addPostProcessor (module) {
        this.processors[module.name] = module;
    },
    handle (processors, value, key, options, translator) {
        processors.forEach((processor)=>{
            if (this.processors[processor]) value = this.processors[processor].process(value, key, options, translator);
        });
        return value;
    }
};
const $f5941fe2585e9af7$var$checkedLoadedFor = {};
class $f5941fe2585e9af7$var$Translator extends $f5941fe2585e9af7$var$EventEmitter {
    constructor(services){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super();
        $f5941fe2585e9af7$var$copy([
            "resourceStore",
            "languageUtils",
            "pluralResolver",
            "interpolator",
            "backendConnector",
            "i18nFormat",
            "utils"
        ], services, this);
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = ".";
        this.logger = $f5941fe2585e9af7$var$baseLogger.create("translator");
    }
    changeLanguage(lng) {
        if (lng) this.language = lng;
    }
    exists(key) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        if (key === undefined || key === null) return false;
        const resolved = this.resolve(key, options);
        return resolved && resolved.res !== undefined;
    }
    extractFromKey(key, options) {
        let nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ":";
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let namespaces = options.ns || this.options.defaultNS || [];
        const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
        const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !$f5941fe2585e9af7$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
        if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
            const m = key.match(this.interpolator.nestingRegexp);
            if (m && m.length > 0) return {
                key: key,
                namespaces: namespaces
            };
            const parts = key.split(nsSeparator);
            if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
            key = parts.join(keySeparator);
        }
        if (typeof namespaces === "string") namespaces = [
            namespaces
        ];
        return {
            key: key,
            namespaces: namespaces
        };
    }
    translate(keys, options, lastKey) {
        if (typeof options !== "object" && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
        if (typeof options === "object") options = {
            ...options
        };
        if (!options) options = {};
        if (keys === undefined || keys === null) return "";
        if (!Array.isArray(keys)) keys = [
            String(keys)
        ];
        const returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const { key: key, namespaces: namespaces } = this.extractFromKey(keys[keys.length - 1], options);
        const namespace = namespaces[namespaces.length - 1];
        const lng = options.lng || this.language;
        const appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
        if (lng && lng.toLowerCase() === "cimode") {
            if (appendNamespaceToCIMode) {
                const nsSeparator = options.nsSeparator || this.options.nsSeparator;
                if (returnDetails) return {
                    res: `${namespace}${nsSeparator}${key}`,
                    usedKey: key,
                    exactUsedKey: key,
                    usedLng: lng,
                    usedNS: namespace,
                    usedParams: this.getUsedParamsDetails(options)
                };
                return `${namespace}${nsSeparator}${key}`;
            }
            if (returnDetails) return {
                res: key,
                usedKey: key,
                exactUsedKey: key,
                usedLng: lng,
                usedNS: namespace,
                usedParams: this.getUsedParamsDetails(options)
            };
            return key;
        }
        const resolved = this.resolve(keys, options);
        let res = resolved && resolved.res;
        const resUsedKey = resolved && resolved.usedKey || key;
        const resExactUsedKey = resolved && resolved.exactUsedKey || key;
        const resType = Object.prototype.toString.apply(res);
        const noObject = [
            "[object Number]",
            "[object Function]",
            "[object RegExp]"
        ];
        const joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
        const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
        const handleAsObject = typeof res !== "string" && typeof res !== "boolean" && typeof res !== "number";
        if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === "string" && resType === "[object Array]")) {
            if (!options.returnObjects && !this.options.returnObjects) {
                if (!this.options.returnedObjectHandler) this.logger.warn("accessing an object - but returnObjects options is not enabled!");
                const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, {
                    ...options,
                    ns: namespaces
                }) : `key '${key} (${this.language})' returned an object instead of string.`;
                if (returnDetails) {
                    resolved.res = r;
                    resolved.usedParams = this.getUsedParamsDetails(options);
                    return resolved;
                }
                return r;
            }
            if (keySeparator) {
                const resTypeIsArray = resType === "[object Array]";
                const copy = resTypeIsArray ? [] : {};
                const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                for(const m in res)if (Object.prototype.hasOwnProperty.call(res, m)) {
                    const deepKey = `${newKeyToUse}${keySeparator}${m}`;
                    copy[m] = this.translate(deepKey, {
                        ...options,
                        joinArrays: false,
                        ns: namespaces
                    });
                    if (copy[m] === deepKey) copy[m] = res[m];
                }
                res = copy;
            }
        } else if (handleAsObjectInI18nFormat && typeof joinArrays === "string" && resType === "[object Array]") {
            res = res.join(joinArrays);
            if (res) res = this.extendTranslation(res, keys, options, lastKey);
        } else {
            let usedDefault = false;
            let usedKey = false;
            const needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
            const hasDefaultValue = $f5941fe2585e9af7$var$Translator.hasDefaultValue(options);
            const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : "";
            const defaultValueSuffixOrdinalFallback = options.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, {
                ordinal: false
            }) : "";
            const defaultValue = options[`defaultValue${defaultValueSuffix}`] || options[`defaultValue${defaultValueSuffixOrdinalFallback}`] || options.defaultValue;
            if (!this.isValidLookup(res) && hasDefaultValue) {
                usedDefault = true;
                res = defaultValue;
            }
            if (!this.isValidLookup(res)) {
                usedKey = true;
                res = key;
            }
            const missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
            const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
            const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
            if (usedKey || usedDefault || updateMissing) {
                this.logger.log(updateMissing ? "updateKey" : "missingKey", lng, namespace, key, updateMissing ? defaultValue : res);
                if (keySeparator) {
                    const fk = this.resolve(key, {
                        ...options,
                        keySeparator: false
                    });
                    if (fk && fk.res) this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
                }
                let lngs = [];
                const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                if (this.options.saveMissingTo === "fallback" && fallbackLngs && fallbackLngs[0]) for(let i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                else if (this.options.saveMissingTo === "all") lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                else lngs.push(options.lng || this.language);
                const send = (l, k, specificDefaultValue)=>{
                    const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                    if (this.options.missingKeyHandler) this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
                    else if (this.backendConnector && this.backendConnector.saveMissing) this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
                    this.emit("missingKey", l, namespace, k, res);
                };
                if (this.options.saveMissing) {
                    if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach((language)=>{
                        this.pluralResolver.getSuffixes(language, options).forEach((suffix)=>{
                            send([
                                language
                            ], key + suffix, options[`defaultValue${suffix}`] || defaultValue);
                        });
                    });
                    else send(lngs, key, defaultValue);
                }
            }
            res = this.extendTranslation(res, keys, options, resolved, lastKey);
            if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}:${key}`;
            if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
                if (this.options.compatibilityAPI !== "v1") res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}:${key}` : key, usedDefault ? res : undefined);
                else res = this.options.parseMissingKeyHandler(res);
            }
        }
        if (returnDetails) {
            resolved.res = res;
            resolved.usedParams = this.getUsedParamsDetails(options);
            return resolved;
        }
        return res;
    }
    extendTranslation(res, key, options, resolved, lastKey) {
        var _this = this;
        if (this.i18nFormat && this.i18nFormat.parse) res = this.i18nFormat.parse(res, {
            ...this.options.interpolation.defaultVariables,
            ...options
        }, options.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
            resolved: resolved
        });
        else if (!options.skipInterpolation) {
            if (options.interpolation) this.interpolator.init({
                ...options,
                interpolation: {
                    ...this.options.interpolation,
                    ...options.interpolation
                }
            });
            const skipOnVariables = typeof res === "string" && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
            let nestBef;
            if (skipOnVariables) {
                const nb = res.match(this.interpolator.nestingRegexp);
                nestBef = nb && nb.length;
            }
            let data = options.replace && typeof options.replace !== "string" ? options.replace : options;
            if (this.options.interpolation.defaultVariables) data = {
                ...this.options.interpolation.defaultVariables,
                ...data
            };
            res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
            if (skipOnVariables) {
                const na = res.match(this.interpolator.nestingRegexp);
                const nestAft = na && na.length;
                if (nestBef < nestAft) options.nest = false;
            }
            if (!options.lng && this.options.compatibilityAPI !== "v1" && resolved && resolved.res) options.lng = resolved.usedLng;
            if (options.nest !== false) res = this.interpolator.nest(res, function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                if (lastKey && lastKey[0] === args[0] && !options.context) {
                    _this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
                    return null;
                }
                return _this.translate(...args, key);
            }, options);
            if (options.interpolation) this.interpolator.reset();
        }
        const postProcess = options.postProcess || this.options.postProcess;
        const postProcessorNames = typeof postProcess === "string" ? [
            postProcess
        ] : postProcess;
        if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) res = $f5941fe2585e9af7$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
            i18nResolved: {
                ...resolved,
                usedParams: this.getUsedParamsDetails(options)
            },
            ...options
        } : options, this);
        return res;
    }
    resolve(keys) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let found;
        let usedKey;
        let exactUsedKey;
        let usedLng;
        let usedNS;
        if (typeof keys === "string") keys = [
            keys
        ];
        keys.forEach((k)=>{
            if (this.isValidLookup(found)) return;
            const extracted = this.extractFromKey(k, options);
            const key = extracted.key;
            usedKey = key;
            let namespaces = extracted.namespaces;
            if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
            const needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
            const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && this.pluralResolver.shouldUseIntlApi();
            const needsContextHandling = options.context !== undefined && (typeof options.context === "string" || typeof options.context === "number") && options.context !== "";
            const codes = options.lngs ? options.lngs : this.languageUtils.toResolveHierarchy(options.lng || this.language, options.fallbackLng);
            namespaces.forEach((ns)=>{
                if (this.isValidLookup(found)) return;
                usedNS = ns;
                if (!$f5941fe2585e9af7$var$checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(usedNS)) {
                    $f5941fe2585e9af7$var$checkedLoadedFor[`${codes[0]}-${ns}`] = true;
                    this.logger.warn(`key "${usedKey}" for languages "${codes.join(", ")}" won't get resolved as namespace "${usedNS}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
                }
                codes.forEach((code)=>{
                    if (this.isValidLookup(found)) return;
                    usedLng = code;
                    const finalKeys = [
                        key
                    ];
                    if (this.i18nFormat && this.i18nFormat.addLookupKeys) this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                    else {
                        let pluralSuffix;
                        if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, options.count, options);
                        const zeroSuffix = `${this.options.pluralSeparator}zero`;
                        const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                        if (needsPluralHandling) {
                            finalKeys.push(key + pluralSuffix);
                            if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                            if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                        }
                        if (needsContextHandling) {
                            const contextKey = `${key}${this.options.contextSeparator}${options.context}`;
                            finalKeys.push(contextKey);
                            if (needsPluralHandling) {
                                finalKeys.push(contextKey + pluralSuffix);
                                if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                                if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                            }
                        }
                    }
                    let possibleKey;
                    while(possibleKey = finalKeys.pop())if (!this.isValidLookup(found)) {
                        exactUsedKey = possibleKey;
                        found = this.getResource(code, ns, possibleKey, options);
                    }
                });
            });
        });
        return {
            res: found,
            usedKey: usedKey,
            exactUsedKey: exactUsedKey,
            usedLng: usedLng,
            usedNS: usedNS
        };
    }
    isValidLookup(res) {
        return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === "");
    }
    getResource(code, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
        return this.resourceStore.getResource(code, ns, key, options);
    }
    getUsedParamsDetails() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const optionsKeys = [
            "defaultValue",
            "ordinal",
            "context",
            "replace",
            "lng",
            "lngs",
            "fallbackLng",
            "ns",
            "keySeparator",
            "nsSeparator",
            "returnObjects",
            "returnDetails",
            "joinArrays",
            "postProcess",
            "interpolation"
        ];
        const useOptionsReplaceForData = options.replace && typeof options.replace !== "string";
        let data = useOptionsReplaceForData ? options.replace : options;
        if (useOptionsReplaceForData && typeof options.count !== "undefined") data.count = options.count;
        if (this.options.interpolation.defaultVariables) data = {
            ...this.options.interpolation.defaultVariables,
            ...data
        };
        if (!useOptionsReplaceForData) {
            data = {
                ...data
            };
            for (const key of optionsKeys)delete data[key];
        }
        return data;
    }
    static hasDefaultValue(options) {
        const prefix = "defaultValue";
        for(const option in options){
            if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
        }
        return false;
    }
}
function $f5941fe2585e9af7$var$capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
class $f5941fe2585e9af7$var$LanguageUtil {
    constructor(options){
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $f5941fe2585e9af7$var$baseLogger.create("languageUtils");
    }
    getScriptPartFromCode(code) {
        code = $f5941fe2585e9af7$var$getCleanedCode(code);
        if (!code || code.indexOf("-") < 0) return null;
        const p = code.split("-");
        if (p.length === 2) return null;
        p.pop();
        if (p[p.length - 1].toLowerCase() === "x") return null;
        return this.formatLanguageCode(p.join("-"));
    }
    getLanguagePartFromCode(code) {
        code = $f5941fe2585e9af7$var$getCleanedCode(code);
        if (!code || code.indexOf("-") < 0) return code;
        const p = code.split("-");
        return this.formatLanguageCode(p[0]);
    }
    formatLanguageCode(code) {
        if (typeof code === "string" && code.indexOf("-") > -1) {
            const specialCases = [
                "hans",
                "hant",
                "latn",
                "cyrl",
                "cans",
                "mong",
                "arab"
            ];
            let p = code.split("-");
            if (this.options.lowerCaseLng) p = p.map((part)=>part.toLowerCase());
            else if (p.length === 2) {
                p[0] = p[0].toLowerCase();
                p[1] = p[1].toUpperCase();
                if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $f5941fe2585e9af7$var$capitalize(p[1].toLowerCase());
            } else if (p.length === 3) {
                p[0] = p[0].toLowerCase();
                if (p[1].length === 2) p[1] = p[1].toUpperCase();
                if (p[0] !== "sgn" && p[2].length === 2) p[2] = p[2].toUpperCase();
                if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $f5941fe2585e9af7$var$capitalize(p[1].toLowerCase());
                if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = $f5941fe2585e9af7$var$capitalize(p[2].toLowerCase());
            }
            return p.join("-");
        }
        return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
    isSupportedCode(code) {
        if (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
        return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
    getBestMatchFromCodes(codes) {
        if (!codes) return null;
        let found;
        codes.forEach((code)=>{
            if (found) return;
            const cleanedLng = this.formatLanguageCode(code);
            if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
        });
        if (!found && this.options.supportedLngs) codes.forEach((code)=>{
            if (found) return;
            const lngOnly = this.getLanguagePartFromCode(code);
            if (this.isSupportedCode(lngOnly)) return found = lngOnly;
            found = this.options.supportedLngs.find((supportedLng)=>{
                if (supportedLng === lngOnly) return supportedLng;
                if (supportedLng.indexOf("-") < 0 && lngOnly.indexOf("-") < 0) return;
                if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
            });
        });
        if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
        return found;
    }
    getFallbackCodes(fallbacks, code) {
        if (!fallbacks) return [];
        if (typeof fallbacks === "function") fallbacks = fallbacks(code);
        if (typeof fallbacks === "string") fallbacks = [
            fallbacks
        ];
        if (Object.prototype.toString.apply(fallbacks) === "[object Array]") return fallbacks;
        if (!code) return fallbacks.default || [];
        let found = fallbacks[code];
        if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
        if (!found) found = fallbacks[this.formatLanguageCode(code)];
        if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
        if (!found) found = fallbacks.default;
        return found || [];
    }
    toResolveHierarchy(code, fallbackCode) {
        const fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
        const codes = [];
        const addCode = (c)=>{
            if (!c) return;
            if (this.isSupportedCode(c)) codes.push(c);
            else this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
        };
        if (typeof code === "string" && (code.indexOf("-") > -1 || code.indexOf("_") > -1)) {
            if (this.options.load !== "languageOnly") addCode(this.formatLanguageCode(code));
            if (this.options.load !== "languageOnly" && this.options.load !== "currentOnly") addCode(this.getScriptPartFromCode(code));
            if (this.options.load !== "currentOnly") addCode(this.getLanguagePartFromCode(code));
        } else if (typeof code === "string") addCode(this.formatLanguageCode(code));
        fallbackCodes.forEach((fc)=>{
            if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
        });
        return codes;
    }
}
let $f5941fe2585e9af7$var$sets = [
    {
        lngs: [
            "ach",
            "ak",
            "am",
            "arn",
            "br",
            "fil",
            "gun",
            "ln",
            "mfe",
            "mg",
            "mi",
            "oc",
            "pt",
            "pt-BR",
            "tg",
            "tl",
            "ti",
            "tr",
            "uz",
            "wa"
        ],
        nr: [
            1,
            2
        ],
        fc: 1
    },
    {
        lngs: [
            "af",
            "an",
            "ast",
            "az",
            "bg",
            "bn",
            "ca",
            "da",
            "de",
            "dev",
            "el",
            "en",
            "eo",
            "es",
            "et",
            "eu",
            "fi",
            "fo",
            "fur",
            "fy",
            "gl",
            "gu",
            "ha",
            "hi",
            "hu",
            "hy",
            "ia",
            "it",
            "kk",
            "kn",
            "ku",
            "lb",
            "mai",
            "ml",
            "mn",
            "mr",
            "nah",
            "nap",
            "nb",
            "ne",
            "nl",
            "nn",
            "no",
            "nso",
            "pa",
            "pap",
            "pms",
            "ps",
            "pt-PT",
            "rm",
            "sco",
            "se",
            "si",
            "so",
            "son",
            "sq",
            "sv",
            "sw",
            "ta",
            "te",
            "tk",
            "ur",
            "yo"
        ],
        nr: [
            1,
            2
        ],
        fc: 2
    },
    {
        lngs: [
            "ay",
            "bo",
            "cgg",
            "fa",
            "ht",
            "id",
            "ja",
            "jbo",
            "ka",
            "km",
            "ko",
            "ky",
            "lo",
            "ms",
            "sah",
            "su",
            "th",
            "tt",
            "ug",
            "vi",
            "wo",
            "zh"
        ],
        nr: [
            1
        ],
        fc: 3
    },
    {
        lngs: [
            "be",
            "bs",
            "cnr",
            "dz",
            "hr",
            "ru",
            "sr",
            "uk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 4
    },
    {
        lngs: [
            "ar"
        ],
        nr: [
            0,
            1,
            2,
            3,
            11,
            100
        ],
        fc: 5
    },
    {
        lngs: [
            "cs",
            "sk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 6
    },
    {
        lngs: [
            "csb",
            "pl"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 7
    },
    {
        lngs: [
            "cy"
        ],
        nr: [
            1,
            2,
            3,
            8
        ],
        fc: 8
    },
    {
        lngs: [
            "fr"
        ],
        nr: [
            1,
            2
        ],
        fc: 9
    },
    {
        lngs: [
            "ga"
        ],
        nr: [
            1,
            2,
            3,
            7,
            11
        ],
        fc: 10
    },
    {
        lngs: [
            "gd"
        ],
        nr: [
            1,
            2,
            3,
            20
        ],
        fc: 11
    },
    {
        lngs: [
            "is"
        ],
        nr: [
            1,
            2
        ],
        fc: 12
    },
    {
        lngs: [
            "jv"
        ],
        nr: [
            0,
            1
        ],
        fc: 13
    },
    {
        lngs: [
            "kw"
        ],
        nr: [
            1,
            2,
            3,
            4
        ],
        fc: 14
    },
    {
        lngs: [
            "lt"
        ],
        nr: [
            1,
            2,
            10
        ],
        fc: 15
    },
    {
        lngs: [
            "lv"
        ],
        nr: [
            1,
            2,
            0
        ],
        fc: 16
    },
    {
        lngs: [
            "mk"
        ],
        nr: [
            1,
            2
        ],
        fc: 17
    },
    {
        lngs: [
            "mnk"
        ],
        nr: [
            0,
            1,
            2
        ],
        fc: 18
    },
    {
        lngs: [
            "mt"
        ],
        nr: [
            1,
            2,
            11,
            20
        ],
        fc: 19
    },
    {
        lngs: [
            "or"
        ],
        nr: [
            2,
            1
        ],
        fc: 2
    },
    {
        lngs: [
            "ro"
        ],
        nr: [
            1,
            2,
            20
        ],
        fc: 20
    },
    {
        lngs: [
            "sl"
        ],
        nr: [
            5,
            1,
            2,
            3
        ],
        fc: 21
    },
    {
        lngs: [
            "he",
            "iw"
        ],
        nr: [
            1,
            2,
            20,
            21
        ],
        fc: 22
    }
];
let $f5941fe2585e9af7$var$_rulesPluralsTypes = {
    1: function(n) {
        return Number(n > 1);
    },
    2: function(n) {
        return Number(n != 1);
    },
    3: function(n) {
        return 0;
    },
    4: function(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    5: function(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
    },
    6: function(n) {
        return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
    },
    7: function(n) {
        return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    8: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
    },
    9: function(n) {
        return Number(n >= 2);
    },
    10: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
    },
    11: function(n) {
        return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
    },
    12: function(n) {
        return Number(n % 10 != 1 || n % 100 == 11);
    },
    13: function(n) {
        return Number(n !== 0);
    },
    14: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
    },
    15: function(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    16: function(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
    },
    17: function(n) {
        return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
    },
    18: function(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
    },
    19: function(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
    },
    20: function(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
    },
    21: function(n) {
        return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
    },
    22: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
    }
};
const $f5941fe2585e9af7$var$nonIntlVersions = [
    "v1",
    "v2",
    "v3"
];
const $f5941fe2585e9af7$var$intlVersions = [
    "v4"
];
const $f5941fe2585e9af7$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
function $f5941fe2585e9af7$var$createRules() {
    const rules = {};
    $f5941fe2585e9af7$var$sets.forEach((set)=>{
        set.lngs.forEach((l)=>{
            rules[l] = {
                numbers: set.nr,
                plurals: $f5941fe2585e9af7$var$_rulesPluralsTypes[set.fc]
            };
        });
    });
    return rules;
}
class $f5941fe2585e9af7$var$PluralResolver {
    constructor(languageUtils){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $f5941fe2585e9af7$var$baseLogger.create("pluralResolver");
        if ((!this.options.compatibilityJSON || $f5941fe2585e9af7$var$intlVersions.includes(this.options.compatibilityJSON)) && (typeof Intl === "undefined" || !Intl.PluralRules)) {
            this.options.compatibilityJSON = "v3";
            this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.");
        }
        this.rules = $f5941fe2585e9af7$var$createRules();
    }
    addRule(lng, obj) {
        this.rules[lng] = obj;
    }
    getRule(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (this.shouldUseIntlApi()) try {
            return new Intl.PluralRules($f5941fe2585e9af7$var$getCleanedCode(code), {
                type: options.ordinal ? "ordinal" : "cardinal"
            });
        } catch  {
            return;
        }
        return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
    needsPlural(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const rule = this.getRule(code, options);
        if (this.shouldUseIntlApi()) return rule && rule.resolvedOptions().pluralCategories.length > 1;
        return rule && rule.numbers.length > 1;
    }
    getPluralFormsOfKey(code, key) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return this.getSuffixes(code, options).map((suffix)=>`${key}${suffix}`);
    }
    getSuffixes(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const rule = this.getRule(code, options);
        if (!rule) return [];
        if (this.shouldUseIntlApi()) return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2)=>$f5941fe2585e9af7$var$suffixesOrder[pluralCategory1] - $f5941fe2585e9af7$var$suffixesOrder[pluralCategory2]).map((pluralCategory)=>`${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ""}${pluralCategory}`);
        return rule.numbers.map((number)=>this.getSuffix(code, number, options));
    }
    getSuffix(code, count) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const rule = this.getRule(code, options);
        if (rule) {
            if (this.shouldUseIntlApi()) return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ""}${rule.select(count)}`;
            return this.getSuffixRetroCompatible(rule, count);
        }
        this.logger.warn(`no plural rule found for: ${code}`);
        return "";
    }
    getSuffixRetroCompatible(rule, count) {
        const idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
        let suffix = rule.numbers[idx];
        if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
            if (suffix === 2) suffix = "plural";
            else if (suffix === 1) suffix = "";
        }
        const returnSuffix = ()=>this.options.prepend && suffix.toString() ? this.options.prepend + suffix.toString() : suffix.toString();
        if (this.options.compatibilityJSON === "v1") {
            if (suffix === 1) return "";
            if (typeof suffix === "number") return `_plural_${suffix.toString()}`;
            return returnSuffix();
        } else if (this.options.compatibilityJSON === "v2") return returnSuffix();
        else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) return returnSuffix();
        return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }
    shouldUseIntlApi() {
        return !$f5941fe2585e9af7$var$nonIntlVersions.includes(this.options.compatibilityJSON);
    }
}
function $f5941fe2585e9af7$var$deepFindWithDefaults(data, defaultData, key) {
    let keySeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ".";
    let ignoreJSONStructure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    let path = $f5941fe2585e9af7$var$getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && typeof key === "string") {
        path = $f5941fe2585e9af7$var$deepFind(data, key, keySeparator);
        if (path === undefined) path = $f5941fe2585e9af7$var$deepFind(defaultData, key, keySeparator);
    }
    return path;
}
class $f5941fe2585e9af7$var$Interpolator {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = $f5941fe2585e9af7$var$baseLogger.create("interpolator");
        this.options = options;
        this.format = options.interpolation && options.interpolation.format || ((value)=>value);
        this.init(options);
    }
    init() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (!options.interpolation) options.interpolation = {
            escapeValue: true
        };
        const iOpts = options.interpolation;
        this.escape = iOpts.escape !== undefined ? iOpts.escape : $f5941fe2585e9af7$var$escape;
        this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
        this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
        this.prefix = iOpts.prefix ? $f5941fe2585e9af7$var$regexEscape(iOpts.prefix) : iOpts.prefixEscaped || "{{";
        this.suffix = iOpts.suffix ? $f5941fe2585e9af7$var$regexEscape(iOpts.suffix) : iOpts.suffixEscaped || "}}";
        this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
        this.unescapePrefix = iOpts.unescapeSuffix ? "" : iOpts.unescapePrefix || "-";
        this.unescapeSuffix = this.unescapePrefix ? "" : iOpts.unescapeSuffix || "";
        this.nestingPrefix = iOpts.nestingPrefix ? $f5941fe2585e9af7$var$regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || $f5941fe2585e9af7$var$regexEscape("$t(");
        this.nestingSuffix = iOpts.nestingSuffix ? $f5941fe2585e9af7$var$regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || $f5941fe2585e9af7$var$regexEscape(")");
        this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ",";
        this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
        this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
        this.resetRegExp();
    }
    reset() {
        if (this.options) this.init(this.options);
    }
    resetRegExp() {
        const regexpStr = `${this.prefix}(.+?)${this.suffix}`;
        this.regexp = new RegExp(regexpStr, "g");
        const regexpUnescapeStr = `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`;
        this.regexpUnescape = new RegExp(regexpUnescapeStr, "g");
        const nestingRegexpStr = `${this.nestingPrefix}(.+?)${this.nestingSuffix}`;
        this.nestingRegexp = new RegExp(nestingRegexpStr, "g");
    }
    interpolate(str, data, lng, options) {
        let match;
        let value;
        let replaces;
        const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
        function regexSafe(val) {
            return val.replace(/\$/g, "$$$$");
        }
        const handleFormat = (key)=>{
            if (key.indexOf(this.formatSeparator) < 0) {
                const path = $f5941fe2585e9af7$var$deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
                return this.alwaysFormat ? this.format(path, undefined, lng, {
                    ...options,
                    ...data,
                    interpolationkey: key
                }) : path;
            }
            const p = key.split(this.formatSeparator);
            const k = p.shift().trim();
            const f = p.join(this.formatSeparator).trim();
            return this.format($f5941fe2585e9af7$var$deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
                ...options,
                ...data,
                interpolationkey: k
            });
        };
        this.resetRegExp();
        const missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
        const skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
        const todos = [
            {
                regex: this.regexpUnescape,
                safeValue: (val)=>regexSafe(val)
            },
            {
                regex: this.regexp,
                safeValue: (val)=>this.escapeValue ? regexSafe(this.escape(val)) : regexSafe(val)
            }
        ];
        todos.forEach((todo)=>{
            replaces = 0;
            while(match = todo.regex.exec(str)){
                const matchedVar = match[1].trim();
                value = handleFormat(matchedVar);
                if (value === undefined) {
                    if (typeof missingInterpolationHandler === "function") {
                        const temp = missingInterpolationHandler(str, match, options);
                        value = typeof temp === "string" ? temp : "";
                    } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = "";
                    else if (skipOnVariables) {
                        value = match[0];
                        continue;
                    } else {
                        this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
                        value = "";
                    }
                } else if (typeof value !== "string" && !this.useRawValueToEscape) value = $f5941fe2585e9af7$var$makeString(value);
                const safeValue = todo.safeValue(value);
                str = str.replace(match[0], safeValue);
                if (skipOnVariables) {
                    todo.regex.lastIndex += value.length;
                    todo.regex.lastIndex -= match[0].length;
                } else todo.regex.lastIndex = 0;
                replaces++;
                if (replaces >= this.maxReplaces) break;
            }
        });
        return str;
    }
    nest(str, fc) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let match;
        let value;
        let clonedOptions;
        function handleHasOptions(key, inheritedOptions) {
            const sep = this.nestingOptionsSeparator;
            if (key.indexOf(sep) < 0) return key;
            const c = key.split(new RegExp(`${sep}[ ]*{`));
            let optionsString = `{${c[1]}`;
            key = c[0];
            optionsString = this.interpolate(optionsString, clonedOptions);
            const matchedSingleQuotes = optionsString.match(/'/g);
            const matchedDoubleQuotes = optionsString.match(/"/g);
            if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
            try {
                clonedOptions = JSON.parse(optionsString);
                if (inheritedOptions) clonedOptions = {
                    ...inheritedOptions,
                    ...clonedOptions
                };
            } catch (e) {
                this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
                return `${key}${sep}${optionsString}`;
            }
            delete clonedOptions.defaultValue;
            return key;
        }
        while(match = this.nestingRegexp.exec(str)){
            let formatters = [];
            clonedOptions = {
                ...options
            };
            clonedOptions = clonedOptions.replace && typeof clonedOptions.replace !== "string" ? clonedOptions.replace : clonedOptions;
            clonedOptions.applyPostProcessor = false;
            delete clonedOptions.defaultValue;
            let doReduce = false;
            if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                const r = match[1].split(this.formatSeparator).map((elem)=>elem.trim());
                match[1] = r.shift();
                formatters = r;
                doReduce = true;
            }
            value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
            if (value && match[0] === str && typeof value !== "string") return value;
            if (typeof value !== "string") value = $f5941fe2585e9af7$var$makeString(value);
            if (!value) {
                this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
                value = "";
            }
            if (doReduce) value = formatters.reduce((v, f)=>this.format(v, f, options.lng, {
                    ...options,
                    interpolationkey: match[1].trim()
                }), value.trim());
            str = str.replace(match[0], value);
            this.regexp.lastIndex = 0;
        }
        return str;
    }
}
function $f5941fe2585e9af7$var$parseFormatStr(formatStr) {
    let formatName = formatStr.toLowerCase().trim();
    const formatOptions = {};
    if (formatStr.indexOf("(") > -1) {
        const p = formatStr.split("(");
        formatName = p[0].toLowerCase().trim();
        const optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === "currency" && optStr.indexOf(":") < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === "relativetime" && optStr.indexOf(":") < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            const opts = optStr.split(";");
            opts.forEach((opt)=>{
                if (!opt) return;
                const [key, ...rest] = opt.split(":");
                const val = rest.join(":").trim().replace(/^'+|'+$/g, "");
                if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val;
                if (val === "false") formatOptions[key.trim()] = false;
                if (val === "true") formatOptions[key.trim()] = true;
                if (!isNaN(val)) formatOptions[key.trim()] = parseInt(val, 10);
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
}
function $f5941fe2585e9af7$var$createCachedFormatter(fn) {
    const cache = {};
    return function invokeFormatter(val, lng, options) {
        const key = lng + JSON.stringify(options);
        let formatter = cache[key];
        if (!formatter) {
            formatter = fn($f5941fe2585e9af7$var$getCleanedCode(lng), options);
            cache[key] = formatter;
        }
        return formatter(val);
    };
}
class $f5941fe2585e9af7$var$Formatter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = $f5941fe2585e9af7$var$baseLogger.create("formatter");
        this.options = options;
        this.formats = {
            number: $f5941fe2585e9af7$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            currency: $f5941fe2585e9af7$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt,
                    style: "currency"
                });
                return (val)=>formatter.format(val);
            }),
            datetime: $f5941fe2585e9af7$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.DateTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            relativetime: $f5941fe2585e9af7$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.RelativeTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val, opt.range || "day");
            }),
            list: $f5941fe2585e9af7$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.ListFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            })
        };
        this.init(options);
    }
    init(services) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        const iOpts = options.interpolation;
        this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
    }
    add(name, fc) {
        this.formats[name.toLowerCase().trim()] = fc;
    }
    addCached(name, fc) {
        this.formats[name.toLowerCase().trim()] = $f5941fe2585e9af7$var$createCachedFormatter(fc);
    }
    format(value, format, lng) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const formats = format.split(this.formatSeparator);
        const result = formats.reduce((mem, f)=>{
            const { formatName: formatName, formatOptions: formatOptions } = $f5941fe2585e9af7$var$parseFormatStr(f);
            if (this.formats[formatName]) {
                let formatted = mem;
                try {
                    const valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
                    const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                    formatted = this.formats[formatName](mem, l, {
                        ...formatOptions,
                        ...options,
                        ...valOptions
                    });
                } catch (error) {
                    this.logger.warn(error);
                }
                return formatted;
            } else this.logger.warn(`there was no format function for ${formatName}`);
            return mem;
        }, value);
        return result;
    }
}
function $f5941fe2585e9af7$var$removePending(q, name) {
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
}
class $f5941fe2585e9af7$var$Connector extends $f5941fe2585e9af7$var$EventEmitter {
    constructor(backend, store, services){
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        super();
        this.backend = backend;
        this.store = store;
        this.services = services;
        this.languageUtils = services.languageUtils;
        this.options = options;
        this.logger = $f5941fe2585e9af7$var$baseLogger.create("backendConnector");
        this.waitingReads = [];
        this.maxParallelReads = options.maxParallelReads || 10;
        this.readingCalls = 0;
        this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        this.state = {};
        this.queue = [];
        if (this.backend && this.backend.init) this.backend.init(services, options.backend, options);
    }
    queueLoad(languages, namespaces, options, callback) {
        const toLoad = {};
        const pending = {};
        const toLoadLanguages = {};
        const toLoadNamespaces = {};
        languages.forEach((lng)=>{
            let hasAllNamespaces = true;
            namespaces.forEach((ns)=>{
                const name = `${lng}|${ns}`;
                if (!options.reload && this.store.hasResourceBundle(lng, ns)) this.state[name] = 2;
                else if (this.state[name] < 0) ;
                else if (this.state[name] === 1) {
                    if (pending[name] === undefined) pending[name] = true;
                } else {
                    this.state[name] = 1;
                    hasAllNamespaces = false;
                    if (pending[name] === undefined) pending[name] = true;
                    if (toLoad[name] === undefined) toLoad[name] = true;
                    if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                }
            });
            if (!hasAllNamespaces) toLoadLanguages[lng] = true;
        });
        if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
            pending: pending,
            pendingCount: Object.keys(pending).length,
            loaded: {},
            errors: [],
            callback: callback
        });
        return {
            toLoad: Object.keys(toLoad),
            pending: Object.keys(pending),
            toLoadLanguages: Object.keys(toLoadLanguages),
            toLoadNamespaces: Object.keys(toLoadNamespaces)
        };
    }
    loaded(name, err, data) {
        const s = name.split("|");
        const lng = s[0];
        const ns = s[1];
        if (err) this.emit("failedLoading", lng, ns, err);
        if (data) this.store.addResourceBundle(lng, ns, data);
        this.state[name] = err ? -1 : 2;
        const loaded = {};
        this.queue.forEach((q)=>{
            $f5941fe2585e9af7$var$pushPath(q.loaded, [
                lng
            ], ns);
            $f5941fe2585e9af7$var$removePending(q, name);
            if (err) q.errors.push(err);
            if (q.pendingCount === 0 && !q.done) {
                Object.keys(q.loaded).forEach((l)=>{
                    if (!loaded[l]) loaded[l] = {};
                    const loadedKeys = q.loaded[l];
                    if (loadedKeys.length) loadedKeys.forEach((n)=>{
                        if (loaded[l][n] === undefined) loaded[l][n] = true;
                    });
                });
                q.done = true;
                if (q.errors.length) q.callback(q.errors);
                else q.callback();
            }
        });
        this.emit("loaded", loaded);
        this.queue = this.queue.filter((q)=>!q.done);
    }
    read(lng, ns, fcName) {
        let tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        let wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
        let callback = arguments.length > 5 ? arguments[5] : undefined;
        if (!lng.length) return callback(null, {});
        if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
                lng: lng,
                ns: ns,
                fcName: fcName,
                tried: tried,
                wait: wait,
                callback: callback
            });
            return;
        }
        this.readingCalls++;
        const resolver = (err, data)=>{
            this.readingCalls--;
            if (this.waitingReads.length > 0) {
                const next = this.waitingReads.shift();
                this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
            }
            if (err && data && tried < this.maxRetries) {
                setTimeout(()=>{
                    this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
                }, wait);
                return;
            }
            callback(err, data);
        };
        const fc = this.backend[fcName].bind(this.backend);
        if (fc.length === 2) {
            try {
                const r = fc(lng, ns);
                if (r && typeof r.then === "function") r.then((data)=>resolver(null, data)).catch(resolver);
                else resolver(null, r);
            } catch (err) {
                resolver(err);
            }
            return;
        }
        return fc(lng, ns, resolver);
    }
    prepareLoading(languages, namespaces) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let callback = arguments.length > 3 ? arguments[3] : undefined;
        if (!this.backend) {
            this.logger.warn("No backend was added via i18next.use. Will not load resources.");
            return callback && callback();
        }
        if (typeof languages === "string") languages = this.languageUtils.toResolveHierarchy(languages);
        if (typeof namespaces === "string") namespaces = [
            namespaces
        ];
        const toLoad = this.queueLoad(languages, namespaces, options, callback);
        if (!toLoad.toLoad.length) {
            if (!toLoad.pending.length) callback();
            return null;
        }
        toLoad.toLoad.forEach((name)=>{
            this.loadOne(name);
        });
    }
    load(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {}, callback);
    }
    reload(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {
            reload: true
        }, callback);
    }
    loadOne(name) {
        let prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
        const s = name.split("|");
        const lng = s[0];
        const ns = s[1];
        this.read(lng, ns, "read", undefined, undefined, (err, data)=>{
            if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
            if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
            this.loaded(name, err, data);
        });
    }
    saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
        let clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : ()=>{};
        if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
            this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
            return;
        }
        if (key === undefined || key === null || key === "") return;
        if (this.backend && this.backend.create) {
            const opts = {
                ...options,
                isUpdate: isUpdate
            };
            const fc = this.backend.create.bind(this.backend);
            if (fc.length < 6) try {
                let r;
                if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                else r = fc(languages, namespace, key, fallbackValue);
                if (r && typeof r.then === "function") r.then((data)=>clb(null, data)).catch(clb);
                else clb(null, r);
            } catch (err) {
                clb(err);
            }
            else fc(languages, namespace, key, fallbackValue, clb, opts);
        }
        if (!languages || !languages[0]) return;
        this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
}
function $f5941fe2585e9af7$var$get() {
    return {
        debug: false,
        initImmediate: true,
        ns: [
            "translation"
        ],
        defaultNS: [
            "translation"
        ],
        fallbackLng: [
            "dev"
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: "all",
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: ".",
        nsSeparator: ":",
        pluralSeparator: "_",
        contextSeparator: "_",
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: "fallback",
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: false,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: function handle(args) {
            let ret = {};
            if (typeof args[1] === "object") ret = args[1];
            if (typeof args[1] === "string") ret.defaultValue = args[1];
            if (typeof args[2] === "string") ret.tDescription = args[2];
            if (typeof args[2] === "object" || typeof args[3] === "object") {
                const options = args[3] || args[2];
                Object.keys(options).forEach((key)=>{
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: (value, format, lng, options)=>value,
            prefix: "{{",
            suffix: "}}",
            formatSeparator: ",",
            unescapePrefix: "-",
            nestingPrefix: "$t(",
            nestingSuffix: ")",
            nestingOptionsSeparator: ",",
            maxReplaces: 1000,
            skipOnVariables: true
        }
    };
}
function $f5941fe2585e9af7$var$transformOptions(options) {
    if (typeof options.ns === "string") options.ns = [
        options.ns
    ];
    if (typeof options.fallbackLng === "string") options.fallbackLng = [
        options.fallbackLng
    ];
    if (typeof options.fallbackNS === "string") options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs && options.supportedLngs.indexOf("cimode") < 0) options.supportedLngs = options.supportedLngs.concat([
        "cimode"
    ]);
    return options;
}
function $f5941fe2585e9af7$var$noop() {}
function $f5941fe2585e9af7$var$bindMemberFunctions(inst) {
    const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach((mem)=>{
        if (typeof inst[mem] === "function") inst[mem] = inst[mem].bind(inst);
    });
}
class $f5941fe2585e9af7$var$I18n extends $f5941fe2585e9af7$var$EventEmitter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        super();
        this.options = $f5941fe2585e9af7$var$transformOptions(options);
        this.services = {};
        this.logger = $f5941fe2585e9af7$var$baseLogger;
        this.modules = {
            external: []
        };
        $f5941fe2585e9af7$var$bindMemberFunctions(this);
        if (callback && !this.isInitialized && !options.isClone) {
            if (!this.options.initImmediate) {
                this.init(options, callback);
                return this;
            }
            setTimeout(()=>{
                this.init(options, callback);
            }, 0);
        }
    }
    init() {
        var _this = this;
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        if (typeof options === "function") {
            callback = options;
            options = {};
        }
        if (!options.defaultNS && options.defaultNS !== false && options.ns) {
            if (typeof options.ns === "string") options.defaultNS = options.ns;
            else if (options.ns.indexOf("translation") < 0) options.defaultNS = options.ns[0];
        }
        const defOpts = $f5941fe2585e9af7$var$get();
        this.options = {
            ...defOpts,
            ...this.options,
            ...$f5941fe2585e9af7$var$transformOptions(options)
        };
        if (this.options.compatibilityAPI !== "v1") this.options.interpolation = {
            ...defOpts.interpolation,
            ...this.options.interpolation
        };
        if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
        if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
        function createClassOnDemand(ClassOrObject) {
            if (!ClassOrObject) return null;
            if (typeof ClassOrObject === "function") return new ClassOrObject();
            return ClassOrObject;
        }
        if (!this.options.isClone) {
            if (this.modules.logger) $f5941fe2585e9af7$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
            else $f5941fe2585e9af7$var$baseLogger.init(null, this.options);
            let formatter;
            if (this.modules.formatter) formatter = this.modules.formatter;
            else if (typeof Intl !== "undefined") formatter = $f5941fe2585e9af7$var$Formatter;
            const lu = new $f5941fe2585e9af7$var$LanguageUtil(this.options);
            this.store = new $f5941fe2585e9af7$var$ResourceStore(this.options.resources, this.options);
            const s = this.services;
            s.logger = $f5941fe2585e9af7$var$baseLogger;
            s.resourceStore = this.store;
            s.languageUtils = lu;
            s.pluralResolver = new $f5941fe2585e9af7$var$PluralResolver(lu, {
                prepend: this.options.pluralSeparator,
                compatibilityJSON: this.options.compatibilityJSON,
                simplifyPluralSuffix: this.options.simplifyPluralSuffix
            });
            if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                s.formatter = createClassOnDemand(formatter);
                s.formatter.init(s, this.options);
                this.options.interpolation.format = s.formatter.format.bind(s.formatter);
            }
            s.interpolator = new $f5941fe2585e9af7$var$Interpolator(this.options);
            s.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            };
            s.backendConnector = new $f5941fe2585e9af7$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
            s.backendConnector.on("*", function(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                _this.emit(event, ...args);
            });
            if (this.modules.languageDetector) {
                s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
            }
            if (this.modules.i18nFormat) {
                s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                if (s.i18nFormat.init) s.i18nFormat.init(this);
            }
            this.translator = new $f5941fe2585e9af7$var$Translator(this.services, this.options);
            this.translator.on("*", function(event) {
                for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                _this.emit(event, ...args);
            });
            this.modules.external.forEach((m)=>{
                if (m.init) m.init(this);
            });
        }
        this.format = this.options.interpolation.format;
        if (!callback) callback = $f5941fe2585e9af7$var$noop;
        if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            if (codes.length > 0 && codes[0] !== "dev") this.options.lng = codes[0];
        }
        if (!this.services.languageDetector && !this.options.lng) this.logger.warn("init: no languageDetector is used and no lng is defined");
        const storeApi = [
            "getResource",
            "hasResourceBundle",
            "getResourceBundle",
            "getDataByLanguage"
        ];
        storeApi.forEach((fcName)=>{
            this[fcName] = function() {
                return _this.store[fcName](...arguments);
            };
        });
        const storeApiChained = [
            "addResource",
            "addResources",
            "addResourceBundle",
            "removeResourceBundle"
        ];
        storeApiChained.forEach((fcName)=>{
            this[fcName] = function() {
                _this.store[fcName](...arguments);
                return _this;
            };
        });
        const deferred = $f5941fe2585e9af7$var$defer();
        const load = ()=>{
            const finish = (err, t)=>{
                if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn("init: i18next is already initialized. You should call init just once!");
                this.isInitialized = true;
                if (!this.options.isClone) this.logger.log("initialized", this.options);
                this.emit("initialized", this.options);
                deferred.resolve(t);
                callback(err, t);
            };
            if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized) return finish(null, this.t.bind(this));
            this.changeLanguage(this.options.lng, finish);
        };
        if (this.options.resources || !this.options.initImmediate) load();
        else setTimeout(load, 0);
        return deferred;
    }
    loadResources(language) {
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $f5941fe2585e9af7$var$noop;
        let usedCallback = callback;
        const usedLng = typeof language === "string" ? language : this.language;
        if (typeof language === "function") usedCallback = language;
        if (!this.options.resources || this.options.partialBundledLanguages) {
            if (usedLng && usedLng.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
            const toLoad = [];
            const append = (lng)=>{
                if (!lng) return;
                if (lng === "cimode") return;
                const lngs = this.services.languageUtils.toResolveHierarchy(lng);
                lngs.forEach((l)=>{
                    if (l === "cimode") return;
                    if (toLoad.indexOf(l) < 0) toLoad.push(l);
                });
            };
            if (!usedLng) {
                const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                fallbacks.forEach((l)=>append(l));
            } else append(usedLng);
            if (this.options.preload) this.options.preload.forEach((l)=>append(l));
            this.services.backendConnector.load(toLoad, this.options.ns, (e)=>{
                if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
                usedCallback(e);
            });
        } else usedCallback(null);
    }
    reloadResources(lngs, ns, callback) {
        const deferred = $f5941fe2585e9af7$var$defer();
        if (!lngs) lngs = this.languages;
        if (!ns) ns = this.options.ns;
        if (!callback) callback = $f5941fe2585e9af7$var$noop;
        this.services.backendConnector.reload(lngs, ns, (err)=>{
            deferred.resolve();
            callback(err);
        });
        return deferred;
    }
    use(module) {
        if (!module) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
        if (!module.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
        if (module.type === "backend") this.modules.backend = module;
        if (module.type === "logger" || module.log && module.warn && module.error) this.modules.logger = module;
        if (module.type === "languageDetector") this.modules.languageDetector = module;
        if (module.type === "i18nFormat") this.modules.i18nFormat = module;
        if (module.type === "postProcessor") $f5941fe2585e9af7$var$postProcessor.addPostProcessor(module);
        if (module.type === "formatter") this.modules.formatter = module;
        if (module.type === "3rdParty") this.modules.external.push(module);
        return this;
    }
    setResolvedLanguage(l) {
        if (!l || !this.languages) return;
        if ([
            "cimode",
            "dev"
        ].indexOf(l) > -1) return;
        for(let li = 0; li < this.languages.length; li++){
            const lngInLngs = this.languages[li];
            if ([
                "cimode",
                "dev"
            ].indexOf(lngInLngs) > -1) continue;
            if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                this.resolvedLanguage = lngInLngs;
                break;
            }
        }
    }
    changeLanguage(lng, callback) {
        var _this2 = this;
        this.isLanguageChangingTo = lng;
        const deferred = $f5941fe2585e9af7$var$defer();
        this.emit("languageChanging", lng);
        const setLngProps = (l)=>{
            this.language = l;
            this.languages = this.services.languageUtils.toResolveHierarchy(l);
            this.resolvedLanguage = undefined;
            this.setResolvedLanguage(l);
        };
        const done = (err, l)=>{
            if (l) {
                setLngProps(l);
                this.translator.changeLanguage(l);
                this.isLanguageChangingTo = undefined;
                this.emit("languageChanged", l);
                this.logger.log("languageChanged", l);
            } else this.isLanguageChangingTo = undefined;
            deferred.resolve(function() {
                return _this2.t(...arguments);
            });
            if (callback) callback(err, function() {
                return _this2.t(...arguments);
            });
        };
        const setLng = (lngs)=>{
            if (!lng && !lngs && this.services.languageDetector) lngs = [];
            const l = typeof lngs === "string" ? lngs : this.services.languageUtils.getBestMatchFromCodes(lngs);
            if (l) {
                if (!this.language) setLngProps(l);
                if (!this.translator.language) this.translator.changeLanguage(l);
                if (this.services.languageDetector && this.services.languageDetector.cacheUserLanguage) this.services.languageDetector.cacheUserLanguage(l);
            }
            this.loadResources(l, (err)=>{
                done(err, l);
            });
        };
        if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
        else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
            if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
            else this.services.languageDetector.detect(setLng);
        } else setLng(lng);
        return deferred;
    }
    getFixedT(lng, ns, keyPrefix) {
        var _this3 = this;
        const fixedT = function(key, opts) {
            let options;
            if (typeof opts !== "object") {
                for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                options = _this3.options.overloadTranslationOptionHandler([
                    key,
                    opts
                ].concat(rest));
            } else options = {
                ...opts
            };
            options.lng = options.lng || fixedT.lng;
            options.lngs = options.lngs || fixedT.lngs;
            options.ns = options.ns || fixedT.ns;
            options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
            const keySeparator = _this3.options.keySeparator || ".";
            let resultKey;
            if (options.keyPrefix && Array.isArray(key)) resultKey = key.map((k)=>`${options.keyPrefix}${keySeparator}${k}`);
            else resultKey = options.keyPrefix ? `${options.keyPrefix}${keySeparator}${key}` : key;
            return _this3.t(resultKey, options);
        };
        if (typeof lng === "string") fixedT.lng = lng;
        else fixedT.lngs = lng;
        fixedT.ns = ns;
        fixedT.keyPrefix = keyPrefix;
        return fixedT;
    }
    t() {
        return this.translator && this.translator.translate(...arguments);
    }
    exists() {
        return this.translator && this.translator.exists(...arguments);
    }
    setDefaultNamespace(ns) {
        this.options.defaultNS = ns;
    }
    hasLoadedNamespace(ns) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (!this.isInitialized) {
            this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages);
            return false;
        }
        if (!this.languages || !this.languages.length) {
            this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages);
            return false;
        }
        const lng = options.lng || this.resolvedLanguage || this.languages[0];
        const fallbackLng = this.options ? this.options.fallbackLng : false;
        const lastLng = this.languages[this.languages.length - 1];
        if (lng.toLowerCase() === "cimode") return true;
        const loadNotPending = (l, n)=>{
            const loadState = this.services.backendConnector.state[`${l}|${n}`];
            return loadState === -1 || loadState === 2;
        };
        if (options.precheck) {
            const preResult = options.precheck(this, loadNotPending);
            if (preResult !== undefined) return preResult;
        }
        if (this.hasResourceBundle(lng, ns)) return true;
        if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
        if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
        return false;
    }
    loadNamespaces(ns, callback) {
        const deferred = $f5941fe2585e9af7$var$defer();
        if (!this.options.ns) {
            if (callback) callback();
            return Promise.resolve();
        }
        if (typeof ns === "string") ns = [
            ns
        ];
        ns.forEach((n)=>{
            if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
        });
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    loadLanguages(lngs, callback) {
        const deferred = $f5941fe2585e9af7$var$defer();
        if (typeof lngs === "string") lngs = [
            lngs
        ];
        const preloaded = this.options.preload || [];
        const newLngs = lngs.filter((lng)=>preloaded.indexOf(lng) < 0);
        if (!newLngs.length) {
            if (callback) callback();
            return Promise.resolve();
        }
        this.options.preload = preloaded.concat(newLngs);
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    dir(lng) {
        if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
        if (!lng) return "rtl";
        const rtlLngs = [
            "ar",
            "shu",
            "sqr",
            "ssh",
            "xaa",
            "yhd",
            "yud",
            "aao",
            "abh",
            "abv",
            "acm",
            "acq",
            "acw",
            "acx",
            "acy",
            "adf",
            "ads",
            "aeb",
            "aec",
            "afb",
            "ajp",
            "apc",
            "apd",
            "arb",
            "arq",
            "ars",
            "ary",
            "arz",
            "auz",
            "avl",
            "ayh",
            "ayl",
            "ayn",
            "ayp",
            "bbz",
            "pga",
            "he",
            "iw",
            "ps",
            "pbt",
            "pbu",
            "pst",
            "prp",
            "prd",
            "ug",
            "ur",
            "ydd",
            "yds",
            "yih",
            "ji",
            "yi",
            "hbo",
            "men",
            "xmn",
            "fa",
            "jpr",
            "peo",
            "pes",
            "prs",
            "dv",
            "sam",
            "ckb"
        ];
        const languageUtils = this.services && this.services.languageUtils || new $f5941fe2585e9af7$var$LanguageUtil($f5941fe2585e9af7$var$get());
        return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
    }
    static createInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        return new $f5941fe2585e9af7$var$I18n(options, callback);
    }
    cloneInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $f5941fe2585e9af7$var$noop;
        const forkResourceStore = options.forkResourceStore;
        if (forkResourceStore) delete options.forkResourceStore;
        const mergedOptions = {
            ...this.options,
            ...options,
            isClone: true
        };
        const clone = new $f5941fe2585e9af7$var$I18n(mergedOptions);
        if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
        const membersToCopy = [
            "store",
            "services",
            "language"
        ];
        membersToCopy.forEach((m)=>{
            clone[m] = this[m];
        });
        clone.services = {
            ...this.services
        };
        clone.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        if (forkResourceStore) {
            clone.store = new $f5941fe2585e9af7$var$ResourceStore(this.store.data, mergedOptions);
            clone.services.resourceStore = clone.store;
        }
        clone.translator = new $f5941fe2585e9af7$var$Translator(clone.services, mergedOptions);
        clone.translator.on("*", function(event) {
            for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
            clone.emit(event, ...args);
        });
        clone.init(mergedOptions, callback);
        clone.translator.options = mergedOptions;
        clone.translator.backendConnector.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        return clone;
    }
    toJSON() {
        return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
        };
    }
}
const $f5941fe2585e9af7$export$2e2bcd8739ae039 = $f5941fe2585e9af7$var$I18n.createInstance();
$f5941fe2585e9af7$export$2e2bcd8739ae039.createInstance = $f5941fe2585e9af7$var$I18n.createInstance;
const $f5941fe2585e9af7$export$99152e8d49ca4e7d = $f5941fe2585e9af7$export$2e2bcd8739ae039.createInstance;
const $f5941fe2585e9af7$export$147ec2801e896265 = $f5941fe2585e9af7$export$2e2bcd8739ae039.dir;
const $f5941fe2585e9af7$export$2cd8252107eb640b = $f5941fe2585e9af7$export$2e2bcd8739ae039.init;
const $f5941fe2585e9af7$export$d3d08d944062d7e = $f5941fe2585e9af7$export$2e2bcd8739ae039.loadResources;
const $f5941fe2585e9af7$export$a5d9bf5d83fcab09 = $f5941fe2585e9af7$export$2e2bcd8739ae039.reloadResources;
const $f5941fe2585e9af7$export$1f96ae73734a86cc = $f5941fe2585e9af7$export$2e2bcd8739ae039.use;
const $f5941fe2585e9af7$export$61465194746e7fd2 = $f5941fe2585e9af7$export$2e2bcd8739ae039.changeLanguage;
const $f5941fe2585e9af7$export$f90d180fc7da3b3b = $f5941fe2585e9af7$export$2e2bcd8739ae039.getFixedT;
const $f5941fe2585e9af7$export$625550452a3fa3ec = $f5941fe2585e9af7$export$2e2bcd8739ae039.t;
const $f5941fe2585e9af7$export$f7e9f41ea797a17 = $f5941fe2585e9af7$export$2e2bcd8739ae039.exists;
const $f5941fe2585e9af7$export$2b4b218e406d2d00 = $f5941fe2585e9af7$export$2e2bcd8739ae039.setDefaultNamespace;
const $f5941fe2585e9af7$export$93d9ee97c1ad3f31 = $f5941fe2585e9af7$export$2e2bcd8739ae039.hasLoadedNamespace;
const $f5941fe2585e9af7$export$83be934b53fff43b = $f5941fe2585e9af7$export$2e2bcd8739ae039.loadNamespaces;
const $f5941fe2585e9af7$export$8cd7e7a54fa865bc = $f5941fe2585e9af7$export$2e2bcd8739ae039.loadLanguages;

});


parcelRegister("5xHX4", function(module, exports) {
/* eslint-disable */ /**
 * jQuery.fn.sortElements
 * --------------
 * @param Function comparator:
 *   Exactly the same behaviour as [1,2,3].sort(comparator)
 *
 * @param Function getSortable
 *   A function that should return the element that is
 *   to be sorted. The comparator will run on the
 *   current collection, but you may want the actual
 *   resulting sort to occur on a parent or another
 *   associated element.
 *
 *   E.g. $('td').sortElements(comparator, function(){
 *      return this.parentNode;
 *   })
 *
 *   The <td>'s parent (<tr>) will be sorted instead
 *   of the <td> itself.
 */ jQuery.fn.sortElements = function() {
    var sort = [].sort;
    return function(comparator, getSortable) {
        getSortable = getSortable || function() {
            return this;
        };
        var placements = this.map(function() {
            var sortElement = getSortable.call(this), parentNode = sortElement.parentNode, // Since the element itself will change position, we have
            // to have some way of storing its original position in
            // the DOM. The easiest way is to have a 'flag' node:
            nextSibling = parentNode.insertBefore(document.createTextNode(""), sortElement.nextSibling);
            return function() {
                if (parentNode === this) throw new Error("You can't sort elements if any one is a descendant of another.");
                // Insert before flag:
                parentNode.insertBefore(this, nextSibling);
                // Remove flag:
                parentNode.removeChild(nextSibling);
            };
        });
        return sort.call(this, comparator).each(function(i) {
            placements[i].call(getSortable.call(this));
        });
    };
}();

});


parcelRegister("9jmJF", function(module, exports) {

var $jwUJU = parcelRequire("jwUJU");
EntityModule.registerInitializer(function(node) {
    $.ajaxSetup({
        headers: {
            "X-XSRF-Token": (0, $jwUJU.getCookie)("XSRF-TOKEN")
        }
    });
});

});
parcelRegister("jwUJU", function(module, exports) {

$parcel$export(module.exports, "convertResponseToText", () => $e37d04beed5aa82a$export$5d9b5532eeed7d60);
$parcel$export(module.exports, "convertResponseToTextWithErrorFunction", () => $e37d04beed5aa82a$export$d285fa026023ffa2);
$parcel$export(module.exports, "convertResponseToTextWithoutSettingRedirectUrl", () => $e37d04beed5aa82a$export$64b079ff2efd6932);
$parcel$export(module.exports, "convertResponseToJson", () => $e37d04beed5aa82a$export$e78d78c407597390);
$parcel$export(module.exports, "handleError", () => $e37d04beed5aa82a$export$d3da1ecaf1206c58);
$parcel$export(module.exports, "handleErrorWithMessage", () => $e37d04beed5aa82a$export$e64a2d8b601b02ce);
$parcel$export(module.exports, "renderTemplateAndReplace", () => $e37d04beed5aa82a$export$53c4fbad7bca0356);
$parcel$export(module.exports, "getCookie", () => $e37d04beed5aa82a$export$4be65e66cfa2648a);
$parcel$export(module.exports, "getBrowser", () => $e37d04beed5aa82a$export$89e15fc796a4a429);
$parcel$export(module.exports, "ax", () => $e37d04beed5aa82a$export$9fa96a7d116ea3ce);
$parcel$export(module.exports, "getTokenSafeHeaders", () => $e37d04beed5aa82a$export$568266231da8653d);

var $fEeKn = parcelRequire("fEeKn");

var $bg8Ty = parcelRequire("bg8Ty");
function $e37d04beed5aa82a$export$5d9b5532eeed7d60(response) {
    if (response.redirected) {
        window.location.href = response.url + "&redirectUrl=" + encodeURI(window.location.href);
        return Promise.reject(null);
    } else if (response.ok) return response.text();
    else return Promise.reject({
        status: response.status,
        statusText: response.statusText
    });
}
function $e37d04beed5aa82a$export$d285fa026023ffa2(response, errorFunction) {
    if (response.redirected) {
        window.location.href = response.url + "&redirectUrl=" + encodeURI(window.location.href);
        return Promise.reject(null);
    } else if (response.ok) return response.text();
    else {
        errorFunction(response);
        return Promise.reject(null);
    }
}
function $e37d04beed5aa82a$export$64b079ff2efd6932(response) {
    if (response.redirected) {
        window.location.href = response.url;
        return Promise.reject(null);
    } else return response.text();
}
function $e37d04beed5aa82a$export$e78d78c407597390(response) {
    if (response.redirected) window.location.href = response.url + "&redirectUrl=" + encodeURI(window.location.href);
    else return response.json();
}
function $e37d04beed5aa82a$export$d3da1ecaf1206c58(e) {
    if (e !== null) {
        if (0, $fEeKn.apm) (0, $fEeKn.apm).captureError(e);
        console.error(e);
        (0, $bg8Ty.showErrorModal)("<p>Oops! Something went wrong, try again later</p>");
    }
}
function $e37d04beed5aa82a$export$e64a2d8b601b02ce(data, handleErrorFunction) {
    data.text().then((text)=>{
        if (!!text) {
            (0, $fEeKn.apm).captureError(text);
            console.error(text);
            (0, $bg8Ty.showErrorModal)(`<p>${text}</p>`);
            handleErrorFunction();
        } else (0, $bg8Ty.showErrorModal)("<p>Oops! Something went wrong, try again later</p>");
    });
}
function $e37d04beed5aa82a$export$b5c363744c17aeab(id, destination, templateConfigurationFunction) {
    var result = document.querySelector(id).content.cloneNode(true);
    templateConfigurationFunction(result);
    $(destination).prepend(result);
}
function $e37d04beed5aa82a$export$53c4fbad7bca0356(id, destination, templateConfigurationFunction) {
    var result = document.querySelector(id).content.cloneNode(true);
    templateConfigurationFunction(result);
    $(destination).html(result);
}
function $e37d04beed5aa82a$export$833712d0163a93e1() {
    var str = window.location.hash;
    var objURL = {};
    str.replace(new RegExp("([^#=&]+)(=([^&]*))?", "g"), function($0, $1, $2, $3) {
        objURL[$1] = $3;
    });
    return objURL;
}
function $e37d04beed5aa82a$export$e2de15bbd9edf9c6() {
    var str = window.location.search;
    var objURL = {};
    str.replace(new RegExp("([^?=&]+)(=([^&]*))?", "g"), function($0, $1, $2, $3) {
        objURL[$1] = $3;
    });
    return objURL;
}
function $e37d04beed5aa82a$export$4be65e66cfa2648a(name) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
}
function $e37d04beed5aa82a$export$89e15fc796a4a429() {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf("safari") !== -1) {
        if (ua.indexOf("chrome") > -1) return "CHROME";
        else return "SAFARI";
    }
}
const $e37d04beed5aa82a$export$9fa96a7d116ea3ce = {
    log: {
        sessionStorageKey: "ax.log.enabled",
        enabled: false,
        prefix: "[AX] ",
        enable () {
            this.enabled = true;
            window.sessionStorage && window.sessionStorage.setItem(this.sessionStorageKey, "true");
        },
        disable () {
            this.enabled = false;
            window.sessionStorage && window.sessionStorage.removeItem(this.sessionStorageKey);
        },
        info (message, params) {
            this.send(console.info, message, params);
        },
        debug (message, params) {
            this.send(console.debug, message, params);
        },
        error (message, params) {
            this.send(console.error, message, params);
        },
        group (title, params) {
            this.send(console.group, title, params);
        },
        groupCollapsed (title, params) {
            this.send(console.groupCollapsed, title, params);
        },
        groupEnd () {
            this.send(console.groupEnd);
        },
        send (target, message, params) {
            if (this.enabled) target(this.prefix + message, params ? params : "");
        }
    }
};
if (window.sessionStorage && sessionStorage.getItem($e37d04beed5aa82a$export$9fa96a7d116ea3ce.log.sessionStorageKey) === "true") $e37d04beed5aa82a$export$9fa96a7d116ea3ce.log.enable();
function $e37d04beed5aa82a$export$568266231da8653d() {
    let cookie = $e37d04beed5aa82a$export$4be65e66cfa2648a("XSRF-TOKEN");
    if (!cookie) return {
        "Content-Type": "application/x-www-form-urlencoded"
    };
    return {
        "X-XSRF-Token": cookie,
        "Content-Type": "application/x-www-form-urlencoded"
    };
}

});
parcelRegister("fEeKn", function(module, exports) {

$parcel$export(module.exports, "apm", () => $b64607e0f829b5f2$export$3f9ccce5afbb8f1);

var $4TTrL = parcelRequire("4TTrL");

var $jwUJU = parcelRequire("jwUJU");
let $b64607e0f829b5f2$var$apmInstance = null;
if (window.camalion.rumServiceName && window.camalion.rumServerUrl && window.camalion.rumEnvironment) $b64607e0f829b5f2$var$apmInstance = (0, $4TTrL.init)({
    serviceName: window.camalion.rumServiceName,
    serverUrl: window.camalion.rumServerUrl,
    environment: window.camalion.rumEnvironment,
    pageLoadTransactionName: window.location.pathname
});
const $b64607e0f829b5f2$export$3f9ccce5afbb8f1 = $b64607e0f829b5f2$var$apmInstance;
let $b64607e0f829b5f2$var$camid = (0, $jwUJU.getCookie)("camid");
if (typeof $b64607e0f829b5f2$var$camid === "undefined") $b64607e0f829b5f2$var$camid = "unknown";
if ($b64607e0f829b5f2$export$3f9ccce5afbb8f1 !== null) $b64607e0f829b5f2$export$3f9ccce5afbb8f1.addLabels({
    cama_uniqueid: $b64607e0f829b5f2$var$camid
});

});
parcelRegister("4TTrL", function(module, exports) {

$parcel$export(module.exports, "init", () => $39174f15305f40b0$export$2cd8252107eb640b);

var $b3k0J = parcelRequire("b3k0J");
var $kbp1h = parcelRequire("kbp1h");
var $la17Z = parcelRequire("la17Z");

var $jbdDh = parcelRequire("jbdDh");
function $39174f15305f40b0$var$getApmBase() {
    if ((0, $la17Z.isBrowser) && window.elasticApm) return window.elasticApm;
    var enabled = (0, $b3k0J.bootstrap)();
    var serviceFactory = (0, $kbp1h.createServiceFactory)();
    var apmBase = new (0, $jbdDh.default)(serviceFactory, !enabled);
    if (0, $la17Z.isBrowser) window.elasticApm = apmBase;
    return apmBase;
}
var $39174f15305f40b0$export$66cd81c234b843ce = $39174f15305f40b0$var$getApmBase();
var $39174f15305f40b0$export$2cd8252107eb640b = $39174f15305f40b0$export$66cd81c234b843ce.init.bind($39174f15305f40b0$export$66cd81c234b843ce);
var $39174f15305f40b0$export$2e2bcd8739ae039 = $39174f15305f40b0$export$2cd8252107eb640b;

});
parcelRegister("b3k0J", function(module, exports) {

$parcel$export(module.exports, "bootstrap", () => $80bf7f39fe0a82ce$export$36aff1fbb4f5dfc6);

var $la17Z = parcelRequire("la17Z");

var $3tnfy = parcelRequire("3tnfy");

var $dgsvq = parcelRequire("dgsvq");
var $80bf7f39fe0a82ce$var$enabled = false;
function $80bf7f39fe0a82ce$export$36aff1fbb4f5dfc6() {
    if ((0, $la17Z.isPlatformSupported)()) {
        (0, $3tnfy.patchAll)();
        (0, $dgsvq.state).bootstrapTime = (0, $la17Z.now)();
        $80bf7f39fe0a82ce$var$enabled = true;
    } else if (0, $la17Z.isBrowser) console.log("[Elastic APM] platform is not supported!");
    return $80bf7f39fe0a82ce$var$enabled;
}

});
parcelRegister("la17Z", function(module, exports) {

$parcel$export(module.exports, "isBrowser", () => $f67b6822c0d0d0e2$export$4e09c449d6c407f7);
$parcel$export(module.exports, "PERF", () => $f67b6822c0d0d0e2$export$20dfe5c0db9ba10);
$parcel$export(module.exports, "generateRandomId", () => $f67b6822c0d0d0e2$export$59b2544ec352d56);
$parcel$export(module.exports, "getDtHeaderValue", () => $f67b6822c0d0d0e2$export$312052e2a8d615c6);
$parcel$export(module.exports, "parseDtHeaderValue", () => $f67b6822c0d0d0e2$export$86a08f9fd706a6b8);
$parcel$export(module.exports, "isDtHeaderValid", () => $f67b6822c0d0d0e2$export$a6f4cb80c241b86f);
$parcel$export(module.exports, "getTSHeaderValue", () => $f67b6822c0d0d0e2$export$6fbffd43bfec7ed8);
$parcel$export(module.exports, "setRequestHeader", () => $f67b6822c0d0d0e2$export$4a0dedceb084213c);
$parcel$export(module.exports, "checkSameOrigin", () => $f67b6822c0d0d0e2$export$8731073ee4364c34);
$parcel$export(module.exports, "isPlatformSupported", () => $f67b6822c0d0d0e2$export$69a8fd7b83cf9f89);
$parcel$export(module.exports, "setLabel", () => $f67b6822c0d0d0e2$export$4f65e594f6031297);
$parcel$export(module.exports, "removeInvalidChars", () => $f67b6822c0d0d0e2$export$fbffb0ac2c2ec159);
$parcel$export(module.exports, "getServerTimingInfo", () => $f67b6822c0d0d0e2$export$11b3928e177dda19);
$parcel$export(module.exports, "stripQueryStringFromUrl", () => $f67b6822c0d0d0e2$export$b3289ee923920b2a);
$parcel$export(module.exports, "getCurrentScript", () => $f67b6822c0d0d0e2$export$8fc24885882b6ead);
$parcel$export(module.exports, "extend", () => $f67b6822c0d0d0e2$export$8b58be045bf06082);
$parcel$export(module.exports, "merge", () => $f67b6822c0d0d0e2$export$4950aa0f605343fb);
$parcel$export(module.exports, "isUndefined", () => $f67b6822c0d0d0e2$export$fce6876652108ab);
$parcel$export(module.exports, "noop", () => $f67b6822c0d0d0e2$export$8793edee2d425525);
$parcel$export(module.exports, "getLatestNonXHRSpan", () => $f67b6822c0d0d0e2$export$4066158e069099c5);
$parcel$export(module.exports, "getLatestXHRSpan", () => $f67b6822c0d0d0e2$export$9db886af3c22d167);
$parcel$export(module.exports, "getEarliestSpan", () => $f67b6822c0d0d0e2$export$26335e41fd84043b);
$parcel$export(module.exports, "now", () => $f67b6822c0d0d0e2$export$461939dd4422153);
$parcel$export(module.exports, "getTime", () => $f67b6822c0d0d0e2$export$1428f42a7de81803);
$parcel$export(module.exports, "getDuration", () => $f67b6822c0d0d0e2$export$75bba95db5c3e753);
$parcel$export(module.exports, "scheduleMicroTask", () => $f67b6822c0d0d0e2$export$3262a5e6cc4c389e);
$parcel$export(module.exports, "isPerfTimelineSupported", () => $f67b6822c0d0d0e2$export$475e1d086d647d28);
$parcel$export(module.exports, "isPerfTypeSupported", () => $f67b6822c0d0d0e2$export$c043ff66aa95c00c);
$parcel$export(module.exports, "isBeaconInspectionEnabled", () => $f67b6822c0d0d0e2$export$7aca418b79512736);
$parcel$export(module.exports, "isRedirectInfoAvailable", () => $f67b6822c0d0d0e2$export$ffcb82e8b0e258ec);

var $lnGft = parcelRequire("lnGft");
var $f67b6822c0d0d0e2$var$slice = [].slice;
var $f67b6822c0d0d0e2$export$4e09c449d6c407f7 = typeof window !== "undefined";
var $f67b6822c0d0d0e2$export$20dfe5c0db9ba10 = $f67b6822c0d0d0e2$export$4e09c449d6c407f7 && typeof performance !== "undefined" ? performance : {};
function $f67b6822c0d0d0e2$export$98d4a615201428ae() {
    var xhr = new window.XMLHttpRequest();
    return "withCredentials" in xhr;
}
var $f67b6822c0d0d0e2$var$byteToHex = [];
for(var $f67b6822c0d0d0e2$var$i = 0; $f67b6822c0d0d0e2$var$i < 256; ++$f67b6822c0d0d0e2$var$i)$f67b6822c0d0d0e2$var$byteToHex[$f67b6822c0d0d0e2$var$i] = ($f67b6822c0d0d0e2$var$i + 0x100).toString(16).substr(1);
function $f67b6822c0d0d0e2$export$58b867e287a802c8(buffer) {
    var hexOctets = [];
    for(var _i = 0; _i < buffer.length; _i++)hexOctets.push($f67b6822c0d0d0e2$var$byteToHex[buffer[_i]]);
    return hexOctets.join("");
}
var $f67b6822c0d0d0e2$var$destination = new Uint8Array(16);
function $f67b6822c0d0d0e2$export$cd94982b18c6332c() {
    if (typeof crypto != "undefined" && typeof crypto.getRandomValues == "function") return crypto.getRandomValues($f67b6822c0d0d0e2$var$destination);
    else if (typeof msCrypto != "undefined" && typeof msCrypto.getRandomValues == "function") return msCrypto.getRandomValues($f67b6822c0d0d0e2$var$destination);
    return $f67b6822c0d0d0e2$var$destination;
}
function $f67b6822c0d0d0e2$export$59b2544ec352d56(length) {
    var id = $f67b6822c0d0d0e2$export$58b867e287a802c8($f67b6822c0d0d0e2$export$cd94982b18c6332c());
    return id.substr(0, length);
}
function $f67b6822c0d0d0e2$export$312052e2a8d615c6(span) {
    var dtVersion = "00";
    var dtUnSampledFlags = "00";
    var dtSampledFlags = "01";
    if (span && span.traceId && span.id && span.parentId) {
        var flags = span.sampled ? dtSampledFlags : dtUnSampledFlags;
        var id = span.sampled ? span.id : span.parentId;
        return dtVersion + "-" + span.traceId + "-" + id + "-" + flags;
    }
}
function $f67b6822c0d0d0e2$export$86a08f9fd706a6b8(value) {
    var parsed = /^([\da-f]{2})-([\da-f]{32})-([\da-f]{16})-([\da-f]{2})$/.exec(value);
    if (parsed) {
        var flags = parsed[4];
        var sampled = flags !== "00";
        return {
            traceId: parsed[2],
            id: parsed[3],
            sampled: sampled
        };
    }
}
function $f67b6822c0d0d0e2$export$a6f4cb80c241b86f(header) {
    return /^[\da-f]{2}-[\da-f]{32}-[\da-f]{16}-[\da-f]{2}$/.test(header) && header.slice(3, 35) !== "00000000000000000000000000000000" && header.slice(36, 52) !== "0000000000000000";
}
function $f67b6822c0d0d0e2$export$6fbffd43bfec7ed8(_ref) {
    var sampleRate = _ref.sampleRate;
    if (typeof sampleRate !== "number" || String(sampleRate).length > 256) return;
    var NAMESPACE = "es";
    var SEPARATOR = "=";
    return "" + NAMESPACE + SEPARATOR + "s:" + sampleRate;
}
function $f67b6822c0d0d0e2$export$4a0dedceb084213c(target, name, value) {
    if (typeof target.setRequestHeader === "function") target.setRequestHeader(name, value);
    else if (target.headers && typeof target.headers.append === "function") target.headers.append(name, value);
    else target[name] = value;
}
function $f67b6822c0d0d0e2$export$8731073ee4364c34(source, target) {
    var isSame = false;
    if (typeof target === "string") isSame = source === target;
    else if (target && typeof target.test === "function") isSame = target.test(source);
    else if (Array.isArray(target)) target.forEach(function(t) {
        if (!isSame) isSame = $f67b6822c0d0d0e2$export$8731073ee4364c34(source, t);
    });
    return isSame;
}
function $f67b6822c0d0d0e2$export$69a8fd7b83cf9f89() {
    return $f67b6822c0d0d0e2$export$4e09c449d6c407f7 && typeof Set === "function" && typeof JSON.stringify === "function" && $f67b6822c0d0d0e2$export$20dfe5c0db9ba10 && typeof $f67b6822c0d0d0e2$export$20dfe5c0db9ba10.now === "function" && $f67b6822c0d0d0e2$export$98d4a615201428ae();
}
function $f67b6822c0d0d0e2$export$4f65e594f6031297(key, value, obj) {
    if (!obj || !key) return;
    var skey = $f67b6822c0d0d0e2$export$fbffb0ac2c2ec159(key);
    var valueType = typeof value;
    if (value != undefined && valueType !== "boolean" && valueType !== "number") value = String(value);
    obj[skey] = value;
    return obj;
}
function $f67b6822c0d0d0e2$export$11b3928e177dda19(serverTimingEntries) {
    if (serverTimingEntries === void 0) serverTimingEntries = [];
    var serverTimingInfo = [];
    var entrySeparator = ", ";
    var valueSeparator = ";";
    for(var _i2 = 0; _i2 < serverTimingEntries.length; _i2++){
        var _serverTimingEntries$ = serverTimingEntries[_i2], name = _serverTimingEntries$.name, duration = _serverTimingEntries$.duration, description = _serverTimingEntries$.description;
        var timingValue = name;
        if (description) timingValue += valueSeparator + "desc=" + description;
        if (duration) timingValue += valueSeparator + "dur=" + duration;
        serverTimingInfo.push(timingValue);
    }
    return serverTimingInfo.join(entrySeparator);
}
function $f67b6822c0d0d0e2$export$e752b05e58096a2f() {
    return $f67b6822c0d0d0e2$export$20dfe5c0db9ba10.timing.fetchStart;
}
function $f67b6822c0d0d0e2$export$b3289ee923920b2a(url) {
    return url && url.split("?")[0];
}
function $f67b6822c0d0d0e2$export$a6cdc56e425d0d0a(value) {
    return value !== null && typeof value === "object";
}
function $f67b6822c0d0d0e2$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}
function $f67b6822c0d0d0e2$export$bf6cb145536e8bab(dst, objs, deep) {
    for(var i = 0, ii = objs.length; i < ii; ++i){
        var obj = objs[i];
        if (!$f67b6822c0d0d0e2$export$a6cdc56e425d0d0a(obj) && !$f67b6822c0d0d0e2$export$f6e2535fb5126e54(obj)) continue;
        var keys = Object.keys(obj);
        for(var j = 0, jj = keys.length; j < jj; j++){
            var key = keys[j];
            var src = obj[key];
            if (deep && $f67b6822c0d0d0e2$export$a6cdc56e425d0d0a(src)) {
                if (!$f67b6822c0d0d0e2$export$a6cdc56e425d0d0a(dst[key])) dst[key] = Array.isArray(src) ? [] : {};
                $f67b6822c0d0d0e2$export$bf6cb145536e8bab(dst[key], [
                    src
                ], false);
            } else dst[key] = src;
        }
    }
    return dst;
}
function $f67b6822c0d0d0e2$export$bf6fdd3c8902f077() {
    if (typeof document !== "undefined") {
        var scripts = document.getElementsByTagName("script");
        for(var i = 0, l = scripts.length; i < l; i++){
            var sc = scripts[i];
            if (sc.src.indexOf("elastic") > 0) return sc;
        }
    }
}
function $f67b6822c0d0d0e2$export$8fc24885882b6ead() {
    if (typeof document !== "undefined") {
        var currentScript = document.currentScript;
        if (!currentScript) return $f67b6822c0d0d0e2$export$bf6fdd3c8902f077();
        return currentScript;
    }
}
function $f67b6822c0d0d0e2$export$8b58be045bf06082(dst) {
    return $f67b6822c0d0d0e2$export$bf6cb145536e8bab(dst, $f67b6822c0d0d0e2$var$slice.call(arguments, 1), false);
}
function $f67b6822c0d0d0e2$export$4950aa0f605343fb(dst) {
    return $f67b6822c0d0d0e2$export$bf6cb145536e8bab(dst, $f67b6822c0d0d0e2$var$slice.call(arguments, 1), true);
}
function $f67b6822c0d0d0e2$export$fce6876652108ab(obj) {
    return typeof obj === "undefined";
}
function $f67b6822c0d0d0e2$export$8793edee2d425525() {}
function $f67b6822c0d0d0e2$export$71aa6c912b956294(array, predicate, thisArg) {
    if (array == null) throw new TypeError("array is null or not defined");
    var o = Object(array);
    var len = o.length >>> 0;
    if (typeof predicate !== "function") throw new TypeError("predicate must be a function");
    var k = 0;
    while(k < len){
        var kValue = o[k];
        if (predicate.call(thisArg, kValue, k, o)) return kValue;
        k++;
    }
    return undefined;
}
function $f67b6822c0d0d0e2$export$fbffb0ac2c2ec159(key) {
    return key.replace(/[.*"]/g, "_");
}
function $f67b6822c0d0d0e2$var$getLatestSpan(spans, typeFilter) {
    var latestSpan = null;
    for(var _i3 = 0; _i3 < spans.length; _i3++){
        var span = spans[_i3];
        if (typeFilter && typeFilter(span.type) && (!latestSpan || latestSpan._end < span._end)) latestSpan = span;
    }
    return latestSpan;
}
function $f67b6822c0d0d0e2$export$4066158e069099c5(spans) {
    return $f67b6822c0d0d0e2$var$getLatestSpan(spans, function(type) {
        return String(type).indexOf("external") === -1;
    });
}
function $f67b6822c0d0d0e2$export$9db886af3c22d167(spans) {
    return $f67b6822c0d0d0e2$var$getLatestSpan(spans, function(type) {
        return String(type).indexOf("external") !== -1;
    });
}
function $f67b6822c0d0d0e2$export$26335e41fd84043b(spans) {
    var earliestSpan = spans[0];
    for(var _i4 = 1; _i4 < spans.length; _i4++){
        var span = spans[_i4];
        if (earliestSpan._start > span._start) earliestSpan = span;
    }
    return earliestSpan;
}
function $f67b6822c0d0d0e2$export$461939dd4422153() {
    return $f67b6822c0d0d0e2$export$20dfe5c0db9ba10.now();
}
function $f67b6822c0d0d0e2$export$1428f42a7de81803(time) {
    return typeof time === "number" && time >= 0 ? time : $f67b6822c0d0d0e2$export$461939dd4422153();
}
function $f67b6822c0d0d0e2$export$75bba95db5c3e753(start, end) {
    if ($f67b6822c0d0d0e2$export$fce6876652108ab(end) || $f67b6822c0d0d0e2$export$fce6876652108ab(start)) return null;
    return parseInt(end - start);
}
function $f67b6822c0d0d0e2$export$fbacb21386347f76(callback) {
    setTimeout(callback, 0);
}
function $f67b6822c0d0d0e2$export$3262a5e6cc4c389e(callback) {
    (0, $lnGft.Promise).resolve().then(callback);
}
function $f67b6822c0d0d0e2$export$475e1d086d647d28() {
    return typeof $f67b6822c0d0d0e2$export$20dfe5c0db9ba10.getEntriesByType === "function";
}
function $f67b6822c0d0d0e2$export$c043ff66aa95c00c(type) {
    return typeof PerformanceObserver !== "undefined" && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.indexOf(type) >= 0;
}
function $f67b6822c0d0d0e2$export$7aca418b79512736() {
    var flagName = "_elastic_inspect_beacon_";
    if (sessionStorage.getItem(flagName) != null) return true;
    if (!window.URL || !window.URLSearchParams) return false;
    try {
        var parsedUrl = new URL(window.location.href);
        var isFlagSet = parsedUrl.searchParams.has(flagName);
        if (isFlagSet) sessionStorage.setItem(flagName, true);
        return isFlagSet;
    } catch (e) {}
    return false;
}
function $f67b6822c0d0d0e2$export$ffcb82e8b0e258ec(timing) {
    return timing.redirectStart > 0;
}

});
parcelRegister("lnGft", function(module, exports) {

$parcel$export(module.exports, "Promise", () => $f90c849eb67520e7$export$775f0de60169233c);

var $3hIuW = parcelRequire("3hIuW");

var $la17Z = parcelRequire("la17Z");
var $f90c849eb67520e7$var$local = {};
if (0, $la17Z.isBrowser) $f90c849eb67520e7$var$local = window;
else if (typeof self !== "undefined") $f90c849eb67520e7$var$local = self;
var $f90c849eb67520e7$export$775f0de60169233c = "Promise" in $f90c849eb67520e7$var$local ? $f90c849eb67520e7$var$local.Promise : (0, $3hIuW.default);

});
parcelRegister("3hIuW", function(module, exports) {

$parcel$export(module.exports, "default", () => $264579fe0db99e6b$export$2e2bcd8739ae039);

var $a0gk8 = parcelRequire("a0gk8");

var $bjJHg = parcelRequire("bjJHg");
// Store setTimeout reference so promise-polyfill will be unaffected by
// other code modifying setTimeout (like sinon.useFakeTimers())
var $264579fe0db99e6b$var$setTimeoutFunc = setTimeout;
function $264579fe0db99e6b$var$isArray(x) {
    return Boolean(x && typeof x.length !== "undefined");
}
function $264579fe0db99e6b$var$noop() {}
// Polyfill for Function.prototype.bind
function $264579fe0db99e6b$var$bind(fn, thisArg) {
    return function() {
        fn.apply(thisArg, arguments);
    };
}
/**
 * @constructor
 * @param {Function} fn
 */ function $264579fe0db99e6b$var$Promise(fn) {
    if (!(this instanceof $264579fe0db99e6b$var$Promise)) throw new TypeError("Promises must be constructed via new");
    if (typeof fn !== "function") throw new TypeError("not a function");
    /** @type {!number} */ this._state = 0;
    /** @type {!boolean} */ this._handled = false;
    /** @type {Promise|undefined} */ this._value = undefined;
    /** @type {!Array<!Function>} */ this._deferreds = [];
    $264579fe0db99e6b$var$doResolve(fn, this);
}
function $264579fe0db99e6b$var$handle(self, deferred) {
    while(self._state === 3)self = self._value;
    if (self._state === 0) {
        self._deferreds.push(deferred);
        return;
    }
    self._handled = true;
    $264579fe0db99e6b$var$Promise._immediateFn(function() {
        var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
        if (cb === null) {
            (self._state === 1 ? $264579fe0db99e6b$var$resolve : $264579fe0db99e6b$var$reject)(deferred.promise, self._value);
            return;
        }
        var ret;
        try {
            ret = cb(self._value);
        } catch (e) {
            $264579fe0db99e6b$var$reject(deferred.promise, e);
            return;
        }
        $264579fe0db99e6b$var$resolve(deferred.promise, ret);
    });
}
function $264579fe0db99e6b$var$resolve(self, newValue) {
    try {
        // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
        if (newValue === self) throw new TypeError("A promise cannot be resolved with itself.");
        if (newValue && (typeof newValue === "object" || typeof newValue === "function")) {
            var then = newValue.then;
            if (newValue instanceof $264579fe0db99e6b$var$Promise) {
                self._state = 3;
                self._value = newValue;
                $264579fe0db99e6b$var$finale(self);
                return;
            } else if (typeof then === "function") {
                $264579fe0db99e6b$var$doResolve($264579fe0db99e6b$var$bind(then, newValue), self);
                return;
            }
        }
        self._state = 1;
        self._value = newValue;
        $264579fe0db99e6b$var$finale(self);
    } catch (e) {
        $264579fe0db99e6b$var$reject(self, e);
    }
}
function $264579fe0db99e6b$var$reject(self, newValue) {
    self._state = 2;
    self._value = newValue;
    $264579fe0db99e6b$var$finale(self);
}
function $264579fe0db99e6b$var$finale(self) {
    if (self._state === 2 && self._deferreds.length === 0) $264579fe0db99e6b$var$Promise._immediateFn(function() {
        if (!self._handled) $264579fe0db99e6b$var$Promise._unhandledRejectionFn(self._value);
    });
    for(var i = 0, len = self._deferreds.length; i < len; i++)$264579fe0db99e6b$var$handle(self, self._deferreds[i]);
    self._deferreds = null;
}
/**
 * @constructor
 */ function $264579fe0db99e6b$var$Handler(onFulfilled, onRejected, promise) {
    this.onFulfilled = typeof onFulfilled === "function" ? onFulfilled : null;
    this.onRejected = typeof onRejected === "function" ? onRejected : null;
    this.promise = promise;
}
/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */ function $264579fe0db99e6b$var$doResolve(fn, self) {
    var done = false;
    try {
        fn(function(value) {
            if (done) return;
            done = true;
            $264579fe0db99e6b$var$resolve(self, value);
        }, function(reason) {
            if (done) return;
            done = true;
            $264579fe0db99e6b$var$reject(self, reason);
        });
    } catch (ex) {
        if (done) return;
        done = true;
        $264579fe0db99e6b$var$reject(self, ex);
    }
}
$264579fe0db99e6b$var$Promise.prototype["catch"] = function(onRejected) {
    return this.then(null, onRejected);
};
$264579fe0db99e6b$var$Promise.prototype.then = function(onFulfilled, onRejected) {
    // @ts-ignore
    var prom = new this.constructor($264579fe0db99e6b$var$noop);
    $264579fe0db99e6b$var$handle(this, new $264579fe0db99e6b$var$Handler(onFulfilled, onRejected, prom));
    return prom;
};
$264579fe0db99e6b$var$Promise.prototype["finally"] = (0, $a0gk8.default);
$264579fe0db99e6b$var$Promise.all = function(arr) {
    return new $264579fe0db99e6b$var$Promise(function(resolve, reject) {
        if (!$264579fe0db99e6b$var$isArray(arr)) return reject(new TypeError("Promise.all accepts an array"));
        var args = Array.prototype.slice.call(arr);
        if (args.length === 0) return resolve([]);
        var remaining = args.length;
        function res(i, val) {
            try {
                if (val && (typeof val === "object" || typeof val === "function")) {
                    var then = val.then;
                    if (typeof then === "function") {
                        then.call(val, function(val) {
                            res(i, val);
                        }, reject);
                        return;
                    }
                }
                args[i] = val;
                if (--remaining === 0) resolve(args);
            } catch (ex) {
                reject(ex);
            }
        }
        for(var i = 0; i < args.length; i++)res(i, args[i]);
    });
};
$264579fe0db99e6b$var$Promise.allSettled = (0, $bjJHg.default);
$264579fe0db99e6b$var$Promise.resolve = function(value) {
    if (value && typeof value === "object" && value.constructor === $264579fe0db99e6b$var$Promise) return value;
    return new $264579fe0db99e6b$var$Promise(function(resolve) {
        resolve(value);
    });
};
$264579fe0db99e6b$var$Promise.reject = function(value) {
    return new $264579fe0db99e6b$var$Promise(function(resolve, reject) {
        reject(value);
    });
};
$264579fe0db99e6b$var$Promise.race = function(arr) {
    return new $264579fe0db99e6b$var$Promise(function(resolve, reject) {
        if (!$264579fe0db99e6b$var$isArray(arr)) return reject(new TypeError("Promise.race accepts an array"));
        for(var i = 0, len = arr.length; i < len; i++)$264579fe0db99e6b$var$Promise.resolve(arr[i]).then(resolve, reject);
    });
};
// Use polyfill for setImmediate for performance gains
$264579fe0db99e6b$var$Promise._immediateFn = // @ts-ignore
typeof setImmediate === "function" && function(fn) {
    // @ts-ignore
    setImmediate(fn);
} || function(fn) {
    $264579fe0db99e6b$var$setTimeoutFunc(fn, 0);
};
$264579fe0db99e6b$var$Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
    if (typeof console !== "undefined" && console) console.warn("Possible Unhandled Promise Rejection:", err); // eslint-disable-line no-console
};
var $264579fe0db99e6b$export$2e2bcd8739ae039 = $264579fe0db99e6b$var$Promise;

});
parcelRegister("a0gk8", function(module, exports) {

$parcel$export(module.exports, "default", () => $748691078bf28629$export$2e2bcd8739ae039);
/**
 * @this {Promise}
 */ function $748691078bf28629$var$finallyConstructor(callback) {
    var constructor = this.constructor;
    return this.then(function(value) {
        // @ts-ignore
        return constructor.resolve(callback()).then(function() {
            return value;
        });
    }, function(reason) {
        // @ts-ignore
        return constructor.resolve(callback()).then(function() {
            // @ts-ignore
            return constructor.reject(reason);
        });
    });
}
var $748691078bf28629$export$2e2bcd8739ae039 = $748691078bf28629$var$finallyConstructor;

});

parcelRegister("bjJHg", function(module, exports) {

$parcel$export(module.exports, "default", () => $83d4ea83f9054ded$export$2e2bcd8739ae039);
function $83d4ea83f9054ded$var$allSettled(arr) {
    var P = this;
    return new P(function(resolve, reject) {
        if (!(arr && typeof arr.length !== "undefined")) return reject(new TypeError(typeof arr + " " + arr + " is not iterable(cannot read property Symbol(Symbol.iterator))"));
        var args = Array.prototype.slice.call(arr);
        if (args.length === 0) return resolve([]);
        var remaining = args.length;
        function res(i, val) {
            if (val && (typeof val === "object" || typeof val === "function")) {
                var then = val.then;
                if (typeof then === "function") {
                    then.call(val, function(val) {
                        res(i, val);
                    }, function(e) {
                        args[i] = {
                            status: "rejected",
                            reason: e
                        };
                        if (--remaining === 0) resolve(args);
                    });
                    return;
                }
            }
            args[i] = {
                status: "fulfilled",
                value: val
            };
            if (--remaining === 0) resolve(args);
        }
        for(var i = 0; i < args.length; i++)res(i, args[i]);
    });
}
var $83d4ea83f9054ded$export$2e2bcd8739ae039 = $83d4ea83f9054ded$var$allSettled;

});




parcelRegister("3tnfy", function(module, exports) {

$parcel$export(module.exports, "patchEventHandler", () => $28761d794c215230$export$602cc6306ec009d8);
$parcel$export(module.exports, "patchAll", () => $28761d794c215230$export$94da54533f7f9289);

var $hRg5i = parcelRequire("hRg5i");

var $2MGu2 = parcelRequire("2MGu2");

var $3AQHB = parcelRequire("3AQHB");

var $coqQq = parcelRequire("coqQq");

var $a3rI2 = parcelRequire("a3rI2");
var $28761d794c215230$export$602cc6306ec009d8 = new (0, $coqQq.default)();
var $28761d794c215230$var$alreadyPatched = false;
function $28761d794c215230$export$94da54533f7f9289() {
    if (!$28761d794c215230$var$alreadyPatched) {
        $28761d794c215230$var$alreadyPatched = true;
        (0, $hRg5i.patchXMLHttpRequest)(function(event, task) {
            $28761d794c215230$export$602cc6306ec009d8.send((0, $a3rI2.XMLHTTPREQUEST), [
                event,
                task
            ]);
        });
        (0, $2MGu2.patchFetch)(function(event, task) {
            $28761d794c215230$export$602cc6306ec009d8.send((0, $a3rI2.FETCH), [
                event,
                task
            ]);
        });
        (0, $3AQHB.patchHistory)(function(event, task) {
            $28761d794c215230$export$602cc6306ec009d8.send((0, $a3rI2.HISTORY), [
                event,
                task
            ]);
        });
    }
    return $28761d794c215230$export$602cc6306ec009d8;
}

});
parcelRegister("hRg5i", function(module, exports) {

$parcel$export(module.exports, "patchXMLHttpRequest", () => $d003dcf34fbfc42f$export$41ed32b4ed20742);

var $3q6JU = parcelRequire("3q6JU");

var $a3rI2 = parcelRequire("a3rI2");
function $d003dcf34fbfc42f$export$41ed32b4ed20742(callback) {
    var XMLHttpRequestPrototype = XMLHttpRequest.prototype;
    if (!XMLHttpRequestPrototype || !XMLHttpRequestPrototype[0, $a3rI2.ADD_EVENT_LISTENER_STR]) return;
    var READY_STATE_CHANGE = "readystatechange";
    var LOAD = "load";
    var ERROR = "error";
    var TIMEOUT = "timeout";
    var ABORT = "abort";
    function invokeTask(task, status) {
        if (task.state !== (0, $a3rI2.INVOKE)) {
            task.state = (0, $a3rI2.INVOKE);
            task.data.status = status;
            callback((0, $a3rI2.INVOKE), task);
        }
    }
    function scheduleTask(task) {
        if (task.state === (0, $a3rI2.SCHEDULE)) return;
        task.state = (0, $a3rI2.SCHEDULE);
        callback((0, $a3rI2.SCHEDULE), task);
        var target = task.data.target;
        function addListener(name) {
            target[0, $a3rI2.ADD_EVENT_LISTENER_STR](name, function(_ref) {
                var type = _ref.type;
                if (type === READY_STATE_CHANGE) {
                    if (target.readyState === 4 && target.status !== 0) invokeTask(task, "success");
                } else {
                    var status = type === LOAD ? "success" : type;
                    invokeTask(task, status);
                }
            });
        }
        addListener(READY_STATE_CHANGE);
        addListener(LOAD);
        addListener(TIMEOUT);
        addListener(ERROR);
        addListener(ABORT);
    }
    var openNative = (0, $3q6JU.patchMethod)(XMLHttpRequestPrototype, "open", function() {
        return function(self, args) {
            if (!self[0, $3q6JU.XHR_IGNORE]) {
                self[0, $3q6JU.XHR_METHOD] = args[0];
                self[0, $3q6JU.XHR_URL] = args[1];
                self[0, $3q6JU.XHR_SYNC] = args[2] === false;
            }
            return openNative.apply(self, args);
        };
    });
    var sendNative = (0, $3q6JU.patchMethod)(XMLHttpRequestPrototype, "send", function() {
        return function(self, args) {
            if (self[0, $3q6JU.XHR_IGNORE]) return sendNative.apply(self, args);
            var task = {
                source: (0, $a3rI2.XMLHTTPREQUEST),
                state: "",
                type: "macroTask",
                data: {
                    target: self,
                    method: self[0, $3q6JU.XHR_METHOD],
                    sync: self[0, $3q6JU.XHR_SYNC],
                    url: self[0, $3q6JU.XHR_URL],
                    status: ""
                }
            };
            try {
                scheduleTask(task);
                return sendNative.apply(self, args);
            } catch (e) {
                invokeTask(task, ERROR);
                throw e;
            }
        };
    });
}

});
parcelRegister("3q6JU", function(module, exports) {

$parcel$export(module.exports, "globalState", () => $27d9071dee091896$export$8e769ad4338a911e);
$parcel$export(module.exports, "patchMethod", () => $27d9071dee091896$export$27a263d91197d790);
$parcel$export(module.exports, "XHR_IGNORE", () => $27d9071dee091896$export$1d2facecfc1955cc);
$parcel$export(module.exports, "XHR_SYNC", () => $27d9071dee091896$export$bda265647bf75488);
$parcel$export(module.exports, "XHR_URL", () => $27d9071dee091896$export$9a7ca3b2c2e97bd9);
$parcel$export(module.exports, "XHR_METHOD", () => $27d9071dee091896$export$90db053605542d02);
var $27d9071dee091896$export$8e769ad4338a911e = {
    fetchInProgress: false
};
function $27d9071dee091896$export$652b0f25a523f48f(name) {
    return "__apm_symbol__" + name;
}
function $27d9071dee091896$var$isPropertyWritable(propertyDesc) {
    if (!propertyDesc) return true;
    if (propertyDesc.writable === false) return false;
    return !(typeof propertyDesc.get === "function" && typeof propertyDesc.set === "undefined");
}
function $27d9071dee091896$var$attachOriginToPatched(patched, original) {
    patched[$27d9071dee091896$export$652b0f25a523f48f("OriginalDelegate")] = original;
}
function $27d9071dee091896$export$27a263d91197d790(target, name, patchFn) {
    var proto = target;
    while(proto && !proto.hasOwnProperty(name))proto = Object.getPrototypeOf(proto);
    if (!proto && target[name]) proto = target;
    var delegateName = $27d9071dee091896$export$652b0f25a523f48f(name);
    var delegate;
    if (proto && !(delegate = proto[delegateName])) {
        delegate = proto[delegateName] = proto[name];
        var desc = proto && Object.getOwnPropertyDescriptor(proto, name);
        if ($27d9071dee091896$var$isPropertyWritable(desc)) {
            var patchDelegate = patchFn(delegate, delegateName, name);
            proto[name] = function() {
                return patchDelegate(this, arguments);
            };
            $27d9071dee091896$var$attachOriginToPatched(proto[name], delegate);
        }
    }
    return delegate;
}
var $27d9071dee091896$export$1d2facecfc1955cc = $27d9071dee091896$export$652b0f25a523f48f("xhrIgnore");
var $27d9071dee091896$export$bda265647bf75488 = $27d9071dee091896$export$652b0f25a523f48f("xhrSync");
var $27d9071dee091896$export$9a7ca3b2c2e97bd9 = $27d9071dee091896$export$652b0f25a523f48f("xhrURL");
var $27d9071dee091896$export$90db053605542d02 = $27d9071dee091896$export$652b0f25a523f48f("xhrMethod");

});

parcelRegister("a3rI2", function(module, exports) {

$parcel$export(module.exports, "SCHEDULE", () => $751fadacf26b4b05$export$2cb68534ade458e0);
$parcel$export(module.exports, "INVOKE", () => $751fadacf26b4b05$export$156c69d71663cf9e);
$parcel$export(module.exports, "ADD_EVENT_LISTENER_STR", () => $751fadacf26b4b05$export$19be37673fbac3e8);
$parcel$export(module.exports, "RESOURCE_INITIATOR_TYPES", () => $751fadacf26b4b05$export$fcac77ffb8211a1f);
$parcel$export(module.exports, "REUSABILITY_THRESHOLD", () => $751fadacf26b4b05$export$1307ffda4f2726e8);
$parcel$export(module.exports, "MAX_SPAN_DURATION", () => $751fadacf26b4b05$export$92d7cb2c71942fbd);
$parcel$export(module.exports, "PAGE_LOAD_DELAY", () => $751fadacf26b4b05$export$b78d68e75d8e9dad);
$parcel$export(module.exports, "PAGE_LOAD", () => $751fadacf26b4b05$export$1502f4f8c48fa539);
$parcel$export(module.exports, "TYPE_CUSTOM", () => $751fadacf26b4b05$export$dd0e4c11f1ad6f76);
$parcel$export(module.exports, "USER_INTERACTION", () => $751fadacf26b4b05$export$ca341a703d5e2151);
$parcel$export(module.exports, "HTTP_REQUEST_TYPE", () => $751fadacf26b4b05$export$c774c31b4c31da8);
$parcel$export(module.exports, "TEMPORARY_TYPE", () => $751fadacf26b4b05$export$c757be00d1bf3ef5);
$parcel$export(module.exports, "NAME_UNKNOWN", () => $751fadacf26b4b05$export$f0eae82cd3ba085f);
$parcel$export(module.exports, "TRANSACTION_TYPE_ORDER", () => $751fadacf26b4b05$export$38ee95dde3859fb7);
$parcel$export(module.exports, "OUTCOME_SUCCESS", () => $751fadacf26b4b05$export$ffae20858202e0de);
$parcel$export(module.exports, "OUTCOME_FAILURE", () => $751fadacf26b4b05$export$a1656598af524751);
$parcel$export(module.exports, "OUTCOME_UNKNOWN", () => $751fadacf26b4b05$export$f46af96a885f2c9b);
$parcel$export(module.exports, "USER_TIMING_THRESHOLD", () => $751fadacf26b4b05$export$833fd3a4a36bef5e);
$parcel$export(module.exports, "TRANSACTION_START", () => $751fadacf26b4b05$export$53ee6f7d651aa888);
$parcel$export(module.exports, "TRANSACTION_END", () => $751fadacf26b4b05$export$3583e51eacab0340);
$parcel$export(module.exports, "CONFIG_CHANGE", () => $751fadacf26b4b05$export$36257f40a0d30563);
$parcel$export(module.exports, "QUEUE_FLUSH", () => $751fadacf26b4b05$export$19245af82a094556);
$parcel$export(module.exports, "QUEUE_ADD_TRANSACTION", () => $751fadacf26b4b05$export$c11a56b9bfcb1d0f);
$parcel$export(module.exports, "XMLHTTPREQUEST", () => $751fadacf26b4b05$export$942b1c2707517311);
$parcel$export(module.exports, "FETCH", () => $751fadacf26b4b05$export$4a07cffb9c3bc884);
$parcel$export(module.exports, "HISTORY", () => $751fadacf26b4b05$export$149eb684a26496a2);
$parcel$export(module.exports, "EVENT_TARGET", () => $751fadacf26b4b05$export$2c4d7da089dce968);
$parcel$export(module.exports, "CLICK", () => $751fadacf26b4b05$export$cb5542418ddbb7ed);
$parcel$export(module.exports, "ERROR", () => $751fadacf26b4b05$export$103bedf43ba882db);
$parcel$export(module.exports, "BEFORE_EVENT", () => $751fadacf26b4b05$export$d75a03bca9277b83);
$parcel$export(module.exports, "AFTER_EVENT", () => $751fadacf26b4b05$export$eeaba87877acb280);
$parcel$export(module.exports, "LOCAL_CONFIG_KEY", () => $751fadacf26b4b05$export$f1f46202fdd81911);
$parcel$export(module.exports, "LONG_TASK", () => $751fadacf26b4b05$export$fd2c36a5e8e50e04);
$parcel$export(module.exports, "PAINT", () => $751fadacf26b4b05$export$ef5de76f1655b5ca);
$parcel$export(module.exports, "MEASURE", () => $751fadacf26b4b05$export$20471946a1148a1b);
$parcel$export(module.exports, "NAVIGATION", () => $751fadacf26b4b05$export$f52dcf7131a7f04);
$parcel$export(module.exports, "RESOURCE", () => $751fadacf26b4b05$export$84ba8fa7099b85b);
$parcel$export(module.exports, "FIRST_CONTENTFUL_PAINT", () => $751fadacf26b4b05$export$c2572a516b804ad3);
$parcel$export(module.exports, "LARGEST_CONTENTFUL_PAINT", () => $751fadacf26b4b05$export$6de1676190bd73c4);
$parcel$export(module.exports, "FIRST_INPUT", () => $751fadacf26b4b05$export$98085453dd812392);
$parcel$export(module.exports, "LAYOUT_SHIFT", () => $751fadacf26b4b05$export$fc5ce9a4261f08e8);
$parcel$export(module.exports, "ERRORS", () => $751fadacf26b4b05$export$4fd720569787ab6f);
$parcel$export(module.exports, "TRANSACTIONS", () => $751fadacf26b4b05$export$33e749855cc8f893);
$parcel$export(module.exports, "CONFIG_SERVICE", () => $751fadacf26b4b05$export$11170dadd5705a7b);
$parcel$export(module.exports, "LOGGING_SERVICE", () => $751fadacf26b4b05$export$7d973190a36b8246);
$parcel$export(module.exports, "TRANSACTION_SERVICE", () => $751fadacf26b4b05$export$ab6389d1a16bebfe);
$parcel$export(module.exports, "APM_SERVER", () => $751fadacf26b4b05$export$8f8a420bfb2d7e37);
$parcel$export(module.exports, "PERFORMANCE_MONITORING", () => $751fadacf26b4b05$export$6a0f49a7699bafca);
$parcel$export(module.exports, "ERROR_LOGGING", () => $751fadacf26b4b05$export$3bb4e88cf5c5fd65);
$parcel$export(module.exports, "TRUNCATED_TYPE", () => $751fadacf26b4b05$export$58a4ef0ce68953f5);
$parcel$export(module.exports, "KEYWORD_LIMIT", () => $751fadacf26b4b05$export$1ef49423f809800e);
$parcel$export(module.exports, "SESSION_TIMEOUT", () => $751fadacf26b4b05$export$c74ee24a01db1ae5);
$parcel$export(module.exports, "HTTP_REQUEST_TIMEOUT", () => $751fadacf26b4b05$export$304f7f334b3888b0);
var $751fadacf26b4b05$export$2cb68534ade458e0 = "schedule";
var $751fadacf26b4b05$export$156c69d71663cf9e = "invoke";
var $751fadacf26b4b05$export$19be37673fbac3e8 = "addEventListener";
var $751fadacf26b4b05$export$2d40f446af293d52 = "removeEventListener";
var $751fadacf26b4b05$export$fcac77ffb8211a1f = [
    "link",
    "css",
    "script",
    "img",
    "xmlhttprequest",
    "fetch",
    "beacon",
    "iframe"
];
var $751fadacf26b4b05$export$1307ffda4f2726e8 = 5000;
var $751fadacf26b4b05$export$92d7cb2c71942fbd = 300000;
var $751fadacf26b4b05$export$b78d68e75d8e9dad = 1000;
var $751fadacf26b4b05$export$1502f4f8c48fa539 = "page-load";
var $751fadacf26b4b05$export$e9e58a8c189b78b1 = "route-change";
var $751fadacf26b4b05$export$dd0e4c11f1ad6f76 = "custom";
var $751fadacf26b4b05$export$ca341a703d5e2151 = "user-interaction";
var $751fadacf26b4b05$export$c774c31b4c31da8 = "http-request";
var $751fadacf26b4b05$export$c757be00d1bf3ef5 = "temporary";
var $751fadacf26b4b05$export$f0eae82cd3ba085f = "Unknown";
var $751fadacf26b4b05$export$38ee95dde3859fb7 = [
    $751fadacf26b4b05$export$1502f4f8c48fa539,
    $751fadacf26b4b05$export$e9e58a8c189b78b1,
    $751fadacf26b4b05$export$ca341a703d5e2151,
    $751fadacf26b4b05$export$c774c31b4c31da8,
    $751fadacf26b4b05$export$dd0e4c11f1ad6f76,
    $751fadacf26b4b05$export$c757be00d1bf3ef5
];
var $751fadacf26b4b05$export$ffae20858202e0de = "success";
var $751fadacf26b4b05$export$a1656598af524751 = "failure";
var $751fadacf26b4b05$export$f46af96a885f2c9b = "unknown";
var $751fadacf26b4b05$export$833fd3a4a36bef5e = 60;
var $751fadacf26b4b05$export$53ee6f7d651aa888 = "transaction:start";
var $751fadacf26b4b05$export$3583e51eacab0340 = "transaction:end";
var $751fadacf26b4b05$export$36257f40a0d30563 = "config:change";
var $751fadacf26b4b05$export$19245af82a094556 = "queue:flush";
var $751fadacf26b4b05$export$c11a56b9bfcb1d0f = "queue:add_transaction";
var $751fadacf26b4b05$export$942b1c2707517311 = "xmlhttprequest";
var $751fadacf26b4b05$export$4a07cffb9c3bc884 = "fetch";
var $751fadacf26b4b05$export$149eb684a26496a2 = "history";
var $751fadacf26b4b05$export$2c4d7da089dce968 = "eventtarget";
var $751fadacf26b4b05$export$cb5542418ddbb7ed = "click";
var $751fadacf26b4b05$export$103bedf43ba882db = "error";
var $751fadacf26b4b05$export$d75a03bca9277b83 = ":before";
var $751fadacf26b4b05$export$eeaba87877acb280 = ":after";
var $751fadacf26b4b05$export$f1f46202fdd81911 = "elastic_apm_config";
var $751fadacf26b4b05$export$fd2c36a5e8e50e04 = "longtask";
var $751fadacf26b4b05$export$ef5de76f1655b5ca = "paint";
var $751fadacf26b4b05$export$20471946a1148a1b = "measure";
var $751fadacf26b4b05$export$f52dcf7131a7f04 = "navigation";
var $751fadacf26b4b05$export$84ba8fa7099b85b = "resource";
var $751fadacf26b4b05$export$c2572a516b804ad3 = "first-contentful-paint";
var $751fadacf26b4b05$export$6de1676190bd73c4 = "largest-contentful-paint";
var $751fadacf26b4b05$export$98085453dd812392 = "first-input";
var $751fadacf26b4b05$export$fc5ce9a4261f08e8 = "layout-shift";
var $751fadacf26b4b05$export$4fd720569787ab6f = "errors";
var $751fadacf26b4b05$export$33e749855cc8f893 = "transactions";
var $751fadacf26b4b05$export$11170dadd5705a7b = "ConfigService";
var $751fadacf26b4b05$export$7d973190a36b8246 = "LoggingService";
var $751fadacf26b4b05$export$ab6389d1a16bebfe = "TransactionService";
var $751fadacf26b4b05$export$8f8a420bfb2d7e37 = "ApmServer";
var $751fadacf26b4b05$export$6a0f49a7699bafca = "PerformanceMonitoring";
var $751fadacf26b4b05$export$3bb4e88cf5c5fd65 = "ErrorLogging";
var $751fadacf26b4b05$export$58a4ef0ce68953f5 = ".truncated";
var $751fadacf26b4b05$export$1ef49423f809800e = 1024;
var $751fadacf26b4b05$export$c74ee24a01db1ae5 = 1800000;
var $751fadacf26b4b05$export$304f7f334b3888b0 = 10000;

});


parcelRegister("2MGu2", function(module, exports) {

$parcel$export(module.exports, "patchFetch", () => $207104c874c4ccf9$export$28f71c1f202028d4);

var $lnGft = parcelRequire("lnGft");

var $3q6JU = parcelRequire("3q6JU");

var $a3rI2 = parcelRequire("a3rI2");

var $la17Z = parcelRequire("la17Z");

var $lORcz = parcelRequire("lORcz");
function $207104c874c4ccf9$export$28f71c1f202028d4(callback) {
    if (!(0, $lORcz.isFetchSupported)()) return;
    function scheduleTask(task) {
        task.state = (0, $a3rI2.SCHEDULE);
        callback((0, $a3rI2.SCHEDULE), task);
    }
    function invokeTask(task) {
        task.state = (0, $a3rI2.INVOKE);
        callback((0, $a3rI2.INVOKE), task);
    }
    function handleResponseError(task, error) {
        task.data.aborted = $207104c874c4ccf9$var$isAbortError(error);
        task.data.error = error;
        invokeTask(task);
    }
    function readStream(stream, task) {
        var reader = stream.getReader();
        var read = function read() {
            reader.read().then(function(_ref) {
                var done = _ref.done;
                if (done) invokeTask(task);
                else read();
            }, function(error) {
                handleResponseError(task, error);
            });
        };
        read();
    }
    var nativeFetch = window.fetch;
    window.fetch = function(input, init) {
        var fetchSelf = this;
        var args = arguments;
        var request, url;
        var isURL = input instanceof URL;
        if (typeof input === "string" || isURL) {
            request = new Request(input, init);
            if (isURL) url = request.url;
            else url = input;
        } else if (input) {
            request = input;
            url = request.url;
        } else return nativeFetch.apply(fetchSelf, args);
        var task = {
            source: (0, $a3rI2.FETCH),
            state: "",
            type: "macroTask",
            data: {
                target: request,
                method: request.method,
                url: url,
                aborted: false
            }
        };
        return new (0, $lnGft.Promise)(function(resolve, reject) {
            (0, $3q6JU.globalState).fetchInProgress = true;
            scheduleTask(task);
            var promise;
            try {
                promise = nativeFetch.apply(fetchSelf, [
                    request
                ]);
            } catch (error) {
                reject(error);
                task.data.error = error;
                invokeTask(task);
                (0, $3q6JU.globalState).fetchInProgress = false;
                return;
            }
            promise.then(function(response) {
                var clonedResponse = response.clone ? response.clone() : {};
                resolve(response);
                (0, $la17Z.scheduleMicroTask)(function() {
                    task.data.response = response;
                    var body = clonedResponse.body;
                    if (body) readStream(body, task);
                    else invokeTask(task);
                });
            }, function(error) {
                reject(error);
                (0, $la17Z.scheduleMicroTask)(function() {
                    handleResponseError(task, error);
                });
            });
            (0, $3q6JU.globalState).fetchInProgress = false;
        });
    };
}
function $207104c874c4ccf9$var$isAbortError(error) {
    return error && error.name === "AbortError";
}

});
parcelRegister("lORcz", function(module, exports) {

$parcel$export(module.exports, "shouldUseFetchWithKeepAlive", () => $fe278944c691f0e3$export$7671e9773d28088a);
$parcel$export(module.exports, "isFetchSupported", () => $fe278944c691f0e3$export$f8c1c61350d9749);
$parcel$export(module.exports, "sendFetchRequest", () => $fe278944c691f0e3$export$de4ef9c2599856d6);

var $a3rI2 = parcelRequire("a3rI2");

var $1Dyof = parcelRequire("1Dyof");
function $fe278944c691f0e3$var$_extends() {
    $fe278944c691f0e3$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $fe278944c691f0e3$var$_extends.apply(this, arguments);
}
var $fe278944c691f0e3$export$1080ec02d04a92c0 = 60000;
function $fe278944c691f0e3$export$7671e9773d28088a(method, payload) {
    if (!$fe278944c691f0e3$export$f8c1c61350d9749()) return false;
    var isKeepAliveSupported = "keepalive" in new Request("");
    if (!isKeepAliveSupported) return false;
    var size = $fe278944c691f0e3$var$calculateSize(payload);
    return method === "POST" && size < $fe278944c691f0e3$export$1080ec02d04a92c0;
}
function $fe278944c691f0e3$export$de4ef9c2599856d6(method, url, _ref) {
    var _ref$keepalive = _ref.keepalive, keepalive = _ref$keepalive === void 0 ? false : _ref$keepalive, _ref$timeout = _ref.timeout, timeout = _ref$timeout === void 0 ? (0, $a3rI2.HTTP_REQUEST_TIMEOUT) : _ref$timeout, payload = _ref.payload, headers = _ref.headers, sendCredentials = _ref.sendCredentials;
    var timeoutConfig = {};
    if (typeof AbortController === "function") {
        var controller = new AbortController();
        timeoutConfig.signal = controller.signal;
        setTimeout(function() {
            return controller.abort();
        }, timeout);
    }
    var fetchResponse;
    return window.fetch(url, $fe278944c691f0e3$var$_extends({
        body: payload,
        headers: headers,
        method: method,
        keepalive: keepalive,
        credentials: sendCredentials ? "include" : "omit"
    }, timeoutConfig)).then(function(response) {
        fetchResponse = response;
        return fetchResponse.text();
    }).then(function(responseText) {
        var bodyResponse = {
            url: url,
            status: fetchResponse.status,
            responseText: responseText
        };
        if (!(0, $1Dyof.isResponseSuccessful)(fetchResponse.status)) throw bodyResponse;
        return bodyResponse;
    });
}
function $fe278944c691f0e3$export$f8c1c61350d9749() {
    return typeof window.fetch === "function" && typeof window.Request === "function";
}
function $fe278944c691f0e3$var$calculateSize(payload) {
    if (!payload) return 0;
    if (payload instanceof Blob) return payload.size;
    return new Blob([
        payload
    ]).size;
}

});
parcelRegister("1Dyof", function(module, exports) {

$parcel$export(module.exports, "isResponseSuccessful", () => $13141c2480b4c437$export$1f29f0bf55f6a59e);
function $13141c2480b4c437$export$1f29f0bf55f6a59e(status) {
    if (status === 0 || status > 399 && status < 600) return false;
    return true;
}

});



parcelRegister("3AQHB", function(module, exports) {

$parcel$export(module.exports, "patchHistory", () => $29dd9d703905dccb$export$1c3c71cac9d1d555);

var $a3rI2 = parcelRequire("a3rI2");
function $29dd9d703905dccb$export$1c3c71cac9d1d555(callback) {
    if (!window.history) return;
    var nativePushState = history.pushState;
    if (typeof nativePushState === "function") history.pushState = function(state, title, url) {
        var task = {
            source: (0, $a3rI2.HISTORY),
            data: {
                state: state,
                title: title,
                url: url
            }
        };
        callback((0, $a3rI2.INVOKE), task);
        nativePushState.apply(this, arguments);
    };
}

});

parcelRegister("coqQq", function(module, exports) {

$parcel$export(module.exports, "default", () => $905c8cb9800894f3$export$2e2bcd8739ae039);

var $a3rI2 = parcelRequire("a3rI2");
var $905c8cb9800894f3$var$EventHandler = function() {
    function EventHandler() {
        this.observers = {};
    }
    var _proto = EventHandler.prototype;
    _proto.observe = function observe(name, fn) {
        var _this = this;
        if (typeof fn === "function") {
            if (!this.observers[name]) this.observers[name] = [];
            this.observers[name].push(fn);
            return function() {
                var index = _this.observers[name].indexOf(fn);
                if (index > -1) _this.observers[name].splice(index, 1);
            };
        }
    };
    _proto.sendOnly = function sendOnly(name, args) {
        var obs = this.observers[name];
        if (obs) obs.forEach(function(fn) {
            try {
                fn.apply(undefined, args);
            } catch (error) {
                console.log(error, error.stack);
            }
        });
    };
    _proto.send = function send(name, args) {
        this.sendOnly(name + (0, $a3rI2.BEFORE_EVENT), args);
        this.sendOnly(name, args);
        this.sendOnly(name + (0, $a3rI2.AFTER_EVENT), args);
    };
    return EventHandler;
}();
var $905c8cb9800894f3$export$2e2bcd8739ae039 = $905c8cb9800894f3$var$EventHandler;

});


parcelRegister("dgsvq", function(module, exports) {

$parcel$export(module.exports, "__DEV__", () => $9a82e1a145738a12$export$a866f231438cc228);
$parcel$export(module.exports, "state", () => $9a82e1a145738a12$export$ca000e230c0caa3e);
var $9a82e1a145738a12$export$a866f231438cc228 = false;
var $9a82e1a145738a12$export$ca000e230c0caa3e = {
    bootstrapTime: null,
    lastHiddenStart: Number.MIN_SAFE_INTEGER
};

});


parcelRegister("kbp1h", function(module, exports) {

$parcel$export(module.exports, "createServiceFactory", () => $eb183e216aa20326$export$791d8bdb130abda4);

var $jZGXn = parcelRequire("jZGXn");

var $4IPxA = parcelRequire("4IPxA");

var $7jITz = parcelRequire("7jITz");

var $la17Z = parcelRequire("la17Z");


var $it0bE = parcelRequire("it0bE");
var $dIA9N = parcelRequire("dIA9N");

var $a3rI2 = parcelRequire("a3rI2");

var $g8N01 = parcelRequire("g8N01");


var $b3k0J = parcelRequire("b3k0J");

function $eb183e216aa20326$export$791d8bdb130abda4() {
    (0, $4IPxA.registerServices)();
    (0, $jZGXn.registerServices)();
    var serviceFactory = new (0, $7jITz.ServiceFactory)();
    return serviceFactory;
}

});
parcelRegister("jZGXn", function(module, exports) {

$parcel$export(module.exports, "registerServices", () => $e8e5091d95950409$export$174fd5f90dd8a5db);

var $89rik = parcelRequire("89rik");

var $a3rI2 = parcelRequire("a3rI2");

var $7jITz = parcelRequire("7jITz");
function $e8e5091d95950409$export$174fd5f90dd8a5db() {
    (0, $7jITz.serviceCreators)[0, $a3rI2.ERROR_LOGGING] = function(serviceFactory) {
        var _serviceFactory$getSe = serviceFactory.getService([
            (0, $a3rI2.APM_SERVER),
            (0, $a3rI2.CONFIG_SERVICE),
            (0, $a3rI2.TRANSACTION_SERVICE)
        ]), apmServer = _serviceFactory$getSe[0], configService = _serviceFactory$getSe[1], transactionService = _serviceFactory$getSe[2];
        return new (0, $89rik.default)(apmServer, configService, transactionService);
    };
}

});
parcelRegister("89rik", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ef45621a51a849e$export$2e2bcd8739ae039);

var $iXbDc = parcelRequire("iXbDc");

var $la17Z = parcelRequire("la17Z");

var $671fv = parcelRequire("671fv");

var $YDh6C = parcelRequire("YDh6C");

var $3JlwZ = parcelRequire("3JlwZ");
var $5ef45621a51a849e$var$_excluded = [
    "tags"
];
function $5ef45621a51a849e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $5ef45621a51a849e$var$IGNORE_KEYS = [
    "stack",
    "message"
];
var $5ef45621a51a849e$var$PROMISE_REJECTION_PREFIX = "Unhandled promise rejection: ";
function $5ef45621a51a849e$var$getErrorProperties(error) {
    var propertyFound = false;
    var properties = {};
    Object.keys(error).forEach(function(key) {
        if ($5ef45621a51a849e$var$IGNORE_KEYS.indexOf(key) >= 0) return;
        var val = error[key];
        if (val == null || typeof val === "function") return;
        if (typeof val === "object") {
            if (typeof val.toISOString !== "function") return;
            val = val.toISOString();
        }
        properties[key] = val;
        propertyFound = true;
    });
    if (propertyFound) return properties;
}
var $5ef45621a51a849e$var$ErrorLogging = function() {
    function ErrorLogging(apmServer, configService, transactionService) {
        this._apmServer = apmServer;
        this._configService = configService;
        this._transactionService = transactionService;
    }
    var _proto = ErrorLogging.prototype;
    _proto.createErrorDataModel = function createErrorDataModel(errorEvent) {
        var frames = (0, $iXbDc.createStackTraces)((0, (/*@__PURE__*/$parcel$interopDefault($3JlwZ))), errorEvent);
        var filteredFrames = (0, $iXbDc.filterInvalidFrames)(frames);
        var culprit = "(inline script)";
        var lastFrame = filteredFrames[filteredFrames.length - 1];
        if (lastFrame && lastFrame.filename) culprit = lastFrame.filename;
        var message = errorEvent.message, error = errorEvent.error;
        var errorMessage = message;
        var errorType = "";
        var errorContext = {};
        if (error && typeof error === "object") {
            errorMessage = errorMessage || error.message;
            errorType = error.name;
            var customProperties = $5ef45621a51a849e$var$getErrorProperties(error);
            if (customProperties) errorContext.custom = customProperties;
        }
        if (!errorType) {
            if (errorMessage && errorMessage.indexOf(":") > -1) errorType = errorMessage.split(":")[0];
        }
        var currentTransaction = this._transactionService.getCurrentTransaction();
        var transactionContext = currentTransaction ? currentTransaction.context : {};
        var _this$_configService$ = this._configService.get("context"), tags = _this$_configService$.tags, configContext = $5ef45621a51a849e$var$_objectWithoutPropertiesLoose(_this$_configService$, $5ef45621a51a849e$var$_excluded);
        var pageContext = (0, $671fv.getPageContext)();
        var context = (0, $la17Z.merge)({}, pageContext, transactionContext, configContext, errorContext);
        var errorObject = {
            id: (0, $la17Z.generateRandomId)(),
            culprit: culprit,
            exception: {
                message: errorMessage,
                stacktrace: filteredFrames,
                type: errorType
            },
            context: context
        };
        if (currentTransaction) errorObject = (0, $la17Z.extend)(errorObject, {
            trace_id: currentTransaction.traceId,
            parent_id: currentTransaction.id,
            transaction_id: currentTransaction.id,
            transaction: {
                type: currentTransaction.type,
                sampled: currentTransaction.sampled
            }
        });
        return (0, $YDh6C.truncateModel)((0, $YDh6C.ERROR_MODEL), errorObject);
    };
    _proto.logErrorEvent = function logErrorEvent(errorEvent) {
        if (typeof errorEvent === "undefined") return;
        var errorObject = this.createErrorDataModel(errorEvent);
        if (typeof errorObject.exception.message === "undefined") return;
        this._apmServer.addError(errorObject);
    };
    _proto.registerListeners = function registerListeners() {
        var _this = this;
        window.addEventListener("error", function(errorEvent) {
            return _this.logErrorEvent(errorEvent);
        });
        window.addEventListener("unhandledrejection", function(promiseRejectionEvent) {
            return _this.logPromiseEvent(promiseRejectionEvent);
        });
    };
    _proto.logPromiseEvent = function logPromiseEvent(promiseRejectionEvent) {
        var reason = promiseRejectionEvent.reason;
        if (reason == null) reason = "<no reason specified>";
        var errorEvent;
        if (typeof reason.message === "string") {
            var name = reason.name ? reason.name + ": " : "";
            errorEvent = {
                error: reason,
                message: $5ef45621a51a849e$var$PROMISE_REJECTION_PREFIX + name + reason.message
            };
        } else errorEvent = this._parseRejectReason(reason);
        this.logErrorEvent(errorEvent);
    };
    _proto.logError = function logError(messageOrError) {
        var errorEvent = {};
        if (typeof messageOrError === "string") errorEvent.message = messageOrError;
        else errorEvent.error = messageOrError;
        return this.logErrorEvent(errorEvent);
    };
    _proto._parseRejectReason = function _parseRejectReason(reason) {
        var errorEvent = {
            message: $5ef45621a51a849e$var$PROMISE_REJECTION_PREFIX
        };
        if (Array.isArray(reason)) errorEvent.message += "<object>";
        else if (typeof reason === "object") try {
            errorEvent.message += JSON.stringify(reason);
            errorEvent.error = reason;
        } catch (error) {
            errorEvent.message += "<object>";
        }
        else if (typeof reason === "function") errorEvent.message += "<function>";
        else errorEvent.message += reason;
        return errorEvent;
    };
    return ErrorLogging;
}();
var $5ef45621a51a849e$export$2e2bcd8739ae039 = $5ef45621a51a849e$var$ErrorLogging;

});
parcelRegister("iXbDc", function(module, exports) {

$parcel$export(module.exports, "createStackTraces", () => $dcc6c26621cdd1c0$export$8c8855196b9f04f8);
$parcel$export(module.exports, "filterInvalidFrames", () => $dcc6c26621cdd1c0$export$388e43ae04f18461);
function $dcc6c26621cdd1c0$var$filePathToFileName(fileUrl) {
    var origin = window.location.origin || window.location.protocol + "//" + window.location.hostname + (window.location.port ? ":" + window.location.port : "");
    if (fileUrl.indexOf(origin) > -1) fileUrl = fileUrl.replace(origin + "/", "");
    return fileUrl;
}
function $dcc6c26621cdd1c0$var$cleanFilePath(filePath) {
    if (filePath === void 0) filePath = "";
    if (filePath === "<anonymous>") filePath = "";
    return filePath;
}
function $dcc6c26621cdd1c0$var$isFileInline(fileUrl) {
    if (fileUrl) return window.location.href.indexOf(fileUrl) === 0;
    return false;
}
function $dcc6c26621cdd1c0$var$normalizeStackFrames(stackFrames) {
    return stackFrames.map(function(frame) {
        if (frame.functionName) frame.functionName = $dcc6c26621cdd1c0$var$normalizeFunctionName(frame.functionName);
        return frame;
    });
}
function $dcc6c26621cdd1c0$var$normalizeFunctionName(fnName) {
    var parts = fnName.split("/");
    if (parts.length > 1) fnName = [
        "Object",
        parts[parts.length - 1]
    ].join(".");
    else fnName = parts[0];
    fnName = fnName.replace(/.<$/gi, ".<anonymous>");
    fnName = fnName.replace(/^Anonymous function$/, "<anonymous>");
    parts = fnName.split(".");
    if (parts.length > 1) fnName = parts[parts.length - 1];
    else fnName = parts[0];
    return fnName;
}
function $dcc6c26621cdd1c0$var$isValidStackTrace(stackTraces) {
    if (stackTraces.length === 0) return false;
    if (stackTraces.length === 1) {
        var stackTrace = stackTraces[0];
        return "lineNumber" in stackTrace;
    }
    return true;
}
function $dcc6c26621cdd1c0$export$8c8855196b9f04f8(stackParser, errorEvent) {
    var error = errorEvent.error, filename = errorEvent.filename, lineno = errorEvent.lineno, colno = errorEvent.colno;
    var stackTraces = [];
    if (error) try {
        stackTraces = stackParser.parse(error);
    } catch (e) {}
    if (!$dcc6c26621cdd1c0$var$isValidStackTrace(stackTraces)) stackTraces = [
        {
            fileName: filename,
            lineNumber: lineno,
            columnNumber: colno
        }
    ];
    var normalizedStackTraces = $dcc6c26621cdd1c0$var$normalizeStackFrames(stackTraces);
    return normalizedStackTraces.map(function(stack) {
        var fileName = stack.fileName, lineNumber = stack.lineNumber, columnNumber = stack.columnNumber, _stack$functionName = stack.functionName, functionName = _stack$functionName === void 0 ? "<anonymous>" : _stack$functionName;
        if (!fileName && !lineNumber) return {};
        if (!columnNumber && !lineNumber) return {};
        var filePath = $dcc6c26621cdd1c0$var$cleanFilePath(fileName);
        var cleanedFileName = $dcc6c26621cdd1c0$var$filePathToFileName(filePath);
        if ($dcc6c26621cdd1c0$var$isFileInline(filePath)) cleanedFileName = "(inline script)";
        return {
            abs_path: fileName,
            filename: cleanedFileName,
            function: functionName,
            lineno: lineNumber,
            colno: columnNumber
        };
    });
}
function $dcc6c26621cdd1c0$export$388e43ae04f18461(frames) {
    return frames.filter(function(_ref) {
        var filename = _ref.filename, lineno = _ref.lineno;
        return typeof filename !== "undefined" && typeof lineno !== "undefined";
    });
}

});

parcelRegister("671fv", function(module, exports) {

$parcel$export(module.exports, "getPageContext", () => $47345d8e64485ba6$export$1303843c2f44065a);
$parcel$export(module.exports, "addSpanContext", () => $47345d8e64485ba6$export$ed109afa225aed5b);
$parcel$export(module.exports, "addTransactionContext", () => $47345d8e64485ba6$export$d10ae57e760667a5);

var $7HOQt = parcelRequire("7HOQt");

var $a3rI2 = parcelRequire("a3rI2");

var $la17Z = parcelRequire("la17Z");
var $47345d8e64485ba6$var$_excluded = [
    "tags"
];
function $47345d8e64485ba6$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $47345d8e64485ba6$var$LEFT_SQUARE_BRACKET = 91;
var $47345d8e64485ba6$var$RIGHT_SQUARE_BRACKET = 93;
var $47345d8e64485ba6$var$EXTERNAL = "external";
var $47345d8e64485ba6$var$RESOURCE = "resource";
var $47345d8e64485ba6$var$HARD_NAVIGATION = "hard-navigation";
function $47345d8e64485ba6$var$getPortNumber(port, protocol) {
    if (port === "") port = protocol === "http:" ? "80" : protocol === "https:" ? "443" : "";
    return port;
}
function $47345d8e64485ba6$var$getResponseContext(perfTimingEntry) {
    var transferSize = perfTimingEntry.transferSize, encodedBodySize = perfTimingEntry.encodedBodySize, decodedBodySize = perfTimingEntry.decodedBodySize, serverTiming = perfTimingEntry.serverTiming;
    var respContext = {
        transfer_size: transferSize,
        encoded_body_size: encodedBodySize,
        decoded_body_size: decodedBodySize
    };
    var serverTimingStr = (0, $la17Z.getServerTimingInfo)(serverTiming);
    if (serverTimingStr) respContext.headers = {
        "server-timing": serverTimingStr
    };
    return respContext;
}
function $47345d8e64485ba6$var$getDestination(parsedUrl) {
    var port = parsedUrl.port, protocol = parsedUrl.protocol, hostname = parsedUrl.hostname;
    var portNumber = $47345d8e64485ba6$var$getPortNumber(port, protocol);
    var ipv6Hostname = hostname.charCodeAt(0) === $47345d8e64485ba6$var$LEFT_SQUARE_BRACKET && hostname.charCodeAt(hostname.length - 1) === $47345d8e64485ba6$var$RIGHT_SQUARE_BRACKET;
    var address = hostname;
    if (ipv6Hostname) address = hostname.slice(1, -1);
    return {
        service: {
            resource: hostname + ":" + portNumber,
            name: "",
            type: ""
        },
        address: address,
        port: Number(portNumber)
    };
}
function $47345d8e64485ba6$var$getResourceContext(data) {
    var entry = data.entry, url = data.url;
    var parsedUrl = new (0, $7HOQt.Url)(url);
    var destination = $47345d8e64485ba6$var$getDestination(parsedUrl);
    return {
        http: {
            url: url,
            response: $47345d8e64485ba6$var$getResponseContext(entry)
        },
        destination: destination
    };
}
function $47345d8e64485ba6$var$getExternalContext(data) {
    var url = data.url, method = data.method, target = data.target, response = data.response;
    var parsedUrl = new (0, $7HOQt.Url)(url);
    var destination = $47345d8e64485ba6$var$getDestination(parsedUrl);
    var context = {
        http: {
            method: method,
            url: parsedUrl.href
        },
        destination: destination
    };
    var statusCode;
    if (target && typeof target.status !== "undefined") statusCode = target.status;
    else if (response) statusCode = response.status;
    context.http.status_code = statusCode;
    return context;
}
function $47345d8e64485ba6$var$getNavigationContext(data) {
    var url = data.url;
    var parsedUrl = new (0, $7HOQt.Url)(url);
    var destination = $47345d8e64485ba6$var$getDestination(parsedUrl);
    return {
        destination: destination
    };
}
function $47345d8e64485ba6$export$1303843c2f44065a() {
    return {
        page: {
            referer: document.referrer,
            url: location.href
        }
    };
}
function $47345d8e64485ba6$export$ed109afa225aed5b(span, data) {
    if (!data) return;
    var type = span.type;
    var context;
    switch(type){
        case $47345d8e64485ba6$var$EXTERNAL:
            context = $47345d8e64485ba6$var$getExternalContext(data);
            break;
        case $47345d8e64485ba6$var$RESOURCE:
            context = $47345d8e64485ba6$var$getResourceContext(data);
            break;
        case $47345d8e64485ba6$var$HARD_NAVIGATION:
            context = $47345d8e64485ba6$var$getNavigationContext(data);
            break;
    }
    span.addContext(context);
}
function $47345d8e64485ba6$export$d10ae57e760667a5(transaction, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, tags = _ref.tags, configContext = $47345d8e64485ba6$var$_objectWithoutPropertiesLoose(_ref, $47345d8e64485ba6$var$_excluded);
    var pageContext = $47345d8e64485ba6$export$1303843c2f44065a();
    var responseContext = {};
    if (transaction.type === (0, $a3rI2.PAGE_LOAD) && (0, $la17Z.isPerfTimelineSupported)()) {
        var entries = (0, $la17Z.PERF).getEntriesByType((0, $a3rI2.NAVIGATION));
        if (entries && entries.length > 0) responseContext = {
            response: $47345d8e64485ba6$var$getResponseContext(entries[0])
        };
    }
    transaction.addContext(pageContext, responseContext, configContext);
}

});
parcelRegister("7HOQt", function(module, exports) {

$parcel$export(module.exports, "Url", () => $59c3fd5bcfd2cb87$export$59d795186a5d3f58);
$parcel$export(module.exports, "slugifyUrl", () => $59c3fd5bcfd2cb87$export$456a5af62e4119f6);

var $la17Z = parcelRequire("la17Z");
function $59c3fd5bcfd2cb87$var$isDefaultPort(port, protocol) {
    switch(protocol){
        case "http:":
            return port === "80";
        case "https:":
            return port === "443";
    }
    return true;
}
var $59c3fd5bcfd2cb87$var$RULES = [
    [
        "#",
        "hash"
    ],
    [
        "?",
        "query"
    ],
    [
        "/",
        "path"
    ],
    [
        "@",
        "auth",
        1
    ],
    [
        NaN,
        "host",
        undefined,
        1
    ]
];
var $59c3fd5bcfd2cb87$var$PROTOCOL_REGEX = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\S\s]*)/i;
var $59c3fd5bcfd2cb87$export$59d795186a5d3f58 = function() {
    function Url(url) {
        var _this$extractProtocol = this.extractProtocol(url || ""), protocol = _this$extractProtocol.protocol, address = _this$extractProtocol.address, slashes = _this$extractProtocol.slashes;
        var relative = !protocol && !slashes;
        var location = this.getLocation();
        var instructions = $59c3fd5bcfd2cb87$var$RULES.slice();
        address = address.replace("\\", "/");
        if (!slashes) instructions[2] = [
            NaN,
            "path"
        ];
        var index;
        for(var i = 0; i < instructions.length; i++){
            var instruction = instructions[i];
            var parse = instruction[0];
            var key = instruction[1];
            if (typeof parse === "string") {
                index = address.indexOf(parse);
                if (~index) {
                    var instLength = instruction[2];
                    if (instLength) {
                        var newIndex = address.lastIndexOf(parse);
                        index = Math.max(index, newIndex);
                        this[key] = address.slice(0, index);
                        address = address.slice(index + instLength);
                    } else {
                        this[key] = address.slice(index);
                        address = address.slice(0, index);
                    }
                }
            } else {
                this[key] = address;
                address = "";
            }
            this[key] = this[key] || (relative && instruction[3] ? location[key] || "" : "");
            if (instruction[3]) this[key] = this[key].toLowerCase();
        }
        if (relative && this.path.charAt(0) !== "/") this.path = "/" + this.path;
        this.relative = relative;
        this.protocol = protocol || location.protocol;
        this.hostname = this.host;
        this.port = "";
        if (/:\d+$/.test(this.host)) {
            var value = this.host.split(":");
            var port = value.pop();
            var hostname = value.join(":");
            if ($59c3fd5bcfd2cb87$var$isDefaultPort(port, this.protocol)) this.host = hostname;
            else this.port = port;
            this.hostname = hostname;
        }
        this.origin = this.protocol && this.host && this.protocol !== "file:" ? this.protocol + "//" + this.host : "null";
        this.href = this.toString();
    }
    var _proto = Url.prototype;
    _proto.toString = function toString() {
        var result = this.protocol;
        result += "//";
        if (this.auth) {
            var REDACTED = "[REDACTED]";
            var userpass = this.auth.split(":");
            var username = userpass[0] ? REDACTED : "";
            var password = userpass[1] ? ":" + REDACTED : "";
            result += username + password + "@";
        }
        result += this.host;
        result += this.path;
        result += this.query;
        result += this.hash;
        return result;
    };
    _proto.getLocation = function getLocation() {
        var globalVar = {};
        if (0, $la17Z.isBrowser) globalVar = window;
        return globalVar.location;
    };
    _proto.extractProtocol = function extractProtocol(url) {
        var match = $59c3fd5bcfd2cb87$var$PROTOCOL_REGEX.exec(url);
        return {
            protocol: match[1] ? match[1].toLowerCase() : "",
            slashes: !!match[2],
            address: match[3]
        };
    };
    return Url;
}();
function $59c3fd5bcfd2cb87$export$456a5af62e4119f6(urlStr, depth) {
    if (depth === void 0) depth = 2;
    var parsedUrl = new $59c3fd5bcfd2cb87$export$59d795186a5d3f58(urlStr);
    var query = parsedUrl.query, path = parsedUrl.path;
    var pathParts = path.substring(1).split("/");
    var redactString = ":id";
    var wildcard = "*";
    var specialCharsRegex = /\W|_/g;
    var digitsRegex = /[0-9]/g;
    var lowerCaseRegex = /[a-z]/g;
    var upperCaseRegex = /[A-Z]/g;
    var redactedParts = [];
    var redactedBefore = false;
    for(var index = 0; index < pathParts.length; index++){
        var part = pathParts[index];
        if (redactedBefore || index > depth - 1) {
            if (part) redactedParts.push(wildcard);
            break;
        }
        var numberOfSpecialChars = (part.match(specialCharsRegex) || []).length;
        if (numberOfSpecialChars >= 2) {
            redactedParts.push(redactString);
            redactedBefore = true;
            continue;
        }
        var numberOfDigits = (part.match(digitsRegex) || []).length;
        if (numberOfDigits > 3 || part.length > 3 && numberOfDigits / part.length >= 0.3) {
            redactedParts.push(redactString);
            redactedBefore = true;
            continue;
        }
        var numberofUpperCase = (part.match(upperCaseRegex) || []).length;
        var numberofLowerCase = (part.match(lowerCaseRegex) || []).length;
        var lowerCaseRate = numberofLowerCase / part.length;
        var upperCaseRate = numberofUpperCase / part.length;
        if (part.length > 5 && (upperCaseRate > 0.3 && upperCaseRate < 0.6 || lowerCaseRate > 0.3 && lowerCaseRate < 0.6)) {
            redactedParts.push(redactString);
            redactedBefore = true;
            continue;
        }
        part && redactedParts.push(part);
    }
    var redacted = "/" + (redactedParts.length >= 2 ? redactedParts.join("/") : redactedParts.join("")) + (query ? "?{query}" : "");
    return redacted;
}

});


parcelRegister("YDh6C", function(module, exports) {

$parcel$export(module.exports, "METADATA_MODEL", () => $0b6411e37bd5cbe5$export$cddc53a868778b3a);
$parcel$export(module.exports, "SPAN_MODEL", () => $0b6411e37bd5cbe5$export$41c959b800170f79);
$parcel$export(module.exports, "TRANSACTION_MODEL", () => $0b6411e37bd5cbe5$export$d887b343e3ec3a69);
$parcel$export(module.exports, "ERROR_MODEL", () => $0b6411e37bd5cbe5$export$fdad63db1c0e037c);
$parcel$export(module.exports, "truncateModel", () => $0b6411e37bd5cbe5$export$488247de36c98c6b);

var $a3rI2 = parcelRequire("a3rI2");
var $0b6411e37bd5cbe5$export$cddc53a868778b3a = {
    service: {
        name: [
            (0, $a3rI2.KEYWORD_LIMIT),
            true
        ],
        version: true,
        agent: {
            version: [
                (0, $a3rI2.KEYWORD_LIMIT),
                true
            ]
        },
        environment: true
    },
    labels: {
        "*": true
    }
};
var $0b6411e37bd5cbe5$export$a92fd7a0c1236a31 = {
    "*": true,
    headers: {
        "*": true
    }
};
var $0b6411e37bd5cbe5$var$DESTINATION_MODEL = {
    address: [
        (0, $a3rI2.KEYWORD_LIMIT)
    ],
    service: {
        "*": [
            (0, $a3rI2.KEYWORD_LIMIT),
            true
        ]
    }
};
var $0b6411e37bd5cbe5$var$CONTEXT_MODEL = {
    user: {
        id: true,
        email: true,
        username: true
    },
    tags: {
        "*": true
    },
    http: {
        response: $0b6411e37bd5cbe5$export$a92fd7a0c1236a31
    },
    destination: $0b6411e37bd5cbe5$var$DESTINATION_MODEL,
    response: $0b6411e37bd5cbe5$export$a92fd7a0c1236a31
};
var $0b6411e37bd5cbe5$export$41c959b800170f79 = {
    name: [
        (0, $a3rI2.KEYWORD_LIMIT),
        true
    ],
    type: [
        (0, $a3rI2.KEYWORD_LIMIT),
        true
    ],
    id: [
        (0, $a3rI2.KEYWORD_LIMIT),
        true
    ],
    trace_id: [
        (0, $a3rI2.KEYWORD_LIMIT),
        true
    ],
    parent_id: [
        (0, $a3rI2.KEYWORD_LIMIT),
        true
    ],
    transaction_id: [
        (0, $a3rI2.KEYWORD_LIMIT),
        true
    ],
    subtype: true,
    action: true,
    context: $0b6411e37bd5cbe5$var$CONTEXT_MODEL
};
var $0b6411e37bd5cbe5$export$d887b343e3ec3a69 = {
    name: true,
    parent_id: true,
    type: [
        (0, $a3rI2.KEYWORD_LIMIT),
        true
    ],
    id: [
        (0, $a3rI2.KEYWORD_LIMIT),
        true
    ],
    trace_id: [
        (0, $a3rI2.KEYWORD_LIMIT),
        true
    ],
    span_count: {
        started: [
            (0, $a3rI2.KEYWORD_LIMIT),
            true
        ]
    },
    context: $0b6411e37bd5cbe5$var$CONTEXT_MODEL
};
var $0b6411e37bd5cbe5$export$fdad63db1c0e037c = {
    id: [
        (0, $a3rI2.KEYWORD_LIMIT),
        true
    ],
    trace_id: true,
    transaction_id: true,
    parent_id: true,
    culprit: true,
    exception: {
        type: true
    },
    transaction: {
        type: true
    },
    context: $0b6411e37bd5cbe5$var$CONTEXT_MODEL
};
function $0b6411e37bd5cbe5$export$6a506b36fdea397d(value, limit, required, placeholder) {
    if (limit === void 0) limit = (0, $a3rI2.KEYWORD_LIMIT);
    if (required === void 0) required = false;
    if (placeholder === void 0) placeholder = "N/A";
    if (required && $0b6411e37bd5cbe5$var$isEmpty(value)) value = placeholder;
    if (typeof value === "string") return value.substring(0, limit);
    return value;
}
function $0b6411e37bd5cbe5$var$isEmpty(value) {
    return value == null || value === "" || typeof value === "undefined";
}
function $0b6411e37bd5cbe5$var$replaceValue(target, key, currModel) {
    var value = $0b6411e37bd5cbe5$export$6a506b36fdea397d(target[key], currModel[0], currModel[1]);
    if ($0b6411e37bd5cbe5$var$isEmpty(value)) {
        delete target[key];
        return;
    }
    target[key] = value;
}
function $0b6411e37bd5cbe5$export$488247de36c98c6b(model, target, childTarget) {
    if (model === void 0) model = {};
    if (childTarget === void 0) childTarget = target;
    var keys = Object.keys(model);
    var emptyArr = [];
    var _loop = function _loop(i) {
        var currKey = keys[i];
        var currModel = model[currKey] === true ? emptyArr : model[currKey];
        if (!Array.isArray(currModel)) $0b6411e37bd5cbe5$export$488247de36c98c6b(currModel, target, childTarget[currKey]);
        else if (currKey === "*") Object.keys(childTarget).forEach(function(key) {
            return $0b6411e37bd5cbe5$var$replaceValue(childTarget, key, currModel);
        });
        else $0b6411e37bd5cbe5$var$replaceValue(childTarget, currKey, currModel);
    };
    for(var i = 0; i < keys.length; i++)_loop(i);
    return target;
}

});

parcelRegister("3JlwZ", function(module, exports) {

(function(root, factory) {
    "use strict";
    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
    /* istanbul ignore next */ if (typeof define === "function" && define.amd) define("error-stack-parser", [
        "stackframe"
    ], factory);
    else module.exports = factory((parcelRequire("9nT2C")));
})(module.exports, function ErrorStackParser(StackFrame) {
    "use strict";
    var FIREFOX_SAFARI_STACK_REGEXP = /(^|@)\S+\:\d+/;
    var CHROME_IE_STACK_REGEXP = /^\s*at .*(\S+\:\d+|\(native\))/m;
    var SAFARI_NATIVE_CODE_REGEXP = /^(eval@)?(\[native code\])?$/;
    function _map(array, fn, thisArg) {
        if (typeof Array.prototype.map === "function") return array.map(fn, thisArg);
        else {
            var output = new Array(array.length);
            for(var i = 0; i < array.length; i++)output[i] = fn.call(thisArg, array[i]);
            return output;
        }
    }
    function _filter(array, fn, thisArg) {
        if (typeof Array.prototype.filter === "function") return array.filter(fn, thisArg);
        else {
            var output = [];
            for(var i = 0; i < array.length; i++)if (fn.call(thisArg, array[i])) output.push(array[i]);
            return output;
        }
    }
    function _indexOf(array, target) {
        if (typeof Array.prototype.indexOf === "function") return array.indexOf(target);
        else {
            for(var i = 0; i < array.length; i++){
                if (array[i] === target) return i;
            }
            return -1;
        }
    }
    return {
        /**
         * Given an Error object, extract the most information from it.
         *
         * @param {Error} error object
         * @return {Array} of StackFrames
         */ parse: function ErrorStackParser$$parse(error) {
            if (typeof error.stacktrace !== "undefined" || typeof error["opera#sourceloc"] !== "undefined") return this.parseOpera(error);
            else if (error.stack && error.stack.match(CHROME_IE_STACK_REGEXP)) return this.parseV8OrIE(error);
            else if (error.stack) return this.parseFFOrSafari(error);
            else throw new Error("Cannot parse given Error object");
        },
        // Separate line and column numbers from a string of the form: (URI:Line:Column)
        extractLocation: function ErrorStackParser$$extractLocation(urlLike) {
            // Fail-fast but return locations like "(native)"
            if (urlLike.indexOf(":") === -1) return [
                urlLike
            ];
            var regExp = /(.+?)(?:\:(\d+))?(?:\:(\d+))?$/;
            var parts = regExp.exec(urlLike.replace(/[\(\)]/g, ""));
            return [
                parts[1],
                parts[2] || undefined,
                parts[3] || undefined
            ];
        },
        parseV8OrIE: function ErrorStackParser$$parseV8OrIE(error) {
            var filtered = _filter(error.stack.split("\n"), function(line) {
                return !!line.match(CHROME_IE_STACK_REGEXP);
            }, this);
            return _map(filtered, function(line) {
                if (line.indexOf("(eval ") > -1) // Throw away eval information until we implement stacktrace.js/stackframe#8
                line = line.replace(/eval code/g, "eval").replace(/(\(eval at [^\()]*)|(\)\,.*$)/g, "");
                var tokens = line.replace(/^\s+/, "").replace(/\(eval code/g, "(").split(/\s+/).slice(1);
                var locationParts = this.extractLocation(tokens.pop());
                var functionName = tokens.join(" ") || undefined;
                var fileName = _indexOf([
                    "eval",
                    "<anonymous>"
                ], locationParts[0]) > -1 ? undefined : locationParts[0];
                return new StackFrame(functionName, undefined, fileName, locationParts[1], locationParts[2], line);
            }, this);
        },
        parseFFOrSafari: function ErrorStackParser$$parseFFOrSafari(error) {
            var filtered = _filter(error.stack.split("\n"), function(line) {
                return !line.match(SAFARI_NATIVE_CODE_REGEXP);
            }, this);
            return _map(filtered, function(line) {
                // Throw away eval information until we implement stacktrace.js/stackframe#8
                if (line.indexOf(" > eval") > -1) line = line.replace(/ line (\d+)(?: > eval line \d+)* > eval\:\d+\:\d+/g, ":$1");
                if (line.indexOf("@") === -1 && line.indexOf(":") === -1) // Safari eval frames only have function names and nothing else
                return new StackFrame(line);
                else {
                    var tokens = line.split("@");
                    var locationParts = this.extractLocation(tokens.pop());
                    var functionName = tokens.join("@") || undefined;
                    return new StackFrame(functionName, undefined, locationParts[0], locationParts[1], locationParts[2], line);
                }
            }, this);
        },
        parseOpera: function ErrorStackParser$$parseOpera(e) {
            if (!e.stacktrace || e.message.indexOf("\n") > -1 && e.message.split("\n").length > e.stacktrace.split("\n").length) return this.parseOpera9(e);
            else if (!e.stack) return this.parseOpera10(e);
            else return this.parseOpera11(e);
        },
        parseOpera9: function ErrorStackParser$$parseOpera9(e) {
            var lineRE = /Line (\d+).*script (?:in )?(\S+)/i;
            var lines = e.message.split("\n");
            var result = [];
            for(var i = 2, len = lines.length; i < len; i += 2){
                var match = lineRE.exec(lines[i]);
                if (match) result.push(new StackFrame(undefined, undefined, match[2], match[1], undefined, lines[i]));
            }
            return result;
        },
        parseOpera10: function ErrorStackParser$$parseOpera10(e) {
            var lineRE = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i;
            var lines = e.stacktrace.split("\n");
            var result = [];
            for(var i = 0, len = lines.length; i < len; i += 2){
                var match = lineRE.exec(lines[i]);
                if (match) result.push(new StackFrame(match[3] || undefined, undefined, match[2], match[1], undefined, lines[i]));
            }
            return result;
        },
        // Opera 10.65+ Error.stack very similar to FF/Safari
        parseOpera11: function ErrorStackParser$$parseOpera11(error) {
            var filtered = _filter(error.stack.split("\n"), function(line) {
                return !!line.match(FIREFOX_SAFARI_STACK_REGEXP) && !line.match(/^Error created at/);
            }, this);
            return _map(filtered, function(line) {
                var tokens = line.split("@");
                var locationParts = this.extractLocation(tokens.pop());
                var functionCall = tokens.shift() || "";
                var functionName = functionCall.replace(/<anonymous function(: (\w+))?>/, "$2").replace(/\([^\)]*\)/g, "") || undefined;
                var argsRaw;
                if (functionCall.match(/\(([^\)]*)\)/)) argsRaw = functionCall.replace(/^[^\(]+\(([^\)]*)\)$/, "$1");
                var args = argsRaw === undefined || argsRaw === "[arguments not available]" ? undefined : argsRaw.split(",");
                return new StackFrame(functionName, args, locationParts[0], locationParts[1], locationParts[2], line);
            }, this);
        }
    };
});

});
parcelRegister("9nT2C", function(module, exports) {
(function(root, factory) {
    "use strict";
    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
    /* istanbul ignore next */ if (typeof define === "function" && define.amd) define("stackframe", [], factory);
    else module.exports = factory();
})(module.exports, function() {
    "use strict";
    function _isNumber(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }
    function StackFrame(functionName, args, fileName, lineNumber, columnNumber, source) {
        if (functionName !== undefined) this.setFunctionName(functionName);
        if (args !== undefined) this.setArgs(args);
        if (fileName !== undefined) this.setFileName(fileName);
        if (lineNumber !== undefined) this.setLineNumber(lineNumber);
        if (columnNumber !== undefined) this.setColumnNumber(columnNumber);
        if (source !== undefined) this.setSource(source);
    }
    StackFrame.prototype = {
        getFunctionName: function() {
            return this.functionName;
        },
        setFunctionName: function(v) {
            this.functionName = String(v);
        },
        getArgs: function() {
            return this.args;
        },
        setArgs: function(v) {
            if (Object.prototype.toString.call(v) !== "[object Array]") throw new TypeError("Args must be an Array");
            this.args = v;
        },
        // NOTE: Property name may be misleading as it includes the path,
        // but it somewhat mirrors V8's JavaScriptStackTraceApi
        // https://code.google.com/p/v8/wiki/JavaScriptStackTraceApi and Gecko's
        // http://mxr.mozilla.org/mozilla-central/source/xpcom/base/nsIException.idl#14
        getFileName: function() {
            return this.fileName;
        },
        setFileName: function(v) {
            this.fileName = String(v);
        },
        getLineNumber: function() {
            return this.lineNumber;
        },
        setLineNumber: function(v) {
            if (!_isNumber(v)) throw new TypeError("Line Number must be a Number");
            this.lineNumber = Number(v);
        },
        getColumnNumber: function() {
            return this.columnNumber;
        },
        setColumnNumber: function(v) {
            if (!_isNumber(v)) throw new TypeError("Column Number must be a Number");
            this.columnNumber = Number(v);
        },
        getSource: function() {
            return this.source;
        },
        setSource: function(v) {
            this.source = String(v);
        },
        toString: function() {
            var functionName = this.getFunctionName() || "{anonymous}";
            var args = "(" + (this.getArgs() || []).join(",") + ")";
            var fileName = this.getFileName() ? "@" + this.getFileName() : "";
            var lineNumber = _isNumber(this.getLineNumber()) ? ":" + this.getLineNumber() : "";
            var columnNumber = _isNumber(this.getColumnNumber()) ? ":" + this.getColumnNumber() : "";
            return functionName + args + fileName + lineNumber + columnNumber;
        }
    };
    return StackFrame;
});

});



parcelRegister("7jITz", function(module, exports) {

$parcel$export(module.exports, "serviceCreators", () => $553d21ff470d1329$export$a7d9bc765837b75c);
$parcel$export(module.exports, "ServiceFactory", () => $553d21ff470d1329$export$654036ce31f352db);

var $aYv1G = parcelRequire("aYv1G");

var $fVBWA = parcelRequire("fVBWA");

var $7ukCo = parcelRequire("7ukCo");

var $a3rI2 = parcelRequire("a3rI2");

var $dgsvq = parcelRequire("dgsvq");
var $553d21ff470d1329$var$_serviceCreators;
var $553d21ff470d1329$export$a7d9bc765837b75c = ($553d21ff470d1329$var$_serviceCreators = {}, $553d21ff470d1329$var$_serviceCreators[0, $a3rI2.CONFIG_SERVICE] = function() {
    return new (0, $fVBWA.default)();
}, $553d21ff470d1329$var$_serviceCreators[0, $a3rI2.LOGGING_SERVICE] = function() {
    return new (0, $7ukCo.default)({
        prefix: "[Elastic APM] "
    });
}, $553d21ff470d1329$var$_serviceCreators[0, $a3rI2.APM_SERVER] = function(factory) {
    var _factory$getService = factory.getService([
        (0, $a3rI2.CONFIG_SERVICE),
        (0, $a3rI2.LOGGING_SERVICE)
    ]), configService = _factory$getService[0], loggingService = _factory$getService[1];
    return new (0, $aYv1G.default)(configService, loggingService);
}, $553d21ff470d1329$var$_serviceCreators);
var $553d21ff470d1329$export$654036ce31f352db = function() {
    function ServiceFactory() {
        this.instances = {};
        this.initialized = false;
    }
    var _proto = ServiceFactory.prototype;
    _proto.init = function init() {
        if (this.initialized) return;
        this.initialized = true;
        var configService = this.getService((0, $a3rI2.CONFIG_SERVICE));
        configService.init();
        var _this$getService = this.getService([
            (0, $a3rI2.LOGGING_SERVICE),
            (0, $a3rI2.APM_SERVER)
        ]), loggingService = _this$getService[0], apmServer = _this$getService[1];
        configService.events.observe((0, $a3rI2.CONFIG_CHANGE), function() {
            var logLevel = configService.get("logLevel");
            loggingService.setLevel(logLevel);
        });
        apmServer.init();
    };
    _proto.getService = function getService(name) {
        var _this = this;
        if (typeof name === "string") {
            if (!this.instances[name]) {
                if (typeof $553d21ff470d1329$export$a7d9bc765837b75c[name] === "function") this.instances[name] = $553d21ff470d1329$export$a7d9bc765837b75c[name](this);
                else if (0, $dgsvq.__DEV__) console.log("Cannot get service, No creator for: " + name);
            }
            return this.instances[name];
        } else if (Array.isArray(name)) return name.map(function(n) {
            return _this.getService(n);
        });
    };
    return ServiceFactory;
}();

});
parcelRegister("aYv1G", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fd79323ded0f448$export$2e2bcd8739ae039);

var $2s2E8 = parcelRequire("2s2E8");

var $dSv4h = parcelRequire("dSv4h");

var $gBH8h = parcelRequire("gBH8h");

var $YDh6C = parcelRequire("YDh6C");

var $a3rI2 = parcelRequire("a3rI2");

var $la17Z = parcelRequire("la17Z");

var $lnGft = parcelRequire("lnGft");

var $fMfGQ = parcelRequire("fMfGQ");

var $dgsvq = parcelRequire("dgsvq");

var $lORcz = parcelRequire("lORcz");

var $3ykUf = parcelRequire("3ykUf");
var $7fd79323ded0f448$var$THROTTLE_INTERVAL = 60000;
var $7fd79323ded0f448$var$ApmServer = function() {
    function ApmServer(configService, loggingService) {
        this._configService = configService;
        this._loggingService = loggingService;
        this.queue = undefined;
        this.throttleEvents = (0, $la17Z.noop);
    }
    var _proto = ApmServer.prototype;
    _proto.init = function init() {
        var _this = this;
        var queueLimit = this._configService.get("queueLimit");
        var flushInterval = this._configService.get("flushInterval");
        var limit = this._configService.get("eventsLimit");
        var onFlush = function onFlush(events) {
            var promise = _this.sendEvents(events);
            if (promise) promise.catch(function(reason) {
                _this._loggingService.warn("Failed sending events!", _this._constructError(reason));
            });
        };
        this.queue = new (0, $2s2E8.default)(onFlush, {
            queueLimit: queueLimit,
            flushInterval: flushInterval
        });
        this.throttleEvents = (0, $dSv4h.default)(this.queue.add.bind(this.queue), function() {
            return _this._loggingService.warn("Dropped events due to throttling!");
        }, {
            limit: limit,
            interval: $7fd79323ded0f448$var$THROTTLE_INTERVAL
        });
        this._configService.observeEvent((0, $a3rI2.QUEUE_FLUSH), function() {
            _this.queue.flush();
        });
    };
    _proto._postJson = function _postJson(endPoint, payload) {
        var _this2 = this;
        var headers = {
            "Content-Type": "application/x-ndjson"
        };
        var apmRequest = this._configService.get("apmRequest");
        var params = {
            payload: payload,
            headers: headers,
            beforeSend: apmRequest
        };
        return (0, $fMfGQ.compressPayload)(params).catch(function(error) {
            if (0, $dgsvq.__DEV__) _this2._loggingService.debug("Compressing the payload using CompressionStream API failed", error.message);
            return params;
        }).then(function(result) {
            return _this2._makeHttpRequest("POST", endPoint, result);
        }).then(function(_ref) {
            var responseText = _ref.responseText;
            return responseText;
        });
    };
    _proto._constructError = function _constructError(reason) {
        var url = reason.url, status = reason.status, responseText = reason.responseText;
        if (typeof status == "undefined") return reason;
        var message = url + " HTTP status: " + status;
        if ((0, $dgsvq.__DEV__) && responseText) try {
            var serverErrors = [];
            var response = JSON.parse(responseText);
            if (response.errors && response.errors.length > 0) {
                response.errors.forEach(function(err) {
                    return serverErrors.push(err.message);
                });
                message += " " + serverErrors.join(",");
            }
        } catch (e) {
            this._loggingService.debug("Error parsing response from APM server", e);
        }
        return new Error(message);
    };
    _proto._makeHttpRequest = function _makeHttpRequest(method, url, _temp) {
        var _ref2 = _temp === void 0 ? {} : _temp, _ref2$timeout = _ref2.timeout, timeout = _ref2$timeout === void 0 ? (0, $a3rI2.HTTP_REQUEST_TIMEOUT) : _ref2$timeout, payload = _ref2.payload, headers = _ref2.headers, beforeSend = _ref2.beforeSend;
        var sendCredentials = this._configService.get("sendCredentials");
        if (!beforeSend && (0, $lORcz.shouldUseFetchWithKeepAlive)(method, payload)) return (0, $lORcz.sendFetchRequest)(method, url, {
            keepalive: true,
            timeout: timeout,
            payload: payload,
            headers: headers,
            sendCredentials: sendCredentials
        }).catch(function(reason) {
            if (reason instanceof TypeError) return (0, $3ykUf.sendXHR)(method, url, {
                timeout: timeout,
                payload: payload,
                headers: headers,
                beforeSend: beforeSend,
                sendCredentials: sendCredentials
            });
            throw reason;
        });
        return (0, $3ykUf.sendXHR)(method, url, {
            timeout: timeout,
            payload: payload,
            headers: headers,
            beforeSend: beforeSend,
            sendCredentials: sendCredentials
        });
    };
    _proto.fetchConfig = function fetchConfig(serviceName, environment) {
        var _this3 = this;
        var _this$getEndpoints = this.getEndpoints(), configEndpoint = _this$getEndpoints.configEndpoint;
        if (!serviceName) return (0, $lnGft.Promise).reject("serviceName is required for fetching central config.");
        configEndpoint += "?service.name=" + serviceName;
        if (environment) configEndpoint += "&service.environment=" + environment;
        var localConfig = this._configService.getLocalConfig();
        if (localConfig) configEndpoint += "&ifnonematch=" + localConfig.etag;
        var apmRequest = this._configService.get("apmRequest");
        return this._makeHttpRequest("GET", configEndpoint, {
            timeout: 5000,
            beforeSend: apmRequest
        }).then(function(xhr) {
            var status = xhr.status, responseText = xhr.responseText;
            if (status === 304) return localConfig;
            else {
                var remoteConfig = JSON.parse(responseText);
                var etag = xhr.getResponseHeader("etag");
                if (etag) {
                    remoteConfig.etag = etag.replace(/["]/g, "");
                    _this3._configService.setLocalConfig(remoteConfig, true);
                }
                return remoteConfig;
            }
        }).catch(function(reason) {
            var error = _this3._constructError(reason);
            return (0, $lnGft.Promise).reject(error);
        });
    };
    _proto.createMetaData = function createMetaData() {
        var cfg = this._configService;
        var metadata = {
            service: {
                name: cfg.get("serviceName"),
                version: cfg.get("serviceVersion"),
                agent: {
                    name: "rum-js",
                    version: cfg.version
                },
                language: {
                    name: "javascript"
                },
                environment: cfg.get("environment")
            },
            labels: cfg.get("context.tags")
        };
        return (0, $YDh6C.truncateModel)((0, $YDh6C.METADATA_MODEL), metadata);
    };
    _proto.addError = function addError(error) {
        var _this$throttleEvents;
        this.throttleEvents((_this$throttleEvents = {}, _this$throttleEvents[0, $a3rI2.ERRORS] = error, _this$throttleEvents));
    };
    _proto.addTransaction = function addTransaction(transaction) {
        var _this$throttleEvents2;
        this.throttleEvents((_this$throttleEvents2 = {}, _this$throttleEvents2[0, $a3rI2.TRANSACTIONS] = transaction, _this$throttleEvents2));
    };
    _proto.ndjsonErrors = function ndjsonErrors(errors, compress) {
        var key = compress ? "e" : "error";
        return errors.map(function(error) {
            var _NDJSON$stringify;
            return (0, $gBH8h.default).stringify((_NDJSON$stringify = {}, _NDJSON$stringify[key] = compress ? (0, $fMfGQ.compressError)(error) : error, _NDJSON$stringify));
        });
    };
    _proto.ndjsonMetricsets = function ndjsonMetricsets(metricsets) {
        return metricsets.map(function(metricset) {
            return (0, $gBH8h.default).stringify({
                metricset: metricset
            });
        }).join("");
    };
    _proto.ndjsonTransactions = function ndjsonTransactions(transactions, compress) {
        var _this4 = this;
        var key = compress ? "x" : "transaction";
        return transactions.map(function(tr) {
            var _NDJSON$stringify2;
            var spans = "", breakdowns = "";
            if (!compress) {
                if (tr.spans) {
                    spans = tr.spans.map(function(span) {
                        return (0, $gBH8h.default).stringify({
                            span: span
                        });
                    }).join("");
                    delete tr.spans;
                }
                if (tr.breakdown) {
                    breakdowns = _this4.ndjsonMetricsets(tr.breakdown);
                    delete tr.breakdown;
                }
            }
            return (0, $gBH8h.default).stringify((_NDJSON$stringify2 = {}, _NDJSON$stringify2[key] = compress ? (0, $fMfGQ.compressTransaction)(tr) : tr, _NDJSON$stringify2)) + spans + breakdowns;
        });
    };
    _proto.sendEvents = function sendEvents(events) {
        var _payload, _NDJSON$stringify3;
        if (events.length === 0) return;
        var transactions = [];
        var errors = [];
        for(var i = 0; i < events.length; i++){
            var event = events[i];
            if (event[0, $a3rI2.TRANSACTIONS]) transactions.push(event[0, $a3rI2.TRANSACTIONS]);
            if (event[0, $a3rI2.ERRORS]) errors.push(event[0, $a3rI2.ERRORS]);
        }
        if (transactions.length === 0 && errors.length === 0) return;
        var cfg = this._configService;
        var payload = (_payload = {}, _payload[0, $a3rI2.TRANSACTIONS] = transactions, _payload[0, $a3rI2.ERRORS] = errors, _payload);
        var filteredPayload = cfg.applyFilters(payload);
        if (!filteredPayload) {
            this._loggingService.warn("Dropped payload due to filtering!");
            return;
        }
        var apiVersion = cfg.get("apiVersion");
        var compress = apiVersion > 2;
        var ndjson = [];
        var metadata = this.createMetaData();
        var metadataKey = compress ? "m" : "metadata";
        ndjson.push((0, $gBH8h.default).stringify((_NDJSON$stringify3 = {}, _NDJSON$stringify3[metadataKey] = compress ? (0, $fMfGQ.compressMetadata)(metadata) : metadata, _NDJSON$stringify3)));
        ndjson = ndjson.concat(this.ndjsonErrors(filteredPayload[0, $a3rI2.ERRORS], compress), this.ndjsonTransactions(filteredPayload[0, $a3rI2.TRANSACTIONS], compress));
        var ndjsonPayload = ndjson.join("");
        var _this$getEndpoints2 = this.getEndpoints(), intakeEndpoint = _this$getEndpoints2.intakeEndpoint;
        return this._postJson(intakeEndpoint, ndjsonPayload);
    };
    _proto.getEndpoints = function getEndpoints() {
        var serverUrl = this._configService.get("serverUrl");
        var apiVersion = this._configService.get("apiVersion");
        var serverUrlPrefix = this._configService.get("serverUrlPrefix") || "/intake/v" + apiVersion + "/rum/events";
        var intakeEndpoint = serverUrl + serverUrlPrefix;
        var configEndpoint = serverUrl + "/config/v1/rum/agents";
        return {
            intakeEndpoint: intakeEndpoint,
            configEndpoint: configEndpoint
        };
    };
    return ApmServer;
}();
var $7fd79323ded0f448$export$2e2bcd8739ae039 = $7fd79323ded0f448$var$ApmServer;

});
parcelRegister("2s2E8", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c903fcd8fe68e2d$export$2e2bcd8739ae039);
var $1c903fcd8fe68e2d$var$Queue = function() {
    function Queue(onFlush, opts) {
        if (opts === void 0) opts = {};
        this.onFlush = onFlush;
        this.items = [];
        this.queueLimit = opts.queueLimit || -1;
        this.flushInterval = opts.flushInterval || 0;
        this.timeoutId = undefined;
    }
    var _proto = Queue.prototype;
    _proto._setTimer = function _setTimer() {
        var _this = this;
        this.timeoutId = setTimeout(function() {
            return _this.flush();
        }, this.flushInterval);
    };
    _proto._clear = function _clear() {
        if (typeof this.timeoutId !== "undefined") {
            clearTimeout(this.timeoutId);
            this.timeoutId = undefined;
        }
        this.items = [];
    };
    _proto.flush = function flush() {
        this.onFlush(this.items);
        this._clear();
    };
    _proto.add = function add(item) {
        this.items.push(item);
        if (this.queueLimit !== -1 && this.items.length >= this.queueLimit) this.flush();
        else if (typeof this.timeoutId === "undefined") this._setTimer();
    };
    return Queue;
}();
var $1c903fcd8fe68e2d$export$2e2bcd8739ae039 = $1c903fcd8fe68e2d$var$Queue;

});

parcelRegister("dSv4h", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1a86af477b54a87$export$2e2bcd8739ae039);
function $a1a86af477b54a87$export$2e2bcd8739ae039(fn, onThrottle, opts) {
    var context = this;
    var limit = opts.limit;
    var interval = opts.interval;
    var counter = 0;
    var timeoutId;
    return function() {
        counter++;
        if (typeof timeoutId === "undefined") timeoutId = setTimeout(function() {
            counter = 0;
            timeoutId = undefined;
        }, interval);
        if (counter > limit && typeof onThrottle === "function") return onThrottle.apply(context, arguments);
        else return fn.apply(context, arguments);
    };
}

});

parcelRegister("gBH8h", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1718f3fa66434db$export$2e2bcd8739ae039);
var $c1718f3fa66434db$var$NDJSON = function() {
    function NDJSON() {}
    NDJSON.stringify = function stringify(object) {
        return JSON.stringify(object) + "\n";
    };
    return NDJSON;
}();
var $c1718f3fa66434db$export$2e2bcd8739ae039 = $c1718f3fa66434db$var$NDJSON;

});

parcelRegister("fMfGQ", function(module, exports) {

$parcel$export(module.exports, "compressMetadata", () => $b7c7826f581e4ff4$export$12b7560e2fabea9);
$parcel$export(module.exports, "compressTransaction", () => $b7c7826f581e4ff4$export$2113d87e265597f0);
$parcel$export(module.exports, "compressError", () => $b7c7826f581e4ff4$export$c8289256501a337d);
$parcel$export(module.exports, "compressPayload", () => $b7c7826f581e4ff4$export$5569fdd03c217956);

var $lnGft = parcelRequire("lnGft");

var $k4y37 = parcelRequire("k4y37");

var $la17Z = parcelRequire("la17Z");
function $b7c7826f581e4ff4$var$compressStackFrames(frames) {
    return frames.map(function(frame) {
        return {
            ap: frame.abs_path,
            f: frame.filename,
            fn: frame.function,
            li: frame.lineno,
            co: frame.colno
        };
    });
}
function $b7c7826f581e4ff4$var$compressResponse(response) {
    return {
        ts: response.transfer_size,
        ebs: response.encoded_body_size,
        dbs: response.decoded_body_size
    };
}
function $b7c7826f581e4ff4$var$compressHTTP(http) {
    var compressed = {};
    var method = http.method, status_code = http.status_code, url = http.url, response = http.response;
    compressed.url = url;
    if (method) compressed.mt = method;
    if (status_code) compressed.sc = status_code;
    if (response) compressed.r = $b7c7826f581e4ff4$var$compressResponse(response);
    return compressed;
}
function $b7c7826f581e4ff4$var$compressContext(context) {
    if (!context) return null;
    var compressed = {};
    var page = context.page, http = context.http, response = context.response, destination = context.destination, user = context.user, custom = context.custom;
    if (page) compressed.p = {
        rf: page.referer,
        url: page.url
    };
    if (http) compressed.h = $b7c7826f581e4ff4$var$compressHTTP(http);
    if (response) compressed.r = $b7c7826f581e4ff4$var$compressResponse(response);
    if (destination) {
        var service = destination.service;
        compressed.dt = {
            se: {
                n: service.name,
                t: service.type,
                rc: service.resource
            },
            ad: destination.address,
            po: destination.port
        };
    }
    if (user) compressed.u = {
        id: user.id,
        un: user.username,
        em: user.email
    };
    if (custom) compressed.cu = custom;
    return compressed;
}
function $b7c7826f581e4ff4$var$compressMarks(marks) {
    if (!marks) return null;
    var compressedNtMarks = $b7c7826f581e4ff4$var$compressNavigationTimingMarks(marks.navigationTiming);
    var compressed = {
        nt: compressedNtMarks,
        a: $b7c7826f581e4ff4$var$compressAgentMarks(compressedNtMarks, marks.agent)
    };
    return compressed;
}
function $b7c7826f581e4ff4$var$compressNavigationTimingMarks(ntMarks) {
    if (!ntMarks) return null;
    var compressed = {};
    (0, $k4y37.COMPRESSED_NAV_TIMING_MARKS).forEach(function(mark, index) {
        var mapping = (0, $k4y37.NAVIGATION_TIMING_MARKS)[index];
        compressed[mark] = ntMarks[mapping];
    });
    return compressed;
}
function $b7c7826f581e4ff4$var$compressAgentMarks(compressedNtMarks, agentMarks) {
    var compressed = {};
    if (compressedNtMarks) compressed = {
        fb: compressedNtMarks.rs,
        di: compressedNtMarks.di,
        dc: compressedNtMarks.dc
    };
    if (agentMarks) {
        var fp = agentMarks.firstContentfulPaint;
        var lp = agentMarks.largestContentfulPaint;
        if (fp) compressed.fp = fp;
        if (lp) compressed.lp = lp;
    }
    if (Object.keys(compressed).length === 0) return null;
    return compressed;
}
function $b7c7826f581e4ff4$export$12b7560e2fabea9(metadata) {
    var service = metadata.service, labels = metadata.labels;
    var agent = service.agent, language = service.language;
    return {
        se: {
            n: service.name,
            ve: service.version,
            a: {
                n: agent.name,
                ve: agent.version
            },
            la: {
                n: language.name
            },
            en: service.environment
        },
        l: labels
    };
}
function $b7c7826f581e4ff4$export$2113d87e265597f0(transaction) {
    var spans = transaction.spans.map(function(span) {
        var spanData = {
            id: span.id,
            n: span.name,
            t: span.type,
            s: span.start,
            d: span.duration,
            c: $b7c7826f581e4ff4$var$compressContext(span.context),
            o: span.outcome,
            sr: span.sample_rate
        };
        if (span.parent_id !== transaction.id) spanData.pid = span.parent_id;
        if (span.sync === true) spanData.sy = true;
        if (span.subtype) spanData.su = span.subtype;
        if (span.action) spanData.ac = span.action;
        return spanData;
    });
    var tr = {
        id: transaction.id,
        tid: transaction.trace_id,
        n: transaction.name,
        t: transaction.type,
        d: transaction.duration,
        c: $b7c7826f581e4ff4$var$compressContext(transaction.context),
        k: $b7c7826f581e4ff4$var$compressMarks(transaction.marks),
        me: $b7c7826f581e4ff4$export$9327fccd6912fe3c(transaction.breakdown),
        y: spans,
        yc: {
            sd: spans.length
        },
        sm: transaction.sampled,
        sr: transaction.sample_rate,
        o: transaction.outcome
    };
    if (transaction.experience) {
        var _transaction$experien = transaction.experience, cls = _transaction$experien.cls, fid = _transaction$experien.fid, tbt = _transaction$experien.tbt, longtask = _transaction$experien.longtask;
        tr.exp = {
            cls: cls,
            fid: fid,
            tbt: tbt,
            lt: longtask
        };
    }
    if (transaction.session) {
        var _transaction$session = transaction.session, id = _transaction$session.id, sequence = _transaction$session.sequence;
        tr.ses = {
            id: id,
            seq: sequence
        };
    }
    return tr;
}
function $b7c7826f581e4ff4$export$c8289256501a337d(error) {
    var exception = error.exception;
    var compressed = {
        id: error.id,
        cl: error.culprit,
        ex: {
            mg: exception.message,
            st: $b7c7826f581e4ff4$var$compressStackFrames(exception.stacktrace),
            t: error.type
        },
        c: $b7c7826f581e4ff4$var$compressContext(error.context)
    };
    var transaction = error.transaction;
    if (transaction) {
        compressed.tid = error.trace_id;
        compressed.pid = error.parent_id;
        compressed.xid = error.transaction_id;
        compressed.x = {
            t: transaction.type,
            sm: transaction.sampled
        };
    }
    return compressed;
}
function $b7c7826f581e4ff4$export$9327fccd6912fe3c(breakdowns) {
    return breakdowns.map(function(_ref) {
        var span = _ref.span, samples = _ref.samples;
        return {
            y: {
                t: span.type
            },
            sa: {
                ysc: {
                    v: samples["span.self_time.count"].value
                },
                yss: {
                    v: samples["span.self_time.sum.us"].value
                }
            }
        };
    });
}
function $b7c7826f581e4ff4$export$5569fdd03c217956(params, type) {
    if (type === void 0) type = "gzip";
    var isCompressionStreamSupported = typeof CompressionStream === "function";
    return new (0, $lnGft.Promise)(function(resolve) {
        if (!isCompressionStreamSupported) return resolve(params);
        if ((0, $la17Z.isBeaconInspectionEnabled)()) return resolve(params);
        var payload = params.payload, headers = params.headers, beforeSend = params.beforeSend;
        var payloadStream = new Blob([
            payload
        ]).stream();
        var compressedStream = payloadStream.pipeThrough(new CompressionStream(type));
        return new Response(compressedStream).blob().then(function(payload) {
            headers["Content-Encoding"] = type;
            return resolve({
                payload: payload,
                headers: headers,
                beforeSend: beforeSend
            });
        });
    });
}

});
parcelRegister("k4y37", function(module, exports) {

$parcel$export(module.exports, "NAVIGATION_TIMING_MARKS", () => $e9ce97e069482005$export$76056912abddbcc9);
$parcel$export(module.exports, "COMPRESSED_NAV_TIMING_MARKS", () => $e9ce97e069482005$export$82a807639806d09d);
$parcel$export(module.exports, "getPageLoadMarks", () => $e9ce97e069482005$export$f010c0904d0d2983);

var $la17Z = parcelRequire("la17Z");
var $e9ce97e069482005$export$76056912abddbcc9 = [
    "fetchStart",
    "domainLookupStart",
    "domainLookupEnd",
    "connectStart",
    "connectEnd",
    "requestStart",
    "responseStart",
    "responseEnd",
    "domLoading",
    "domInteractive",
    "domContentLoadedEventStart",
    "domContentLoadedEventEnd",
    "domComplete",
    "loadEventStart",
    "loadEventEnd"
];
var $e9ce97e069482005$export$82a807639806d09d = [
    "fs",
    "ls",
    "le",
    "cs",
    "ce",
    "qs",
    "rs",
    "re",
    "dl",
    "di",
    "ds",
    "de",
    "dc",
    "es",
    "ee"
];
function $e9ce97e069482005$export$f010c0904d0d2983(timing) {
    var marks = $e9ce97e069482005$var$getNavigationTimingMarks(timing);
    if (marks == null) return null;
    return {
        navigationTiming: marks,
        agent: {
            timeToFirstByte: marks.responseStart,
            domInteractive: marks.domInteractive,
            domComplete: marks.domComplete
        }
    };
}
function $e9ce97e069482005$var$getNavigationTimingMarks(timing) {
    var redirectStart = timing.redirectStart, fetchStart = timing.fetchStart, navigationStart = timing.navigationStart, responseStart = timing.responseStart, responseEnd = timing.responseEnd;
    if (fetchStart >= navigationStart && responseStart >= fetchStart && responseEnd >= responseStart) {
        var marks = {};
        $e9ce97e069482005$export$76056912abddbcc9.forEach(function(timingKey) {
            var m = timing[timingKey];
            if (m && m >= fetchStart) {
                if ((0, $la17Z.isRedirectInfoAvailable)(timing)) marks[timingKey] = parseInt(m - redirectStart);
                else marks[timingKey] = parseInt(m - fetchStart);
            }
        });
        return marks;
    }
    return null;
}

});


parcelRegister("3ykUf", function(module, exports) {

$parcel$export(module.exports, "sendXHR", () => $2964c39834436320$export$998d51f5856d10f5);

var $3q6JU = parcelRequire("3q6JU");

var $1Dyof = parcelRequire("1Dyof");

var $lnGft = parcelRequire("lnGft");
function $2964c39834436320$export$998d51f5856d10f5(method, url, _ref) {
    var _ref$timeout = _ref.timeout, timeout = _ref$timeout === void 0 ? HTTP_REQUEST_TIMEOUT : _ref$timeout, payload = _ref.payload, headers = _ref.headers, beforeSend = _ref.beforeSend, sendCredentials = _ref.sendCredentials;
    return new (0, $lnGft.Promise)(function(resolve, reject) {
        var xhr = new window.XMLHttpRequest();
        xhr[0, $3q6JU.XHR_IGNORE] = true;
        xhr.open(method, url, true);
        xhr.timeout = timeout;
        xhr.withCredentials = sendCredentials;
        if (headers) {
            for(var header in headers)if (headers.hasOwnProperty(header)) xhr.setRequestHeader(header, headers[header]);
        }
        xhr.onreadystatechange = function() {
            if (xhr.readyState === 4) {
                var status = xhr.status, responseText = xhr.responseText;
                if ((0, $1Dyof.isResponseSuccessful)(status)) resolve(xhr);
                else reject({
                    url: url,
                    status: status,
                    responseText: responseText
                });
            }
        };
        xhr.onerror = function() {
            var status = xhr.status, responseText = xhr.responseText;
            reject({
                url: url,
                status: status,
                responseText: responseText
            });
        };
        var canSend = true;
        if (typeof beforeSend === "function") canSend = beforeSend({
            url: url,
            method: method,
            headers: headers,
            payload: payload,
            xhr: xhr
        });
        if (canSend) xhr.send(payload);
        else reject({
            url: url,
            status: 0,
            responseText: "Request rejected by user configuration."
        });
    });
}

});


parcelRegister("fVBWA", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9899cc4d018603d$export$2e2bcd8739ae039);

var $la17Z = parcelRequire("la17Z");

var $coqQq = parcelRequire("coqQq");

var $a3rI2 = parcelRequire("a3rI2");
function $b9899cc4d018603d$var$_extends() {
    $b9899cc4d018603d$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b9899cc4d018603d$var$_extends.apply(this, arguments);
}
function $b9899cc4d018603d$var$getConfigFromScript() {
    var script = (0, $la17Z.getCurrentScript)();
    var config = $b9899cc4d018603d$var$getDataAttributesFromNode(script);
    return config;
}
function $b9899cc4d018603d$var$getDataAttributesFromNode(node) {
    if (!node) return {};
    var dataAttrs = {};
    var dataRegex = /^data-([\w-]+)$/;
    var attrs = node.attributes;
    for(var i = 0; i < attrs.length; i++){
        var attr = attrs[i];
        if (dataRegex.test(attr.nodeName)) {
            var key = attr.nodeName.match(dataRegex)[1];
            var camelCasedkey = key.split("-").map(function(value, index) {
                return index > 0 ? value.charAt(0).toUpperCase() + value.substring(1) : value;
            }).join("");
            dataAttrs[camelCasedkey] = attr.value || attr.nodeValue;
        }
    }
    return dataAttrs;
}
var $b9899cc4d018603d$var$Config = function() {
    function Config() {
        this.config = {
            serviceName: "",
            serviceVersion: "",
            environment: "",
            serverUrl: "http://localhost:8200",
            serverUrlPrefix: "",
            active: true,
            instrument: true,
            disableInstrumentations: [],
            logLevel: "warn",
            breakdownMetrics: false,
            ignoreTransactions: [],
            eventsLimit: 80,
            queueLimit: -1,
            flushInterval: 500,
            distributedTracing: true,
            distributedTracingOrigins: [],
            distributedTracingHeaderName: "traceparent",
            pageLoadTraceId: "",
            pageLoadSpanId: "",
            pageLoadSampled: false,
            pageLoadTransactionName: "",
            propagateTracestate: false,
            transactionSampleRate: 1.0,
            centralConfig: false,
            monitorLongtasks: true,
            apiVersion: 2,
            context: {},
            session: false,
            apmRequest: null,
            sendCredentials: false
        };
        this.events = new (0, $coqQq.default)();
        this.filters = [];
        this.version = "";
    }
    var _proto = Config.prototype;
    _proto.init = function init() {
        var scriptData = $b9899cc4d018603d$var$getConfigFromScript();
        this.setConfig(scriptData);
    };
    _proto.setVersion = function setVersion(version) {
        this.version = version;
    };
    _proto.addFilter = function addFilter(cb) {
        if (typeof cb !== "function") throw new Error("Argument to must be function");
        this.filters.push(cb);
    };
    _proto.applyFilters = function applyFilters(data) {
        for(var i = 0; i < this.filters.length; i++){
            data = this.filters[i](data);
            if (!data) return;
        }
        return data;
    };
    _proto.get = function get(key) {
        return key.split(".").reduce(function(obj, objKey) {
            return obj && obj[objKey];
        }, this.config);
    };
    _proto.setUserContext = function setUserContext(userContext) {
        if (userContext === void 0) userContext = {};
        var context = {};
        var _userContext = userContext, id = _userContext.id, username = _userContext.username, email = _userContext.email;
        if (typeof id === "number" || typeof id === "string") context.id = id;
        if (typeof username === "string") context.username = username;
        if (typeof email === "string") context.email = email;
        this.config.context.user = (0, $la17Z.extend)(this.config.context.user || {}, context);
    };
    _proto.setCustomContext = function setCustomContext(customContext) {
        if (customContext === void 0) customContext = {};
        this.config.context.custom = (0, $la17Z.extend)(this.config.context.custom || {}, customContext);
    };
    _proto.addLabels = function addLabels(tags) {
        var _this = this;
        if (!this.config.context.tags) this.config.context.tags = {};
        var keys = Object.keys(tags);
        keys.forEach(function(k) {
            return (0, $la17Z.setLabel)(k, tags[k], _this.config.context.tags);
        });
    };
    _proto.setConfig = function setConfig(properties) {
        if (properties === void 0) properties = {};
        var _properties = properties, transactionSampleRate = _properties.transactionSampleRate, serverUrl = _properties.serverUrl;
        if (serverUrl) properties.serverUrl = serverUrl.replace(/\/+$/, "");
        if (!(0, $la17Z.isUndefined)(transactionSampleRate)) {
            if (transactionSampleRate < 0.0001 && transactionSampleRate > 0) transactionSampleRate = 0.0001;
            properties.transactionSampleRate = Math.round(transactionSampleRate * 10000) / 10000;
        }
        (0, $la17Z.merge)(this.config, properties);
        this.events.send((0, $a3rI2.CONFIG_CHANGE), [
            this.config
        ]);
    };
    _proto.validate = function validate(properties) {
        if (properties === void 0) properties = {};
        var requiredKeys = [
            "serviceName",
            "serverUrl"
        ];
        var allKeys = Object.keys(this.config);
        var errors = {
            missing: [],
            invalid: [],
            unknown: []
        };
        Object.keys(properties).forEach(function(key) {
            if (requiredKeys.indexOf(key) !== -1 && !properties[key]) errors.missing.push(key);
            if (allKeys.indexOf(key) === -1) errors.unknown.push(key);
        });
        if (properties.serviceName && !/^[a-zA-Z0-9 _-]+$/.test(properties.serviceName)) errors.invalid.push({
            key: "serviceName",
            value: properties.serviceName,
            allowed: "a-z, A-Z, 0-9, _, -, <space>"
        });
        var sampleRate = properties.transactionSampleRate;
        if (typeof sampleRate !== "undefined" && (typeof sampleRate !== "number" || isNaN(sampleRate) || sampleRate < 0 || sampleRate > 1)) errors.invalid.push({
            key: "transactionSampleRate",
            value: sampleRate,
            allowed: "Number between 0 and 1"
        });
        return errors;
    };
    _proto.getLocalConfig = function getLocalConfig() {
        var storage = sessionStorage;
        if (this.config.session) storage = localStorage;
        var config = storage.getItem((0, $a3rI2.LOCAL_CONFIG_KEY));
        if (config) return JSON.parse(config);
    };
    _proto.setLocalConfig = function setLocalConfig(config, merge) {
        if (config) {
            if (merge) {
                var prevConfig = this.getLocalConfig();
                config = $b9899cc4d018603d$var$_extends({}, prevConfig, config);
            }
            var storage = sessionStorage;
            if (this.config.session) storage = localStorage;
            storage.setItem((0, $a3rI2.LOCAL_CONFIG_KEY), JSON.stringify(config));
        }
    };
    _proto.dispatchEvent = function dispatchEvent(name, args) {
        this.events.send(name, args);
    };
    _proto.observeEvent = function observeEvent(name, fn) {
        return this.events.observe(name, fn);
    };
    return Config;
}();
var $b9899cc4d018603d$export$2e2bcd8739ae039 = $b9899cc4d018603d$var$Config;

});

parcelRegister("7ukCo", function(module, exports) {

$parcel$export(module.exports, "default", () => $573b541f0808c051$export$2e2bcd8739ae039);

var $la17Z = parcelRequire("la17Z");
var $573b541f0808c051$var$LoggingService = function() {
    function LoggingService(spec) {
        if (spec === void 0) spec = {};
        this.levels = [
            "trace",
            "debug",
            "info",
            "warn",
            "error"
        ];
        this.level = spec.level || "warn";
        this.prefix = spec.prefix || "";
        this.resetLogMethods();
    }
    var _proto = LoggingService.prototype;
    _proto.shouldLog = function shouldLog(level) {
        return this.levels.indexOf(level) >= this.levels.indexOf(this.level);
    };
    _proto.setLevel = function setLevel(level) {
        if (level === this.level) return;
        this.level = level;
        this.resetLogMethods();
    };
    _proto.resetLogMethods = function resetLogMethods() {
        var _this = this;
        this.levels.forEach(function(level) {
            _this[level] = _this.shouldLog(level) ? log : (0, $la17Z.noop);
            function log() {
                var normalizedLevel = level;
                if (level === "trace" || level === "debug") normalizedLevel = "info";
                var args = arguments;
                args[0] = this.prefix + args[0];
                if (console) {
                    var realMethod = console[normalizedLevel] || console.log;
                    if (typeof realMethod === "function") realMethod.apply(console, args);
                }
            }
        });
    };
    return LoggingService;
}();
var $573b541f0808c051$export$2e2bcd8739ae039 = $573b541f0808c051$var$LoggingService;

});



parcelRegister("4IPxA", function(module, exports) {

$parcel$export(module.exports, "registerServices", () => $3703406598eb7b41$export$174fd5f90dd8a5db);

var $3LUpG = parcelRequire("3LUpG");

var $1N8XZ = parcelRequire("1N8XZ");

var $a3rI2 = parcelRequire("a3rI2");

var $7jITz = parcelRequire("7jITz");
function $3703406598eb7b41$export$174fd5f90dd8a5db() {
    (0, $7jITz.serviceCreators)[0, $a3rI2.TRANSACTION_SERVICE] = function(serviceFactory) {
        var _serviceFactory$getSe = serviceFactory.getService([
            (0, $a3rI2.LOGGING_SERVICE),
            (0, $a3rI2.CONFIG_SERVICE)
        ]), loggingService = _serviceFactory$getSe[0], configService = _serviceFactory$getSe[1];
        return new (0, $1N8XZ.default)(loggingService, configService);
    };
    (0, $7jITz.serviceCreators)[0, $a3rI2.PERFORMANCE_MONITORING] = function(serviceFactory) {
        var _serviceFactory$getSe2 = serviceFactory.getService([
            (0, $a3rI2.APM_SERVER),
            (0, $a3rI2.CONFIG_SERVICE),
            (0, $a3rI2.LOGGING_SERVICE),
            (0, $a3rI2.TRANSACTION_SERVICE)
        ]), apmServer = _serviceFactory$getSe2[0], configService = _serviceFactory$getSe2[1], loggingService = _serviceFactory$getSe2[2], transactionService = _serviceFactory$getSe2[3];
        return new (0, $3LUpG.default)(apmServer, configService, loggingService, transactionService);
    };
}

});
parcelRegister("3LUpG", function(module, exports) {

$parcel$export(module.exports, "default", () => $2bf185667d4e3823$export$2e2bcd8739ae039);

var $la17Z = parcelRequire("la17Z");

var $7HOQt = parcelRequire("7HOQt");

var $3tnfy = parcelRequire("3tnfy");

var $3q6JU = parcelRequire("3q6JU");

var $a3rI2 = parcelRequire("a3rI2");

var $YDh6C = parcelRequire("YDh6C");

var $dgsvq = parcelRequire("dgsvq");
var $2bf185667d4e3823$var$SIMILAR_SPAN_TO_TRANSACTION_RATIO = 0.05;
var $2bf185667d4e3823$var$TRANSACTION_DURATION_THRESHOLD = 60000;
function $2bf185667d4e3823$export$82a182639eda9ace(originalSpans, transDuration, threshold) {
    originalSpans.sort(function(spanA, spanB) {
        return spanA._start - spanB._start;
    });
    var spans = [];
    var lastCount = 1;
    originalSpans.forEach(function(span, index) {
        if (spans.length === 0) spans.push(span);
        else {
            var lastSpan = spans[spans.length - 1];
            var isContinuouslySimilar = lastSpan.type === span.type && lastSpan.subtype === span.subtype && lastSpan.action === span.action && lastSpan.name === span.name && span.duration() / transDuration < threshold && (span._start - lastSpan._end) / transDuration < threshold;
            var isLastSpan = originalSpans.length === index + 1;
            if (isContinuouslySimilar) {
                lastCount++;
                lastSpan._end = span._end;
            }
            if (lastCount > 1 && (!isContinuouslySimilar || isLastSpan)) {
                lastSpan.name = lastCount + "x " + lastSpan.name;
                lastCount = 1;
            }
            if (!isContinuouslySimilar) spans.push(span);
        }
    });
    return spans;
}
function $2bf185667d4e3823$export$e5fabcf37bedf526(transaction) {
    if (transaction.sampled) {
        var filterdSpans = transaction.spans.filter(function(span) {
            return span.duration() > 0 && span._start >= transaction._start && span._end <= transaction._end;
        });
        if (transaction.isManaged()) {
            var duration = transaction.duration();
            var similarSpans = $2bf185667d4e3823$export$82a182639eda9ace(filterdSpans, duration, $2bf185667d4e3823$var$SIMILAR_SPAN_TO_TRANSACTION_RATIO);
            transaction.spans = similarSpans;
        } else transaction.spans = filterdSpans;
    } else transaction.resetFields();
    return transaction;
}
var $2bf185667d4e3823$export$2e2bcd8739ae039 = function() {
    function PerformanceMonitoring(apmServer, configService, loggingService, transactionService) {
        this._apmServer = apmServer;
        this._configService = configService;
        this._logginService = loggingService;
        this._transactionService = transactionService;
    }
    var _proto = PerformanceMonitoring.prototype;
    _proto.init = function init(flags) {
        var _this = this;
        if (flags === void 0) flags = {};
        this._configService.events.observe((0, $a3rI2.TRANSACTION_END) + (0, $a3rI2.AFTER_EVENT), function(tr) {
            var payload = _this.createTransactionPayload(tr);
            if (payload) {
                _this._apmServer.addTransaction(payload);
                _this._configService.dispatchEvent((0, $a3rI2.QUEUE_ADD_TRANSACTION));
            }
        });
        if (flags[0, $a3rI2.HISTORY]) (0, $3tnfy.patchEventHandler).observe((0, $a3rI2.HISTORY), this.getHistorySub());
        if (flags[0, $a3rI2.XMLHTTPREQUEST]) (0, $3tnfy.patchEventHandler).observe((0, $a3rI2.XMLHTTPREQUEST), this.getXHRSub());
        if (flags[0, $a3rI2.FETCH]) (0, $3tnfy.patchEventHandler).observe((0, $a3rI2.FETCH), this.getFetchSub());
    };
    _proto.getHistorySub = function getHistorySub() {
        var transactionService = this._transactionService;
        return function(event, task) {
            if (task.source === (0, $a3rI2.HISTORY) && event === (0, $a3rI2.INVOKE)) transactionService.startTransaction(task.data.title, "route-change", {
                managed: true,
                canReuse: true
            });
        };
    };
    _proto.getXHRSub = function getXHRSub() {
        var _this2 = this;
        return function(event, task) {
            if (task.source === (0, $a3rI2.XMLHTTPREQUEST) && !(0, $3q6JU.globalState).fetchInProgress) _this2.processAPICalls(event, task);
        };
    };
    _proto.getFetchSub = function getFetchSub() {
        var _this3 = this;
        return function(event, task) {
            if (task.source === (0, $a3rI2.FETCH)) _this3.processAPICalls(event, task);
        };
    };
    _proto.processAPICalls = function processAPICalls(event, task) {
        var configService = this._configService;
        var transactionService = this._transactionService;
        if (task.data && task.data.url) {
            var endpoints = this._apmServer.getEndpoints();
            var isOwnEndpoint = Object.keys(endpoints).some(function(endpoint) {
                return task.data.url.indexOf(endpoints[endpoint]) !== -1;
            });
            if (isOwnEndpoint) return;
        }
        if (event === (0, $a3rI2.SCHEDULE) && task.data) {
            var data = task.data;
            var requestUrl = new (0, $7HOQt.Url)(data.url);
            var spanName = data.method + " " + (requestUrl.relative ? requestUrl.path : (0, $la17Z.stripQueryStringFromUrl)(requestUrl.href));
            if (!transactionService.getCurrentTransaction()) transactionService.startTransaction(spanName, (0, $a3rI2.HTTP_REQUEST_TYPE), {
                managed: true
            });
            var span = transactionService.startSpan(spanName, "external.http", {
                blocking: true
            });
            if (!span) return;
            var isDtEnabled = configService.get("distributedTracing");
            var dtOrigins = configService.get("distributedTracingOrigins");
            var currentUrl = new (0, $7HOQt.Url)(window.location.href);
            var isSameOrigin = (0, $la17Z.checkSameOrigin)(requestUrl.origin, currentUrl.origin) || (0, $la17Z.checkSameOrigin)(requestUrl.origin, dtOrigins);
            var target = data.target;
            if (isDtEnabled && isSameOrigin && target) {
                this.injectDtHeader(span, target);
                var propagateTracestate = configService.get("propagateTracestate");
                if (propagateTracestate) this.injectTSHeader(span, target);
            } else if (0, $dgsvq.__DEV__) this._logginService.debug("Could not inject distributed tracing header to the request origin ('" + requestUrl.origin + "') from the current origin ('" + currentUrl.origin + "')");
            if (data.sync) span.sync = data.sync;
            data.span = span;
        } else if (event === (0, $a3rI2.INVOKE)) {
            var _data = task.data;
            if (_data && _data.span) {
                var _span = _data.span, response = _data.response, _target = _data.target;
                var status;
                if (response) status = response.status;
                else status = _target.status;
                var outcome;
                if (_data.status != "abort" && !_data.aborted) {
                    if (status >= 400 || status == 0) outcome = (0, $a3rI2.OUTCOME_FAILURE);
                    else outcome = (0, $a3rI2.OUTCOME_SUCCESS);
                } else outcome = (0, $a3rI2.OUTCOME_UNKNOWN);
                _span.outcome = outcome;
                var tr = transactionService.getCurrentTransaction();
                if (tr && tr.type === (0, $a3rI2.HTTP_REQUEST_TYPE)) tr.outcome = outcome;
                transactionService.endSpan(_span, _data);
            }
        }
    };
    _proto.injectDtHeader = function injectDtHeader(span, target) {
        var headerName = this._configService.get("distributedTracingHeaderName");
        var headerValue = (0, $la17Z.getDtHeaderValue)(span);
        var isHeaderValid = (0, $la17Z.isDtHeaderValid)(headerValue);
        if (isHeaderValid && headerValue && headerName) (0, $la17Z.setRequestHeader)(target, headerName, headerValue);
    };
    _proto.injectTSHeader = function injectTSHeader(span, target) {
        var headerValue = (0, $la17Z.getTSHeaderValue)(span);
        if (headerValue) (0, $la17Z.setRequestHeader)(target, "tracestate", headerValue);
    };
    _proto.extractDtHeader = function extractDtHeader(target) {
        var configService = this._configService;
        var headerName = configService.get("distributedTracingHeaderName");
        if (target) return (0, $la17Z.parseDtHeaderValue)(target[headerName]);
    };
    _proto.filterTransaction = function filterTransaction(tr) {
        var duration = tr.duration();
        if (!duration) {
            if (0, $dgsvq.__DEV__) {
                var message = "transaction(" + tr.id + ", " + tr.name + ") was discarded! ";
                if (duration === 0) message += "Transaction duration is 0";
                else message += "Transaction wasn't ended";
                this._logginService.debug(message);
            }
            return false;
        }
        if (tr.isManaged()) {
            if (duration > $2bf185667d4e3823$var$TRANSACTION_DURATION_THRESHOLD) {
                if (0, $dgsvq.__DEV__) this._logginService.debug("transaction(" + tr.id + ", " + tr.name + ") was discarded! Transaction duration (" + duration + ") is greater than managed transaction threshold (" + $2bf185667d4e3823$var$TRANSACTION_DURATION_THRESHOLD + ")");
                return false;
            }
            if (tr.sampled && tr.spans.length === 0) {
                if (0, $dgsvq.__DEV__) this._logginService.debug("transaction(" + tr.id + ", " + tr.name + ") was discarded! Transaction does not have any spans");
                return false;
            }
        }
        return true;
    };
    _proto.createTransactionDataModel = function createTransactionDataModel(transaction) {
        var transactionStart = transaction._start;
        var spans = transaction.spans.map(function(span) {
            var spanData = {
                id: span.id,
                transaction_id: transaction.id,
                parent_id: span.parentId || transaction.id,
                trace_id: transaction.traceId,
                name: span.name,
                type: span.type,
                subtype: span.subtype,
                action: span.action,
                sync: span.sync,
                start: parseInt(span._start - transactionStart),
                duration: span.duration(),
                context: span.context,
                outcome: span.outcome,
                sample_rate: span.sampleRate
            };
            return (0, $YDh6C.truncateModel)((0, $YDh6C.SPAN_MODEL), spanData);
        });
        var transactionData = {
            id: transaction.id,
            trace_id: transaction.traceId,
            session: transaction.session,
            name: transaction.name,
            type: transaction.type,
            duration: transaction.duration(),
            spans: spans,
            context: transaction.context,
            marks: transaction.marks,
            breakdown: transaction.breakdownTimings,
            span_count: {
                started: spans.length
            },
            sampled: transaction.sampled,
            sample_rate: transaction.sampleRate,
            experience: transaction.experience,
            outcome: transaction.outcome
        };
        return (0, $YDh6C.truncateModel)((0, $YDh6C.TRANSACTION_MODEL), transactionData);
    };
    _proto.createTransactionPayload = function createTransactionPayload(transaction) {
        var adjustedTransaction = $2bf185667d4e3823$export$e5fabcf37bedf526(transaction);
        var filtered = this.filterTransaction(adjustedTransaction);
        if (filtered) return this.createTransactionDataModel(transaction);
    };
    return PerformanceMonitoring;
}();

});

parcelRegister("1N8XZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $14e1529f406f5f89$export$2e2bcd8739ae039);

var $lnGft = parcelRequire("lnGft");

var $cl6Rd = parcelRequire("cl6Rd");

var $SnFkZ = parcelRequire("SnFkZ");

var $la17Z = parcelRequire("la17Z");

var $bcTuV = parcelRequire("bcTuV");

var $a3rI2 = parcelRequire("a3rI2");

var $671fv = parcelRequire("671fv");

var $dgsvq = parcelRequire("dgsvq");

var $7HOQt = parcelRequire("7HOQt");
var $14e1529f406f5f89$var$TransactionService = function() {
    function TransactionService(logger, config) {
        var _this = this;
        this._config = config;
        this._logger = logger;
        this.currentTransaction = undefined;
        this.respIntervalId = undefined;
        this.recorder = new (0, $SnFkZ.PerfEntryRecorder)(function(list) {
            var tr = _this.getCurrentTransaction();
            if (tr && tr.captureTimings) {
                var _tr$spans;
                var isHardNavigation = tr.type === (0, $a3rI2.PAGE_LOAD);
                var _captureObserverEntri = (0, $SnFkZ.captureObserverEntries)(list, {
                    isHardNavigation: isHardNavigation,
                    trStart: isHardNavigation ? 0 : tr._start
                }), spans = _captureObserverEntri.spans, marks = _captureObserverEntri.marks;
                (_tr$spans = tr.spans).push.apply(_tr$spans, spans);
                tr.addMarks({
                    agent: marks
                });
            }
        });
    }
    var _proto = TransactionService.prototype;
    _proto.createCurrentTransaction = function createCurrentTransaction(name, type, options) {
        var tr = new (0, $cl6Rd.default)(name, type, options);
        this.currentTransaction = tr;
        return tr;
    };
    _proto.getCurrentTransaction = function getCurrentTransaction() {
        if (this.currentTransaction && !this.currentTransaction.ended) return this.currentTransaction;
    };
    _proto.createOptions = function createOptions(options) {
        var config = this._config.config;
        var presetOptions = {
            transactionSampleRate: config.transactionSampleRate
        };
        var perfOptions = (0, $la17Z.extend)(presetOptions, options);
        if (perfOptions.managed) perfOptions = (0, $la17Z.extend)({
            pageLoadTraceId: config.pageLoadTraceId,
            pageLoadSampled: config.pageLoadSampled,
            pageLoadSpanId: config.pageLoadSpanId,
            pageLoadTransactionName: config.pageLoadTransactionName
        }, perfOptions);
        return perfOptions;
    };
    _proto.startManagedTransaction = function startManagedTransaction(name, type, perfOptions) {
        var tr = this.getCurrentTransaction();
        var isRedefined = false;
        if (!tr) tr = this.createCurrentTransaction(name, type, perfOptions);
        else if (tr.canReuse() && perfOptions.canReuse) {
            var redefineType = tr.type;
            var currentTypeOrder = (0, $a3rI2.TRANSACTION_TYPE_ORDER).indexOf(tr.type);
            var redefineTypeOrder = (0, $a3rI2.TRANSACTION_TYPE_ORDER).indexOf(type);
            if (currentTypeOrder >= 0 && redefineTypeOrder < currentTypeOrder) redefineType = type;
            if (0, $dgsvq.__DEV__) this._logger.debug("redefining transaction(" + tr.id + ", " + tr.name + ", " + tr.type + ")", "to", "(" + (name || tr.name) + ", " + redefineType + ")", tr);
            tr.redefine(name, redefineType, perfOptions);
            isRedefined = true;
        } else {
            if (0, $dgsvq.__DEV__) this._logger.debug("ending previous transaction(" + tr.id + ", " + tr.name + ")", tr);
            tr.end();
            tr = this.createCurrentTransaction(name, type, perfOptions);
        }
        if (tr.type === (0, $a3rI2.PAGE_LOAD)) {
            if (!isRedefined) {
                this.recorder.start((0, $a3rI2.LARGEST_CONTENTFUL_PAINT));
                this.recorder.start((0, $a3rI2.PAINT));
                this.recorder.start((0, $a3rI2.FIRST_INPUT));
                this.recorder.start((0, $a3rI2.LAYOUT_SHIFT));
            }
            if (perfOptions.pageLoadTraceId) tr.traceId = perfOptions.pageLoadTraceId;
            if (perfOptions.pageLoadSampled) tr.sampled = perfOptions.pageLoadSampled;
            if (tr.name === (0, $a3rI2.NAME_UNKNOWN) && perfOptions.pageLoadTransactionName) tr.name = perfOptions.pageLoadTransactionName;
        }
        if (!isRedefined && this._config.get("monitorLongtasks")) this.recorder.start((0, $a3rI2.LONG_TASK));
        if (tr.sampled) tr.captureTimings = true;
        return tr;
    };
    _proto.startTransaction = function startTransaction(name, type, options) {
        var _this2 = this;
        var perfOptions = this.createOptions(options);
        var tr;
        var fireOnstartHook = true;
        if (perfOptions.managed) {
            var current = this.currentTransaction;
            tr = this.startManagedTransaction(name, type, perfOptions);
            if (current === tr) fireOnstartHook = false;
        } else tr = new (0, $cl6Rd.default)(name, type, perfOptions);
        tr.onEnd = function() {
            return _this2.handleTransactionEnd(tr);
        };
        if (fireOnstartHook) {
            if (0, $dgsvq.__DEV__) this._logger.debug("startTransaction(" + tr.id + ", " + tr.name + ", " + tr.type + ")");
            this._config.events.send((0, $a3rI2.TRANSACTION_START), [
                tr
            ]);
        }
        return tr;
    };
    _proto.handleTransactionEnd = function handleTransactionEnd(tr) {
        var _this3 = this;
        this.recorder.stop();
        var currentUrl = window.location.href;
        return (0, $lnGft.Promise).resolve().then(function() {
            var name = tr.name, type = tr.type;
            var lastHiddenStart = (0, $dgsvq.state).lastHiddenStart;
            if (lastHiddenStart >= tr._start) {
                if (0, $dgsvq.__DEV__) _this3._logger.debug("transaction(" + tr.id + ", " + name + ", " + type + ") was discarded! The page was hidden during the transaction!");
                return;
            }
            if (_this3.shouldIgnoreTransaction(name) || type === (0, $a3rI2.TEMPORARY_TYPE)) {
                if (0, $dgsvq.__DEV__) _this3._logger.debug("transaction(" + tr.id + ", " + name + ", " + type + ") is ignored");
                return;
            }
            if (type === (0, $a3rI2.PAGE_LOAD)) {
                var pageLoadTransactionName = _this3._config.get("pageLoadTransactionName");
                if (name === (0, $a3rI2.NAME_UNKNOWN) && pageLoadTransactionName) tr.name = pageLoadTransactionName;
                if (tr.captureTimings) {
                    var cls = (0, $SnFkZ.metrics).cls, fid = (0, $SnFkZ.metrics).fid, tbt = (0, $SnFkZ.metrics).tbt, longtask = (0, $SnFkZ.metrics).longtask;
                    if (tbt.duration > 0) tr.spans.push((0, $SnFkZ.createTotalBlockingTimeSpan)(tbt));
                    tr.experience = {};
                    if ((0, $la17Z.isPerfTypeSupported)((0, $a3rI2.LONG_TASK))) tr.experience.tbt = tbt.duration;
                    if ((0, $la17Z.isPerfTypeSupported)((0, $a3rI2.LAYOUT_SHIFT))) tr.experience.cls = cls.score;
                    if (fid > 0) tr.experience.fid = fid;
                    if (longtask.count > 0) tr.experience.longtask = {
                        count: longtask.count,
                        sum: longtask.duration,
                        max: longtask.max
                    };
                }
                _this3.setSession(tr);
            }
            if (tr.name === (0, $a3rI2.NAME_UNKNOWN)) tr.name = (0, $7HOQt.slugifyUrl)(currentUrl);
            (0, $bcTuV.captureNavigation)(tr);
            _this3.adjustTransactionTime(tr);
            var breakdownMetrics = _this3._config.get("breakdownMetrics");
            if (breakdownMetrics) tr.captureBreakdown();
            var configContext = _this3._config.get("context");
            (0, $671fv.addTransactionContext)(tr, configContext);
            _this3._config.events.send((0, $a3rI2.TRANSACTION_END), [
                tr
            ]);
            if (0, $dgsvq.__DEV__) _this3._logger.debug("end transaction(" + tr.id + ", " + tr.name + ", " + tr.type + ")", tr);
        }, function(err) {
            if (0, $dgsvq.__DEV__) _this3._logger.debug("error ending transaction(" + tr.id + ", " + tr.name + ")", err);
        });
    };
    _proto.setSession = function setSession(tr) {
        var session = this._config.get("session");
        if (session) {
            if (typeof session == "boolean") tr.session = {
                id: (0, $la17Z.generateRandomId)(16),
                sequence: 1
            };
            else if (session.timestamp && Date.now() - session.timestamp > (0, $a3rI2.SESSION_TIMEOUT)) tr.session = {
                id: (0, $la17Z.generateRandomId)(16),
                sequence: 1
            };
            else tr.session = {
                id: session.id,
                sequence: session.sequence ? session.sequence + 1 : 1
            };
            var sessionConfig = {
                session: {
                    id: tr.session.id,
                    sequence: tr.session.sequence,
                    timestamp: Date.now()
                }
            };
            this._config.setConfig(sessionConfig);
            this._config.setLocalConfig(sessionConfig, true);
        }
    };
    _proto.adjustTransactionTime = function adjustTransactionTime(transaction) {
        var spans = transaction.spans;
        var earliestSpan = (0, $la17Z.getEarliestSpan)(spans);
        if (earliestSpan && earliestSpan._start < transaction._start) transaction._start = earliestSpan._start;
        var latestSpan = (0, $la17Z.getLatestNonXHRSpan)(spans) || {};
        var latestSpanEnd = latestSpan._end || 0;
        if (transaction.type === (0, $a3rI2.PAGE_LOAD)) {
            var transactionEndWithoutDelay = transaction._end - (0, $a3rI2.PAGE_LOAD_DELAY);
            var lcp = (0, $SnFkZ.metrics).lcp || 0;
            var latestXHRSpan = (0, $la17Z.getLatestXHRSpan)(spans) || {};
            var latestXHRSpanEnd = latestXHRSpan._end || 0;
            transaction._end = Math.max(latestSpanEnd, latestXHRSpanEnd, lcp, transactionEndWithoutDelay);
        } else if (latestSpanEnd > transaction._end) transaction._end = latestSpanEnd;
        this.truncateSpans(spans, transaction._end);
    };
    _proto.truncateSpans = function truncateSpans(spans, transactionEnd) {
        for(var i = 0; i < spans.length; i++){
            var span = spans[i];
            if (span._end > transactionEnd) {
                span._end = transactionEnd;
                span.type += (0, $a3rI2.TRUNCATED_TYPE);
            }
            if (span._start > transactionEnd) span._start = transactionEnd;
        }
    };
    _proto.shouldIgnoreTransaction = function shouldIgnoreTransaction(transactionName) {
        var ignoreList = this._config.get("ignoreTransactions");
        if (ignoreList && ignoreList.length) for(var i = 0; i < ignoreList.length; i++){
            var element = ignoreList[i];
            if (typeof element.test === "function") {
                if (element.test(transactionName)) return true;
            } else if (element === transactionName) return true;
        }
        return false;
    };
    _proto.startSpan = function startSpan(name, type, options) {
        var tr = this.getCurrentTransaction();
        if (!tr) tr = this.createCurrentTransaction(undefined, (0, $a3rI2.TEMPORARY_TYPE), this.createOptions({
            canReuse: true,
            managed: true
        }));
        var span = tr.startSpan(name, type, options);
        if (0, $dgsvq.__DEV__) this._logger.debug("startSpan(" + name + ", " + span.type + ")", "on transaction(" + tr.id + ", " + tr.name + ")");
        return span;
    };
    _proto.endSpan = function endSpan(span, context) {
        if (!span) return;
        if (0, $dgsvq.__DEV__) {
            var tr = this.getCurrentTransaction();
            tr && this._logger.debug("endSpan(" + span.name + ", " + span.type + ")", "on transaction(" + tr.id + ", " + tr.name + ")");
        }
        span.end(null, context);
    };
    return TransactionService;
}();
var $14e1529f406f5f89$export$2e2bcd8739ae039 = $14e1529f406f5f89$var$TransactionService;

});
parcelRegister("cl6Rd", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fbcc3e89ca9258d$export$2e2bcd8739ae039);

var $1a2MJ = parcelRequire("1a2MJ");

var $7kikK = parcelRequire("7kikK");

var $la17Z = parcelRequire("la17Z");

var $a3rI2 = parcelRequire("a3rI2");

var $831VT = parcelRequire("831VT");
function $8fbcc3e89ca9258d$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $8fbcc3e89ca9258d$var$_setPrototypeOf(subClass, superClass);
}
function $8fbcc3e89ca9258d$var$_setPrototypeOf(o, p) {
    $8fbcc3e89ca9258d$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $8fbcc3e89ca9258d$var$_setPrototypeOf(o, p);
}
var $8fbcc3e89ca9258d$var$Transaction = function(_SpanBase) {
    $8fbcc3e89ca9258d$var$_inheritsLoose(Transaction, _SpanBase);
    function Transaction(name, type, options) {
        var _this;
        _this = _SpanBase.call(this, name, type, options) || this;
        _this.traceId = (0, $la17Z.generateRandomId)();
        _this.marks = undefined;
        _this.spans = [];
        _this._activeSpans = {};
        _this._activeTasks = new Set();
        _this.blocked = false;
        _this.captureTimings = false;
        _this.breakdownTimings = [];
        _this.sampleRate = _this.options.transactionSampleRate;
        _this.sampled = Math.random() <= _this.sampleRate;
        return _this;
    }
    var _proto = Transaction.prototype;
    _proto.addMarks = function addMarks(obj) {
        this.marks = (0, $la17Z.merge)(this.marks || {}, obj);
    };
    _proto.mark = function mark(key) {
        var skey = (0, $la17Z.removeInvalidChars)(key);
        var markTime = (0, $la17Z.now)() - this._start;
        var custom = {};
        custom[skey] = markTime;
        this.addMarks({
            custom: custom
        });
    };
    _proto.canReuse = function canReuse() {
        var threshold = this.options.reuseThreshold || (0, $a3rI2.REUSABILITY_THRESHOLD);
        return !!this.options.canReuse && !this.ended && (0, $la17Z.now)() - this._start < threshold;
    };
    _proto.redefine = function redefine(name, type, options) {
        if (name) this.name = name;
        if (type) this.type = type;
        if (options) {
            this.options.reuseThreshold = options.reuseThreshold;
            (0, $la17Z.extend)(this.options, options);
        }
    };
    _proto.startSpan = function startSpan(name, type, options) {
        var _this2 = this;
        if (this.ended) return;
        var opts = (0, $la17Z.extend)({}, options);
        opts.onEnd = function(trc) {
            _this2._onSpanEnd(trc);
        };
        opts.traceId = this.traceId;
        opts.sampled = this.sampled;
        opts.sampleRate = this.sampleRate;
        if (!opts.parentId) opts.parentId = this.id;
        var span = new (0, $1a2MJ.default)(name, type, opts);
        this._activeSpans[span.id] = span;
        if (opts.blocking) this.addTask(span.id);
        return span;
    };
    _proto.isFinished = function isFinished() {
        return !this.blocked && this._activeTasks.size === 0;
    };
    _proto.detectFinish = function detectFinish() {
        if (this.isFinished()) this.end();
    };
    _proto.end = function end(endTime) {
        if (this.ended) return;
        this.ended = true;
        this._end = (0, $la17Z.getTime)(endTime);
        for(var sid in this._activeSpans){
            var span = this._activeSpans[sid];
            span.type = span.type + (0, $a3rI2.TRUNCATED_TYPE);
            span.end(endTime);
        }
        this.callOnEnd();
    };
    _proto.captureBreakdown = function captureBreakdown() {
        this.breakdownTimings = (0, $831VT.captureBreakdown)(this);
    };
    _proto.block = function block(flag) {
        this.blocked = flag;
        if (!this.blocked) this.detectFinish();
    };
    _proto.addTask = function addTask(taskId) {
        if (!taskId) taskId = "task-" + (0, $la17Z.generateRandomId)(16);
        this._activeTasks.add(taskId);
        return taskId;
    };
    _proto.removeTask = function removeTask(taskId) {
        var deleted = this._activeTasks.delete(taskId);
        deleted && this.detectFinish();
    };
    _proto.resetFields = function resetFields() {
        this.spans = [];
        this.sampleRate = 0;
    };
    _proto._onSpanEnd = function _onSpanEnd(span) {
        this.spans.push(span);
        delete this._activeSpans[span.id];
        this.removeTask(span.id);
    };
    _proto.isManaged = function isManaged() {
        return !!this.options.managed;
    };
    return Transaction;
}((0, $7kikK.default));
var $8fbcc3e89ca9258d$export$2e2bcd8739ae039 = $8fbcc3e89ca9258d$var$Transaction;

});
parcelRegister("1a2MJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d88e2a9ffd23fee$export$2e2bcd8739ae039);

var $7kikK = parcelRequire("7kikK");

var $671fv = parcelRequire("671fv");
function $0d88e2a9ffd23fee$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $0d88e2a9ffd23fee$var$_setPrototypeOf(subClass, superClass);
}
function $0d88e2a9ffd23fee$var$_setPrototypeOf(o, p) {
    $0d88e2a9ffd23fee$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0d88e2a9ffd23fee$var$_setPrototypeOf(o, p);
}
var $0d88e2a9ffd23fee$var$Span = function(_SpanBase) {
    $0d88e2a9ffd23fee$var$_inheritsLoose(Span, _SpanBase);
    function Span(name, type, options) {
        var _this;
        _this = _SpanBase.call(this, name, type, options) || this;
        _this.parentId = _this.options.parentId;
        _this.subtype = undefined;
        _this.action = undefined;
        if (_this.type.indexOf(".") !== -1) {
            var fields = _this.type.split(".", 3);
            _this.type = fields[0];
            _this.subtype = fields[1];
            _this.action = fields[2];
        }
        _this.sync = _this.options.sync;
        return _this;
    }
    var _proto = Span.prototype;
    _proto.end = function end(endTime, data) {
        _SpanBase.prototype.end.call(this, endTime);
        (0, $671fv.addSpanContext)(this, data);
    };
    return Span;
}((0, $7kikK.default));
var $0d88e2a9ffd23fee$export$2e2bcd8739ae039 = $0d88e2a9ffd23fee$var$Span;

});
parcelRegister("7kikK", function(module, exports) {

$parcel$export(module.exports, "default", () => $55589f524383c379$export$2e2bcd8739ae039);

var $la17Z = parcelRequire("la17Z");

var $a3rI2 = parcelRequire("a3rI2");
var $55589f524383c379$var$SpanBase = function() {
    function SpanBase(name, type, options) {
        if (options === void 0) options = {};
        if (!name) name = (0, $a3rI2.NAME_UNKNOWN);
        if (!type) type = (0, $a3rI2.TYPE_CUSTOM);
        this.name = name;
        this.type = type;
        this.options = options;
        this.id = options.id || (0, $la17Z.generateRandomId)(16);
        this.traceId = options.traceId;
        this.sampled = options.sampled;
        this.sampleRate = options.sampleRate;
        this.timestamp = options.timestamp;
        this._start = (0, $la17Z.getTime)(options.startTime);
        this._end = undefined;
        this.ended = false;
        this.outcome = undefined;
        this.onEnd = options.onEnd;
    }
    var _proto = SpanBase.prototype;
    _proto.ensureContext = function ensureContext() {
        if (!this.context) this.context = {};
    };
    _proto.addLabels = function addLabels(tags) {
        this.ensureContext();
        var ctx = this.context;
        if (!ctx.tags) ctx.tags = {};
        var keys = Object.keys(tags);
        keys.forEach(function(k) {
            return (0, $la17Z.setLabel)(k, tags[k], ctx.tags);
        });
    };
    _proto.addContext = function addContext() {
        for(var _len = arguments.length, context = new Array(_len), _key = 0; _key < _len; _key++)context[_key] = arguments[_key];
        if (context.length === 0) return;
        this.ensureContext();
        (0, $la17Z.merge).apply(void 0, [
            this.context
        ].concat(context));
    };
    _proto.end = function end(endTime) {
        if (this.ended) return;
        this.ended = true;
        this._end = (0, $la17Z.getTime)(endTime);
        this.callOnEnd();
    };
    _proto.callOnEnd = function callOnEnd() {
        if (typeof this.onEnd === "function") this.onEnd(this);
    };
    _proto.duration = function duration() {
        return (0, $la17Z.getDuration)(this._start, this._end);
    };
    return SpanBase;
}();
var $55589f524383c379$export$2e2bcd8739ae039 = $55589f524383c379$var$SpanBase;

});


parcelRegister("831VT", function(module, exports) {

$parcel$export(module.exports, "captureBreakdown", () => $5dc01a5d2bb4f7c6$export$f29e26af65381f57);

var $la17Z = parcelRequire("la17Z");

var $a3rI2 = parcelRequire("a3rI2");
var $5dc01a5d2bb4f7c6$var$pageLoadBreakdowns = [
    [
        "domainLookupStart",
        "domainLookupEnd",
        "DNS"
    ],
    [
        "connectStart",
        "connectEnd",
        "TCP"
    ],
    [
        "requestStart",
        "responseStart",
        "Request"
    ],
    [
        "responseStart",
        "responseEnd",
        "Response"
    ],
    [
        "domLoading",
        "domComplete",
        "Processing"
    ],
    [
        "loadEventStart",
        "loadEventEnd",
        "Load"
    ]
];
function $5dc01a5d2bb4f7c6$var$getValue(value) {
    return {
        value: value
    };
}
function $5dc01a5d2bb4f7c6$var$calculateSelfTime(transaction) {
    var spans = transaction.spans, _start = transaction._start, _end = transaction._end;
    if (spans.length === 0) return transaction.duration();
    spans.sort(function(span1, span2) {
        return span1._start - span2._start;
    });
    var span = spans[0];
    var spanEnd = span._end;
    var spanStart = span._start;
    var lastContinuousEnd = spanEnd;
    var selfTime = spanStart - _start;
    for(var i = 1; i < spans.length; i++){
        span = spans[i];
        spanStart = span._start;
        spanEnd = span._end;
        if (spanStart > lastContinuousEnd) {
            selfTime += spanStart - lastContinuousEnd;
            lastContinuousEnd = spanEnd;
        } else if (spanEnd > lastContinuousEnd) lastContinuousEnd = spanEnd;
    }
    if (lastContinuousEnd < _end) selfTime += _end - lastContinuousEnd;
    return selfTime;
}
function $5dc01a5d2bb4f7c6$var$groupSpans(transaction) {
    var spanMap = {};
    var transactionSelfTime = $5dc01a5d2bb4f7c6$var$calculateSelfTime(transaction);
    spanMap["app"] = {
        count: 1,
        duration: transactionSelfTime
    };
    var spans = transaction.spans;
    for(var i = 0; i < spans.length; i++){
        var span = spans[i];
        var duration = span.duration();
        if (duration === 0 || duration == null) continue;
        var type = span.type, subtype = span.subtype;
        var key = type.replace((0, $a3rI2.TRUNCATED_TYPE), "");
        if (subtype) key += "." + subtype;
        if (!spanMap[key]) spanMap[key] = {
            duration: 0,
            count: 0
        };
        spanMap[key].count++;
        spanMap[key].duration += duration;
    }
    return spanMap;
}
function $5dc01a5d2bb4f7c6$var$getSpanBreakdown(transactionDetails, _ref) {
    var details = _ref.details, _ref$count = _ref.count, count = _ref$count === void 0 ? 1 : _ref$count, duration = _ref.duration;
    return {
        transaction: transactionDetails,
        span: details,
        samples: {
            "span.self_time.count": $5dc01a5d2bb4f7c6$var$getValue(count),
            "span.self_time.sum.us": $5dc01a5d2bb4f7c6$var$getValue(duration * 1000)
        }
    };
}
function $5dc01a5d2bb4f7c6$export$f29e26af65381f57(transaction, timings) {
    if (timings === void 0) timings = (0, $la17Z.PERF).timing;
    var breakdowns = [];
    var name = transaction.name, type = transaction.type, sampled = transaction.sampled;
    var transactionDetails = {
        name: name,
        type: type
    };
    if (!sampled) return breakdowns;
    if (type === (0, $a3rI2.PAGE_LOAD) && timings) for(var i = 0; i < $5dc01a5d2bb4f7c6$var$pageLoadBreakdowns.length; i++){
        var current = $5dc01a5d2bb4f7c6$var$pageLoadBreakdowns[i];
        var start = timings[current[0]];
        var end = timings[current[1]];
        var duration = (0, $la17Z.getDuration)(start, end);
        if (duration === 0 || duration == null) continue;
        breakdowns.push($5dc01a5d2bb4f7c6$var$getSpanBreakdown(transactionDetails, {
            details: {
                type: current[2]
            },
            duration: duration
        }));
    }
    else {
        var spanMap = $5dc01a5d2bb4f7c6$var$groupSpans(transaction);
        Object.keys(spanMap).forEach(function(key) {
            var _key$split = key.split("."), type = _key$split[0], subtype = _key$split[1];
            var _spanMap$key = spanMap[key], duration = _spanMap$key.duration, count = _spanMap$key.count;
            breakdowns.push($5dc01a5d2bb4f7c6$var$getSpanBreakdown(transactionDetails, {
                details: {
                    type: type,
                    subtype: subtype
                },
                duration: duration,
                count: count
            }));
        });
    }
    return breakdowns;
}

});


parcelRegister("SnFkZ", function(module, exports) {

$parcel$export(module.exports, "metrics", () => $0a3766c8451866a8$export$b0c5c2fac8144e54);
$parcel$export(module.exports, "createTotalBlockingTimeSpan", () => $0a3766c8451866a8$export$4f167c0032dd3716);
$parcel$export(module.exports, "captureObserverEntries", () => $0a3766c8451866a8$export$9042c3a3f5ee2ee);
$parcel$export(module.exports, "PerfEntryRecorder", () => $0a3766c8451866a8$export$e105e1823c980668);

var $a3rI2 = parcelRequire("a3rI2");

var $la17Z = parcelRequire("la17Z");

var $1a2MJ = parcelRequire("1a2MJ");
var $0a3766c8451866a8$export$b0c5c2fac8144e54 = {
    fid: 0,
    fcp: 0,
    tbt: {
        start: Infinity,
        duration: 0
    },
    cls: {
        score: 0,
        firstEntryTime: Number.NEGATIVE_INFINITY,
        prevEntryTime: Number.NEGATIVE_INFINITY,
        currentSessionScore: 0
    },
    longtask: {
        count: 0,
        duration: 0,
        max: 0
    }
};
var $0a3766c8451866a8$var$LONG_TASK_THRESHOLD = 50;
function $0a3766c8451866a8$export$2bed7abe701121db(longtasks, agg) {
    var spans = [];
    for(var i = 0; i < longtasks.length; i++){
        var _longtasks$i = longtasks[i], name = _longtasks$i.name, startTime = _longtasks$i.startTime, duration = _longtasks$i.duration, attribution = _longtasks$i.attribution;
        var end = startTime + duration;
        var span = new (0, $1a2MJ.default)("Longtask(" + name + ")", (0, $a3rI2.LONG_TASK), {
            startTime: startTime
        });
        agg.count++;
        agg.duration += duration;
        agg.max = Math.max(duration, agg.max);
        if (attribution.length > 0) {
            var _attribution$ = attribution[0], _name = _attribution$.name, containerType = _attribution$.containerType, containerName = _attribution$.containerName, containerId = _attribution$.containerId;
            var customContext = {
                attribution: _name,
                type: containerType
            };
            if (containerName) customContext.name = containerName;
            if (containerId) customContext.id = containerId;
            span.addContext({
                custom: customContext
            });
        }
        span.end(end);
        spans.push(span);
    }
    return spans;
}
function $0a3766c8451866a8$export$dbb9abd64c7ad2de(fidEntries) {
    var firstInput = fidEntries[0];
    if (firstInput) {
        var startTime = firstInput.startTime, processingStart = firstInput.processingStart;
        var span = new (0, $1a2MJ.default)("First Input Delay", (0, $a3rI2.FIRST_INPUT), {
            startTime: startTime
        });
        span.end(processingStart);
        return span;
    }
}
function $0a3766c8451866a8$export$4f167c0032dd3716(tbtObject) {
    var start = tbtObject.start, duration = tbtObject.duration;
    var tbtSpan = new (0, $1a2MJ.default)("Total Blocking Time", (0, $a3rI2.LONG_TASK), {
        startTime: start
    });
    tbtSpan.end(start + duration);
    return tbtSpan;
}
function $0a3766c8451866a8$export$cdc3b71aeb75f979(longtaskEntries) {
    longtaskEntries.forEach(function(entry) {
        var name = entry.name, startTime = entry.startTime, duration = entry.duration;
        if (startTime < $0a3766c8451866a8$export$b0c5c2fac8144e54.fcp) return;
        if (name !== "self" && name.indexOf("same-origin") === -1) return;
        $0a3766c8451866a8$export$b0c5c2fac8144e54.tbt.start = Math.min($0a3766c8451866a8$export$b0c5c2fac8144e54.tbt.start, startTime);
        var blockingTime = duration - $0a3766c8451866a8$var$LONG_TASK_THRESHOLD;
        if (blockingTime > 0) $0a3766c8451866a8$export$b0c5c2fac8144e54.tbt.duration += blockingTime;
    });
}
function $0a3766c8451866a8$export$1ee9edc2f05fc2c0(clsEntries) {
    clsEntries.forEach(function(entry) {
        if (!entry.hadRecentInput && entry.value) {
            var shouldCreateNewSession = entry.startTime - $0a3766c8451866a8$export$b0c5c2fac8144e54.cls.firstEntryTime > 5000 || entry.startTime - $0a3766c8451866a8$export$b0c5c2fac8144e54.cls.prevEntryTime > 1000;
            if (shouldCreateNewSession) {
                $0a3766c8451866a8$export$b0c5c2fac8144e54.cls.firstEntryTime = entry.startTime;
                $0a3766c8451866a8$export$b0c5c2fac8144e54.cls.currentSessionScore = 0;
            }
            $0a3766c8451866a8$export$b0c5c2fac8144e54.cls.prevEntryTime = entry.startTime;
            $0a3766c8451866a8$export$b0c5c2fac8144e54.cls.currentSessionScore += entry.value;
            $0a3766c8451866a8$export$b0c5c2fac8144e54.cls.score = Math.max($0a3766c8451866a8$export$b0c5c2fac8144e54.cls.score, $0a3766c8451866a8$export$b0c5c2fac8144e54.cls.currentSessionScore);
        }
    });
}
function $0a3766c8451866a8$export$9042c3a3f5ee2ee(list, _ref) {
    var isHardNavigation = _ref.isHardNavigation, trStart = _ref.trStart;
    var longtaskEntries = list.getEntriesByType((0, $a3rI2.LONG_TASK)).filter(function(entry) {
        return entry.startTime >= trStart;
    });
    var longTaskSpans = $0a3766c8451866a8$export$2bed7abe701121db(longtaskEntries, $0a3766c8451866a8$export$b0c5c2fac8144e54.longtask);
    var result = {
        spans: longTaskSpans,
        marks: {}
    };
    if (!isHardNavigation) return result;
    var lcpEntries = list.getEntriesByType((0, $a3rI2.LARGEST_CONTENTFUL_PAINT));
    var lastLcpEntry = lcpEntries[lcpEntries.length - 1];
    if (lastLcpEntry) {
        var lcp = parseInt(lastLcpEntry.startTime);
        $0a3766c8451866a8$export$b0c5c2fac8144e54.lcp = lcp;
        result.marks.largestContentfulPaint = lcp;
    }
    var timing = (0, $la17Z.PERF).timing;
    var unloadDiff = timing.fetchStart - timing.navigationStart;
    if ((0, $la17Z.isRedirectInfoAvailable)(timing)) unloadDiff = 0;
    var fcpEntry = list.getEntriesByName((0, $a3rI2.FIRST_CONTENTFUL_PAINT))[0];
    if (fcpEntry) {
        var fcp = parseInt(unloadDiff >= 0 ? fcpEntry.startTime - unloadDiff : fcpEntry.startTime);
        $0a3766c8451866a8$export$b0c5c2fac8144e54.fcp = fcp;
        result.marks.firstContentfulPaint = fcp;
    }
    var fidEntries = list.getEntriesByType((0, $a3rI2.FIRST_INPUT));
    var fidSpan = $0a3766c8451866a8$export$dbb9abd64c7ad2de(fidEntries);
    if (fidSpan) {
        $0a3766c8451866a8$export$b0c5c2fac8144e54.fid = fidSpan.duration();
        result.spans.push(fidSpan);
    }
    $0a3766c8451866a8$export$cdc3b71aeb75f979(longtaskEntries);
    var clsEntries = list.getEntriesByType((0, $a3rI2.LAYOUT_SHIFT));
    $0a3766c8451866a8$export$1ee9edc2f05fc2c0(clsEntries);
    return result;
}
var $0a3766c8451866a8$export$e105e1823c980668 = function() {
    function PerfEntryRecorder(callback) {
        this.po = {
            observe: (0, $la17Z.noop),
            disconnect: (0, $la17Z.noop)
        };
        if (window.PerformanceObserver) this.po = new PerformanceObserver(callback);
    }
    var _proto = PerfEntryRecorder.prototype;
    _proto.start = function start(type) {
        try {
            if (!(0, $la17Z.isPerfTypeSupported)(type)) return;
            this.po.observe({
                type: type,
                buffered: true
            });
        } catch (_) {}
    };
    _proto.stop = function stop() {
        this.po.disconnect();
    };
    return PerfEntryRecorder;
}();

});

parcelRegister("bcTuV", function(module, exports) {

$parcel$export(module.exports, "captureNavigation", () => $828bdd6433dfa29c$export$ffbf565d212a6a74);

var $la17Z = parcelRequire("la17Z");

var $a3rI2 = parcelRequire("a3rI2");

var $dgsvq = parcelRequire("dgsvq");

var $bPuLz = parcelRequire("bPuLz");

var $48aCp = parcelRequire("48aCp");

var $iQvp2 = parcelRequire("iQvp2");

var $k4y37 = parcelRequire("k4y37");
function $828bdd6433dfa29c$export$ffbf565d212a6a74(transaction) {
    if (!transaction.captureTimings) {
        if (transaction.type === (0, $a3rI2.PAGE_LOAD)) transaction._start = 0;
        return;
    }
    var trEnd = transaction._end;
    if (transaction.type === (0, $a3rI2.PAGE_LOAD)) {
        if (transaction.marks && transaction.marks.custom) {
            var customMarks = transaction.marks.custom;
            Object.keys(customMarks).forEach(function(key) {
                customMarks[key] += transaction._start;
            });
        }
        var trStart = 0;
        transaction._start = trStart;
        var timings = (0, $la17Z.PERF).timing;
        var baseTime = (0, $la17Z.isRedirectInfoAvailable)(timings) ? timings.redirectStart : timings.fetchStart;
        (0, $bPuLz.createNavigationTimingSpans)(timings, baseTime, trStart, trEnd).forEach(function(span) {
            span.traceId = transaction.traceId;
            span.sampled = transaction.sampled;
            if (span.pageResponse && transaction.options.pageLoadSpanId) span.id = transaction.options.pageLoadSpanId;
            transaction.spans.push(span);
        });
        transaction.addMarks((0, $k4y37.getPageLoadMarks)(timings));
    }
    if ((0, $la17Z.isPerfTimelineSupported)()) {
        var _trStart = transaction._start;
        var resourceEntries = (0, $la17Z.PERF).getEntriesByType((0, $a3rI2.RESOURCE));
        (0, $iQvp2.createResourceTimingSpans)(resourceEntries, (0, $dgsvq.state).bootstrapTime, _trStart, trEnd).forEach(function(span) {
            return transaction.spans.push(span);
        });
        var userEntries = (0, $la17Z.PERF).getEntriesByType((0, $a3rI2.MEASURE));
        (0, $48aCp.createUserTimingSpans)(userEntries, _trStart, trEnd).forEach(function(span) {
            return transaction.spans.push(span);
        });
    }
}

});
parcelRegister("bPuLz", function(module, exports) {

$parcel$export(module.exports, "createNavigationTimingSpans", () => $89cc52a6621a84b5$export$3f88cb87ead13585);

var $1U5cw = parcelRequire("1U5cw");

var $1a2MJ = parcelRequire("1a2MJ");
var $89cc52a6621a84b5$var$eventPairs = [
    [
        "redirectStart",
        "redirectEnd",
        "Redirect"
    ],
    [
        "domainLookupStart",
        "domainLookupEnd",
        "Domain lookup"
    ],
    [
        "connectStart",
        "connectEnd",
        "Making a connection to the server"
    ],
    [
        "requestStart",
        "responseEnd",
        "Requesting and receiving the document"
    ],
    [
        "domLoading",
        "domInteractive",
        "Parsing the document, executing sync. scripts"
    ],
    [
        "domContentLoadedEventStart",
        "domContentLoadedEventEnd",
        'Fire "DOMContentLoaded" event'
    ],
    [
        "loadEventStart",
        "loadEventEnd",
        'Fire "load" event'
    ]
];
function $89cc52a6621a84b5$export$3f88cb87ead13585(timings, baseTime, trStart, trEnd) {
    var spans = [];
    for(var i = 0; i < $89cc52a6621a84b5$var$eventPairs.length; i++){
        var start = timings[$89cc52a6621a84b5$var$eventPairs[i][0]];
        var end = timings[$89cc52a6621a84b5$var$eventPairs[i][1]];
        if (!(0, $1U5cw.shouldCreateSpan)(start, end, trStart, trEnd, baseTime)) continue;
        var span = new (0, $1a2MJ.default)($89cc52a6621a84b5$var$eventPairs[i][2], "hard-navigation.browser-timing");
        var data = null;
        if ($89cc52a6621a84b5$var$eventPairs[i][0] === "requestStart") {
            span.pageResponse = true;
            data = {
                url: location.origin
            };
        }
        span._start = start - baseTime;
        span.end(end - baseTime, data);
        spans.push(span);
    }
    return spans;
}

});
parcelRegister("1U5cw", function(module, exports) {

$parcel$export(module.exports, "shouldCreateSpan", () => $162f0e2f99c5881d$export$ee8bd369faf2c186);

var $a3rI2 = parcelRequire("a3rI2");
function $162f0e2f99c5881d$export$ee8bd369faf2c186(start, end, trStart, trEnd, baseTime) {
    if (baseTime === void 0) baseTime = 0;
    return typeof start === "number" && typeof end === "number" && start >= baseTime && end > start && start - baseTime >= trStart && end - baseTime <= trEnd && end - start < (0, $a3rI2.MAX_SPAN_DURATION) && start - baseTime < (0, $a3rI2.MAX_SPAN_DURATION) && end - baseTime < (0, $a3rI2.MAX_SPAN_DURATION);
}

});


parcelRegister("48aCp", function(module, exports) {

$parcel$export(module.exports, "createUserTimingSpans", () => $302025608178b53f$export$d31d86bf4b796a11);

var $a3rI2 = parcelRequire("a3rI2");

var $1U5cw = parcelRequire("1U5cw");

var $1a2MJ = parcelRequire("1a2MJ");
function $302025608178b53f$export$d31d86bf4b796a11(entries, trStart, trEnd) {
    var userTimingSpans = [];
    for(var i = 0; i < entries.length; i++){
        var _entries$i = entries[i], name = _entries$i.name, startTime = _entries$i.startTime, duration = _entries$i.duration;
        var end = startTime + duration;
        if (duration <= (0, $a3rI2.USER_TIMING_THRESHOLD) || !(0, $1U5cw.shouldCreateSpan)(startTime, end, trStart, trEnd)) continue;
        var kind = "app";
        var span = new (0, $1a2MJ.default)(name, kind);
        span._start = startTime;
        span.end(end);
        userTimingSpans.push(span);
    }
    return userTimingSpans;
}

});

parcelRegister("iQvp2", function(module, exports) {

$parcel$export(module.exports, "createResourceTimingSpans", () => $db85714463b8d8b3$export$c7038f2b5602881b);

var $la17Z = parcelRequire("la17Z");

var $1U5cw = parcelRequire("1U5cw");

var $a3rI2 = parcelRequire("a3rI2");

var $1a2MJ = parcelRequire("1a2MJ");
function $db85714463b8d8b3$var$createResourceTimingSpan(resourceTimingEntry) {
    var name = resourceTimingEntry.name, initiatorType = resourceTimingEntry.initiatorType, startTime = resourceTimingEntry.startTime, responseEnd = resourceTimingEntry.responseEnd;
    var kind = "resource";
    if (initiatorType) kind += "." + initiatorType;
    var spanName = (0, $la17Z.stripQueryStringFromUrl)(name);
    var span = new (0, $1a2MJ.default)(spanName, kind);
    span._start = startTime;
    span.end(responseEnd, {
        url: name,
        entry: resourceTimingEntry
    });
    return span;
}
function $db85714463b8d8b3$var$isCapturedByPatching(resourceStartTime, requestPatchTime) {
    return requestPatchTime != null && resourceStartTime > requestPatchTime;
}
function $db85714463b8d8b3$var$isIntakeAPIEndpoint(url) {
    return /intake\/v\d+\/rum\/events/.test(url);
}
function $db85714463b8d8b3$export$c7038f2b5602881b(entries, requestPatchTime, trStart, trEnd) {
    var spans = [];
    for(var i = 0; i < entries.length; i++){
        var _entries$i = entries[i], initiatorType = _entries$i.initiatorType, name = _entries$i.name, startTime = _entries$i.startTime, responseEnd = _entries$i.responseEnd;
        if ((0, $a3rI2.RESOURCE_INITIATOR_TYPES).indexOf(initiatorType) === -1 || name == null) continue;
        if ((initiatorType === "xmlhttprequest" || initiatorType === "fetch") && ($db85714463b8d8b3$var$isIntakeAPIEndpoint(name) || $db85714463b8d8b3$var$isCapturedByPatching(startTime, requestPatchTime))) continue;
        if ((0, $1U5cw.shouldCreateSpan)(startTime, responseEnd, trStart, trEnd)) spans.push($db85714463b8d8b3$var$createResourceTimingSpan(entries[i]));
    }
    return spans;
}

});




parcelRegister("it0bE", function(module, exports) {

$parcel$export(module.exports, "observePageClicks", () => $d71b148739cd7ad0$export$1f926008e0357783);

var $a3rI2 = parcelRequire("a3rI2");
var $d71b148739cd7ad0$var$INTERACTIVE_SELECTOR = "a[data-transaction-name], button[data-transaction-name]";
function $d71b148739cd7ad0$export$1f926008e0357783(transactionService) {
    var clickHandler = function clickHandler(event) {
        if (event.target instanceof Element) $d71b148739cd7ad0$var$createUserInteractionTransaction(transactionService, event.target);
    };
    var eventName = "click";
    var useCapture = true;
    window.addEventListener(eventName, clickHandler, useCapture);
    return function() {
        window.removeEventListener(eventName, clickHandler, useCapture);
    };
}
function $d71b148739cd7ad0$var$createUserInteractionTransaction(transactionService, target) {
    var _getTransactionMetada = $d71b148739cd7ad0$var$getTransactionMetadata(target), transactionName = _getTransactionMetada.transactionName, context = _getTransactionMetada.context;
    var tr = transactionService.startTransaction("Click - " + transactionName, (0, $a3rI2.USER_INTERACTION), {
        managed: true,
        canReuse: true,
        reuseThreshold: 300
    });
    if (tr && context) tr.addContext(context);
}
function $d71b148739cd7ad0$var$getTransactionMetadata(target) {
    var metadata = {
        transactionName: null,
        context: null
    };
    metadata.transactionName = $d71b148739cd7ad0$var$buildTransactionName(target);
    var classes = target.getAttribute("class");
    if (classes) metadata.context = {
        custom: {
            classes: classes
        }
    };
    return metadata;
}
function $d71b148739cd7ad0$var$buildTransactionName(target) {
    var dtName = $d71b148739cd7ad0$var$findCustomTransactionName(target);
    if (dtName) return dtName;
    var tagName = target.tagName.toLowerCase();
    var name = target.getAttribute("name");
    if (!!name) return tagName + '["' + name + '"]';
    return tagName;
}
function $d71b148739cd7ad0$var$findCustomTransactionName(target) {
    if (target.closest) {
        var element = target.closest($d71b148739cd7ad0$var$INTERACTIVE_SELECTOR);
        return element ? element.dataset.transactionName : null;
    }
    return target.dataset.transactionName;
}

});

parcelRegister("dIA9N", function(module, exports) {

$parcel$export(module.exports, "observePageVisibility", () => $9fcb6e770829002a$export$469e44f8217c68b6);

var $a3rI2 = parcelRequire("a3rI2");

var $dgsvq = parcelRequire("dgsvq");

var $la17Z = parcelRequire("la17Z");
function $9fcb6e770829002a$export$469e44f8217c68b6(configService, transactionService) {
    if (document.visibilityState === "hidden") (0, $dgsvq.state).lastHiddenStart = 0;
    var visibilityChangeHandler = function visibilityChangeHandler() {
        if (document.visibilityState === "hidden") $9fcb6e770829002a$var$onPageHidden(configService, transactionService);
    };
    var pageHideHandler = function pageHideHandler() {
        return $9fcb6e770829002a$var$onPageHidden(configService, transactionService);
    };
    var useCapture = true;
    window.addEventListener("visibilitychange", visibilityChangeHandler, useCapture);
    window.addEventListener("pagehide", pageHideHandler, useCapture);
    return function() {
        window.removeEventListener("visibilitychange", visibilityChangeHandler, useCapture);
        window.removeEventListener("pagehide", pageHideHandler, useCapture);
    };
}
function $9fcb6e770829002a$var$onPageHidden(configService, transactionService) {
    var tr = transactionService.getCurrentTransaction();
    if (tr) {
        var unobserve = configService.observeEvent((0, $a3rI2.QUEUE_ADD_TRANSACTION), function() {
            configService.dispatchEvent((0, $a3rI2.QUEUE_FLUSH));
            (0, $dgsvq.state).lastHiddenStart = (0, $la17Z.now)();
            unobserve();
        });
        tr.end();
    } else {
        configService.dispatchEvent((0, $a3rI2.QUEUE_FLUSH));
        (0, $dgsvq.state).lastHiddenStart = (0, $la17Z.now)();
    }
}

});

parcelRegister("g8N01", function(module, exports) {

$parcel$export(module.exports, "getInstrumentationFlags", () => $bc0366f5517a884d$export$7852da8de47c1ce0);

var $a3rI2 = parcelRequire("a3rI2");
function $bc0366f5517a884d$export$7852da8de47c1ce0(instrument, disabledInstrumentations) {
    var _flags;
    var flags = (_flags = {}, _flags[0, $a3rI2.XMLHTTPREQUEST] = false, _flags[0, $a3rI2.FETCH] = false, _flags[0, $a3rI2.HISTORY] = false, _flags[0, $a3rI2.PAGE_LOAD] = false, _flags[0, $a3rI2.ERROR] = false, _flags[0, $a3rI2.EVENT_TARGET] = false, _flags[0, $a3rI2.CLICK] = false, _flags);
    if (!instrument) return flags;
    Object.keys(flags).forEach(function(key) {
        if (disabledInstrumentations.indexOf(key) === -1) flags[key] = true;
    });
    return flags;
}

});


parcelRegister("jbdDh", function(module, exports) {

$parcel$export(module.exports, "default", () => $df699e8778ea67bd$export$2e2bcd8739ae039);

var $a3rI2 = parcelRequire("a3rI2");
var $g8N01 = parcelRequire("g8N01");
var $it0bE = parcelRequire("it0bE");
var $dIA9N = parcelRequire("dIA9N");
var $df699e8778ea67bd$export$2e2bcd8739ae039 = function() {
    function ApmBase(serviceFactory, disable) {
        this._disable = disable;
        this.serviceFactory = serviceFactory;
        this._initialized = false;
    }
    var _proto = ApmBase.prototype;
    _proto.isEnabled = function isEnabled() {
        return !this._disable;
    };
    _proto.isActive = function isActive() {
        var configService = this.serviceFactory.getService((0, $a3rI2.CONFIG_SERVICE));
        return this.isEnabled() && this._initialized && configService.get("active");
    };
    _proto.init = function init(config) {
        var _this = this;
        if (this.isEnabled() && !this._initialized) {
            this._initialized = true;
            var _this$serviceFactory$ = this.serviceFactory.getService([
                (0, $a3rI2.CONFIG_SERVICE),
                (0, $a3rI2.LOGGING_SERVICE),
                (0, $a3rI2.TRANSACTION_SERVICE)
            ]), configService = _this$serviceFactory$[0], loggingService = _this$serviceFactory$[1], transactionService = _this$serviceFactory$[2];
            configService.setVersion("5.15.0");
            this.config(config);
            var logLevel = configService.get("logLevel");
            loggingService.setLevel(logLevel);
            var isConfigActive = configService.get("active");
            if (isConfigActive) {
                this.serviceFactory.init();
                var flags = (0, $g8N01.getInstrumentationFlags)(configService.get("instrument"), configService.get("disableInstrumentations"));
                var performanceMonitoring = this.serviceFactory.getService((0, $a3rI2.PERFORMANCE_MONITORING));
                performanceMonitoring.init(flags);
                if (flags[0, $a3rI2.ERROR]) {
                    var errorLogging = this.serviceFactory.getService((0, $a3rI2.ERROR_LOGGING));
                    errorLogging.registerListeners();
                }
                if (configService.get("session")) {
                    var localConfig = configService.getLocalConfig();
                    if (localConfig && localConfig.session) configService.setConfig({
                        session: localConfig.session
                    });
                }
                var sendPageLoad = function sendPageLoad() {
                    return flags[0, $a3rI2.PAGE_LOAD] && _this._sendPageLoadMetrics();
                };
                if (configService.get("centralConfig")) this.fetchCentralConfig().then(sendPageLoad);
                else sendPageLoad();
                (0, $dIA9N.observePageVisibility)(configService, transactionService);
                if (flags[0, $a3rI2.EVENT_TARGET] && flags[0, $a3rI2.CLICK]) (0, $it0bE.observePageClicks)(transactionService);
            } else {
                this._disable = true;
                loggingService.warn("RUM agent is inactive");
            }
        }
        return this;
    };
    _proto.fetchCentralConfig = function fetchCentralConfig() {
        var _this$serviceFactory$2 = this.serviceFactory.getService([
            (0, $a3rI2.APM_SERVER),
            (0, $a3rI2.LOGGING_SERVICE),
            (0, $a3rI2.CONFIG_SERVICE)
        ]), apmServer = _this$serviceFactory$2[0], loggingService = _this$serviceFactory$2[1], configService = _this$serviceFactory$2[2];
        return apmServer.fetchConfig(configService.get("serviceName"), configService.get("environment")).then(function(config) {
            var transactionSampleRate = config["transaction_sample_rate"];
            if (transactionSampleRate) {
                transactionSampleRate = Number(transactionSampleRate);
                var _config2 = {
                    transactionSampleRate: transactionSampleRate
                };
                var _configService$valida = configService.validate(_config2), invalid = _configService$valida.invalid;
                if (invalid.length === 0) configService.setConfig(_config2);
                else {
                    var _invalid$ = invalid[0], key = _invalid$.key, value = _invalid$.value, allowed = _invalid$.allowed;
                    loggingService.warn('invalid value "' + value + '" for ' + key + ". Allowed: " + allowed + ".");
                }
            }
            return config;
        }).catch(function(error) {
            loggingService.warn("failed fetching config:", error);
        });
    };
    _proto._sendPageLoadMetrics = function _sendPageLoadMetrics() {
        var tr = this.startTransaction(undefined, (0, $a3rI2.PAGE_LOAD), {
            managed: true,
            canReuse: true
        });
        if (!tr) return;
        tr.addTask((0, $a3rI2.PAGE_LOAD));
        var sendPageLoadMetrics = function sendPageLoadMetrics() {
            setTimeout(function() {
                return tr.removeTask((0, $a3rI2.PAGE_LOAD));
            }, (0, $a3rI2.PAGE_LOAD_DELAY));
        };
        if (document.readyState === "complete") sendPageLoadMetrics();
        else window.addEventListener("load", sendPageLoadMetrics);
    };
    _proto.observe = function observe(name, fn) {
        var configService = this.serviceFactory.getService((0, $a3rI2.CONFIG_SERVICE));
        configService.events.observe(name, fn);
    };
    _proto.config = function config(_config) {
        var _this$serviceFactory$3 = this.serviceFactory.getService([
            (0, $a3rI2.CONFIG_SERVICE),
            (0, $a3rI2.LOGGING_SERVICE)
        ]), configService = _this$serviceFactory$3[0], loggingService = _this$serviceFactory$3[1];
        var _configService$valida2 = configService.validate(_config), missing = _configService$valida2.missing, invalid = _configService$valida2.invalid, unknown = _configService$valida2.unknown;
        if (unknown.length > 0) {
            var message = "Unknown config options are specified for RUM agent: " + unknown.join(", ");
            loggingService.warn(message);
        }
        if (missing.length === 0 && invalid.length === 0) configService.setConfig(_config);
        else {
            var separator = ", ";
            var _message = "RUM agent isn't correctly configured. ";
            if (missing.length > 0) {
                _message += missing.join(separator) + " is missing";
                if (invalid.length > 0) _message += separator;
            }
            invalid.forEach(function(_ref, index) {
                var key = _ref.key, value = _ref.value, allowed = _ref.allowed;
                _message += key + ' "' + value + '" contains invalid characters! (allowed: ' + allowed + ")" + (index !== invalid.length - 1 ? separator : "");
            });
            loggingService.error(_message);
            configService.setConfig({
                active: false
            });
        }
    };
    _proto.setUserContext = function setUserContext(userContext) {
        var configService = this.serviceFactory.getService((0, $a3rI2.CONFIG_SERVICE));
        configService.setUserContext(userContext);
    };
    _proto.setCustomContext = function setCustomContext(customContext) {
        var configService = this.serviceFactory.getService((0, $a3rI2.CONFIG_SERVICE));
        configService.setCustomContext(customContext);
    };
    _proto.addLabels = function addLabels(labels) {
        var configService = this.serviceFactory.getService((0, $a3rI2.CONFIG_SERVICE));
        configService.addLabels(labels);
    };
    _proto.setInitialPageLoadName = function setInitialPageLoadName(name) {
        var configService = this.serviceFactory.getService((0, $a3rI2.CONFIG_SERVICE));
        configService.setConfig({
            pageLoadTransactionName: name
        });
    };
    _proto.startTransaction = function startTransaction(name, type, options) {
        if (this.isEnabled()) {
            var transactionService = this.serviceFactory.getService((0, $a3rI2.TRANSACTION_SERVICE));
            return transactionService.startTransaction(name, type, options);
        }
    };
    _proto.startSpan = function startSpan(name, type, options) {
        if (this.isEnabled()) {
            var transactionService = this.serviceFactory.getService((0, $a3rI2.TRANSACTION_SERVICE));
            return transactionService.startSpan(name, type, options);
        }
    };
    _proto.getCurrentTransaction = function getCurrentTransaction() {
        if (this.isEnabled()) {
            var transactionService = this.serviceFactory.getService((0, $a3rI2.TRANSACTION_SERVICE));
            return transactionService.getCurrentTransaction();
        }
    };
    _proto.captureError = function captureError(error) {
        if (this.isEnabled()) {
            var errorLogging = this.serviceFactory.getService((0, $a3rI2.ERROR_LOGGING));
            return errorLogging.logError(error);
        }
    };
    _proto.addFilter = function addFilter(fn) {
        var configService = this.serviceFactory.getService((0, $a3rI2.CONFIG_SERVICE));
        configService.addFilter(fn);
    };
    return ApmBase;
}();

});



parcelRegister("bg8Ty", function(module, exports) {

$parcel$export(module.exports, "showErrorModal", () => $832816afd25702d5$export$eb122250488b74d5);
$parcel$export(module.exports, "showValidationErrorModal", () => $832816afd25702d5$export$55acb1e880590fa5);
function $832816afd25702d5$export$eb122250488b74d5(content, showErrorImage) {
    if (!showErrorImage) $("#errorModal .modal-image-wrapper").css("display", "none");
    $("#errorModal .modal-body-content").html(content);
    $("#errorModal").modal("show");
}
function $832816afd25702d5$export$55acb1e880590fa5(content, showErrorImage) {
    if (!showErrorImage) $("#validationErrorModal .modal-image-wrapper").css("display", "none");
    $("#validationErrorModal .modal-body-content").html(content);
    $("#validationErrorModal").modal("show");
}

});



parcelRegister("76V10", function(module, exports) {
// auto-stretch textboxes in inline controls
Stretchy.selectors.filter = ".editable-value-wrapper *";
// general Unpoly setup
var $52d551fbbd13e869$var$unpolySetupFinished = false;
// Hookup EntityModule initialization with Unpoly fragments, because fragment:inserted
// also fires on the initial Unpoly bootstrap, we need to skip the first call to
// avoid intializeFormElements from being executed twice on the same nodes
up.on("up:fragment:inserted", function(event, fragment) {
    if ($52d551fbbd13e869$var$unpolySetupFinished) EntityModule.initializeFormElements(fragment);
    else $52d551fbbd13e869$var$unpolySetupFinished = true;
});
// Drawer modal - can be used for notifications
up.modal.flavors.drawer = {
    openAnimation: "move-from-right",
    closeAnimation: "move-to-right",
    position: "right"
};
up.on("up:proxy:loaded", (event)=>{
    const responseUrl = event.response.url;
    if (!!responseUrl && responseUrl.includes("login")) {
        event.preventDefault();
        location.href = responseUrl;
    }
});
$("body").tooltip({
    selector: "[data-toggle=tooltip]"
});

});

parcelRegister("gg9zr", function(module, exports) {
parcelRequire("bDi0k");
parcelRequire("7VslK");
parcelRequire("9KbvK");
parcelRequire("gSmNj");
parcelRequire("c5J35");
parcelRequire("iqYmi");
parcelRequire("6GBWH");
parcelRequire("7dAOI");
parcelRequire("f8r0C");
parcelRequire("fkLXk");
parcelRequire("iTV5B");
parcelRequire("4XgQu");
parcelRequire("34uz3");
parcelRequire("5e859");
parcelRequire("lysSP");
parcelRequire("GWkRr");
parcelRequire("aFvAO");
parcelRequire("kloe4");
parcelRequire("8adAR");
parcelRequire("4cFjd");
parcelRequire("71oKe");
parcelRequire("5CGf6");
parcelRequire("7KoNM");
parcelRequire("g49wf");

});
parcelRegister("bDi0k", function(module, exports) {

var $jwUJU = parcelRequire("jwUJU");

var $bg8Ty = parcelRequire("bg8Ty");

var $4k8rO = parcelRequire("4k8rO");
$("#tc-modal-accept-button").prop("disabled", true);
$("#tc-modal-accept-terms").on("change", function(event) {
    if ($(this).prop("checked")) $("#tc-modal-accept-button").prop("disabled", false);
    else $("#tc-modal-accept-button").prop("disabled", true);
});
$(document).on("click", "#tc-modal-logout-button", function(event) {
    window.location.href = "/logout";
});
$(document).on("click", "#tc-modal-accept-button", function(event) {
    (0, $4k8rO.showSpinner)("#tc-modal-accept-button");
    const params = {
        type: $("#documentType").val(),
        date: $("#documentDate").val()
    };
    fetch("/manager/accept-policy?", {
        method: "POST",
        headers: {
            "X-XSRF-Token": (0, $jwUJU.getCookie)("XSRF-TOKEN"),
            "Content-Type": "application/json"
        },
        body: JSON.stringify(params)
    }).then((0, $jwUJU.convertResponseToTextWithoutSettingRedirectUrl)).catch((0, $jwUJU.handleError));
});
$(document).on("click", "#tc-modal-decline-button", function(event) {
    $(".js-accept-conditions-modal").addClass("d-none");
    $(".js-accept-conditions-modal").parent().find(".modal-backdrop").remove();
    const result = document.querySelector("#decline-conditions-template").content.cloneNode(true);
    $("#errorModal .js-error-modal-title").css("display", "none");
    $("#errorModal .js-error-modal-button").css("display", "none");
    (0, $bg8Ty.showErrorModal)(result);
    $("#errorModal").css("display", "inline-block");
});
$(document).on("click", "#tc-modal-back-button", function(event) {
    $("#errorModal").css("display", "none");
    $(".js-accept-conditions-modal").removeClass("d-none");
});

});
parcelRegister("4k8rO", function(module, exports) {

$parcel$export(module.exports, "showSpinner", () => $325f952bc1760550$export$2a7a135fa1ec651f);
$parcel$export(module.exports, "hideSpinner", () => $325f952bc1760550$export$95fec50f68454318);
$parcel$export(module.exports, "showSpinnerCenter", () => $325f952bc1760550$export$b6a035018447b78c);
function $325f952bc1760550$export$2a7a135fa1ec651f(buttonId) {
    $(`${buttonId}.spinner`).addClass("show").prop("disabled", true);
}
function $325f952bc1760550$export$95fec50f68454318(buttonId) {
    $(`${buttonId}.spinner`).removeClass("show").prop("disabled", false);
}
function $325f952bc1760550$export$b6a035018447b78c(buttonId) {
    $(`${buttonId}.spinner-center`).addClass("show").prop("disabled", true);
    $(`${buttonId}.spinner-center`).html("");
}
function $325f952bc1760550$export$b4b436815cd177e(buttonId, text) {
    $(`${buttonId}.spinner-center`).removeClass("show").prop("disabled", false);
    $(`${buttonId}.spinner-center`).html("<span>" + text + "</span>");
}

});


parcelRegister("7VslK", function(module, exports) {
EntityModule.registerInitializer(function(node) {
    $("[data-ajax-load]", node).each(function(node) {
        var settings = $(this).data("ajax-load");
        $(this).on("click", function(e) {
            e.preventDefault();
            var link = $(this);
            var dialog = $('<div class="modal fade" tabindex="-1" data-backdrop="static" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true">\n  <div class="modal-dialog modal-dialog-centered" role="document">\n    <div class="modal-content">\n<div class="modal-header">\n        <h5 class="modal-title" id="staticBackdropLabel"></h5>\n        <button type="button" class="close" data-dismiss="modal" aria-label="Close">\n          <span aria-hidden="true">&times;</span>\n        </button>\n      </div>  </div>\n</div>').modal();
            $.ajax({
                type: "get",
                url: link.attr("href"),
                headers: {
                    "ax-em-partial": settings.partial,
                    "ax-em-ajax-context": "dialog"
                }
            }).done(function(data, status, request) {
                $(".modal-title", dialog).html(request.getResponseHeader("ax-em-dialog-title"));
                $(".modal-header", dialog).after($(data));
                EntityModule.initializeFormElements(dialog);
                $("#btn-cancel", dialog).on("click", function(e) {
                    e.preventDefault();
                    dialog.on("hidden.bs.modal", function(e) {
                        dialog.remove();
                    }).modal("hide");
                });
            });
        });
    });
});

});

parcelRegister("9KbvK", function(module, exports) {

var $bg8Ty = parcelRequire("bg8Ty");
const $718156cbce1cef09$var$$ = window.$;
$718156cbce1cef09$var$$("#assetModal").on("show.bs.modal", function(e) {
    $718156cbce1cef09$var$get({
        type: "get",
        url: "/manager/entities/asset?view=assetList&_partial=content"
    }, $718156cbce1cef09$var$$(e.relatedTarget).data("campaign-asset-id"));
});
$718156cbce1cef09$var$$(document).on("click", ".linkAssetToCampaignInvalid", function(e) {
    (0, $bg8Ty.showValidationErrorModal)(e.currentTarget.getAttribute("data-validation-modal-content"), true);
});
function $718156cbce1cef09$var$get(formConfig, campaignAssetId) {
    $718156cbce1cef09$var$$.ajax(formConfig).done(function(data) {
        var body = $718156cbce1cef09$var$$(document).find(".modal-body");
        body.html(data);
        $718156cbce1cef09$var$ajaxify(body, campaignAssetId);
    });
}
var $718156cbce1cef09$var$ajaxify = function(node, campaignAssetId) {
    EntityModule.initializeFormElements(node);
    $718156cbce1cef09$var$$("form", node).on("submit", function(e) {
        e.preventDefault();
        e.stopPropagation();
        $718156cbce1cef09$var$get({
            type: "get",
            url: "/manager/entities/asset?view=assetList&_partial=content",
            data: $718156cbce1cef09$var$$(this).serialize()
        });
    });
    const selectAssetBtn = $718156cbce1cef09$var$$(".js-submit-asset");
    selectAssetBtn.prop("disabled", false);
    selectAssetBtn.on("click", function(e) {
        $718156cbce1cef09$var$$(this).prop("disabled", true);
        $718156cbce1cef09$var$$(this).find(".loading").removeClass("d-none");
        var selectedCard = $718156cbce1cef09$var$$("#assetModal").find(".card.selected-asset ");
        var selectedAssetId = selectedCard.data("asset-id");
        var linkingUrl = "/manager/assets/" + campaignAssetId + "/link/" + selectedAssetId;
        var csrf = $718156cbce1cef09$var$$('[name="_csrf"]').val();
        $718156cbce1cef09$var$$.ajax({
            type: "POST",
            url: linkingUrl,
            data: {
                _csrf: csrf
            },
            success: function(e) {
                window.location.reload();
            },
            fail: function(xhr, textStatus, errorThrown) {
                alert("Failed linking the asset to the campaignRequirement. Please try again");
            }
        });
    });
};
let $718156cbce1cef09$var$propertySorter = {
    property: undefined,
    direction: undefined
};
$718156cbce1cef09$var$$(document).on("mouseover", '.js-asset-library:not(.grouped-table) thead th:not(".sortable")', function(event) {
    $718156cbce1cef09$var$$(event.target).css("color", "#0b0b0b");
    $718156cbce1cef09$var$$(event.target).css("cursor", "pointer");
});
$718156cbce1cef09$var$$(document).on("mouseleave", '.js-asset-library:not(.grouped-table) thead th:not(".sortable")', function(event) {
    $718156cbce1cef09$var$$(event.target).css("color", "#888");
});
$718156cbce1cef09$var$$(document).on("click", '.js-asset-library:not(.grouped-table) thead th:not(".sortable")', function(event) {
    const currentHeading = $718156cbce1cef09$var$$(event.target);
    const propertyToSort = currentHeading.data("tbl-field");
    if ($718156cbce1cef09$var$propertySorter.property === propertyToSort) $718156cbce1cef09$var$propertySorter.direction = $718156cbce1cef09$var$propertySorter.direction === "ASC" ? "DESC" : "ASC";
    else $718156cbce1cef09$var$propertySorter = {
        property: propertyToSort,
        direction: "ASC"
    };
    const inverse = $718156cbce1cef09$var$propertySorter.direction === "DESC";
    $718156cbce1cef09$var$$(".js-asset-library:not(.grouped-table) tbody").find("td").filter(function() {
        return $718156cbce1cef09$var$$(this).data("tbl-field") === $718156cbce1cef09$var$propertySorter.property;
    }).sortElements(function(a, b) {
        return $718156cbce1cef09$var$$.text([
            a
        ]) > $718156cbce1cef09$var$$.text([
            b
        ]) ? inverse ? -1 : 1 : inverse ? 1 : -1;
    }, function() {
        return this.parentNode;
    });
    $718156cbce1cef09$var$$(".js-asset-library:not(.grouped-table) thead th").removeClass("asc desc pseudo-sortable");
    currentHeading.addClass("pseudo-sortable " + $718156cbce1cef09$var$propertySorter.direction.toLowerCase());
});
$718156cbce1cef09$var$$(document).on("click", ".js-select-asset", function(e) {
    var card = $718156cbce1cef09$var$$(e.currentTarget);
    $718156cbce1cef09$var$$(".js-select-asset").removeClass("selected-asset");
    card.addClass("selected-asset");
    $718156cbce1cef09$var$$(".js-submit-asset").removeClass("disabled");
});

});

parcelRegister("gSmNj", function(module, exports) {
/**
 * Sets up default blade view opening and behaviour.
 */ /**
 * Calculate if the blade container must be sticky
 */ var $c4935ef610fee2ce$var$blade = document.getElementById("blade-container");
var $c4935ef610fee2ce$var$sticky = $c4935ef610fee2ce$var$blade.offsetTop;
window.onscroll = function() {
    if (window.pageYOffset > $c4935ef610fee2ce$var$sticky) $c4935ef610fee2ce$var$blade.classList.add("sticky");
    else $c4935ef610fee2ce$var$blade.classList.remove("sticky");
};
/**
 * Open the blade as soon as .blade-content is inserted.
 */ up.compiler(".blade-content", function() {
    setTimeout(function() {
        // use timeout to active the animation
        $(".page-wrapper").addClass("show-blade");
        // initialize close button
        $(".blade-header", $($c4935ef610fee2ce$var$blade)).find("button.actions-close").on("click", function(event) {
            var pageWrapper = $(".page-wrapper");
            if (pageWrapper.hasClass("show-blade")) pageWrapper.removeClass("show-blade");
        });
    });
});
/**
 * Hide the blade when the user clicks outside of it.
 * Uses mousedown as blade might be opened with 'up-instant', and else the
 * 'click' would follow the mouse down and close instantly.
 */ $(document).on("mousedown", function(event) {
    var target = $(event.target);
    var pageWrapper = $(".page-wrapper");
    if (!target.closest(".blade-wrapper").length && !target.closest(".up-modal").length && pageWrapper.hasClass("show-blade")) pageWrapper.removeClass("show-blade");
});
/**
 * Sortable table summary urls always open inside the blade.
 */ up.macro("tr[data-summary-url]", function(row) {
    row.setAttribute("up-target", ".blade-wrapper");
    row.setAttribute("up-href", row.getAttribute("data-summary-url"));
    row.setAttribute("up-restore-scroll", true);
    row.setAttribute("up-history", false);
    row.setAttribute("up-instant", "up-instant"); // load on mousedown
    row.setAttribute("up-cache", false);
});

});

parcelRegister("c5J35", function(module, exports) {

$parcel$export(module.exports, "initializeDatePickers", () => $8cd8e5686a58bdea$export$de01a5d2298a9bfb);

var $jwUJU = parcelRequire("jwUJU");
function $8cd8e5686a58bdea$export$de01a5d2298a9bfb(node) {
    if ((0, $jwUJU.getBrowser)() === "SAFARI") {
        $.datepicker.regional.en = {
            closeText: "Done",
            prevText: "Prev",
            nextText: "Next",
            currentText: "Today",
            monthNames: [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December"
            ],
            monthNamesShort: [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec"
            ],
            dayNames: [
                "Sunday",
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday"
            ],
            dayNamesShort: [
                "Sun",
                "Mon",
                "Tue",
                "Wed",
                "Thu",
                "Fri",
                "Sat"
            ],
            dayNamesMin: [
                "Su",
                "Mo",
                "Tu",
                "We",
                "Th",
                "Fr",
                "Sa"
            ],
            weekHeader: "Wk",
            dateFormat: "yy-mm-dd",
            firstDay: 1,
            isRTL: false,
            showMonthAfterYear: false,
            yearSuffix: "",
            autoClose: true,
            defaultDate: new Date()
        };
        $.datepicker.regional.nl = {
            closeText: "Sluiten",
            prevText: "Vorige",
            nextText: "Volgende",
            currentText: "Vandaag",
            monthNames: [
                "januari",
                "februari",
                "maart",
                "april",
                "mei",
                "juni",
                "juli",
                "augustus",
                "september",
                "oktober",
                "november",
                "december"
            ],
            monthNamesShort: [
                "jan",
                "feb",
                "mrt",
                "apr",
                "mei",
                "jun",
                "jul",
                "aug",
                "sep",
                "okt",
                "nov",
                "dec"
            ],
            dayNames: [
                "zondag",
                "maandag",
                "dinsdag",
                "woensdag",
                "donderdag",
                "vrijdag",
                "zaterdag"
            ],
            dayNamesShort: [
                "zon",
                "maa",
                "din",
                "woe",
                "don",
                "vri",
                "zat"
            ],
            dayNamesMin: [
                "zo",
                "ma",
                "di",
                "wo",
                "do",
                "vr",
                "za"
            ],
            weekHeader: "Wk",
            dateFormat: "yy-mm-dd",
            firstDay: 1,
            isRTL: false,
            showMonthAfterYear: false,
            yearSuffix: "",
            autoClose: true,
            defaultDate: new Date()
        };
        $.datepicker.regional.fr = {
            closeText: "Fermer",
            prevText: "Pr\xe9c\xe9dent",
            nextText: "Suivant",
            currentText: "Aujourd'hui",
            monthNames: [
                "janvier",
                "f\xe9vrier",
                "mars",
                "avril",
                "mai",
                "juin",
                "juillet",
                "ao\xfbt",
                "septembre",
                "octobre",
                "novembre",
                "d\xe9cembre"
            ],
            monthNamesShort: [
                "janv.",
                "f\xe9vr.",
                "mars",
                "avr.",
                "mai",
                "juin",
                "juil.",
                "ao\xfbt",
                "sept.",
                "oct.",
                "nov.",
                "d\xe9c."
            ],
            dayNames: [
                "dimanche",
                "lundi",
                "mardi",
                "mercredi",
                "jeudi",
                "vendredi",
                "samedi"
            ],
            dayNamesShort: [
                "dim.",
                "lun.",
                "mar.",
                "mer.",
                "jeu.",
                "ven.",
                "sam."
            ],
            dayNamesMin: [
                "D",
                "L",
                "M",
                "M",
                "J",
                "V",
                "S"
            ],
            weekHeader: "Sem.",
            dateFormat: "yy-mm-dd",
            firstDay: 1,
            isRTL: false,
            showMonthAfterYear: false,
            yearSuffix: "",
            autoClose: true,
            defaultDate: new Date()
        };
        $(".date-picker", node).each(function(idx, el) {
            const element = $(el);
            //This is necessary in order to make the datepicker work
            element.attr("id", element.attr("id") + Math.random());
            element.datepicker($.datepicker.regional[window.camalion.userLanguage]);
        });
    }
}

});

parcelRegister("iqYmi", function(module, exports) {

$parcel$export(module.exports, "updatePropertyData", () => $d6b979a95a845ae5$export$b92017fdda101fde);

var $jwUJU = parcelRequire("jwUJU");
/**
 * EditableValue is a readonly value which can be converted into an actual
 * control when clicked. The control is expected to be rendered in the
 * markup as a <script> snippet.
 *
 * If an attribute 'em-property-value-changed' is
 * set on the same node that contains the 'data-em-property-id', the control
 * will be fetched again from the server before showing it. This will cause a small delay
 * during with the class 'editable-value-reload' will be set on the wrapper element.
 */ function $d6b979a95a845ae5$var$entityPrefixOf(propertyId) {
    return propertyId.substring(0, propertyId.lastIndexOf("/") + 1);
}
function $d6b979a95a845ae5$var$propertyNameOf(propertyId) {
    return propertyId.substring(propertyId.lastIndexOf("/") + 1);
}
function $d6b979a95a845ae5$var$resolveViewElementMode(node) {
    var viewElementMode = $(node).data("em-ve-mode");
    if (viewElementMode == null) return "VALUE";
    return viewElementMode;
}
function $d6b979a95a845ae5$export$b92017fdda101fde(propertyId, propertyData) {
    $('[data-em-property-id="' + propertyId + '"]').each(function() {
        $(this).data("em-property-value-changed", true);
        var label = propertyData.labels[$d6b979a95a845ae5$var$resolveViewElementMode($(this))];
        $(this).html(label);
        EntityModule.initializeFormElements($(this));
    });
}
var $d6b979a95a845ae5$var$EDITABLE_CONTROL_WRAPPER = '<form class="editable-value-form"><div class="editable-value-control"><span data-editable-value-control="true"></span><span class="editable-value-actions"><a class="btn btn-sm" data-action="save"><i class="fas fa-check fa-fw"/></a><a class="btn btn-sm" data-action="cancel"><i class="fas fa-times fa-fw"/></a></span></div></form>';
var $d6b979a95a845ae5$var$EDITABLE_CONTROL_WRAPPER_WITHOUT_ACTIONS = '<form class="editable-value-form"><div class="editable-value-control"><span data-editable-value-control="true"></span></div></form>';
class $d6b979a95a845ae5$var$EditableValue {
    constructor(wrapper){
        this.showActions = wrapper.attr("show-actions");
        this.wrapper = wrapper;
        this.settings = wrapper.data("em-editable-value");
        this.label = $("[data-em-editable-value-role=value]", wrapper).first();
        this.controlContainer = $("[data-em-editable-value-role=control-container]", wrapper).first();
        this.propertyId = this.settings.propertyId;
        this.entityPrefix = $d6b979a95a845ae5$var$entityPrefixOf(this.settings.propertyId);
        this.propertyNameOfControl = $d6b979a95a845ae5$var$propertyNameOf(this.settings.propertyId);
    }
    activate() {
        (0, $jwUJU.ax).log.groupCollapsed("Activating editable value for " + this.propertyId);
        (0, $jwUJU.ax).log.info("Wrapper element", this.wrapper.get(0));
        (0, $jwUJU.ax).log.debug("Entity prefix:", this.entityPrefix);
        (0, $jwUJU.ax).log.debug("Property name:", this.propertyNameOfControl);
        // Activate styling when javascript hooked up
        this.wrapper.addClass("editable-value-wrapper");
        this._configureLabelHandler();
        (0, $jwUJU.ax).log.groupEnd();
    }
    _configureLabelHandler() {
        var label = this.label;
        // Configure refresh from other value updates
        label.addClass("editable-value-value").attr("data-em-property-id", this.propertyId);
        // Trigger the control reloading on mousedown, so it would fetch slightly faster if necessary
        label.on("mousedown", this._refreshControlScript.bind(this));
        label.on("click", this.switchToControl.bind(this));
    }
    _refreshControlScript() {
        if (this.isValuePossibleChanged()) {
            this.refreshBusy = true;
            var editableControl = this;
            (0, $jwUJU.ax).log.debug("Refreshing editable value control for", this.propertyId);
            $.ajax({
                type: "get",
                url: editableControl.settings.targetUrl,
                data: "&_partial=::editableValue-" + editableControl.propertyNameOfControl + "-control"
            }).done(function(data) {
                (0, $jwUJU.ax).log.debug("Updating control script for property", editableControl.propertyId);
                editableControl.controlContainer.html(data);
                editableControl.resetChangeTracking();
                editableControl.refreshBusy = false;
                if (editableControl.controlSwitchRequested) editableControl._renderControl();
            });
        }
    }
    switchToControl(event) {
        this.controlSwitchRequested = true;
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (!this.refreshBusy) this._renderControl();
        else this.wrapper.addClass("editable-value-reload");
    }
    _renderControl() {
        this.controlSwitchRequested = false;
        (0, $jwUJU.ax).log.debug("Switching to editable value control for", this.propertyId);
        this.label.addClass("d-none");
        this.wrapper.removeClass("editable-value-reload").append(this.showActions === "true" ? $d6b979a95a845ae5$var$EDITABLE_CONTROL_WRAPPER : $d6b979a95a845ae5$var$EDITABLE_CONTROL_WRAPPER_WITHOUT_ACTIONS);
        // ensure form cannot be submitted
        var controlHolder = $("form", this.wrapper);
        controlHolder.on("submit", function(e) {
            e.preventDefault();
            e.stopPropagation();
            return false;
        });
        // build the control DOM structure
        var controlScript = $("[data-em-editable-value-role=control]", this.wrapper).first();
        let $control = $("[data-editable-value-control]", controlHolder);
        $control.html(BootstrapUiModule.refTarget(controlScript).html());
        $control.data("editableValue", this);
        EntityModule.initializeFormElements($control);
        this.controlHolder = controlHolder;
        $("[data-action=cancel]", controlHolder).on("click", this._cancelControl.bind(this));
        $("[data-action=save]", controlHolder).on("click", this._updateValue.bind(this));
        // $( '[data-editable-value-control=true]', controlHolder ).on( 'focusout', ( e ) => {
        // this._cancelControl( e );
        // } );
        /**
     * Hide the blade when the user clicks outside of it.
     * Uses mousedown as blade might be opened with 'up-instant', and else the
     * 'click' would follow the mouse down and close instantly.
     */ $(document).on("mousedown", (event)=>{
            var target = $(event.target);
            if (this.controlHolder && !target.closest(".editable-value-control").length) this._cancelControl(event);
        });
    }
    // hide the control - switch back to label
    _cancelControl(e) {
        e.preventDefault();
        e.stopPropagation();
        (0, $jwUJU.ax).log.debug("Closing editable value control for", this.propertyId);
        this.label.removeClass("d-none");
        this.controlHolder.remove();
        this.controlHolder = null;
    }
    // submit the control value
    _updateValue(e) {
        e.preventDefault();
        e.stopPropagation();
        (0, $jwUJU.ax).log.group("Posting editable value update for", this.propertyId);
        var properties = this._retrieveRefreshableValuesToUpdate();
        (0, $jwUJU.ax).log.debug("Requesting refresh for properties", properties);
        var requestedPropertiesData = properties.join("&");
        var wrapper = this.wrapper;
        var entityPrefix = this.entityPrefix;
        var propertyId = this.propertyId;
        var label = this.label;
        var propertyNameOfControl = this.propertyNameOfControl;
        var controlHolder = this.controlHolder;
        controlHolder.addClass("spinner");
        let input = controlHolder.find("input");
        let select = controlHolder.find("select");
        const serializedForm = $("form", wrapper).serialize();
        input.attr("disabled", true);
        select.attr("disabled", true);
        $.ajax({
            type: "post",
            url: this.settings.targetUrl,
            data: serializedForm + "&" + requestedPropertiesData
        }).done(function(data, status, request) {
            if (data.success) {
                controlHolder.removeClass("is-invalid");
                $d6b979a95a845ae5$export$b92017fdda101fde(propertyId, data.properties[propertyNameOfControl]);
                label.removeClass("d-none");
                controlHolder.remove();
                //update absolute proerties
                $.each(data.absoluteProperties, function(propertyName, propertyData) {
                    if (propertyName !== propertyNameOfControl) $d6b979a95a845ae5$export$b92017fdda101fde(propertyName, propertyData);
                });
                // update other relative properties
                $.each(data.properties, function(propertyName, propertyData) {
                    if (propertyName !== propertyNameOfControl) $d6b979a95a845ae5$export$b92017fdda101fde(entityPrefix + propertyName, propertyData);
                });
            } else {
                controlHolder.removeClass("spinner");
                controlHolder.addClass("is-invalid");
                input.removeAttr("disabled");
                select.removeAttr("disabled");
                $(".invalid-feedback", controlHolder).remove();
                $(".form-control", controlHolder).addClass("is-invalid");
                var messages = $.map(data.errors[propertyNameOfControl], function(error, ix) {
                    return '<span class="validation-message">' + error.message + "</span>";
                });
                controlHolder.append('<div class="invalid-feedback">' + messages.join() + "</div>");
            }
        }).fail(function(xhr, status, error) {
            (0, $jwUJU.ax).log.error("Updating value failed for " + propertyId, xhr.responseText);
            controlHolder.addClass("is-invalid");
            $(".invalid-feedback", controlHolder).remove();
            $(".form-control", controlHolder).addClass("is-invalid");
        });
        (0, $jwUJU.ax).log.groupEnd();
    }
    // submit the control value
    _submitValue(e, successFunction, failFunction) {
        e.preventDefault();
        e.stopPropagation();
        (0, $jwUJU.ax).log.group("Posting editable value update for", this.propertyId);
        var properties = this._retrieveRefreshableValuesToUpdate();
        (0, $jwUJU.ax).log.debug("Requesting refresh for properties", properties);
        var requestedPropertiesData = properties.join("&");
        var wrapper = this.wrapper;
        var entityPrefix = this.entityPrefix;
        var propertyId = this.propertyId;
        var propertyNameOfControl = this.propertyNameOfControl;
        var controlHolder = this.controlHolder;
        $.ajax({
            type: "post",
            url: this.settings.targetUrl,
            data: $("form", wrapper).serialize() + "&" + requestedPropertiesData
        }).done(function(data, status, request) {
            if (data.success) {
                successFunction();
                controlHolder.removeClass("is-invalid");
                $(".invalid-feedback", controlHolder).remove();
                $d6b979a95a845ae5$export$b92017fdda101fde(propertyId, data.properties[propertyNameOfControl]);
                // update other properties
                $.each(data.properties, function(propertyName, propertyData) {
                    if (propertyName !== propertyNameOfControl) {
                        if (propertyName.startsWith(propertyId.substring(0, propertyId.indexOf("/")))) $d6b979a95a845ae5$export$b92017fdda101fde(propertyName, propertyData);
                        else $d6b979a95a845ae5$export$b92017fdda101fde(entityPrefix + propertyName, propertyData);
                    }
                });
            } else {
                failFunction();
                controlHolder.addClass("is-invalid");
                $(".invalid-feedback", controlHolder).remove();
                $(".form-control", controlHolder).addClass("is-invalid");
                var messages = $.map(data.errors[propertyNameOfControl], function(error, ix) {
                    return '<span class="validation-message">' + error.message + "</span>";
                });
                controlHolder.append('<div class="invalid-feedback">' + messages.join() + "</div>");
            }
        }).fail(function(xhr, status, error) {
            failFunction();
            (0, $jwUJU.ax).log.error("Updating value failed for " + propertyId, xhr.responseText);
            controlHolder.addClass("is-invalid");
            $(".invalid-feedback", controlHolder).remove();
            $(".form-control", controlHolder).addClass("is-invalid");
        });
        (0, $jwUJU.ax).log.groupEnd();
    }
    _retrieveRefreshableValuesToUpdate() {
        var entityPrefix = this.entityPrefix;
        var properties = {};
        $("[data-em-property-id]").each(function() {
            var propertyId = $(this).data("em-property-id");
            if (propertyId.startsWith(entityPrefix)) {
                var viewElementMode = $d6b979a95a845ae5$var$resolveViewElementMode($(this));
                properties["extensions[editableValues].properties[" + $d6b979a95a845ae5$var$propertyNameOf(propertyId) + "]=" + viewElementMode] = true;
            }
        });
        return $.map(properties, function(value, key) {
            return key;
        });
    }
    resetChangeTracking() {
        this.label.removeData("em-property-value-changed");
    }
    isValuePossibleChanged() {
        return this.label.data("em-property-value-changed") != null;
    }
}
EntityModule.registerInitializer(function(node) {
    $("[data-em-editable-value]", node).each(function() {
        new $d6b979a95a845ae5$var$EditableValue($(this)).activate();
    });
});
EntityModule.registerInitializer(function(node) {
    if (node && $(node).data("editable-value-control") === true) {
        $("input[type=text]", $(node)).focusTextToEnd();
        $(".bootstrap-tagsinput span[data-role=remove]", $(node)).off().on("click", function(e) {
            let removeOnSuccess = false;
            if ($(this).parent().parent().children("span").length === 1) {
                $(this).parent().find("input").val("");
                removeOnSuccess = true;
            } else $(this).parent().remove();
            let editableValue = $(node).data("editableValue");
            editableValue._submitValue(e, ()=>{
                if (removeOnSuccess) $(this).parent().remove();
            }, ()=>{});
        });
        $("input[type=text].js-multi-value-input", $(node)).off().on("keypress", (e)=>{
            if (e.key === "Enter") {
                if ($(e.target).attr("new-value") === "true" && !!e.target.value) {
                    const id = $(e.target).attr("id");
                    const newTag = `<span data-editable-value-control="true" hidden="true" class="tag label label-info"><input name=${id} type="hidden" value=${e.target.value}> ${e.target.value} <span data-role="remove"></span></span>`;
                    $(newTag).insertBefore($(e.target));
                    let editableValue = $(node).data("editableValue");
                    // //LOL, remove clears the JQuery context before it removes the node from the DOM, #eendagnietgeklaagdiseendagnietgeleefd
                    editableValue._submitValue(e, ()=>{
                        $(`input[value="${e.target.value}"]`).parent().removeAttr("hidden");
                        $(e.target).val("");
                        EntityModule.initializeFormElements($(node));
                    }, ()=>{
                        $(`input[value="${e.target.value}"]`).parent().remove();
                    });
                } else {
                    let editableValue = $(node).data("editableValue");
                    // //LOL, remove clears the JQuery context before it removes the node from the DOM, #eendagnietgeklaagdiseendagnietgeleefd
                    editableValue._submitValue(e);
                }
            }
        });
        // Update editable value on enter
        $("input[type=text]:not(.js-multi-value-input), input[type=search]", $(node)).on("keypress", (e)=>{
            if (e.key === "Enter") {
                let editableValue = $(node).data("editableValue");
                $("input[type=text]", $(node)).blur();
                editableValue._updateValue(e);
            }
        });
        // Update editable value on change
        $("input[type=checkbox], input[type=radio], select", $(node)).change(function(e) {
            let editableValue = $(node).data("editableValue");
            editableValue._updateValue(e);
        });
    }
});
(function($1) {
    $1.fn.focusTextToEnd = function() {
        this.focus();
        var $thisVal = this.val();
        this.val("").val($thisVal);
        return this;
    };
})(jQuery);

});

parcelRegister("6GBWH", function(module, exports) {
EntityModule.registerInitializer(function(node) {
    const FloatLabel = (()=>{
        const handleFocus = (e)=>{
            e.target.closest(".form-group", node).classList.add("focus");
        };
        const handleChange = (e)=>{
            const target = e.target;
            if (target.selectedIndex === 0) target.closest(".form-group", node).classList.remove("active");
            else target.closest(".form-group", node).classList.add("active");
        };
        // remove active class
        const handleBlur = (e)=>{
            const target = e.target;
            if (!target.value) {
                target.closest(".form-group", node).classList.remove("active");
                target.closest(".form-group", node).classList.remove("focus");
            }
        };
        // disable the submit on enter
        const disableSubmit = (e)=>{
            if (e.keyCode === 13) {
                $(e.currentTarget).trigger("change");
                e.preventDefault();
            }
        };
        // register events
        const bindEvents = (element, querySelector)=>{
            const floatFields = element.querySelectorAll(querySelector, node);
            floatFields.forEach((field)=>{
                if (querySelector === "select") field.addEventListener("change", handleChange);
                else if (querySelector === ".js-entity-query-control" || querySelector === ".datetimepicker-input") {
                    field.addEventListener("keydown", disableSubmit);
                    field.addEventListener("focus", handleFocus);
                } else field.addEventListener("focus", handleFocus);
                field.addEventListener("blur", handleBlur);
            });
        };
        // get DOM elements
        const init = ()=>{
            const floatContainers = document.querySelectorAll(".entity-query-filter-form-basic > .form-group, .filter-blade-filter-form-basic > .form-group");
            floatContainers.forEach((element)=>{
                if (!!element.querySelector(".multi-value-autosuggest", node)) {
                    if (element.querySelector(".tt-input", node).value) element.classList.add("active");
                    bindEvents(element, ".tt-input");
                } else if (!!element.querySelector(".bootstrap-select", node)) {
                    if (element.querySelector("select").querySelector("option[selected=selected]") !== null && !!element.querySelector("select").querySelector("option[selected=selected]").value) element.classList.add("active");
                    bindEvents(element, "select");
                } else if (!!element.querySelector(".js-entity-query-control", node)) {
                    if (element.querySelector(".js-entity-query-control", node).value) element.classList.add("active");
                    bindEvents(element, ".js-entity-query-control");
                } else if (!!element.querySelector(".datetimepicker-input")) {
                    if (element.querySelector(".datetimepicker-input", node).value) element.classList.add("active");
                    bindEvents(element, ".datetimepicker-input");
                }
            });
        };
        return {
            init: init
        };
    })();
    FloatLabel.init();
});

});

parcelRegister("7dAOI", function(module, exports) {

$parcel$export(module.exports, "initializeModalConfigurations", () => $54164e62462458f1$export$61ad63542699d2e8);
$parcel$export(module.exports, "executeFetchRequest", () => $54164e62462458f1$export$f5fd31e257f0566b);

var $jwUJU = parcelRequire("jwUJU");

var $iqYmi = parcelRequire("iqYmi");

var $4k8rO = parcelRequire("4k8rO");

var $fEeKn = parcelRequire("fEeKn");

var $bg8Ty = parcelRequire("bg8Ty");
EntityModule.registerInitializer(function(node) {
    $54164e62462458f1$export$61ad63542699d2e8(node);
});
function $54164e62462458f1$export$61ad63542699d2e8(node) {
    $("[data-modal-load]", node).each((idx, element)=>{
        $54164e62462458f1$var$initializeModalConfiguration(element);
    });
}
function $54164e62462458f1$var$initializeModalConfiguration(element) {
    let $node = $(element);
    let config = $.extend(true, {}, $node.data("modal-load"));
    const targetModalId = "#" + config.targetModalId;
    $node.off().on("click", (e)=>{
        e.preventDefault();
        $(targetModalId).one("show.bs.modal", (event)=>{
            $54164e62462458f1$export$f5fd31e257f0566b(config.content.url, config.content.method).then((0, $jwUJU.convertResponseToText)).then((html)=>{
                if (targetModalId) {
                    $54164e62462458f1$export$17967ba0df18d26c(targetModalId, html);
                    $(targetModalId).trigger("modal:content-loaded");
                }
            }).catch((e)=>{
                $(targetModalId).modal("hide");
                if (e !== null) {
                    (0, $fEeKn.apm).captureError(e);
                    console.error(e);
                }
                (0, $bg8Ty.showErrorModal)("<p>Oops! Something went wrong, try again later</p>");
            });
        });
        config.submissions.forEach(function(item, index) {
            $54164e62462458f1$var$configureModalSubmission(targetModalId, config, item, item.name);
        });
        $(targetModalId).on("hide.bs.modal", (e)=>{
            $54164e62462458f1$var$cleanUpModal(targetModalId);
        });
    });
}
function $54164e62462458f1$export$17967ba0df18d26c(target, content) {
    $(target + " .modal-body").html("</form>" + content);
    EntityModule.initializeFormElements($(target + " .modal-body"));
}
function $54164e62462458f1$var$configureModalSubmission(target, config, submissionConfig, btnId) {
    let $submissionBtn = $(target + " .js-" + btnId);
    $submissionBtn.prop("disabled", false);
    $submissionBtn.off().on("click", (e)=>{
        (0, $4k8rO.showSpinner)("#" + btnId);
        e.preventDefault();
        e.stopPropagation();
        $(this).prop("disabled", true);
        $(this).find(".loading").removeClass("d-none");
        const requestConfiguration = $.extend({}, {
            type: submissionConfig.type,
            url: submissionConfig.url,
            method: submissionConfig.method,
            form: `${target} form`
        });
        $54164e62462458f1$var$executeRequest(requestConfiguration).then((response)=>{
            (0, $4k8rO.hideSpinner)("#" + btnId);
            if (response.redirected) {
                if (!config.ignoreRedirects) window.location.href = response.url;
                return Promise.resolve({
                    replace: false
                });
            } else if (response.ok) {
                const contentType = response.headers.get("content-type");
                if (contentType.includes("application/json")) return response.json();
                else return response.text().then((html)=>{
                    return {
                        content: html,
                        replace: true
                    };
                });
            } else {
                if (0, $fEeKn.apm) (0, $fEeKn.apm).captureError("Error while calling " + submissionConfig.url);
                console.error("Error while calling " + submissionConfig.url);
                if (response.status === 601) response.text().then((0, $bg8Ty.showValidationErrorModal));
                else (0, $bg8Ty.showErrorModal)("<p>Oops! Something went wrong, try again later</p>");
            }
        }).then((data)=>{
            if (data.success) {
                $(target).modal("hide");
                $.each(data.properties, function(propertyName, propertyData) {
                    (0, $iqYmi.updatePropertyData)(propertyName, propertyData);
                });
            } else if (data && data.replace) $54164e62462458f1$export$17967ba0df18d26c(target, data.content);
            else {
                $(target).modal("hide");
                if (config.refreshOnClose && config.refreshOnClose) $54164e62462458f1$var$handleRefreshOnClose(config.refreshOnClose);
            }
            $(target).trigger("modal:action-complete", data);
        });
    });
}
/*
    todo.stg: create a global javascript object which holds functions we can execute.
    This way we can reuse functionality across pages/components
 */ function $54164e62462458f1$var$handleRefreshOnClose(config) {
    // todo.stg can we extract the unpoly specifics in h.then logic?
    const executed = $54164e62462458f1$var$executeRequest(config);
    if (!config.type.startsWith("unpoly")) {
        if (Array.isArray(executed)) executed.forEach((data)=>{
            if (!data.partial.type.startsWith("unpoly")) $54164e62462458f1$var$refreshPartial(data.promise);
        });
        else $54164e62462458f1$var$refreshPartial(executed);
    }
}
function $54164e62462458f1$var$cleanUpModal(target) {
    $(target + " .modal-body").html("");
    let $submissionBtn = $(target + " .js-modal-submit");
    $submissionBtn.prop("disabled", false);
    $submissionBtn.find(".loading").addClass("d-none");
}
function $54164e62462458f1$var$executeRequest(requestConfig) {
    switch(requestConfig.type){
        case "partial:multi":
            return requestConfig.partials.map((partial)=>{
                return {
                    partial: partial,
                    promise: $54164e62462458f1$var$executeRequest(partial)
                };
            });
        case "partial:single":
            return $54164e62462458f1$var$executePartialRequest(requestConfig);
        case "unpoly:reload":
            return $54164e62462458f1$var$UNPOLY_REQUEST.reload(requestConfig);
        case "unpoly:replace":
            return $54164e62462458f1$var$UNPOLY_REQUEST.replace(requestConfig);
        default:
            (0, $jwUJU.ax).log.debug("Did not find a suitable request handler. Config: ", requestConfig);
    }
}
const $54164e62462458f1$var$UNPOLY_REQUEST = {
    reload: function(req) {
        return Promise.resolve(req.url ? up.reload(req.target, req.url) : up.reload(req.target));
    },
    replace: function(req) {
        (0, $jwUJU.ax).log.debug("unpoly replace requests have not been implemented yet");
        return Promise.resolve();
    }
};
function $54164e62462458f1$var$executePartialRequest(partialConfiguration) {
    const { partial: partial, form: form, method: method, url: url } = partialConfiguration;
    const baseUrl = url ? url : window.location.href.split("?")[0];
    const requestUrl = partial ? url.indexOf("?") === -1 ? `${baseUrl}?_partial=${partial}` : `${baseUrl}&_partial=${partial}` : baseUrl;
    const formToSerialize = form ? $(form) : null;
    if (formToSerialize) return $54164e62462458f1$var$executeFormRequest(requestUrl, method, formToSerialize);
    return $54164e62462458f1$export$f5fd31e257f0566b(requestUrl, method, formToSerialize);
}
function $54164e62462458f1$var$executeFormRequest(url, method, form) {
    let formConfiguration = {
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        }
    };
    if (form.attr("enctype") === "multipart/form-data") {
        formConfiguration.body = new FormData(form[0]);
        formConfiguration.processData = false;
        formConfiguration.contentType = false;
        formConfiguration.cache = false;
    } else formConfiguration.body = $54164e62462458f1$var$getFormDate($(form[0]));
    return $54164e62462458f1$export$f5fd31e257f0566b(url, method, formConfiguration);
}
function $54164e62462458f1$export$f5fd31e257f0566b(url, method, requestConfiguration) {
    const fetchConfiguration = $.extend(true, {}, {
        method: method,
        headers: {
            "X-XSRF-Token": (0, $jwUJU.getCookie)("XSRF-TOKEN"),
            "Content-Type": "application/x-www-form-urlencoded"
        }
    }, requestConfiguration);
    return fetch(url, fetchConfiguration);
}
function $54164e62462458f1$var$getFormDate($form) {
    const data = new URLSearchParams();
    var form = $form.serializeArray();
    if (form.length) {
        for(var i = 0; i < form.length; i++){
            var key = form[i].name, value = form[i].value;
            if (key.substr(key.length - 2, 2) === "[]") key = key.substr(0, key.length - 2);
            if (data.get(key) != null) {
                let valueToAppend = data.get(key);
                if (valueToAppend.push !== undefined) valueToAppend.push(value);
                else valueToAppend = [
                    valueToAppend,
                    value
                ];
                data.set(key, valueToAppend);
            } else data.append(key, value);
        }
        return data;
    }
}
/*
    todo.stg: create a global javascript object which holds functions we can execute.
    This way we can reuse functionality across pages/components
 */ function $54164e62462458f1$var$refreshPartial(partialConfiguration) {
    const { partial: partial, form: form, method: method, url: url, target: target } = partialConfiguration;
    const baseUrl = url ? url : window.location.href.split("?")[0];
    const requestUrl = `${baseUrl}?_partial=${partial}`;
    const formToSerialize = form ? $(form) : null;
    $54164e62462458f1$var$executeRequest(requestUrl, method, formToSerialize).then((0, $jwUJU.convertResponseToText)).then((html)=>{
        $(target).replaceWith(html);
        EntityModule.initializeFormElements($(target));
    });
}

});

parcelRegister("f8r0C", function(module, exports) {
/**
 * Adapts the default navigation to work through Unpoly.
 */ {
    /**
   * Closes custom layers that should be closed when navigation changes.
   */ function closeLayers() {
        $(".page-wrapper").removeClass("show-blade");
    }
    function isUnpolyAware(node) {
        return node.hasAttribute("up-target") || node.hasAttribute("up-popup") || node.hasAttribute("up-modal") || node.hasAttribute("up-drawer");
    }
    /**
   * Sidebar and breadcrumb navigation always updates the page-content wrapper.
   */ up.macro(".sidebar a.list-group-item-action:not(.list-group-subgroup-toggle), .breadcrumb .breadcrumb-item a", function(link) {
        link.setAttribute("up-target", ".page-content-wrapper");
        link.setAttribute("up-restore-scroll", true);
        link.setAttribute("up-history", true);
        link.setAttribute("up-instant", "up-instant"); // load on mousedown
        link.setAttribute("up-cache", false);
        $(link).on("mousedown", closeLayers);
    });
    /**
   * In-page tab navigation only updates the tab section.
   */ up.macro(".tabbable .pcs-nav a.nav-link", function(link) {
        link.setAttribute("up-target", ".main");
        link.setAttribute("up-restore-scroll", true);
        link.setAttribute("up-history", true);
        link.setAttribute("up-instant", "up-instant"); // load on mousedown
        link.setAttribute("up-cache", false);
        $(link).on("mousedown", closeLayers);
    });
    /**
   * List form and sortable table links refresh the main by default (if on target set).
   */ up.macro(".list-header-actions a:not(.js-disable-unpoly), .em-sortableTable-table td.row-actions a:not(.download-asset), .main #btn-cancel, tr[data-target-url]", function(link) {
        if (!isUnpolyAware(link)) {
            link.setAttribute("up-target", ".main");
            link.setAttribute("up-restore-scroll", false);
            link.setAttribute("up-history", true);
            link.setAttribute("up-cache", false);
            if (link.hasAttribute("data-target-url")) link.setAttribute("up-href", link.getAttribute("data-target-url"));
            $(link).on("mousedown", closeLayers);
        }
    });
    /**
   * Cancel button closes the modal.
   */ up.compiler(".up-modal-content #btn-cancel", function(link) {
        link.setAttribute("up-close", true);
    });
    /**
   * Entity edit forms reload both the form and the feedback section.
   * If no form present in the response, fallback to main.
   */ up.compiler("form.em-form, form.em-list-form", function(form) {
        if (!form.hasAttribute("up-target")) {
            form.setAttribute("up-target", ".main");
            form.setAttribute("up-restore-scroll", false);
            form.setAttribute("up-history", true);
            form.setAttribute("up-cache", false);
        }
    });
    up.compiler("form.em-list-form", function(form) {
        form.setAttribute("up-autosubmit", true);
        form.setAttribute("up-delay", 100);
        form.setAttribute("up-restore-scroll", true);
        form.setAttribute("up-target", ".lists-results");
    });
}
});

parcelRegister("fkLXk", function(module, exports) {

var $jwUJU = parcelRequire("jwUJU");
/**
 * Activates support for data-partial-load.
 */ function $b29dec5395ded859$var$addParametersToUrl(url) {
    const parametersToCopyToUrl = [
        "personal"
    ];
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.forEach(function(value, key) {
        if (parametersToCopyToUrl.includes(key)) {
            url += "&" + key;
            url += !!value ? NaN + value : "";
        }
    });
    return url;
}
EntityModule.registerInitializer(function(node) {
    $("[data-partial]", node).each(function(idx, value) {
        var _this = $(this);
        $.get(_this.data("partial"), function(data) {
            var wrapper = _this.find(".js-data-wrapper");
            wrapper.html(data);
            EntityModule.initializeFormElements(wrapper);
        });
    });
    // automatically load partial content when a control is modified
    function buildPartialLoadParameters(element, config) {
        var parameters = $.merge(config, {
            data: ""
        });
        if (parameters.form == null && parameters.url == null) // neither url nor form specified, default to fetching any current form
        parameters.form = "form";
        if (parameters.form != null) {
            var formToSubmit = element.closest(parameters.form);
            if (formToSubmit.length) {
                parameters.data = formToSubmit.serialize();
                if (parameters.url == null) parameters.url = formToSubmit.attr("action");
            }
        }
        if (parameters.url == null) parameters.url = window.location.href;
        return parameters;
    }
    function configurePartialRefresh(element, config) {
        $(element).one("bootstrapui.change", _.debounce(function() {
            var parameters = buildPartialLoadParameters($(this), config);
            var control = $(this);
            var target;
            if (parameters.target == null) {
                // no target specified, check if another container is labelled as target for the partial
                target = $('[data-partial-target="' + parameters.partial + '"]');
                if (!target.length) // none found, replace the current element
                target = control;
            } else target = $(parameters.target);
            // if the target does not have the 'data-partial-target' - add a wrapper
            var wrapperAdded = false;
            if (!target.data("partial-target")) {
                wrapperAdded = true;
                target.wrap('<div data-partial-target="' + parameters.partial + '"></div>');
                target = $('[data-partial-target="' + parameters.partial + '"]');
            }
            target.addClass("partial-loading");
            target.append('<div class="partial-spinner"></div>');
            var url = parameters.url.substring(0, parameters.url.indexOf("?")) + "?" + parameters.data + "&" + $.param({
                _partial: "::" + parameters.partial
            });
            url = $b29dec5395ded859$var$addParametersToUrl(url);
            fetch(url, {
                method: parameters.method,
                redirect: "follow",
                headers: {
                    "X-XSRF-Token": (0, $jwUJU.getCookie)("XSRF-TOKEN"),
                    "Content-Type": "application/x-www-form-urlencoded"
                }
            }).then((0, $jwUJU.convertResponseToText)).then((data)=>{
                target.html(data);
                EntityModule.initializeFormElements(target);
                target.removeClass("partial-loading");
                var newUrl = url.split("?")[0] + "?" + parameters.data;
                newUrl = $b29dec5395ded859$var$addParametersToUrl(newUrl);
                window.history.pushState({
                    path: newUrl
                }, "", newUrl);
                if (wrapperAdded) {
                    var firstChild = target.children().first();
                    if (firstChild.length) firstChild.unwrap();
                }
            }).catch((0, $jwUJU.handleError));
        }, 1));
    }
    $("[data-partial-load]", node).each(function() {
        var config = $(this).data("partial-load");
        configurePartialRefresh(this, config);
    });
    $("[data-multi-partial-load]", node).each(function() {
        var _element = $(this);
        var config = $(this).data("multi-partial-load");
        if (config && config.partials) {
            var partials = config.partials;
            if (partials && partials.length) for(let i = 0; i < partials.length; i++)configurePartialRefresh(_element, partials[i]);
        }
    });
});

});

parcelRegister("iTV5B", function(module, exports) {
EntityModule.registerInitializer(function(node) {
    $(".password-strength-calculator").keyup((e)=>{
        const $element = $(e.target);
        const $passwordStrengthDescriptor = $element.siblings(".password-strength-view");
        const weakLabel = $passwordStrengthDescriptor.attr("data-label-weak");
        const averageLabel = $passwordStrengthDescriptor.attr("data-label-average");
        const strongLabel = $passwordStrengthDescriptor.attr("data-label-strong");
        const pwVal = $element.val();
        let strengthPoints = 0;
        if (pwVal.length >= 8) strengthPoints++;
        if (pwVal.length >= 12 && /\d{2,}/.test(pwVal) && /\w{2,}/.test(pwVal)) strengthPoints++;
        if (/\d/.test(pwVal)) strengthPoints++;
        if (/\w/.test(pwVal)) strengthPoints++;
        if (/[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/.test(pwVal)) strengthPoints++;
        else strengthPoints--;
        if (strengthPoints <= 0) $element.siblings(".password-strength-view").html(`<span style="color: #e0e0e0">\u{2014}</span>
                            <span style="color: #e0e0e0">\u{2014}</span>
                            <span style="color: #e0e0e0">\u{2014}</span>
                            <span class="text" style="color: #e0e0e0">${weakLabel}</span>`);
        else if (strengthPoints === 1 || strengthPoints === 2 || strengthPoints === 3) $element.siblings(".password-strength-view").html(`<span style="color: #ff5050">\u{2014}</span>
                            <span style="color: #e0e0e0">\u{2014}</span>
                            <span style="color: #e0e0e0">\u{2014}</span>
                            <span class="text"  style="color: #ff5050">${weakLabel}</span>`);
        else if (strengthPoints === 4) $element.siblings(".password-strength-view").html(`<span style="color: #ff9800">\u{2014}</span>
                            <span style="color: #ff9800">\u{2014}</span>
                            <span style="color: #e0e0e0">\u{2014}</span>
                            <span class="text"  style="color: #ff9800">${averageLabel}</span>`);
        else if (strengthPoints === 5) $element.siblings(".password-strength-view").html(`<span style="color: #4caf50">\u{2014}</span>
                            <span style="color: #4caf50">\u{2014}</span>
                            <span style="color: #4caf50">\u{2014}</span>
                            <span class="text"  style="color: #4caf50">${strongLabel}</span>`);
    });
});

});

parcelRegister("4XgQu", function(module, exports) {
EntityModule.registerInitializer(function(node) {
    $(".js-period-input-amount").on("change", function(event) {
        updatePeriodAmount(event.currentTarget, event.currentTarget.value);
    });
    $(".js-period-input-cardinality").on("change", function(event) {
        updatePeriodCardinality(event.currentTarget, event.currentTarget.value);
    });
    function updatePeriodAmount(target, amount) {
        var periodInput = $(target).parent().parent().find(".js-period-input");
        if (amount) {
            periodInput.attr("data-amount", amount);
            var cardinality = periodInput.attr("data-cardinality");
            var value = "P" + amount + cardinality;
            periodInput.val(value);
        } else periodInput.val("");
    }
    function updatePeriodCardinality(target, cardinality) {
        if (cardinality && cardinality !== "") {
            var periodInput = $(target).parent().parent().parent().find(".js-period-input");
            periodInput.attr("data-cardinality", cardinality);
            var amount = periodInput.attr("data-amount");
            var value = "P" + amount + cardinality;
            periodInput.val(value);
        }
    }
});

});

parcelRegister("34uz3", function(module, exports) {
EntityModule.registerInitializer(function() {
    $(".js-price-modifier-select a").on("click", function(event) {
        $23c9744a2b710d5b$var$dropDownItemClicked(event);
    });
    $(".js-price-modifier-input").on("blur", function(event) {
        $23c9744a2b710d5b$var$setPriceModifier(event.currentTarget.value);
    });
});
function $23c9744a2b710d5b$var$dropDownItemClicked(event) {
    $23c9744a2b710d5b$var$updateCurrencySymbol(event);
    $23c9744a2b710d5b$var$setHelpText($(event.currentTarget));
    $23c9744a2b710d5b$var$setPriceModifier($(".js-price-modifier-input").val());
}
function $23c9744a2b710d5b$var$setPriceModifier(modifierNumber) {
    modifierNumber = modifierNumber.replace(".", "").replace(",", ".").replace("\u20AC", "").trim();
    $(".js-price-modifier").val(modifierNumber);
}
function $23c9744a2b710d5b$var$updateCurrencySymbol(event) {
    const currencySymbol = " " + event.currentTarget.text;
    $(".js-price-modifier-input[data-bootstrapui-numeric]").data("autoNumeric").update({
        currencySymbol: currencySymbol
    });
    $(".js-price-modifier-type-value").text(currencySymbol);
}
function $23c9744a2b710d5b$var$setHelpText(selectedType) {
    $(".js-price-modifier-help").text(selectedType.data("help"));
}

});

parcelRegister("5e859", function(module, exports) {
function $3ce4877dab6ab66f$var$additionalTypesDropdown(node) {
    var suffix = $("[options-type ='channel']").find($("[checked ='checked']")).parent().attr("amount-suffix");
    if (!!suffix) $("form").find(".input-group-addon").html(suffix);
    $("[value ='additionalTypesDropdown']", node).on("click", function(event) {
        var typeId = $(event.target).attr("data-value");
        if (!!typeId) {
            var currentUrl = window.location.href.split("?")[0];
            // this is the button, its parent is the partial view element, which we are going to replace
            var destination = $(this).parent().parent();
            console.log("refreshing additional types", this, destination);
            var selectionData = $(this).closest("form").serialize();
            $.ajax({
                type: "post",
                url: currentUrl,
                data: "property=" + typeId + "&_partial=::ProductFeatureValueSelectorForCollectionControl&" + selectionData
            }).done(function(data) {
                $(destination).html(data);
                EntityModule.initializeFormElements($(destination));
            });
        }
    });
}
EntityModule.registerInitializer($3ce4877dab6ab66f$var$additionalTypesDropdown);

});

parcelRegister("lysSP", function(module, exports) {

var $iqYmi = parcelRequire("iqYmi");

var $jwUJU = parcelRequire("jwUJU");

var $7dAOI = parcelRequire("7dAOI");
EntityModule.registerInitializer(function(node) {
    $("[data-request]", node).each((idx, element)=>{
        $fb132d908219d855$var$initializeRequestConfiguration(element);
    });
});
function $fb132d908219d855$var$initializeRequestConfiguration(element) {
    let $node = $(element);
    let config = $.extend(true, {}, $node.data("request"));
    $node.on("click", (e)=>{
        e.preventDefault();
        (0, $7dAOI.executeFetchRequest)(config.url, config.method).then((response)=>{
            if (response.redirected) {
                window.location.href = response.url + "&redirectUrl=" + encodeURI(window.location.href);
                return Promise.reject(null);
            } else {
                const contentType = response.headers.get("content-type");
                if (contentType.includes("application/json")) return response.json();
                else return response.text().then((html)=>{
                    return {
                        content: html,
                        replace: true
                    };
                });
            }
        }).then((data)=>{
            if (data.success) {
                $.each(data.properties, function(propertyName, propertyData) {
                    (0, $iqYmi.updatePropertyData)(propertyName, propertyData);
                });
                $node.trigger("request:action-complete", data);
            }
        }).catch((0, $jwUJU.handleError));
    });
}

});

parcelRegister("GWkRr", function(module, exports) {
$(document).ready(function() {
    $08112c9145464a5d$var$bindTranslationShowKey();
});
function $08112c9145464a5d$var$bindTranslationShowKey() {
    $(document).keydown(function(event) {
        if (event.key === "Control") //ctrl
        $08112c9145464a5d$var$displayAllCodes();
    }).keyup(function(event) {
        if (event.key === "Control") //ctrl
        $08112c9145464a5d$var$displayAllTranslations();
    });
}
function $08112c9145464a5d$var$displayAllCodes() {
    $(".js-translated-element").each(function() {
        const $this = $(this);
        if (!$this.hasClass("showing-code")) {
            $this.html($this.attr("data-translation-code"));
            $this.addClass("showing-code");
        }
    });
// This is a tryout for rendering codes in placeholders
/*$( '.js-translated-attribute' ).each( function () {
      const $this = $( this );
      if ( !$this.hasClass( 'showing-code' ) ) {
        const attribute = $this.attr( 'data-translation-attribute' );
        $this.attr( attribute, $this.attr( 'data-translation-code' ) );
        $this.addClass( 'showing-code' );
      }
    } );*/ }
function $08112c9145464a5d$var$displayAllTranslations() {
    $(".js-translated-element").each(function() {
        const $this = $(this);
        if ($this.hasClass("showing-code")) {
            $this.html($this.attr("data-translation-value"));
            $this.removeClass("showing-code");
        }
    });
// This is a tryout for rendering codes in placeholders
/*$( '.js-translated-attribute' ).each( function () {
      const $this = $( this );
      if ( $this.hasClass( 'showing-code' ) ) {
        const attribute = $this.attr( 'data-translation-attribute' );
        $this.attr( attribute, $this.attr( 'data-translation-value' ) );
        $this.removeClass( 'showing-code' );
      }
    } );*/ }

});

parcelRegister("aFvAO", function(module, exports) {
EntityModule.registerInitializer(function(node) {
    const $actionTypeSelector = $("div[data-em-property='workflowActionFields[].fieldType']", node);
    $actionTypeSelector.each(function() {
        var selectedValue = $(this).find(":selected").val();
        $7c463d5f484e1dbf$var$showOrHideOptions(selectedValue, $(this).parent());
        $(this).change(function() {
            selectedValue = $(this).find(":selected").val();
            $7c463d5f484e1dbf$var$showOrHideOptions(selectedValue, $(this).parent());
        });
    });
});
function $7c463d5f484e1dbf$var$showOrHideOptions(selectedValue, node) {
    if (selectedValue !== "SELECT") $("div[data-em-property='workflowActionFields[].options']", node).hide();
    else $("div[data-em-property='workflowActionFields[].options']", node).show();
}

});

parcelRegister("kloe4", function(module, exports) {
EntityModule.registerInitializer(function(node) {
    $ecf88f92385c6c3f$var$hideAllActionFieldGroups(node);
    $("div[data-em-property='possibleTransitionActions'] .checkbox-list", node).each(function() {
        const $possibleTransactionsSelector = $(this);
        $ecf88f92385c6c3f$var$showCorrectActionFieldGroups($possibleTransactionsSelector);
        $possibleTransactionsSelector.change(function() {
            $ecf88f92385c6c3f$var$hideAllActionFieldGroups(node);
            $ecf88f92385c6c3f$var$showCorrectActionFieldGroups($possibleTransactionsSelector);
        });
    });
});
function $ecf88f92385c6c3f$var$hideAllActionFieldGroups(node) {
    $("div[data-em-property='possibleTransitionActions'] .action-field-group", node).hide();
}
function $ecf88f92385c6c3f$var$showCorrectActionFieldGroups($possibleTransactionsSelector) {
    $possibleTransactionsSelector.find(":checked").each(function() {
        var selectedAction = $(this).val();
        $(`div[data-em-property='possibleTransitionActions'] [data-action-id='${selectedAction}']`).show();
    });
}

});

parcelRegister("8adAR", function(module, exports) {

var $g42dj = parcelRequire("g42dj");
/**
 * Specific configuration for campaign tags on CompanyCampaignResponsibility association.
 * When tag components support configuration attributes, this method should be generalized to initialize <em>all</em> tag controls.
 */ EntityModule.registerInitializer(function(node) {
    $("[data-em-association='companyCampaignResponsibility.company']", node).each(function() {
        (0, $g42dj.initializeCustomTagAutosuggests)('[data-em-association="companyCampaignResponsibility.company"] .form-group .tags-autosuggest', "LABEL");
    });
});

});
parcelRegister("g42dj", function(module, exports) {

$parcel$export(module.exports, "initializeCustomTagAutosuggests", () => $bb1ebca3e5e63108$export$76aa4a834c5849fc);

var $33ozY = parcelRequire("33ozY");

var $jwUJU = parcelRequire("jwUJU");
function $bb1ebca3e5e63108$export$8b98dbd817393b28($tagInput, emptyTemplate, tagType) {
    const bloodhoundTagAutocomplete = new Bloodhound({
        datumTokenizer: Bloodhound.tokenizers.obj.whitespace("value"),
        queryTokenizer: Bloodhound.tokenizers.obj.whitespace("value"),
        remote: {
            url: "/api/tag?prefix=%QUERY&type=" + tagType,
            wildcard: "%QUERY"
        }
    });
    bloodhoundTagAutocomplete.initialize();
    window.bloodhoundTagAutocomplete = bloodhoundTagAutocomplete;
    var suggestionTemplate = `<div class="suggestion">{{name}}</div>`;
    var $dummyPlusTag = $('<span class="tag label label-info">+</span>');
    $tagInput.tagsinput({
        itemValue: "tagId",
        itemText: "name",
        delimiter: "|",
        maxChars: 30,
        typeaheadjs: [
            {
                hint: true,
                highlight: true,
                minLength: 1,
                maxLength: 30
            },
            {
                name: "tags",
                displayKey: "name",
                source: bloodhoundTagAutocomplete.ttAdapter(),
                templates: {
                    empty: Handlebars.compile(emptyTemplate),
                    suggestion: Handlebars.compile(suggestionTemplate)
                }
            }
        ],
        freeInput: false
    });
    var $tagsInput = $(".bootstrap-tagsinput");
    var $inputfield = $(".bootstrap-tagsinput .tt-input", $tagInput.parent());
    $(".bootstrap-tagsinput .tt-input", $tagInput.parent()).attr("maxLength", 30);
    $tagInput.on("itemAddedOnInit", function(event) {
        $dummyPlusTag.remove($tagsInput);
        $dummyPlusTag.insertBefore($inputfield);
    });
    $tagInput.on("itemAdded", function(event) {
        $dummyPlusTag.remove($tagsInput);
        $dummyPlusTag.insertBefore($inputfield);
    });
    if ($tagInput.attr("tags") === undefined || $tagInput.attr("tags") === "[]") $dummyPlusTag.insertBefore($inputfield);
    $inputfield.focusin(function() {
        $dummyPlusTag.remove();
    });
    $inputfield.focusout(function() {
        $dummyPlusTag.insertBefore($inputfield);
    });
    $(".twitter-typeahead").on("keyup", function(e) {
        //remove single quotes from input
        if (e.which === 52) {
            $(this).find(".tt-input").val($(this).find(".tt-input").val().replace(/'/g, ""));
            $(this).find(".tt-input").trigger("input");
        }
        if (e.which === 13) $(".tt-suggestion:first-child", this).trigger("click");
    });
}
function $bb1ebca3e5e63108$var$addTag(newTag, $tagInput, tagType) {
    fetch("/api/tag", {
        method: "post",
        headers: {
            "X-XSRF-Token": (0, $jwUJU.getCookie)("XSRF-TOKEN"),
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            name: newTag,
            type: tagType
        })
    }).then((0, $jwUJU.convertResponseToJson)).then((data)=>{
        if (window.bloodhoundTagAutocomplete) {
            window.bloodhoundTagAutocomplete.clear();
            window.bloodhoundTagAutocomplete.clearRemoteCache();
        }
        $tagInput.parent().find(".tt-input").val("");
        $tagInput.parent().find(".tt-input").trigger("input");
        $tagInput.tagsinput("add", {
            tagId: data.tagId,
            name: data.name
        });
    }).catch((0, $jwUJU.handleError));
}
window.addTag = $bb1ebca3e5e63108$var$addTag;
function $bb1ebca3e5e63108$var$removeQuery($tagInput) {
    $tagInput.parent().find(".tt-input").val("");
    $tagInput.parent().find(".tt-input").trigger("input");
}
window.removeQuery = $bb1ebca3e5e63108$var$removeQuery;
function $bb1ebca3e5e63108$export$76aa4a834c5849fc(selector, tagType, selectorParentNode) {
    const addTagText = (0, $33ozY.default).t("Frontend.tags.add-tag", {
        0: "%query%"
    }).replace("%query%", "{{query}}");
    const emptyTemplate = document.getElementById("add-tag-template").innerHTML;
    const emptyTemplateFn = Handlebars.compile(emptyTemplate);
    const emptyTemplateContent = emptyTemplateFn({
        tagBody: "{{query}}",
        addTagText: addTagText,
        selector: selector,
        tagType: tagType
    });
    $bb1ebca3e5e63108$export$8b98dbd817393b28($(selector, selectorParentNode), emptyTemplateContent, tagType);
    $(selector).each(function() {
        var $input = $(this);
        let currentTags = $input.attr("tags");
        if (currentTags) {
            var tags = JSON.parse(currentTags);
            if (tags.length) tags.forEach(function(tag) {
                $input.tagsinput("add", {
                    tagId: tag.id,
                    name: tag.description
                }, {
                    preventPost: true
                });
            });
        }
    });
}

});
parcelRegister("33ozY", function(module, exports) {

$parcel$export(module.exports, "default", () => $de1c191ccc1b0cb9$export$2e2bcd8739ae039);

var $l5cY7 = parcelRequire("l5cY7");

var $gQYZb = parcelRequire("gQYZb");

var $bjeXt = parcelRequire("bjeXt");

var $4OXlf = parcelRequire("4OXlf");
const $de1c191ccc1b0cb9$var$userLanguage = window.camalion.userLanguage;
const $de1c191ccc1b0cb9$var$camalionStaticVersion = window.camalion.staticVersion;
const $de1c191ccc1b0cb9$var$developmentMode = window.camalion.developmentMode;
let $de1c191ccc1b0cb9$var$basePath = window.AcrossWebModule.staticPath;
(0, $l5cY7.default).use((0, $gQYZb.default)).init({
    lng: $de1c191ccc1b0cb9$var$userLanguage,
    fallbackLng: "en",
    load: "currentOnly",
    nsSeparator: false,
    keySeparator: false,
    backend: {
        backends: [
            (0, $bjeXt.default),
            (0, $4OXlf.default)
        ],
        backendOptions: [
            {
                prefix: "i18next_res_",
                defaultVersion: $de1c191ccc1b0cb9$var$camalionStaticVersion,
                expirationTime: $de1c191ccc1b0cb9$var$developmentMode ? 0 : 604800000,
                store: window.localStorage
            },
            {
                loadPath: $de1c191ccc1b0cb9$var$basePath + "/" + $de1c191ccc1b0cb9$var$camalionStaticVersion + "/camashop/i18n/{lng}/translations.json"
            }
        ]
    },
    interpolation: {
        prefix: "{",
        // prefix: '{[\\d]+',
        suffix: "}"
    }
});
var $de1c191ccc1b0cb9$export$2e2bcd8739ae039 = (0, $l5cY7.default);

});
parcelRegister("gQYZb", function(module, exports) {

$parcel$export(module.exports, "default", () => $c450cf2b8ef06a9c$export$2e2bcd8739ae039);

var $k20Ab = parcelRequire("k20Ab");

var $327Rj = parcelRequire("327Rj");
var $c450cf2b8ef06a9c$var$arr = [];
var $c450cf2b8ef06a9c$var$each = $c450cf2b8ef06a9c$var$arr.forEach;
var $c450cf2b8ef06a9c$var$slice = $c450cf2b8ef06a9c$var$arr.slice;
function $c450cf2b8ef06a9c$var$defaults(obj) {
    $c450cf2b8ef06a9c$var$each.call($c450cf2b8ef06a9c$var$slice.call(arguments, 1), function(source) {
        if (source) {
            for(var prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
function $c450cf2b8ef06a9c$var$createClassOnDemand(ClassOrObject) {
    if (!ClassOrObject) return null;
    if (typeof ClassOrObject === "function") return new ClassOrObject();
    return ClassOrObject;
}
function $c450cf2b8ef06a9c$var$getDefaults() {
    return {
        handleEmptyResourcesAsFailed: true,
        cacheHitMode: "none"
    };
}
function $c450cf2b8ef06a9c$var$handleCorrectReadFunction(backend, language, namespace, resolver) {
    var fc = backend.read.bind(backend);
    if (fc.length === 2) {
        // no callback
        try {
            var r = fc(language, namespace);
            if (r && typeof r.then === "function") // promise
            r.then(function(data) {
                return resolver(null, data);
            })["catch"](resolver);
            else // sync
            resolver(null, r);
        } catch (err) {
            resolver(err);
        }
        return;
    }
    // normal with callback
    fc(language, namespace, resolver);
}
var $c450cf2b8ef06a9c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Backend(services) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var i18nextOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        (0, $k20Ab.default)(this, Backend);
        this.backends = [];
        this.type = "backend";
        this.allOptions = i18nextOptions;
        this.init(services, options);
    }
    (0, $327Rj.default)(Backend, [
        {
            key: "init",
            value: function init(services) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var i18nextOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                this.services = services;
                this.options = $c450cf2b8ef06a9c$var$defaults(options, this.options || {}, $c450cf2b8ef06a9c$var$getDefaults());
                this.allOptions = i18nextOptions;
                this.options.backends && this.options.backends.forEach(function(b, i) {
                    _this.backends[i] = _this.backends[i] || $c450cf2b8ef06a9c$var$createClassOnDemand(b);
                    _this.backends[i].init(services, _this.options.backendOptions && _this.options.backendOptions[i] || {}, i18nextOptions);
                });
                if (this.services && this.options.reloadInterval) setInterval(function() {
                    return _this.reload();
                }, this.options.reloadInterval);
            }
        },
        {
            key: "read",
            value: function read(language, namespace, callback) {
                var _this2 = this;
                var bLen = this.backends.length;
                var loadPosition = function loadPosition(pos) {
                    if (pos >= bLen) return callback(new Error("non of the backend loaded data", true)); // failed pass retry flag
                    var isLastBackend = pos === bLen - 1;
                    var lengthCheckAmount = _this2.options.handleEmptyResourcesAsFailed && !isLastBackend ? 0 : -1;
                    var backend = _this2.backends[pos];
                    if (backend.read) $c450cf2b8ef06a9c$var$handleCorrectReadFunction(backend, language, namespace, function(err, data, savedAt) {
                        if (!err && data && Object.keys(data).length > lengthCheckAmount) {
                            callback(null, data, pos);
                            savePosition(pos - 1, data); // save one in front
                            if (backend.save && _this2.options.cacheHitMode && [
                                "refresh",
                                "refreshAndUpdateStore"
                            ].indexOf(_this2.options.cacheHitMode) > -1) {
                                if (savedAt && _this2.options.refreshExpirationTime && savedAt + _this2.options.refreshExpirationTime > Date.now()) return;
                                var nextBackend = _this2.backends[pos + 1];
                                if (nextBackend && nextBackend.read) $c450cf2b8ef06a9c$var$handleCorrectReadFunction(nextBackend, language, namespace, function(err, data) {
                                    if (err) return;
                                    if (!data) return;
                                    if (Object.keys(data).length <= lengthCheckAmount) return;
                                    savePosition(pos, data);
                                    if (_this2.options.cacheHitMode !== "refreshAndUpdateStore") return;
                                    if (_this2.services && _this2.services.resourceStore) _this2.services.resourceStore.addResourceBundle(language, namespace, data);
                                });
                            }
                        } else loadPosition(pos + 1); // try load from next
                    });
                    else loadPosition(pos + 1); // try load from next
                };
                var savePosition = function savePosition(pos, data) {
                    if (pos < 0) return;
                    var backend = _this2.backends[pos];
                    if (backend.save) {
                        backend.save(language, namespace, data);
                        savePosition(pos - 1, data);
                    } else savePosition(pos - 1, data);
                };
                loadPosition(0);
            }
        },
        {
            key: "create",
            value: function create(languages, namespace, key, fallbackValue) {
                var clb = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function() {};
                var opts = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                this.backends.forEach(function(b) {
                    if (!b.create) return;
                    var fc = b.create.bind(b);
                    if (fc.length < 6) {
                        // no callback
                        try {
                            var r;
                            if (fc.length === 5) // future callback-less api for i18next-locize-backend
                            r = fc(languages, namespace, key, fallbackValue, opts);
                            else r = fc(languages, namespace, key, fallbackValue);
                            if (r && typeof r.then === "function") // promise
                            r.then(function(data) {
                                return clb(null, data);
                            })["catch"](clb);
                            else // sync
                            clb(null, r);
                        } catch (err) {
                            clb(err);
                        }
                        return;
                    }
                    // normal with callback
                    fc(languages, namespace, key, fallbackValue, clb /* unused callback */ , opts);
                });
            }
        },
        {
            key: "reload",
            value: function reload() {
                var _this3 = this;
                var _this$services = this.services, backendConnector = _this$services.backendConnector, languageUtils = _this$services.languageUtils, logger = _this$services.logger;
                var currentLanguage = backendConnector.language;
                if (currentLanguage && currentLanguage.toLowerCase() === "cimode") return; // avoid loading resources for cimode
                var toLoad = [];
                var append = function append(lng) {
                    var lngs = languageUtils.toResolveHierarchy(lng);
                    lngs.forEach(function(l) {
                        if (toLoad.indexOf(l) < 0) toLoad.push(l);
                    });
                };
                append(currentLanguage);
                if (this.allOptions.preload) this.allOptions.preload.forEach(function(l) {
                    return append(l);
                });
                toLoad.forEach(function(lng) {
                    _this3.allOptions.ns.forEach(function(ns) {
                        backendConnector.read(lng, ns, "read", null, null, function(err, data) {
                            if (err) logger.warn("loading namespace ".concat(ns, " for language ").concat(lng, " failed"), err);
                            if (!err && data) logger.log("loaded namespace ".concat(ns, " for language ").concat(lng), data);
                            backendConnector.loaded("".concat(lng, "|").concat(ns), err, data);
                        });
                    });
                });
            }
        }
    ]);
    return Backend;
}();
$c450cf2b8ef06a9c$export$2e2bcd8739ae039.type = "backend";

});
parcelRegister("k20Ab", function(module, exports) {

$parcel$export(module.exports, "default", () => $e954723e94b4a2de$export$2e2bcd8739ae039);
function $e954723e94b4a2de$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("327Rj", function(module, exports) {

$parcel$export(module.exports, "default", () => $2357a796a59d9b04$export$2e2bcd8739ae039);

var $j2E3R = parcelRequire("j2E3R");
function $2357a796a59d9b04$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $j2E3R.default)(descriptor.key), descriptor);
    }
}
function $2357a796a59d9b04$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $2357a796a59d9b04$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $2357a796a59d9b04$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}

});
parcelRegister("j2E3R", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddcd4793373faf83$export$2e2bcd8739ae039);

var $cwSwb = parcelRequire("cwSwb");

var $bdyQi = parcelRequire("bdyQi");
function $ddcd4793373faf83$export$2e2bcd8739ae039(arg) {
    var key = (0, $bdyQi.default)(arg, "string");
    return (0, $cwSwb.default)(key) === "symbol" ? key : String(key);
}

});
parcelRegister("cwSwb", function(module, exports) {

$parcel$export(module.exports, "default", () => $91f2c359417535c0$export$2e2bcd8739ae039);
function $91f2c359417535c0$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $91f2c359417535c0$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $91f2c359417535c0$export$2e2bcd8739ae039(o);
}

});

parcelRegister("bdyQi", function(module, exports) {

$parcel$export(module.exports, "default", () => $82abef94db586cee$export$2e2bcd8739ae039);

var $cwSwb = parcelRequire("cwSwb");
function $82abef94db586cee$export$2e2bcd8739ae039(input, hint) {
    if ((0, $cwSwb.default)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $cwSwb.default)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

});




parcelRegister("bjeXt", function(module, exports) {

$parcel$export(module.exports, "default", () => $83bd127383f65208$export$2e2bcd8739ae039);

var $9QtdP = parcelRequire("9QtdP");

var $2lfr3 = parcelRequire("2lfr3");

var $19wiI = parcelRequire("19wiI");
function $83bd127383f65208$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $83bd127383f65208$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $83bd127383f65208$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $9QtdP.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $83bd127383f65208$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/* eslint-disable max-classes-per-file */ var $83bd127383f65208$var$Storage = /*#__PURE__*/ function() {
    function Storage(options) {
        (0, $2lfr3.default)(this, Storage);
        this.store = options.store;
    }
    (0, $19wiI.default)(Storage, [
        {
            key: "setItem",
            value: function setItem(key, value) {
                if (this.store) try {
                    this.store.setItem(key, value);
                } catch (e) {
                // f.log('failed to set value for key "' + key + '" to localStorage.');
                }
            }
        },
        {
            key: "getItem",
            value: function getItem(key, value) {
                if (this.store) try {
                    return this.store.getItem(key, value);
                } catch (e) {
                // f.log('failed to get value for key "' + key + '" from localStorage.');
                }
                return undefined;
            }
        }
    ]);
    return Storage;
}();
function $83bd127383f65208$var$getDefaults() {
    var store = null;
    try {
        store = window.localStorage;
    } catch (e) {
        if (typeof window !== "undefined") console.log("Failed to load local storage.", e);
    }
    return {
        prefix: "i18next_res_",
        expirationTime: 604800000,
        defaultVersion: undefined,
        versions: {},
        store: store
    };
}
var $83bd127383f65208$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Cache(services) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $2lfr3.default)(this, Cache);
        this.init(services, options);
        this.type = "backend";
    }
    (0, $19wiI.default)(Cache, [
        {
            key: "init",
            value: function init(services) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                this.services = services;
                this.options = $83bd127383f65208$var$_objectSpread($83bd127383f65208$var$_objectSpread($83bd127383f65208$var$_objectSpread({}, $83bd127383f65208$var$getDefaults()), this.options), options);
                this.storage = new $83bd127383f65208$var$Storage(this.options);
            }
        },
        {
            key: "read",
            value: function read(language, namespace, callback) {
                var nowMS = Date.now();
                if (!this.storage.store) return callback(null, null);
                var local = this.storage.getItem("".concat(this.options.prefix).concat(language, "-").concat(namespace));
                if (local) {
                    local = JSON.parse(local);
                    var version = this.getVersion(language);
                    if (// expiration field is mandatory, and should not be expired
                    local.i18nStamp && local.i18nStamp + this.options.expirationTime > nowMS && // there should be no language version set, or if it is, it should match the one in translation
                    version === local.i18nVersion) {
                        var i18nStamp = local.i18nStamp;
                        delete local.i18nVersion;
                        delete local.i18nStamp;
                        return callback(null, local, i18nStamp);
                    }
                }
                return callback(null, null);
            }
        },
        {
            key: "save",
            value: function save(language, namespace, data) {
                if (this.storage.store) {
                    data.i18nStamp = Date.now();
                    // language version (if set)
                    var version = this.getVersion(language);
                    if (version) data.i18nVersion = version;
                    // save
                    this.storage.setItem("".concat(this.options.prefix).concat(language, "-").concat(namespace), JSON.stringify(data));
                }
            }
        },
        {
            key: "getVersion",
            value: function getVersion(language) {
                return this.options.versions[language] || this.options.defaultVersion;
            }
        }
    ]);
    return Cache;
}();
$83bd127383f65208$export$2e2bcd8739ae039.type = "backend";

});
parcelRegister("9QtdP", function(module, exports) {

$parcel$export(module.exports, "default", () => $72afa34833808965$export$2e2bcd8739ae039);

var $a3QZG = parcelRequire("a3QZG");
function $72afa34833808965$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $a3QZG.default)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});
parcelRegister("a3QZG", function(module, exports) {

$parcel$export(module.exports, "default", () => $75334aa89eb03c07$export$2e2bcd8739ae039);

var $5Z1ta = parcelRequire("5Z1ta");

var $3nMiA = parcelRequire("3nMiA");
function $75334aa89eb03c07$export$2e2bcd8739ae039(arg) {
    var key = (0, $3nMiA.default)(arg, "string");
    return (0, $5Z1ta.default)(key) === "symbol" ? key : String(key);
}

});
parcelRegister("5Z1ta", function(module, exports) {

$parcel$export(module.exports, "default", () => $45b3ca1398772e95$export$2e2bcd8739ae039);
function $45b3ca1398772e95$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $45b3ca1398772e95$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $45b3ca1398772e95$export$2e2bcd8739ae039(o);
}

});

parcelRegister("3nMiA", function(module, exports) {

$parcel$export(module.exports, "default", () => $2768fc3b9d5e363a$export$2e2bcd8739ae039);

var $5Z1ta = parcelRequire("5Z1ta");
function $2768fc3b9d5e363a$export$2e2bcd8739ae039(input, hint) {
    if ((0, $5Z1ta.default)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $5Z1ta.default)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

});



parcelRegister("2lfr3", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b498417d6a7a7e7$export$2e2bcd8739ae039);
function $1b498417d6a7a7e7$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("19wiI", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d6faff7340f5791$export$2e2bcd8739ae039);

var $a3QZG = parcelRequire("a3QZG");
function $0d6faff7340f5791$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $a3QZG.default)(descriptor.key), descriptor);
    }
}
function $0d6faff7340f5791$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $0d6faff7340f5791$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $0d6faff7340f5791$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}

});


parcelRegister("4OXlf", function(module, exports) {

$parcel$export(module.exports, "default", () => $3829dcf0a17b618d$export$2e2bcd8739ae039);

var $lGXxj = parcelRequire("lGXxj");

var $jq8zO = parcelRequire("jq8zO");
function $3829dcf0a17b618d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3829dcf0a17b618d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3829dcf0a17b618d$var$_typeof(o);
}
function $3829dcf0a17b618d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3829dcf0a17b618d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $3829dcf0a17b618d$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $3829dcf0a17b618d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3829dcf0a17b618d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3829dcf0a17b618d$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $3829dcf0a17b618d$var$_defineProperty(obj, key, value) {
    key = $3829dcf0a17b618d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3829dcf0a17b618d$var$_toPropertyKey(arg) {
    var key = $3829dcf0a17b618d$var$_toPrimitive(arg, "string");
    return $3829dcf0a17b618d$var$_typeof(key) === "symbol" ? key : String(key);
}
function $3829dcf0a17b618d$var$_toPrimitive(input, hint) {
    if ($3829dcf0a17b618d$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($3829dcf0a17b618d$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $3829dcf0a17b618d$var$getDefaults = function getDefaults() {
    return {
        loadPath: "/locales/{{lng}}/{{ns}}.json",
        addPath: "/locales/add/{{lng}}/{{ns}}",
        parse: function parse(data) {
            return JSON.parse(data);
        },
        stringify: JSON.stringify,
        parsePayload: function parsePayload(namespace, key, fallbackValue) {
            return $3829dcf0a17b618d$var$_defineProperty({}, key, fallbackValue || "");
        },
        parseLoadPayload: function parseLoadPayload(languages, namespaces) {
            return undefined;
        },
        request: (0, $jq8zO.default),
        reloadInterval: typeof window !== "undefined" ? false : 3600000,
        customHeaders: {},
        queryStringParams: {},
        crossDomain: false,
        withCredentials: false,
        overrideMimeType: false,
        requestOptions: {
            mode: "cors",
            credentials: "same-origin",
            cache: "default"
        }
    };
};
var $3829dcf0a17b618d$var$Backend = function() {
    function Backend(services) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        $3829dcf0a17b618d$var$_classCallCheck(this, Backend);
        this.services = services;
        this.options = options;
        this.allOptions = allOptions;
        this.type = "backend";
        this.init(services, options, allOptions);
    }
    $3829dcf0a17b618d$var$_createClass(Backend, [
        {
            key: "init",
            value: function init(services) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                this.services = services;
                this.options = (0, $lGXxj.defaults)(options, this.options || {}, $3829dcf0a17b618d$var$getDefaults());
                this.allOptions = allOptions;
                if (this.services && this.options.reloadInterval) setInterval(function() {
                    return _this.reload();
                }, this.options.reloadInterval);
            }
        },
        {
            key: "readMulti",
            value: function readMulti(languages, namespaces, callback) {
                this._readAny(languages, languages, namespaces, namespaces, callback);
            }
        },
        {
            key: "read",
            value: function read(language, namespace, callback) {
                this._readAny([
                    language
                ], language, [
                    namespace
                ], namespace, callback);
            }
        },
        {
            key: "_readAny",
            value: function _readAny(languages, loadUrlLanguages, namespaces, loadUrlNamespaces, callback) {
                var _this2 = this;
                var loadPath = this.options.loadPath;
                if (typeof this.options.loadPath === "function") loadPath = this.options.loadPath(languages, namespaces);
                loadPath = (0, $lGXxj.makePromise)(loadPath);
                loadPath.then(function(resolvedLoadPath) {
                    if (!resolvedLoadPath) return callback(null, {});
                    var url = _this2.services.interpolator.interpolate(resolvedLoadPath, {
                        lng: languages.join("+"),
                        ns: namespaces.join("+")
                    });
                    _this2.loadUrl(url, callback, loadUrlLanguages, loadUrlNamespaces);
                });
            }
        },
        {
            key: "loadUrl",
            value: function loadUrl(url, callback, languages, namespaces) {
                var _this3 = this;
                var lng = typeof languages === "string" ? [
                    languages
                ] : languages;
                var ns = typeof namespaces === "string" ? [
                    namespaces
                ] : namespaces;
                var payload = this.options.parseLoadPayload(lng, ns);
                this.options.request(this.options, url, payload, function(err, res) {
                    if (res && (res.status >= 500 && res.status < 600 || !res.status)) return callback("failed loading " + url + "; status code: " + res.status, true);
                    if (res && res.status >= 400 && res.status < 500) return callback("failed loading " + url + "; status code: " + res.status, false);
                    if (!res && err && err.message && err.message.indexOf("Failed to fetch") > -1) return callback("failed loading " + url + ": " + err.message, true);
                    if (err) return callback(err, false);
                    var ret, parseErr;
                    try {
                        if (typeof res.data === "string") ret = _this3.options.parse(res.data, languages, namespaces);
                        else ret = res.data;
                    } catch (e) {
                        parseErr = "failed parsing " + url + " to json";
                    }
                    if (parseErr) return callback(parseErr, false);
                    callback(null, ret);
                });
            }
        },
        {
            key: "create",
            value: function create(languages, namespace, key, fallbackValue, callback) {
                var _this4 = this;
                if (!this.options.addPath) return;
                if (typeof languages === "string") languages = [
                    languages
                ];
                var payload = this.options.parsePayload(namespace, key, fallbackValue);
                var finished = 0;
                var dataArray = [];
                var resArray = [];
                languages.forEach(function(lng) {
                    var addPath = _this4.options.addPath;
                    if (typeof _this4.options.addPath === "function") addPath = _this4.options.addPath(lng, namespace);
                    var url = _this4.services.interpolator.interpolate(addPath, {
                        lng: lng,
                        ns: namespace
                    });
                    _this4.options.request(_this4.options, url, payload, function(data, res) {
                        finished += 1;
                        dataArray.push(data);
                        resArray.push(res);
                        if (finished === languages.length) {
                            if (typeof callback === "function") callback(dataArray, resArray);
                        }
                    });
                });
            }
        },
        {
            key: "reload",
            value: function reload() {
                var _this5 = this;
                var _this$services = this.services, backendConnector = _this$services.backendConnector, languageUtils = _this$services.languageUtils, logger = _this$services.logger;
                var currentLanguage = backendConnector.language;
                if (currentLanguage && currentLanguage.toLowerCase() === "cimode") return;
                var toLoad = [];
                var append = function append(lng) {
                    var lngs = languageUtils.toResolveHierarchy(lng);
                    lngs.forEach(function(l) {
                        if (toLoad.indexOf(l) < 0) toLoad.push(l);
                    });
                };
                append(currentLanguage);
                if (this.allOptions.preload) this.allOptions.preload.forEach(function(l) {
                    return append(l);
                });
                toLoad.forEach(function(lng) {
                    _this5.allOptions.ns.forEach(function(ns) {
                        backendConnector.read(lng, ns, "read", null, null, function(err, data) {
                            if (err) logger.warn("loading namespace ".concat(ns, " for language ").concat(lng, " failed"), err);
                            if (!err && data) logger.log("loaded namespace ".concat(ns, " for language ").concat(lng), data);
                            backendConnector.loaded("".concat(lng, "|").concat(ns), err, data);
                        });
                    });
                });
            }
        }
    ]);
    return Backend;
}();
$3829dcf0a17b618d$var$Backend.type = "backend";
var $3829dcf0a17b618d$export$2e2bcd8739ae039 = $3829dcf0a17b618d$var$Backend;

});
parcelRegister("lGXxj", function(module, exports) {

$parcel$export(module.exports, "defaults", () => $fcabb3e3a95855c5$export$ebe90cb607ad99e);
$parcel$export(module.exports, "hasXMLHttpRequest", () => $fcabb3e3a95855c5$export$87022daa49baf612);
$parcel$export(module.exports, "makePromise", () => $fcabb3e3a95855c5$export$1625492ec82002b9);
function $fcabb3e3a95855c5$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $fcabb3e3a95855c5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $fcabb3e3a95855c5$var$_typeof(o);
}
var $fcabb3e3a95855c5$var$arr = [];
var $fcabb3e3a95855c5$var$each = $fcabb3e3a95855c5$var$arr.forEach;
var $fcabb3e3a95855c5$var$slice = $fcabb3e3a95855c5$var$arr.slice;
function $fcabb3e3a95855c5$export$ebe90cb607ad99e(obj) {
    $fcabb3e3a95855c5$var$each.call($fcabb3e3a95855c5$var$slice.call(arguments, 1), function(source) {
        if (source) {
            for(var prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
function $fcabb3e3a95855c5$export$87022daa49baf612() {
    return typeof XMLHttpRequest === "function" || (typeof XMLHttpRequest === "undefined" ? "undefined" : $fcabb3e3a95855c5$var$_typeof(XMLHttpRequest)) === "object";
}
function $fcabb3e3a95855c5$var$isPromise(maybePromise) {
    return !!maybePromise && typeof maybePromise.then === "function";
}
function $fcabb3e3a95855c5$export$1625492ec82002b9(maybePromise) {
    if ($fcabb3e3a95855c5$var$isPromise(maybePromise)) return maybePromise;
    return Promise.resolve(maybePromise);
}

});

parcelRegister("jq8zO", function(module, exports) {

$parcel$export(module.exports, "default", () => $03a60ccb14049a23$export$2e2bcd8739ae039);

var $lGXxj = parcelRequire("lGXxj");

var $bjlc5 = parcelRequire("bjlc5");
function $03a60ccb14049a23$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $03a60ccb14049a23$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $03a60ccb14049a23$var$_typeof(o);
}
var $03a60ccb14049a23$var$fetchApi;
if (typeof fetch === "function") {
    if (typeof $parcel$global !== "undefined" && $parcel$global.fetch) $03a60ccb14049a23$var$fetchApi = $parcel$global.fetch;
    else if (typeof window !== "undefined" && window.fetch) $03a60ccb14049a23$var$fetchApi = window.fetch;
    else $03a60ccb14049a23$var$fetchApi = fetch;
}
var $03a60ccb14049a23$var$XmlHttpRequestApi;
if ((0, $lGXxj.hasXMLHttpRequest)()) {
    if (typeof $parcel$global !== "undefined" && $parcel$global.XMLHttpRequest) $03a60ccb14049a23$var$XmlHttpRequestApi = $parcel$global.XMLHttpRequest;
    else if (typeof window !== "undefined" && window.XMLHttpRequest) $03a60ccb14049a23$var$XmlHttpRequestApi = window.XMLHttpRequest;
}
var $03a60ccb14049a23$var$ActiveXObjectApi;
if (typeof ActiveXObject === "function") {
    if (typeof $parcel$global !== "undefined" && $parcel$global.ActiveXObject) $03a60ccb14049a23$var$ActiveXObjectApi = $parcel$global.ActiveXObject;
    else if (typeof window !== "undefined" && window.ActiveXObject) $03a60ccb14049a23$var$ActiveXObjectApi = window.ActiveXObject;
}
if (!$03a60ccb14049a23$var$fetchApi && $bjlc5 && !$03a60ccb14049a23$var$XmlHttpRequestApi && !$03a60ccb14049a23$var$ActiveXObjectApi) $03a60ccb14049a23$var$fetchApi = $bjlc5.default || $bjlc5;
if (typeof $03a60ccb14049a23$var$fetchApi !== "function") $03a60ccb14049a23$var$fetchApi = undefined;
var $03a60ccb14049a23$var$addQueryString = function addQueryString(url, params) {
    if (params && $03a60ccb14049a23$var$_typeof(params) === "object") {
        var queryString = "";
        for(var paramName in params)queryString += "&" + encodeURIComponent(paramName) + "=" + encodeURIComponent(params[paramName]);
        if (!queryString) return url;
        url = url + (url.indexOf("?") !== -1 ? "&" : "?") + queryString.slice(1);
    }
    return url;
};
var $03a60ccb14049a23$var$fetchIt = function fetchIt(url, fetchOptions, callback) {
    var resolver = function resolver(response) {
        if (!response.ok) return callback(response.statusText || "Error", {
            status: response.status
        });
        response.text().then(function(data) {
            callback(null, {
                status: response.status,
                data: data
            });
        }).catch(callback);
    };
    if (typeof fetch === "function") fetch(url, fetchOptions).then(resolver).catch(callback);
    else $03a60ccb14049a23$var$fetchApi(url, fetchOptions).then(resolver).catch(callback);
};
var $03a60ccb14049a23$var$omitFetchOptions = false;
var $03a60ccb14049a23$var$requestWithFetch = function requestWithFetch(options, url, payload, callback) {
    if (options.queryStringParams) url = $03a60ccb14049a23$var$addQueryString(url, options.queryStringParams);
    var headers = (0, $lGXxj.defaults)({}, typeof options.customHeaders === "function" ? options.customHeaders() : options.customHeaders);
    if (typeof window === "undefined" && typeof $parcel$global !== "undefined" && typeof $parcel$global.process !== "undefined" && $parcel$global.process.versions && $parcel$global.process.versions.node) headers["User-Agent"] = "i18next-http-backend (node/".concat($parcel$global.process.version, "; ").concat($parcel$global.process.platform, " ").concat($parcel$global.process.arch, ")");
    if (payload) headers["Content-Type"] = "application/json";
    var reqOptions = typeof options.requestOptions === "function" ? options.requestOptions(payload) : options.requestOptions;
    var fetchOptions = (0, $lGXxj.defaults)({
        method: payload ? "POST" : "GET",
        body: payload ? options.stringify(payload) : undefined,
        headers: headers
    }, $03a60ccb14049a23$var$omitFetchOptions ? {} : reqOptions);
    try {
        $03a60ccb14049a23$var$fetchIt(url, fetchOptions, callback);
    } catch (e) {
        if (!reqOptions || Object.keys(reqOptions).length === 0 || !e.message || e.message.indexOf("not implemented") < 0) return callback(e);
        try {
            Object.keys(reqOptions).forEach(function(opt) {
                delete fetchOptions[opt];
            });
            $03a60ccb14049a23$var$fetchIt(url, fetchOptions, callback);
            $03a60ccb14049a23$var$omitFetchOptions = true;
        } catch (err) {
            callback(err);
        }
    }
};
var $03a60ccb14049a23$var$requestWithXmlHttpRequest = function requestWithXmlHttpRequest(options, url, payload, callback) {
    if (payload && $03a60ccb14049a23$var$_typeof(payload) === "object") payload = $03a60ccb14049a23$var$addQueryString("", payload).slice(1);
    if (options.queryStringParams) url = $03a60ccb14049a23$var$addQueryString(url, options.queryStringParams);
    try {
        var x;
        if ($03a60ccb14049a23$var$XmlHttpRequestApi) x = new $03a60ccb14049a23$var$XmlHttpRequestApi();
        else x = new $03a60ccb14049a23$var$ActiveXObjectApi("MSXML2.XMLHTTP.3.0");
        x.open(payload ? "POST" : "GET", url, 1);
        if (!options.crossDomain) x.setRequestHeader("X-Requested-With", "XMLHttpRequest");
        x.withCredentials = !!options.withCredentials;
        if (payload) x.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
        if (x.overrideMimeType) x.overrideMimeType("application/json");
        var h = options.customHeaders;
        h = typeof h === "function" ? h() : h;
        if (h) for(var i in h)x.setRequestHeader(i, h[i]);
        x.onreadystatechange = function() {
            x.readyState > 3 && callback(x.status >= 400 ? x.statusText : null, {
                status: x.status,
                data: x.responseText
            });
        };
        x.send(payload);
    } catch (e) {
        console && console.log(e);
    }
};
var $03a60ccb14049a23$var$request = function request(options, url, payload, callback) {
    if (typeof payload === "function") {
        callback = payload;
        payload = undefined;
    }
    callback = callback || function() {};
    if ($03a60ccb14049a23$var$fetchApi && url.indexOf("file:") !== 0) return $03a60ccb14049a23$var$requestWithFetch(options, url, payload, callback);
    if ((0, $lGXxj.hasXMLHttpRequest)() || typeof ActiveXObject === "function") return $03a60ccb14049a23$var$requestWithXmlHttpRequest(options, url, payload, callback);
    callback(new Error("No fetch and no xhr implementation found!"));
};
var $03a60ccb14049a23$export$2e2bcd8739ae039 = $03a60ccb14049a23$var$request;

});
parcelRegister("bjlc5", function(module, exports) {
var $d856e2e9a887b49a$var$fetchApi;
if (typeof fetch === "function") {
    if (typeof $parcel$global !== "undefined" && $parcel$global.fetch) $d856e2e9a887b49a$var$fetchApi = $parcel$global.fetch;
    else if (typeof window !== "undefined" && window.fetch) $d856e2e9a887b49a$var$fetchApi = window.fetch;
    else $d856e2e9a887b49a$var$fetchApi = fetch;
}

if (typeof window === "undefined" || typeof window.document === "undefined") {
    var $d856e2e9a887b49a$var$f = $d856e2e9a887b49a$var$fetchApi || (parcelRequire("16s93"));
    if ($d856e2e9a887b49a$var$f.default) $d856e2e9a887b49a$var$f = $d856e2e9a887b49a$var$f.default;
    module.exports.default = $d856e2e9a887b49a$var$f;
    module.exports = module.exports.default;
}

});
parcelRegister("16s93", function(module, exports) {
// Save global object in a variable
var __global__ = typeof globalThis !== "undefined" && globalThis || typeof self !== "undefined" && self || typeof $parcel$global !== "undefined" && $parcel$global;
// Create an object that extends from __global__ without the fetch function
var __globalThis__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = __global__.DOMException;
    }
    F.prototype = __global__; // Needed for feature detection on whatwg-fetch's code
    return new F();
}();
// Wraps whatwg-fetch with a function scope to hijack the global object
// "globalThis" that's going to be patched
(function(globalThis1) {
    var irrelevant = function(exports1) {
        var global1 = typeof globalThis1 !== "undefined" && globalThis1 || typeof self !== "undefined" && self || typeof global1 !== "undefined" && global1;
        var support = {
            searchParams: "URLSearchParams" in global1,
            iterable: "Symbol" in global1 && "iterator" in Symbol,
            blob: "FileReader" in global1 && "Blob" in global1 && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: "FormData" in global1,
            arrayBuffer: "ArrayBuffer" in global1
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                "[object Int8Array]",
                "[object Uint8Array]",
                "[object Uint8ClampedArray]",
                "[object Int16Array]",
                "[object Uint16Array]",
                "[object Int32Array]",
                "[object Uint32Array]",
                "[object Float32Array]",
                "[object Float64Array]"
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== "string") name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === "") throw new TypeError('Invalid character in header field name: "' + name + '"');
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== "string") value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ", " + value : value;
        };
        Headers.prototype["delete"] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body.bodyUsed) return Promise.reject(new TypeError("Already read"));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsText(blob);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join("");
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                /*
        fetch-mock wraps the Response object in an ES6 Proxy to
        provide useful test harness features such as flush. However, on
        ES5 browsers without fetch or Proxy support pollyfills must be used;
        the proxy-pollyfill is unable to proxy an attribute unless it exists
        on the object before the Proxy is created. This change ensures
        Response.bodyUsed exists on the instance, while maintaining the
        semantic of setting Request.bodyUsed in the constructor before
        _initBody is called.
      */ this.bodyUsed = this.bodyUsed;
                this._bodyInit = body;
                if (!body) this._bodyText = "";
                else if (typeof body === "string") this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get("content-type")) {
                    if (typeof body === "string") this.headers.set("content-type", "text/plain;charset=UTF-8");
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set("content-type", this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
                }
            };
            if (support.blob) {
                this.blob = function() {
                    var rejected = consumed(this);
                    if (rejected) return rejected;
                    if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                    else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                        this._bodyArrayBuffer
                    ]));
                    else if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                    else return Promise.resolve(new Blob([
                        this._bodyText
                    ]));
                };
                this.arrayBuffer = function() {
                    if (this._bodyArrayBuffer) {
                        var isConsumed = consumed(this);
                        if (isConsumed) return isConsumed;
                        if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
                        else return Promise.resolve(this._bodyArrayBuffer);
                    } else return this.blob().then(readBlobAsArrayBuffer);
                };
            }
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error("could not read FormData body as text");
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            "DELETE",
            "GET",
            "HEAD",
            "OPTIONS",
            "POST",
            "PUT"
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            if (!(this instanceof Request)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError("Already read");
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || "same-origin";
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || "GET");
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal;
            this.referrer = null;
            if ((this.method === "GET" || this.method === "HEAD") && body) throw new TypeError("Body not allowed for GET or HEAD requests");
            this._initBody(body);
            if (this.method === "GET" || this.method === "HEAD") {
                if (options.cache === "no-store" || options.cache === "no-cache") {
                    // Search for a '_' parameter in the query string
                    var reParamSearch = /([?&])_=[^&]*/;
                    if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
                    this.url = this.url.replace(reParamSearch, "$1_=" + new Date().getTime());
                    else {
                        // Otherwise add a new '_' parameter to the end with the current time
                        var reQueryString = /\?/;
                        this.url += (reQueryString.test(this.url) ? "&" : "?") + "_=" + new Date().getTime();
                    }
                }
            }
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split("&").forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split("=");
                    var name = split.shift().replace(/\+/g, " ");
                    var value = split.join("=").replace(/\+/g, " ");
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
            // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
            // https://github.com/github/fetch/issues/748
            // https://github.com/zloirock/core-js/issues/751
            preProcessedHeaders.split("\r").map(function(header) {
                return header.indexOf("\n") === 0 ? header.substr(1, header.length) : header;
            }).forEach(function(line) {
                var parts = line.split(":");
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(":").trim();
                    headers.append(key, value);
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!(this instanceof Response)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            if (!options) options = {};
            this.type = "default";
            this.status = options.status === undefined ? 200 : options.status;
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = options.statusText === undefined ? "" : "" + options.statusText;
            this.headers = new Headers(options.headers);
            this.url = options.url || "";
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 0,
                statusText: ""
            });
            response.type = "error";
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError("Invalid status code");
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = global1.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException("Aborted", "AbortError"));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        status: xhr.status,
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || "")
                    };
                    options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
                    var body = "response" in xhr ? xhr.response : xhr.responseText;
                    setTimeout(function() {
                        resolve(new Response(body, options));
                    }, 0);
                };
                xhr.onerror = function() {
                    setTimeout(function() {
                        reject(new TypeError("Network request failed"));
                    }, 0);
                };
                xhr.ontimeout = function() {
                    setTimeout(function() {
                        reject(new TypeError("Network request failed"));
                    }, 0);
                };
                xhr.onabort = function() {
                    setTimeout(function() {
                        reject(new exports1.DOMException("Aborted", "AbortError"));
                    }, 0);
                };
                function fixUrl(url) {
                    try {
                        return url === "" && global1.location.href ? global1.location.href : url;
                    } catch (e) {
                        return url;
                    }
                }
                xhr.open(request.method, fixUrl(request.url), true);
                if (request.credentials === "include") xhr.withCredentials = true;
                else if (request.credentials === "omit") xhr.withCredentials = false;
                if ("responseType" in xhr) {
                    if (support.blob) xhr.responseType = "blob";
                    else if (support.arrayBuffer && request.headers.get("Content-Type") && request.headers.get("Content-Type").indexOf("application/octet-stream") !== -1) xhr.responseType = "arraybuffer";
                }
                if (init && typeof init.headers === "object" && !(init.headers instanceof Headers)) Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                    xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
                });
                else request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener("abort", abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener("abort", abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!global1.fetch) {
            global1.fetch = fetch;
            global1.Headers = Headers;
            global1.Request = Request;
            global1.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        return exports1;
    }({});
})(__globalThis__);
// This is a ponyfill, so...
__globalThis__.fetch.ponyfill = true;
delete __globalThis__.fetch.polyfill;
// Choose between native implementation (__global__) or custom implementation (__globalThis__)
var ctx = __global__.fetch ? __global__ : __globalThis__;
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

});







parcelRegister("4cFjd", function(module, exports) {

var $jwUJU = parcelRequire("jwUJU");

var $4ZoVl = parcelRequire("4ZoVl");

var $fF4Ij = parcelRequire("fF4Ij");

var $6EtAI = parcelRequire("6EtAI");

var $l1VEz = parcelRequire("l1VEz");
(0, (/*@__PURE__*/$parcel$interopDefault($fF4Ij))).plugins.register([
    $6EtAI
]);
EntityModule.registerInitializer(function(node) {
    $(".js-audio-detail-button", node).on("click", function(e) {
        const assetLibraryEntryId = $(this).attr("data-asset-library-entry-id");
        const waveSurfer = $(".wave-surfer", node).prop("wavesurferInstance");
        if (waveSurfer !== undefined && waveSurfer !== null) waveSurfer.pause();
        $30f8537b7f601595$var$showAudioDetailModal(assetLibraryEntryId);
    });
});
function $30f8537b7f601595$var$calculateSpaceForNonAudioElements() {
    const PINK_BACKDROP = 20;
    const ASSET_INFO = 92;
    const PLAYER = 40;
    const WAVE_MARGIN = 20;
    const TIMELINE = 20;
    const MODAL_TITLE = 50;
    const MODAL_BORDER = 2;
    const LINE_BETWEEN_WAVES = 1;
    return PINK_BACKDROP + ASSET_INFO + PLAYER + WAVE_MARGIN + TIMELINE + MODAL_TITLE + MODAL_BORDER + LINE_BETWEEN_WAVES;
}
function $30f8537b7f601595$var$showAudioDetailModal(assetLibraryEntryId) {
    fetch("/manager/audio-details?assetLibraryEntryId=" + assetLibraryEntryId).then((data)=>data.text()).then((data)=>{
        $("#modal .modal-dialog").addClass("modal-xl modal-audio-detail");
        $("#modal .modal-content").html(data);
        $("#modal").modal("show");
        const spaceForNonAudioElements = $30f8537b7f601595$var$calculateSpaceForNonAudioElements();
        const calculatedAudioSpace = window.innerHeight - spaceForNonAudioElements;
        const calculatedChartHeight = calculatedAudioSpace / 2;
        const topChartWrapper = $(".chart-wrapper-top");
        const bottomChartWrapper = $(".chart-wrapper-bottom");
        topChartWrapper.css("height", calculatedChartHeight);
        topChartWrapper.css("min-height", calculatedChartHeight);
        $("#chart-top").css("height", calculatedChartHeight);
        bottomChartWrapper.css("height", calculatedChartHeight);
        bottomChartWrapper.css("min-height", calculatedChartHeight);
        bottomChartWrapper.css("top", calculatedChartHeight);
        $("#chart-bottom").css("height", calculatedChartHeight);
        $("#peak-meter").css("height", calculatedAudioSpace);
        $(".audio-detail-wave-surfer", $("#modal .modal-content")).each(function() {
            const assetWaveId = $(this).attr("data-asset-waver");
            const duration = $(".wave", this).attr("data-asset-duration");
            var audioCtx = new (window.AudioContext || window.webkitAudioContext)();
            const wavesurfer = (0, $4ZoVl.initWaveSurfer)(this, duration, ".audio-detail-wave-surfer .wave[data-asset-waver='" + assetWaveId + "']", ".audio-detail-wave-surfer .wave-timeline", calculatedChartHeight, audioCtx);
            const peakMeter = $("#modal #peak-meter").get(0);
            const audio = $("#modal audio").get(0);
            const sourceNode = audioCtx.createMediaElementSource(audio);
            sourceNode.connect(audioCtx.destination);
            const meterNode = (0, (/*@__PURE__*/$parcel$interopDefault($l1VEz))).createMeterNode(sourceNode, audioCtx);
            (0, (/*@__PURE__*/$parcel$interopDefault($l1VEz))).createMeter(peakMeter, meterNode, {
                borderSize: 4,
                fontSize: 12,
                backgroundColor: "white",
                tickColor: "#888",
                labelColor: "#888",
                //gradient: ['#dc3545 1%', '#ff0 16%', 'lime 45%','#4caf50 100%'],
                gradient: [
                    "#dc3545 1%",
                    "#ffc107 16%",
                    "#4caf50 45%",
                    "#28a745 100%"
                ],
                dbRange: 48,
                dbTickSize: 6
            });
            $("#modal").one("hidden.bs.modal", function() {
                meterNode.disconnect();
                sourceNode.disconnect();
                wavesurfer.destroy();
            });
            wavesurfer.on("waveform-ready", function() {
                const width = wavesurfer.mediaContainer.scrollWidth;
                let peaks = wavesurfer.backend.getPeaks(width, 0, width);
                let firstPeaks = peaks[0];
                let secondPeaks = peaks[1];
                let combinedMin = Math.min(wavesurfer.util.min(firstPeaks), wavesurfer.util.min(secondPeaks));
                let combinedMax = Math.max(wavesurfer.util.max(firstPeaks), wavesurfer.util.max(secondPeaks));
                $30f8537b7f601595$var$drawChart("chart-top", combinedMin, combinedMax);
                $30f8537b7f601595$var$drawChart("chart-bottom", combinedMin, combinedMax);
            });
        });
    }).catch((0, $jwUJU.handleError));
}
function $30f8537b7f601595$var$drawChart(elementId, min, max) {
    // const actualAbsoluteYAxisValue = Math.max(Math.abs(min), Math.abs(max));
    const actualAbsoluteYAxisValue = 1;
    var ctx = document.getElementById(elementId).getContext("2d");
    const vrtPreferredMaxPeak = 0.354813; // linear value for -9 dB
    var chart = new (0, (/*@__PURE__*/$parcel$interopDefault($fF4Ij)))(ctx, {
        type: "line",
        options: {
            maintainAspectRatio: false,
            annotation: {
                annotations: [
                    {
                        type: "line",
                        mode: "horizontal",
                        scaleID: "y-axis-0",
                        value: vrtPreferredMaxPeak,
                        borderWidth: 1,
                        borderColor: "#C010C0",
                        label: {
                            enabled: false
                        }
                    },
                    {
                        type: "line",
                        mode: "horizontal",
                        scaleID: "y-axis-0",
                        value: -vrtPreferredMaxPeak,
                        borderWidth: 1,
                        borderColor: "#C010C0",
                        label: {
                            enabled: false
                        }
                    }
                ]
            },
            elements: {
                point: {
                    radius: 0
                }
            },
            legend: {
                display: false
            },
            scales: {
                xAxes: [
                    {
                        display: false
                    }
                ],
                yAxes: [
                    {
                        ticks: {
                            min: -actualAbsoluteYAxisValue,
                            max: actualAbsoluteYAxisValue,
                            precision: 2,
                            stepSize: actualAbsoluteYAxisValue / 4.0,
                            callback: function(value) {
                                const db = 20.0 * Math.log10(Math.abs(value));
                                //const val = Math.round((db + Number.EPSILON) * 10) / 10;
                                if (db === Infinity) return "Inf";
                                if (db === -Infinity) return "-Inf";
                                return (Math.round(db * 10.0) / 10.0).toFixed(1);
                            }
                        }
                    }
                ]
            }
        }
    });
}

});
parcelRegister("4ZoVl", function(module, exports) {

$parcel$export(module.exports, "initWaveSurfer", () => $3a203146973578bb$export$8cec704859d86746);

var $bB862 = parcelRequire("bB862");

var $1PHuw = parcelRequire("1PHuw");

var $9gA9b = parcelRequire("9gA9b");
function $3a203146973578bb$var$formatTimeCallback(seconds, pxPerSec) {
    seconds = Number(seconds);
    var minutes = Math.floor(seconds / 60);
    seconds = seconds % 60;
    var secondsStr = Math.round(seconds).toString();
    secondsStr = seconds.toFixed(0);
    if (minutes > 0) {
        if (seconds < 10) secondsStr = "0" + secondsStr;
        return `${minutes}:${secondsStr}`;
    }
    return secondsStr;
}
function $3a203146973578bb$var$timeInterval(pxPerSec) {
    return 1;
}
function $3a203146973578bb$var$primaryLabelInterval(pxPerSec) {
    return 1;
}
function $3a203146973578bb$var$secondaryLabelInterval(pxPerSec) {
    return 0;
}
function $3a203146973578bb$export$8cec704859d86746(node, duration, container, timelineContainer, height, audioContext) {
    const wavesurfer = (0, (/*@__PURE__*/$parcel$interopDefault($bB862))).create({
        container: container,
        waveColor: "#007bff",
        progressColor: "#0056b3",
        backend: "MediaElement",
        splitChannels: true,
        cursorColor: "#c010c0",
        height: height,
        audioContext: audioContext,
        splitChannelsOptions: {
            overlay: false,
            relativeNormalization: true,
            filterChannels: [],
            channelColors: {
                0: {
                    progressColor: "#0056b3",
                    waveColor: "#007bff"
                },
                1: {
                    progressColor: "#0056b3",
                    waveColor: "#007bff"
                }
            }
        },
        plugins: [
            (0, (/*@__PURE__*/$parcel$interopDefault($1PHuw))).create({
                formatTimeCallback: $3a203146973578bb$var$formatTimeCallback,
                timeInterval: $3a203146973578bb$var$timeInterval,
                primaryLabelInterval: $3a203146973578bb$var$primaryLabelInterval,
                secondaryLabelInterval: $3a203146973578bb$var$secondaryLabelInterval,
                container: timelineContainer
            }),
            (0, (/*@__PURE__*/$parcel$interopDefault($9gA9b))).create({
                showTime: true,
                opacity: 1,
                customShowTimeStyle: {
                    "background-color": "#c010c0",
                    color: "#fff",
                    padding: "2px",
                    "font-size": "15px"
                }
            })
        ]
    });
    $(node).prop("wavesurferInstance", wavesurfer);
    const source = $(".wave", node).attr("data-src");
    wavesurfer.on("waveform-ready", function() {
        $(wavesurfer.params.container).prev().addClass("d-none");
    });
    wavesurfer.load(source);
    const play = $(".play", node);
    const pause = $(".pause", node);
    $(".wave-play-button", node).on("click", wavesurfer.playPause.bind(wavesurfer));
    $(".wave-play-button", node).on("click", ()=>{
        if (play.hasClass("show")) {
            pause.addClass("show");
            play.removeClass("show");
        } else {
            play.addClass("show");
            pause.removeClass("show");
        }
    });
    wavesurfer.on("finish", function() {
        play.addClass("show");
        pause.removeClass("show");
    });
    return wavesurfer;
}

});
parcelRegister("bB862", function(module, exports) {
/*!
 * wavesurfer.js 4.6.0 (2021-03-05)
 * https://wavesurfer-js.org
 * @license BSD-3-Clause
 */ (function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
})(module.exports, function() {
    return /******/ (()=>{
        /******/ var __webpack_modules__ = {
            /***/ "./src/drawer.canvasentry.js": /*!***********************************!*\
  !*** ./src/drawer.canvasentry.js ***!
  \***********************************/ /***/ (module1, exports, __webpack_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var _style = _interopRequireDefault(__webpack_require__(/*! ./util/style */ "./src/util/style.js"));
                var _getId = _interopRequireDefault(__webpack_require__(/*! ./util/get-id */ "./src/util/get-id.js"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                /**
 * The `CanvasEntry` class represents an element consisting of a wave `canvas`
 * and an (optional) progress wave `canvas`.
 *
 * The `MultiCanvas` renderer uses one or more `CanvasEntry` instances to
 * render a waveform, depending on the zoom level.
 */ var CanvasEntry = /*#__PURE__*/ function() {
                    function CanvasEntry() {
                        _classCallCheck(this, CanvasEntry);
                        /**
     * The wave node
     *
     * @type {HTMLCanvasElement}
     */ this.wave = null;
                        /**
     * The wave canvas rendering context
     *
     * @type {CanvasRenderingContext2D}
     */ this.waveCtx = null;
                        /**
     * The (optional) progress wave node
     *
     * @type {HTMLCanvasElement}
     */ this.progress = null;
                        /**
     * The (optional) progress wave canvas rendering context
     *
     * @type {CanvasRenderingContext2D}
     */ this.progressCtx = null;
                        /**
     * Start of the area the canvas should render, between 0 and 1
     *
     * @type {number}
     */ this.start = 0;
                        /**
     * End of the area the canvas should render, between 0 and 1
     *
     * @type {number}
     */ this.end = 1;
                        /**
     * Unique identifier for this entry
     *
     * @type {string}
     */ this.id = (0, _getId.default)(typeof this.constructor.name !== "undefined" ? this.constructor.name.toLowerCase() + "_" : "canvasentry_");
                        /**
     * Canvas 2d context attributes
     *
     * @type {object}
     */ this.canvasContextAttributes = {};
                    }
                    /**
   * Store the wave canvas element and create the 2D rendering context
   *
   * @param {HTMLCanvasElement} element The wave `canvas` element.
   */ _createClass(CanvasEntry, [
                        {
                            key: "initWave",
                            value: function initWave(element) {
                                this.wave = element;
                                this.waveCtx = this.wave.getContext("2d", this.canvasContextAttributes);
                            }
                        },
                        {
                            key: "initProgress",
                            value: function initProgress(element) {
                                this.progress = element;
                                this.progressCtx = this.progress.getContext("2d", this.canvasContextAttributes);
                            }
                        },
                        {
                            key: "updateDimensions",
                            value: function updateDimensions(elementWidth, totalWidth, width, height) {
                                // where the canvas starts and ends in the waveform, represented as a
                                // decimal between 0 and 1
                                this.start = this.wave.offsetLeft / totalWidth || 0;
                                this.end = this.start + elementWidth / totalWidth; // set wave canvas dimensions
                                this.wave.width = width;
                                this.wave.height = height;
                                var elementSize = {
                                    width: elementWidth + "px"
                                };
                                (0, _style.default)(this.wave, elementSize);
                                if (this.hasProgressCanvas) {
                                    // set progress canvas dimensions
                                    this.progress.width = width;
                                    this.progress.height = height;
                                    (0, _style.default)(this.progress, elementSize);
                                }
                            }
                        },
                        {
                            key: "clearWave",
                            value: function clearWave() {
                                // wave
                                this.waveCtx.clearRect(0, 0, this.waveCtx.canvas.width, this.waveCtx.canvas.height); // progress
                                if (this.hasProgressCanvas) this.progressCtx.clearRect(0, 0, this.progressCtx.canvas.width, this.progressCtx.canvas.height);
                            }
                        },
                        {
                            key: "setFillStyles",
                            value: function setFillStyles(waveColor, progressColor) {
                                this.waveCtx.fillStyle = waveColor;
                                if (this.hasProgressCanvas) this.progressCtx.fillStyle = progressColor;
                            }
                        },
                        {
                            key: "fillRects",
                            value: function fillRects(x, y, width, height, radius) {
                                this.fillRectToContext(this.waveCtx, x, y, width, height, radius);
                                if (this.hasProgressCanvas) this.fillRectToContext(this.progressCtx, x, y, width, height, radius);
                            }
                        },
                        {
                            key: "fillRectToContext",
                            value: function fillRectToContext(ctx, x, y, width, height, radius) {
                                if (!ctx) return;
                                if (radius) this.drawRoundedRect(ctx, x, y, width, height, radius);
                                else ctx.fillRect(x, y, width, height);
                            }
                        },
                        {
                            key: "drawRoundedRect",
                            value: function drawRoundedRect(ctx, x, y, width, height, radius) {
                                if (height === 0) return;
                                 // peaks are float values from -1 to 1. Use absolute height values in
                                // order to correctly calculate rounded rectangle coordinates
                                if (height < 0) {
                                    height *= -1;
                                    y -= height;
                                }
                                ctx.beginPath();
                                ctx.moveTo(x + radius, y);
                                ctx.lineTo(x + width - radius, y);
                                ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
                                ctx.lineTo(x + width, y + height - radius);
                                ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
                                ctx.lineTo(x + radius, y + height);
                                ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
                                ctx.lineTo(x, y + radius);
                                ctx.quadraticCurveTo(x, y, x + radius, y);
                                ctx.closePath();
                                ctx.fill();
                            }
                        },
                        {
                            key: "drawLines",
                            value: function drawLines(peaks, absmax, halfH, offsetY, start, end) {
                                this.drawLineToContext(this.waveCtx, peaks, absmax, halfH, offsetY, start, end);
                                if (this.hasProgressCanvas) this.drawLineToContext(this.progressCtx, peaks, absmax, halfH, offsetY, start, end);
                            }
                        },
                        {
                            key: "drawLineToContext",
                            value: function drawLineToContext(ctx, peaks, absmax, halfH, offsetY, start, end) {
                                if (!ctx) return;
                                var length = peaks.length / 2;
                                var first = Math.round(length * this.start); // use one more peak value to make sure we join peaks at ends -- unless,
                                // of course, this is the last canvas
                                var last = Math.round(length * this.end) + 1;
                                var canvasStart = first;
                                var canvasEnd = last;
                                var scale = this.wave.width / (canvasEnd - canvasStart - 1); // optimization
                                var halfOffset = halfH + offsetY;
                                var absmaxHalf = absmax / halfH;
                                ctx.beginPath();
                                ctx.moveTo((canvasStart - first) * scale, halfOffset);
                                ctx.lineTo((canvasStart - first) * scale, halfOffset - Math.round((peaks[2 * canvasStart] || 0) / absmaxHalf));
                                var i, peak, h;
                                for(i = canvasStart; i < canvasEnd; i++){
                                    peak = peaks[2 * i] || 0;
                                    h = Math.round(peak / absmaxHalf);
                                    ctx.lineTo((i - first) * scale + this.halfPixel, halfOffset - h);
                                } // draw the bottom edge going backwards, to make a single
                                // closed hull to fill
                                var j = canvasEnd - 1;
                                for(j; j >= canvasStart; j--){
                                    peak = peaks[2 * j + 1] || 0;
                                    h = Math.round(peak / absmaxHalf);
                                    ctx.lineTo((j - first) * scale + this.halfPixel, halfOffset - h);
                                }
                                ctx.lineTo((canvasStart - first) * scale, halfOffset - Math.round((peaks[2 * canvasStart + 1] || 0) / absmaxHalf));
                                ctx.closePath();
                                ctx.fill();
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                this.waveCtx = null;
                                this.wave = null;
                                this.progressCtx = null;
                                this.progress = null;
                            }
                        },
                        {
                            key: "getImage",
                            value: function getImage(format, quality, type) {
                                var _this = this;
                                if (type === "blob") return new Promise(function(resolve) {
                                    _this.wave.toBlob(resolve, format, quality);
                                });
                                else if (type === "dataURL") return this.wave.toDataURL(format, quality);
                            }
                        }
                    ]);
                    return CanvasEntry;
                }();
                exports.default = CanvasEntry;
                module1.exports = exports.default;
            /***/ },
            /***/ "./src/drawer.js": /*!***********************!*\
  !*** ./src/drawer.js ***!
  \***********************/ /***/ (module1, exports, __webpack_require__)=>{
                "use strict";
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var util = _interopRequireWildcard(__webpack_require__(/*! ./util */ "./src/util/index.js"));
                function _getRequireWildcardCache() {
                    if (typeof WeakMap !== "function") return null;
                    var cache = new WeakMap();
                    _getRequireWildcardCache = function _getRequireWildcardCache() {
                        return cache;
                    };
                    return cache;
                }
                function _interopRequireWildcard(obj) {
                    if (obj && obj.__esModule) return obj;
                    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") return {
                        default: obj
                    };
                    var cache = _getRequireWildcardCache();
                    if (cache && cache.has(obj)) return cache.get(obj);
                    var newObj = {};
                    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
                        else newObj[key] = obj[key];
                    }
                    newObj.default = obj;
                    if (cache) cache.set(obj, newObj);
                    return newObj;
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) _setPrototypeOf(subClass, superClass);
                }
                function _setPrototypeOf(o, p) {
                    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                        o.__proto__ = p;
                        return o;
                    };
                    return _setPrototypeOf(o, p);
                }
                function _createSuper(Derived) {
                    var hasNativeReflectConstruct = _isNativeReflectConstruct();
                    return function _createSuperInternal() {
                        var Super = _getPrototypeOf(Derived), result;
                        if (hasNativeReflectConstruct) {
                            var NewTarget = _getPrototypeOf(this).constructor;
                            result = Reflect.construct(Super, arguments, NewTarget);
                        } else result = Super.apply(this, arguments);
                        return _possibleConstructorReturn(this, result);
                    };
                }
                function _possibleConstructorReturn(self, call) {
                    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
                    return _assertThisInitialized(self);
                }
                function _assertThisInitialized(self) {
                    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self;
                }
                function _isNativeReflectConstruct() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                function _getPrototypeOf(o) {
                    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                        return o.__proto__ || Object.getPrototypeOf(o);
                    };
                    return _getPrototypeOf(o);
                }
                /**
 * Parent class for renderers
 *
 * @extends {Observer}
 */ var Drawer = /*#__PURE__*/ function(_util$Observer) {
                    _inherits(Drawer, _util$Observer);
                    var _super = _createSuper(Drawer);
                    /**
   * @param {HTMLElement} container The container node of the wavesurfer instance
   * @param {WavesurferParams} params The wavesurfer initialisation options
   */ function Drawer(container, params) {
                        var _this;
                        _classCallCheck(this, Drawer);
                        _this = _super.call(this);
                        _this.container = container;
                        /**
     * @type {WavesurferParams}
     */ _this.params = params;
                        /**
     * The width of the renderer
     * @type {number}
     */ _this.width = 0;
                        /**
     * The height of the renderer
     * @type {number}
     */ _this.height = params.height * _this.params.pixelRatio;
                        _this.lastPos = 0;
                        /**
     * The `<wave>` element which is added to the container
     * @type {HTMLElement}
     */ _this.wrapper = null;
                        return _this;
                    }
                    /**
   * Alias of `util.style`
   *
   * @param {HTMLElement} el The element that the styles will be applied to
   * @param {Object} styles The map of propName: attribute, both are used as-is
   * @return {HTMLElement} el
   */ _createClass(Drawer, [
                        {
                            key: "style",
                            value: function style(el, styles) {
                                return util.style(el, styles);
                            }
                        },
                        {
                            key: "createWrapper",
                            value: function createWrapper() {
                                this.wrapper = this.container.appendChild(document.createElement("wave"));
                                this.style(this.wrapper, {
                                    display: "block",
                                    position: "relative",
                                    userSelect: "none",
                                    webkitUserSelect: "none",
                                    height: this.params.height + "px"
                                });
                                if (this.params.fillParent || this.params.scrollParent) this.style(this.wrapper, {
                                    width: "100%",
                                    overflowX: this.params.hideScrollbar ? "hidden" : "auto",
                                    overflowY: "hidden"
                                });
                                this.setupWrapperEvents();
                            }
                        },
                        {
                            key: "handleEvent",
                            value: function handleEvent(e, noPrevent) {
                                !noPrevent && e.preventDefault();
                                var clientX = e.targetTouches ? e.targetTouches[0].clientX : e.clientX;
                                var bbox = this.wrapper.getBoundingClientRect();
                                var nominalWidth = this.width;
                                var parentWidth = this.getWidth();
                                var progress;
                                if (!this.params.fillParent && nominalWidth < parentWidth) progress = (this.params.rtl ? bbox.right - clientX : clientX - bbox.left) * (this.params.pixelRatio / nominalWidth) || 0;
                                else progress = ((this.params.rtl ? bbox.right - clientX : clientX - bbox.left) + this.wrapper.scrollLeft) / this.wrapper.scrollWidth || 0;
                                return util.clamp(progress, 0, 1);
                            }
                        },
                        {
                            key: "setupWrapperEvents",
                            value: function setupWrapperEvents() {
                                var _this2 = this;
                                this.wrapper.addEventListener("click", function(e) {
                                    var scrollbarHeight = _this2.wrapper.offsetHeight - _this2.wrapper.clientHeight;
                                    if (scrollbarHeight !== 0) {
                                        // scrollbar is visible.  Check if click was on it
                                        var bbox = _this2.wrapper.getBoundingClientRect();
                                        if (e.clientY >= bbox.bottom - scrollbarHeight) // ignore mousedown as it was on the scrollbar
                                        return;
                                    }
                                    if (_this2.params.interact) _this2.fireEvent("click", e, _this2.handleEvent(e));
                                });
                                this.wrapper.addEventListener("dblclick", function(e) {
                                    if (_this2.params.interact) _this2.fireEvent("dblclick", e, _this2.handleEvent(e));
                                });
                                this.wrapper.addEventListener("scroll", function(e) {
                                    return _this2.fireEvent("scroll", e);
                                });
                            }
                        },
                        {
                            key: "drawPeaks",
                            value: function drawPeaks(peaks, length, start, end) {
                                if (!this.setWidth(length)) this.clearWave();
                                this.params.barWidth ? this.drawBars(peaks, 0, start, end) : this.drawWave(peaks, 0, start, end);
                            }
                        },
                        {
                            key: "resetScroll",
                            value: function resetScroll() {
                                if (this.wrapper !== null) this.wrapper.scrollLeft = 0;
                            }
                        },
                        {
                            key: "recenter",
                            value: function recenter(percent) {
                                var position = this.wrapper.scrollWidth * percent;
                                this.recenterOnPosition(position, true);
                            }
                        },
                        {
                            key: "recenterOnPosition",
                            value: function recenterOnPosition(position, immediate) {
                                var scrollLeft = this.wrapper.scrollLeft;
                                var half = ~~(this.wrapper.clientWidth / 2);
                                var maxScroll = this.wrapper.scrollWidth - this.wrapper.clientWidth;
                                var target = position - half;
                                var offset = target - scrollLeft;
                                if (maxScroll == 0) // no need to continue if scrollbar is not there
                                return;
                                 // if the cursor is currently visible...
                                if (!immediate && -half <= offset && offset < half) {
                                    // set rate at which waveform is centered
                                    var rate = this.params.autoCenterRate; // make rate depend on width of view and length of waveform
                                    rate /= half;
                                    rate *= maxScroll;
                                    offset = Math.max(-rate, Math.min(rate, offset));
                                    target = scrollLeft + offset;
                                } // limit target to valid range (0 to maxScroll)
                                target = Math.max(0, Math.min(maxScroll, target)); // no use attempting to scroll if we're not moving
                                if (target != scrollLeft) this.wrapper.scrollLeft = target;
                            }
                        },
                        {
                            key: "getScrollX",
                            value: function getScrollX() {
                                var x = 0;
                                if (this.wrapper) {
                                    var pixelRatio = this.params.pixelRatio;
                                    x = Math.round(this.wrapper.scrollLeft * pixelRatio); // In cases of elastic scroll (safari with mouse wheel) you can
                                    // scroll beyond the limits of the container
                                    // Calculate and floor the scrollable extent to make sure an out
                                    // of bounds value is not returned
                                    // Ticket #1312
                                    if (this.params.scrollParent) {
                                        var maxScroll = ~~(this.wrapper.scrollWidth * pixelRatio - this.getWidth());
                                        x = Math.min(maxScroll, Math.max(0, x));
                                    }
                                }
                                return x;
                            }
                        },
                        {
                            key: "getWidth",
                            value: function getWidth() {
                                return Math.round(this.container.clientWidth * this.params.pixelRatio);
                            }
                        },
                        {
                            key: "setWidth",
                            value: function setWidth(width) {
                                if (this.width == width) return false;
                                this.width = width;
                                if (this.params.fillParent || this.params.scrollParent) this.style(this.wrapper, {
                                    width: ""
                                });
                                else this.style(this.wrapper, {
                                    width: ~~(this.width / this.params.pixelRatio) + "px"
                                });
                                this.updateSize();
                                return true;
                            }
                        },
                        {
                            key: "setHeight",
                            value: function setHeight(height) {
                                if (height == this.height) return false;
                                this.height = height;
                                this.style(this.wrapper, {
                                    height: ~~(this.height / this.params.pixelRatio) + "px"
                                });
                                this.updateSize();
                                return true;
                            }
                        },
                        {
                            key: "progress",
                            value: function progress(_progress) {
                                var minPxDelta = 1 / this.params.pixelRatio;
                                var pos = Math.round(_progress * this.width) * minPxDelta;
                                if (pos < this.lastPos || pos - this.lastPos >= minPxDelta) {
                                    this.lastPos = pos;
                                    if (this.params.scrollParent && this.params.autoCenter) {
                                        var newPos = ~~(this.wrapper.scrollWidth * _progress);
                                        this.recenterOnPosition(newPos, this.params.autoCenterImmediately);
                                    }
                                    this.updateProgress(pos);
                                }
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                this.unAll();
                                if (this.wrapper) {
                                    if (this.wrapper.parentNode == this.container) this.container.removeChild(this.wrapper);
                                    this.wrapper = null;
                                }
                            }
                        },
                        {
                            key: "updateCursor",
                            value: function updateCursor() {}
                        },
                        {
                            key: "updateSize",
                            value: function updateSize() {}
                        },
                        {
                            key: "drawBars",
                            value: function drawBars(peaks, channelIndex, start, end) {}
                        },
                        {
                            key: "drawWave",
                            value: function drawWave(peaks, channelIndex, start, end) {}
                        },
                        {
                            key: "clearWave",
                            value: function clearWave() {}
                        },
                        {
                            key: "updateProgress",
                            value: function updateProgress(position) {}
                        }
                    ]);
                    return Drawer;
                }(util.Observer);
                exports.default = Drawer;
                module1.exports = exports.default;
            /***/ },
            /***/ "./src/drawer.multicanvas.js": /*!***********************************!*\
  !*** ./src/drawer.multicanvas.js ***!
  \***********************************/ /***/ (module1, exports, __webpack_require__)=>{
                "use strict";
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var _drawer = _interopRequireDefault(__webpack_require__(/*! ./drawer */ "./src/drawer.js"));
                var util = _interopRequireWildcard(__webpack_require__(/*! ./util */ "./src/util/index.js"));
                var _drawer2 = _interopRequireDefault(__webpack_require__(/*! ./drawer.canvasentry */ "./src/drawer.canvasentry.js"));
                function _getRequireWildcardCache() {
                    if (typeof WeakMap !== "function") return null;
                    var cache = new WeakMap();
                    _getRequireWildcardCache = function _getRequireWildcardCache() {
                        return cache;
                    };
                    return cache;
                }
                function _interopRequireWildcard(obj) {
                    if (obj && obj.__esModule) return obj;
                    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") return {
                        default: obj
                    };
                    var cache = _getRequireWildcardCache();
                    if (cache && cache.has(obj)) return cache.get(obj);
                    var newObj = {};
                    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
                        else newObj[key] = obj[key];
                    }
                    newObj.default = obj;
                    if (cache) cache.set(obj, newObj);
                    return newObj;
                }
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) _setPrototypeOf(subClass, superClass);
                }
                function _setPrototypeOf(o, p) {
                    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                        o.__proto__ = p;
                        return o;
                    };
                    return _setPrototypeOf(o, p);
                }
                function _createSuper(Derived) {
                    var hasNativeReflectConstruct = _isNativeReflectConstruct();
                    return function _createSuperInternal() {
                        var Super = _getPrototypeOf(Derived), result;
                        if (hasNativeReflectConstruct) {
                            var NewTarget = _getPrototypeOf(this).constructor;
                            result = Reflect.construct(Super, arguments, NewTarget);
                        } else result = Super.apply(this, arguments);
                        return _possibleConstructorReturn(this, result);
                    };
                }
                function _possibleConstructorReturn(self, call) {
                    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
                    return _assertThisInitialized(self);
                }
                function _assertThisInitialized(self) {
                    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self;
                }
                function _isNativeReflectConstruct() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                function _getPrototypeOf(o) {
                    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                        return o.__proto__ || Object.getPrototypeOf(o);
                    };
                    return _getPrototypeOf(o);
                }
                /**
 * MultiCanvas renderer for wavesurfer. Is currently the default and sole
 * builtin renderer.
 *
 * A `MultiCanvas` consists of one or more `CanvasEntry` instances, depending
 * on the zoom level.
 */ var MultiCanvas = /*#__PURE__*/ function(_Drawer) {
                    _inherits(MultiCanvas, _Drawer);
                    var _super = _createSuper(MultiCanvas);
                    /**
   * @param {HTMLElement} container The container node of the wavesurfer instance
   * @param {WavesurferParams} params The wavesurfer initialisation options
   */ function MultiCanvas(container, params) {
                        var _this;
                        _classCallCheck(this, MultiCanvas);
                        _this = _super.call(this, container, params);
                        /**
     * @type {number}
     */ _this.maxCanvasWidth = params.maxCanvasWidth;
                        /**
     * @type {number}
     */ _this.maxCanvasElementWidth = Math.round(params.maxCanvasWidth / params.pixelRatio);
                        /**
     * Whether or not the progress wave is rendered. If the `waveColor`
     * and `progressColor` are the same color it is not.
     *
     * @type {boolean}
     */ _this.hasProgressCanvas = params.waveColor != params.progressColor;
                        /**
     * @type {number}
     */ _this.halfPixel = 0.5 / params.pixelRatio;
                        /**
     * List of `CanvasEntry` instances.
     *
     * @type {Array}
     */ _this.canvases = [];
                        /**
     * @type {HTMLElement}
     */ _this.progressWave = null;
                        /**
     * Class used to generate entries.
     *
     * @type {function}
     */ _this.EntryClass = _drawer2.default;
                        /**
     * Canvas 2d context attributes.
     *
     * @type {object}
     */ _this.canvasContextAttributes = params.drawingContextAttributes;
                        /**
     * Overlap added between entries to prevent vertical white stripes
     * between `canvas` elements.
     *
     * @type {number}
     */ _this.overlap = 2 * Math.ceil(params.pixelRatio / 2);
                        /**
     * The radius of the wave bars. Makes bars rounded
     *
     * @type {number}
     */ _this.barRadius = params.barRadius || 0;
                        return _this;
                    }
                    /**
   * Initialize the drawer
   */ _createClass(MultiCanvas, [
                        {
                            key: "init",
                            value: function init() {
                                this.createWrapper();
                                this.createElements();
                            }
                        },
                        {
                            key: "createElements",
                            value: function createElements() {
                                this.progressWave = this.wrapper.appendChild(this.style(document.createElement("wave"), {
                                    position: "absolute",
                                    zIndex: 3,
                                    left: 0,
                                    top: 0,
                                    bottom: 0,
                                    overflow: "hidden",
                                    width: "0",
                                    display: "none",
                                    boxSizing: "border-box",
                                    borderRightStyle: "solid",
                                    pointerEvents: "none"
                                }));
                                this.addCanvas();
                                this.updateCursor();
                            }
                        },
                        {
                            key: "updateCursor",
                            value: function updateCursor() {
                                this.style(this.progressWave, {
                                    borderRightWidth: this.params.cursorWidth + "px",
                                    borderRightColor: this.params.cursorColor
                                });
                            }
                        },
                        {
                            key: "updateSize",
                            value: function updateSize() {
                                var _this2 = this;
                                var totalWidth = Math.round(this.width / this.params.pixelRatio);
                                var requiredCanvases = Math.ceil(totalWidth / (this.maxCanvasElementWidth + this.overlap)); // add required canvases
                                while(this.canvases.length < requiredCanvases)this.addCanvas();
                                 // remove older existing canvases, if any
                                while(this.canvases.length > requiredCanvases)this.removeCanvas();
                                var canvasWidth = this.maxCanvasWidth + this.overlap;
                                var lastCanvas = this.canvases.length - 1;
                                this.canvases.forEach(function(entry, i) {
                                    if (i == lastCanvas) canvasWidth = _this2.width - _this2.maxCanvasWidth * lastCanvas;
                                    _this2.updateDimensions(entry, canvasWidth, _this2.height);
                                    entry.clearWave();
                                });
                            }
                        },
                        {
                            key: "addCanvas",
                            value: function addCanvas() {
                                var entry = new this.EntryClass();
                                entry.canvasContextAttributes = this.canvasContextAttributes;
                                entry.hasProgressCanvas = this.hasProgressCanvas;
                                entry.halfPixel = this.halfPixel;
                                var leftOffset = this.maxCanvasElementWidth * this.canvases.length; // wave
                                entry.initWave(this.wrapper.appendChild(this.style(document.createElement("canvas"), {
                                    position: "absolute",
                                    zIndex: 2,
                                    left: leftOffset + "px",
                                    top: 0,
                                    bottom: 0,
                                    height: "100%",
                                    pointerEvents: "none"
                                }))); // progress
                                if (this.hasProgressCanvas) entry.initProgress(this.progressWave.appendChild(this.style(document.createElement("canvas"), {
                                    position: "absolute",
                                    left: leftOffset + "px",
                                    top: 0,
                                    bottom: 0,
                                    height: "100%"
                                })));
                                this.canvases.push(entry);
                            }
                        },
                        {
                            key: "removeCanvas",
                            value: function removeCanvas() {
                                var lastEntry = this.canvases[this.canvases.length - 1]; // wave
                                lastEntry.wave.parentElement.removeChild(lastEntry.wave); // progress
                                if (this.hasProgressCanvas) lastEntry.progress.parentElement.removeChild(lastEntry.progress);
                                 // cleanup
                                if (lastEntry) {
                                    lastEntry.destroy();
                                    lastEntry = null;
                                }
                                this.canvases.pop();
                            }
                        },
                        {
                            key: "updateDimensions",
                            value: function updateDimensions(entry, width, height) {
                                var elementWidth = Math.round(width / this.params.pixelRatio);
                                var totalWidth = Math.round(this.width / this.params.pixelRatio); // update canvas dimensions
                                entry.updateDimensions(elementWidth, totalWidth, width, height); // style element
                                this.style(this.progressWave, {
                                    display: "block"
                                });
                            }
                        },
                        {
                            key: "clearWave",
                            value: function clearWave() {
                                var _this3 = this;
                                util.frame(function() {
                                    _this3.canvases.forEach(function(entry) {
                                        return entry.clearWave();
                                    });
                                })();
                            }
                        },
                        {
                            key: "drawBars",
                            value: function drawBars(peaks, channelIndex, start, end) {
                                var _this4 = this;
                                return this.prepareDraw(peaks, channelIndex, start, end, function(_ref) {
                                    var absmax = _ref.absmax, hasMinVals = _ref.hasMinVals, height = _ref.height, offsetY = _ref.offsetY, halfH = _ref.halfH, peaks = _ref.peaks, ch = _ref.channelIndex;
                                    // if drawBars was called within ws.empty we don't pass a start and
                                    // don't want anything to happen
                                    if (start === undefined) return;
                                     // Skip every other value if there are negatives.
                                    var peakIndexScale = hasMinVals ? 2 : 1;
                                    var length = peaks.length / peakIndexScale;
                                    var bar = _this4.params.barWidth * _this4.params.pixelRatio;
                                    var gap = _this4.params.barGap === null ? Math.max(_this4.params.pixelRatio, ~~(bar / 2)) : Math.max(_this4.params.pixelRatio, _this4.params.barGap * _this4.params.pixelRatio);
                                    var step = bar + gap;
                                    var scale = length / _this4.width;
                                    var first = start;
                                    var last = end;
                                    var i = first;
                                    for(i; i < last; i += step){
                                        var peak = peaks[Math.floor(i * scale * peakIndexScale)] || 0;
                                        var h = Math.round(peak / absmax * halfH);
                                        /* in case of silences, allow the user to specify that we
           * always draw *something* (normally a 1px high bar) */ if (h == 0 && _this4.params.barMinHeight) h = _this4.params.barMinHeight;
                                        _this4.fillRect(i + _this4.halfPixel, halfH - h + offsetY, bar + _this4.halfPixel, h * 2, _this4.barRadius, ch);
                                    }
                                });
                            }
                        },
                        {
                            key: "drawWave",
                            value: function drawWave(peaks, channelIndex, start, end) {
                                var _this5 = this;
                                return this.prepareDraw(peaks, channelIndex, start, end, function(_ref2) {
                                    var absmax = _ref2.absmax, hasMinVals = _ref2.hasMinVals, height = _ref2.height, offsetY = _ref2.offsetY, halfH = _ref2.halfH, peaks = _ref2.peaks, channelIndex = _ref2.channelIndex;
                                    if (!hasMinVals) {
                                        var reflectedPeaks = [];
                                        var len = peaks.length;
                                        var i = 0;
                                        for(i; i < len; i++){
                                            reflectedPeaks[2 * i] = peaks[i];
                                            reflectedPeaks[2 * i + 1] = -peaks[i];
                                        }
                                        peaks = reflectedPeaks;
                                    } // if drawWave was called within ws.empty we don't pass a start and
                                    // end and simply want a flat line
                                    if (start !== undefined) _this5.drawLine(peaks, absmax, halfH, offsetY, start, end, channelIndex);
                                     // always draw a median line
                                    _this5.fillRect(0, halfH + offsetY - _this5.halfPixel, _this5.width, _this5.halfPixel, _this5.barRadius, channelIndex);
                                });
                            }
                        },
                        {
                            key: "drawLine",
                            value: function drawLine(peaks, absmax, halfH, offsetY, start, end, channelIndex) {
                                var _this6 = this;
                                var _ref3 = this.params.splitChannelsOptions.channelColors[channelIndex] || {}, waveColor = _ref3.waveColor, progressColor = _ref3.progressColor;
                                this.canvases.forEach(function(entry, i) {
                                    _this6.setFillStyles(entry, waveColor, progressColor);
                                    entry.drawLines(peaks, absmax, halfH, offsetY, start, end);
                                });
                            }
                        },
                        {
                            key: "fillRect",
                            value: function fillRect(x, y, width, height, radius, channelIndex) {
                                var startCanvas = Math.floor(x / this.maxCanvasWidth);
                                var endCanvas = Math.min(Math.ceil((x + width) / this.maxCanvasWidth) + 1, this.canvases.length);
                                var i = startCanvas;
                                for(i; i < endCanvas; i++){
                                    var entry = this.canvases[i];
                                    var leftOffset = i * this.maxCanvasWidth;
                                    var intersection = {
                                        x1: Math.max(x, i * this.maxCanvasWidth),
                                        y1: y,
                                        x2: Math.min(x + width, i * this.maxCanvasWidth + entry.wave.width),
                                        y2: y + height
                                    };
                                    if (intersection.x1 < intersection.x2) {
                                        var _ref4 = this.params.splitChannelsOptions.channelColors[channelIndex] || {}, waveColor = _ref4.waveColor, progressColor = _ref4.progressColor;
                                        this.setFillStyles(entry, waveColor, progressColor);
                                        entry.fillRects(intersection.x1 - leftOffset, intersection.y1, intersection.x2 - intersection.x1, intersection.y2 - intersection.y1, radius);
                                    }
                                }
                            }
                        },
                        {
                            key: "hideChannel",
                            value: function hideChannel(channelIndex) {
                                return this.params.splitChannels && this.params.splitChannelsOptions.filterChannels.includes(channelIndex);
                            }
                        },
                        {
                            key: "prepareDraw",
                            value: function prepareDraw(peaks, channelIndex, start, end, fn, drawIndex, normalizedMax) {
                                var _this7 = this;
                                return util.frame(function() {
                                    // Split channels and call this function with the channelIndex set
                                    if (peaks[0] instanceof Array) {
                                        var channels = peaks;
                                        if (_this7.params.splitChannels) {
                                            var filteredChannels = channels.filter(function(c, i) {
                                                return !_this7.hideChannel(i);
                                            });
                                            if (!_this7.params.splitChannelsOptions.overlay) _this7.setHeight(Math.max(filteredChannels.length, 1) * _this7.params.height * _this7.params.pixelRatio);
                                            var overallAbsMax;
                                            if (_this7.params.splitChannelsOptions && _this7.params.splitChannelsOptions.relativeNormalization) // calculate maximum peak across channels to use for normalization
                                            overallAbsMax = util.max(channels.map(function(channelPeaks) {
                                                return util.absMax(channelPeaks);
                                            }));
                                            return channels.forEach(function(channelPeaks, i) {
                                                return _this7.prepareDraw(channelPeaks, i, start, end, fn, filteredChannels.indexOf(channelPeaks), overallAbsMax);
                                            });
                                        }
                                        peaks = channels[0];
                                    } // Return and do not draw channel peaks if hidden.
                                    if (_this7.hideChannel(channelIndex)) return;
                                     // calculate maximum modulation value, either from the barHeight
                                    // parameter or if normalize=true from the largest value in the peak
                                    // set
                                    var absmax = 1 / _this7.params.barHeight;
                                    if (_this7.params.normalize) absmax = normalizedMax === undefined ? util.absMax(peaks) : normalizedMax;
                                     // Bar wave draws the bottom only as a reflection of the top,
                                    // so we don't need negative values
                                    var hasMinVals = [].some.call(peaks, function(val) {
                                        return val < 0;
                                    });
                                    var height = _this7.params.height * _this7.params.pixelRatio;
                                    var halfH = height / 2;
                                    var offsetY = height * drawIndex || 0; // Override offsetY if overlay is true
                                    if (_this7.params.splitChannelsOptions && _this7.params.splitChannelsOptions.overlay) offsetY = 0;
                                    return fn({
                                        absmax: absmax,
                                        hasMinVals: hasMinVals,
                                        height: height,
                                        offsetY: offsetY,
                                        halfH: halfH,
                                        peaks: peaks,
                                        channelIndex: channelIndex
                                    });
                                })();
                            }
                        },
                        {
                            key: "setFillStyles",
                            value: function setFillStyles(entry) {
                                var waveColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.params.waveColor;
                                var progressColor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.params.progressColor;
                                entry.setFillStyles(waveColor, progressColor);
                            }
                        },
                        {
                            key: "getImage",
                            value: function getImage(format, quality, type) {
                                if (type === "blob") return Promise.all(this.canvases.map(function(entry) {
                                    return entry.getImage(format, quality, type);
                                }));
                                else if (type === "dataURL") {
                                    var images = this.canvases.map(function(entry) {
                                        return entry.getImage(format, quality, type);
                                    });
                                    return images.length > 1 ? images : images[0];
                                }
                            }
                        },
                        {
                            key: "updateProgress",
                            value: function updateProgress(position) {
                                this.style(this.progressWave, {
                                    width: position + "px"
                                });
                            }
                        }
                    ]);
                    return MultiCanvas;
                }(_drawer.default);
                exports.default = MultiCanvas;
                module1.exports = exports.default;
            /***/ },
            /***/ "./src/mediaelement-webaudio.js": /*!**************************************!*\
  !*** ./src/mediaelement-webaudio.js ***!
  \**************************************/ /***/ (module1, exports, __webpack_require__)=>{
                "use strict";
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var _mediaelement = _interopRequireDefault(__webpack_require__(/*! ./mediaelement */ "./src/mediaelement.js"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                function _get(target, property, receiver) {
                    if (typeof Reflect !== "undefined" && Reflect.get) _get = Reflect.get;
                    else _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) return desc.get.call(receiver);
                        return desc.value;
                    };
                    return _get(target, property, receiver || target);
                }
                function _superPropBase(object, property) {
                    while(!Object.prototype.hasOwnProperty.call(object, property)){
                        object = _getPrototypeOf(object);
                        if (object === null) break;
                    }
                    return object;
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) _setPrototypeOf(subClass, superClass);
                }
                function _setPrototypeOf(o, p) {
                    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                        o.__proto__ = p;
                        return o;
                    };
                    return _setPrototypeOf(o, p);
                }
                function _createSuper(Derived) {
                    var hasNativeReflectConstruct = _isNativeReflectConstruct();
                    return function _createSuperInternal() {
                        var Super = _getPrototypeOf(Derived), result;
                        if (hasNativeReflectConstruct) {
                            var NewTarget = _getPrototypeOf(this).constructor;
                            result = Reflect.construct(Super, arguments, NewTarget);
                        } else result = Super.apply(this, arguments);
                        return _possibleConstructorReturn(this, result);
                    };
                }
                function _possibleConstructorReturn(self, call) {
                    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
                    return _assertThisInitialized(self);
                }
                function _assertThisInitialized(self) {
                    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self;
                }
                function _isNativeReflectConstruct() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                function _getPrototypeOf(o) {
                    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                        return o.__proto__ || Object.getPrototypeOf(o);
                    };
                    return _getPrototypeOf(o);
                }
                /**
 * MediaElementWebAudio backend: load audio via an HTML5 audio tag, but playback with the WebAudio API.
 * The advantage here is that the html5 <audio> tag can perform range requests on the server and not
 * buffer the entire file in one request, and you still get the filtering and scripting functionality
 * of the webaudio API.
 * Note that in order to use range requests and prevent buffering, you must provide peak data.
 *
 * @since 3.2.0
 */ var MediaElementWebAudio = /*#__PURE__*/ function(_MediaElement) {
                    _inherits(MediaElementWebAudio, _MediaElement);
                    var _super = _createSuper(MediaElementWebAudio);
                    /**
   * Construct the backend
   *
   * @param {WavesurferParams} params Wavesurfer parameters
   */ function MediaElementWebAudio(params) {
                        var _this;
                        _classCallCheck(this, MediaElementWebAudio);
                        _this = _super.call(this, params);
                        /** @private */ _this.params = params;
                        /** @private */ _this.sourceMediaElement = null;
                        return _this;
                    }
                    /**
   * Initialise the backend, called in `wavesurfer.createBackend()`
   */ _createClass(MediaElementWebAudio, [
                        {
                            key: "init",
                            value: function init() {
                                this.setPlaybackRate(this.params.audioRate);
                                this.createTimer();
                                this.createVolumeNode();
                                this.createScriptNode();
                                this.createAnalyserNode();
                            }
                        },
                        {
                            key: "_load",
                            value: function _load(media, peaks, preload) {
                                _get(_getPrototypeOf(MediaElementWebAudio.prototype), "_load", this).call(this, media, peaks, preload);
                                this.createMediaElementSource(media);
                            }
                        },
                        {
                            key: "createMediaElementSource",
                            value: function createMediaElementSource(mediaElement) {
                                this.sourceMediaElement = this.ac.createMediaElementSource(mediaElement);
                                this.sourceMediaElement.connect(this.analyser);
                            }
                        },
                        {
                            key: "play",
                            value: function play(start, end) {
                                this.resumeAudioContext();
                                return _get(_getPrototypeOf(MediaElementWebAudio.prototype), "play", this).call(this, start, end);
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                _get(_getPrototypeOf(MediaElementWebAudio.prototype), "destroy", this).call(this);
                                this.destroyWebAudio();
                            }
                        }
                    ]);
                    return MediaElementWebAudio;
                }(_mediaelement.default);
                exports.default = MediaElementWebAudio;
                module1.exports = exports.default;
            /***/ },
            /***/ "./src/mediaelement.js": /*!*****************************!*\
  !*** ./src/mediaelement.js ***!
  \*****************************/ /***/ (module1, exports, __webpack_require__)=>{
                "use strict";
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var _webaudio = _interopRequireDefault(__webpack_require__(/*! ./webaudio */ "./src/webaudio.js"));
                var util = _interopRequireWildcard(__webpack_require__(/*! ./util */ "./src/util/index.js"));
                function _getRequireWildcardCache() {
                    if (typeof WeakMap !== "function") return null;
                    var cache = new WeakMap();
                    _getRequireWildcardCache = function _getRequireWildcardCache() {
                        return cache;
                    };
                    return cache;
                }
                function _interopRequireWildcard(obj) {
                    if (obj && obj.__esModule) return obj;
                    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") return {
                        default: obj
                    };
                    var cache = _getRequireWildcardCache();
                    if (cache && cache.has(obj)) return cache.get(obj);
                    var newObj = {};
                    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
                        else newObj[key] = obj[key];
                    }
                    newObj.default = obj;
                    if (cache) cache.set(obj, newObj);
                    return newObj;
                }
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                function _get(target, property, receiver) {
                    if (typeof Reflect !== "undefined" && Reflect.get) _get = Reflect.get;
                    else _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) return desc.get.call(receiver);
                        return desc.value;
                    };
                    return _get(target, property, receiver || target);
                }
                function _superPropBase(object, property) {
                    while(!Object.prototype.hasOwnProperty.call(object, property)){
                        object = _getPrototypeOf(object);
                        if (object === null) break;
                    }
                    return object;
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) _setPrototypeOf(subClass, superClass);
                }
                function _setPrototypeOf(o, p) {
                    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                        o.__proto__ = p;
                        return o;
                    };
                    return _setPrototypeOf(o, p);
                }
                function _createSuper(Derived) {
                    var hasNativeReflectConstruct = _isNativeReflectConstruct();
                    return function _createSuperInternal() {
                        var Super = _getPrototypeOf(Derived), result;
                        if (hasNativeReflectConstruct) {
                            var NewTarget = _getPrototypeOf(this).constructor;
                            result = Reflect.construct(Super, arguments, NewTarget);
                        } else result = Super.apply(this, arguments);
                        return _possibleConstructorReturn(this, result);
                    };
                }
                function _possibleConstructorReturn(self, call) {
                    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
                    return _assertThisInitialized(self);
                }
                function _assertThisInitialized(self) {
                    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self;
                }
                function _isNativeReflectConstruct() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                function _getPrototypeOf(o) {
                    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                        return o.__proto__ || Object.getPrototypeOf(o);
                    };
                    return _getPrototypeOf(o);
                }
                /**
 * MediaElement backend
 */ var MediaElement = /*#__PURE__*/ function(_WebAudio) {
                    _inherits(MediaElement, _WebAudio);
                    var _super = _createSuper(MediaElement);
                    /**
   * Construct the backend
   *
   * @param {WavesurferParams} params Wavesurfer parameters
   */ function MediaElement(params) {
                        var _this;
                        _classCallCheck(this, MediaElement);
                        _this = _super.call(this, params);
                        /** @private */ _this.params = params;
                        /**
     * Initially a dummy media element to catch errors. Once `_load` is
     * called, this will contain the actual `HTMLMediaElement`.
     * @private
     */ _this.media = {
                            currentTime: 0,
                            duration: 0,
                            paused: true,
                            playbackRate: 1,
                            play: function play() {},
                            pause: function pause() {},
                            volume: 0
                        };
                        /** @private */ _this.mediaType = params.mediaType.toLowerCase();
                        /** @private */ _this.elementPosition = params.elementPosition;
                        /** @private */ _this.peaks = null;
                        /** @private */ _this.playbackRate = 1;
                        /** @private */ _this.volume = 1;
                        /** @private */ _this.isMuted = false;
                        /** @private */ _this.buffer = null;
                        /** @private */ _this.onPlayEnd = null;
                        /** @private */ _this.mediaListeners = {};
                        return _this;
                    }
                    /**
   * Initialise the backend, called in `wavesurfer.createBackend()`
   */ _createClass(MediaElement, [
                        {
                            key: "init",
                            value: function init() {
                                this.setPlaybackRate(this.params.audioRate);
                                this.createTimer();
                            }
                        },
                        {
                            key: "_setupMediaListeners",
                            value: function _setupMediaListeners() {
                                var _this2 = this;
                                this.mediaListeners.error = function() {
                                    _this2.fireEvent("error", "Error loading media element");
                                };
                                this.mediaListeners.canplay = function() {
                                    _this2.fireEvent("canplay");
                                };
                                this.mediaListeners.ended = function() {
                                    _this2.fireEvent("finish");
                                }; // listen to and relay play, pause and seeked events to enable
                                // playback control from the external media element
                                this.mediaListeners.play = function() {
                                    _this2.fireEvent("play");
                                };
                                this.mediaListeners.pause = function() {
                                    _this2.fireEvent("pause");
                                };
                                this.mediaListeners.seeked = function(event) {
                                    _this2.fireEvent("seek");
                                };
                                this.mediaListeners.volumechange = function(event) {
                                    _this2.isMuted = _this2.media.muted;
                                    if (_this2.isMuted) _this2.volume = 0;
                                    else _this2.volume = _this2.media.volume;
                                    _this2.fireEvent("volume");
                                }; // reset event listeners
                                Object.keys(this.mediaListeners).forEach(function(id) {
                                    _this2.media.removeEventListener(id, _this2.mediaListeners[id]);
                                    _this2.media.addEventListener(id, _this2.mediaListeners[id]);
                                });
                            }
                        },
                        {
                            key: "createTimer",
                            value: function createTimer() {
                                var _this3 = this;
                                var onAudioProcess = function onAudioProcess() {
                                    if (_this3.isPaused()) return;
                                    _this3.fireEvent("audioprocess", _this3.getCurrentTime()); // Call again in the next frame
                                    util.frame(onAudioProcess)();
                                };
                                this.on("play", onAudioProcess); // Update the progress one more time to prevent it from being stuck in
                                // case of lower framerates
                                this.on("pause", function() {
                                    _this3.fireEvent("audioprocess", _this3.getCurrentTime());
                                });
                            }
                        },
                        {
                            key: "load",
                            value: function load(url, container, peaks, preload) {
                                var media = document.createElement(this.mediaType);
                                media.controls = this.params.mediaControls;
                                media.autoplay = this.params.autoplay || false;
                                media.preload = preload == null ? "auto" : preload;
                                media.src = url;
                                media.style.width = "100%";
                                var prevMedia = container.querySelector(this.mediaType);
                                if (prevMedia) container.removeChild(prevMedia);
                                container.appendChild(media);
                                this._load(media, peaks, preload);
                            }
                        },
                        {
                            key: "loadElt",
                            value: function loadElt(elt, peaks) {
                                elt.controls = this.params.mediaControls;
                                elt.autoplay = this.params.autoplay || false;
                                this._load(elt, peaks, elt.preload);
                            }
                        },
                        {
                            key: "_load",
                            value: function _load(media, peaks, preload) {
                                // verify media element is valid
                                if (!(media instanceof HTMLMediaElement) || typeof media.addEventListener === "undefined") throw new Error("media parameter is not a valid media element");
                                 // load must be called manually on iOS, otherwise peaks won't draw
                                // until a user interaction triggers load --> 'ready' event
                                //
                                // note that we avoid calling media.load here when given peaks and preload == 'none'
                                // as this almost always triggers some browser fetch of the media.
                                if (typeof media.load == "function" && !(peaks && preload == "none")) // Resets the media element and restarts the media resource. Any
                                // pending events are discarded. How much media data is fetched is
                                // still affected by the preload attribute.
                                media.load();
                                this.media = media;
                                this._setupMediaListeners();
                                this.peaks = peaks;
                                this.onPlayEnd = null;
                                this.buffer = null;
                                this.isMuted = media.muted;
                                this.setPlaybackRate(this.playbackRate);
                                this.setVolume(this.volume);
                            }
                        },
                        {
                            key: "isPaused",
                            value: function isPaused() {
                                return !this.media || this.media.paused;
                            }
                        },
                        {
                            key: "getDuration",
                            value: function getDuration() {
                                if (this.explicitDuration) return this.explicitDuration;
                                var duration = (this.buffer || this.media).duration;
                                if (duration >= Infinity) // streaming audio
                                duration = this.media.seekable.end(0);
                                return duration;
                            }
                        },
                        {
                            key: "getCurrentTime",
                            value: function getCurrentTime() {
                                return this.media && this.media.currentTime;
                            }
                        },
                        {
                            key: "getPlayedPercents",
                            value: function getPlayedPercents() {
                                return this.getCurrentTime() / this.getDuration() || 0;
                            }
                        },
                        {
                            key: "getPlaybackRate",
                            value: function getPlaybackRate() {
                                return this.playbackRate || this.media.playbackRate;
                            }
                        },
                        {
                            key: "setPlaybackRate",
                            value: function setPlaybackRate(value) {
                                this.playbackRate = value || 1;
                                this.media.playbackRate = this.playbackRate;
                            }
                        },
                        {
                            key: "seekTo",
                            value: function seekTo(start) {
                                if (start != null) this.media.currentTime = start;
                                this.clearPlayEnd();
                            }
                        },
                        {
                            key: "play",
                            value: function play(start, end) {
                                this.seekTo(start);
                                var promise = this.media.play();
                                end && this.setPlayEnd(end);
                                return promise;
                            }
                        },
                        {
                            key: "pause",
                            value: function pause() {
                                var promise;
                                if (this.media) promise = this.media.pause();
                                this.clearPlayEnd();
                                return promise;
                            }
                        },
                        {
                            key: "setPlayEnd",
                            value: function setPlayEnd(end) {
                                var _this4 = this;
                                this.clearPlayEnd();
                                this._onPlayEnd = function(time) {
                                    if (time >= end) {
                                        _this4.pause();
                                        _this4.seekTo(end);
                                    }
                                };
                                this.on("audioprocess", this._onPlayEnd);
                            }
                        },
                        {
                            key: "clearPlayEnd",
                            value: function clearPlayEnd() {
                                if (this._onPlayEnd) {
                                    this.un("audioprocess", this._onPlayEnd);
                                    this._onPlayEnd = null;
                                }
                            }
                        },
                        {
                            key: "getPeaks",
                            value: function getPeaks(length, first, last) {
                                if (this.buffer) return _get(_getPrototypeOf(MediaElement.prototype), "getPeaks", this).call(this, length, first, last);
                                return this.peaks || [];
                            }
                        },
                        {
                            key: "setSinkId",
                            value: function setSinkId(deviceId) {
                                if (deviceId) {
                                    if (!this.media.setSinkId) return Promise.reject(new Error("setSinkId is not supported in your browser"));
                                    return this.media.setSinkId(deviceId);
                                }
                                return Promise.reject(new Error("Invalid deviceId: " + deviceId));
                            }
                        },
                        {
                            key: "getVolume",
                            value: function getVolume() {
                                return this.volume;
                            }
                        },
                        {
                            key: "setVolume",
                            value: function setVolume(value) {
                                this.volume = value; // no need to change when it's already at that volume
                                if (this.media.volume !== this.volume) this.media.volume = this.volume;
                            }
                        },
                        {
                            key: "setMute",
                            value: function setMute(muted) {
                                // This causes a volume change to be emitted too through the
                                // volumechange event listener.
                                this.isMuted = this.media.muted = muted;
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                var _this5 = this;
                                this.pause();
                                this.unAll();
                                this.destroyed = true; // cleanup media event listeners
                                Object.keys(this.mediaListeners).forEach(function(id) {
                                    if (_this5.media) _this5.media.removeEventListener(id, _this5.mediaListeners[id]);
                                });
                                if (this.params.removeMediaElementOnDestroy && this.media && this.media.parentNode) this.media.parentNode.removeChild(this.media);
                                this.media = null;
                            }
                        }
                    ]);
                    return MediaElement;
                }(_webaudio.default);
                exports.default = MediaElement;
                module1.exports = exports.default;
            /***/ },
            /***/ "./src/peakcache.js": /*!**************************!*\
  !*** ./src/peakcache.js ***!
  \**************************/ /***/ (module1, exports)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                /**
 * Caches the decoded peaks data to improve rendering speed for large audio
 *
 * Is used if the option parameter `partialRender` is set to `true`
 */ var PeakCache = /*#__PURE__*/ function() {
                    /**
   * Instantiate cache
   */ function PeakCache() {
                        _classCallCheck(this, PeakCache);
                        this.clearPeakCache();
                    }
                    /**
   * Empty the cache
   */ _createClass(PeakCache, [
                        {
                            key: "clearPeakCache",
                            value: function clearPeakCache() {
                                /**
       * Flat array with entries that are always in pairs to mark the
       * beginning and end of each subrange.  This is a convenience so we can
       * iterate over the pairs for easy set difference operations.
       * @private
       */ this.peakCacheRanges = [];
                                /**
       * Length of the entire cachable region, used for resetting the cache
       * when this changes (zoom events, for instance).
       * @private
       */ this.peakCacheLength = -1;
                            }
                        },
                        {
                            key: "addRangeToPeakCache",
                            value: function addRangeToPeakCache(length, start, end) {
                                if (length != this.peakCacheLength) {
                                    this.clearPeakCache();
                                    this.peakCacheLength = length;
                                } // Return ranges that weren't in the cache before the call.
                                var uncachedRanges = [];
                                var i = 0; // Skip ranges before the current start.
                                while(i < this.peakCacheRanges.length && this.peakCacheRanges[i] < start)i++;
                                 // If |i| is even, |start| falls after an existing range.  Otherwise,
                                // |start| falls between an existing range, and the uncached region
                                // starts when we encounter the next node in |peakCacheRanges| or
                                // |end|, whichever comes first.
                                if (i % 2 == 0) uncachedRanges.push(start);
                                while(i < this.peakCacheRanges.length && this.peakCacheRanges[i] <= end){
                                    uncachedRanges.push(this.peakCacheRanges[i]);
                                    i++;
                                } // If |i| is even, |end| is after all existing ranges.
                                if (i % 2 == 0) uncachedRanges.push(end);
                                 // Filter out the 0-length ranges.
                                uncachedRanges = uncachedRanges.filter(function(item, pos, arr) {
                                    if (pos == 0) return item != arr[pos + 1];
                                    else if (pos == arr.length - 1) return item != arr[pos - 1];
                                    return item != arr[pos - 1] && item != arr[pos + 1];
                                }); // Merge the two ranges together, uncachedRanges will either contain
                                // wholly new points, or duplicates of points in peakCacheRanges.  If
                                // duplicates are detected, remove both and extend the range.
                                this.peakCacheRanges = this.peakCacheRanges.concat(uncachedRanges);
                                this.peakCacheRanges = this.peakCacheRanges.sort(function(a, b) {
                                    return a - b;
                                }).filter(function(item, pos, arr) {
                                    if (pos == 0) return item != arr[pos + 1];
                                    else if (pos == arr.length - 1) return item != arr[pos - 1];
                                    return item != arr[pos - 1] && item != arr[pos + 1];
                                }); // Push the uncached ranges into an array of arrays for ease of
                                // iteration in the functions that call this.
                                var uncachedRangePairs = [];
                                for(i = 0; i < uncachedRanges.length; i += 2)uncachedRangePairs.push([
                                    uncachedRanges[i],
                                    uncachedRanges[i + 1]
                                ]);
                                return uncachedRangePairs;
                            }
                        },
                        {
                            key: "getCacheRanges",
                            value: function getCacheRanges() {
                                var peakCacheRangePairs = [];
                                var i;
                                for(i = 0; i < this.peakCacheRanges.length; i += 2)peakCacheRangePairs.push([
                                    this.peakCacheRanges[i],
                                    this.peakCacheRanges[i + 1]
                                ]);
                                return peakCacheRangePairs;
                            }
                        }
                    ]);
                    return PeakCache;
                }();
                exports.default = PeakCache;
                module1.exports = exports.default;
            /***/ },
            /***/ "./src/util/absMax.js": /*!****************************!*\
  !*** ./src/util/absMax.js ***!
  \****************************/ /***/ (module1, exports, __webpack_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = absMax;
                var _max = _interopRequireDefault(__webpack_require__(/*! ./max */ "./src/util/max.js"));
                var _min = _interopRequireDefault(__webpack_require__(/*! ./min */ "./src/util/min.js"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                /**
 * Get the largest absolute value in an array
 *
 * @param   {Array} values Array of numbers
 * @returns {Number} Largest number found
 * @example console.log(max([-3, 2, 1]), max([-3, 2, 4])); // logs 3 4
 * @since 4.3.0
 */ function absMax(values) {
                    var max = (0, _max.default)(values);
                    var min = (0, _min.default)(values);
                    return -min > max ? -min : max;
                }
                module1.exports = exports.default;
            /***/ },
            /***/ "./src/util/clamp.js": /*!***************************!*\
  !*** ./src/util/clamp.js ***!
  \***************************/ /***/ (module1, exports)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = clamp;
                /**
 * Returns a number limited to the given range.
 *
 * @param {number} val The number to be limited to a range
 * @param {number} min The lower boundary of the limit range
 * @param {number} max The upper boundary of the limit range
 * @returns {number} A number in the range [min, max]
 */ function clamp(val, min, max) {
                    return Math.min(Math.max(min, val), max);
                }
                module1.exports = exports.default;
            /***/ },
            /***/ "./src/util/fetch.js": /*!***************************!*\
  !*** ./src/util/fetch.js ***!
  \***************************/ /***/ (module1, exports, __webpack_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = fetchFile;
                var _observer = _interopRequireDefault(__webpack_require__(/*! ./observer */ "./src/util/observer.js"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                var ProgressHandler = /*#__PURE__*/ function() {
                    /**
   * Instantiate ProgressHandler
   *
   * @param {Observer} instance The `fetchFile` observer instance.
   * @param {Number} contentLength Content length.
   * @param {Response} response Response object.
   */ function ProgressHandler(instance, contentLength, response) {
                        _classCallCheck(this, ProgressHandler);
                        this.instance = instance;
                        this.instance._reader = response.body.getReader();
                        this.total = parseInt(contentLength, 10);
                        this.loaded = 0;
                    }
                    /**
   * A method that is called once, immediately after the `ReadableStream``
   * is constructed.
   *
   * @param {ReadableStreamDefaultController} controller Controller instance
   *     used to control the stream.
   */ _createClass(ProgressHandler, [
                        {
                            key: "start",
                            value: function start(controller) {
                                var _this = this;
                                var read = function read() {
                                    // instance._reader.read() returns a promise that resolves
                                    // when a value has been received
                                    _this.instance._reader.read().then(function(_ref) {
                                        var done = _ref.done, value = _ref.value;
                                        // result objects contain two properties:
                                        // done  - true if the stream has already given you all its data.
                                        // value - some data. Always undefined when done is true.
                                        if (done) {
                                            // ensure onProgress called when content-length=0
                                            if (_this.total === 0) _this.instance.onProgress.call(_this.instance, {
                                                loaded: _this.loaded,
                                                total: _this.total,
                                                lengthComputable: false
                                            });
                                             // no more data needs to be consumed, close the stream
                                            controller.close();
                                            return;
                                        }
                                        _this.loaded += value.byteLength;
                                        _this.instance.onProgress.call(_this.instance, {
                                            loaded: _this.loaded,
                                            total: _this.total,
                                            lengthComputable: !(_this.total === 0)
                                        }); // enqueue the next data chunk into our target stream
                                        controller.enqueue(value);
                                        read();
                                    }).catch(function(error) {
                                        controller.error(error);
                                    });
                                };
                                read();
                            }
                        }
                    ]);
                    return ProgressHandler;
                }();
                /**
 * Load a file using `fetch`.
 *
 * @param {object} options Request options to use. See example below.
 * @returns {Observer} Observer instance
 * @example
 * // default options
 * let options = {
 *     url: undefined,
 *     method: 'GET',
 *     mode: 'cors',
 *     credentials: 'same-origin',
 *     cache: 'default',
 *     responseType: 'json',
 *     requestHeaders: [],
 *     redirect: 'follow',
 *     referrer: 'client'
 * };
 *
 * // override some options
 * options.url = '../media/demo.wav';

 * // available types: 'arraybuffer', 'blob', 'json' or 'text'
 * options.responseType = 'arraybuffer';
 *
 * // make fetch call
 * let request = util.fetchFile(options);
 *
 * // listen for events
 * request.on('progress', e => {
 *     console.log('progress', e);
 * });
 *
 * request.on('success', data => {
 *     console.log('success!', data);
 * });
 *
 * request.on('error', e => {
 *     console.warn('fetchFile error: ', e);
 * });
 */ function fetchFile(options) {
                    if (!options) throw new Error("fetch options missing");
                    else if (!options.url) throw new Error("fetch url missing");
                    var instance = new _observer.default();
                    var fetchHeaders = new Headers();
                    var fetchRequest = new Request(options.url); // add ability to abort
                    instance.controller = new AbortController(); // check if headers have to be added
                    if (options && options.requestHeaders) // add custom request headers
                    options.requestHeaders.forEach(function(header) {
                        fetchHeaders.append(header.key, header.value);
                    });
                     // parse fetch options
                    var responseType = options.responseType || "json";
                    var fetchOptions = {
                        method: options.method || "GET",
                        headers: fetchHeaders,
                        mode: options.mode || "cors",
                        credentials: options.credentials || "same-origin",
                        cache: options.cache || "default",
                        redirect: options.redirect || "follow",
                        referrer: options.referrer || "client",
                        signal: instance.controller.signal
                    };
                    fetch(fetchRequest, fetchOptions).then(function(response) {
                        // store response reference
                        instance.response = response;
                        var progressAvailable = true;
                        if (!response.body) // ReadableStream is not yet supported in this browser
                        // see https://developer.mozilla.org/en-US/docs/Web/API/ReadableStream
                        progressAvailable = false;
                         // Server must send CORS header "Access-Control-Expose-Headers: content-length"
                        var contentLength = response.headers.get("content-length");
                        if (contentLength === null) // Content-Length server response header missing.
                        // Don't evaluate download progress if we can't compare against a total size
                        // see https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS#Access-Control-Expose-Headers
                        progressAvailable = false;
                        if (!progressAvailable) // not able to check download progress so skip it
                        return response;
                         // fire progress event when during load
                        instance.onProgress = function(e) {
                            instance.fireEvent("progress", e);
                        };
                        return new Response(new ReadableStream(new ProgressHandler(instance, contentLength, response)), fetchOptions);
                    }).then(function(response) {
                        var errMsg;
                        if (response.ok) switch(responseType){
                            case "arraybuffer":
                                return response.arrayBuffer();
                            case "json":
                                return response.json();
                            case "blob":
                                return response.blob();
                            case "text":
                                return response.text();
                            default:
                                errMsg = "Unknown responseType: " + responseType;
                                break;
                        }
                        if (!errMsg) errMsg = "HTTP error status: " + response.status;
                        throw new Error(errMsg);
                    }).then(function(response) {
                        instance.fireEvent("success", response);
                    }).catch(function(error) {
                        instance.fireEvent("error", error);
                    }); // return the fetch request
                    instance.fetchRequest = fetchRequest;
                    return instance;
                }
                module1.exports = exports.default;
            /***/ },
            /***/ "./src/util/frame.js": /*!***************************!*\
  !*** ./src/util/frame.js ***!
  \***************************/ /***/ (module1, exports, __webpack_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = frame;
                var _requestAnimationFrame = _interopRequireDefault(__webpack_require__(/*! ./request-animation-frame */ "./src/util/request-animation-frame.js"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                /**
 * Create a function which will be called at the next requestAnimationFrame
 * cycle
 *
 * @param {function} func The function to call
 *
 * @return {func} The function wrapped within a requestAnimationFrame
 */ function frame(func) {
                    return function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        return (0, _requestAnimationFrame.default)(function() {
                            return func.apply(void 0, args);
                        });
                    };
                }
                module1.exports = exports.default;
            /***/ },
            /***/ "./src/util/get-id.js": /*!****************************!*\
  !*** ./src/util/get-id.js ***!
  \****************************/ /***/ (module1, exports)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = getId;
                /**
 * Get a random prefixed ID
 *
 * @param {String} prefix Prefix to use. Default is `'wavesurfer_'`.
 * @returns {String} Random prefixed ID
 * @example
 * console.log(getId()); // logs 'wavesurfer_b5pors4ru6g'
 *
 * let prefix = 'foo-';
 * console.log(getId(prefix)); // logs 'foo-b5pors4ru6g'
 */ function getId(prefix) {
                    if (prefix === undefined) prefix = "wavesurfer_";
                    return prefix + Math.random().toString(32).substring(2);
                }
                module1.exports = exports.default;
            /***/ },
            /***/ "./src/util/index.js": /*!***************************!*\
  !*** ./src/util/index.js ***!
  \***************************/ /***/ (__unused_webpack_module, exports, __webpack_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                Object.defineProperty(exports, "getId", {
                    enumerable: true,
                    get: function get() {
                        return _getId.default;
                    }
                });
                Object.defineProperty(exports, "max", {
                    enumerable: true,
                    get: function get() {
                        return _max.default;
                    }
                });
                Object.defineProperty(exports, "min", {
                    enumerable: true,
                    get: function get() {
                        return _min.default;
                    }
                });
                Object.defineProperty(exports, "absMax", {
                    enumerable: true,
                    get: function get() {
                        return _absMax.default;
                    }
                });
                Object.defineProperty(exports, "Observer", {
                    enumerable: true,
                    get: function get() {
                        return _observer.default;
                    }
                });
                Object.defineProperty(exports, "style", {
                    enumerable: true,
                    get: function get() {
                        return _style.default;
                    }
                });
                Object.defineProperty(exports, "requestAnimationFrame", {
                    enumerable: true,
                    get: function get() {
                        return _requestAnimationFrame.default;
                    }
                });
                Object.defineProperty(exports, "frame", {
                    enumerable: true,
                    get: function get() {
                        return _frame.default;
                    }
                });
                Object.defineProperty(exports, "debounce", {
                    enumerable: true,
                    get: function get() {
                        return _debounce.default;
                    }
                });
                Object.defineProperty(exports, "preventClick", {
                    enumerable: true,
                    get: function get() {
                        return _preventClick.default;
                    }
                });
                Object.defineProperty(exports, "fetchFile", {
                    enumerable: true,
                    get: function get() {
                        return _fetch.default;
                    }
                });
                Object.defineProperty(exports, "clamp", {
                    enumerable: true,
                    get: function get() {
                        return _clamp.default;
                    }
                });
                var _getId = _interopRequireDefault(__webpack_require__(/*! ./get-id */ "./src/util/get-id.js"));
                var _max = _interopRequireDefault(__webpack_require__(/*! ./max */ "./src/util/max.js"));
                var _min = _interopRequireDefault(__webpack_require__(/*! ./min */ "./src/util/min.js"));
                var _absMax = _interopRequireDefault(__webpack_require__(/*! ./absMax */ "./src/util/absMax.js"));
                var _observer = _interopRequireDefault(__webpack_require__(/*! ./observer */ "./src/util/observer.js"));
                var _style = _interopRequireDefault(__webpack_require__(/*! ./style */ "./src/util/style.js"));
                var _requestAnimationFrame = _interopRequireDefault(__webpack_require__(/*! ./request-animation-frame */ "./src/util/request-animation-frame.js"));
                var _frame = _interopRequireDefault(__webpack_require__(/*! ./frame */ "./src/util/frame.js"));
                var _debounce = _interopRequireDefault(__webpack_require__(/*! debounce */ "./node_modules/debounce/index.js"));
                var _preventClick = _interopRequireDefault(__webpack_require__(/*! ./prevent-click */ "./src/util/prevent-click.js"));
                var _fetch = _interopRequireDefault(__webpack_require__(/*! ./fetch */ "./src/util/fetch.js"));
                var _clamp = _interopRequireDefault(__webpack_require__(/*! ./clamp */ "./src/util/clamp.js"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
            /***/ },
            /***/ "./src/util/max.js": /*!*************************!*\
  !*** ./src/util/max.js ***!
  \*************************/ /***/ (module1, exports)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = max;
                /**
 * Get the largest value
 *
 * @param   {Array} values Array of numbers
 * @returns {Number} Largest number found
 * @example console.log(max([1, 2, 3])); // logs 3
 */ function max(values) {
                    var largest = -Infinity;
                    Object.keys(values).forEach(function(i) {
                        if (values[i] > largest) largest = values[i];
                    });
                    return largest;
                }
                module1.exports = exports.default;
            /***/ },
            /***/ "./src/util/min.js": /*!*************************!*\
  !*** ./src/util/min.js ***!
  \*************************/ /***/ (module1, exports)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = min;
                /**
 * Get the smallest value
 *
 * @param   {Array} values Array of numbers
 * @returns {Number} Smallest number found
 * @example console.log(min([1, 2, 3])); // logs 1
 */ function min(values) {
                    var smallest = Number(Infinity);
                    Object.keys(values).forEach(function(i) {
                        if (values[i] < smallest) smallest = values[i];
                    });
                    return smallest;
                }
                module1.exports = exports.default;
            /***/ },
            /***/ "./src/util/observer.js": /*!******************************!*\
  !*** ./src/util/observer.js ***!
  \******************************/ /***/ (module1, exports)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                /**
 * @typedef {Object} ListenerDescriptor
 * @property {string} name The name of the event
 * @property {function} callback The callback
 * @property {function} un The function to call to remove the listener
 */ /**
 * Observer class
 */ var Observer = /*#__PURE__*/ function() {
                    /**
   * Instantiate Observer
   */ function Observer() {
                        _classCallCheck(this, Observer);
                        /**
     * @private
     * @todo Initialise the handlers here already and remove the conditional
     * assignment in `on()`
     */ this._disabledEventEmissions = [];
                        this.handlers = null;
                    }
                    /**
   * Attach a handler function for an event.
   *
   * @param {string} event Name of the event to listen to
   * @param {function} fn The callback to trigger when the event is fired
   * @return {ListenerDescriptor} The event descriptor
   */ _createClass(Observer, [
                        {
                            key: "on",
                            value: function on(event, fn) {
                                var _this = this;
                                if (!this.handlers) this.handlers = {};
                                var handlers = this.handlers[event];
                                if (!handlers) handlers = this.handlers[event] = [];
                                handlers.push(fn); // Return an event descriptor
                                return {
                                    name: event,
                                    callback: fn,
                                    un: function un(e, fn) {
                                        return _this.un(e, fn);
                                    }
                                };
                            }
                        },
                        {
                            key: "un",
                            value: function un(event, fn) {
                                if (!this.handlers) return;
                                var handlers = this.handlers[event];
                                var i;
                                if (handlers) {
                                    if (fn) {
                                        for(i = handlers.length - 1; i >= 0; i--)if (handlers[i] == fn) handlers.splice(i, 1);
                                    } else handlers.length = 0;
                                }
                            }
                        },
                        {
                            key: "unAll",
                            value: function unAll() {
                                this.handlers = null;
                            }
                        },
                        {
                            key: "once",
                            value: function once(event, handler) {
                                var _this2 = this;
                                var fn = function fn() {
                                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                                    /*  eslint-disable no-invalid-this */ handler.apply(_this2, args);
                                    /*  eslint-enable no-invalid-this */ setTimeout(function() {
                                        _this2.un(event, fn);
                                    }, 0);
                                };
                                return this.on(event, fn);
                            }
                        },
                        {
                            key: "setDisabledEventEmissions",
                            value: function setDisabledEventEmissions(eventNames) {
                                this._disabledEventEmissions = eventNames;
                            }
                        },
                        {
                            key: "_isDisabledEventEmission",
                            value: function _isDisabledEventEmission(event) {
                                return this._disabledEventEmissions && this._disabledEventEmissions.includes(event);
                            }
                        },
                        {
                            key: "fireEvent",
                            value: function fireEvent(event) {
                                for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                                if (!this.handlers || this._isDisabledEventEmission(event)) return;
                                var handlers = this.handlers[event];
                                handlers && handlers.forEach(function(fn) {
                                    fn.apply(void 0, args);
                                });
                            }
                        }
                    ]);
                    return Observer;
                }();
                exports.default = Observer;
                module1.exports = exports.default;
            /***/ },
            /***/ "./src/util/prevent-click.js": /*!***********************************!*\
  !*** ./src/util/prevent-click.js ***!
  \***********************************/ /***/ (module1, exports)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = preventClick;
                /**
 * Stops propagation of click event and removes event listener
 *
 * @private
 * @param {object} event The click event
 */ function preventClickHandler(event) {
                    event.stopPropagation();
                    document.body.removeEventListener("click", preventClickHandler, true);
                }
                /**
 * Starts listening for click event and prevent propagation
 *
 * @param {object} values Values
 */ function preventClick(values) {
                    document.body.addEventListener("click", preventClickHandler, true);
                }
                module1.exports = exports.default;
            /***/ },
            /***/ "./src/util/request-animation-frame.js": /*!*********************************************!*\
  !*** ./src/util/request-animation-frame.js ***!
  \*********************************************/ /***/ (module1, exports)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                /* eslint-disable valid-jsdoc */ /**
 * Returns the `requestAnimationFrame` function for the browser, or a shim with
 * `setTimeout` if the function is not found
 *
 * @return {function} Available `requestAnimationFrame` function for the browser
 */ var _default = (window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function(callback, element) {
                    return setTimeout(callback, 1000 / 60);
                }).bind(window);
                exports.default = _default;
                module1.exports = exports.default;
            /***/ },
            /***/ "./src/util/style.js": /*!***************************!*\
  !*** ./src/util/style.js ***!
  \***************************/ /***/ (module1, exports)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = style;
                /**
 * Apply a map of styles to an element
 *
 * @param {HTMLElement} el The element that the styles will be applied to
 * @param {Object} styles The map of propName: attribute, both are used as-is
 *
 * @return {HTMLElement} el
 */ function style(el, styles) {
                    Object.keys(styles).forEach(function(prop) {
                        if (el.style[prop] !== styles[prop]) el.style[prop] = styles[prop];
                    });
                    return el;
                }
                module1.exports = exports.default;
            /***/ },
            /***/ "./src/wavesurfer.js": /*!***************************!*\
  !*** ./src/wavesurfer.js ***!
  \***************************/ /***/ (module1, exports, __webpack_require__)=>{
                "use strict";
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var util = _interopRequireWildcard(__webpack_require__(/*! ./util */ "./src/util/index.js"));
                var _drawer = _interopRequireDefault(__webpack_require__(/*! ./drawer.multicanvas */ "./src/drawer.multicanvas.js"));
                var _webaudio = _interopRequireDefault(__webpack_require__(/*! ./webaudio */ "./src/webaudio.js"));
                var _mediaelement = _interopRequireDefault(__webpack_require__(/*! ./mediaelement */ "./src/mediaelement.js"));
                var _peakcache = _interopRequireDefault(__webpack_require__(/*! ./peakcache */ "./src/peakcache.js"));
                var _mediaelementWebaudio = _interopRequireDefault(__webpack_require__(/*! ./mediaelement-webaudio */ "./src/mediaelement-webaudio.js"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function _getRequireWildcardCache() {
                    if (typeof WeakMap !== "function") return null;
                    var cache = new WeakMap();
                    _getRequireWildcardCache = function _getRequireWildcardCache() {
                        return cache;
                    };
                    return cache;
                }
                function _interopRequireWildcard(obj) {
                    if (obj && obj.__esModule) return obj;
                    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") return {
                        default: obj
                    };
                    var cache = _getRequireWildcardCache();
                    if (cache && cache.has(obj)) return cache.get(obj);
                    var newObj = {};
                    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
                        else newObj[key] = obj[key];
                    }
                    newObj.default = obj;
                    if (cache) cache.set(obj, newObj);
                    return newObj;
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) _setPrototypeOf(subClass, superClass);
                }
                function _setPrototypeOf(o, p) {
                    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                        o.__proto__ = p;
                        return o;
                    };
                    return _setPrototypeOf(o, p);
                }
                function _createSuper(Derived) {
                    var hasNativeReflectConstruct = _isNativeReflectConstruct();
                    return function _createSuperInternal() {
                        var Super = _getPrototypeOf(Derived), result;
                        if (hasNativeReflectConstruct) {
                            var NewTarget = _getPrototypeOf(this).constructor;
                            result = Reflect.construct(Super, arguments, NewTarget);
                        } else result = Super.apply(this, arguments);
                        return _possibleConstructorReturn(this, result);
                    };
                }
                function _possibleConstructorReturn(self, call) {
                    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
                    return _assertThisInitialized(self);
                }
                function _assertThisInitialized(self) {
                    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self;
                }
                function _isNativeReflectConstruct() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                function _getPrototypeOf(o) {
                    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                        return o.__proto__ || Object.getPrototypeOf(o);
                    };
                    return _getPrototypeOf(o);
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                /*
 * This work is licensed under a BSD-3-Clause License.
 */ /** @external {HTMLElement} https://developer.mozilla.org/en/docs/Web/API/HTMLElement */ /** @external {OfflineAudioContext} https://developer.mozilla.org/en-US/docs/Web/API/OfflineAudioContext */ /** @external {File} https://developer.mozilla.org/en-US/docs/Web/API/File */ /** @external {Blob} https://developer.mozilla.org/en-US/docs/Web/API/Blob */ /** @external {CanvasRenderingContext2D} https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D */ /** @external {MediaStreamConstraints} https://developer.mozilla.org/en-US/docs/Web/API/MediaStreamConstraints */ /** @external {AudioNode} https://developer.mozilla.org/de/docs/Web/API/AudioNode */ /**
 * @typedef {Object} WavesurferParams
 * @property {AudioContext} audioContext=null Use your own previously
 * initialized AudioContext or leave blank.
 * @property {number} audioRate=1 Speed at which to play audio. Lower number is
 * slower.
 * @property {ScriptProcessorNode} audioScriptProcessor=null Use your own previously
 * initialized ScriptProcessorNode or leave blank.
 * @property {boolean} autoCenter=true If a scrollbar is present, center the
 * waveform on current progress
 * @property {number} autoCenterRate=5 If autoCenter is active, rate at which the
 * waveform is centered
 * @property {boolean} autoCenterImmediately=false If autoCenter is active, immediately
 * center waveform on current progress
 * @property {string} backend='WebAudio' `'WebAudio'|'MediaElement'|'MediaElementWebAudio'` In most cases
 * you don't have to set this manually. MediaElement is a fallback for unsupported browsers.
 * MediaElementWebAudio allows to use WebAudio API also with big audio files, loading audio like with
 * MediaElement backend (HTML5 audio tag). You have to use the same methods of MediaElement backend for loading and
 * playback, giving also peaks, so the audio data are not decoded. In this way you can use WebAudio features, like filters,
 * also with audio with big duration. For example:
 * ` wavesurfer.load(url | HTMLMediaElement, peaks, preload, duration);
 *   wavesurfer.play();
 *   wavesurfer.setFilter(customFilter);
 * `
 * @property {string} backgroundColor=null Change background color of the
 * waveform container.
 * @property {number} barHeight=1 The height of the wave bars.
 * @property {number} barRadius=0 The radius of the wave bars. Makes bars rounded
 * @property {number} barGap=null The optional spacing between bars of the wave,
 * if not provided will be calculated in legacy format.
 * @property {number} barWidth=null Draw the waveform using bars.
 * @property {number} barMinHeight=null If specified, draw at least a bar of this height,
 * eliminating waveform gaps
 * @property {boolean} closeAudioContext=false Close and nullify all audio
 * contexts when the destroy method is called.
 * @property {!string|HTMLElement} container CSS selector or HTML element where
 * the waveform should be drawn. This is the only required parameter.
 * @property {string} cursorColor='#333' The fill color of the cursor indicating
 * the playhead position.
 * @property {number} cursorWidth=1 Measured in pixels.
 * @property {object} drawingContextAttributes={desynchronized: false} Drawing context
 * attributes.
 * @property {number} duration=null Optional audio length so pre-rendered peaks
 * can be display immediately for example.
 * @property {boolean} fillParent=true Whether to fill the entire container or
 * draw only according to `minPxPerSec`.
 * @property {boolean} forceDecode=false Force decoding of audio using web audio
 * when zooming to get a more detailed waveform.
 * @property {number} height=128 The height of the waveform. Measured in
 * pixels.
 * @property {boolean} hideScrollbar=false Whether to hide the horizontal
 * scrollbar when one would normally be shown.
 * @property {boolean} interact=true Whether the mouse interaction will be
 * enabled at initialization. You can switch this parameter at any time later
 * on.
 * @property {boolean} loopSelection=true (Use with regions plugin) Enable
 * looping of selected regions
 * @property {number} maxCanvasWidth=4000 Maximum width of a single canvas in
 * pixels, excluding a small overlap (2 * `pixelRatio`, rounded up to the next
 * even integer). If the waveform is longer than this value, additional canvases
 * will be used to render the waveform, which is useful for very large waveforms
 * that may be too wide for browsers to draw on a single canvas.
 * @property {boolean} mediaControls=false (Use with backend `MediaElement` or `MediaElementWebAudio`)
 * this enables the native controls for the media element
 * @property {string} mediaType='audio' (Use with backend `MediaElement` or `MediaElementWebAudio`)
 * `'audio'|'video'` ('video' only for `MediaElement`)
 * @property {number} minPxPerSec=20 Minimum number of pixels per second of
 * audio.
 * @property {boolean} normalize=false If true, normalize by the maximum peak
 * instead of 1.0.
 * @property {boolean} partialRender=false Use the PeakCache to improve
 * rendering speed of large waveforms
 * @property {number} pixelRatio=window.devicePixelRatio The pixel ratio used to
 * calculate display
 * @property {PluginDefinition[]} plugins=[] An array of plugin definitions to
 * register during instantiation, they will be directly initialised unless they
 * are added with the `deferInit` property set to true.
 * @property {string} progressColor='#555' The fill color of the part of the
 * waveform behind the cursor. When `progressColor` and `waveColor` are the same
 * the progress wave is not rendered at all.
 * @property {boolean} removeMediaElementOnDestroy=true Set to false to keep the
 * media element in the DOM when the player is destroyed. This is useful when
 * reusing an existing media element via the `loadMediaElement` method.
 * @property {Object} renderer=MultiCanvas Can be used to inject a custom
 * renderer.
 * @property {boolean|number} responsive=false If set to `true` resize the
 * waveform, when the window is resized. This is debounced with a `100ms`
 * timeout by default. If this parameter is a number it represents that timeout.
 * @property {boolean} rtl=false If set to `true`, renders waveform from
 * right-to-left.
 * @property {boolean} scrollParent=false Whether to scroll the container with a
 * lengthy waveform. Otherwise the waveform is shrunk to the container width
 * (see fillParent).
 * @property {number} skipLength=2 Number of seconds to skip with the
 * skipForward() and skipBackward() methods.
 * @property {boolean} splitChannels=false Render with separate waveforms for
 * the channels of the audio
 * @property {SplitChannelOptions} splitChannelsOptions={} Options for splitChannel rendering
 * @property {string} waveColor='#999' The fill color of the waveform after the
 * cursor.
 * @property {object} xhr={} XHR options. For example:
 * `let xhr = {
 *     cache: 'default',
 *     mode: 'cors',
 *     method: 'GET',
 *     credentials: 'same-origin',
 *     redirect: 'follow',
 *     referrer: 'client',
 *     requestHeaders: [
 *         {
 *             key: 'Authorization',
 *             value: 'my-token'
 *         }
 *     ]
 * };`
 */ /**
 * @typedef {Object} PluginDefinition
 * @desc The Object used to describe a plugin
 * @example wavesurfer.addPlugin(pluginDefinition);
 * @property {string} name The name of the plugin, the plugin instance will be
 * added as a property to the wavesurfer instance under this name
 * @property {?Object} staticProps The properties that should be added to the
 * wavesurfer instance as static properties
 * @property {?boolean} deferInit Don't initialise plugin
 * automatically
 * @property {Object} params={} The plugin parameters, they are the first parameter
 * passed to the plugin class constructor function
 * @property {PluginClass} instance The plugin instance factory, is called with
 * the dependency specified in extends. Returns the plugin class.
 */ /**
 * @typedef {Object} SplitChannelOptions
 * @desc parameters applied when splitChannels option is true
 * @property {boolean} overlay=false determines whether channels are rendered on top of each other or on separate tracks
 * @property {object} channelColors={} object describing color for each channel. Example:
 * {
 *     0: {
 *         progressColor: 'green',
 *         waveColor: 'pink'
 *     },
 *     1: {
 *         progressColor: 'orange',
 *         waveColor: 'purple'
 *     }
 * }
 * @property {number[]} filterChannels=[] indexes of channels to be hidden from rendering
 * @property {boolean} relativeNormalization=false determines whether
 * normalization is done per channel or maintains proportionality between
 * channels. Only applied when normalize and splitChannels are both true.
 * @since 4.3.0
 */ /**
 * @interface PluginClass
 *
 * @desc This is the interface which is implemented by all plugin classes. Note
 * that this only turns into an observer after being passed through
 * `wavesurfer.addPlugin`.
 *
 * @extends {Observer}
 */ var PluginClass = /*#__PURE__*/ function() {
                    /**
   * Construct the plugin
   *
   * @param {Object} params={} The plugin params (specific to the plugin)
   * @param {Object} ws The wavesurfer instance
   */ function PluginClass(params, ws) {
                        _classCallCheck(this, PluginClass);
                    }
                    /**
   * Initialise the plugin
   *
   * Start doing something. This is called by
   * `wavesurfer.initPlugin(pluginName)`
   */ _createClass(PluginClass, [
                        {
                            key: "create",
                            value: /**
     * Plugin definition factory
     *
     * This function must be used to create a plugin definition which can be
     * used by wavesurfer to correctly instantiate the plugin.
     *
     * It returns a `PluginDefinition` object representing the plugin.
     *
     * @param {Object} params={} The plugin params (specific to the plugin)
     */ function create(params) {}
                        },
                        {
                            key: "init",
                            value: function init() {}
                        },
                        {
                            key: "destroy",
                            value: function destroy() {}
                        }
                    ]);
                    return PluginClass;
                }();
                /**
 * WaveSurfer core library class
 *
 * @extends {Observer}
 * @example
 * const params = {
 *   container: '#waveform',
 *   waveColor: 'violet',
 *   progressColor: 'purple'
 * };
 *
 * // initialise like this
 * const wavesurfer = WaveSurfer.create(params);
 *
 * // or like this ...
 * const wavesurfer = new WaveSurfer(params);
 * wavesurfer.init();
 *
 * // load audio file
 * wavesurfer.load('example/media/demo.wav');
 */ var WaveSurfer = /*#__PURE__*/ function(_util$Observer) {
                    _inherits(WaveSurfer, _util$Observer);
                    var _super = _createSuper(WaveSurfer);
                    /**
   * Initialise wavesurfer instance
   *
   * @param {WavesurferParams} params Instantiation options for wavesurfer
   * @example
   * const wavesurfer = new WaveSurfer(params);
   * @returns {this} Wavesurfer instance
   */ function WaveSurfer(params) {
                        var _this;
                        _classCallCheck(this, WaveSurfer);
                        _this = _super.call(this);
                        /**
     * Extract relevant parameters (or defaults)
     * @private
     */ _this.defaultParams = {
                            audioContext: null,
                            audioScriptProcessor: null,
                            audioRate: 1,
                            autoCenter: true,
                            autoCenterRate: 5,
                            autoCenterImmediately: false,
                            backend: "WebAudio",
                            backgroundColor: null,
                            barHeight: 1,
                            barRadius: 0,
                            barGap: null,
                            barMinHeight: null,
                            container: null,
                            cursorColor: "#333",
                            cursorWidth: 1,
                            dragSelection: true,
                            drawingContextAttributes: {
                                // Boolean that hints the user agent to reduce the latency
                                // by desynchronizing the canvas paint cycle from the event
                                // loop
                                desynchronized: false
                            },
                            duration: null,
                            fillParent: true,
                            forceDecode: false,
                            height: 128,
                            hideScrollbar: false,
                            interact: true,
                            loopSelection: true,
                            maxCanvasWidth: 4000,
                            mediaContainer: null,
                            mediaControls: false,
                            mediaType: "audio",
                            minPxPerSec: 20,
                            normalize: false,
                            partialRender: false,
                            pixelRatio: window.devicePixelRatio || screen.deviceXDPI / screen.logicalXDPI,
                            plugins: [],
                            progressColor: "#555",
                            removeMediaElementOnDestroy: true,
                            renderer: _drawer.default,
                            responsive: false,
                            rtl: false,
                            scrollParent: false,
                            skipLength: 2,
                            splitChannels: false,
                            splitChannelsOptions: {
                                overlay: false,
                                channelColors: {},
                                filterChannels: [],
                                relativeNormalization: false
                            },
                            waveColor: "#999",
                            xhr: {}
                        };
                        _this.backends = {
                            MediaElement: _mediaelement.default,
                            WebAudio: _webaudio.default,
                            MediaElementWebAudio: _mediaelementWebaudio.default
                        };
                        _this.util = util;
                        _this.params = Object.assign({}, _this.defaultParams, params);
                        _this.params.splitChannelsOptions = Object.assign({}, _this.defaultParams.splitChannelsOptions, params.splitChannelsOptions);
                        /** @private */ _this.container = "string" == typeof params.container ? document.querySelector(_this.params.container) : _this.params.container;
                        if (!_this.container) throw new Error("Container element not found");
                        if (_this.params.mediaContainer == null) /** @private */ _this.mediaContainer = _this.container;
                        else if (typeof _this.params.mediaContainer == "string") /** @private */ _this.mediaContainer = document.querySelector(_this.params.mediaContainer);
                        else /** @private */ _this.mediaContainer = _this.params.mediaContainer;
                        if (!_this.mediaContainer) throw new Error("Media Container element not found");
                        if (_this.params.maxCanvasWidth <= 1) throw new Error("maxCanvasWidth must be greater than 1");
                        else if (_this.params.maxCanvasWidth % 2 == 1) throw new Error("maxCanvasWidth must be an even number");
                        if (_this.params.rtl === true) util.style(_this.container, {
                            transform: "rotateY(180deg)"
                        });
                        if (_this.params.backgroundColor) _this.setBackgroundColor(_this.params.backgroundColor);
                        /**
     * @private Used to save the current volume when muting so we can
     * restore once unmuted
     * @type {number}
     */ _this.savedVolume = 0;
                        /**
     * @private The current muted state
     * @type {boolean}
     */ _this.isMuted = false;
                        /**
     * @private Will hold a list of event descriptors that need to be
     * canceled on subsequent loads of audio
     * @type {Object[]}
     */ _this.tmpEvents = [];
                        /**
     * @private Holds any running audio downloads
     * @type {Observer}
     */ _this.currentRequest = null;
                        /** @private */ _this.arraybuffer = null;
                        /** @private */ _this.drawer = null;
                        /** @private */ _this.backend = null;
                        /** @private */ _this.peakCache = null; // cache constructor objects
                        if (typeof _this.params.renderer !== "function") throw new Error("Renderer parameter is invalid");
                        /**
     * @private The uninitialised Drawer class
     */ _this.Drawer = _this.params.renderer;
                        /**
     * @private The uninitialised Backend class
     */ // Back compat
                        if (_this.params.backend == "AudioElement") _this.params.backend = "MediaElement";
                        if ((_this.params.backend == "WebAudio" || _this.params.backend === "MediaElementWebAudio") && !_webaudio.default.prototype.supportsWebAudio.call(null)) _this.params.backend = "MediaElement";
                        _this.Backend = _this.backends[_this.params.backend];
                        /**
     * @private map of plugin names that are currently initialised
     */ _this.initialisedPluginList = {};
                        /** @private */ _this.isDestroyed = false;
                        /**
     * Get the current ready status.
     *
     * @example const isReady = wavesurfer.isReady;
     * @return {boolean}
     */ _this.isReady = false; // responsive debounced event listener. If this.params.responsive is not
                        // set, this is never called. Use 100ms or this.params.responsive as
                        // timeout for the debounce function.
                        var prevWidth = 0;
                        _this._onResize = util.debounce(function() {
                            if (prevWidth != _this.drawer.wrapper.clientWidth && !_this.params.scrollParent) {
                                prevWidth = _this.drawer.wrapper.clientWidth;
                                _this.drawer.fireEvent("redraw");
                            }
                        }, typeof _this.params.responsive === "number" ? _this.params.responsive : 100);
                        return _possibleConstructorReturn(_this, _assertThisInitialized(_this));
                    }
                    /**
   * Initialise the wave
   *
   * @example
   * var wavesurfer = new WaveSurfer(params);
   * wavesurfer.init();
   * @return {this} The wavesurfer instance
   */ _createClass(WaveSurfer, [
                        {
                            key: "init",
                            value: function init() {
                                this.registerPlugins(this.params.plugins);
                                this.createDrawer();
                                this.createBackend();
                                this.createPeakCache();
                                return this;
                            }
                        },
                        {
                            key: "registerPlugins",
                            value: function registerPlugins(plugins) {
                                var _this2 = this;
                                // first instantiate all the plugins
                                plugins.forEach(function(plugin) {
                                    return _this2.addPlugin(plugin);
                                }); // now run the init functions
                                plugins.forEach(function(plugin) {
                                    // call init function of the plugin if deferInit is falsey
                                    // in that case you would manually use initPlugins()
                                    if (!plugin.deferInit) _this2.initPlugin(plugin.name);
                                });
                                this.fireEvent("plugins-registered", plugins);
                                return this;
                            }
                        },
                        {
                            key: "getActivePlugins",
                            value: function getActivePlugins() {
                                return this.initialisedPluginList;
                            }
                        },
                        {
                            key: "addPlugin",
                            value: function addPlugin(plugin) {
                                var _this3 = this;
                                if (!plugin.name) throw new Error("Plugin does not have a name!");
                                if (!plugin.instance) throw new Error("Plugin ".concat(plugin.name, " does not have an instance property!"));
                                 // staticProps properties are applied to wavesurfer instance
                                if (plugin.staticProps) Object.keys(plugin.staticProps).forEach(function(pluginStaticProp) {
                                    /**
           * Properties defined in a plugin definition's `staticProps` property are added as
           * staticProps properties of the WaveSurfer instance
           */ _this3[pluginStaticProp] = plugin.staticProps[pluginStaticProp];
                                });
                                var Instance = plugin.instance; // turn the plugin instance into an observer
                                var observerPrototypeKeys = Object.getOwnPropertyNames(util.Observer.prototype);
                                observerPrototypeKeys.forEach(function(key) {
                                    Instance.prototype[key] = util.Observer.prototype[key];
                                });
                                /**
       * Instantiated plugin classes are added as a property of the wavesurfer
       * instance
       * @type {Object}
       */ this[plugin.name] = new Instance(plugin.params || {}, this);
                                this.fireEvent("plugin-added", plugin.name);
                                return this;
                            }
                        },
                        {
                            key: "initPlugin",
                            value: function initPlugin(name) {
                                if (!this[name]) throw new Error("Plugin ".concat(name, " has not been added yet!"));
                                if (this.initialisedPluginList[name]) // destroy any already initialised plugins
                                this.destroyPlugin(name);
                                this[name].init();
                                this.initialisedPluginList[name] = true;
                                this.fireEvent("plugin-initialised", name);
                                return this;
                            }
                        },
                        {
                            key: "destroyPlugin",
                            value: function destroyPlugin(name) {
                                if (!this[name]) throw new Error("Plugin ".concat(name, " has not been added yet and cannot be destroyed!"));
                                if (!this.initialisedPluginList[name]) throw new Error("Plugin ".concat(name, " is not active and cannot be destroyed!"));
                                if (typeof this[name].destroy !== "function") throw new Error("Plugin ".concat(name, " does not have a destroy function!"));
                                this[name].destroy();
                                delete this.initialisedPluginList[name];
                                this.fireEvent("plugin-destroyed", name);
                                return this;
                            }
                        },
                        {
                            key: "destroyAllPlugins",
                            value: function destroyAllPlugins() {
                                var _this4 = this;
                                Object.keys(this.initialisedPluginList).forEach(function(name) {
                                    return _this4.destroyPlugin(name);
                                });
                            }
                        },
                        {
                            key: "createDrawer",
                            value: function createDrawer() {
                                var _this5 = this;
                                this.drawer = new this.Drawer(this.container, this.params);
                                this.drawer.init();
                                this.fireEvent("drawer-created", this.drawer);
                                if (this.params.responsive !== false) {
                                    window.addEventListener("resize", this._onResize, true);
                                    window.addEventListener("orientationchange", this._onResize, true);
                                }
                                this.drawer.on("redraw", function() {
                                    _this5.drawBuffer();
                                    _this5.drawer.progress(_this5.backend.getPlayedPercents());
                                }); // Click-to-seek
                                this.drawer.on("click", function(e, progress) {
                                    setTimeout(function() {
                                        return _this5.seekTo(progress);
                                    }, 0);
                                }); // Relay the scroll event from the drawer
                                this.drawer.on("scroll", function(e) {
                                    if (_this5.params.partialRender) _this5.drawBuffer();
                                    _this5.fireEvent("scroll", e);
                                });
                            }
                        },
                        {
                            key: "createBackend",
                            value: function createBackend() {
                                var _this6 = this;
                                if (this.backend) this.backend.destroy();
                                this.backend = new this.Backend(this.params);
                                this.backend.init();
                                this.fireEvent("backend-created", this.backend);
                                this.backend.on("finish", function() {
                                    _this6.drawer.progress(_this6.backend.getPlayedPercents());
                                    _this6.fireEvent("finish");
                                });
                                this.backend.on("play", function() {
                                    return _this6.fireEvent("play");
                                });
                                this.backend.on("pause", function() {
                                    return _this6.fireEvent("pause");
                                });
                                this.backend.on("audioprocess", function(time) {
                                    _this6.drawer.progress(_this6.backend.getPlayedPercents());
                                    _this6.fireEvent("audioprocess", time);
                                }); // only needed for MediaElement and MediaElementWebAudio backend
                                if (this.params.backend === "MediaElement" || this.params.backend === "MediaElementWebAudio") {
                                    this.backend.on("seek", function() {
                                        _this6.drawer.progress(_this6.backend.getPlayedPercents());
                                    });
                                    this.backend.on("volume", function() {
                                        var newVolume = _this6.getVolume();
                                        _this6.fireEvent("volume", newVolume);
                                        if (_this6.backend.isMuted !== _this6.isMuted) {
                                            _this6.isMuted = _this6.backend.isMuted;
                                            _this6.fireEvent("mute", _this6.isMuted);
                                        }
                                    });
                                }
                            }
                        },
                        {
                            key: "createPeakCache",
                            value: function createPeakCache() {
                                if (this.params.partialRender) this.peakCache = new _peakcache.default();
                            }
                        },
                        {
                            key: "getDuration",
                            value: function getDuration() {
                                return this.backend.getDuration();
                            }
                        },
                        {
                            key: "getCurrentTime",
                            value: function getCurrentTime() {
                                return this.backend.getCurrentTime();
                            }
                        },
                        {
                            key: "setCurrentTime",
                            value: function setCurrentTime(seconds) {
                                if (seconds >= this.getDuration()) this.seekTo(1);
                                else this.seekTo(seconds / this.getDuration());
                            }
                        },
                        {
                            key: "play",
                            value: function play(start, end) {
                                var _this7 = this;
                                this.fireEvent("interaction", function() {
                                    return _this7.play(start, end);
                                });
                                return this.backend.play(start, end);
                            }
                        },
                        {
                            key: "setPlayEnd",
                            value: function setPlayEnd(position) {
                                this.backend.setPlayEnd(position);
                            }
                        },
                        {
                            key: "pause",
                            value: function pause() {
                                if (!this.backend.isPaused()) return this.backend.pause();
                            }
                        },
                        {
                            key: "playPause",
                            value: function playPause() {
                                return this.backend.isPaused() ? this.play() : this.pause();
                            }
                        },
                        {
                            key: "isPlaying",
                            value: function isPlaying() {
                                return !this.backend.isPaused();
                            }
                        },
                        {
                            key: "skipBackward",
                            value: function skipBackward(seconds) {
                                this.skip(-seconds || -this.params.skipLength);
                            }
                        },
                        {
                            key: "skipForward",
                            value: function skipForward(seconds) {
                                this.skip(seconds || this.params.skipLength);
                            }
                        },
                        {
                            key: "skip",
                            value: function skip(offset) {
                                var duration = this.getDuration() || 1;
                                var position = this.getCurrentTime() || 0;
                                position = Math.max(0, Math.min(duration, position + (offset || 0)));
                                this.seekAndCenter(position / duration);
                            }
                        },
                        {
                            key: "seekAndCenter",
                            value: function seekAndCenter(progress) {
                                this.seekTo(progress);
                                this.drawer.recenter(progress);
                            }
                        },
                        {
                            key: "seekTo",
                            value: function seekTo(progress) {
                                var _this8 = this;
                                // return an error if progress is not a number between 0 and 1
                                if (typeof progress !== "number" || !isFinite(progress) || progress < 0 || progress > 1) throw new Error("Error calling wavesurfer.seekTo, parameter must be a number between 0 and 1!");
                                this.fireEvent("interaction", function() {
                                    return _this8.seekTo(progress);
                                });
                                var isWebAudioBackend = this.params.backend === "WebAudio";
                                var paused = this.backend.isPaused();
                                if (isWebAudioBackend && !paused) this.backend.pause();
                                 // avoid small scrolls while paused seeking
                                var oldScrollParent = this.params.scrollParent;
                                this.params.scrollParent = false;
                                this.backend.seekTo(progress * this.getDuration());
                                this.drawer.progress(progress);
                                if (isWebAudioBackend && !paused) this.backend.play();
                                this.params.scrollParent = oldScrollParent;
                                this.fireEvent("seek", progress);
                            }
                        },
                        {
                            key: "stop",
                            value: function stop() {
                                this.pause();
                                this.seekTo(0);
                                this.drawer.progress(0);
                            }
                        },
                        {
                            key: "setSinkId",
                            value: function setSinkId(deviceId) {
                                return this.backend.setSinkId(deviceId);
                            }
                        },
                        {
                            key: "setVolume",
                            value: function setVolume(newVolume) {
                                this.backend.setVolume(newVolume);
                                this.fireEvent("volume", newVolume);
                            }
                        },
                        {
                            key: "getVolume",
                            value: function getVolume() {
                                return this.backend.getVolume();
                            }
                        },
                        {
                            key: "setPlaybackRate",
                            value: function setPlaybackRate(rate) {
                                this.backend.setPlaybackRate(rate);
                            }
                        },
                        {
                            key: "getPlaybackRate",
                            value: function getPlaybackRate() {
                                return this.backend.getPlaybackRate();
                            }
                        },
                        {
                            key: "toggleMute",
                            value: function toggleMute() {
                                this.setMute(!this.isMuted);
                            }
                        },
                        {
                            key: "setMute",
                            value: function setMute(mute) {
                                // ignore all muting requests if the audio is already in that state
                                if (mute === this.isMuted) {
                                    this.fireEvent("mute", this.isMuted);
                                    return;
                                }
                                if (this.backend.setMute) {
                                    // Backends such as the MediaElement backend have their own handling
                                    // of mute, let them handle it.
                                    this.backend.setMute(mute);
                                    this.isMuted = mute;
                                } else if (mute) {
                                    // If currently not muted then save current volume,
                                    // turn off the volume and update the mute properties
                                    this.savedVolume = this.backend.getVolume();
                                    this.backend.setVolume(0);
                                    this.isMuted = true;
                                    this.fireEvent("volume", 0);
                                } else {
                                    // If currently muted then restore to the saved volume
                                    // and update the mute properties
                                    this.backend.setVolume(this.savedVolume);
                                    this.isMuted = false;
                                    this.fireEvent("volume", this.savedVolume);
                                }
                                this.fireEvent("mute", this.isMuted);
                            }
                        },
                        {
                            key: "getMute",
                            value: function getMute() {
                                return this.isMuted;
                            }
                        },
                        {
                            key: "getFilters",
                            value: function getFilters() {
                                return this.backend.filters || [];
                            }
                        },
                        {
                            key: "toggleScroll",
                            value: function toggleScroll() {
                                this.params.scrollParent = !this.params.scrollParent;
                                this.drawBuffer();
                            }
                        },
                        {
                            key: "toggleInteraction",
                            value: function toggleInteraction() {
                                this.params.interact = !this.params.interact;
                            }
                        },
                        {
                            key: "getWaveColor",
                            value: function getWaveColor() {
                                return this.params.waveColor;
                            }
                        },
                        {
                            key: "setWaveColor",
                            value: function setWaveColor(color) {
                                this.params.waveColor = color;
                                this.drawBuffer();
                            }
                        },
                        {
                            key: "getProgressColor",
                            value: function getProgressColor() {
                                return this.params.progressColor;
                            }
                        },
                        {
                            key: "setProgressColor",
                            value: function setProgressColor(color) {
                                this.params.progressColor = color;
                                this.drawBuffer();
                            }
                        },
                        {
                            key: "getBackgroundColor",
                            value: function getBackgroundColor() {
                                return this.params.backgroundColor;
                            }
                        },
                        {
                            key: "setBackgroundColor",
                            value: function setBackgroundColor(color) {
                                this.params.backgroundColor = color;
                                util.style(this.container, {
                                    background: this.params.backgroundColor
                                });
                            }
                        },
                        {
                            key: "getCursorColor",
                            value: function getCursorColor() {
                                return this.params.cursorColor;
                            }
                        },
                        {
                            key: "setCursorColor",
                            value: function setCursorColor(color) {
                                this.params.cursorColor = color;
                                this.drawer.updateCursor();
                            }
                        },
                        {
                            key: "getHeight",
                            value: function getHeight() {
                                return this.params.height;
                            }
                        },
                        {
                            key: "setHeight",
                            value: function setHeight(height) {
                                this.params.height = height;
                                this.drawer.setHeight(height * this.params.pixelRatio);
                                this.drawBuffer();
                            }
                        },
                        {
                            key: "setFilteredChannels",
                            value: function setFilteredChannels(channelIndices) {
                                this.params.splitChannelsOptions.filterChannels = channelIndices;
                                this.drawBuffer();
                            }
                        },
                        {
                            key: "drawBuffer",
                            value: function drawBuffer() {
                                var nominalWidth = Math.round(this.getDuration() * this.params.minPxPerSec * this.params.pixelRatio);
                                var parentWidth = this.drawer.getWidth();
                                var width = nominalWidth; // always start at 0 after zooming for scrolling : issue redraw left part
                                var start = 0;
                                var end = Math.max(start + parentWidth, width); // Fill container
                                if (this.params.fillParent && (!this.params.scrollParent || nominalWidth < parentWidth)) {
                                    width = parentWidth;
                                    start = 0;
                                    end = width;
                                }
                                var peaks;
                                if (this.params.partialRender) {
                                    var newRanges = this.peakCache.addRangeToPeakCache(width, start, end);
                                    var i;
                                    for(i = 0; i < newRanges.length; i++){
                                        peaks = this.backend.getPeaks(width, newRanges[i][0], newRanges[i][1]);
                                        this.drawer.drawPeaks(peaks, width, newRanges[i][0], newRanges[i][1]);
                                    }
                                } else {
                                    peaks = this.backend.getPeaks(width, start, end);
                                    this.drawer.drawPeaks(peaks, width, start, end);
                                }
                                this.fireEvent("redraw", peaks, width);
                            }
                        },
                        {
                            key: "zoom",
                            value: function zoom(pxPerSec) {
                                if (!pxPerSec) {
                                    this.params.minPxPerSec = this.defaultParams.minPxPerSec;
                                    this.params.scrollParent = false;
                                } else {
                                    this.params.minPxPerSec = pxPerSec;
                                    this.params.scrollParent = true;
                                }
                                this.drawBuffer();
                                this.drawer.progress(this.backend.getPlayedPercents());
                                this.drawer.recenter(this.getCurrentTime() / this.getDuration());
                                this.fireEvent("zoom", pxPerSec);
                            }
                        },
                        {
                            key: "loadArrayBuffer",
                            value: function loadArrayBuffer(arraybuffer) {
                                var _this9 = this;
                                this.decodeArrayBuffer(arraybuffer, function(data) {
                                    if (!_this9.isDestroyed) _this9.loadDecodedBuffer(data);
                                });
                            }
                        },
                        {
                            key: "loadDecodedBuffer",
                            value: function loadDecodedBuffer(buffer) {
                                this.backend.load(buffer);
                                this.drawBuffer();
                                this.isReady = true;
                                this.fireEvent("ready");
                            }
                        },
                        {
                            key: "loadBlob",
                            value: function loadBlob(blob) {
                                var _this10 = this;
                                // Create file reader
                                var reader = new FileReader();
                                reader.addEventListener("progress", function(e) {
                                    return _this10.onProgress(e);
                                });
                                reader.addEventListener("load", function(e) {
                                    return _this10.loadArrayBuffer(e.target.result);
                                });
                                reader.addEventListener("error", function() {
                                    return _this10.fireEvent("error", "Error reading file");
                                });
                                reader.readAsArrayBuffer(blob);
                                this.empty();
                            }
                        },
                        {
                            key: "load",
                            value: function load(url, peaks, preload, duration) {
                                if (!url) throw new Error("url parameter cannot be empty");
                                this.empty();
                                if (preload) {
                                    // check whether the preload attribute will be usable and if not log
                                    // a warning listing the reasons why not and nullify the variable
                                    var preloadIgnoreReasons = {
                                        "Preload is not 'auto', 'none' or 'metadata'": [
                                            "auto",
                                            "metadata",
                                            "none"
                                        ].indexOf(preload) === -1,
                                        "Peaks are not provided": !peaks,
                                        "Backend is not of type 'MediaElement' or 'MediaElementWebAudio'": [
                                            "MediaElement",
                                            "MediaElementWebAudio"
                                        ].indexOf(this.params.backend) === -1,
                                        "Url is not of type string": typeof url !== "string"
                                    };
                                    var activeReasons = Object.keys(preloadIgnoreReasons).filter(function(reason) {
                                        return preloadIgnoreReasons[reason];
                                    });
                                    if (activeReasons.length) {
                                        // eslint-disable-next-line no-console
                                        console.warn("Preload parameter of wavesurfer.load will be ignored because:\n	- " + activeReasons.join("\n	- ")); // stop invalid values from being used
                                        preload = null;
                                    }
                                } // loadBuffer(url, peaks, duration) requires that url is a string
                                // but users can pass in a HTMLMediaElement to WaveSurfer
                                if (this.params.backend === "WebAudio" && url instanceof HTMLMediaElement) url = url.src;
                                switch(this.params.backend){
                                    case "WebAudio":
                                        return this.loadBuffer(url, peaks, duration);
                                    case "MediaElement":
                                    case "MediaElementWebAudio":
                                        return this.loadMediaElement(url, peaks, preload, duration);
                                }
                            }
                        },
                        {
                            key: "loadBuffer",
                            value: function loadBuffer(url, peaks, duration) {
                                var _this11 = this;
                                var load = function load(action) {
                                    if (action) _this11.tmpEvents.push(_this11.once("ready", action));
                                    return _this11.getArrayBuffer(url, function(data) {
                                        return _this11.loadArrayBuffer(data);
                                    });
                                };
                                if (peaks) {
                                    this.backend.setPeaks(peaks, duration);
                                    this.drawBuffer();
                                    this.fireEvent("waveform-ready");
                                    this.tmpEvents.push(this.once("interaction", load));
                                } else return load();
                            }
                        },
                        {
                            key: "loadMediaElement",
                            value: function loadMediaElement(urlOrElt, peaks, preload, duration) {
                                var _this12 = this;
                                var url = urlOrElt;
                                if (typeof urlOrElt === "string") this.backend.load(url, this.mediaContainer, peaks, preload);
                                else {
                                    var elt = urlOrElt;
                                    this.backend.loadElt(elt, peaks); // If peaks are not provided,
                                    // url = element.src so we can get peaks with web audio
                                    url = elt.src;
                                }
                                this.tmpEvents.push(this.backend.once("canplay", function() {
                                    // ignore when backend was already destroyed
                                    if (!_this12.backend.destroyed) {
                                        _this12.drawBuffer();
                                        _this12.isReady = true;
                                        _this12.fireEvent("ready");
                                    }
                                }), this.backend.once("error", function(err) {
                                    return _this12.fireEvent("error", err);
                                })); // If peaks are provided, render them and fire the `waveform-ready` event.
                                if (peaks) {
                                    this.backend.setPeaks(peaks, duration);
                                    this.drawBuffer();
                                    this.fireEvent("waveform-ready");
                                } // If no pre-decoded peaks are provided, or are provided with
                                // forceDecode flag, attempt to download the audio file and decode it
                                // with Web Audio.
                                if ((!peaks || this.params.forceDecode) && this.backend.supportsWebAudio()) this.getArrayBuffer(url, function(arraybuffer) {
                                    _this12.decodeArrayBuffer(arraybuffer, function(buffer) {
                                        _this12.backend.buffer = buffer;
                                        _this12.backend.setPeaks(null);
                                        _this12.drawBuffer();
                                        _this12.fireEvent("waveform-ready");
                                    });
                                });
                            }
                        },
                        {
                            key: "decodeArrayBuffer",
                            value: function decodeArrayBuffer(arraybuffer, callback) {
                                var _this13 = this;
                                this.arraybuffer = arraybuffer;
                                this.backend.decodeArrayBuffer(arraybuffer, function(data) {
                                    // Only use the decoded data if we haven't been destroyed or
                                    // another decode started in the meantime
                                    if (!_this13.isDestroyed && _this13.arraybuffer == arraybuffer) {
                                        callback(data);
                                        _this13.arraybuffer = null;
                                    }
                                }, function() {
                                    return _this13.fireEvent("error", "Error decoding audiobuffer");
                                });
                            }
                        },
                        {
                            key: "getArrayBuffer",
                            value: function getArrayBuffer(url, callback) {
                                var _this14 = this;
                                var options = Object.assign({
                                    url: url,
                                    responseType: "arraybuffer"
                                }, this.params.xhr);
                                var request = util.fetchFile(options);
                                this.currentRequest = request;
                                this.tmpEvents.push(request.on("progress", function(e) {
                                    _this14.onProgress(e);
                                }), request.on("success", function(data) {
                                    callback(data);
                                    _this14.currentRequest = null;
                                }), request.on("error", function(e) {
                                    _this14.fireEvent("error", e);
                                    _this14.currentRequest = null;
                                }));
                                return request;
                            }
                        },
                        {
                            key: "onProgress",
                            value: function onProgress(e) {
                                var percentComplete;
                                if (e.lengthComputable) percentComplete = e.loaded / e.total;
                                else // Approximate progress with an asymptotic
                                // function, and assume downloads in the 1-3 MB range.
                                percentComplete = e.loaded / (e.loaded + 1000000);
                                this.fireEvent("loading", Math.round(percentComplete * 100), e.target);
                            }
                        },
                        {
                            key: "exportPCM",
                            value: function exportPCM(length, accuracy, noWindow, start, end) {
                                length = length || 1024;
                                start = start || 0;
                                accuracy = accuracy || 10000;
                                noWindow = noWindow || false;
                                var peaks = this.backend.getPeaks(length, start, end);
                                var arr = [].map.call(peaks, function(val) {
                                    return Math.round(val * accuracy) / accuracy;
                                });
                                return new Promise(function(resolve, reject) {
                                    var json = JSON.stringify(arr);
                                    if (!noWindow) window.open("data:application/json;charset=utf-8," + encodeURIComponent(json));
                                    resolve(json);
                                });
                            }
                        },
                        {
                            key: "exportImage",
                            value: function exportImage(format, quality, type) {
                                if (!format) format = "image/png";
                                if (!quality) quality = 1;
                                if (!type) type = "dataURL";
                                return this.drawer.getImage(format, quality, type);
                            }
                        },
                        {
                            key: "cancelAjax",
                            value: function cancelAjax() {
                                if (this.currentRequest && this.currentRequest.controller) {
                                    // If the current request has a ProgressHandler, then its ReadableStream might need to be cancelled too
                                    // See: Wavesurfer issue #2042
                                    // See Firefox bug: https://bugzilla.mozilla.org/show_bug.cgi?id=1583815
                                    if (this.currentRequest._reader) // Ignoring exceptions thrown by call to cancel()
                                    this.currentRequest._reader.cancel().catch(function(err) {});
                                    this.currentRequest.controller.abort();
                                    this.currentRequest = null;
                                }
                            }
                        },
                        {
                            key: "clearTmpEvents",
                            value: function clearTmpEvents() {
                                this.tmpEvents.forEach(function(e) {
                                    return e.un();
                                });
                            }
                        },
                        {
                            key: "empty",
                            value: function empty() {
                                if (!this.backend.isPaused()) {
                                    this.stop();
                                    this.backend.disconnectSource();
                                }
                                this.isReady = false;
                                this.cancelAjax();
                                this.clearTmpEvents(); // empty drawer
                                this.drawer.progress(0);
                                this.drawer.setWidth(0);
                                this.drawer.drawPeaks({
                                    length: this.drawer.getWidth()
                                }, 0);
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                this.destroyAllPlugins();
                                this.fireEvent("destroy");
                                this.cancelAjax();
                                this.clearTmpEvents();
                                this.unAll();
                                if (this.params.responsive !== false) {
                                    window.removeEventListener("resize", this._onResize, true);
                                    window.removeEventListener("orientationchange", this._onResize, true);
                                }
                                if (this.backend) {
                                    this.backend.destroy(); // clears memory usage
                                    this.backend = null;
                                }
                                if (this.drawer) this.drawer.destroy();
                                this.isDestroyed = true;
                                this.isReady = false;
                                this.arraybuffer = null;
                            }
                        }
                    ], [
                        {
                            key: "create",
                            value: /** @private */ /** @private */ /**
     * Instantiate this class, call its `init` function and returns it
     *
     * @param {WavesurferParams} params The wavesurfer parameters
     * @return {Object} WaveSurfer instance
     * @example const wavesurfer = WaveSurfer.create(params);
     */ function create(params) {
                                var wavesurfer = new WaveSurfer(params);
                                return wavesurfer.init();
                            }
                        }
                    ]);
                    return WaveSurfer;
                }(util.Observer);
                exports.default = WaveSurfer;
                WaveSurfer.VERSION = "4.6.0";
                WaveSurfer.util = util;
                module1.exports = exports.default;
            /***/ },
            /***/ "./src/webaudio.js": /*!*************************!*\
  !*** ./src/webaudio.js ***!
  \*************************/ /***/ (module1, exports, __webpack_require__)=>{
                "use strict";
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var util = _interopRequireWildcard(__webpack_require__(/*! ./util */ "./src/util/index.js"));
                function _getRequireWildcardCache() {
                    if (typeof WeakMap !== "function") return null;
                    var cache = new WeakMap();
                    _getRequireWildcardCache = function _getRequireWildcardCache() {
                        return cache;
                    };
                    return cache;
                }
                function _interopRequireWildcard(obj) {
                    if (obj && obj.__esModule) return obj;
                    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") return {
                        default: obj
                    };
                    var cache = _getRequireWildcardCache();
                    if (cache && cache.has(obj)) return cache.get(obj);
                    var newObj = {};
                    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
                        else newObj[key] = obj[key];
                    }
                    newObj.default = obj;
                    if (cache) cache.set(obj, newObj);
                    return newObj;
                }
                function _defineProperty(obj, key, value) {
                    if (key in obj) Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                    else obj[key] = value;
                    return obj;
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) _setPrototypeOf(subClass, superClass);
                }
                function _setPrototypeOf(o, p) {
                    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                        o.__proto__ = p;
                        return o;
                    };
                    return _setPrototypeOf(o, p);
                }
                function _createSuper(Derived) {
                    var hasNativeReflectConstruct = _isNativeReflectConstruct();
                    return function _createSuperInternal() {
                        var Super = _getPrototypeOf(Derived), result;
                        if (hasNativeReflectConstruct) {
                            var NewTarget = _getPrototypeOf(this).constructor;
                            result = Reflect.construct(Super, arguments, NewTarget);
                        } else result = Super.apply(this, arguments);
                        return _possibleConstructorReturn(this, result);
                    };
                }
                function _possibleConstructorReturn(self, call) {
                    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
                    return _assertThisInitialized(self);
                }
                function _assertThisInitialized(self) {
                    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self;
                }
                function _isNativeReflectConstruct() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                function _getPrototypeOf(o) {
                    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                        return o.__proto__ || Object.getPrototypeOf(o);
                    };
                    return _getPrototypeOf(o);
                }
                // using constants to prevent someone writing the string wrong
                var PLAYING = "playing";
                var PAUSED = "paused";
                var FINISHED = "finished";
                /**
 * WebAudio backend
 *
 * @extends {Observer}
 */ var WebAudio = /*#__PURE__*/ function(_util$Observer) {
                    _inherits(WebAudio, _util$Observer);
                    var _super = _createSuper(WebAudio);
                    /**
   * Construct the backend
   *
   * @param {WavesurferParams} params Wavesurfer parameters
   */ function WebAudio(params) {
                        var _this$stateBehaviors, _this$states;
                        var _this;
                        _classCallCheck(this, WebAudio);
                        _this = _super.call(this);
                        /** @private */ _this.audioContext = null;
                        _this.offlineAudioContext = null;
                        _this.stateBehaviors = (_this$stateBehaviors = {}, _defineProperty(_this$stateBehaviors, PLAYING, {
                            init: function init() {
                                this.addOnAudioProcess();
                            },
                            getPlayedPercents: function getPlayedPercents() {
                                var duration = this.getDuration();
                                return this.getCurrentTime() / duration || 0;
                            },
                            getCurrentTime: function getCurrentTime() {
                                return this.startPosition + this.getPlayedTime();
                            }
                        }), _defineProperty(_this$stateBehaviors, PAUSED, {
                            init: function init() {
                                this.removeOnAudioProcess();
                            },
                            getPlayedPercents: function getPlayedPercents() {
                                var duration = this.getDuration();
                                return this.getCurrentTime() / duration || 0;
                            },
                            getCurrentTime: function getCurrentTime() {
                                return this.startPosition;
                            }
                        }), _defineProperty(_this$stateBehaviors, FINISHED, {
                            init: function init() {
                                this.removeOnAudioProcess();
                                this.fireEvent("finish");
                            },
                            getPlayedPercents: function getPlayedPercents() {
                                return 1;
                            },
                            getCurrentTime: function getCurrentTime() {
                                return this.getDuration();
                            }
                        }), _this$stateBehaviors);
                        _this.params = params;
                        /** ac: Audio Context instance */ _this.ac = params.audioContext || (_this.supportsWebAudio() ? _this.getAudioContext() : {});
                        /**@private */ _this.lastPlay = _this.ac.currentTime;
                        /** @private */ _this.startPosition = 0;
                        /** @private */ _this.scheduledPause = null;
                        /** @private */ _this.states = (_this$states = {}, _defineProperty(_this$states, PLAYING, Object.create(_this.stateBehaviors[PLAYING])), _defineProperty(_this$states, PAUSED, Object.create(_this.stateBehaviors[PAUSED])), _defineProperty(_this$states, FINISHED, Object.create(_this.stateBehaviors[FINISHED])), _this$states);
                        /** @private */ _this.buffer = null;
                        /** @private */ _this.filters = [];
                        /** gainNode: allows to control audio volume */ _this.gainNode = null;
                        /** @private */ _this.mergedPeaks = null;
                        /** @private */ _this.offlineAc = null;
                        /** @private */ _this.peaks = null;
                        /** @private */ _this.playbackRate = 1;
                        /** analyser: provides audio analysis information */ _this.analyser = null;
                        /** scriptNode: allows processing audio */ _this.scriptNode = null;
                        /** @private */ _this.source = null;
                        /** @private */ _this.splitPeaks = [];
                        /** @private */ _this.state = null;
                        /** @private */ _this.explicitDuration = params.duration;
                        /**
     * Boolean indicating if the backend was destroyed.
     */ _this.destroyed = false;
                        return _this;
                    }
                    /**
   * Initialise the backend, called in `wavesurfer.createBackend()`
   */ _createClass(WebAudio, [
                        {
                            key: "supportsWebAudio",
                            value: /** scriptBufferSize: size of the processing buffer */ /** audioContext: allows to process audio with WebAudio API */ /** @private */ /** @private */ /**
     * Does the browser support this backend
     *
     * @return {boolean} Whether or not this browser supports this backend
     */ function supportsWebAudio() {
                                return !!(window.AudioContext || window.webkitAudioContext);
                            }
                        },
                        {
                            key: "getAudioContext",
                            value: function getAudioContext() {
                                if (!window.WaveSurferAudioContext) window.WaveSurferAudioContext = new (window.AudioContext || window.webkitAudioContext)();
                                return window.WaveSurferAudioContext;
                            }
                        },
                        {
                            key: "getOfflineAudioContext",
                            value: function getOfflineAudioContext(sampleRate) {
                                if (!window.WaveSurferOfflineAudioContext) window.WaveSurferOfflineAudioContext = new (window.OfflineAudioContext || window.webkitOfflineAudioContext)(1, 2, sampleRate);
                                return window.WaveSurferOfflineAudioContext;
                            }
                        },
                        {
                            key: "init",
                            value: function init() {
                                this.createVolumeNode();
                                this.createScriptNode();
                                this.createAnalyserNode();
                                this.setState(PAUSED);
                                this.setPlaybackRate(this.params.audioRate);
                                this.setLength(0);
                            }
                        },
                        {
                            key: "disconnectFilters",
                            value: function disconnectFilters() {
                                if (this.filters) {
                                    this.filters.forEach(function(filter) {
                                        filter && filter.disconnect();
                                    });
                                    this.filters = null; // Reconnect direct path
                                    this.analyser.connect(this.gainNode);
                                }
                            }
                        },
                        {
                            key: "setState",
                            value: function setState(state) {
                                if (this.state !== this.states[state]) {
                                    this.state = this.states[state];
                                    this.state.init.call(this);
                                }
                            }
                        },
                        {
                            key: "setFilter",
                            value: function setFilter() {
                                for(var _len = arguments.length, filters = new Array(_len), _key = 0; _key < _len; _key++)filters[_key] = arguments[_key];
                                this.setFilters(filters);
                            }
                        },
                        {
                            key: "setFilters",
                            value: function setFilters(filters) {
                                // Remove existing filters
                                this.disconnectFilters(); // Insert filters if filter array not empty
                                if (filters && filters.length) {
                                    this.filters = filters; // Disconnect direct path before inserting filters
                                    this.analyser.disconnect(); // Connect each filter in turn
                                    filters.reduce(function(prev, curr) {
                                        prev.connect(curr);
                                        return curr;
                                    }, this.analyser).connect(this.gainNode);
                                }
                            }
                        },
                        {
                            key: "createScriptNode",
                            value: function createScriptNode() {
                                if (this.params.audioScriptProcessor) this.scriptNode = this.params.audioScriptProcessor;
                                else if (this.ac.createScriptProcessor) this.scriptNode = this.ac.createScriptProcessor(WebAudio.scriptBufferSize);
                                else this.scriptNode = this.ac.createJavaScriptNode(WebAudio.scriptBufferSize);
                                this.scriptNode.connect(this.ac.destination);
                            }
                        },
                        {
                            key: "addOnAudioProcess",
                            value: function addOnAudioProcess() {
                                var _this2 = this;
                                this.scriptNode.onaudioprocess = function() {
                                    var time = _this2.getCurrentTime();
                                    if (time >= _this2.getDuration()) {
                                        _this2.setState(FINISHED);
                                        _this2.fireEvent("pause");
                                    } else if (time >= _this2.scheduledPause) _this2.pause();
                                    else if (_this2.state === _this2.states[PLAYING]) _this2.fireEvent("audioprocess", time);
                                };
                            }
                        },
                        {
                            key: "removeOnAudioProcess",
                            value: function removeOnAudioProcess() {
                                this.scriptNode.onaudioprocess = function() {};
                            }
                        },
                        {
                            key: "createAnalyserNode",
                            value: function createAnalyserNode() {
                                this.analyser = this.ac.createAnalyser();
                                this.analyser.connect(this.gainNode);
                            }
                        },
                        {
                            key: "createVolumeNode",
                            value: function createVolumeNode() {
                                // Create gain node using the AudioContext
                                if (this.ac.createGain) this.gainNode = this.ac.createGain();
                                else this.gainNode = this.ac.createGainNode();
                                 // Add the gain node to the graph
                                this.gainNode.connect(this.ac.destination);
                            }
                        },
                        {
                            key: "setSinkId",
                            value: function setSinkId(deviceId) {
                                if (deviceId) {
                                    /**
         * The webaudio API doesn't currently support setting the device
         * output. Here we create an HTMLAudioElement, connect the
         * webaudio stream to that element and setSinkId there.
         */ var audio = new window.Audio();
                                    if (!audio.setSinkId) return Promise.reject(new Error("setSinkId is not supported in your browser"));
                                    audio.autoplay = true;
                                    var dest = this.ac.createMediaStreamDestination();
                                    this.gainNode.disconnect();
                                    this.gainNode.connect(dest);
                                    audio.srcObject = dest.stream;
                                    return audio.setSinkId(deviceId);
                                } else return Promise.reject(new Error("Invalid deviceId: " + deviceId));
                            }
                        },
                        {
                            key: "setVolume",
                            value: function setVolume(value) {
                                this.gainNode.gain.setValueAtTime(value, this.ac.currentTime);
                            }
                        },
                        {
                            key: "getVolume",
                            value: function getVolume() {
                                return this.gainNode.gain.value;
                            }
                        },
                        {
                            key: "decodeArrayBuffer",
                            value: function decodeArrayBuffer(arraybuffer, callback, errback) {
                                if (!this.offlineAc) this.offlineAc = this.getOfflineAudioContext(this.ac && this.ac.sampleRate ? this.ac.sampleRate : 44100);
                                if ("webkitAudioContext" in window) // Safari: no support for Promise-based decodeAudioData enabled
                                // Enable it in Safari using the Experimental Features > Modern WebAudio API option
                                this.offlineAc.decodeAudioData(arraybuffer, function(data) {
                                    return callback(data);
                                }, errback);
                                else this.offlineAc.decodeAudioData(arraybuffer).then(function(data) {
                                    return callback(data);
                                }).catch(function(err) {
                                    return errback(err);
                                });
                            }
                        },
                        {
                            key: "setPeaks",
                            value: function setPeaks(peaks, duration) {
                                if (duration != null) this.explicitDuration = duration;
                                this.peaks = peaks;
                            }
                        },
                        {
                            key: "setLength",
                            value: function setLength(length) {
                                // No resize, we can preserve the cached peaks.
                                if (this.mergedPeaks && length == 2 * this.mergedPeaks.length - 1 + 2) return;
                                this.splitPeaks = [];
                                this.mergedPeaks = []; // Set the last element of the sparse array so the peak arrays are
                                // appropriately sized for other calculations.
                                var channels = this.buffer ? this.buffer.numberOfChannels : 1;
                                var c;
                                for(c = 0; c < channels; c++){
                                    this.splitPeaks[c] = [];
                                    this.splitPeaks[c][2 * (length - 1)] = 0;
                                    this.splitPeaks[c][2 * (length - 1) + 1] = 0;
                                }
                                this.mergedPeaks[2 * (length - 1)] = 0;
                                this.mergedPeaks[2 * (length - 1) + 1] = 0;
                            }
                        },
                        {
                            key: "getPeaks",
                            value: function getPeaks(length, first, last) {
                                if (this.peaks) return this.peaks;
                                if (!this.buffer) return [];
                                first = first || 0;
                                last = last || length - 1;
                                this.setLength(length);
                                if (!this.buffer) return this.params.splitChannels ? this.splitPeaks : this.mergedPeaks;
                                /**
       * The following snippet fixes a buffering data issue on the Safari
       * browser which returned undefined It creates the missing buffer based
       * on 1 channel, 4096 samples and the sampleRate from the current
       * webaudio context 4096 samples seemed to be the best fit for rendering
       * will review this code once a stable version of Safari TP is out
       */ if (!this.buffer.length) {
                                    var newBuffer = this.createBuffer(1, 4096, this.sampleRate);
                                    this.buffer = newBuffer.buffer;
                                }
                                var sampleSize = this.buffer.length / length;
                                var sampleStep = ~~(sampleSize / 10) || 1;
                                var channels = this.buffer.numberOfChannels;
                                var c;
                                for(c = 0; c < channels; c++){
                                    var peaks = this.splitPeaks[c];
                                    var chan = this.buffer.getChannelData(c);
                                    var i = void 0;
                                    for(i = first; i <= last; i++){
                                        var start = ~~(i * sampleSize);
                                        var end = ~~(start + sampleSize);
                                        /**
           * Initialize the max and min to the first sample of this
           * subrange, so that even if the samples are entirely
           * on one side of zero, we still return the true max and
           * min values in the subrange.
           */ var min = chan[start];
                                        var max = min;
                                        var j = void 0;
                                        for(j = start; j < end; j += sampleStep){
                                            var value = chan[j];
                                            if (value > max) max = value;
                                            if (value < min) min = value;
                                        }
                                        peaks[2 * i] = max;
                                        peaks[2 * i + 1] = min;
                                        if (c == 0 || max > this.mergedPeaks[2 * i]) this.mergedPeaks[2 * i] = max;
                                        if (c == 0 || min < this.mergedPeaks[2 * i + 1]) this.mergedPeaks[2 * i + 1] = min;
                                    }
                                }
                                return this.params.splitChannels ? this.splitPeaks : this.mergedPeaks;
                            }
                        },
                        {
                            key: "getPlayedPercents",
                            value: function getPlayedPercents() {
                                return this.state.getPlayedPercents.call(this);
                            }
                        },
                        {
                            key: "disconnectSource",
                            value: function disconnectSource() {
                                if (this.source) this.source.disconnect();
                            }
                        },
                        {
                            key: "destroyWebAudio",
                            value: function destroyWebAudio() {
                                this.disconnectFilters();
                                this.disconnectSource();
                                this.gainNode.disconnect();
                                this.scriptNode.disconnect();
                                this.analyser.disconnect(); // close the audioContext if closeAudioContext option is set to true
                                if (this.params.closeAudioContext) {
                                    // check if browser supports AudioContext.close()
                                    if (typeof this.ac.close === "function" && this.ac.state != "closed") this.ac.close();
                                     // clear the reference to the audiocontext
                                    this.ac = null; // clear the actual audiocontext, either passed as param or the
                                    // global singleton
                                    if (!this.params.audioContext) window.WaveSurferAudioContext = null;
                                    else this.params.audioContext = null;
                                     // clear the offlineAudioContext
                                    window.WaveSurferOfflineAudioContext = null;
                                }
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                if (!this.isPaused()) this.pause();
                                this.unAll();
                                this.buffer = null;
                                this.destroyed = true;
                                this.destroyWebAudio();
                            }
                        },
                        {
                            key: "load",
                            value: function load(buffer) {
                                this.startPosition = 0;
                                this.lastPlay = this.ac.currentTime;
                                this.buffer = buffer;
                                this.createSource();
                            }
                        },
                        {
                            key: "createSource",
                            value: function createSource() {
                                this.disconnectSource();
                                this.source = this.ac.createBufferSource(); // adjust for old browsers
                                this.source.start = this.source.start || this.source.noteGrainOn;
                                this.source.stop = this.source.stop || this.source.noteOff;
                                this.setPlaybackRate(this.playbackRate);
                                this.source.buffer = this.buffer;
                                this.source.connect(this.analyser);
                            }
                        },
                        {
                            key: "resumeAudioContext",
                            value: function resumeAudioContext() {
                                if (this.ac.state == "suspended") this.ac.resume && this.ac.resume();
                            }
                        },
                        {
                            key: "isPaused",
                            value: function isPaused() {
                                return this.state !== this.states[PLAYING];
                            }
                        },
                        {
                            key: "getDuration",
                            value: function getDuration() {
                                if (this.explicitDuration) return this.explicitDuration;
                                if (!this.buffer) return 0;
                                return this.buffer.duration;
                            }
                        },
                        {
                            key: "seekTo",
                            value: function seekTo(start, end) {
                                if (!this.buffer) return;
                                this.scheduledPause = null;
                                if (start == null) {
                                    start = this.getCurrentTime();
                                    if (start >= this.getDuration()) start = 0;
                                }
                                if (end == null) end = this.getDuration();
                                this.startPosition = start;
                                this.lastPlay = this.ac.currentTime;
                                if (this.state === this.states[FINISHED]) this.setState(PAUSED);
                                return {
                                    start: start,
                                    end: end
                                };
                            }
                        },
                        {
                            key: "getPlayedTime",
                            value: function getPlayedTime() {
                                return (this.ac.currentTime - this.lastPlay) * this.playbackRate;
                            }
                        },
                        {
                            key: "play",
                            value: function play(start, end) {
                                if (!this.buffer) return;
                                 // need to re-create source on each playback
                                this.createSource();
                                var adjustedTime = this.seekTo(start, end);
                                start = adjustedTime.start;
                                end = adjustedTime.end;
                                this.scheduledPause = end;
                                this.source.start(0, start);
                                this.resumeAudioContext();
                                this.setState(PLAYING);
                                this.fireEvent("play");
                            }
                        },
                        {
                            key: "pause",
                            value: function pause() {
                                this.scheduledPause = null;
                                this.startPosition += this.getPlayedTime();
                                this.source && this.source.stop(0);
                                this.setState(PAUSED);
                                this.fireEvent("pause");
                            }
                        },
                        {
                            key: "getCurrentTime",
                            value: function getCurrentTime() {
                                return this.state.getCurrentTime.call(this);
                            }
                        },
                        {
                            key: "getPlaybackRate",
                            value: function getPlaybackRate() {
                                return this.playbackRate;
                            }
                        },
                        {
                            key: "setPlaybackRate",
                            value: function setPlaybackRate(value) {
                                this.playbackRate = value || 1;
                                this.source && this.source.playbackRate.setValueAtTime(this.playbackRate, this.ac.currentTime);
                            }
                        },
                        {
                            key: "setPlayEnd",
                            value: function setPlayEnd(end) {
                                this.scheduledPause = end;
                            }
                        }
                    ]);
                    return WebAudio;
                }(util.Observer);
                exports.default = WebAudio;
                WebAudio.scriptBufferSize = 256;
                module1.exports = exports.default;
            /***/ },
            /***/ "./node_modules/debounce/index.js": /*!****************************************!*\
  !*** ./node_modules/debounce/index.js ***!
  \****************************************/ /***/ (module1)=>{
                /**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */ function debounce(func, wait, immediate) {
                    var timeout, args, context, timestamp, result;
                    if (null == wait) wait = 100;
                    function later() {
                        var last = Date.now() - timestamp;
                        if (last < wait && last >= 0) timeout = setTimeout(later, wait - last);
                        else {
                            timeout = null;
                            if (!immediate) {
                                result = func.apply(context, args);
                                context = args = null;
                            }
                        }
                    }
                    var debounced = function() {
                        context = this;
                        args = arguments;
                        timestamp = Date.now();
                        var callNow = immediate && !timeout;
                        if (!timeout) timeout = setTimeout(later, wait);
                        if (callNow) {
                            result = func.apply(context, args);
                            context = args = null;
                        }
                        return result;
                    };
                    debounced.clear = function() {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                    };
                    debounced.flush = function() {
                        if (timeout) {
                            result = func.apply(context, args);
                            context = args = null;
                            clearTimeout(timeout);
                            timeout = null;
                        }
                    };
                    return debounced;
                }
                // Adds compatibility for ES modules
                debounce.debounce = debounce;
                module1.exports = debounce;
            /***/ }
        };
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ if (__webpack_module_cache__[moduleId]) /******/ return __webpack_module_cache__[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId](module1, module1.exports, __webpack_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /******/ // startup
        /******/ // Load entry module and return exports
        /******/ // This entry module is referenced by other modules so it can't be inlined
        /******/ var __webpack_exports__ = __webpack_require__("./src/wavesurfer.js");
        /******/ /******/ return __webpack_exports__;
    /******/ })();
});

});

parcelRegister("1PHuw", function(module, exports) {
/*!
 * wavesurfer.js timeline plugin 4.6.0 (2021-03-05)
 * https://wavesurfer-js.org
 * @license BSD-3-Clause
 */ (function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
})(module.exports, function() {
    return /******/ (()=>{
        /******/ "use strict";
        /******/ var __webpack_modules__ = {
            /***/ "./src/plugin/timeline/index.js": /*!**************************************!*\
  !*** ./src/plugin/timeline/index.js ***!
  \**************************************/ /***/ (module1, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                /**
 * @typedef {Object} TimelinePluginParams
 * @desc Extends the `WavesurferParams` wavesurfer was initialised with
 * @property {!string|HTMLElement} container CSS selector or HTML element where
 * the timeline should be drawn. This is the only required parameter.
 * @property {number} notchPercentHeight=90 Height of notches in percent
 * @property {string} unlabeledNotchColor='#c0c0c0' The colour of the notches
 * that do not have labels
 * @property {string} primaryColor='#000' The colour of the main notches
 * @property {string} secondaryColor='#c0c0c0' The colour of the secondary
 * notches
 * @property {string} primaryFontColor='#000' The colour of the labels next to
 * the main notches
 * @property {string} secondaryFontColor='#000' The colour of the labels next to
 * the secondary notches
 * @property {number} labelPadding=5 The padding between the label and the notch
 * @property {?number} zoomDebounce A debounce timeout to increase rendering
 * performance for large files
 * @property {string} fontFamily='Arial'
 * @property {number} fontSize=10 Font size of labels in pixels
 * @property {?number} duration Length of the track in seconds. Overrides
 * getDuration() for setting length of timeline
 * @property {function} formatTimeCallback (sec, pxPerSec) -> label
 * @property {function} timeInterval (pxPerSec) -> seconds between notches
 * @property {function} primaryLabelInterval (pxPerSec) -> cadence between
 * labels in primary color
 * @property {function} secondaryLabelInterval (pxPerSec) -> cadence between
 * labels in secondary color
 * @property {?number} offset Offset for the timeline start in seconds. May also be
 * negative.
 * @property {?boolean} deferInit Set to true to manually call
 * `initPlugin('timeline')`
 */ /**
 * Adds a timeline to the waveform.
 *
 * @implements {PluginClass}
 * @extends {Observer}
 * @example
 * // es6
 * import TimelinePlugin from 'wavesurfer.timeline.js';
 *
 * // commonjs
 * var TimelinePlugin = require('wavesurfer.timeline.js');
 *
 * // if you are using <script> tags
 * var TimelinePlugin = window.WaveSurfer.timeline;
 *
 * // ... initialising wavesurfer with the plugin
 * var wavesurfer = WaveSurfer.create({
 *   // wavesurfer options ...
 *   plugins: [
 *     TimelinePlugin.create({
 *       // plugin options ...
 *     })
 *   ]
 * });
 */ var TimelinePlugin = /*#__PURE__*/ function() {
                    /**
   * Creates an instance of TimelinePlugin.
   *
   * You probably want to use TimelinePlugin.create()
   *
   * @param {TimelinePluginParams} params Plugin parameters
   * @param {object} ws Wavesurfer instance
   */ function TimelinePlugin(params, ws) {
                        var _this = this;
                        _classCallCheck(this, TimelinePlugin);
                        _initialiseProps.call(this);
                        this.container = "string" == typeof params.container ? document.querySelector(params.container) : params.container;
                        if (!this.container) throw new Error("No container for wavesurfer timeline");
                        this.wavesurfer = ws;
                        this.util = ws.util;
                        this.params = Object.assign({}, {
                            height: 20,
                            notchPercentHeight: 90,
                            labelPadding: 5,
                            unlabeledNotchColor: "#c0c0c0",
                            primaryColor: "#000",
                            secondaryColor: "#c0c0c0",
                            primaryFontColor: "#000",
                            secondaryFontColor: "#000",
                            fontFamily: "Arial",
                            fontSize: 10,
                            duration: null,
                            zoomDebounce: false,
                            formatTimeCallback: this.defaultFormatTimeCallback,
                            timeInterval: this.defaultTimeInterval,
                            primaryLabelInterval: this.defaultPrimaryLabelInterval,
                            secondaryLabelInterval: this.defaultSecondaryLabelInterval,
                            offset: 0
                        }, params);
                        this.canvases = [];
                        this.wrapper = null;
                        this.drawer = null;
                        this.pixelRatio = null;
                        this.maxCanvasWidth = null;
                        this.maxCanvasElementWidth = null;
                        /**
     * This event handler has to be in the constructor function because it
     * relies on the debounce function which is only available after
     * instantiation
     *
     * Use a debounced function if `params.zoomDebounce` is defined
     *
     * @returns {void}
     */ this._onZoom = this.params.zoomDebounce ? this.wavesurfer.util.debounce(function() {
                            return _this.render();
                        }, this.params.zoomDebounce) : function() {
                            return _this.render();
                        };
                    }
                    /**
   * Initialisation function used by the plugin API
   */ _createClass(TimelinePlugin, [
                        {
                            key: "init",
                            value: function init() {
                                // Check if ws is ready
                                if (this.wavesurfer.isReady) this._onReady();
                                else this.wavesurfer.once("ready", this._onReady);
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                this.unAll();
                                this.wavesurfer.un("redraw", this._onRedraw);
                                this.wavesurfer.un("zoom", this._onZoom);
                                this.wavesurfer.un("ready", this._onReady);
                                this.wavesurfer.drawer.wrapper.removeEventListener("scroll", this._onScroll);
                                if (this.wrapper && this.wrapper.parentNode) {
                                    this.wrapper.removeEventListener("click", this._onWrapperClick);
                                    this.wrapper.parentNode.removeChild(this.wrapper);
                                    this.wrapper = null;
                                }
                            }
                        },
                        {
                            key: "createWrapper",
                            value: function createWrapper() {
                                var wsParams = this.wavesurfer.params;
                                this.container.innerHTML = "";
                                this.wrapper = this.container.appendChild(document.createElement("timeline"));
                                this.util.style(this.wrapper, {
                                    display: "block",
                                    position: "relative",
                                    userSelect: "none",
                                    webkitUserSelect: "none",
                                    height: "".concat(this.params.height, "px")
                                });
                                if (wsParams.fillParent || wsParams.scrollParent) this.util.style(this.wrapper, {
                                    width: "100%",
                                    overflowX: "hidden",
                                    overflowY: "hidden"
                                });
                                this.wrapper.addEventListener("click", this._onWrapperClick);
                            }
                        },
                        {
                            key: "render",
                            value: function render() {
                                if (!this.wrapper) this.createWrapper();
                                this.updateCanvases();
                                this.updateCanvasesPositioning();
                                this.renderCanvases();
                            }
                        },
                        {
                            key: "addCanvas",
                            value: function addCanvas() {
                                var canvas = this.wrapper.appendChild(document.createElement("canvas"));
                                this.canvases.push(canvas);
                                this.util.style(canvas, {
                                    position: "absolute",
                                    zIndex: 4
                                });
                            }
                        },
                        {
                            key: "removeCanvas",
                            value: function removeCanvas() {
                                var canvas = this.canvases.pop();
                                canvas.parentElement.removeChild(canvas);
                            }
                        },
                        {
                            key: "updateCanvases",
                            value: function updateCanvases() {
                                var totalWidth = Math.round(this.drawer.wrapper.scrollWidth);
                                var requiredCanvases = Math.ceil(totalWidth / this.maxCanvasElementWidth);
                                while(this.canvases.length < requiredCanvases)this.addCanvas();
                                while(this.canvases.length > requiredCanvases)this.removeCanvas();
                            }
                        },
                        {
                            key: "updateCanvasesPositioning",
                            value: function updateCanvasesPositioning() {
                                var _this2 = this;
                                // cache length for performance
                                var canvasesLength = this.canvases.length;
                                this.canvases.forEach(function(canvas, i) {
                                    // canvas width is the max element width, or if it is the last the
                                    // required width
                                    var canvasWidth = i === canvasesLength - 1 ? _this2.drawer.wrapper.scrollWidth - _this2.maxCanvasElementWidth * (canvasesLength - 1) : _this2.maxCanvasElementWidth; // set dimensions and style
                                    canvas.width = canvasWidth * _this2.pixelRatio; // on certain pixel ratios the canvas appears cut off at the bottom,
                                    // therefore leave 1px extra
                                    canvas.height = (_this2.params.height + 1) * _this2.pixelRatio;
                                    _this2.util.style(canvas, {
                                        width: "".concat(canvasWidth, "px"),
                                        height: "".concat(_this2.params.height, "px"),
                                        left: "".concat(i * _this2.maxCanvasElementWidth, "px")
                                    });
                                });
                            }
                        },
                        {
                            key: "renderCanvases",
                            value: function renderCanvases() {
                                var _this3 = this;
                                var duration = this.params.duration || this.wavesurfer.backend.getDuration();
                                if (duration <= 0) return;
                                var wsParams = this.wavesurfer.params;
                                var fontSize = this.params.fontSize * wsParams.pixelRatio;
                                var totalSeconds = parseInt(duration, 10) + 1;
                                var width = wsParams.fillParent && !wsParams.scrollParent ? this.drawer.getWidth() : this.drawer.wrapper.scrollWidth * wsParams.pixelRatio;
                                var height1 = this.params.height * this.pixelRatio;
                                var height2 = this.params.height * (this.params.notchPercentHeight / 100) * this.pixelRatio;
                                var pixelsPerSecond = width / duration;
                                var formatTime = this.params.formatTimeCallback; // if parameter is function, call the function with
                                // pixelsPerSecond, otherwise simply take the value as-is
                                var intervalFnOrVal = function intervalFnOrVal(option) {
                                    return typeof option === "function" ? option(pixelsPerSecond) : option;
                                };
                                var timeInterval = intervalFnOrVal(this.params.timeInterval);
                                var primaryLabelInterval = intervalFnOrVal(this.params.primaryLabelInterval);
                                var secondaryLabelInterval = intervalFnOrVal(this.params.secondaryLabelInterval);
                                var curPixel = pixelsPerSecond * this.params.offset;
                                var curSeconds = 0;
                                var i; // build an array of position data with index, second and pixel data,
                                // this is then used multiple times below
                                var positioning = [];
                                for(i = 0; i < totalSeconds / timeInterval; i++){
                                    positioning.push([
                                        i,
                                        curSeconds,
                                        curPixel
                                    ]);
                                    curSeconds += timeInterval;
                                    curPixel += pixelsPerSecond * timeInterval;
                                } // iterate over each position
                                var renderPositions = function renderPositions(cb) {
                                    positioning.forEach(function(pos) {
                                        cb(pos[0], pos[1], pos[2]);
                                    });
                                }; // render primary labels
                                this.setFillStyles(this.params.primaryColor);
                                this.setFonts("".concat(fontSize, "px ").concat(this.params.fontFamily));
                                this.setFillStyles(this.params.primaryFontColor);
                                renderPositions(function(i, curSeconds, curPixel) {
                                    if (i % primaryLabelInterval === 0) {
                                        _this3.fillRect(curPixel, 0, 1, height1);
                                        _this3.fillText(formatTime(curSeconds, pixelsPerSecond), curPixel + _this3.params.labelPadding * _this3.pixelRatio, height1);
                                    }
                                }); // render secondary labels
                                this.setFillStyles(this.params.secondaryColor);
                                this.setFonts("".concat(fontSize, "px ").concat(this.params.fontFamily));
                                this.setFillStyles(this.params.secondaryFontColor);
                                renderPositions(function(i, curSeconds, curPixel) {
                                    if (i % secondaryLabelInterval === 0) {
                                        _this3.fillRect(curPixel, 0, 1, height1);
                                        _this3.fillText(formatTime(curSeconds, pixelsPerSecond), curPixel + _this3.params.labelPadding * _this3.pixelRatio, height1);
                                    }
                                }); // render the actual notches (when no labels are used)
                                this.setFillStyles(this.params.unlabeledNotchColor);
                                renderPositions(function(i, curSeconds, curPixel) {
                                    if (i % secondaryLabelInterval !== 0 && i % primaryLabelInterval !== 0) _this3.fillRect(curPixel, 0, 1, height2);
                                });
                            }
                        },
                        {
                            key: "setFillStyles",
                            value: function setFillStyles(fillStyle) {
                                this.canvases.forEach(function(canvas) {
                                    canvas.getContext("2d").fillStyle = fillStyle;
                                });
                            }
                        },
                        {
                            key: "setFonts",
                            value: function setFonts(font) {
                                this.canvases.forEach(function(canvas) {
                                    canvas.getContext("2d").font = font;
                                });
                            }
                        },
                        {
                            key: "fillRect",
                            value: function fillRect(x, y, width, height) {
                                var _this4 = this;
                                this.canvases.forEach(function(canvas, i) {
                                    var leftOffset = i * _this4.maxCanvasWidth;
                                    var intersection = {
                                        x1: Math.max(x, i * _this4.maxCanvasWidth),
                                        y1: y,
                                        x2: Math.min(x + width, i * _this4.maxCanvasWidth + canvas.width),
                                        y2: y + height
                                    };
                                    if (intersection.x1 < intersection.x2) canvas.getContext("2d").fillRect(intersection.x1 - leftOffset, intersection.y1, intersection.x2 - intersection.x1, intersection.y2 - intersection.y1);
                                });
                            }
                        },
                        {
                            key: "fillText",
                            value: function fillText(text, x, y) {
                                var textWidth;
                                var xOffset = 0;
                                this.canvases.forEach(function(canvas) {
                                    var context = canvas.getContext("2d");
                                    var canvasWidth = context.canvas.width;
                                    if (xOffset > x + textWidth) return;
                                    if (xOffset + canvasWidth > x) {
                                        textWidth = context.measureText(text).width;
                                        context.fillText(text, x - xOffset, y);
                                    }
                                    xOffset += canvasWidth;
                                });
                            }
                        },
                        {
                            key: "defaultFormatTimeCallback",
                            value: function defaultFormatTimeCallback(seconds, pxPerSec) {
                                if (seconds / 60 > 1) {
                                    // calculate minutes and seconds from seconds count
                                    var minutes = parseInt(seconds / 60, 10);
                                    seconds = parseInt(seconds % 60, 10); // fill up seconds with zeroes
                                    seconds = seconds < 10 ? "0" + seconds : seconds;
                                    return "".concat(minutes, ":").concat(seconds);
                                }
                                return Math.round(seconds * 1000) / 1000;
                            }
                        },
                        {
                            key: "defaultTimeInterval",
                            value: function defaultTimeInterval(pxPerSec) {
                                if (pxPerSec >= 25) return 1;
                                else if (pxPerSec * 5 >= 25) return 5;
                                else if (pxPerSec * 15 >= 25) return 15;
                                return Math.ceil(0.5 / pxPerSec) * 60;
                            }
                        },
                        {
                            key: "defaultPrimaryLabelInterval",
                            value: function defaultPrimaryLabelInterval(pxPerSec) {
                                if (pxPerSec >= 25) return 10;
                                else if (pxPerSec * 5 >= 25) return 6;
                                else if (pxPerSec * 15 >= 25) return 4;
                                return 4;
                            }
                        },
                        {
                            key: "defaultSecondaryLabelInterval",
                            value: function defaultSecondaryLabelInterval(pxPerSec) {
                                if (pxPerSec >= 25) return 5;
                                else if (pxPerSec * 5 >= 25) return 2;
                                else if (pxPerSec * 15 >= 25) return 2;
                                return 2;
                            }
                        }
                    ], [
                        {
                            key: "create",
                            value: /**
     * Timeline plugin definition factory
     *
     * This function must be used to create a plugin definition which can be
     * used by wavesurfer to correctly instantiate the plugin.
     *
     * @param  {TimelinePluginParams} params parameters use to initialise the plugin
     * @return {PluginDefinition} an object representing the plugin
     */ function create(params) {
                                return {
                                    name: "timeline",
                                    deferInit: params && params.deferInit ? params.deferInit : false,
                                    params: params,
                                    instance: TimelinePlugin
                                };
                            } // event handlers
                        }
                    ]);
                    return TimelinePlugin;
                }();
                exports.default = TimelinePlugin;
                var _initialiseProps = function _initialiseProps() {
                    var _this5 = this;
                    this._onScroll = function() {
                        if (_this5.wrapper && _this5.drawer.wrapper) _this5.wrapper.scrollLeft = _this5.drawer.wrapper.scrollLeft;
                    };
                    this._onRedraw = function() {
                        return _this5.render();
                    };
                    this._onReady = function() {
                        var ws = _this5.wavesurfer;
                        _this5.drawer = ws.drawer;
                        _this5.pixelRatio = ws.drawer.params.pixelRatio;
                        _this5.maxCanvasWidth = ws.drawer.maxCanvasWidth || ws.drawer.width;
                        _this5.maxCanvasElementWidth = ws.drawer.maxCanvasElementWidth || Math.round(_this5.maxCanvasWidth / _this5.pixelRatio); // add listeners
                        ws.drawer.wrapper.addEventListener("scroll", _this5._onScroll);
                        ws.on("redraw", _this5._onRedraw);
                        ws.on("zoom", _this5._onZoom);
                        _this5.render();
                    };
                    this._onWrapperClick = function(e) {
                        e.preventDefault();
                        var relX = "offsetX" in e ? e.offsetX : e.layerX;
                        _this5.fireEvent("click", relX / _this5.wrapper.scrollWidth || 0);
                    };
                };
                module1.exports = exports.default;
            /***/ }
        };
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ if (__webpack_module_cache__[moduleId]) /******/ return __webpack_module_cache__[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId](module1, module1.exports, __webpack_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /******/ // startup
        /******/ // Load entry module and return exports
        /******/ // This entry module is referenced by other modules so it can't be inlined
        /******/ var __webpack_exports__ = __webpack_require__("./src/plugin/timeline/index.js");
        /******/ /******/ return __webpack_exports__;
    /******/ })();
});

});

parcelRegister("9gA9b", function(module, exports) {
/*!
 * wavesurfer.js cursor plugin 4.6.0 (2021-03-05)
 * https://wavesurfer-js.org
 * @license BSD-3-Clause
 */ (function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
})(module.exports, function() {
    return /******/ (()=>{
        /******/ "use strict";
        /******/ var __webpack_modules__ = {
            /***/ "./src/plugin/cursor/index.js": /*!************************************!*\
  !*** ./src/plugin/cursor/index.js ***!
  \************************************/ /***/ (module1, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                /**
 * @typedef {Object} CursorPluginParams
 * @property {?boolean} deferInit Set to true to stop auto init in `addPlugin()`
 * @property {boolean} hideOnBlur=true Hide the cursor when the mouse leaves the
 * waveform
 * @property {string} width='1px' The width of the cursor
 * @property {string} color='black' The color of the cursor
 * @property {string} opacity='0.25' The opacity of the cursor
 * @property {string} style='solid' The border style of the cursor
 * @property {number} zIndex=3 The z-index of the cursor element
 * @property {object} customStyle An object with custom styles which are applied
 * to the cursor element
 * @property {boolean} showTime=false Show the time on the cursor.
 * @property {object} customShowTimeStyle An object with custom styles which are
 * applied to the cursor time element.
 * @property {string} followCursorY=false Use `true` to make the time on
 * the cursor follow the x and the y-position of the mouse. Use `false` to make the
 * it only follow the x-position of the mouse.
 * @property {function} formatTimeCallback Formats the timestamp on the cursor.
 */ /**
 * Displays a thin line at the position of the cursor on the waveform.
 *
 * @implements {PluginClass}
 * @extends {Observer}
 * @example
 * // es6
 * import CursorPlugin from 'wavesurfer.cursor.js';
 *
 * // commonjs
 * var CursorPlugin = require('wavesurfer.cursor.js');
 *
 * // if you are using <script> tags
 * var CursorPlugin = window.WaveSurfer.cursor;
 *
 * // ... initialising wavesurfer with the plugin
 * var wavesurfer = WaveSurfer.create({
 *   // wavesurfer options ...
 *   plugins: [
 *     CursorPlugin.create({
 *       // plugin options ...
 *     })
 *   ]
 * });
 */ var CursorPlugin = /*#__PURE__*/ function() {
                    /**
   * Construct the plugin class. You probably want to use `CursorPlugin.create`
   * instead.
   *
   * @param {CursorPluginParams} params Plugin parameters
   * @param {object} ws Wavesurfer instance
   */ function CursorPlugin(params, ws) {
                        var _this = this;
                        _classCallCheck(this, CursorPlugin);
                        this.defaultParams = {
                            hideOnBlur: true,
                            width: "1px",
                            color: "black",
                            opacity: "0.25",
                            style: "solid",
                            zIndex: 4,
                            customStyle: {},
                            customShowTimeStyle: {},
                            showTime: false,
                            followCursorY: false,
                            formatTimeCallback: null
                        };
                        this._onMousemove = function(e) {
                            var bbox = _this.wavesurfer.container.getBoundingClientRect();
                            var y = 0;
                            var x = e.clientX - bbox.left;
                            var flip = bbox.right < e.clientX + _this.outerWidth(_this.displayTime);
                            if (_this.params.showTime && _this.params.followCursorY) // follow y-position of the mouse
                            y = e.clientY - (bbox.top + bbox.height / 2);
                            _this.updateCursorPosition(x, y, flip);
                        };
                        this._onMouseenter = function() {
                            return _this.showCursor();
                        };
                        this._onMouseleave = function() {
                            return _this.hideCursor();
                        };
                        this.wavesurfer = ws;
                        this.style = ws.util.style;
                        /**
     * The cursor HTML element
     *
     * @type {?HTMLElement}
     */ this.cursor = null;
                        /**
     * displays the time next to the cursor
     *
     * @type {?HTMLElement}
     */ this.showTime = null;
                        /**
     * The html container that will display the time
     *
     * @type {?HTMLElement}
     */ this.displayTime = null;
                        this.params = Object.assign({}, this.defaultParams, params);
                    }
                    /**
   * Initialise the plugin (used by the Plugin API)
   */ _createClass(CursorPlugin, [
                        {
                            key: "init",
                            value: function init() {
                                this.wrapper = this.wavesurfer.container;
                                this.cursor = this.wrapper.appendChild(this.style(document.createElement("cursor"), Object.assign({
                                    position: "absolute",
                                    zIndex: this.params.zIndex,
                                    left: 0,
                                    top: 0,
                                    bottom: 0,
                                    width: "0",
                                    display: "flex",
                                    borderRightStyle: this.params.style,
                                    borderRightWidth: this.params.width,
                                    borderRightColor: this.params.color,
                                    opacity: this.params.opacity,
                                    pointerEvents: "none"
                                }, this.params.customStyle)));
                                if (this.params.showTime) {
                                    this.showTime = this.wrapper.appendChild(this.style(document.createElement("showTitle"), Object.assign({
                                        position: "absolute",
                                        zIndex: this.params.zIndex,
                                        left: 0,
                                        top: 0,
                                        bottom: 0,
                                        width: "auto",
                                        display: "flex",
                                        opacity: this.params.opacity,
                                        pointerEvents: "none",
                                        height: "100%"
                                    }, this.params.customStyle)));
                                    this.displayTime = this.showTime.appendChild(this.style(document.createElement("div"), Object.assign({
                                        display: "inline",
                                        pointerEvents: "none",
                                        margin: "auto",
                                        visibility: "hidden" // initial value will be hidden just for measuring purpose
                                    }, this.params.customShowTimeStyle))); // initial value to measure display width
                                    this.displayTime.innerHTML = this.formatTime(0);
                                }
                                this.wrapper.addEventListener("mousemove", this._onMousemove);
                                if (this.params.hideOnBlur) {
                                    // ensure elements are hidden initially
                                    this.hideCursor();
                                    this.wrapper.addEventListener("mouseenter", this._onMouseenter);
                                    this.wrapper.addEventListener("mouseleave", this._onMouseleave);
                                }
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                if (this.params.showTime) this.cursor.parentNode.removeChild(this.showTime);
                                this.cursor.parentNode.removeChild(this.cursor);
                                this.wrapper.removeEventListener("mousemove", this._onMousemove);
                                if (this.params.hideOnBlur) {
                                    this.wrapper.removeEventListener("mouseenter", this._onMouseenter);
                                    this.wrapper.removeEventListener("mouseleave", this._onMouseleave);
                                }
                            }
                        },
                        {
                            key: "updateCursorPosition",
                            value: function updateCursorPosition(xpos, ypos) {
                                var flip = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                                this.style(this.cursor, {
                                    left: "".concat(xpos, "px")
                                });
                                if (this.params.showTime) {
                                    var duration = this.wavesurfer.getDuration();
                                    var elementWidth = this.wavesurfer.drawer.width / this.wavesurfer.params.pixelRatio;
                                    var scrollWidth = this.wavesurfer.drawer.getScrollX();
                                    var scrollTime = duration / this.wavesurfer.drawer.width * scrollWidth;
                                    var timeValue = Math.max(0, xpos / elementWidth * duration) + scrollTime;
                                    var formatValue = this.formatTime(timeValue);
                                    if (flip) {
                                        var textOffset = this.outerWidth(this.displayTime);
                                        xpos -= textOffset;
                                    }
                                    this.style(this.showTime, {
                                        left: "".concat(xpos, "px"),
                                        top: "".concat(ypos, "px")
                                    });
                                    this.style(this.displayTime, {
                                        visibility: "visible"
                                    });
                                    this.displayTime.innerHTML = "".concat(formatValue);
                                }
                            }
                        },
                        {
                            key: "showCursor",
                            value: function showCursor() {
                                this.style(this.cursor, {
                                    display: "flex"
                                });
                                if (this.params.showTime) this.style(this.showTime, {
                                    display: "flex"
                                });
                            }
                        },
                        {
                            key: "hideCursor",
                            value: function hideCursor() {
                                this.style(this.cursor, {
                                    display: "none"
                                });
                                if (this.params.showTime) this.style(this.showTime, {
                                    display: "none"
                                });
                            }
                        },
                        {
                            key: "formatTime",
                            value: function formatTime(cursorTime) {
                                cursorTime = isNaN(cursorTime) ? 0 : cursorTime;
                                if (this.params.formatTimeCallback) return this.params.formatTimeCallback(cursorTime);
                                return [
                                    cursorTime
                                ].map(function(time) {
                                    return [
                                        Math.floor(time % 3600 / 60),
                                        ("00" + Math.floor(time % 60)).slice(-2),
                                        ("000" + Math.floor(time % 1 * 1000)).slice(-3) // milliseconds
                                    ].join(":");
                                });
                            }
                        },
                        {
                            key: "outerWidth",
                            value: function outerWidth(element) {
                                if (!element) return 0;
                                var width = element.offsetWidth;
                                var style = getComputedStyle(element);
                                width += parseInt(style.marginLeft + style.marginRight);
                                return width;
                            }
                        }
                    ], [
                        {
                            key: "create",
                            value: /**
     * Cursor plugin definition factory
     *
     * This function must be used to create a plugin definition which can be
     * used by wavesurfer to correctly instantiate the plugin.
     *
     * @param  {CursorPluginParams} params parameters use to initialise the
     * plugin
     * @return {PluginDefinition} an object representing the plugin
     */ function create(params) {
                                return {
                                    name: "cursor",
                                    deferInit: params && params.deferInit ? params.deferInit : false,
                                    params: params,
                                    staticProps: {},
                                    instance: CursorPlugin
                                };
                            }
                        }
                    ]);
                    return CursorPlugin;
                }();
                exports.default = CursorPlugin;
                module1.exports = exports.default;
            /***/ }
        };
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ if (__webpack_module_cache__[moduleId]) /******/ return __webpack_module_cache__[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId](module1, module1.exports, __webpack_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /******/ // startup
        /******/ // Load entry module and return exports
        /******/ // This entry module is referenced by other modules so it can't be inlined
        /******/ var __webpack_exports__ = __webpack_require__("./src/plugin/cursor/index.js");
        /******/ /******/ return __webpack_exports__;
    /******/ })();
});

});


parcelRegister("fF4Ij", function(module, exports) {

/*!
 * Chart.js v2.9.4
 * https://www.chartjs.org
 * (c) 2020 Chart.js Contributors
 * Released under the MIT License
 */ (function(global, factory) {
    module.exports = factory(function() {
        try {
            return (parcelRequire("YChVI"));
        } catch (e) {}
    }());
})(module.exports, function(moment) {
    "use strict";
    moment = moment && moment.hasOwnProperty("default") ? moment["default"] : moment;
    function createCommonjsModule(fn, module1) {
        return module1 = {
            exports: {}
        }, fn(module1, module1.exports), module1.exports;
    }
    function getCjsExportFromNamespace(n) {
        return n && n["default"] || n;
    }
    var colorName = {
        "aliceblue": [
            240,
            248,
            255
        ],
        "antiquewhite": [
            250,
            235,
            215
        ],
        "aqua": [
            0,
            255,
            255
        ],
        "aquamarine": [
            127,
            255,
            212
        ],
        "azure": [
            240,
            255,
            255
        ],
        "beige": [
            245,
            245,
            220
        ],
        "bisque": [
            255,
            228,
            196
        ],
        "black": [
            0,
            0,
            0
        ],
        "blanchedalmond": [
            255,
            235,
            205
        ],
        "blue": [
            0,
            0,
            255
        ],
        "blueviolet": [
            138,
            43,
            226
        ],
        "brown": [
            165,
            42,
            42
        ],
        "burlywood": [
            222,
            184,
            135
        ],
        "cadetblue": [
            95,
            158,
            160
        ],
        "chartreuse": [
            127,
            255,
            0
        ],
        "chocolate": [
            210,
            105,
            30
        ],
        "coral": [
            255,
            127,
            80
        ],
        "cornflowerblue": [
            100,
            149,
            237
        ],
        "cornsilk": [
            255,
            248,
            220
        ],
        "crimson": [
            220,
            20,
            60
        ],
        "cyan": [
            0,
            255,
            255
        ],
        "darkblue": [
            0,
            0,
            139
        ],
        "darkcyan": [
            0,
            139,
            139
        ],
        "darkgoldenrod": [
            184,
            134,
            11
        ],
        "darkgray": [
            169,
            169,
            169
        ],
        "darkgreen": [
            0,
            100,
            0
        ],
        "darkgrey": [
            169,
            169,
            169
        ],
        "darkkhaki": [
            189,
            183,
            107
        ],
        "darkmagenta": [
            139,
            0,
            139
        ],
        "darkolivegreen": [
            85,
            107,
            47
        ],
        "darkorange": [
            255,
            140,
            0
        ],
        "darkorchid": [
            153,
            50,
            204
        ],
        "darkred": [
            139,
            0,
            0
        ],
        "darksalmon": [
            233,
            150,
            122
        ],
        "darkseagreen": [
            143,
            188,
            143
        ],
        "darkslateblue": [
            72,
            61,
            139
        ],
        "darkslategray": [
            47,
            79,
            79
        ],
        "darkslategrey": [
            47,
            79,
            79
        ],
        "darkturquoise": [
            0,
            206,
            209
        ],
        "darkviolet": [
            148,
            0,
            211
        ],
        "deeppink": [
            255,
            20,
            147
        ],
        "deepskyblue": [
            0,
            191,
            255
        ],
        "dimgray": [
            105,
            105,
            105
        ],
        "dimgrey": [
            105,
            105,
            105
        ],
        "dodgerblue": [
            30,
            144,
            255
        ],
        "firebrick": [
            178,
            34,
            34
        ],
        "floralwhite": [
            255,
            250,
            240
        ],
        "forestgreen": [
            34,
            139,
            34
        ],
        "fuchsia": [
            255,
            0,
            255
        ],
        "gainsboro": [
            220,
            220,
            220
        ],
        "ghostwhite": [
            248,
            248,
            255
        ],
        "gold": [
            255,
            215,
            0
        ],
        "goldenrod": [
            218,
            165,
            32
        ],
        "gray": [
            128,
            128,
            128
        ],
        "green": [
            0,
            128,
            0
        ],
        "greenyellow": [
            173,
            255,
            47
        ],
        "grey": [
            128,
            128,
            128
        ],
        "honeydew": [
            240,
            255,
            240
        ],
        "hotpink": [
            255,
            105,
            180
        ],
        "indianred": [
            205,
            92,
            92
        ],
        "indigo": [
            75,
            0,
            130
        ],
        "ivory": [
            255,
            255,
            240
        ],
        "khaki": [
            240,
            230,
            140
        ],
        "lavender": [
            230,
            230,
            250
        ],
        "lavenderblush": [
            255,
            240,
            245
        ],
        "lawngreen": [
            124,
            252,
            0
        ],
        "lemonchiffon": [
            255,
            250,
            205
        ],
        "lightblue": [
            173,
            216,
            230
        ],
        "lightcoral": [
            240,
            128,
            128
        ],
        "lightcyan": [
            224,
            255,
            255
        ],
        "lightgoldenrodyellow": [
            250,
            250,
            210
        ],
        "lightgray": [
            211,
            211,
            211
        ],
        "lightgreen": [
            144,
            238,
            144
        ],
        "lightgrey": [
            211,
            211,
            211
        ],
        "lightpink": [
            255,
            182,
            193
        ],
        "lightsalmon": [
            255,
            160,
            122
        ],
        "lightseagreen": [
            32,
            178,
            170
        ],
        "lightskyblue": [
            135,
            206,
            250
        ],
        "lightslategray": [
            119,
            136,
            153
        ],
        "lightslategrey": [
            119,
            136,
            153
        ],
        "lightsteelblue": [
            176,
            196,
            222
        ],
        "lightyellow": [
            255,
            255,
            224
        ],
        "lime": [
            0,
            255,
            0
        ],
        "limegreen": [
            50,
            205,
            50
        ],
        "linen": [
            250,
            240,
            230
        ],
        "magenta": [
            255,
            0,
            255
        ],
        "maroon": [
            128,
            0,
            0
        ],
        "mediumaquamarine": [
            102,
            205,
            170
        ],
        "mediumblue": [
            0,
            0,
            205
        ],
        "mediumorchid": [
            186,
            85,
            211
        ],
        "mediumpurple": [
            147,
            112,
            219
        ],
        "mediumseagreen": [
            60,
            179,
            113
        ],
        "mediumslateblue": [
            123,
            104,
            238
        ],
        "mediumspringgreen": [
            0,
            250,
            154
        ],
        "mediumturquoise": [
            72,
            209,
            204
        ],
        "mediumvioletred": [
            199,
            21,
            133
        ],
        "midnightblue": [
            25,
            25,
            112
        ],
        "mintcream": [
            245,
            255,
            250
        ],
        "mistyrose": [
            255,
            228,
            225
        ],
        "moccasin": [
            255,
            228,
            181
        ],
        "navajowhite": [
            255,
            222,
            173
        ],
        "navy": [
            0,
            0,
            128
        ],
        "oldlace": [
            253,
            245,
            230
        ],
        "olive": [
            128,
            128,
            0
        ],
        "olivedrab": [
            107,
            142,
            35
        ],
        "orange": [
            255,
            165,
            0
        ],
        "orangered": [
            255,
            69,
            0
        ],
        "orchid": [
            218,
            112,
            214
        ],
        "palegoldenrod": [
            238,
            232,
            170
        ],
        "palegreen": [
            152,
            251,
            152
        ],
        "paleturquoise": [
            175,
            238,
            238
        ],
        "palevioletred": [
            219,
            112,
            147
        ],
        "papayawhip": [
            255,
            239,
            213
        ],
        "peachpuff": [
            255,
            218,
            185
        ],
        "peru": [
            205,
            133,
            63
        ],
        "pink": [
            255,
            192,
            203
        ],
        "plum": [
            221,
            160,
            221
        ],
        "powderblue": [
            176,
            224,
            230
        ],
        "purple": [
            128,
            0,
            128
        ],
        "rebeccapurple": [
            102,
            51,
            153
        ],
        "red": [
            255,
            0,
            0
        ],
        "rosybrown": [
            188,
            143,
            143
        ],
        "royalblue": [
            65,
            105,
            225
        ],
        "saddlebrown": [
            139,
            69,
            19
        ],
        "salmon": [
            250,
            128,
            114
        ],
        "sandybrown": [
            244,
            164,
            96
        ],
        "seagreen": [
            46,
            139,
            87
        ],
        "seashell": [
            255,
            245,
            238
        ],
        "sienna": [
            160,
            82,
            45
        ],
        "silver": [
            192,
            192,
            192
        ],
        "skyblue": [
            135,
            206,
            235
        ],
        "slateblue": [
            106,
            90,
            205
        ],
        "slategray": [
            112,
            128,
            144
        ],
        "slategrey": [
            112,
            128,
            144
        ],
        "snow": [
            255,
            250,
            250
        ],
        "springgreen": [
            0,
            255,
            127
        ],
        "steelblue": [
            70,
            130,
            180
        ],
        "tan": [
            210,
            180,
            140
        ],
        "teal": [
            0,
            128,
            128
        ],
        "thistle": [
            216,
            191,
            216
        ],
        "tomato": [
            255,
            99,
            71
        ],
        "turquoise": [
            64,
            224,
            208
        ],
        "violet": [
            238,
            130,
            238
        ],
        "wheat": [
            245,
            222,
            179
        ],
        "white": [
            255,
            255,
            255
        ],
        "whitesmoke": [
            245,
            245,
            245
        ],
        "yellow": [
            255,
            255,
            0
        ],
        "yellowgreen": [
            154,
            205,
            50
        ]
    };
    var conversions = createCommonjsModule(function(module1) {
        /* MIT license */ // NOTE: conversions should only return primitive values (i.e. arrays, or
        //       values that give correct `typeof` results).
        //       do not use box values types (i.e. Number(), String(), etc.)
        var reverseKeywords = {};
        for(var key in colorName)if (colorName.hasOwnProperty(key)) reverseKeywords[colorName[key]] = key;
        var convert = module1.exports = {
            rgb: {
                channels: 3,
                labels: "rgb"
            },
            hsl: {
                channels: 3,
                labels: "hsl"
            },
            hsv: {
                channels: 3,
                labels: "hsv"
            },
            hwb: {
                channels: 3,
                labels: "hwb"
            },
            cmyk: {
                channels: 4,
                labels: "cmyk"
            },
            xyz: {
                channels: 3,
                labels: "xyz"
            },
            lab: {
                channels: 3,
                labels: "lab"
            },
            lch: {
                channels: 3,
                labels: "lch"
            },
            hex: {
                channels: 1,
                labels: [
                    "hex"
                ]
            },
            keyword: {
                channels: 1,
                labels: [
                    "keyword"
                ]
            },
            ansi16: {
                channels: 1,
                labels: [
                    "ansi16"
                ]
            },
            ansi256: {
                channels: 1,
                labels: [
                    "ansi256"
                ]
            },
            hcg: {
                channels: 3,
                labels: [
                    "h",
                    "c",
                    "g"
                ]
            },
            apple: {
                channels: 3,
                labels: [
                    "r16",
                    "g16",
                    "b16"
                ]
            },
            gray: {
                channels: 1,
                labels: [
                    "gray"
                ]
            }
        };
        // hide .channels and .labels properties
        for(var model in convert)if (convert.hasOwnProperty(model)) {
            if (!("channels" in convert[model])) throw new Error("missing channels property: " + model);
            if (!("labels" in convert[model])) throw new Error("missing channel labels property: " + model);
            if (convert[model].labels.length !== convert[model].channels) throw new Error("channel and label counts mismatch: " + model);
            var channels = convert[model].channels;
            var labels = convert[model].labels;
            delete convert[model].channels;
            delete convert[model].labels;
            Object.defineProperty(convert[model], "channels", {
                value: channels
            });
            Object.defineProperty(convert[model], "labels", {
                value: labels
            });
        }
        convert.rgb.hsl = function(rgb) {
            var r = rgb[0] / 255;
            var g = rgb[1] / 255;
            var b = rgb[2] / 255;
            var min = Math.min(r, g, b);
            var max = Math.max(r, g, b);
            var delta = max - min;
            var h;
            var s;
            var l;
            if (max === min) h = 0;
            else if (r === max) h = (g - b) / delta;
            else if (g === max) h = 2 + (b - r) / delta;
            else if (b === max) h = 4 + (r - g) / delta;
            h = Math.min(h * 60, 360);
            if (h < 0) h += 360;
            l = (min + max) / 2;
            if (max === min) s = 0;
            else if (l <= 0.5) s = delta / (max + min);
            else s = delta / (2 - max - min);
            return [
                h,
                s * 100,
                l * 100
            ];
        };
        convert.rgb.hsv = function(rgb) {
            var rdif;
            var gdif;
            var bdif;
            var h;
            var s;
            var r = rgb[0] / 255;
            var g = rgb[1] / 255;
            var b = rgb[2] / 255;
            var v = Math.max(r, g, b);
            var diff = v - Math.min(r, g, b);
            var diffc = function(c) {
                return (v - c) / 6 / diff + 0.5;
            };
            if (diff === 0) h = s = 0;
            else {
                s = diff / v;
                rdif = diffc(r);
                gdif = diffc(g);
                bdif = diffc(b);
                if (r === v) h = bdif - gdif;
                else if (g === v) h = 1 / 3 + rdif - bdif;
                else if (b === v) h = 2 / 3 + gdif - rdif;
                if (h < 0) h += 1;
                else if (h > 1) h -= 1;
            }
            return [
                h * 360,
                s * 100,
                v * 100
            ];
        };
        convert.rgb.hwb = function(rgb) {
            var r = rgb[0];
            var g = rgb[1];
            var b = rgb[2];
            var h = convert.rgb.hsl(rgb)[0];
            var w = 1 / 255 * Math.min(r, Math.min(g, b));
            b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
            return [
                h,
                w * 100,
                b * 100
            ];
        };
        convert.rgb.cmyk = function(rgb) {
            var r = rgb[0] / 255;
            var g = rgb[1] / 255;
            var b = rgb[2] / 255;
            var c;
            var m;
            var y;
            var k;
            k = Math.min(1 - r, 1 - g, 1 - b);
            c = (1 - r - k) / (1 - k) || 0;
            m = (1 - g - k) / (1 - k) || 0;
            y = (1 - b - k) / (1 - k) || 0;
            return [
                c * 100,
                m * 100,
                y * 100,
                k * 100
            ];
        };
        /**
 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
 * */ function comparativeDistance(x, y) {
            return Math.pow(x[0] - y[0], 2) + Math.pow(x[1] - y[1], 2) + Math.pow(x[2] - y[2], 2);
        }
        convert.rgb.keyword = function(rgb) {
            var reversed = reverseKeywords[rgb];
            if (reversed) return reversed;
            var currentClosestDistance = Infinity;
            var currentClosestKeyword;
            for(var keyword in colorName)if (colorName.hasOwnProperty(keyword)) {
                var value = colorName[keyword];
                // Compute comparative distance
                var distance = comparativeDistance(rgb, value);
                // Check if its less, if so set as closest
                if (distance < currentClosestDistance) {
                    currentClosestDistance = distance;
                    currentClosestKeyword = keyword;
                }
            }
            return currentClosestKeyword;
        };
        convert.keyword.rgb = function(keyword) {
            return colorName[keyword];
        };
        convert.rgb.xyz = function(rgb) {
            var r = rgb[0] / 255;
            var g = rgb[1] / 255;
            var b = rgb[2] / 255;
            // assume sRGB
            r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
            g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
            b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
            var x = r * 0.4124 + g * 0.3576 + b * 0.1805;
            var y = r * 0.2126 + g * 0.7152 + b * 0.0722;
            var z = r * 0.0193 + g * 0.1192 + b * 0.9505;
            return [
                x * 100,
                y * 100,
                z * 100
            ];
        };
        convert.rgb.lab = function(rgb) {
            var xyz = convert.rgb.xyz(rgb);
            var x = xyz[0];
            var y = xyz[1];
            var z = xyz[2];
            var l;
            var a;
            var b;
            x /= 95.047;
            y /= 100;
            z /= 108.883;
            x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
            y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
            z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
            l = 116 * y - 16;
            a = 500 * (x - y);
            b = 200 * (y - z);
            return [
                l,
                a,
                b
            ];
        };
        convert.hsl.rgb = function(hsl) {
            var h = hsl[0] / 360;
            var s = hsl[1] / 100;
            var l = hsl[2] / 100;
            var t1;
            var t2;
            var t3;
            var rgb;
            var val;
            if (s === 0) {
                val = l * 255;
                return [
                    val,
                    val,
                    val
                ];
            }
            if (l < 0.5) t2 = l * (1 + s);
            else t2 = l + s - l * s;
            t1 = 2 * l - t2;
            rgb = [
                0,
                0,
                0
            ];
            for(var i = 0; i < 3; i++){
                t3 = h + 1 / 3 * -(i - 1);
                if (t3 < 0) t3++;
                if (t3 > 1) t3--;
                if (6 * t3 < 1) val = t1 + (t2 - t1) * 6 * t3;
                else if (2 * t3 < 1) val = t2;
                else if (3 * t3 < 2) val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
                else val = t1;
                rgb[i] = val * 255;
            }
            return rgb;
        };
        convert.hsl.hsv = function(hsl) {
            var h = hsl[0];
            var s = hsl[1] / 100;
            var l = hsl[2] / 100;
            var smin = s;
            var lmin = Math.max(l, 0.01);
            var sv;
            var v;
            l *= 2;
            s *= l <= 1 ? l : 2 - l;
            smin *= lmin <= 1 ? lmin : 2 - lmin;
            v = (l + s) / 2;
            sv = l === 0 ? 2 * smin / (lmin + smin) : 2 * s / (l + s);
            return [
                h,
                sv * 100,
                v * 100
            ];
        };
        convert.hsv.rgb = function(hsv) {
            var h = hsv[0] / 60;
            var s = hsv[1] / 100;
            var v = hsv[2] / 100;
            var hi = Math.floor(h) % 6;
            var f = h - Math.floor(h);
            var p = 255 * v * (1 - s);
            var q = 255 * v * (1 - s * f);
            var t = 255 * v * (1 - s * (1 - f));
            v *= 255;
            switch(hi){
                case 0:
                    return [
                        v,
                        t,
                        p
                    ];
                case 1:
                    return [
                        q,
                        v,
                        p
                    ];
                case 2:
                    return [
                        p,
                        v,
                        t
                    ];
                case 3:
                    return [
                        p,
                        q,
                        v
                    ];
                case 4:
                    return [
                        t,
                        p,
                        v
                    ];
                case 5:
                    return [
                        v,
                        p,
                        q
                    ];
            }
        };
        convert.hsv.hsl = function(hsv) {
            var h = hsv[0];
            var s = hsv[1] / 100;
            var v = hsv[2] / 100;
            var vmin = Math.max(v, 0.01);
            var lmin;
            var sl;
            var l;
            l = (2 - s) * v;
            lmin = (2 - s) * vmin;
            sl = s * vmin;
            sl /= lmin <= 1 ? lmin : 2 - lmin;
            sl = sl || 0;
            l /= 2;
            return [
                h,
                sl * 100,
                l * 100
            ];
        };
        // http://dev.w3.org/csswg/css-color/#hwb-to-rgb
        convert.hwb.rgb = function(hwb) {
            var h = hwb[0] / 360;
            var wh = hwb[1] / 100;
            var bl = hwb[2] / 100;
            var ratio = wh + bl;
            var i;
            var v;
            var f;
            var n;
            // wh + bl cant be > 1
            if (ratio > 1) {
                wh /= ratio;
                bl /= ratio;
            }
            i = Math.floor(6 * h);
            v = 1 - bl;
            f = 6 * h - i;
            if ((i & 0x01) !== 0) f = 1 - f;
            n = wh + f * (v - wh); // linear interpolation
            var r;
            var g;
            var b;
            switch(i){
                default:
                case 6:
                case 0:
                    r = v;
                    g = n;
                    b = wh;
                    break;
                case 1:
                    r = n;
                    g = v;
                    b = wh;
                    break;
                case 2:
                    r = wh;
                    g = v;
                    b = n;
                    break;
                case 3:
                    r = wh;
                    g = n;
                    b = v;
                    break;
                case 4:
                    r = n;
                    g = wh;
                    b = v;
                    break;
                case 5:
                    r = v;
                    g = wh;
                    b = n;
                    break;
            }
            return [
                r * 255,
                g * 255,
                b * 255
            ];
        };
        convert.cmyk.rgb = function(cmyk) {
            var c = cmyk[0] / 100;
            var m = cmyk[1] / 100;
            var y = cmyk[2] / 100;
            var k = cmyk[3] / 100;
            var r;
            var g;
            var b;
            r = 1 - Math.min(1, c * (1 - k) + k);
            g = 1 - Math.min(1, m * (1 - k) + k);
            b = 1 - Math.min(1, y * (1 - k) + k);
            return [
                r * 255,
                g * 255,
                b * 255
            ];
        };
        convert.xyz.rgb = function(xyz) {
            var x = xyz[0] / 100;
            var y = xyz[1] / 100;
            var z = xyz[2] / 100;
            var r;
            var g;
            var b;
            r = x * 3.2406 + y * -1.5372 + z * -0.4986;
            g = x * -0.9689 + y * 1.8758 + z * 0.0415;
            b = x * 0.0557 + y * -0.204 + z * 1.0570;
            // assume sRGB
            r = r > 0.0031308 ? 1.055 * Math.pow(r, 1.0 / 2.4) - 0.055 : r * 12.92;
            g = g > 0.0031308 ? 1.055 * Math.pow(g, 1.0 / 2.4) - 0.055 : g * 12.92;
            b = b > 0.0031308 ? 1.055 * Math.pow(b, 1.0 / 2.4) - 0.055 : b * 12.92;
            r = Math.min(Math.max(0, r), 1);
            g = Math.min(Math.max(0, g), 1);
            b = Math.min(Math.max(0, b), 1);
            return [
                r * 255,
                g * 255,
                b * 255
            ];
        };
        convert.xyz.lab = function(xyz) {
            var x = xyz[0];
            var y = xyz[1];
            var z = xyz[2];
            var l;
            var a;
            var b;
            x /= 95.047;
            y /= 100;
            z /= 108.883;
            x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
            y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
            z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
            l = 116 * y - 16;
            a = 500 * (x - y);
            b = 200 * (y - z);
            return [
                l,
                a,
                b
            ];
        };
        convert.lab.xyz = function(lab) {
            var l = lab[0];
            var a = lab[1];
            var b = lab[2];
            var x;
            var y;
            var z;
            y = (l + 16) / 116;
            x = a / 500 + y;
            z = y - b / 200;
            var y2 = Math.pow(y, 3);
            var x2 = Math.pow(x, 3);
            var z2 = Math.pow(z, 3);
            y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
            x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
            z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
            x *= 95.047;
            y *= 100;
            z *= 108.883;
            return [
                x,
                y,
                z
            ];
        };
        convert.lab.lch = function(lab) {
            var l = lab[0];
            var a = lab[1];
            var b = lab[2];
            var hr;
            var h;
            var c;
            hr = Math.atan2(b, a);
            h = hr * 360 / 2 / Math.PI;
            if (h < 0) h += 360;
            c = Math.sqrt(a * a + b * b);
            return [
                l,
                c,
                h
            ];
        };
        convert.lch.lab = function(lch) {
            var l = lch[0];
            var c = lch[1];
            var h = lch[2];
            var a;
            var b;
            var hr;
            hr = h / 360 * 2 * Math.PI;
            a = c * Math.cos(hr);
            b = c * Math.sin(hr);
            return [
                l,
                a,
                b
            ];
        };
        convert.rgb.ansi16 = function(args) {
            var r = args[0];
            var g = args[1];
            var b = args[2];
            var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization
            value = Math.round(value / 50);
            if (value === 0) return 30;
            var ansi = 30 + (Math.round(b / 255) << 2 | Math.round(g / 255) << 1 | Math.round(r / 255));
            if (value === 2) ansi += 60;
            return ansi;
        };
        convert.hsv.ansi16 = function(args) {
            // optimization here; we already know the value and don't need to get
            // it converted for us.
            return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
        };
        convert.rgb.ansi256 = function(args) {
            var r = args[0];
            var g = args[1];
            var b = args[2];
            // we use the extended greyscale palette here, with the exception of
            // black and white. normal palette only has 4 greyscale shades.
            if (r === g && g === b) {
                if (r < 8) return 16;
                if (r > 248) return 231;
                return Math.round((r - 8) / 247 * 24) + 232;
            }
            var ansi = 16 + 36 * Math.round(r / 255 * 5) + 6 * Math.round(g / 255 * 5) + Math.round(b / 255 * 5);
            return ansi;
        };
        convert.ansi16.rgb = function(args) {
            var color = args % 10;
            // handle greyscale
            if (color === 0 || color === 7) {
                if (args > 50) color += 3.5;
                color = color / 10.5 * 255;
                return [
                    color,
                    color,
                    color
                ];
            }
            var mult = (~~(args > 50) + 1) * 0.5;
            var r = (color & 1) * mult * 255;
            var g = (color >> 1 & 1) * mult * 255;
            var b = (color >> 2 & 1) * mult * 255;
            return [
                r,
                g,
                b
            ];
        };
        convert.ansi256.rgb = function(args) {
            // handle greyscale
            if (args >= 232) {
                var c = (args - 232) * 10 + 8;
                return [
                    c,
                    c,
                    c
                ];
            }
            args -= 16;
            var rem;
            var r = Math.floor(args / 36) / 5 * 255;
            var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
            var b = rem % 6 / 5 * 255;
            return [
                r,
                g,
                b
            ];
        };
        convert.rgb.hex = function(args) {
            var integer = ((Math.round(args[0]) & 0xFF) << 16) + ((Math.round(args[1]) & 0xFF) << 8) + (Math.round(args[2]) & 0xFF);
            var string = integer.toString(16).toUpperCase();
            return "000000".substring(string.length) + string;
        };
        convert.hex.rgb = function(args) {
            var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
            if (!match) return [
                0,
                0,
                0
            ];
            var colorString = match[0];
            if (match[0].length === 3) colorString = colorString.split("").map(function(char) {
                return char + char;
            }).join("");
            var integer = parseInt(colorString, 16);
            var r = integer >> 16 & 0xFF;
            var g = integer >> 8 & 0xFF;
            var b = integer & 0xFF;
            return [
                r,
                g,
                b
            ];
        };
        convert.rgb.hcg = function(rgb) {
            var r = rgb[0] / 255;
            var g = rgb[1] / 255;
            var b = rgb[2] / 255;
            var max = Math.max(Math.max(r, g), b);
            var min = Math.min(Math.min(r, g), b);
            var chroma = max - min;
            var grayscale;
            var hue;
            if (chroma < 1) grayscale = min / (1 - chroma);
            else grayscale = 0;
            if (chroma <= 0) hue = 0;
            else if (max === r) hue = (g - b) / chroma % 6;
            else if (max === g) hue = 2 + (b - r) / chroma;
            else hue = 4 + (r - g) / chroma + 4;
            hue /= 6;
            hue %= 1;
            return [
                hue * 360,
                chroma * 100,
                grayscale * 100
            ];
        };
        convert.hsl.hcg = function(hsl) {
            var s = hsl[1] / 100;
            var l = hsl[2] / 100;
            var c = 1;
            var f = 0;
            if (l < 0.5) c = 2.0 * s * l;
            else c = 2.0 * s * (1.0 - l);
            if (c < 1.0) f = (l - 0.5 * c) / (1.0 - c);
            return [
                hsl[0],
                c * 100,
                f * 100
            ];
        };
        convert.hsv.hcg = function(hsv) {
            var s = hsv[1] / 100;
            var v = hsv[2] / 100;
            var c = s * v;
            var f = 0;
            if (c < 1.0) f = (v - c) / (1 - c);
            return [
                hsv[0],
                c * 100,
                f * 100
            ];
        };
        convert.hcg.rgb = function(hcg) {
            var h = hcg[0] / 360;
            var c = hcg[1] / 100;
            var g = hcg[2] / 100;
            if (c === 0.0) return [
                g * 255,
                g * 255,
                g * 255
            ];
            var pure = [
                0,
                0,
                0
            ];
            var hi = h % 1 * 6;
            var v = hi % 1;
            var w = 1 - v;
            var mg = 0;
            switch(Math.floor(hi)){
                case 0:
                    pure[0] = 1;
                    pure[1] = v;
                    pure[2] = 0;
                    break;
                case 1:
                    pure[0] = w;
                    pure[1] = 1;
                    pure[2] = 0;
                    break;
                case 2:
                    pure[0] = 0;
                    pure[1] = 1;
                    pure[2] = v;
                    break;
                case 3:
                    pure[0] = 0;
                    pure[1] = w;
                    pure[2] = 1;
                    break;
                case 4:
                    pure[0] = v;
                    pure[1] = 0;
                    pure[2] = 1;
                    break;
                default:
                    pure[0] = 1;
                    pure[1] = 0;
                    pure[2] = w;
            }
            mg = (1.0 - c) * g;
            return [
                (c * pure[0] + mg) * 255,
                (c * pure[1] + mg) * 255,
                (c * pure[2] + mg) * 255
            ];
        };
        convert.hcg.hsv = function(hcg) {
            var c = hcg[1] / 100;
            var g = hcg[2] / 100;
            var v = c + g * (1.0 - c);
            var f = 0;
            if (v > 0.0) f = c / v;
            return [
                hcg[0],
                f * 100,
                v * 100
            ];
        };
        convert.hcg.hsl = function(hcg) {
            var c = hcg[1] / 100;
            var g = hcg[2] / 100;
            var l = g * (1.0 - c) + 0.5 * c;
            var s = 0;
            if (l > 0.0 && l < 0.5) s = c / (2 * l);
            else if (l >= 0.5 && l < 1.0) s = c / (2 * (1 - l));
            return [
                hcg[0],
                s * 100,
                l * 100
            ];
        };
        convert.hcg.hwb = function(hcg) {
            var c = hcg[1] / 100;
            var g = hcg[2] / 100;
            var v = c + g * (1.0 - c);
            return [
                hcg[0],
                (v - c) * 100,
                (1 - v) * 100
            ];
        };
        convert.hwb.hcg = function(hwb) {
            var w = hwb[1] / 100;
            var b = hwb[2] / 100;
            var v = 1 - b;
            var c = v - w;
            var g = 0;
            if (c < 1) g = (v - c) / (1 - c);
            return [
                hwb[0],
                c * 100,
                g * 100
            ];
        };
        convert.apple.rgb = function(apple) {
            return [
                apple[0] / 65535 * 255,
                apple[1] / 65535 * 255,
                apple[2] / 65535 * 255
            ];
        };
        convert.rgb.apple = function(rgb) {
            return [
                rgb[0] / 255 * 65535,
                rgb[1] / 255 * 65535,
                rgb[2] / 255 * 65535
            ];
        };
        convert.gray.rgb = function(args) {
            return [
                args[0] / 100 * 255,
                args[0] / 100 * 255,
                args[0] / 100 * 255
            ];
        };
        convert.gray.hsl = convert.gray.hsv = function(args) {
            return [
                0,
                0,
                args[0]
            ];
        };
        convert.gray.hwb = function(gray) {
            return [
                0,
                100,
                gray[0]
            ];
        };
        convert.gray.cmyk = function(gray) {
            return [
                0,
                0,
                0,
                gray[0]
            ];
        };
        convert.gray.lab = function(gray) {
            return [
                gray[0],
                0,
                0
            ];
        };
        convert.gray.hex = function(gray) {
            var val = Math.round(gray[0] / 100 * 255) & 0xFF;
            var integer = (val << 16) + (val << 8) + val;
            var string = integer.toString(16).toUpperCase();
            return "000000".substring(string.length) + string;
        };
        convert.rgb.gray = function(rgb) {
            var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
            return [
                val / 255 * 100
            ];
        };
    });
    var conversions_1 = conversions.rgb;
    var conversions_2 = conversions.hsl;
    var conversions_3 = conversions.hsv;
    var conversions_4 = conversions.hwb;
    var conversions_5 = conversions.cmyk;
    var conversions_6 = conversions.xyz;
    var conversions_7 = conversions.lab;
    var conversions_8 = conversions.lch;
    var conversions_9 = conversions.hex;
    var conversions_10 = conversions.keyword;
    var conversions_11 = conversions.ansi16;
    var conversions_12 = conversions.ansi256;
    var conversions_13 = conversions.hcg;
    var conversions_14 = conversions.apple;
    var conversions_15 = conversions.gray;
    /*
	this function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/ function buildGraph() {
        var graph = {};
        // https://jsperf.com/object-keys-vs-for-in-with-closure/3
        var models = Object.keys(conversions);
        for(var len = models.length, i = 0; i < len; i++)graph[models[i]] = {
            // http://jsperf.com/1-vs-infinity
            // micro-opt, but this is simple.
            distance: -1,
            parent: null
        };
        return graph;
    }
    // https://en.wikipedia.org/wiki/Breadth-first_search
    function deriveBFS(fromModel) {
        var graph = buildGraph();
        var queue = [
            fromModel
        ]; // unshift -> queue -> pop
        graph[fromModel].distance = 0;
        while(queue.length){
            var current = queue.pop();
            var adjacents = Object.keys(conversions[current]);
            for(var len = adjacents.length, i = 0; i < len; i++){
                var adjacent = adjacents[i];
                var node = graph[adjacent];
                if (node.distance === -1) {
                    node.distance = graph[current].distance + 1;
                    node.parent = current;
                    queue.unshift(adjacent);
                }
            }
        }
        return graph;
    }
    function link(from, to) {
        return function(args) {
            return to(from(args));
        };
    }
    function wrapConversion(toModel, graph) {
        var path = [
            graph[toModel].parent,
            toModel
        ];
        var fn = conversions[graph[toModel].parent][toModel];
        var cur = graph[toModel].parent;
        while(graph[cur].parent){
            path.unshift(graph[cur].parent);
            fn = link(conversions[graph[cur].parent][cur], fn);
            cur = graph[cur].parent;
        }
        fn.conversion = path;
        return fn;
    }
    var route = function(fromModel) {
        var graph = deriveBFS(fromModel);
        var conversion = {};
        var models = Object.keys(graph);
        for(var len = models.length, i = 0; i < len; i++){
            var toModel = models[i];
            var node = graph[toModel];
            if (node.parent === null) continue;
            conversion[toModel] = wrapConversion(toModel, graph);
        }
        return conversion;
    };
    var convert = {};
    var models = Object.keys(conversions);
    function wrapRaw(fn) {
        var wrappedFn = function(args) {
            if (args === undefined || args === null) return args;
            if (arguments.length > 1) args = Array.prototype.slice.call(arguments);
            return fn(args);
        };
        // preserve .conversion property if there is one
        if ("conversion" in fn) wrappedFn.conversion = fn.conversion;
        return wrappedFn;
    }
    function wrapRounded(fn) {
        var wrappedFn = function(args) {
            if (args === undefined || args === null) return args;
            if (arguments.length > 1) args = Array.prototype.slice.call(arguments);
            var result = fn(args);
            // we're assuming the result is an array here.
            // see notice in conversions.js; don't use box types
            // in conversion functions.
            if (typeof result === "object") for(var len = result.length, i = 0; i < len; i++)result[i] = Math.round(result[i]);
            return result;
        };
        // preserve .conversion property if there is one
        if ("conversion" in fn) wrappedFn.conversion = fn.conversion;
        return wrappedFn;
    }
    models.forEach(function(fromModel) {
        convert[fromModel] = {};
        Object.defineProperty(convert[fromModel], "channels", {
            value: conversions[fromModel].channels
        });
        Object.defineProperty(convert[fromModel], "labels", {
            value: conversions[fromModel].labels
        });
        var routes = route(fromModel);
        var routeModels = Object.keys(routes);
        routeModels.forEach(function(toModel) {
            var fn = routes[toModel];
            convert[fromModel][toModel] = wrapRounded(fn);
            convert[fromModel][toModel].raw = wrapRaw(fn);
        });
    });
    var colorConvert = convert;
    var colorName$1 = {
        "aliceblue": [
            240,
            248,
            255
        ],
        "antiquewhite": [
            250,
            235,
            215
        ],
        "aqua": [
            0,
            255,
            255
        ],
        "aquamarine": [
            127,
            255,
            212
        ],
        "azure": [
            240,
            255,
            255
        ],
        "beige": [
            245,
            245,
            220
        ],
        "bisque": [
            255,
            228,
            196
        ],
        "black": [
            0,
            0,
            0
        ],
        "blanchedalmond": [
            255,
            235,
            205
        ],
        "blue": [
            0,
            0,
            255
        ],
        "blueviolet": [
            138,
            43,
            226
        ],
        "brown": [
            165,
            42,
            42
        ],
        "burlywood": [
            222,
            184,
            135
        ],
        "cadetblue": [
            95,
            158,
            160
        ],
        "chartreuse": [
            127,
            255,
            0
        ],
        "chocolate": [
            210,
            105,
            30
        ],
        "coral": [
            255,
            127,
            80
        ],
        "cornflowerblue": [
            100,
            149,
            237
        ],
        "cornsilk": [
            255,
            248,
            220
        ],
        "crimson": [
            220,
            20,
            60
        ],
        "cyan": [
            0,
            255,
            255
        ],
        "darkblue": [
            0,
            0,
            139
        ],
        "darkcyan": [
            0,
            139,
            139
        ],
        "darkgoldenrod": [
            184,
            134,
            11
        ],
        "darkgray": [
            169,
            169,
            169
        ],
        "darkgreen": [
            0,
            100,
            0
        ],
        "darkgrey": [
            169,
            169,
            169
        ],
        "darkkhaki": [
            189,
            183,
            107
        ],
        "darkmagenta": [
            139,
            0,
            139
        ],
        "darkolivegreen": [
            85,
            107,
            47
        ],
        "darkorange": [
            255,
            140,
            0
        ],
        "darkorchid": [
            153,
            50,
            204
        ],
        "darkred": [
            139,
            0,
            0
        ],
        "darksalmon": [
            233,
            150,
            122
        ],
        "darkseagreen": [
            143,
            188,
            143
        ],
        "darkslateblue": [
            72,
            61,
            139
        ],
        "darkslategray": [
            47,
            79,
            79
        ],
        "darkslategrey": [
            47,
            79,
            79
        ],
        "darkturquoise": [
            0,
            206,
            209
        ],
        "darkviolet": [
            148,
            0,
            211
        ],
        "deeppink": [
            255,
            20,
            147
        ],
        "deepskyblue": [
            0,
            191,
            255
        ],
        "dimgray": [
            105,
            105,
            105
        ],
        "dimgrey": [
            105,
            105,
            105
        ],
        "dodgerblue": [
            30,
            144,
            255
        ],
        "firebrick": [
            178,
            34,
            34
        ],
        "floralwhite": [
            255,
            250,
            240
        ],
        "forestgreen": [
            34,
            139,
            34
        ],
        "fuchsia": [
            255,
            0,
            255
        ],
        "gainsboro": [
            220,
            220,
            220
        ],
        "ghostwhite": [
            248,
            248,
            255
        ],
        "gold": [
            255,
            215,
            0
        ],
        "goldenrod": [
            218,
            165,
            32
        ],
        "gray": [
            128,
            128,
            128
        ],
        "green": [
            0,
            128,
            0
        ],
        "greenyellow": [
            173,
            255,
            47
        ],
        "grey": [
            128,
            128,
            128
        ],
        "honeydew": [
            240,
            255,
            240
        ],
        "hotpink": [
            255,
            105,
            180
        ],
        "indianred": [
            205,
            92,
            92
        ],
        "indigo": [
            75,
            0,
            130
        ],
        "ivory": [
            255,
            255,
            240
        ],
        "khaki": [
            240,
            230,
            140
        ],
        "lavender": [
            230,
            230,
            250
        ],
        "lavenderblush": [
            255,
            240,
            245
        ],
        "lawngreen": [
            124,
            252,
            0
        ],
        "lemonchiffon": [
            255,
            250,
            205
        ],
        "lightblue": [
            173,
            216,
            230
        ],
        "lightcoral": [
            240,
            128,
            128
        ],
        "lightcyan": [
            224,
            255,
            255
        ],
        "lightgoldenrodyellow": [
            250,
            250,
            210
        ],
        "lightgray": [
            211,
            211,
            211
        ],
        "lightgreen": [
            144,
            238,
            144
        ],
        "lightgrey": [
            211,
            211,
            211
        ],
        "lightpink": [
            255,
            182,
            193
        ],
        "lightsalmon": [
            255,
            160,
            122
        ],
        "lightseagreen": [
            32,
            178,
            170
        ],
        "lightskyblue": [
            135,
            206,
            250
        ],
        "lightslategray": [
            119,
            136,
            153
        ],
        "lightslategrey": [
            119,
            136,
            153
        ],
        "lightsteelblue": [
            176,
            196,
            222
        ],
        "lightyellow": [
            255,
            255,
            224
        ],
        "lime": [
            0,
            255,
            0
        ],
        "limegreen": [
            50,
            205,
            50
        ],
        "linen": [
            250,
            240,
            230
        ],
        "magenta": [
            255,
            0,
            255
        ],
        "maroon": [
            128,
            0,
            0
        ],
        "mediumaquamarine": [
            102,
            205,
            170
        ],
        "mediumblue": [
            0,
            0,
            205
        ],
        "mediumorchid": [
            186,
            85,
            211
        ],
        "mediumpurple": [
            147,
            112,
            219
        ],
        "mediumseagreen": [
            60,
            179,
            113
        ],
        "mediumslateblue": [
            123,
            104,
            238
        ],
        "mediumspringgreen": [
            0,
            250,
            154
        ],
        "mediumturquoise": [
            72,
            209,
            204
        ],
        "mediumvioletred": [
            199,
            21,
            133
        ],
        "midnightblue": [
            25,
            25,
            112
        ],
        "mintcream": [
            245,
            255,
            250
        ],
        "mistyrose": [
            255,
            228,
            225
        ],
        "moccasin": [
            255,
            228,
            181
        ],
        "navajowhite": [
            255,
            222,
            173
        ],
        "navy": [
            0,
            0,
            128
        ],
        "oldlace": [
            253,
            245,
            230
        ],
        "olive": [
            128,
            128,
            0
        ],
        "olivedrab": [
            107,
            142,
            35
        ],
        "orange": [
            255,
            165,
            0
        ],
        "orangered": [
            255,
            69,
            0
        ],
        "orchid": [
            218,
            112,
            214
        ],
        "palegoldenrod": [
            238,
            232,
            170
        ],
        "palegreen": [
            152,
            251,
            152
        ],
        "paleturquoise": [
            175,
            238,
            238
        ],
        "palevioletred": [
            219,
            112,
            147
        ],
        "papayawhip": [
            255,
            239,
            213
        ],
        "peachpuff": [
            255,
            218,
            185
        ],
        "peru": [
            205,
            133,
            63
        ],
        "pink": [
            255,
            192,
            203
        ],
        "plum": [
            221,
            160,
            221
        ],
        "powderblue": [
            176,
            224,
            230
        ],
        "purple": [
            128,
            0,
            128
        ],
        "rebeccapurple": [
            102,
            51,
            153
        ],
        "red": [
            255,
            0,
            0
        ],
        "rosybrown": [
            188,
            143,
            143
        ],
        "royalblue": [
            65,
            105,
            225
        ],
        "saddlebrown": [
            139,
            69,
            19
        ],
        "salmon": [
            250,
            128,
            114
        ],
        "sandybrown": [
            244,
            164,
            96
        ],
        "seagreen": [
            46,
            139,
            87
        ],
        "seashell": [
            255,
            245,
            238
        ],
        "sienna": [
            160,
            82,
            45
        ],
        "silver": [
            192,
            192,
            192
        ],
        "skyblue": [
            135,
            206,
            235
        ],
        "slateblue": [
            106,
            90,
            205
        ],
        "slategray": [
            112,
            128,
            144
        ],
        "slategrey": [
            112,
            128,
            144
        ],
        "snow": [
            255,
            250,
            250
        ],
        "springgreen": [
            0,
            255,
            127
        ],
        "steelblue": [
            70,
            130,
            180
        ],
        "tan": [
            210,
            180,
            140
        ],
        "teal": [
            0,
            128,
            128
        ],
        "thistle": [
            216,
            191,
            216
        ],
        "tomato": [
            255,
            99,
            71
        ],
        "turquoise": [
            64,
            224,
            208
        ],
        "violet": [
            238,
            130,
            238
        ],
        "wheat": [
            245,
            222,
            179
        ],
        "white": [
            255,
            255,
            255
        ],
        "whitesmoke": [
            245,
            245,
            245
        ],
        "yellow": [
            255,
            255,
            0
        ],
        "yellowgreen": [
            154,
            205,
            50
        ]
    };
    /* MIT license */ var colorString = {
        getRgba: getRgba,
        getHsla: getHsla,
        getRgb: getRgb,
        getHsl: getHsl,
        getHwb: getHwb,
        getAlpha: getAlpha,
        hexString: hexString,
        rgbString: rgbString,
        rgbaString: rgbaString,
        percentString: percentString,
        percentaString: percentaString,
        hslString: hslString,
        hslaString: hslaString,
        hwbString: hwbString,
        keyword: keyword
    };
    function getRgba(string) {
        if (!string) return;
        var abbr = /^#([a-fA-F0-9]{3,4})$/i, hex = /^#([a-fA-F0-9]{6}([a-fA-F0-9]{2})?)$/i, rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i, per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i, keyword = /(\w+)/;
        var rgb = [
            0,
            0,
            0
        ], a = 1, match = string.match(abbr), hexAlpha = "";
        if (match) {
            match = match[1];
            hexAlpha = match[3];
            for(var i = 0; i < rgb.length; i++)rgb[i] = parseInt(match[i] + match[i], 16);
            if (hexAlpha) a = Math.round(parseInt(hexAlpha + hexAlpha, 16) / 255 * 100) / 100;
        } else if (match = string.match(hex)) {
            hexAlpha = match[2];
            match = match[1];
            for(var i = 0; i < rgb.length; i++)rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
            if (hexAlpha) a = Math.round(parseInt(hexAlpha, 16) / 255 * 100) / 100;
        } else if (match = string.match(rgba)) {
            for(var i = 0; i < rgb.length; i++)rgb[i] = parseInt(match[i + 1]);
            a = parseFloat(match[4]);
        } else if (match = string.match(per)) {
            for(var i = 0; i < rgb.length; i++)rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
            a = parseFloat(match[4]);
        } else if (match = string.match(keyword)) {
            if (match[1] == "transparent") return [
                0,
                0,
                0,
                0
            ];
            rgb = colorName$1[match[1]];
            if (!rgb) return;
        }
        for(var i = 0; i < rgb.length; i++)rgb[i] = scale(rgb[i], 0, 255);
        if (!a && a != 0) a = 1;
        else a = scale(a, 0, 1);
        rgb[3] = a;
        return rgb;
    }
    function getHsla(string) {
        if (!string) return;
        var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
        var match = string.match(hsl);
        if (match) {
            var alpha = parseFloat(match[4]);
            var h = scale(parseInt(match[1]), 0, 360), s = scale(parseFloat(match[2]), 0, 100), l = scale(parseFloat(match[3]), 0, 100), a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
            return [
                h,
                s,
                l,
                a
            ];
        }
    }
    function getHwb(string) {
        if (!string) return;
        var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
        var match = string.match(hwb);
        if (match) {
            var alpha = parseFloat(match[4]);
            var h = scale(parseInt(match[1]), 0, 360), w = scale(parseFloat(match[2]), 0, 100), b = scale(parseFloat(match[3]), 0, 100), a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
            return [
                h,
                w,
                b,
                a
            ];
        }
    }
    function getRgb(string) {
        var rgba = getRgba(string);
        return rgba && rgba.slice(0, 3);
    }
    function getHsl(string) {
        var hsla = getHsla(string);
        return hsla && hsla.slice(0, 3);
    }
    function getAlpha(string) {
        var vals = getRgba(string);
        if (vals) return vals[3];
        else if (vals = getHsla(string)) return vals[3];
        else if (vals = getHwb(string)) return vals[3];
    }
    // generators
    function hexString(rgba, a) {
        var a = a !== undefined && rgba.length === 3 ? a : rgba[3];
        return "#" + hexDouble(rgba[0]) + hexDouble(rgba[1]) + hexDouble(rgba[2]) + (a >= 0 && a < 1 ? hexDouble(Math.round(a * 255)) : "");
    }
    function rgbString(rgba, alpha) {
        if (alpha < 1 || rgba[3] && rgba[3] < 1) return rgbaString(rgba, alpha);
        return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
    }
    function rgbaString(rgba, alpha) {
        if (alpha === undefined) alpha = rgba[3] !== undefined ? rgba[3] : 1;
        return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ", " + alpha + ")";
    }
    function percentString(rgba, alpha) {
        if (alpha < 1 || rgba[3] && rgba[3] < 1) return percentaString(rgba, alpha);
        var r = Math.round(rgba[0] / 255 * 100), g = Math.round(rgba[1] / 255 * 100), b = Math.round(rgba[2] / 255 * 100);
        return "rgb(" + r + "%, " + g + "%, " + b + "%)";
    }
    function percentaString(rgba, alpha) {
        var r = Math.round(rgba[0] / 255 * 100), g = Math.round(rgba[1] / 255 * 100), b = Math.round(rgba[2] / 255 * 100);
        return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
    }
    function hslString(hsla, alpha) {
        if (alpha < 1 || hsla[3] && hsla[3] < 1) return hslaString(hsla, alpha);
        return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
    }
    function hslaString(hsla, alpha) {
        if (alpha === undefined) alpha = hsla[3] !== undefined ? hsla[3] : 1;
        return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, " + alpha + ")";
    }
    // hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
    // (hwb have alpha optional & 1 is default value)
    function hwbString(hwb, alpha) {
        if (alpha === undefined) alpha = hwb[3] !== undefined ? hwb[3] : 1;
        return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%" + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
    }
    function keyword(rgb) {
        return reverseNames[rgb.slice(0, 3)];
    }
    // helpers
    function scale(num, min, max) {
        return Math.min(Math.max(min, num), max);
    }
    function hexDouble(num) {
        var str = num.toString(16).toUpperCase();
        return str.length < 2 ? "0" + str : str;
    }
    //create a list of reverse color names
    var reverseNames = {};
    for(var name in colorName$1)reverseNames[colorName$1[name]] = name;
    /* MIT license */ var Color = function(obj) {
        if (obj instanceof Color) return obj;
        if (!(this instanceof Color)) return new Color(obj);
        this.valid = false;
        this.values = {
            rgb: [
                0,
                0,
                0
            ],
            hsl: [
                0,
                0,
                0
            ],
            hsv: [
                0,
                0,
                0
            ],
            hwb: [
                0,
                0,
                0
            ],
            cmyk: [
                0,
                0,
                0,
                0
            ],
            alpha: 1
        };
        // parse Color() argument
        var vals;
        if (typeof obj === "string") {
            vals = colorString.getRgba(obj);
            if (vals) this.setValues("rgb", vals);
            else if (vals = colorString.getHsla(obj)) this.setValues("hsl", vals);
            else if (vals = colorString.getHwb(obj)) this.setValues("hwb", vals);
        } else if (typeof obj === "object") {
            vals = obj;
            if (vals.r !== undefined || vals.red !== undefined) this.setValues("rgb", vals);
            else if (vals.l !== undefined || vals.lightness !== undefined) this.setValues("hsl", vals);
            else if (vals.v !== undefined || vals.value !== undefined) this.setValues("hsv", vals);
            else if (vals.w !== undefined || vals.whiteness !== undefined) this.setValues("hwb", vals);
            else if (vals.c !== undefined || vals.cyan !== undefined) this.setValues("cmyk", vals);
        }
    };
    Color.prototype = {
        isValid: function() {
            return this.valid;
        },
        rgb: function() {
            return this.setSpace("rgb", arguments);
        },
        hsl: function() {
            return this.setSpace("hsl", arguments);
        },
        hsv: function() {
            return this.setSpace("hsv", arguments);
        },
        hwb: function() {
            return this.setSpace("hwb", arguments);
        },
        cmyk: function() {
            return this.setSpace("cmyk", arguments);
        },
        rgbArray: function() {
            return this.values.rgb;
        },
        hslArray: function() {
            return this.values.hsl;
        },
        hsvArray: function() {
            return this.values.hsv;
        },
        hwbArray: function() {
            var values = this.values;
            if (values.alpha !== 1) return values.hwb.concat([
                values.alpha
            ]);
            return values.hwb;
        },
        cmykArray: function() {
            return this.values.cmyk;
        },
        rgbaArray: function() {
            var values = this.values;
            return values.rgb.concat([
                values.alpha
            ]);
        },
        hslaArray: function() {
            var values = this.values;
            return values.hsl.concat([
                values.alpha
            ]);
        },
        alpha: function(val) {
            if (val === undefined) return this.values.alpha;
            this.setValues("alpha", val);
            return this;
        },
        red: function(val) {
            return this.setChannel("rgb", 0, val);
        },
        green: function(val) {
            return this.setChannel("rgb", 1, val);
        },
        blue: function(val) {
            return this.setChannel("rgb", 2, val);
        },
        hue: function(val) {
            if (val) {
                val %= 360;
                val = val < 0 ? 360 + val : val;
            }
            return this.setChannel("hsl", 0, val);
        },
        saturation: function(val) {
            return this.setChannel("hsl", 1, val);
        },
        lightness: function(val) {
            return this.setChannel("hsl", 2, val);
        },
        saturationv: function(val) {
            return this.setChannel("hsv", 1, val);
        },
        whiteness: function(val) {
            return this.setChannel("hwb", 1, val);
        },
        blackness: function(val) {
            return this.setChannel("hwb", 2, val);
        },
        value: function(val) {
            return this.setChannel("hsv", 2, val);
        },
        cyan: function(val) {
            return this.setChannel("cmyk", 0, val);
        },
        magenta: function(val) {
            return this.setChannel("cmyk", 1, val);
        },
        yellow: function(val) {
            return this.setChannel("cmyk", 2, val);
        },
        black: function(val) {
            return this.setChannel("cmyk", 3, val);
        },
        hexString: function() {
            return colorString.hexString(this.values.rgb);
        },
        rgbString: function() {
            return colorString.rgbString(this.values.rgb, this.values.alpha);
        },
        rgbaString: function() {
            return colorString.rgbaString(this.values.rgb, this.values.alpha);
        },
        percentString: function() {
            return colorString.percentString(this.values.rgb, this.values.alpha);
        },
        hslString: function() {
            return colorString.hslString(this.values.hsl, this.values.alpha);
        },
        hslaString: function() {
            return colorString.hslaString(this.values.hsl, this.values.alpha);
        },
        hwbString: function() {
            return colorString.hwbString(this.values.hwb, this.values.alpha);
        },
        keyword: function() {
            return colorString.keyword(this.values.rgb, this.values.alpha);
        },
        rgbNumber: function() {
            var rgb = this.values.rgb;
            return rgb[0] << 16 | rgb[1] << 8 | rgb[2];
        },
        luminosity: function() {
            // http://www.w3.org/TR/WCAG20/#relativeluminancedef
            var rgb = this.values.rgb;
            var lum = [];
            for(var i = 0; i < rgb.length; i++){
                var chan = rgb[i] / 255;
                lum[i] = chan <= 0.03928 ? chan / 12.92 : Math.pow((chan + 0.055) / 1.055, 2.4);
            }
            return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
        },
        contrast: function(color2) {
            // http://www.w3.org/TR/WCAG20/#contrast-ratiodef
            var lum1 = this.luminosity();
            var lum2 = color2.luminosity();
            if (lum1 > lum2) return (lum1 + 0.05) / (lum2 + 0.05);
            return (lum2 + 0.05) / (lum1 + 0.05);
        },
        level: function(color2) {
            var contrastRatio = this.contrast(color2);
            if (contrastRatio >= 7.1) return "AAA";
            return contrastRatio >= 4.5 ? "AA" : "";
        },
        dark: function() {
            // YIQ equation from http://24ways.org/2010/calculating-color-contrast
            var rgb = this.values.rgb;
            var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
            return yiq < 128;
        },
        light: function() {
            return !this.dark();
        },
        negate: function() {
            var rgb = [];
            for(var i = 0; i < 3; i++)rgb[i] = 255 - this.values.rgb[i];
            this.setValues("rgb", rgb);
            return this;
        },
        lighten: function(ratio) {
            var hsl = this.values.hsl;
            hsl[2] += hsl[2] * ratio;
            this.setValues("hsl", hsl);
            return this;
        },
        darken: function(ratio) {
            var hsl = this.values.hsl;
            hsl[2] -= hsl[2] * ratio;
            this.setValues("hsl", hsl);
            return this;
        },
        saturate: function(ratio) {
            var hsl = this.values.hsl;
            hsl[1] += hsl[1] * ratio;
            this.setValues("hsl", hsl);
            return this;
        },
        desaturate: function(ratio) {
            var hsl = this.values.hsl;
            hsl[1] -= hsl[1] * ratio;
            this.setValues("hsl", hsl);
            return this;
        },
        whiten: function(ratio) {
            var hwb = this.values.hwb;
            hwb[1] += hwb[1] * ratio;
            this.setValues("hwb", hwb);
            return this;
        },
        blacken: function(ratio) {
            var hwb = this.values.hwb;
            hwb[2] += hwb[2] * ratio;
            this.setValues("hwb", hwb);
            return this;
        },
        greyscale: function() {
            var rgb = this.values.rgb;
            // http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
            var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
            this.setValues("rgb", [
                val,
                val,
                val
            ]);
            return this;
        },
        clearer: function(ratio) {
            var alpha = this.values.alpha;
            this.setValues("alpha", alpha - alpha * ratio);
            return this;
        },
        opaquer: function(ratio) {
            var alpha = this.values.alpha;
            this.setValues("alpha", alpha + alpha * ratio);
            return this;
        },
        rotate: function(degrees) {
            var hsl = this.values.hsl;
            var hue = (hsl[0] + degrees) % 360;
            hsl[0] = hue < 0 ? 360 + hue : hue;
            this.setValues("hsl", hsl);
            return this;
        },
        /**
	 * Ported from sass implementation in C
	 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
	 */ mix: function(mixinColor, weight) {
            var color1 = this;
            var color2 = mixinColor;
            var p = weight === undefined ? 0.5 : weight;
            var w = 2 * p - 1;
            var a = color1.alpha() - color2.alpha();
            var w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
            var w2 = 1 - w1;
            return this.rgb(w1 * color1.red() + w2 * color2.red(), w1 * color1.green() + w2 * color2.green(), w1 * color1.blue() + w2 * color2.blue()).alpha(color1.alpha() * p + color2.alpha() * (1 - p));
        },
        toJSON: function() {
            return this.rgb();
        },
        clone: function() {
            // NOTE(SB): using node-clone creates a dependency to Buffer when using browserify,
            // making the final build way to big to embed in Chart.js. So let's do it manually,
            // assuming that values to clone are 1 dimension arrays containing only numbers,
            // except 'alpha' which is a number.
            var result = new Color();
            var source = this.values;
            var target = result.values;
            var value, type;
            for(var prop in source)if (source.hasOwnProperty(prop)) {
                value = source[prop];
                type = ({}).toString.call(value);
                if (type === "[object Array]") target[prop] = value.slice(0);
                else if (type === "[object Number]") target[prop] = value;
                else console.error("unexpected color value:", value);
            }
            return result;
        }
    };
    Color.prototype.spaces = {
        rgb: [
            "red",
            "green",
            "blue"
        ],
        hsl: [
            "hue",
            "saturation",
            "lightness"
        ],
        hsv: [
            "hue",
            "saturation",
            "value"
        ],
        hwb: [
            "hue",
            "whiteness",
            "blackness"
        ],
        cmyk: [
            "cyan",
            "magenta",
            "yellow",
            "black"
        ]
    };
    Color.prototype.maxes = {
        rgb: [
            255,
            255,
            255
        ],
        hsl: [
            360,
            100,
            100
        ],
        hsv: [
            360,
            100,
            100
        ],
        hwb: [
            360,
            100,
            100
        ],
        cmyk: [
            100,
            100,
            100,
            100
        ]
    };
    Color.prototype.getValues = function(space) {
        var values = this.values;
        var vals = {};
        for(var i = 0; i < space.length; i++)vals[space.charAt(i)] = values[space][i];
        if (values.alpha !== 1) vals.a = values.alpha;
        // {r: 255, g: 255, b: 255, a: 0.4}
        return vals;
    };
    Color.prototype.setValues = function(space, vals) {
        var values = this.values;
        var spaces = this.spaces;
        var maxes = this.maxes;
        var alpha = 1;
        var i;
        this.valid = true;
        if (space === "alpha") alpha = vals;
        else if (vals.length) {
            // [10, 10, 10]
            values[space] = vals.slice(0, space.length);
            alpha = vals[space.length];
        } else if (vals[space.charAt(0)] !== undefined) {
            // {r: 10, g: 10, b: 10}
            for(i = 0; i < space.length; i++)values[space][i] = vals[space.charAt(i)];
            alpha = vals.a;
        } else if (vals[spaces[space][0]] !== undefined) {
            // {red: 10, green: 10, blue: 10}
            var chans = spaces[space];
            for(i = 0; i < space.length; i++)values[space][i] = vals[chans[i]];
            alpha = vals.alpha;
        }
        values.alpha = Math.max(0, Math.min(1, alpha === undefined ? values.alpha : alpha));
        if (space === "alpha") return false;
        var capped;
        // cap values of the space prior converting all values
        for(i = 0; i < space.length; i++){
            capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
            values[space][i] = Math.round(capped);
        }
        // convert to all the other color spaces
        for(var sname in spaces)if (sname !== space) values[sname] = colorConvert[space][sname](values[space]);
        return true;
    };
    Color.prototype.setSpace = function(space, args) {
        var vals = args[0];
        if (vals === undefined) // color.rgb()
        return this.getValues(space);
        // color.rgb(10, 10, 10)
        if (typeof vals === "number") vals = Array.prototype.slice.call(args);
        this.setValues(space, vals);
        return this;
    };
    Color.prototype.setChannel = function(space, index, val) {
        var svalues = this.values[space];
        if (val === undefined) // color.red()
        return svalues[index];
        else if (val === svalues[index]) // color.red(color.red())
        return this;
        // color.red(100)
        svalues[index] = val;
        this.setValues(space, svalues);
        return this;
    };
    if (typeof window !== "undefined") window.Color = Color;
    var chartjsColor = Color;
    function isValidKey(key) {
        return [
            "__proto__",
            "prototype",
            "constructor"
        ].indexOf(key) === -1;
    }
    /**
 * @namespace Chart.helpers
 */ var helpers = {
        /**
	 * An empty function that can be used, for example, for optional callback.
	 */ noop: function() {},
        /**
	 * Returns a unique id, sequentially generated from a global variable.
	 * @returns {number}
	 * @function
	 */ uid: function() {
            var id = 0;
            return function() {
                return id++;
            };
        }(),
        /**
	 * Returns true if `value` is neither null nor undefined, else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @since 2.7.0
	 */ isNullOrUndef: function(value) {
            return value === null || typeof value === "undefined";
        },
        /**
	 * Returns true if `value` is an array (including typed arrays), else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @function
	 */ isArray: function(value) {
            if (Array.isArray && Array.isArray(value)) return true;
            var type = Object.prototype.toString.call(value);
            if (type.substr(0, 7) === "[object" && type.substr(-6) === "Array]") return true;
            return false;
        },
        /**
	 * Returns true if `value` is an object (excluding null), else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @since 2.7.0
	 */ isObject: function(value) {
            return value !== null && Object.prototype.toString.call(value) === "[object Object]";
        },
        /**
	 * Returns true if `value` is a finite number, else returns false
	 * @param {*} value  - The value to test.
	 * @returns {boolean}
	 */ isFinite: function(value) {
            return (typeof value === "number" || value instanceof Number) && isFinite(value);
        },
        /**
	 * Returns `value` if defined, else returns `defaultValue`.
	 * @param {*} value - The value to return if defined.
	 * @param {*} defaultValue - The value to return if `value` is undefined.
	 * @returns {*}
	 */ valueOrDefault: function(value, defaultValue) {
            return typeof value === "undefined" ? defaultValue : value;
        },
        /**
	 * Returns value at the given `index` in array if defined, else returns `defaultValue`.
	 * @param {Array} value - The array to lookup for value at `index`.
	 * @param {number} index - The index in `value` to lookup for value.
	 * @param {*} defaultValue - The value to return if `value[index]` is undefined.
	 * @returns {*}
	 */ valueAtIndexOrDefault: function(value, index, defaultValue) {
            return helpers.valueOrDefault(helpers.isArray(value) ? value[index] : value, defaultValue);
        },
        /**
	 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
	 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
	 * @param {function} fn - The function to call.
	 * @param {Array|undefined|null} args - The arguments with which `fn` should be called.
	 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @returns {*}
	 */ callback: function(fn, args, thisArg) {
            if (fn && typeof fn.call === "function") return fn.apply(thisArg, args);
        },
        /**
	 * Note(SB) for performance sake, this method should only be used when loopable type
	 * is unknown or in none intensive code (not called often and small loopable). Else
	 * it's preferable to use a regular for() loop and save extra function calls.
	 * @param {object|Array} loopable - The object or array to be iterated.
	 * @param {function} fn - The function to call for each item.
	 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @param {boolean} [reverse] - If true, iterates backward on the loopable.
	 */ each: function(loopable, fn, thisArg, reverse) {
            var i, len, keys;
            if (helpers.isArray(loopable)) {
                len = loopable.length;
                if (reverse) for(i = len - 1; i >= 0; i--)fn.call(thisArg, loopable[i], i);
                else for(i = 0; i < len; i++)fn.call(thisArg, loopable[i], i);
            } else if (helpers.isObject(loopable)) {
                keys = Object.keys(loopable);
                len = keys.length;
                for(i = 0; i < len; i++)fn.call(thisArg, loopable[keys[i]], keys[i]);
            }
        },
        /**
	 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
	 * @see https://stackoverflow.com/a/14853974
	 * @param {Array} a0 - The array to compare
	 * @param {Array} a1 - The array to compare
	 * @returns {boolean}
	 */ arrayEquals: function(a0, a1) {
            var i, ilen, v0, v1;
            if (!a0 || !a1 || a0.length !== a1.length) return false;
            for(i = 0, ilen = a0.length; i < ilen; ++i){
                v0 = a0[i];
                v1 = a1[i];
                if (v0 instanceof Array && v1 instanceof Array) {
                    if (!helpers.arrayEquals(v0, v1)) return false;
                } else if (v0 !== v1) // NOTE: two different object instances will never be equal: {x:20} != {x:20}
                return false;
            }
            return true;
        },
        /**
	 * Returns a deep copy of `source` without keeping references on objects and arrays.
	 * @param {*} source - The value to clone.
	 * @returns {*}
	 */ clone: function(source) {
            if (helpers.isArray(source)) return source.map(helpers.clone);
            if (helpers.isObject(source)) {
                var target = Object.create(source);
                var keys = Object.keys(source);
                var klen = keys.length;
                var k = 0;
                for(; k < klen; ++k)target[keys[k]] = helpers.clone(source[keys[k]]);
                return target;
            }
            return source;
        },
        /**
	 * The default merger when Chart.helpers.merge is called without merger option.
	 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
	 * @private
	 */ _merger: function(key, target, source, options) {
            if (!isValidKey(key)) // We want to ensure we do not copy prototypes over
            // as this can pollute global namespaces
            return;
            var tval = target[key];
            var sval = source[key];
            if (helpers.isObject(tval) && helpers.isObject(sval)) helpers.merge(tval, sval, options);
            else target[key] = helpers.clone(sval);
        },
        /**
	 * Merges source[key] in target[key] only if target[key] is undefined.
	 * @private
	 */ _mergerIf: function(key, target, source) {
            if (!isValidKey(key)) // We want to ensure we do not copy prototypes over
            // as this can pollute global namespaces
            return;
            var tval = target[key];
            var sval = source[key];
            if (helpers.isObject(tval) && helpers.isObject(sval)) helpers.mergeIf(tval, sval);
            else if (!target.hasOwnProperty(key)) target[key] = helpers.clone(sval);
        },
        /**
	 * Recursively deep copies `source` properties into `target` with the given `options`.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {object} target - The target object in which all sources are merged into.
	 * @param {object|object[]} source - Object(s) to merge into `target`.
	 * @param {object} [options] - Merging options:
	 * @param {function} [options.merger] - The merge method (key, target, source, options)
	 * @returns {object} The `target` object.
	 */ merge: function(target, source, options) {
            var sources = helpers.isArray(source) ? source : [
                source
            ];
            var ilen = sources.length;
            var merge, i, keys, klen, k;
            if (!helpers.isObject(target)) return target;
            options = options || {};
            merge = options.merger || helpers._merger;
            for(i = 0; i < ilen; ++i){
                source = sources[i];
                if (!helpers.isObject(source)) continue;
                keys = Object.keys(source);
                for(k = 0, klen = keys.length; k < klen; ++k)merge(keys[k], target, source, options);
            }
            return target;
        },
        /**
	 * Recursively deep copies `source` properties into `target` *only* if not defined in target.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {object} target - The target object in which all sources are merged into.
	 * @param {object|object[]} source - Object(s) to merge into `target`.
	 * @returns {object} The `target` object.
	 */ mergeIf: function(target, source) {
            return helpers.merge(target, source, {
                merger: helpers._mergerIf
            });
        },
        /**
	 * Applies the contents of two or more objects together into the first object.
	 * @param {object} target - The target object in which all objects are merged into.
	 * @param {object} arg1 - Object containing additional properties to merge in target.
	 * @param {object} argN - Additional objects containing properties to merge in target.
	 * @returns {object} The `target` object.
	 */ extend: Object.assign || function(target) {
            return helpers.merge(target, [].slice.call(arguments, 1), {
                merger: function(key, dst, src) {
                    dst[key] = src[key];
                }
            });
        },
        /**
	 * Basic javascript inheritance based on the model created in Backbone.js
	 */ inherits: function(extensions) {
            var me = this;
            var ChartElement = extensions && extensions.hasOwnProperty("constructor") ? extensions.constructor : function() {
                return me.apply(this, arguments);
            };
            var Surrogate = function() {
                this.constructor = ChartElement;
            };
            Surrogate.prototype = me.prototype;
            ChartElement.prototype = new Surrogate();
            ChartElement.extend = helpers.inherits;
            if (extensions) helpers.extend(ChartElement.prototype, extensions);
            ChartElement.__super__ = me.prototype;
            return ChartElement;
        },
        _deprecated: function(scope, value, previous, current) {
            if (value !== undefined) console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
        }
    };
    var helpers_core = helpers;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart.helpers.callback instead.
 * @function Chart.helpers.callCallback
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */ helpers.callCallback = helpers.callback;
    /**
 * Provided for backward compatibility, use Array.prototype.indexOf instead.
 * Array.prototype.indexOf compatibility: Chrome, Opera, Safari, FF1.5+, IE9+
 * @function Chart.helpers.indexOf
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers.indexOf = function(array, item, fromIndex) {
        return Array.prototype.indexOf.call(array, item, fromIndex);
    };
    /**
 * Provided for backward compatibility, use Chart.helpers.valueOrDefault instead.
 * @function Chart.helpers.getValueOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers.getValueOrDefault = helpers.valueOrDefault;
    /**
 * Provided for backward compatibility, use Chart.helpers.valueAtIndexOrDefault instead.
 * @function Chart.helpers.getValueAtIndexOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers.getValueAtIndexOrDefault = helpers.valueAtIndexOrDefault;
    /**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easingEffects
 * @see http://www.robertpenner.com/easing/
 */ var effects = {
        linear: function(t) {
            return t;
        },
        easeInQuad: function(t) {
            return t * t;
        },
        easeOutQuad: function(t) {
            return -t * (t - 2);
        },
        easeInOutQuad: function(t) {
            if ((t /= 0.5) < 1) return 0.5 * t * t;
            return -0.5 * (--t * (t - 2) - 1);
        },
        easeInCubic: function(t) {
            return t * t * t;
        },
        easeOutCubic: function(t) {
            return (t = t - 1) * t * t + 1;
        },
        easeInOutCubic: function(t) {
            if ((t /= 0.5) < 1) return 0.5 * t * t * t;
            return 0.5 * ((t -= 2) * t * t + 2);
        },
        easeInQuart: function(t) {
            return t * t * t * t;
        },
        easeOutQuart: function(t) {
            return -((t = t - 1) * t * t * t - 1);
        },
        easeInOutQuart: function(t) {
            if ((t /= 0.5) < 1) return 0.5 * t * t * t * t;
            return -0.5 * ((t -= 2) * t * t * t - 2);
        },
        easeInQuint: function(t) {
            return t * t * t * t * t;
        },
        easeOutQuint: function(t) {
            return (t = t - 1) * t * t * t * t + 1;
        },
        easeInOutQuint: function(t) {
            if ((t /= 0.5) < 1) return 0.5 * t * t * t * t * t;
            return 0.5 * ((t -= 2) * t * t * t * t + 2);
        },
        easeInSine: function(t) {
            return -Math.cos(t * (Math.PI / 2)) + 1;
        },
        easeOutSine: function(t) {
            return Math.sin(t * (Math.PI / 2));
        },
        easeInOutSine: function(t) {
            return -0.5 * (Math.cos(Math.PI * t) - 1);
        },
        easeInExpo: function(t) {
            return t === 0 ? 0 : Math.pow(2, 10 * (t - 1));
        },
        easeOutExpo: function(t) {
            return t === 1 ? 1 : -Math.pow(2, -10 * t) + 1;
        },
        easeInOutExpo: function(t) {
            if (t === 0) return 0;
            if (t === 1) return 1;
            if ((t /= 0.5) < 1) return 0.5 * Math.pow(2, 10 * (t - 1));
            return 0.5 * (-Math.pow(2, -10 * --t) + 2);
        },
        easeInCirc: function(t) {
            if (t >= 1) return t;
            return -(Math.sqrt(1 - t * t) - 1);
        },
        easeOutCirc: function(t) {
            return Math.sqrt(1 - (t = t - 1) * t);
        },
        easeInOutCirc: function(t) {
            if ((t /= 0.5) < 1) return -0.5 * (Math.sqrt(1 - t * t) - 1);
            return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
        },
        easeInElastic: function(t) {
            var s = 1.70158;
            var p = 0;
            var a = 1;
            if (t === 0) return 0;
            if (t === 1) return 1;
            if (!p) p = 0.3;
            if (a < 1) {
                a = 1;
                s = p / 4;
            } else s = p / (2 * Math.PI) * Math.asin(1 / a);
            return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
        },
        easeOutElastic: function(t) {
            var s = 1.70158;
            var p = 0;
            var a = 1;
            if (t === 0) return 0;
            if (t === 1) return 1;
            if (!p) p = 0.3;
            if (a < 1) {
                a = 1;
                s = p / 4;
            } else s = p / (2 * Math.PI) * Math.asin(1 / a);
            return a * Math.pow(2, -10 * t) * Math.sin((t - s) * (2 * Math.PI) / p) + 1;
        },
        easeInOutElastic: function(t) {
            var s = 1.70158;
            var p = 0;
            var a = 1;
            if (t === 0) return 0;
            if ((t /= 0.5) === 2) return 1;
            if (!p) p = 0.45;
            if (a < 1) {
                a = 1;
                s = p / 4;
            } else s = p / (2 * Math.PI) * Math.asin(1 / a);
            if (t < 1) return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
            return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p) * 0.5 + 1;
        },
        easeInBack: function(t) {
            var s = 1.70158;
            return t * t * ((s + 1) * t - s);
        },
        easeOutBack: function(t) {
            var s = 1.70158;
            return (t = t - 1) * t * ((s + 1) * t + s) + 1;
        },
        easeInOutBack: function(t) {
            var s = 1.70158;
            if ((t /= 0.5) < 1) return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
            return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
        },
        easeInBounce: function(t) {
            return 1 - effects.easeOutBounce(1 - t);
        },
        easeOutBounce: function(t) {
            if (t < 1 / 2.75) return 7.5625 * t * t;
            if (t < 2 / 2.75) return 7.5625 * (t -= 1.5 / 2.75) * t + 0.75;
            if (t < 2.5 / 2.75) return 7.5625 * (t -= 2.25 / 2.75) * t + 0.9375;
            return 7.5625 * (t -= 2.625 / 2.75) * t + 0.984375;
        },
        easeInOutBounce: function(t) {
            if (t < 0.5) return effects.easeInBounce(t * 2) * 0.5;
            return effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
        }
    };
    var helpers_easing = {
        effects: effects
    };
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart.helpers.easing.effects instead.
 * @function Chart.helpers.easingEffects
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers_core.easingEffects = effects;
    var PI = Math.PI;
    var RAD_PER_DEG = PI / 180;
    var DOUBLE_PI = PI * 2;
    var HALF_PI = PI / 2;
    var QUARTER_PI = PI / 4;
    var TWO_THIRDS_PI = PI * 2 / 3;
    /**
 * @namespace Chart.helpers.canvas
 */ var exports$1 = {
        /**
	 * Clears the entire canvas associated to the given `chart`.
	 * @param {Chart} chart - The chart for which to clear the canvas.
	 */ clear: function(chart) {
            chart.ctx.clearRect(0, 0, chart.width, chart.height);
        },
        /**
	 * Creates a "path" for a rectangle with rounded corners at position (x, y) with a
	 * given size (width, height) and the same `radius` for all corners.
	 * @param {CanvasRenderingContext2D} ctx - The canvas 2D Context.
	 * @param {number} x - The x axis of the coordinate for the rectangle starting point.
	 * @param {number} y - The y axis of the coordinate for the rectangle starting point.
	 * @param {number} width - The rectangle's width.
	 * @param {number} height - The rectangle's height.
	 * @param {number} radius - The rounded amount (in pixels) for the four corners.
	 * @todo handle `radius` as top-left, top-right, bottom-right, bottom-left array/object?
	 */ roundedRect: function(ctx, x, y, width, height, radius) {
            if (radius) {
                var r = Math.min(radius, height / 2, width / 2);
                var left = x + r;
                var top = y + r;
                var right = x + width - r;
                var bottom = y + height - r;
                ctx.moveTo(x, top);
                if (left < right && top < bottom) {
                    ctx.arc(left, top, r, -PI, -HALF_PI);
                    ctx.arc(right, top, r, -HALF_PI, 0);
                    ctx.arc(right, bottom, r, 0, HALF_PI);
                    ctx.arc(left, bottom, r, HALF_PI, PI);
                } else if (left < right) {
                    ctx.moveTo(left, y);
                    ctx.arc(right, top, r, -HALF_PI, HALF_PI);
                    ctx.arc(left, top, r, HALF_PI, PI + HALF_PI);
                } else if (top < bottom) {
                    ctx.arc(left, top, r, -PI, 0);
                    ctx.arc(left, bottom, r, 0, PI);
                } else ctx.arc(left, top, r, -PI, PI);
                ctx.closePath();
                ctx.moveTo(x, y);
            } else ctx.rect(x, y, width, height);
        },
        drawPoint: function(ctx, style, radius, x, y, rotation) {
            var type, xOffset, yOffset, size, cornerRadius;
            var rad = (rotation || 0) * RAD_PER_DEG;
            if (style && typeof style === "object") {
                type = style.toString();
                if (type === "[object HTMLImageElement]" || type === "[object HTMLCanvasElement]") {
                    ctx.save();
                    ctx.translate(x, y);
                    ctx.rotate(rad);
                    ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
                    ctx.restore();
                    return;
                }
            }
            if (isNaN(radius) || radius <= 0) return;
            ctx.beginPath();
            switch(style){
                // Default includes circle
                default:
                    ctx.arc(x, y, radius, 0, DOUBLE_PI);
                    ctx.closePath();
                    break;
                case "triangle":
                    ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
                    rad += TWO_THIRDS_PI;
                    ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
                    rad += TWO_THIRDS_PI;
                    ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
                    ctx.closePath();
                    break;
                case "rectRounded":
                    // NOTE: the rounded rect implementation changed to use `arc` instead of
                    // `quadraticCurveTo` since it generates better results when rect is
                    // almost a circle. 0.516 (instead of 0.5) produces results with visually
                    // closer proportion to the previous impl and it is inscribed in the
                    // circle with `radius`. For more details, see the following PRs:
                    // https://github.com/chartjs/Chart.js/issues/5597
                    // https://github.com/chartjs/Chart.js/issues/5858
                    cornerRadius = radius * 0.516;
                    size = radius - cornerRadius;
                    xOffset = Math.cos(rad + QUARTER_PI) * size;
                    yOffset = Math.sin(rad + QUARTER_PI) * size;
                    ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
                    ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - HALF_PI, rad);
                    ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + HALF_PI);
                    ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
                    ctx.closePath();
                    break;
                case "rect":
                    if (!rotation) {
                        size = Math.SQRT1_2 * radius;
                        ctx.rect(x - size, y - size, 2 * size, 2 * size);
                        break;
                    }
                    rad += QUARTER_PI;
                /* falls through */ case "rectRot":
                    xOffset = Math.cos(rad) * radius;
                    yOffset = Math.sin(rad) * radius;
                    ctx.moveTo(x - xOffset, y - yOffset);
                    ctx.lineTo(x + yOffset, y - xOffset);
                    ctx.lineTo(x + xOffset, y + yOffset);
                    ctx.lineTo(x - yOffset, y + xOffset);
                    ctx.closePath();
                    break;
                case "crossRot":
                    rad += QUARTER_PI;
                /* falls through */ case "cross":
                    xOffset = Math.cos(rad) * radius;
                    yOffset = Math.sin(rad) * radius;
                    ctx.moveTo(x - xOffset, y - yOffset);
                    ctx.lineTo(x + xOffset, y + yOffset);
                    ctx.moveTo(x + yOffset, y - xOffset);
                    ctx.lineTo(x - yOffset, y + xOffset);
                    break;
                case "star":
                    xOffset = Math.cos(rad) * radius;
                    yOffset = Math.sin(rad) * radius;
                    ctx.moveTo(x - xOffset, y - yOffset);
                    ctx.lineTo(x + xOffset, y + yOffset);
                    ctx.moveTo(x + yOffset, y - xOffset);
                    ctx.lineTo(x - yOffset, y + xOffset);
                    rad += QUARTER_PI;
                    xOffset = Math.cos(rad) * radius;
                    yOffset = Math.sin(rad) * radius;
                    ctx.moveTo(x - xOffset, y - yOffset);
                    ctx.lineTo(x + xOffset, y + yOffset);
                    ctx.moveTo(x + yOffset, y - xOffset);
                    ctx.lineTo(x - yOffset, y + xOffset);
                    break;
                case "line":
                    xOffset = Math.cos(rad) * radius;
                    yOffset = Math.sin(rad) * radius;
                    ctx.moveTo(x - xOffset, y - yOffset);
                    ctx.lineTo(x + xOffset, y + yOffset);
                    break;
                case "dash":
                    ctx.moveTo(x, y);
                    ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
                    break;
            }
            ctx.fill();
            ctx.stroke();
        },
        /**
	 * Returns true if the point is inside the rectangle
	 * @param {object} point - The point to test
	 * @param {object} area - The rectangle
	 * @returns {boolean}
	 * @private
	 */ _isPointInArea: function(point, area) {
            var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.
            return point.x > area.left - epsilon && point.x < area.right + epsilon && point.y > area.top - epsilon && point.y < area.bottom + epsilon;
        },
        clipArea: function(ctx, area) {
            ctx.save();
            ctx.beginPath();
            ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
            ctx.clip();
        },
        unclipArea: function(ctx) {
            ctx.restore();
        },
        lineTo: function(ctx, previous, target, flip) {
            var stepped = target.steppedLine;
            if (stepped) {
                if (stepped === "middle") {
                    var midpoint = (previous.x + target.x) / 2.0;
                    ctx.lineTo(midpoint, flip ? target.y : previous.y);
                    ctx.lineTo(midpoint, flip ? previous.y : target.y);
                } else if (stepped === "after" && !flip || stepped !== "after" && flip) ctx.lineTo(previous.x, target.y);
                else ctx.lineTo(target.x, previous.y);
                ctx.lineTo(target.x, target.y);
                return;
            }
            if (!target.tension) {
                ctx.lineTo(target.x, target.y);
                return;
            }
            ctx.bezierCurveTo(flip ? previous.controlPointPreviousX : previous.controlPointNextX, flip ? previous.controlPointPreviousY : previous.controlPointNextY, flip ? target.controlPointNextX : target.controlPointPreviousX, flip ? target.controlPointNextY : target.controlPointPreviousY, target.x, target.y);
        }
    };
    var helpers_canvas = exports$1;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart.helpers.canvas.clear instead.
 * @namespace Chart.helpers.clear
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers_core.clear = exports$1.clear;
    /**
 * Provided for backward compatibility, use Chart.helpers.canvas.roundedRect instead.
 * @namespace Chart.helpers.drawRoundedRectangle
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers_core.drawRoundedRectangle = function(ctx) {
        ctx.beginPath();
        exports$1.roundedRect.apply(exports$1, arguments);
    };
    var defaults = {
        /**
	 * @private
	 */ _set: function(scope, values) {
            return helpers_core.merge(this[scope] || (this[scope] = {}), values);
        }
    };
    // TODO(v3): remove 'global' from namespace.  all default are global and
    // there's inconsistency around which options are under 'global'
    defaults._set("global", {
        defaultColor: "rgba(0,0,0,0.1)",
        defaultFontColor: "#666",
        defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        defaultFontSize: 12,
        defaultFontStyle: "normal",
        defaultLineHeight: 1.2,
        showLines: true
    });
    var core_defaults = defaults;
    var valueOrDefault = helpers_core.valueOrDefault;
    /**
 * Converts the given font object into a CSS font string.
 * @param {object} font - A font object.
 * @return {string} The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */ function toFontString(font) {
        if (!font || helpers_core.isNullOrUndef(font.size) || helpers_core.isNullOrUndef(font.family)) return null;
        return (font.style ? font.style + " " : "") + (font.weight ? font.weight + " " : "") + font.size + "px " + font.family;
    }
    /**
 * @alias Chart.helpers.options
 * @namespace
 */ var helpers_options = {
        /**
	 * Converts the given line height `value` in pixels for a specific font `size`.
	 * @param {number|string} value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
	 * @param {number} size - The font size (in pixels) used to resolve relative `value`.
	 * @returns {number} The effective line height in pixels (size * 1.2 if value is invalid).
	 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
	 * @since 2.7.0
	 */ toLineHeight: function(value, size) {
            var matches = ("" + value).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
            if (!matches || matches[1] === "normal") return size * 1.2;
            value = +matches[2];
            switch(matches[3]){
                case "px":
                    return value;
                case "%":
                    value /= 100;
                    break;
            }
            return size * value;
        },
        /**
	 * Converts the given value into a padding object with pre-computed width/height.
	 * @param {number|object} value - If a number, set the value to all TRBL component,
	 *  else, if and object, use defined properties and sets undefined ones to 0.
	 * @returns {object} The padding values (top, right, bottom, left, width, height)
	 * @since 2.7.0
	 */ toPadding: function(value) {
            var t, r, b, l;
            if (helpers_core.isObject(value)) {
                t = +value.top || 0;
                r = +value.right || 0;
                b = +value.bottom || 0;
                l = +value.left || 0;
            } else t = r = b = l = +value || 0;
            return {
                top: t,
                right: r,
                bottom: b,
                left: l,
                height: t + b,
                width: l + r
            };
        },
        /**
	 * Parses font options and returns the font object.
	 * @param {object} options - A object that contains font options to be parsed.
	 * @return {object} The font object.
	 * @todo Support font.* options and renamed to toFont().
	 * @private
	 */ _parseFont: function(options) {
            var globalDefaults = core_defaults.global;
            var size = valueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
            var font = {
                family: valueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily),
                lineHeight: helpers_core.options.toLineHeight(valueOrDefault(options.lineHeight, globalDefaults.defaultLineHeight), size),
                size: size,
                style: valueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle),
                weight: null,
                string: ""
            };
            font.string = toFontString(font);
            return font;
        },
        /**
	 * Evaluates the given `inputs` sequentially and returns the first defined value.
	 * @param {Array} inputs - An array of values, falling back to the last value.
	 * @param {object} [context] - If defined and the current value is a function, the value
	 * is called with `context` as first argument and the result becomes the new input.
	 * @param {number} [index] - If defined and the current value is an array, the value
	 * at `index` become the new input.
	 * @param {object} [info] - object to return information about resolution in
	 * @param {boolean} [info.cacheable] - Will be set to `false` if option is not cacheable.
	 * @since 2.7.0
	 */ resolve: function(inputs, context, index, info) {
            var cacheable = true;
            var i, ilen, value;
            for(i = 0, ilen = inputs.length; i < ilen; ++i){
                value = inputs[i];
                if (value === undefined) continue;
                if (context !== undefined && typeof value === "function") {
                    value = value(context);
                    cacheable = false;
                }
                if (index !== undefined && helpers_core.isArray(value)) {
                    value = value[index];
                    cacheable = false;
                }
                if (value !== undefined) {
                    if (info && !cacheable) info.cacheable = false;
                    return value;
                }
            }
        }
    };
    /**
 * @alias Chart.helpers.math
 * @namespace
 */ var exports$2 = {
        /**
	 * Returns an array of factors sorted from 1 to sqrt(value)
	 * @private
	 */ _factorize: function(value) {
            var result = [];
            var sqrt = Math.sqrt(value);
            var i;
            for(i = 1; i < sqrt; i++)if (value % i === 0) {
                result.push(i);
                result.push(value / i);
            }
            if (sqrt === (sqrt | 0)) result.push(sqrt);
            result.sort(function(a, b) {
                return a - b;
            }).pop();
            return result;
        },
        log10: Math.log10 || function(x) {
            var exponent = Math.log(x) * Math.LOG10E; // Math.LOG10E = 1 / Math.LN10.
            // Check for whole powers of 10,
            // which due to floating point rounding error should be corrected.
            var powerOf10 = Math.round(exponent);
            var isPowerOf10 = x === Math.pow(10, powerOf10);
            return isPowerOf10 ? powerOf10 : exponent;
        }
    };
    var helpers_math = exports$2;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart.helpers.math.log10 instead.
 * @namespace Chart.helpers.log10
 * @deprecated since version 2.9.0
 * @todo remove at version 3
 * @private
 */ helpers_core.log10 = exports$2.log10;
    var getRtlAdapter = function(rectX, width) {
        return {
            x: function(x) {
                return rectX + rectX + width - x;
            },
            setWidth: function(w) {
                width = w;
            },
            textAlign: function(align) {
                if (align === "center") return align;
                return align === "right" ? "left" : "right";
            },
            xPlus: function(x, value) {
                return x - value;
            },
            leftForLtr: function(x, itemWidth) {
                return x - itemWidth;
            }
        };
    };
    var getLtrAdapter = function() {
        return {
            x: function(x) {
                return x;
            },
            setWidth: function(w) {},
            textAlign: function(align) {
                return align;
            },
            xPlus: function(x, value) {
                return x + value;
            },
            leftForLtr: function(x, _itemWidth) {
                return x;
            }
        };
    };
    var getAdapter = function(rtl, rectX, width) {
        return rtl ? getRtlAdapter(rectX, width) : getLtrAdapter();
    };
    var overrideTextDirection = function(ctx, direction) {
        var style, original;
        if (direction === "ltr" || direction === "rtl") {
            style = ctx.canvas.style;
            original = [
                style.getPropertyValue("direction"),
                style.getPropertyPriority("direction")
            ];
            style.setProperty("direction", direction, "important");
            ctx.prevTextDirection = original;
        }
    };
    var restoreTextDirection = function(ctx) {
        var original = ctx.prevTextDirection;
        if (original !== undefined) {
            delete ctx.prevTextDirection;
            ctx.canvas.style.setProperty("direction", original[0], original[1]);
        }
    };
    var helpers_rtl = {
        getRtlAdapter: getAdapter,
        overrideTextDirection: overrideTextDirection,
        restoreTextDirection: restoreTextDirection
    };
    var helpers$1 = helpers_core;
    var easing = helpers_easing;
    var canvas = helpers_canvas;
    var options = helpers_options;
    var math = helpers_math;
    var rtl = helpers_rtl;
    helpers$1.easing = easing;
    helpers$1.canvas = canvas;
    helpers$1.options = options;
    helpers$1.math = math;
    helpers$1.rtl = rtl;
    function interpolate(start, view, model, ease) {
        var keys = Object.keys(model);
        var i, ilen, key, actual, origin, target, type, c0, c1;
        for(i = 0, ilen = keys.length; i < ilen; ++i){
            key = keys[i];
            target = model[key];
            // if a value is added to the model after pivot() has been called, the view
            // doesn't contain it, so let's initialize the view to the target value.
            if (!view.hasOwnProperty(key)) view[key] = target;
            actual = view[key];
            if (actual === target || key[0] === "_") continue;
            if (!start.hasOwnProperty(key)) start[key] = actual;
            origin = start[key];
            type = typeof target;
            if (type === typeof origin) {
                if (type === "string") {
                    c0 = chartjsColor(origin);
                    if (c0.valid) {
                        c1 = chartjsColor(target);
                        if (c1.valid) {
                            view[key] = c1.mix(c0, ease).rgbString();
                            continue;
                        }
                    }
                } else if (helpers$1.isFinite(origin) && helpers$1.isFinite(target)) {
                    view[key] = origin + (target - origin) * ease;
                    continue;
                }
            }
            view[key] = target;
        }
    }
    var Element = function(configuration) {
        helpers$1.extend(this, configuration);
        this.initialize.apply(this, arguments);
    };
    helpers$1.extend(Element.prototype, {
        _type: undefined,
        initialize: function() {
            this.hidden = false;
        },
        pivot: function() {
            var me = this;
            if (!me._view) me._view = helpers$1.extend({}, me._model);
            me._start = {};
            return me;
        },
        transition: function(ease) {
            var me = this;
            var model = me._model;
            var start = me._start;
            var view = me._view;
            // No animation -> No Transition
            if (!model || ease === 1) {
                me._view = helpers$1.extend({}, model);
                me._start = null;
                return me;
            }
            if (!view) view = me._view = {};
            if (!start) start = me._start = {};
            interpolate(start, view, model, ease);
            return me;
        },
        tooltipPosition: function() {
            return {
                x: this._model.x,
                y: this._model.y
            };
        },
        hasValue: function() {
            return helpers$1.isNumber(this._model.x) && helpers$1.isNumber(this._model.y);
        }
    });
    Element.extend = helpers$1.inherits;
    var core_element = Element;
    var exports$3 = core_element.extend({
        chart: null,
        currentStep: 0,
        numSteps: 60,
        easing: "",
        render: null,
        onAnimationProgress: null,
        onAnimationComplete: null
    });
    var core_animation = exports$3;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart.Animation instead
 * @prop Chart.Animation#animationObject
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 */ Object.defineProperty(exports$3.prototype, "animationObject", {
        get: function() {
            return this;
        }
    });
    /**
 * Provided for backward compatibility, use Chart.Animation#chart instead
 * @prop Chart.Animation#chartInstance
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 */ Object.defineProperty(exports$3.prototype, "chartInstance", {
        get: function() {
            return this.chart;
        },
        set: function(value) {
            this.chart = value;
        }
    });
    core_defaults._set("global", {
        animation: {
            duration: 1000,
            easing: "easeOutQuart",
            onProgress: helpers$1.noop,
            onComplete: helpers$1.noop
        }
    });
    var core_animations = {
        animations: [],
        request: null,
        /**
	 * @param {Chart} chart - The chart to animate.
	 * @param {Chart.Animation} animation - The animation that we will animate.
	 * @param {number} duration - The animation duration in ms.
	 * @param {boolean} lazy - if true, the chart is not marked as animating to enable more responsive interactions
	 */ addAnimation: function(chart, animation, duration, lazy) {
            var animations = this.animations;
            var i, ilen;
            animation.chart = chart;
            animation.startTime = Date.now();
            animation.duration = duration;
            if (!lazy) chart.animating = true;
            for(i = 0, ilen = animations.length; i < ilen; ++i)if (animations[i].chart === chart) {
                animations[i] = animation;
                return;
            }
            animations.push(animation);
            // If there are no animations queued, manually kickstart a digest, for lack of a better word
            if (animations.length === 1) this.requestAnimationFrame();
        },
        cancelAnimation: function(chart) {
            var index = helpers$1.findIndex(this.animations, function(animation) {
                return animation.chart === chart;
            });
            if (index !== -1) {
                this.animations.splice(index, 1);
                chart.animating = false;
            }
        },
        requestAnimationFrame: function() {
            var me = this;
            if (me.request === null) // Skip animation frame requests until the active one is executed.
            // This can happen when processing mouse events, e.g. 'mousemove'
            // and 'mouseout' events will trigger multiple renders.
            me.request = helpers$1.requestAnimFrame.call(window, function() {
                me.request = null;
                me.startDigest();
            });
        },
        /**
	 * @private
	 */ startDigest: function() {
            var me = this;
            me.advance();
            // Do we have more stuff to animate?
            if (me.animations.length > 0) me.requestAnimationFrame();
        },
        /**
	 * @private
	 */ advance: function() {
            var animations = this.animations;
            var animation, chart, numSteps, nextStep;
            var i = 0;
            // 1 animation per chart, so we are looping charts here
            while(i < animations.length){
                animation = animations[i];
                chart = animation.chart;
                numSteps = animation.numSteps;
                // Make sure that currentStep starts at 1
                // https://github.com/chartjs/Chart.js/issues/6104
                nextStep = Math.floor((Date.now() - animation.startTime) / animation.duration * numSteps) + 1;
                animation.currentStep = Math.min(nextStep, numSteps);
                helpers$1.callback(animation.render, [
                    chart,
                    animation
                ], chart);
                helpers$1.callback(animation.onAnimationProgress, [
                    animation
                ], chart);
                if (animation.currentStep >= numSteps) {
                    helpers$1.callback(animation.onAnimationComplete, [
                        animation
                    ], chart);
                    chart.animating = false;
                    animations.splice(i, 1);
                } else ++i;
            }
        }
    };
    var resolve = helpers$1.options.resolve;
    var arrayEvents = [
        "push",
        "pop",
        "shift",
        "splice",
        "unshift"
    ];
    /**
 * Hooks the array methods that add or remove values ('push', pop', 'shift', 'splice',
 * 'unshift') and notify the listener AFTER the array has been altered. Listeners are
 * called on the 'onData*' callbacks (e.g. onDataPush, etc.) with same arguments.
 */ function listenArrayEvents(array, listener) {
        if (array._chartjs) {
            array._chartjs.listeners.push(listener);
            return;
        }
        Object.defineProperty(array, "_chartjs", {
            configurable: true,
            enumerable: false,
            value: {
                listeners: [
                    listener
                ]
            }
        });
        arrayEvents.forEach(function(key) {
            var method = "onData" + key.charAt(0).toUpperCase() + key.slice(1);
            var base = array[key];
            Object.defineProperty(array, key, {
                configurable: true,
                enumerable: false,
                value: function() {
                    var args = Array.prototype.slice.call(arguments);
                    var res = base.apply(this, args);
                    helpers$1.each(array._chartjs.listeners, function(object) {
                        if (typeof object[method] === "function") object[method].apply(object, args);
                    });
                    return res;
                }
            });
        });
    }
    /**
 * Removes the given array event listener and cleanup extra attached properties (such as
 * the _chartjs stub and overridden methods) if array doesn't have any more listeners.
 */ function unlistenArrayEvents(array, listener) {
        var stub = array._chartjs;
        if (!stub) return;
        var listeners = stub.listeners;
        var index = listeners.indexOf(listener);
        if (index !== -1) listeners.splice(index, 1);
        if (listeners.length > 0) return;
        arrayEvents.forEach(function(key) {
            delete array[key];
        });
        delete array._chartjs;
    }
    // Base class for all dataset controllers (line, bar, etc)
    var DatasetController = function(chart, datasetIndex) {
        this.initialize(chart, datasetIndex);
    };
    helpers$1.extend(DatasetController.prototype, {
        /**
	 * Element type used to generate a meta dataset (e.g. Chart.element.Line).
	 * @type {Chart.core.element}
	 */ datasetElementType: null,
        /**
	 * Element type used to generate a meta data (e.g. Chart.element.Point).
	 * @type {Chart.core.element}
	 */ dataElementType: null,
        /**
	 * Dataset element option keys to be resolved in _resolveDatasetElementOptions.
	 * A derived controller may override this to resolve controller-specific options.
	 * The keys defined here are for backward compatibility for legend styles.
	 * @private
	 */ _datasetElementOptions: [
            "backgroundColor",
            "borderCapStyle",
            "borderColor",
            "borderDash",
            "borderDashOffset",
            "borderJoinStyle",
            "borderWidth"
        ],
        /**
	 * Data element option keys to be resolved in _resolveDataElementOptions.
	 * A derived controller may override this to resolve controller-specific options.
	 * The keys defined here are for backward compatibility for legend styles.
	 * @private
	 */ _dataElementOptions: [
            "backgroundColor",
            "borderColor",
            "borderWidth",
            "pointStyle"
        ],
        initialize: function(chart, datasetIndex) {
            var me = this;
            me.chart = chart;
            me.index = datasetIndex;
            me.linkScales();
            me.addElements();
            me._type = me.getMeta().type;
        },
        updateIndex: function(datasetIndex) {
            this.index = datasetIndex;
        },
        linkScales: function() {
            var me = this;
            var meta = me.getMeta();
            var chart = me.chart;
            var scales = chart.scales;
            var dataset = me.getDataset();
            var scalesOpts = chart.options.scales;
            if (meta.xAxisID === null || !(meta.xAxisID in scales) || dataset.xAxisID) meta.xAxisID = dataset.xAxisID || scalesOpts.xAxes[0].id;
            if (meta.yAxisID === null || !(meta.yAxisID in scales) || dataset.yAxisID) meta.yAxisID = dataset.yAxisID || scalesOpts.yAxes[0].id;
        },
        getDataset: function() {
            return this.chart.data.datasets[this.index];
        },
        getMeta: function() {
            return this.chart.getDatasetMeta(this.index);
        },
        getScaleForId: function(scaleID) {
            return this.chart.scales[scaleID];
        },
        /**
	 * @private
	 */ _getValueScaleId: function() {
            return this.getMeta().yAxisID;
        },
        /**
	 * @private
	 */ _getIndexScaleId: function() {
            return this.getMeta().xAxisID;
        },
        /**
	 * @private
	 */ _getValueScale: function() {
            return this.getScaleForId(this._getValueScaleId());
        },
        /**
	 * @private
	 */ _getIndexScale: function() {
            return this.getScaleForId(this._getIndexScaleId());
        },
        reset: function() {
            this._update(true);
        },
        /**
	 * @private
	 */ destroy: function() {
            if (this._data) unlistenArrayEvents(this._data, this);
        },
        createMetaDataset: function() {
            var me = this;
            var type = me.datasetElementType;
            return type && new type({
                _chart: me.chart,
                _datasetIndex: me.index
            });
        },
        createMetaData: function(index) {
            var me = this;
            var type = me.dataElementType;
            return type && new type({
                _chart: me.chart,
                _datasetIndex: me.index,
                _index: index
            });
        },
        addElements: function() {
            var me = this;
            var meta = me.getMeta();
            var data = me.getDataset().data || [];
            var metaData = meta.data;
            var i, ilen;
            for(i = 0, ilen = data.length; i < ilen; ++i)metaData[i] = metaData[i] || me.createMetaData(i);
            meta.dataset = meta.dataset || me.createMetaDataset();
        },
        addElementAndReset: function(index) {
            var element = this.createMetaData(index);
            this.getMeta().data.splice(index, 0, element);
            this.updateElement(element, index, true);
        },
        buildOrUpdateElements: function() {
            var me = this;
            var dataset = me.getDataset();
            var data = dataset.data || (dataset.data = []);
            // In order to correctly handle data addition/deletion animation (an thus simulate
            // real-time charts), we need to monitor these data modifications and synchronize
            // the internal meta data accordingly.
            if (me._data !== data) {
                if (me._data) // This case happens when the user replaced the data array instance.
                unlistenArrayEvents(me._data, me);
                if (data && Object.isExtensible(data)) listenArrayEvents(data, me);
                me._data = data;
            }
            // Re-sync meta data in case the user replaced the data array or if we missed
            // any updates and so make sure that we handle number of datapoints changing.
            me.resyncElements();
        },
        /**
	 * Returns the merged user-supplied and default dataset-level options
	 * @private
	 */ _configure: function() {
            var me = this;
            me._config = helpers$1.merge(Object.create(null), [
                me.chart.options.datasets[me._type],
                me.getDataset()
            ], {
                merger: function(key, target, source) {
                    if (key !== "_meta" && key !== "data") helpers$1._merger(key, target, source);
                }
            });
        },
        _update: function(reset) {
            var me = this;
            me._configure();
            me._cachedDataOpts = null;
            me.update(reset);
        },
        update: helpers$1.noop,
        transition: function(easingValue) {
            var meta = this.getMeta();
            var elements = meta.data || [];
            var ilen = elements.length;
            var i = 0;
            for(; i < ilen; ++i)elements[i].transition(easingValue);
            if (meta.dataset) meta.dataset.transition(easingValue);
        },
        draw: function() {
            var meta = this.getMeta();
            var elements = meta.data || [];
            var ilen = elements.length;
            var i = 0;
            if (meta.dataset) meta.dataset.draw();
            for(; i < ilen; ++i)elements[i].draw();
        },
        /**
	 * Returns a set of predefined style properties that should be used to represent the dataset
	 * or the data if the index is specified
	 * @param {number} index - data index
	 * @return {IStyleInterface} style object
	 */ getStyle: function(index) {
            var me = this;
            var meta = me.getMeta();
            var dataset = meta.dataset;
            var style;
            me._configure();
            if (dataset && index === undefined) style = me._resolveDatasetElementOptions(dataset || {});
            else {
                index = index || 0;
                style = me._resolveDataElementOptions(meta.data[index] || {}, index);
            }
            if (style.fill === false || style.fill === null) style.backgroundColor = style.borderColor;
            return style;
        },
        /**
	 * @private
	 */ _resolveDatasetElementOptions: function(element, hover) {
            var me = this;
            var chart = me.chart;
            var datasetOpts = me._config;
            var custom = element.custom || {};
            var options = chart.options.elements[me.datasetElementType.prototype._type] || {};
            var elementOptions = me._datasetElementOptions;
            var values = {};
            var i, ilen, key, readKey;
            // Scriptable options
            var context = {
                chart: chart,
                dataset: me.getDataset(),
                datasetIndex: me.index,
                hover: hover
            };
            for(i = 0, ilen = elementOptions.length; i < ilen; ++i){
                key = elementOptions[i];
                readKey = hover ? "hover" + key.charAt(0).toUpperCase() + key.slice(1) : key;
                values[key] = resolve([
                    custom[readKey],
                    datasetOpts[readKey],
                    options[readKey]
                ], context);
            }
            return values;
        },
        /**
	 * @private
	 */ _resolveDataElementOptions: function(element, index) {
            var me = this;
            var custom = element && element.custom;
            var cached = me._cachedDataOpts;
            if (cached && !custom) return cached;
            var chart = me.chart;
            var datasetOpts = me._config;
            var options = chart.options.elements[me.dataElementType.prototype._type] || {};
            var elementOptions = me._dataElementOptions;
            var values = {};
            // Scriptable options
            var context = {
                chart: chart,
                dataIndex: index,
                dataset: me.getDataset(),
                datasetIndex: me.index
            };
            // `resolve` sets cacheable to `false` if any option is indexed or scripted
            var info = {
                cacheable: !custom
            };
            var keys, i, ilen, key;
            custom = custom || {};
            if (helpers$1.isArray(elementOptions)) for(i = 0, ilen = elementOptions.length; i < ilen; ++i){
                key = elementOptions[i];
                values[key] = resolve([
                    custom[key],
                    datasetOpts[key],
                    options[key]
                ], context, index, info);
            }
            else {
                keys = Object.keys(elementOptions);
                for(i = 0, ilen = keys.length; i < ilen; ++i){
                    key = keys[i];
                    values[key] = resolve([
                        custom[key],
                        datasetOpts[elementOptions[key]],
                        datasetOpts[key],
                        options[key]
                    ], context, index, info);
                }
            }
            if (info.cacheable) me._cachedDataOpts = Object.freeze(values);
            return values;
        },
        removeHoverStyle: function(element) {
            helpers$1.merge(element._model, element.$previousStyle || {});
            delete element.$previousStyle;
        },
        setHoverStyle: function(element) {
            var dataset = this.chart.data.datasets[element._datasetIndex];
            var index = element._index;
            var custom = element.custom || {};
            var model = element._model;
            var getHoverColor = helpers$1.getHoverColor;
            element.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth
            };
            model.backgroundColor = resolve([
                custom.hoverBackgroundColor,
                dataset.hoverBackgroundColor,
                getHoverColor(model.backgroundColor)
            ], undefined, index);
            model.borderColor = resolve([
                custom.hoverBorderColor,
                dataset.hoverBorderColor,
                getHoverColor(model.borderColor)
            ], undefined, index);
            model.borderWidth = resolve([
                custom.hoverBorderWidth,
                dataset.hoverBorderWidth,
                model.borderWidth
            ], undefined, index);
        },
        /**
	 * @private
	 */ _removeDatasetHoverStyle: function() {
            var element = this.getMeta().dataset;
            if (element) this.removeHoverStyle(element);
        },
        /**
	 * @private
	 */ _setDatasetHoverStyle: function() {
            var element = this.getMeta().dataset;
            var prev = {};
            var i, ilen, key, keys, hoverOptions, model;
            if (!element) return;
            model = element._model;
            hoverOptions = this._resolveDatasetElementOptions(element, true);
            keys = Object.keys(hoverOptions);
            for(i = 0, ilen = keys.length; i < ilen; ++i){
                key = keys[i];
                prev[key] = model[key];
                model[key] = hoverOptions[key];
            }
            element.$previousStyle = prev;
        },
        /**
	 * @private
	 */ resyncElements: function() {
            var me = this;
            var meta = me.getMeta();
            var data = me.getDataset().data;
            var numMeta = meta.data.length;
            var numData = data.length;
            if (numData < numMeta) meta.data.splice(numData, numMeta - numData);
            else if (numData > numMeta) me.insertElements(numMeta, numData - numMeta);
        },
        /**
	 * @private
	 */ insertElements: function(start, count) {
            for(var i = 0; i < count; ++i)this.addElementAndReset(start + i);
        },
        /**
	 * @private
	 */ onDataPush: function() {
            var count = arguments.length;
            this.insertElements(this.getDataset().data.length - count, count);
        },
        /**
	 * @private
	 */ onDataPop: function() {
            this.getMeta().data.pop();
        },
        /**
	 * @private
	 */ onDataShift: function() {
            this.getMeta().data.shift();
        },
        /**
	 * @private
	 */ onDataSplice: function(start, count) {
            this.getMeta().data.splice(start, count);
            this.insertElements(start, arguments.length - 2);
        },
        /**
	 * @private
	 */ onDataUnshift: function() {
            this.insertElements(0, arguments.length);
        }
    });
    DatasetController.extend = helpers$1.inherits;
    var core_datasetController = DatasetController;
    var TAU = Math.PI * 2;
    core_defaults._set("global", {
        elements: {
            arc: {
                backgroundColor: core_defaults.global.defaultColor,
                borderColor: "#fff",
                borderWidth: 2,
                borderAlign: "center"
            }
        }
    });
    function clipArc(ctx, arc) {
        var startAngle = arc.startAngle;
        var endAngle = arc.endAngle;
        var pixelMargin = arc.pixelMargin;
        var angleMargin = pixelMargin / arc.outerRadius;
        var x = arc.x;
        var y = arc.y;
        // Draw an inner border by cliping the arc and drawing a double-width border
        // Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
        ctx.beginPath();
        ctx.arc(x, y, arc.outerRadius, startAngle - angleMargin, endAngle + angleMargin);
        if (arc.innerRadius > pixelMargin) {
            angleMargin = pixelMargin / arc.innerRadius;
            ctx.arc(x, y, arc.innerRadius - pixelMargin, endAngle + angleMargin, startAngle - angleMargin, true);
        } else ctx.arc(x, y, pixelMargin, endAngle + Math.PI / 2, startAngle - Math.PI / 2);
        ctx.closePath();
        ctx.clip();
    }
    function drawFullCircleBorders(ctx, vm, arc, inner) {
        var endAngle = arc.endAngle;
        var i;
        if (inner) {
            arc.endAngle = arc.startAngle + TAU;
            clipArc(ctx, arc);
            arc.endAngle = endAngle;
            if (arc.endAngle === arc.startAngle && arc.fullCircles) {
                arc.endAngle += TAU;
                arc.fullCircles--;
            }
        }
        ctx.beginPath();
        ctx.arc(arc.x, arc.y, arc.innerRadius, arc.startAngle + TAU, arc.startAngle, true);
        for(i = 0; i < arc.fullCircles; ++i)ctx.stroke();
        ctx.beginPath();
        ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.startAngle + TAU);
        for(i = 0; i < arc.fullCircles; ++i)ctx.stroke();
    }
    function drawBorder(ctx, vm, arc) {
        var inner = vm.borderAlign === "inner";
        if (inner) {
            ctx.lineWidth = vm.borderWidth * 2;
            ctx.lineJoin = "round";
        } else {
            ctx.lineWidth = vm.borderWidth;
            ctx.lineJoin = "bevel";
        }
        if (arc.fullCircles) drawFullCircleBorders(ctx, vm, arc, inner);
        if (inner) clipArc(ctx, arc);
        ctx.beginPath();
        ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.endAngle);
        ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
        ctx.closePath();
        ctx.stroke();
    }
    var element_arc = core_element.extend({
        _type: "arc",
        inLabelRange: function(mouseX) {
            var vm = this._view;
            if (vm) return Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2);
            return false;
        },
        inRange: function(chartX, chartY) {
            var vm = this._view;
            if (vm) {
                var pointRelativePosition = helpers$1.getAngleFromPoint(vm, {
                    x: chartX,
                    y: chartY
                });
                var angle = pointRelativePosition.angle;
                var distance = pointRelativePosition.distance;
                // Sanitise angle range
                var startAngle = vm.startAngle;
                var endAngle = vm.endAngle;
                while(endAngle < startAngle)endAngle += TAU;
                while(angle > endAngle)angle -= TAU;
                while(angle < startAngle)angle += TAU;
                // Check if within the range of the open/close angle
                var betweenAngles = angle >= startAngle && angle <= endAngle;
                var withinRadius = distance >= vm.innerRadius && distance <= vm.outerRadius;
                return betweenAngles && withinRadius;
            }
            return false;
        },
        getCenterPoint: function() {
            var vm = this._view;
            var halfAngle = (vm.startAngle + vm.endAngle) / 2;
            var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
            return {
                x: vm.x + Math.cos(halfAngle) * halfRadius,
                y: vm.y + Math.sin(halfAngle) * halfRadius
            };
        },
        getArea: function() {
            var vm = this._view;
            return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
        },
        tooltipPosition: function() {
            var vm = this._view;
            var centreAngle = vm.startAngle + (vm.endAngle - vm.startAngle) / 2;
            var rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;
            return {
                x: vm.x + Math.cos(centreAngle) * rangeFromCentre,
                y: vm.y + Math.sin(centreAngle) * rangeFromCentre
            };
        },
        draw: function() {
            var ctx = this._chart.ctx;
            var vm = this._view;
            var pixelMargin = vm.borderAlign === "inner" ? 0.33 : 0;
            var arc = {
                x: vm.x,
                y: vm.y,
                innerRadius: vm.innerRadius,
                outerRadius: Math.max(vm.outerRadius - pixelMargin, 0),
                pixelMargin: pixelMargin,
                startAngle: vm.startAngle,
                endAngle: vm.endAngle,
                fullCircles: Math.floor(vm.circumference / TAU)
            };
            var i;
            ctx.save();
            ctx.fillStyle = vm.backgroundColor;
            ctx.strokeStyle = vm.borderColor;
            if (arc.fullCircles) {
                arc.endAngle = arc.startAngle + TAU;
                ctx.beginPath();
                ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
                ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
                ctx.closePath();
                for(i = 0; i < arc.fullCircles; ++i)ctx.fill();
                arc.endAngle = arc.startAngle + vm.circumference % TAU;
            }
            ctx.beginPath();
            ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
            ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
            ctx.closePath();
            ctx.fill();
            if (vm.borderWidth) drawBorder(ctx, vm, arc);
            ctx.restore();
        }
    });
    var valueOrDefault$1 = helpers$1.valueOrDefault;
    var defaultColor = core_defaults.global.defaultColor;
    core_defaults._set("global", {
        elements: {
            line: {
                tension: 0.4,
                backgroundColor: defaultColor,
                borderWidth: 3,
                borderColor: defaultColor,
                borderCapStyle: "butt",
                borderDash: [],
                borderDashOffset: 0.0,
                borderJoinStyle: "miter",
                capBezierPoints: true,
                fill: true
            }
        }
    });
    var element_line = core_element.extend({
        _type: "line",
        draw: function() {
            var me = this;
            var vm = me._view;
            var ctx = me._chart.ctx;
            var spanGaps = vm.spanGaps;
            var points = me._children.slice(); // clone array
            var globalDefaults = core_defaults.global;
            var globalOptionLineElements = globalDefaults.elements.line;
            var lastDrawnIndex = -1;
            var closePath = me._loop;
            var index, previous, currentVM;
            if (!points.length) return;
            if (me._loop) {
                for(index = 0; index < points.length; ++index){
                    previous = helpers$1.previousItem(points, index);
                    // If the line has an open path, shift the point array
                    if (!points[index]._view.skip && previous._view.skip) {
                        points = points.slice(index).concat(points.slice(0, index));
                        closePath = spanGaps;
                        break;
                    }
                }
                // If the line has a close path, add the first point again
                if (closePath) points.push(points[0]);
            }
            ctx.save();
            // Stroke Line Options
            ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;
            // IE 9 and 10 do not support line dash
            if (ctx.setLineDash) ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
            ctx.lineDashOffset = valueOrDefault$1(vm.borderDashOffset, globalOptionLineElements.borderDashOffset);
            ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
            ctx.lineWidth = valueOrDefault$1(vm.borderWidth, globalOptionLineElements.borderWidth);
            ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;
            // Stroke Line
            ctx.beginPath();
            // First point moves to it's starting position no matter what
            currentVM = points[0]._view;
            if (!currentVM.skip) {
                ctx.moveTo(currentVM.x, currentVM.y);
                lastDrawnIndex = 0;
            }
            for(index = 1; index < points.length; ++index){
                currentVM = points[index]._view;
                previous = lastDrawnIndex === -1 ? helpers$1.previousItem(points, index) : points[lastDrawnIndex];
                if (!currentVM.skip) {
                    if (lastDrawnIndex !== index - 1 && !spanGaps || lastDrawnIndex === -1) // There was a gap and this is the first point after the gap
                    ctx.moveTo(currentVM.x, currentVM.y);
                    else // Line to next point
                    helpers$1.canvas.lineTo(ctx, previous._view, currentVM);
                    lastDrawnIndex = index;
                }
            }
            if (closePath) ctx.closePath();
            ctx.stroke();
            ctx.restore();
        }
    });
    var valueOrDefault$2 = helpers$1.valueOrDefault;
    var defaultColor$1 = core_defaults.global.defaultColor;
    core_defaults._set("global", {
        elements: {
            point: {
                radius: 3,
                pointStyle: "circle",
                backgroundColor: defaultColor$1,
                borderColor: defaultColor$1,
                borderWidth: 1,
                // Hover
                hitRadius: 1,
                hoverRadius: 4,
                hoverBorderWidth: 1
            }
        }
    });
    function xRange(mouseX) {
        var vm = this._view;
        return vm ? Math.abs(mouseX - vm.x) < vm.radius + vm.hitRadius : false;
    }
    function yRange(mouseY) {
        var vm = this._view;
        return vm ? Math.abs(mouseY - vm.y) < vm.radius + vm.hitRadius : false;
    }
    var element_point = core_element.extend({
        _type: "point",
        inRange: function(mouseX, mouseY) {
            var vm = this._view;
            return vm ? Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2) < Math.pow(vm.hitRadius + vm.radius, 2) : false;
        },
        inLabelRange: xRange,
        inXRange: xRange,
        inYRange: yRange,
        getCenterPoint: function() {
            var vm = this._view;
            return {
                x: vm.x,
                y: vm.y
            };
        },
        getArea: function() {
            return Math.PI * Math.pow(this._view.radius, 2);
        },
        tooltipPosition: function() {
            var vm = this._view;
            return {
                x: vm.x,
                y: vm.y,
                padding: vm.radius + vm.borderWidth
            };
        },
        draw: function(chartArea) {
            var vm = this._view;
            var ctx = this._chart.ctx;
            var pointStyle = vm.pointStyle;
            var rotation = vm.rotation;
            var radius = vm.radius;
            var x = vm.x;
            var y = vm.y;
            var globalDefaults = core_defaults.global;
            var defaultColor = globalDefaults.defaultColor; // eslint-disable-line no-shadow
            if (vm.skip) return;
            // Clipping for Points.
            if (chartArea === undefined || helpers$1.canvas._isPointInArea(vm, chartArea)) {
                ctx.strokeStyle = vm.borderColor || defaultColor;
                ctx.lineWidth = valueOrDefault$2(vm.borderWidth, globalDefaults.elements.point.borderWidth);
                ctx.fillStyle = vm.backgroundColor || defaultColor;
                helpers$1.canvas.drawPoint(ctx, pointStyle, radius, x, y, rotation);
            }
        }
    });
    var defaultColor$2 = core_defaults.global.defaultColor;
    core_defaults._set("global", {
        elements: {
            rectangle: {
                backgroundColor: defaultColor$2,
                borderColor: defaultColor$2,
                borderSkipped: "bottom",
                borderWidth: 0
            }
        }
    });
    function isVertical(vm) {
        return vm && vm.width !== undefined;
    }
    /**
 * Helper function to get the bounds of the bar regardless of the orientation
 * @param bar {Chart.Element.Rectangle} the bar
 * @return {Bounds} bounds of the bar
 * @private
 */ function getBarBounds(vm) {
        var x1, x2, y1, y2, half;
        if (isVertical(vm)) {
            half = vm.width / 2;
            x1 = vm.x - half;
            x2 = vm.x + half;
            y1 = Math.min(vm.y, vm.base);
            y2 = Math.max(vm.y, vm.base);
        } else {
            half = vm.height / 2;
            x1 = Math.min(vm.x, vm.base);
            x2 = Math.max(vm.x, vm.base);
            y1 = vm.y - half;
            y2 = vm.y + half;
        }
        return {
            left: x1,
            top: y1,
            right: x2,
            bottom: y2
        };
    }
    function swap(orig, v1, v2) {
        return orig === v1 ? v2 : orig === v2 ? v1 : orig;
    }
    function parseBorderSkipped(vm) {
        var edge = vm.borderSkipped;
        var res = {};
        if (!edge) return res;
        if (vm.horizontal) {
            if (vm.base > vm.x) edge = swap(edge, "left", "right");
        } else if (vm.base < vm.y) edge = swap(edge, "bottom", "top");
        res[edge] = true;
        return res;
    }
    function parseBorderWidth(vm, maxW, maxH) {
        var value = vm.borderWidth;
        var skip = parseBorderSkipped(vm);
        var t, r, b, l;
        if (helpers$1.isObject(value)) {
            t = +value.top || 0;
            r = +value.right || 0;
            b = +value.bottom || 0;
            l = +value.left || 0;
        } else t = r = b = l = +value || 0;
        return {
            t: skip.top || t < 0 ? 0 : t > maxH ? maxH : t,
            r: skip.right || r < 0 ? 0 : r > maxW ? maxW : r,
            b: skip.bottom || b < 0 ? 0 : b > maxH ? maxH : b,
            l: skip.left || l < 0 ? 0 : l > maxW ? maxW : l
        };
    }
    function boundingRects(vm) {
        var bounds = getBarBounds(vm);
        var width = bounds.right - bounds.left;
        var height = bounds.bottom - bounds.top;
        var border = parseBorderWidth(vm, width / 2, height / 2);
        return {
            outer: {
                x: bounds.left,
                y: bounds.top,
                w: width,
                h: height
            },
            inner: {
                x: bounds.left + border.l,
                y: bounds.top + border.t,
                w: width - border.l - border.r,
                h: height - border.t - border.b
            }
        };
    }
    function inRange(vm, x, y) {
        var skipX = x === null;
        var skipY = y === null;
        var bounds = !vm || skipX && skipY ? false : getBarBounds(vm);
        return bounds && (skipX || x >= bounds.left && x <= bounds.right) && (skipY || y >= bounds.top && y <= bounds.bottom);
    }
    var element_rectangle = core_element.extend({
        _type: "rectangle",
        draw: function() {
            var ctx = this._chart.ctx;
            var vm = this._view;
            var rects = boundingRects(vm);
            var outer = rects.outer;
            var inner = rects.inner;
            ctx.fillStyle = vm.backgroundColor;
            ctx.fillRect(outer.x, outer.y, outer.w, outer.h);
            if (outer.w === inner.w && outer.h === inner.h) return;
            ctx.save();
            ctx.beginPath();
            ctx.rect(outer.x, outer.y, outer.w, outer.h);
            ctx.clip();
            ctx.fillStyle = vm.borderColor;
            ctx.rect(inner.x, inner.y, inner.w, inner.h);
            ctx.fill("evenodd");
            ctx.restore();
        },
        height: function() {
            var vm = this._view;
            return vm.base - vm.y;
        },
        inRange: function(mouseX, mouseY) {
            return inRange(this._view, mouseX, mouseY);
        },
        inLabelRange: function(mouseX, mouseY) {
            var vm = this._view;
            return isVertical(vm) ? inRange(vm, mouseX, null) : inRange(vm, null, mouseY);
        },
        inXRange: function(mouseX) {
            return inRange(this._view, mouseX, null);
        },
        inYRange: function(mouseY) {
            return inRange(this._view, null, mouseY);
        },
        getCenterPoint: function() {
            var vm = this._view;
            var x, y;
            if (isVertical(vm)) {
                x = vm.x;
                y = (vm.y + vm.base) / 2;
            } else {
                x = (vm.x + vm.base) / 2;
                y = vm.y;
            }
            return {
                x: x,
                y: y
            };
        },
        getArea: function() {
            var vm = this._view;
            return isVertical(vm) ? vm.width * Math.abs(vm.y - vm.base) : vm.height * Math.abs(vm.x - vm.base);
        },
        tooltipPosition: function() {
            var vm = this._view;
            return {
                x: vm.x,
                y: vm.y
            };
        }
    });
    var elements = {};
    var Arc = element_arc;
    var Line = element_line;
    var Point = element_point;
    var Rectangle = element_rectangle;
    elements.Arc = Arc;
    elements.Line = Line;
    elements.Point = Point;
    elements.Rectangle = Rectangle;
    var deprecated = helpers$1._deprecated;
    var valueOrDefault$3 = helpers$1.valueOrDefault;
    core_defaults._set("bar", {
        hover: {
            mode: "label"
        },
        scales: {
            xAxes: [
                {
                    type: "category",
                    offset: true,
                    gridLines: {
                        offsetGridLines: true
                    }
                }
            ],
            yAxes: [
                {
                    type: "linear"
                }
            ]
        }
    });
    core_defaults._set("global", {
        datasets: {
            bar: {
                categoryPercentage: 0.8,
                barPercentage: 0.9
            }
        }
    });
    /**
 * Computes the "optimal" sample size to maintain bars equally sized while preventing overlap.
 * @private
 */ function computeMinSampleSize(scale, pixels) {
        var min = scale._length;
        var prev, curr, i, ilen;
        for(i = 1, ilen = pixels.length; i < ilen; ++i)min = Math.min(min, Math.abs(pixels[i] - pixels[i - 1]));
        for(i = 0, ilen = scale.getTicks().length; i < ilen; ++i){
            curr = scale.getPixelForTick(i);
            min = i > 0 ? Math.min(min, Math.abs(curr - prev)) : min;
            prev = curr;
        }
        return min;
    }
    /**
 * Computes an "ideal" category based on the absolute bar thickness or, if undefined or null,
 * uses the smallest interval (see computeMinSampleSize) that prevents bar overlapping. This
 * mode currently always generates bars equally sized (until we introduce scriptable options?).
 * @private
 */ function computeFitCategoryTraits(index, ruler, options) {
        var thickness = options.barThickness;
        var count = ruler.stackCount;
        var curr = ruler.pixels[index];
        var min = helpers$1.isNullOrUndef(thickness) ? computeMinSampleSize(ruler.scale, ruler.pixels) : -1;
        var size, ratio;
        if (helpers$1.isNullOrUndef(thickness)) {
            size = min * options.categoryPercentage;
            ratio = options.barPercentage;
        } else {
            // When bar thickness is enforced, category and bar percentages are ignored.
            // Note(SB): we could add support for relative bar thickness (e.g. barThickness: '50%')
            // and deprecate barPercentage since this value is ignored when thickness is absolute.
            size = thickness * count;
            ratio = 1;
        }
        return {
            chunk: size / count,
            ratio: ratio,
            start: curr - size / 2
        };
    }
    /**
 * Computes an "optimal" category that globally arranges bars side by side (no gap when
 * percentage options are 1), based on the previous and following categories. This mode
 * generates bars with different widths when data are not evenly spaced.
 * @private
 */ function computeFlexCategoryTraits(index, ruler, options) {
        var pixels = ruler.pixels;
        var curr = pixels[index];
        var prev = index > 0 ? pixels[index - 1] : null;
        var next = index < pixels.length - 1 ? pixels[index + 1] : null;
        var percent = options.categoryPercentage;
        var start, size;
        if (prev === null) // first data: its size is double based on the next point or,
        // if it's also the last data, we use the scale size.
        prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
        if (next === null) // last data: its size is also double based on the previous point.
        next = curr + curr - prev;
        start = curr - (curr - Math.min(prev, next)) / 2 * percent;
        size = Math.abs(next - prev) / 2 * percent;
        return {
            chunk: size / ruler.stackCount,
            ratio: options.barPercentage,
            start: start
        };
    }
    var controller_bar = core_datasetController.extend({
        dataElementType: elements.Rectangle,
        /**
	 * @private
	 */ _dataElementOptions: [
            "backgroundColor",
            "borderColor",
            "borderSkipped",
            "borderWidth",
            "barPercentage",
            "barThickness",
            "categoryPercentage",
            "maxBarThickness",
            "minBarLength"
        ],
        initialize: function() {
            var me = this;
            var meta, scaleOpts;
            core_datasetController.prototype.initialize.apply(me, arguments);
            meta = me.getMeta();
            meta.stack = me.getDataset().stack;
            meta.bar = true;
            scaleOpts = me._getIndexScale().options;
            deprecated("bar chart", scaleOpts.barPercentage, "scales.[x/y]Axes.barPercentage", "dataset.barPercentage");
            deprecated("bar chart", scaleOpts.barThickness, "scales.[x/y]Axes.barThickness", "dataset.barThickness");
            deprecated("bar chart", scaleOpts.categoryPercentage, "scales.[x/y]Axes.categoryPercentage", "dataset.categoryPercentage");
            deprecated("bar chart", me._getValueScale().options.minBarLength, "scales.[x/y]Axes.minBarLength", "dataset.minBarLength");
            deprecated("bar chart", scaleOpts.maxBarThickness, "scales.[x/y]Axes.maxBarThickness", "dataset.maxBarThickness");
        },
        update: function(reset) {
            var me = this;
            var rects = me.getMeta().data;
            var i, ilen;
            me._ruler = me.getRuler();
            for(i = 0, ilen = rects.length; i < ilen; ++i)me.updateElement(rects[i], i, reset);
        },
        updateElement: function(rectangle, index, reset) {
            var me = this;
            var meta = me.getMeta();
            var dataset = me.getDataset();
            var options = me._resolveDataElementOptions(rectangle, index);
            rectangle._xScale = me.getScaleForId(meta.xAxisID);
            rectangle._yScale = me.getScaleForId(meta.yAxisID);
            rectangle._datasetIndex = me.index;
            rectangle._index = index;
            rectangle._model = {
                backgroundColor: options.backgroundColor,
                borderColor: options.borderColor,
                borderSkipped: options.borderSkipped,
                borderWidth: options.borderWidth,
                datasetLabel: dataset.label,
                label: me.chart.data.labels[index]
            };
            if (helpers$1.isArray(dataset.data[index])) rectangle._model.borderSkipped = null;
            me._updateElementGeometry(rectangle, index, reset, options);
            rectangle.pivot();
        },
        /**
	 * @private
	 */ _updateElementGeometry: function(rectangle, index, reset, options) {
            var me = this;
            var model = rectangle._model;
            var vscale = me._getValueScale();
            var base = vscale.getBasePixel();
            var horizontal = vscale.isHorizontal();
            var ruler = me._ruler || me.getRuler();
            var vpixels = me.calculateBarValuePixels(me.index, index, options);
            var ipixels = me.calculateBarIndexPixels(me.index, index, ruler, options);
            model.horizontal = horizontal;
            model.base = reset ? base : vpixels.base;
            model.x = horizontal ? reset ? base : vpixels.head : ipixels.center;
            model.y = horizontal ? ipixels.center : reset ? base : vpixels.head;
            model.height = horizontal ? ipixels.size : undefined;
            model.width = horizontal ? undefined : ipixels.size;
        },
        /**
	 * Returns the stacks based on groups and bar visibility.
	 * @param {number} [last] - The dataset index
	 * @returns {string[]} The list of stack IDs
	 * @private
	 */ _getStacks: function(last) {
            var me = this;
            var scale = me._getIndexScale();
            var metasets = scale._getMatchingVisibleMetas(me._type);
            var stacked = scale.options.stacked;
            var ilen = metasets.length;
            var stacks = [];
            var i, meta;
            for(i = 0; i < ilen; ++i){
                meta = metasets[i];
                // stacked   | meta.stack
                //           | found | not found | undefined
                // false     |   x   |     x     |     x
                // true      |       |     x     |
                // undefined |       |     x     |     x
                if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) stacks.push(meta.stack);
                if (meta.index === last) break;
            }
            return stacks;
        },
        /**
	 * Returns the effective number of stacks based on groups and bar visibility.
	 * @private
	 */ getStackCount: function() {
            return this._getStacks().length;
        },
        /**
	 * Returns the stack index for the given dataset based on groups and bar visibility.
	 * @param {number} [datasetIndex] - The dataset index
	 * @param {string} [name] - The stack name to find
	 * @returns {number} The stack index
	 * @private
	 */ getStackIndex: function(datasetIndex, name) {
            var stacks = this._getStacks(datasetIndex);
            var index = name !== undefined ? stacks.indexOf(name) : -1; // indexOf returns -1 if element is not present
            return index === -1 ? stacks.length - 1 : index;
        },
        /**
	 * @private
	 */ getRuler: function() {
            var me = this;
            var scale = me._getIndexScale();
            var pixels = [];
            var i, ilen;
            for(i = 0, ilen = me.getMeta().data.length; i < ilen; ++i)pixels.push(scale.getPixelForValue(null, i, me.index));
            return {
                pixels: pixels,
                start: scale._startPixel,
                end: scale._endPixel,
                stackCount: me.getStackCount(),
                scale: scale
            };
        },
        /**
	 * Note: pixel values are not clamped to the scale area.
	 * @private
	 */ calculateBarValuePixels: function(datasetIndex, index, options) {
            var me = this;
            var chart = me.chart;
            var scale = me._getValueScale();
            var isHorizontal = scale.isHorizontal();
            var datasets = chart.data.datasets;
            var metasets = scale._getMatchingVisibleMetas(me._type);
            var value = scale._parseValue(datasets[datasetIndex].data[index]);
            var minBarLength = options.minBarLength;
            var stacked = scale.options.stacked;
            var stack = me.getMeta().stack;
            var start = value.start === undefined ? 0 : value.max >= 0 && value.min >= 0 ? value.min : value.max;
            var length = value.start === undefined ? value.end : value.max >= 0 && value.min >= 0 ? value.max - value.min : value.min - value.max;
            var ilen = metasets.length;
            var i, imeta, ivalue, base, head, size, stackLength;
            if (stacked || stacked === undefined && stack !== undefined) for(i = 0; i < ilen; ++i){
                imeta = metasets[i];
                if (imeta.index === datasetIndex) break;
                if (imeta.stack === stack) {
                    stackLength = scale._parseValue(datasets[imeta.index].data[index]);
                    ivalue = stackLength.start === undefined ? stackLength.end : stackLength.min >= 0 && stackLength.max >= 0 ? stackLength.max : stackLength.min;
                    if (value.min < 0 && ivalue < 0 || value.max >= 0 && ivalue > 0) start += ivalue;
                }
            }
            base = scale.getPixelForValue(start);
            head = scale.getPixelForValue(start + length);
            size = head - base;
            if (minBarLength !== undefined && Math.abs(size) < minBarLength) {
                size = minBarLength;
                if (length >= 0 && !isHorizontal || length < 0 && isHorizontal) head = base - minBarLength;
                else head = base + minBarLength;
            }
            return {
                size: size,
                base: base,
                head: head,
                center: head + size / 2
            };
        },
        /**
	 * @private
	 */ calculateBarIndexPixels: function(datasetIndex, index, ruler, options) {
            var me = this;
            var range = options.barThickness === "flex" ? computeFlexCategoryTraits(index, ruler, options) : computeFitCategoryTraits(index, ruler, options);
            var stackIndex = me.getStackIndex(datasetIndex, me.getMeta().stack);
            var center = range.start + range.chunk * stackIndex + range.chunk / 2;
            var size = Math.min(valueOrDefault$3(options.maxBarThickness, Infinity), range.chunk * range.ratio);
            return {
                base: center - size / 2,
                head: center + size / 2,
                center: center,
                size: size
            };
        },
        draw: function() {
            var me = this;
            var chart = me.chart;
            var scale = me._getValueScale();
            var rects = me.getMeta().data;
            var dataset = me.getDataset();
            var ilen = rects.length;
            var i = 0;
            helpers$1.canvas.clipArea(chart.ctx, chart.chartArea);
            for(; i < ilen; ++i){
                var val = scale._parseValue(dataset.data[i]);
                if (!isNaN(val.min) && !isNaN(val.max)) rects[i].draw();
            }
            helpers$1.canvas.unclipArea(chart.ctx);
        },
        /**
	 * @private
	 */ _resolveDataElementOptions: function() {
            var me = this;
            var values = helpers$1.extend({}, core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments));
            var indexOpts = me._getIndexScale().options;
            var valueOpts = me._getValueScale().options;
            values.barPercentage = valueOrDefault$3(indexOpts.barPercentage, values.barPercentage);
            values.barThickness = valueOrDefault$3(indexOpts.barThickness, values.barThickness);
            values.categoryPercentage = valueOrDefault$3(indexOpts.categoryPercentage, values.categoryPercentage);
            values.maxBarThickness = valueOrDefault$3(indexOpts.maxBarThickness, values.maxBarThickness);
            values.minBarLength = valueOrDefault$3(valueOpts.minBarLength, values.minBarLength);
            return values;
        }
    });
    var valueOrDefault$4 = helpers$1.valueOrDefault;
    var resolve$1 = helpers$1.options.resolve;
    core_defaults._set("bubble", {
        hover: {
            mode: "single"
        },
        scales: {
            xAxes: [
                {
                    type: "linear",
                    position: "bottom",
                    id: "x-axis-0" // need an ID so datasets can reference the scale
                }
            ],
            yAxes: [
                {
                    type: "linear",
                    position: "left",
                    id: "y-axis-0"
                }
            ]
        },
        tooltips: {
            callbacks: {
                title: function() {
                    // Title doesn't make sense for scatter since we format the data as a point
                    return "";
                },
                label: function(item, data) {
                    var datasetLabel = data.datasets[item.datasetIndex].label || "";
                    var dataPoint = data.datasets[item.datasetIndex].data[item.index];
                    return datasetLabel + ": (" + item.xLabel + ", " + item.yLabel + ", " + dataPoint.r + ")";
                }
            }
        }
    });
    var controller_bubble = core_datasetController.extend({
        /**
	 * @protected
	 */ dataElementType: elements.Point,
        /**
	 * @private
	 */ _dataElementOptions: [
            "backgroundColor",
            "borderColor",
            "borderWidth",
            "hoverBackgroundColor",
            "hoverBorderColor",
            "hoverBorderWidth",
            "hoverRadius",
            "hitRadius",
            "pointStyle",
            "rotation"
        ],
        /**
	 * @protected
	 */ update: function(reset) {
            var me = this;
            var meta = me.getMeta();
            var points = meta.data;
            // Update Points
            helpers$1.each(points, function(point, index) {
                me.updateElement(point, index, reset);
            });
        },
        /**
	 * @protected
	 */ updateElement: function(point, index, reset) {
            var me = this;
            var meta = me.getMeta();
            var custom = point.custom || {};
            var xScale = me.getScaleForId(meta.xAxisID);
            var yScale = me.getScaleForId(meta.yAxisID);
            var options = me._resolveDataElementOptions(point, index);
            var data = me.getDataset().data[index];
            var dsIndex = me.index;
            var x = reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === "object" ? data : NaN, index, dsIndex);
            var y = reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex);
            point._xScale = xScale;
            point._yScale = yScale;
            point._options = options;
            point._datasetIndex = dsIndex;
            point._index = index;
            point._model = {
                backgroundColor: options.backgroundColor,
                borderColor: options.borderColor,
                borderWidth: options.borderWidth,
                hitRadius: options.hitRadius,
                pointStyle: options.pointStyle,
                rotation: options.rotation,
                radius: reset ? 0 : options.radius,
                skip: custom.skip || isNaN(x) || isNaN(y),
                x: x,
                y: y
            };
            point.pivot();
        },
        /**
	 * @protected
	 */ setHoverStyle: function(point) {
            var model = point._model;
            var options = point._options;
            var getHoverColor = helpers$1.getHoverColor;
            point.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth,
                radius: model.radius
            };
            model.backgroundColor = valueOrDefault$4(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
            model.borderColor = valueOrDefault$4(options.hoverBorderColor, getHoverColor(options.borderColor));
            model.borderWidth = valueOrDefault$4(options.hoverBorderWidth, options.borderWidth);
            model.radius = options.radius + options.hoverRadius;
        },
        /**
	 * @private
	 */ _resolveDataElementOptions: function(point, index) {
            var me = this;
            var chart = me.chart;
            var dataset = me.getDataset();
            var custom = point.custom || {};
            var data = dataset.data[index] || {};
            var values = core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments);
            // Scriptable options
            var context = {
                chart: chart,
                dataIndex: index,
                dataset: dataset,
                datasetIndex: me.index
            };
            // In case values were cached (and thus frozen), we need to clone the values
            if (me._cachedDataOpts === values) values = helpers$1.extend({}, values);
            // Custom radius resolution
            values.radius = resolve$1([
                custom.radius,
                data.r,
                me._config.radius,
                chart.options.elements.point.radius
            ], context, index);
            return values;
        }
    });
    var valueOrDefault$5 = helpers$1.valueOrDefault;
    var PI$1 = Math.PI;
    var DOUBLE_PI$1 = PI$1 * 2;
    var HALF_PI$1 = PI$1 / 2;
    core_defaults._set("doughnut", {
        animation: {
            // Boolean - Whether we animate the rotation of the Doughnut
            animateRotate: true,
            // Boolean - Whether we animate scaling the Doughnut from the centre
            animateScale: false
        },
        hover: {
            mode: "single"
        },
        legendCallback: function(chart) {
            var list = document.createElement("ul");
            var data = chart.data;
            var datasets = data.datasets;
            var labels = data.labels;
            var i, ilen, listItem, listItemSpan;
            list.setAttribute("class", chart.id + "-legend");
            if (datasets.length) for(i = 0, ilen = datasets[0].data.length; i < ilen; ++i){
                listItem = list.appendChild(document.createElement("li"));
                listItemSpan = listItem.appendChild(document.createElement("span"));
                listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
                if (labels[i]) listItem.appendChild(document.createTextNode(labels[i]));
            }
            return list.outerHTML;
        },
        legend: {
            labels: {
                generateLabels: function(chart) {
                    var data = chart.data;
                    if (data.labels.length && data.datasets.length) return data.labels.map(function(label, i) {
                        var meta = chart.getDatasetMeta(0);
                        var style = meta.controller.getStyle(i);
                        return {
                            text: label,
                            fillStyle: style.backgroundColor,
                            strokeStyle: style.borderColor,
                            lineWidth: style.borderWidth,
                            hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,
                            // Extra data used for toggling the correct item
                            index: i
                        };
                    });
                    return [];
                }
            },
            onClick: function(e, legendItem) {
                var index = legendItem.index;
                var chart = this.chart;
                var i, ilen, meta;
                for(i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i){
                    meta = chart.getDatasetMeta(i);
                    // toggle visibility of index if exists
                    if (meta.data[index]) meta.data[index].hidden = !meta.data[index].hidden;
                }
                chart.update();
            }
        },
        // The percentage of the chart that we cut out of the middle.
        cutoutPercentage: 50,
        // The rotation of the chart, where the first data arc begins.
        rotation: -HALF_PI$1,
        // The total circumference of the chart.
        circumference: DOUBLE_PI$1,
        // Need to override these to give a nice default
        tooltips: {
            callbacks: {
                title: function() {
                    return "";
                },
                label: function(tooltipItem, data) {
                    var dataLabel = data.labels[tooltipItem.index];
                    var value = ": " + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                    if (helpers$1.isArray(dataLabel)) {
                        // show value on first line of multiline label
                        // need to clone because we are changing the value
                        dataLabel = dataLabel.slice();
                        dataLabel[0] += value;
                    } else dataLabel += value;
                    return dataLabel;
                }
            }
        }
    });
    var controller_doughnut = core_datasetController.extend({
        dataElementType: elements.Arc,
        linkScales: helpers$1.noop,
        /**
	 * @private
	 */ _dataElementOptions: [
            "backgroundColor",
            "borderColor",
            "borderWidth",
            "borderAlign",
            "hoverBackgroundColor",
            "hoverBorderColor",
            "hoverBorderWidth"
        ],
        // Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
        getRingIndex: function(datasetIndex) {
            var ringIndex = 0;
            for(var j = 0; j < datasetIndex; ++j)if (this.chart.isDatasetVisible(j)) ++ringIndex;
            return ringIndex;
        },
        update: function(reset) {
            var me = this;
            var chart = me.chart;
            var chartArea = chart.chartArea;
            var opts = chart.options;
            var ratioX = 1;
            var ratioY = 1;
            var offsetX = 0;
            var offsetY = 0;
            var meta = me.getMeta();
            var arcs = meta.data;
            var cutout = opts.cutoutPercentage / 100 || 0;
            var circumference = opts.circumference;
            var chartWeight = me._getRingWeight(me.index);
            var maxWidth, maxHeight, i, ilen;
            // If the chart's circumference isn't a full circle, calculate size as a ratio of the width/height of the arc
            if (circumference < DOUBLE_PI$1) {
                var startAngle = opts.rotation % DOUBLE_PI$1;
                startAngle += startAngle >= PI$1 ? -DOUBLE_PI$1 : startAngle < -PI$1 ? DOUBLE_PI$1 : 0;
                var endAngle = startAngle + circumference;
                var startX = Math.cos(startAngle);
                var startY = Math.sin(startAngle);
                var endX = Math.cos(endAngle);
                var endY = Math.sin(endAngle);
                var contains0 = startAngle <= 0 && endAngle >= 0 || endAngle >= DOUBLE_PI$1;
                var contains90 = startAngle <= HALF_PI$1 && endAngle >= HALF_PI$1 || endAngle >= DOUBLE_PI$1 + HALF_PI$1;
                var contains180 = startAngle === -PI$1 || endAngle >= PI$1;
                var contains270 = startAngle <= -HALF_PI$1 && endAngle >= -HALF_PI$1 || endAngle >= PI$1 + HALF_PI$1;
                var minX = contains180 ? -1 : Math.min(startX, startX * cutout, endX, endX * cutout);
                var minY = contains270 ? -1 : Math.min(startY, startY * cutout, endY, endY * cutout);
                var maxX = contains0 ? 1 : Math.max(startX, startX * cutout, endX, endX * cutout);
                var maxY = contains90 ? 1 : Math.max(startY, startY * cutout, endY, endY * cutout);
                ratioX = (maxX - minX) / 2;
                ratioY = (maxY - minY) / 2;
                offsetX = -(maxX + minX) / 2;
                offsetY = -(maxY + minY) / 2;
            }
            for(i = 0, ilen = arcs.length; i < ilen; ++i)arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
            chart.borderWidth = me.getMaxBorderWidth();
            maxWidth = (chartArea.right - chartArea.left - chart.borderWidth) / ratioX;
            maxHeight = (chartArea.bottom - chartArea.top - chart.borderWidth) / ratioY;
            chart.outerRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
            chart.innerRadius = Math.max(chart.outerRadius * cutout, 0);
            chart.radiusLength = (chart.outerRadius - chart.innerRadius) / (me._getVisibleDatasetWeightTotal() || 1);
            chart.offsetX = offsetX * chart.outerRadius;
            chart.offsetY = offsetY * chart.outerRadius;
            meta.total = me.calculateTotal();
            me.outerRadius = chart.outerRadius - chart.radiusLength * me._getRingWeightOffset(me.index);
            me.innerRadius = Math.max(me.outerRadius - chart.radiusLength * chartWeight, 0);
            for(i = 0, ilen = arcs.length; i < ilen; ++i)me.updateElement(arcs[i], i, reset);
        },
        updateElement: function(arc, index, reset) {
            var me = this;
            var chart = me.chart;
            var chartArea = chart.chartArea;
            var opts = chart.options;
            var animationOpts = opts.animation;
            var centerX = (chartArea.left + chartArea.right) / 2;
            var centerY = (chartArea.top + chartArea.bottom) / 2;
            var startAngle = opts.rotation; // non reset case handled later
            var endAngle = opts.rotation; // non reset case handled later
            var dataset = me.getDataset();
            var circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / DOUBLE_PI$1);
            var innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius;
            var outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius;
            var options = arc._options || {};
            helpers$1.extend(arc, {
                // Utility
                _datasetIndex: me.index,
                _index: index,
                // Desired view properties
                _model: {
                    backgroundColor: options.backgroundColor,
                    borderColor: options.borderColor,
                    borderWidth: options.borderWidth,
                    borderAlign: options.borderAlign,
                    x: centerX + chart.offsetX,
                    y: centerY + chart.offsetY,
                    startAngle: startAngle,
                    endAngle: endAngle,
                    circumference: circumference,
                    outerRadius: outerRadius,
                    innerRadius: innerRadius,
                    label: helpers$1.valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
                }
            });
            var model = arc._model;
            // Set correct angles if not resetting
            if (!reset || !animationOpts.animateRotate) {
                if (index === 0) model.startAngle = opts.rotation;
                else model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
                model.endAngle = model.startAngle + model.circumference;
            }
            arc.pivot();
        },
        calculateTotal: function() {
            var dataset = this.getDataset();
            var meta = this.getMeta();
            var total = 0;
            var value;
            helpers$1.each(meta.data, function(element, index) {
                value = dataset.data[index];
                if (!isNaN(value) && !element.hidden) total += Math.abs(value);
            });
            /* if (total === 0) {
			total = NaN;
		}*/ return total;
        },
        calculateCircumference: function(value) {
            var total = this.getMeta().total;
            if (total > 0 && !isNaN(value)) return DOUBLE_PI$1 * (Math.abs(value) / total);
            return 0;
        },
        // gets the max border or hover width to properly scale pie charts
        getMaxBorderWidth: function(arcs) {
            var me = this;
            var max = 0;
            var chart = me.chart;
            var i, ilen, meta, arc, controller, options, borderWidth, hoverWidth;
            if (!arcs) {
                // Find the outmost visible dataset
                for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                    meta = chart.getDatasetMeta(i);
                    arcs = meta.data;
                    if (i !== me.index) controller = meta.controller;
                    break;
                }
            }
            if (!arcs) return 0;
            for(i = 0, ilen = arcs.length; i < ilen; ++i){
                arc = arcs[i];
                if (controller) {
                    controller._configure();
                    options = controller._resolveDataElementOptions(arc, i);
                } else options = arc._options;
                if (options.borderAlign !== "inner") {
                    borderWidth = options.borderWidth;
                    hoverWidth = options.hoverBorderWidth;
                    max = borderWidth > max ? borderWidth : max;
                    max = hoverWidth > max ? hoverWidth : max;
                }
            }
            return max;
        },
        /**
	 * @protected
	 */ setHoverStyle: function(arc) {
            var model = arc._model;
            var options = arc._options;
            var getHoverColor = helpers$1.getHoverColor;
            arc.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth
            };
            model.backgroundColor = valueOrDefault$5(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
            model.borderColor = valueOrDefault$5(options.hoverBorderColor, getHoverColor(options.borderColor));
            model.borderWidth = valueOrDefault$5(options.hoverBorderWidth, options.borderWidth);
        },
        /**
	 * Get radius length offset of the dataset in relation to the visible datasets weights. This allows determining the inner and outer radius correctly
	 * @private
	 */ _getRingWeightOffset: function(datasetIndex) {
            var ringWeightOffset = 0;
            for(var i = 0; i < datasetIndex; ++i)if (this.chart.isDatasetVisible(i)) ringWeightOffset += this._getRingWeight(i);
            return ringWeightOffset;
        },
        /**
	 * @private
	 */ _getRingWeight: function(dataSetIndex) {
            return Math.max(valueOrDefault$5(this.chart.data.datasets[dataSetIndex].weight, 1), 0);
        },
        /**
	 * Returns the sum of all visibile data set weights.  This value can be 0.
	 * @private
	 */ _getVisibleDatasetWeightTotal: function() {
            return this._getRingWeightOffset(this.chart.data.datasets.length);
        }
    });
    core_defaults._set("horizontalBar", {
        hover: {
            mode: "index",
            axis: "y"
        },
        scales: {
            xAxes: [
                {
                    type: "linear",
                    position: "bottom"
                }
            ],
            yAxes: [
                {
                    type: "category",
                    position: "left",
                    offset: true,
                    gridLines: {
                        offsetGridLines: true
                    }
                }
            ]
        },
        elements: {
            rectangle: {
                borderSkipped: "left"
            }
        },
        tooltips: {
            mode: "index",
            axis: "y"
        }
    });
    core_defaults._set("global", {
        datasets: {
            horizontalBar: {
                categoryPercentage: 0.8,
                barPercentage: 0.9
            }
        }
    });
    var controller_horizontalBar = controller_bar.extend({
        /**
	 * @private
	 */ _getValueScaleId: function() {
            return this.getMeta().xAxisID;
        },
        /**
	 * @private
	 */ _getIndexScaleId: function() {
            return this.getMeta().yAxisID;
        }
    });
    var valueOrDefault$6 = helpers$1.valueOrDefault;
    var resolve$2 = helpers$1.options.resolve;
    var isPointInArea = helpers$1.canvas._isPointInArea;
    core_defaults._set("line", {
        showLines: true,
        spanGaps: false,
        hover: {
            mode: "label"
        },
        scales: {
            xAxes: [
                {
                    type: "category",
                    id: "x-axis-0"
                }
            ],
            yAxes: [
                {
                    type: "linear",
                    id: "y-axis-0"
                }
            ]
        }
    });
    function scaleClip(scale, halfBorderWidth) {
        var tickOpts = scale && scale.options.ticks || {};
        var reverse = tickOpts.reverse;
        var min = tickOpts.min === undefined ? halfBorderWidth : 0;
        var max = tickOpts.max === undefined ? halfBorderWidth : 0;
        return {
            start: reverse ? max : min,
            end: reverse ? min : max
        };
    }
    function defaultClip(xScale, yScale, borderWidth) {
        var halfBorderWidth = borderWidth / 2;
        var x = scaleClip(xScale, halfBorderWidth);
        var y = scaleClip(yScale, halfBorderWidth);
        return {
            top: y.end,
            right: x.end,
            bottom: y.start,
            left: x.start
        };
    }
    function toClip(value) {
        var t, r, b, l;
        if (helpers$1.isObject(value)) {
            t = value.top;
            r = value.right;
            b = value.bottom;
            l = value.left;
        } else t = r = b = l = value;
        return {
            top: t,
            right: r,
            bottom: b,
            left: l
        };
    }
    var controller_line = core_datasetController.extend({
        datasetElementType: elements.Line,
        dataElementType: elements.Point,
        /**
	 * @private
	 */ _datasetElementOptions: [
            "backgroundColor",
            "borderCapStyle",
            "borderColor",
            "borderDash",
            "borderDashOffset",
            "borderJoinStyle",
            "borderWidth",
            "cubicInterpolationMode",
            "fill"
        ],
        /**
	 * @private
	 */ _dataElementOptions: {
            backgroundColor: "pointBackgroundColor",
            borderColor: "pointBorderColor",
            borderWidth: "pointBorderWidth",
            hitRadius: "pointHitRadius",
            hoverBackgroundColor: "pointHoverBackgroundColor",
            hoverBorderColor: "pointHoverBorderColor",
            hoverBorderWidth: "pointHoverBorderWidth",
            hoverRadius: "pointHoverRadius",
            pointStyle: "pointStyle",
            radius: "pointRadius",
            rotation: "pointRotation"
        },
        update: function(reset) {
            var me = this;
            var meta = me.getMeta();
            var line = meta.dataset;
            var points = meta.data || [];
            var options = me.chart.options;
            var config = me._config;
            var showLine = me._showLine = valueOrDefault$6(config.showLine, options.showLines);
            var i, ilen;
            me._xScale = me.getScaleForId(meta.xAxisID);
            me._yScale = me.getScaleForId(meta.yAxisID);
            // Update Line
            if (showLine) {
                // Compatibility: If the properties are defined with only the old name, use those values
                if (config.tension !== undefined && config.lineTension === undefined) config.lineTension = config.tension;
                // Utility
                line._scale = me._yScale;
                line._datasetIndex = me.index;
                // Data
                line._children = points;
                // Model
                line._model = me._resolveDatasetElementOptions(line);
                line.pivot();
            }
            // Update Points
            for(i = 0, ilen = points.length; i < ilen; ++i)me.updateElement(points[i], i, reset);
            if (showLine && line._model.tension !== 0) me.updateBezierControlPoints();
            // Now pivot the point for animation
            for(i = 0, ilen = points.length; i < ilen; ++i)points[i].pivot();
        },
        updateElement: function(point, index, reset) {
            var me = this;
            var meta = me.getMeta();
            var custom = point.custom || {};
            var dataset = me.getDataset();
            var datasetIndex = me.index;
            var value = dataset.data[index];
            var xScale = me._xScale;
            var yScale = me._yScale;
            var lineModel = meta.dataset._model;
            var x, y;
            var options = me._resolveDataElementOptions(point, index);
            x = xScale.getPixelForValue(typeof value === "object" ? value : NaN, index, datasetIndex);
            y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);
            // Utility
            point._xScale = xScale;
            point._yScale = yScale;
            point._options = options;
            point._datasetIndex = datasetIndex;
            point._index = index;
            // Desired view properties
            point._model = {
                x: x,
                y: y,
                skip: custom.skip || isNaN(x) || isNaN(y),
                // Appearance
                radius: options.radius,
                pointStyle: options.pointStyle,
                rotation: options.rotation,
                backgroundColor: options.backgroundColor,
                borderColor: options.borderColor,
                borderWidth: options.borderWidth,
                tension: valueOrDefault$6(custom.tension, lineModel ? lineModel.tension : 0),
                steppedLine: lineModel ? lineModel.steppedLine : false,
                // Tooltip
                hitRadius: options.hitRadius
            };
        },
        /**
	 * @private
	 */ _resolveDatasetElementOptions: function(element) {
            var me = this;
            var config = me._config;
            var custom = element.custom || {};
            var options = me.chart.options;
            var lineOptions = options.elements.line;
            var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);
            // The default behavior of lines is to break at null values, according
            // to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
            // This option gives lines the ability to span gaps
            values.spanGaps = valueOrDefault$6(config.spanGaps, options.spanGaps);
            values.tension = valueOrDefault$6(config.lineTension, lineOptions.tension);
            values.steppedLine = resolve$2([
                custom.steppedLine,
                config.steppedLine,
                lineOptions.stepped
            ]);
            values.clip = toClip(valueOrDefault$6(config.clip, defaultClip(me._xScale, me._yScale, values.borderWidth)));
            return values;
        },
        calculatePointY: function(value, index, datasetIndex) {
            var me = this;
            var chart = me.chart;
            var yScale = me._yScale;
            var sumPos = 0;
            var sumNeg = 0;
            var i, ds, dsMeta, stackedRightValue, rightValue, metasets, ilen;
            if (yScale.options.stacked) {
                rightValue = +yScale.getRightValue(value);
                metasets = chart._getSortedVisibleDatasetMetas();
                ilen = metasets.length;
                for(i = 0; i < ilen; ++i){
                    dsMeta = metasets[i];
                    if (dsMeta.index === datasetIndex) break;
                    ds = chart.data.datasets[dsMeta.index];
                    if (dsMeta.type === "line" && dsMeta.yAxisID === yScale.id) {
                        stackedRightValue = +yScale.getRightValue(ds.data[index]);
                        if (stackedRightValue < 0) sumNeg += stackedRightValue || 0;
                        else sumPos += stackedRightValue || 0;
                    }
                }
                if (rightValue < 0) return yScale.getPixelForValue(sumNeg + rightValue);
                return yScale.getPixelForValue(sumPos + rightValue);
            }
            return yScale.getPixelForValue(value);
        },
        updateBezierControlPoints: function() {
            var me = this;
            var chart = me.chart;
            var meta = me.getMeta();
            var lineModel = meta.dataset._model;
            var area = chart.chartArea;
            var points = meta.data || [];
            var i, ilen, model, controlPoints;
            // Only consider points that are drawn in case the spanGaps option is used
            if (lineModel.spanGaps) points = points.filter(function(pt) {
                return !pt._model.skip;
            });
            function capControlPoint(pt, min, max) {
                return Math.max(Math.min(pt, max), min);
            }
            if (lineModel.cubicInterpolationMode === "monotone") helpers$1.splineCurveMonotone(points);
            else for(i = 0, ilen = points.length; i < ilen; ++i){
                model = points[i]._model;
                controlPoints = helpers$1.splineCurve(helpers$1.previousItem(points, i)._model, model, helpers$1.nextItem(points, i)._model, lineModel.tension);
                model.controlPointPreviousX = controlPoints.previous.x;
                model.controlPointPreviousY = controlPoints.previous.y;
                model.controlPointNextX = controlPoints.next.x;
                model.controlPointNextY = controlPoints.next.y;
            }
            if (chart.options.elements.line.capBezierPoints) for(i = 0, ilen = points.length; i < ilen; ++i){
                model = points[i]._model;
                if (isPointInArea(model, area)) {
                    if (i > 0 && isPointInArea(points[i - 1]._model, area)) {
                        model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
                        model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
                    }
                    if (i < points.length - 1 && isPointInArea(points[i + 1]._model, area)) {
                        model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
                        model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
                    }
                }
            }
        },
        draw: function() {
            var me = this;
            var chart = me.chart;
            var meta = me.getMeta();
            var points = meta.data || [];
            var area = chart.chartArea;
            var canvas = chart.canvas;
            var i = 0;
            var ilen = points.length;
            var clip;
            if (me._showLine) {
                clip = meta.dataset._model.clip;
                helpers$1.canvas.clipArea(chart.ctx, {
                    left: clip.left === false ? 0 : area.left - clip.left,
                    right: clip.right === false ? canvas.width : area.right + clip.right,
                    top: clip.top === false ? 0 : area.top - clip.top,
                    bottom: clip.bottom === false ? canvas.height : area.bottom + clip.bottom
                });
                meta.dataset.draw();
                helpers$1.canvas.unclipArea(chart.ctx);
            }
            // Draw the points
            for(; i < ilen; ++i)points[i].draw(area);
        },
        /**
	 * @protected
	 */ setHoverStyle: function(point) {
            var model = point._model;
            var options = point._options;
            var getHoverColor = helpers$1.getHoverColor;
            point.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth,
                radius: model.radius
            };
            model.backgroundColor = valueOrDefault$6(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
            model.borderColor = valueOrDefault$6(options.hoverBorderColor, getHoverColor(options.borderColor));
            model.borderWidth = valueOrDefault$6(options.hoverBorderWidth, options.borderWidth);
            model.radius = valueOrDefault$6(options.hoverRadius, options.radius);
        }
    });
    var resolve$3 = helpers$1.options.resolve;
    core_defaults._set("polarArea", {
        scale: {
            type: "radialLinear",
            angleLines: {
                display: false
            },
            gridLines: {
                circular: true
            },
            pointLabels: {
                display: false
            },
            ticks: {
                beginAtZero: true
            }
        },
        // Boolean - Whether to animate the rotation of the chart
        animation: {
            animateRotate: true,
            animateScale: true
        },
        startAngle: -0.5 * Math.PI,
        legendCallback: function(chart) {
            var list = document.createElement("ul");
            var data = chart.data;
            var datasets = data.datasets;
            var labels = data.labels;
            var i, ilen, listItem, listItemSpan;
            list.setAttribute("class", chart.id + "-legend");
            if (datasets.length) for(i = 0, ilen = datasets[0].data.length; i < ilen; ++i){
                listItem = list.appendChild(document.createElement("li"));
                listItemSpan = listItem.appendChild(document.createElement("span"));
                listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
                if (labels[i]) listItem.appendChild(document.createTextNode(labels[i]));
            }
            return list.outerHTML;
        },
        legend: {
            labels: {
                generateLabels: function(chart) {
                    var data = chart.data;
                    if (data.labels.length && data.datasets.length) return data.labels.map(function(label, i) {
                        var meta = chart.getDatasetMeta(0);
                        var style = meta.controller.getStyle(i);
                        return {
                            text: label,
                            fillStyle: style.backgroundColor,
                            strokeStyle: style.borderColor,
                            lineWidth: style.borderWidth,
                            hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,
                            // Extra data used for toggling the correct item
                            index: i
                        };
                    });
                    return [];
                }
            },
            onClick: function(e, legendItem) {
                var index = legendItem.index;
                var chart = this.chart;
                var i, ilen, meta;
                for(i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i){
                    meta = chart.getDatasetMeta(i);
                    meta.data[index].hidden = !meta.data[index].hidden;
                }
                chart.update();
            }
        },
        // Need to override these to give a nice default
        tooltips: {
            callbacks: {
                title: function() {
                    return "";
                },
                label: function(item, data) {
                    return data.labels[item.index] + ": " + item.yLabel;
                }
            }
        }
    });
    var controller_polarArea = core_datasetController.extend({
        dataElementType: elements.Arc,
        linkScales: helpers$1.noop,
        /**
	 * @private
	 */ _dataElementOptions: [
            "backgroundColor",
            "borderColor",
            "borderWidth",
            "borderAlign",
            "hoverBackgroundColor",
            "hoverBorderColor",
            "hoverBorderWidth"
        ],
        /**
	 * @private
	 */ _getIndexScaleId: function() {
            return this.chart.scale.id;
        },
        /**
	 * @private
	 */ _getValueScaleId: function() {
            return this.chart.scale.id;
        },
        update: function(reset) {
            var me = this;
            var dataset = me.getDataset();
            var meta = me.getMeta();
            var start = me.chart.options.startAngle || 0;
            var starts = me._starts = [];
            var angles = me._angles = [];
            var arcs = meta.data;
            var i, ilen, angle;
            me._updateRadius();
            meta.count = me.countVisibleElements();
            for(i = 0, ilen = dataset.data.length; i < ilen; i++){
                starts[i] = start;
                angle = me._computeAngle(i);
                angles[i] = angle;
                start += angle;
            }
            for(i = 0, ilen = arcs.length; i < ilen; ++i){
                arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
                me.updateElement(arcs[i], i, reset);
            }
        },
        /**
	 * @private
	 */ _updateRadius: function() {
            var me = this;
            var chart = me.chart;
            var chartArea = chart.chartArea;
            var opts = chart.options;
            var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
            chart.outerRadius = Math.max(minSize / 2, 0);
            chart.innerRadius = Math.max(opts.cutoutPercentage ? chart.outerRadius / 100 * opts.cutoutPercentage : 1, 0);
            chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
            me.outerRadius = chart.outerRadius - chart.radiusLength * me.index;
            me.innerRadius = me.outerRadius - chart.radiusLength;
        },
        updateElement: function(arc, index, reset) {
            var me = this;
            var chart = me.chart;
            var dataset = me.getDataset();
            var opts = chart.options;
            var animationOpts = opts.animation;
            var scale = chart.scale;
            var labels = chart.data.labels;
            var centerX = scale.xCenter;
            var centerY = scale.yCenter;
            // var negHalfPI = -0.5 * Math.PI;
            var datasetStartAngle = opts.startAngle;
            var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
            var startAngle = me._starts[index];
            var endAngle = startAngle + (arc.hidden ? 0 : me._angles[index]);
            var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
            var options = arc._options || {};
            helpers$1.extend(arc, {
                // Utility
                _datasetIndex: me.index,
                _index: index,
                _scale: scale,
                // Desired view properties
                _model: {
                    backgroundColor: options.backgroundColor,
                    borderColor: options.borderColor,
                    borderWidth: options.borderWidth,
                    borderAlign: options.borderAlign,
                    x: centerX,
                    y: centerY,
                    innerRadius: 0,
                    outerRadius: reset ? resetRadius : distance,
                    startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
                    endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
                    label: helpers$1.valueAtIndexOrDefault(labels, index, labels[index])
                }
            });
            arc.pivot();
        },
        countVisibleElements: function() {
            var dataset = this.getDataset();
            var meta = this.getMeta();
            var count = 0;
            helpers$1.each(meta.data, function(element, index) {
                if (!isNaN(dataset.data[index]) && !element.hidden) count++;
            });
            return count;
        },
        /**
	 * @protected
	 */ setHoverStyle: function(arc) {
            var model = arc._model;
            var options = arc._options;
            var getHoverColor = helpers$1.getHoverColor;
            var valueOrDefault = helpers$1.valueOrDefault;
            arc.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth
            };
            model.backgroundColor = valueOrDefault(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
            model.borderColor = valueOrDefault(options.hoverBorderColor, getHoverColor(options.borderColor));
            model.borderWidth = valueOrDefault(options.hoverBorderWidth, options.borderWidth);
        },
        /**
	 * @private
	 */ _computeAngle: function(index) {
            var me = this;
            var count = this.getMeta().count;
            var dataset = me.getDataset();
            var meta = me.getMeta();
            if (isNaN(dataset.data[index]) || meta.data[index].hidden) return 0;
            // Scriptable options
            var context = {
                chart: me.chart,
                dataIndex: index,
                dataset: dataset,
                datasetIndex: me.index
            };
            return resolve$3([
                me.chart.options.elements.arc.angle,
                2 * Math.PI / count
            ], context, index);
        }
    });
    core_defaults._set("pie", helpers$1.clone(core_defaults.doughnut));
    core_defaults._set("pie", {
        cutoutPercentage: 0
    });
    // Pie charts are Doughnut chart with different defaults
    var controller_pie = controller_doughnut;
    var valueOrDefault$7 = helpers$1.valueOrDefault;
    core_defaults._set("radar", {
        spanGaps: false,
        scale: {
            type: "radialLinear"
        },
        elements: {
            line: {
                fill: "start",
                tension: 0 // no bezier in radar
            }
        }
    });
    var controller_radar = core_datasetController.extend({
        datasetElementType: elements.Line,
        dataElementType: elements.Point,
        linkScales: helpers$1.noop,
        /**
	 * @private
	 */ _datasetElementOptions: [
            "backgroundColor",
            "borderWidth",
            "borderColor",
            "borderCapStyle",
            "borderDash",
            "borderDashOffset",
            "borderJoinStyle",
            "fill"
        ],
        /**
	 * @private
	 */ _dataElementOptions: {
            backgroundColor: "pointBackgroundColor",
            borderColor: "pointBorderColor",
            borderWidth: "pointBorderWidth",
            hitRadius: "pointHitRadius",
            hoverBackgroundColor: "pointHoverBackgroundColor",
            hoverBorderColor: "pointHoverBorderColor",
            hoverBorderWidth: "pointHoverBorderWidth",
            hoverRadius: "pointHoverRadius",
            pointStyle: "pointStyle",
            radius: "pointRadius",
            rotation: "pointRotation"
        },
        /**
	 * @private
	 */ _getIndexScaleId: function() {
            return this.chart.scale.id;
        },
        /**
	 * @private
	 */ _getValueScaleId: function() {
            return this.chart.scale.id;
        },
        update: function(reset) {
            var me = this;
            var meta = me.getMeta();
            var line = meta.dataset;
            var points = meta.data || [];
            var scale = me.chart.scale;
            var config = me._config;
            var i, ilen;
            // Compatibility: If the properties are defined with only the old name, use those values
            if (config.tension !== undefined && config.lineTension === undefined) config.lineTension = config.tension;
            // Utility
            line._scale = scale;
            line._datasetIndex = me.index;
            // Data
            line._children = points;
            line._loop = true;
            // Model
            line._model = me._resolveDatasetElementOptions(line);
            line.pivot();
            // Update Points
            for(i = 0, ilen = points.length; i < ilen; ++i)me.updateElement(points[i], i, reset);
            // Update bezier control points
            me.updateBezierControlPoints();
            // Now pivot the point for animation
            for(i = 0, ilen = points.length; i < ilen; ++i)points[i].pivot();
        },
        updateElement: function(point, index, reset) {
            var me = this;
            var custom = point.custom || {};
            var dataset = me.getDataset();
            var scale = me.chart.scale;
            var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);
            var options = me._resolveDataElementOptions(point, index);
            var lineModel = me.getMeta().dataset._model;
            var x = reset ? scale.xCenter : pointPosition.x;
            var y = reset ? scale.yCenter : pointPosition.y;
            // Utility
            point._scale = scale;
            point._options = options;
            point._datasetIndex = me.index;
            point._index = index;
            // Desired view properties
            point._model = {
                x: x,
                y: y,
                skip: custom.skip || isNaN(x) || isNaN(y),
                // Appearance
                radius: options.radius,
                pointStyle: options.pointStyle,
                rotation: options.rotation,
                backgroundColor: options.backgroundColor,
                borderColor: options.borderColor,
                borderWidth: options.borderWidth,
                tension: valueOrDefault$7(custom.tension, lineModel ? lineModel.tension : 0),
                // Tooltip
                hitRadius: options.hitRadius
            };
        },
        /**
	 * @private
	 */ _resolveDatasetElementOptions: function() {
            var me = this;
            var config = me._config;
            var options = me.chart.options;
            var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);
            values.spanGaps = valueOrDefault$7(config.spanGaps, options.spanGaps);
            values.tension = valueOrDefault$7(config.lineTension, options.elements.line.tension);
            return values;
        },
        updateBezierControlPoints: function() {
            var me = this;
            var meta = me.getMeta();
            var area = me.chart.chartArea;
            var points = meta.data || [];
            var i, ilen, model, controlPoints;
            // Only consider points that are drawn in case the spanGaps option is used
            if (meta.dataset._model.spanGaps) points = points.filter(function(pt) {
                return !pt._model.skip;
            });
            function capControlPoint(pt, min, max) {
                return Math.max(Math.min(pt, max), min);
            }
            for(i = 0, ilen = points.length; i < ilen; ++i){
                model = points[i]._model;
                controlPoints = helpers$1.splineCurve(helpers$1.previousItem(points, i, true)._model, model, helpers$1.nextItem(points, i, true)._model, model.tension);
                // Prevent the bezier going outside of the bounds of the graph
                model.controlPointPreviousX = capControlPoint(controlPoints.previous.x, area.left, area.right);
                model.controlPointPreviousY = capControlPoint(controlPoints.previous.y, area.top, area.bottom);
                model.controlPointNextX = capControlPoint(controlPoints.next.x, area.left, area.right);
                model.controlPointNextY = capControlPoint(controlPoints.next.y, area.top, area.bottom);
            }
        },
        setHoverStyle: function(point) {
            var model = point._model;
            var options = point._options;
            var getHoverColor = helpers$1.getHoverColor;
            point.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth,
                radius: model.radius
            };
            model.backgroundColor = valueOrDefault$7(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
            model.borderColor = valueOrDefault$7(options.hoverBorderColor, getHoverColor(options.borderColor));
            model.borderWidth = valueOrDefault$7(options.hoverBorderWidth, options.borderWidth);
            model.radius = valueOrDefault$7(options.hoverRadius, options.radius);
        }
    });
    core_defaults._set("scatter", {
        hover: {
            mode: "single"
        },
        scales: {
            xAxes: [
                {
                    id: "x-axis-1",
                    type: "linear",
                    position: "bottom"
                }
            ],
            yAxes: [
                {
                    id: "y-axis-1",
                    type: "linear",
                    position: "left"
                }
            ]
        },
        tooltips: {
            callbacks: {
                title: function() {
                    return ""; // doesn't make sense for scatter since data are formatted as a point
                },
                label: function(item) {
                    return "(" + item.xLabel + ", " + item.yLabel + ")";
                }
            }
        }
    });
    core_defaults._set("global", {
        datasets: {
            scatter: {
                showLine: false
            }
        }
    });
    // Scatter charts use line controllers
    var controller_scatter = controller_line;
    // NOTE export a map in which the key represents the controller type, not
    // the class, and so must be CamelCase in order to be correctly retrieved
    // by the controller in core.controller.js (`controllers[meta.type]`).
    var controllers = {
        bar: controller_bar,
        bubble: controller_bubble,
        doughnut: controller_doughnut,
        horizontalBar: controller_horizontalBar,
        line: controller_line,
        polarArea: controller_polarArea,
        pie: controller_pie,
        radar: controller_radar,
        scatter: controller_scatter
    };
    /**
 * Helper function to get relative position for an event
 * @param {Event|IEvent} event - The event to get the position for
 * @param {Chart} chart - The chart
 * @returns {object} the event position
 */ function getRelativePosition(e, chart) {
        if (e.native) return {
            x: e.x,
            y: e.y
        };
        return helpers$1.getRelativePosition(e, chart);
    }
    /**
 * Helper function to traverse all of the visible elements in the chart
 * @param {Chart} chart - the chart
 * @param {function} handler - the callback to execute for each visible item
 */ function parseVisibleItems(chart, handler) {
        var metasets = chart._getSortedVisibleDatasetMetas();
        var metadata, i, j, ilen, jlen, element;
        for(i = 0, ilen = metasets.length; i < ilen; ++i){
            metadata = metasets[i].data;
            for(j = 0, jlen = metadata.length; j < jlen; ++j){
                element = metadata[j];
                if (!element._view.skip) handler(element);
            }
        }
    }
    /**
 * Helper function to get the items that intersect the event position
 * @param {ChartElement[]} items - elements to filter
 * @param {object} position - the point to be nearest to
 * @return {ChartElement[]} the nearest items
 */ function getIntersectItems(chart, position) {
        var elements = [];
        parseVisibleItems(chart, function(element) {
            if (element.inRange(position.x, position.y)) elements.push(element);
        });
        return elements;
    }
    /**
 * Helper function to get the items nearest to the event position considering all visible items in teh chart
 * @param {Chart} chart - the chart to look at elements from
 * @param {object} position - the point to be nearest to
 * @param {boolean} intersect - if true, only consider items that intersect the position
 * @param {function} distanceMetric - function to provide the distance between points
 * @return {ChartElement[]} the nearest items
 */ function getNearestItems(chart, position, intersect, distanceMetric) {
        var minDistance = Number.POSITIVE_INFINITY;
        var nearestItems = [];
        parseVisibleItems(chart, function(element) {
            if (intersect && !element.inRange(position.x, position.y)) return;
            var center = element.getCenterPoint();
            var distance = distanceMetric(position, center);
            if (distance < minDistance) {
                nearestItems = [
                    element
                ];
                minDistance = distance;
            } else if (distance === minDistance) // Can have multiple items at the same distance in which case we sort by size
            nearestItems.push(element);
        });
        return nearestItems;
    }
    /**
 * Get a distance metric function for two points based on the
 * axis mode setting
 * @param {string} axis - the axis mode. x|y|xy
 */ function getDistanceMetricForAxis(axis) {
        var useX = axis.indexOf("x") !== -1;
        var useY = axis.indexOf("y") !== -1;
        return function(pt1, pt2) {
            var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
            var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
            return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
        };
    }
    function indexMode(chart, e, options) {
        var position = getRelativePosition(e, chart);
        // Default axis for index mode is 'x' to match old behaviour
        options.axis = options.axis || "x";
        var distanceMetric = getDistanceMetricForAxis(options.axis);
        var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
        var elements = [];
        if (!items.length) return [];
        chart._getSortedVisibleDatasetMetas().forEach(function(meta) {
            var element = meta.data[items[0]._index];
            // don't count items that are skipped (null data)
            if (element && !element._view.skip) elements.push(element);
        });
        return elements;
    }
    /**
 * @interface IInteractionOptions
 */ /**
 * If true, only consider items that intersect the point
 * @name IInterfaceOptions#boolean
 * @type Boolean
 */ /**
 * Contains interaction related functions
 * @namespace Chart.Interaction
 */ var core_interaction = {
        // Helper function for different modes
        modes: {
            single: function(chart, e) {
                var position = getRelativePosition(e, chart);
                var elements = [];
                parseVisibleItems(chart, function(element) {
                    if (element.inRange(position.x, position.y)) {
                        elements.push(element);
                        return elements;
                    }
                });
                return elements.slice(0, 1);
            },
            /**
		 * @function Chart.Interaction.modes.label
		 * @deprecated since version 2.4.0
		 * @todo remove at version 3
		 * @private
		 */ label: indexMode,
            /**
		 * Returns items at the same index. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect mode is false, we find the nearest item and return the items at the same index as that item
		 * @function Chart.Interaction.modes.index
		 * @since v2.4.0
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ index: indexMode,
            /**
		 * Returns items in the same dataset. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect is false, we find the nearest item and return the items in that dataset
		 * @function Chart.Interaction.modes.dataset
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ dataset: function(chart, e, options) {
                var position = getRelativePosition(e, chart);
                options.axis = options.axis || "xy";
                var distanceMetric = getDistanceMetricForAxis(options.axis);
                var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
                if (items.length > 0) items = chart.getDatasetMeta(items[0]._datasetIndex).data;
                return items;
            },
            /**
		 * @function Chart.Interaction.modes.x-axis
		 * @deprecated since version 2.4.0. Use index mode and intersect == true
		 * @todo remove at version 3
		 * @private
		 */ "x-axis": function(chart, e) {
                return indexMode(chart, e, {
                    intersect: false
                });
            },
            /**
		 * Point mode returns all elements that hit test based on the event position
		 * of the event
		 * @function Chart.Interaction.modes.intersect
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ point: function(chart, e) {
                var position = getRelativePosition(e, chart);
                return getIntersectItems(chart, position);
            },
            /**
		 * nearest mode returns the element closest to the point
		 * @function Chart.Interaction.modes.intersect
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ nearest: function(chart, e, options) {
                var position = getRelativePosition(e, chart);
                options.axis = options.axis || "xy";
                var distanceMetric = getDistanceMetricForAxis(options.axis);
                return getNearestItems(chart, position, options.intersect, distanceMetric);
            },
            /**
		 * x mode returns the elements that hit-test at the current x coordinate
		 * @function Chart.Interaction.modes.x
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ x: function(chart, e, options) {
                var position = getRelativePosition(e, chart);
                var items = [];
                var intersectsItem = false;
                parseVisibleItems(chart, function(element) {
                    if (element.inXRange(position.x)) items.push(element);
                    if (element.inRange(position.x, position.y)) intersectsItem = true;
                });
                // If we want to trigger on an intersect and we don't have any items
                // that intersect the position, return nothing
                if (options.intersect && !intersectsItem) items = [];
                return items;
            },
            /**
		 * y mode returns the elements that hit-test at the current y coordinate
		 * @function Chart.Interaction.modes.y
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ y: function(chart, e, options) {
                var position = getRelativePosition(e, chart);
                var items = [];
                var intersectsItem = false;
                parseVisibleItems(chart, function(element) {
                    if (element.inYRange(position.y)) items.push(element);
                    if (element.inRange(position.x, position.y)) intersectsItem = true;
                });
                // If we want to trigger on an intersect and we don't have any items
                // that intersect the position, return nothing
                if (options.intersect && !intersectsItem) items = [];
                return items;
            }
        }
    };
    var extend = helpers$1.extend;
    function filterByPosition(array, position) {
        return helpers$1.where(array, function(v) {
            return v.pos === position;
        });
    }
    function sortByWeight(array, reverse) {
        return array.sort(function(a, b) {
            var v0 = reverse ? b : a;
            var v1 = reverse ? a : b;
            return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
        });
    }
    function wrapBoxes(boxes) {
        var layoutBoxes = [];
        var i, ilen, box;
        for(i = 0, ilen = (boxes || []).length; i < ilen; ++i){
            box = boxes[i];
            layoutBoxes.push({
                index: i,
                box: box,
                pos: box.position,
                horizontal: box.isHorizontal(),
                weight: box.weight
            });
        }
        return layoutBoxes;
    }
    function setLayoutDims(layouts, params) {
        var i, ilen, layout;
        for(i = 0, ilen = layouts.length; i < ilen; ++i){
            layout = layouts[i];
            // store width used instead of chartArea.w in fitBoxes
            layout.width = layout.horizontal ? layout.box.fullWidth && params.availableWidth : params.vBoxMaxWidth;
            // store height used instead of chartArea.h in fitBoxes
            layout.height = layout.horizontal && params.hBoxMaxHeight;
        }
    }
    function buildLayoutBoxes(boxes) {
        var layoutBoxes = wrapBoxes(boxes);
        var left = sortByWeight(filterByPosition(layoutBoxes, "left"), true);
        var right = sortByWeight(filterByPosition(layoutBoxes, "right"));
        var top = sortByWeight(filterByPosition(layoutBoxes, "top"), true);
        var bottom = sortByWeight(filterByPosition(layoutBoxes, "bottom"));
        return {
            leftAndTop: left.concat(top),
            rightAndBottom: right.concat(bottom),
            chartArea: filterByPosition(layoutBoxes, "chartArea"),
            vertical: left.concat(right),
            horizontal: top.concat(bottom)
        };
    }
    function getCombinedMax(maxPadding, chartArea, a, b) {
        return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
    }
    function updateDims(chartArea, params, layout) {
        var box = layout.box;
        var maxPadding = chartArea.maxPadding;
        var newWidth, newHeight;
        if (layout.size) // this layout was already counted for, lets first reduce old size
        chartArea[layout.pos] -= layout.size;
        layout.size = layout.horizontal ? box.height : box.width;
        chartArea[layout.pos] += layout.size;
        if (box.getPadding) {
            var boxPadding = box.getPadding();
            maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
            maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
            maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
            maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
        }
        newWidth = params.outerWidth - getCombinedMax(maxPadding, chartArea, "left", "right");
        newHeight = params.outerHeight - getCombinedMax(maxPadding, chartArea, "top", "bottom");
        if (newWidth !== chartArea.w || newHeight !== chartArea.h) {
            chartArea.w = newWidth;
            chartArea.h = newHeight;
            // return true if chart area changed in layout's direction
            var sizes = layout.horizontal ? [
                newWidth,
                chartArea.w
            ] : [
                newHeight,
                chartArea.h
            ];
            return sizes[0] !== sizes[1] && (!isNaN(sizes[0]) || !isNaN(sizes[1]));
        }
    }
    function handleMaxPadding(chartArea) {
        var maxPadding = chartArea.maxPadding;
        function updatePos(pos) {
            var change = Math.max(maxPadding[pos] - chartArea[pos], 0);
            chartArea[pos] += change;
            return change;
        }
        chartArea.y += updatePos("top");
        chartArea.x += updatePos("left");
        updatePos("right");
        updatePos("bottom");
    }
    function getMargins(horizontal, chartArea) {
        var maxPadding = chartArea.maxPadding;
        function marginForPositions(positions) {
            var margin = {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            };
            positions.forEach(function(pos) {
                margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
            });
            return margin;
        }
        return horizontal ? marginForPositions([
            "left",
            "right"
        ]) : marginForPositions([
            "top",
            "bottom"
        ]);
    }
    function fitBoxes(boxes, chartArea, params) {
        var refitBoxes = [];
        var i, ilen, layout, box, refit, changed;
        for(i = 0, ilen = boxes.length; i < ilen; ++i){
            layout = boxes[i];
            box = layout.box;
            box.update(layout.width || chartArea.w, layout.height || chartArea.h, getMargins(layout.horizontal, chartArea));
            if (updateDims(chartArea, params, layout)) {
                changed = true;
                if (refitBoxes.length) // Dimensions changed and there were non full width boxes before this
                // -> we have to refit those
                refit = true;
            }
            if (!box.fullWidth) refitBoxes.push(layout);
        }
        return refit ? fitBoxes(refitBoxes, chartArea, params) || changed : changed;
    }
    function placeBoxes(boxes, chartArea, params) {
        var userPadding = params.padding;
        var x = chartArea.x;
        var y = chartArea.y;
        var i, ilen, layout, box;
        for(i = 0, ilen = boxes.length; i < ilen; ++i){
            layout = boxes[i];
            box = layout.box;
            if (layout.horizontal) {
                box.left = box.fullWidth ? userPadding.left : chartArea.left;
                box.right = box.fullWidth ? params.outerWidth - userPadding.right : chartArea.left + chartArea.w;
                box.top = y;
                box.bottom = y + box.height;
                box.width = box.right - box.left;
                y = box.bottom;
            } else {
                box.left = x;
                box.right = x + box.width;
                box.top = chartArea.top;
                box.bottom = chartArea.top + chartArea.h;
                box.height = box.bottom - box.top;
                x = box.right;
            }
        }
        chartArea.x = x;
        chartArea.y = y;
    }
    core_defaults._set("global", {
        layout: {
            padding: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            }
        }
    });
    /**
 * @interface ILayoutItem
 * @prop {string} position - The position of the item in the chart layout. Possible values are
 * 'left', 'top', 'right', 'bottom', and 'chartArea'
 * @prop {number} weight - The weight used to sort the item. Higher weights are further away from the chart area
 * @prop {boolean} fullWidth - if true, and the item is horizontal, then push vertical boxes down
 * @prop {function} isHorizontal - returns true if the layout item is horizontal (ie. top or bottom)
 * @prop {function} update - Takes two parameters: width and height. Returns size of item
 * @prop {function} getPadding -  Returns an object with padding on the edges
 * @prop {number} width - Width of item. Must be valid after update()
 * @prop {number} height - Height of item. Must be valid after update()
 * @prop {number} left - Left edge of the item. Set by layout system and cannot be used in update
 * @prop {number} top - Top edge of the item. Set by layout system and cannot be used in update
 * @prop {number} right - Right edge of the item. Set by layout system and cannot be used in update
 * @prop {number} bottom - Bottom edge of the item. Set by layout system and cannot be used in update
 */ // The layout service is very self explanatory.  It's responsible for the layout within a chart.
    // Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
    // It is this service's responsibility of carrying out that layout.
    var core_layouts = {
        defaults: {},
        /**
	 * Register a box to a chart.
	 * A box is simply a reference to an object that requires layout. eg. Scales, Legend, Title.
	 * @param {Chart} chart - the chart to use
	 * @param {ILayoutItem} item - the item to add to be layed out
	 */ addBox: function(chart, item) {
            if (!chart.boxes) chart.boxes = [];
            // initialize item with default values
            item.fullWidth = item.fullWidth || false;
            item.position = item.position || "top";
            item.weight = item.weight || 0;
            item._layers = item._layers || function() {
                return [
                    {
                        z: 0,
                        draw: function() {
                            item.draw.apply(item, arguments);
                        }
                    }
                ];
            };
            chart.boxes.push(item);
        },
        /**
	 * Remove a layoutItem from a chart
	 * @param {Chart} chart - the chart to remove the box from
	 * @param {ILayoutItem} layoutItem - the item to remove from the layout
	 */ removeBox: function(chart, layoutItem) {
            var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
            if (index !== -1) chart.boxes.splice(index, 1);
        },
        /**
	 * Sets (or updates) options on the given `item`.
	 * @param {Chart} chart - the chart in which the item lives (or will be added to)
	 * @param {ILayoutItem} item - the item to configure with the given options
	 * @param {object} options - the new item options.
	 */ configure: function(chart, item, options) {
            var props = [
                "fullWidth",
                "position",
                "weight"
            ];
            var ilen = props.length;
            var i = 0;
            var prop;
            for(; i < ilen; ++i){
                prop = props[i];
                if (options.hasOwnProperty(prop)) item[prop] = options[prop];
            }
        },
        /**
	 * Fits boxes of the given chart into the given size by having each box measure itself
	 * then running a fitting algorithm
	 * @param {Chart} chart - the chart
	 * @param {number} width - the width to fit into
	 * @param {number} height - the height to fit into
	 */ update: function(chart, width, height) {
            if (!chart) return;
            var layoutOptions = chart.options.layout || {};
            var padding = helpers$1.options.toPadding(layoutOptions.padding);
            var availableWidth = width - padding.width;
            var availableHeight = height - padding.height;
            var boxes = buildLayoutBoxes(chart.boxes);
            var verticalBoxes = boxes.vertical;
            var horizontalBoxes = boxes.horizontal;
            // Essentially we now have any number of boxes on each of the 4 sides.
            // Our canvas looks like the following.
            // The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
            // B1 is the bottom axis
            // There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
            // These locations are single-box locations only, when trying to register a chartArea location that is already taken,
            // an error will be thrown.
            //
            // |----------------------------------------------------|
            // |                  T1 (Full Width)                   |
            // |----------------------------------------------------|
            // |    |    |                 T2                  |    |
            // |    |----|-------------------------------------|----|
            // |    |    | C1 |                           | C2 |    |
            // |    |    |----|                           |----|    |
            // |    |    |                                     |    |
            // | L1 | L2 |           ChartArea (C0)            | R1 |
            // |    |    |                                     |    |
            // |    |    |----|                           |----|    |
            // |    |    | C3 |                           | C4 |    |
            // |    |----|-------------------------------------|----|
            // |    |    |                 B1                  |    |
            // |----------------------------------------------------|
            // |                  B2 (Full Width)                   |
            // |----------------------------------------------------|
            //
            var params = Object.freeze({
                outerWidth: width,
                outerHeight: height,
                padding: padding,
                availableWidth: availableWidth,
                vBoxMaxWidth: availableWidth / 2 / verticalBoxes.length,
                hBoxMaxHeight: availableHeight / 2
            });
            var chartArea = extend({
                maxPadding: extend({}, padding),
                w: availableWidth,
                h: availableHeight,
                x: padding.left,
                y: padding.top
            }, padding);
            setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
            // First fit vertical boxes
            fitBoxes(verticalBoxes, chartArea, params);
            // Then fit horizontal boxes
            if (fitBoxes(horizontalBoxes, chartArea, params)) // if the area changed, re-fit vertical boxes
            fitBoxes(verticalBoxes, chartArea, params);
            handleMaxPadding(chartArea);
            // Finally place the boxes to correct coordinates
            placeBoxes(boxes.leftAndTop, chartArea, params);
            // Move to opposite side of chart
            chartArea.x += chartArea.w;
            chartArea.y += chartArea.h;
            placeBoxes(boxes.rightAndBottom, chartArea, params);
            chart.chartArea = {
                left: chartArea.left,
                top: chartArea.top,
                right: chartArea.left + chartArea.w,
                bottom: chartArea.top + chartArea.h
            };
            // Finally update boxes in chartArea (radial scale for example)
            helpers$1.each(boxes.chartArea, function(layout) {
                var box = layout.box;
                extend(box, chart.chartArea);
                box.update(chartArea.w, chartArea.h);
            });
        }
    };
    /**
 * Platform fallback implementation (minimal).
 * @see https://github.com/chartjs/Chart.js/pull/4591#issuecomment-319575939
 */ var platform_basic = {
        acquireContext: function(item) {
            if (item && item.canvas) // Support for any object associated to a canvas (including a context2d)
            item = item.canvas;
            return item && item.getContext("2d") || null;
        }
    };
    var platform_dom = "/*\r\n * DOM element rendering detection\r\n * https://davidwalsh.name/detect-node-insertion\r\n */\r\n@keyframes chartjs-render-animation {\r\n	from { opacity: 0.99; }\r\n	to { opacity: 1; }\r\n}\r\n\r\n.chartjs-render-monitor {\r\n	animation: chartjs-render-animation 0.001s;\r\n}\r\n\r\n/*\r\n * DOM element resizing detection\r\n * https://github.com/marcj/css-element-queries\r\n */\r\n.chartjs-size-monitor,\r\n.chartjs-size-monitor-expand,\r\n.chartjs-size-monitor-shrink {\r\n	position: absolute;\r\n	direction: ltr;\r\n	left: 0;\r\n	top: 0;\r\n	right: 0;\r\n	bottom: 0;\r\n	overflow: hidden;\r\n	pointer-events: none;\r\n	visibility: hidden;\r\n	z-index: -1;\r\n}\r\n\r\n.chartjs-size-monitor-expand > div {\r\n	position: absolute;\r\n	width: 1000000px;\r\n	height: 1000000px;\r\n	left: 0;\r\n	top: 0;\r\n}\r\n\r\n.chartjs-size-monitor-shrink > div {\r\n	position: absolute;\r\n	width: 200%;\r\n	height: 200%;\r\n	left: 0;\r\n	top: 0;\r\n}\r\n";
    var platform_dom$1 = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        "default": platform_dom
    });
    var stylesheet = getCjsExportFromNamespace(platform_dom$1);
    var EXPANDO_KEY = "$chartjs";
    var CSS_PREFIX = "chartjs-";
    var CSS_SIZE_MONITOR = CSS_PREFIX + "size-monitor";
    var CSS_RENDER_MONITOR = CSS_PREFIX + "render-monitor";
    var CSS_RENDER_ANIMATION = CSS_PREFIX + "render-animation";
    var ANIMATION_START_EVENTS = [
        "animationstart",
        "webkitAnimationStart"
    ];
    /**
 * DOM event types -> Chart.js event types.
 * Note: only events with different types are mapped.
 * @see https://developer.mozilla.org/en-US/docs/Web/Events
 */ var EVENT_TYPES = {
        touchstart: "mousedown",
        touchmove: "mousemove",
        touchend: "mouseup",
        pointerenter: "mouseenter",
        pointerdown: "mousedown",
        pointermove: "mousemove",
        pointerup: "mouseup",
        pointerleave: "mouseout",
        pointerout: "mouseout"
    };
    /**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns {number} Size in pixels or undefined if unknown.
 */ function readUsedSize(element, property) {
        var value = helpers$1.getStyle(element, property);
        var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
        return matches ? Number(matches[1]) : undefined;
    }
    /**
 * Initializes the canvas style and render size without modifying the canvas display size,
 * since responsiveness is handled by the controller.resize() method. The config is used
 * to determine the aspect ratio to apply in case no explicit height has been specified.
 */ function initCanvas(canvas, config) {
        var style = canvas.style;
        // NOTE(SB) canvas.getAttribute('width') !== canvas.width: in the first case it
        // returns null or '' if no explicit value has been set to the canvas attribute.
        var renderHeight = canvas.getAttribute("height");
        var renderWidth = canvas.getAttribute("width");
        // Chart.js modifies some canvas values that we want to restore on destroy
        canvas[EXPANDO_KEY] = {
            initial: {
                height: renderHeight,
                width: renderWidth,
                style: {
                    display: style.display,
                    height: style.height,
                    width: style.width
                }
            }
        };
        // Force canvas to display as block to avoid extra space caused by inline
        // elements, which would interfere with the responsive resize process.
        // https://github.com/chartjs/Chart.js/issues/2538
        style.display = style.display || "block";
        if (renderWidth === null || renderWidth === "") {
            var displayWidth = readUsedSize(canvas, "width");
            if (displayWidth !== undefined) canvas.width = displayWidth;
        }
        if (renderHeight === null || renderHeight === "") {
            if (canvas.style.height === "") // If no explicit render height and style height, let's apply the aspect ratio,
            // which one can be specified by the user but also by charts as default option
            // (i.e. options.aspectRatio). If not specified, use canvas aspect ratio of 2.
            canvas.height = canvas.width / (config.options.aspectRatio || 2);
            else {
                var displayHeight = readUsedSize(canvas, "height");
                if (displayWidth !== undefined) canvas.height = displayHeight;
            }
        }
        return canvas;
    }
    /**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */ var supportsEventListenerOptions = function() {
        var supports = false;
        try {
            var options = Object.defineProperty({}, "passive", {
                // eslint-disable-next-line getter-return
                get: function() {
                    supports = true;
                }
            });
            window.addEventListener("e", null, options);
        } catch (e) {
        // continue regardless of error
        }
        return supports;
    }();
    // Default passive to true as expected by Chrome for 'touchstart' and 'touchend' events.
    // https://github.com/chartjs/Chart.js/issues/4287
    var eventListenerOptions = supportsEventListenerOptions ? {
        passive: true
    } : false;
    function addListener(node, type, listener) {
        node.addEventListener(type, listener, eventListenerOptions);
    }
    function removeListener(node, type, listener) {
        node.removeEventListener(type, listener, eventListenerOptions);
    }
    function createEvent(type, chart, x, y, nativeEvent) {
        return {
            type: type,
            chart: chart,
            native: nativeEvent || null,
            x: x !== undefined ? x : null,
            y: y !== undefined ? y : null
        };
    }
    function fromNativeEvent(event, chart) {
        var type = EVENT_TYPES[event.type] || event.type;
        var pos = helpers$1.getRelativePosition(event, chart);
        return createEvent(type, chart, pos.x, pos.y, event);
    }
    function throttled(fn, thisArg) {
        var ticking = false;
        var args = [];
        return function() {
            args = Array.prototype.slice.call(arguments);
            thisArg = thisArg || this;
            if (!ticking) {
                ticking = true;
                helpers$1.requestAnimFrame.call(window, function() {
                    ticking = false;
                    fn.apply(thisArg, args);
                });
            }
        };
    }
    function createDiv(cls) {
        var el = document.createElement("div");
        el.className = cls || "";
        return el;
    }
    // Implementation based on https://github.com/marcj/css-element-queries
    function createResizer(handler) {
        var maxSize = 1000000;
        // NOTE(SB) Don't use innerHTML because it could be considered unsafe.
        // https://github.com/chartjs/Chart.js/issues/5902
        var resizer = createDiv(CSS_SIZE_MONITOR);
        var expand = createDiv(CSS_SIZE_MONITOR + "-expand");
        var shrink = createDiv(CSS_SIZE_MONITOR + "-shrink");
        expand.appendChild(createDiv());
        shrink.appendChild(createDiv());
        resizer.appendChild(expand);
        resizer.appendChild(shrink);
        resizer._reset = function() {
            expand.scrollLeft = maxSize;
            expand.scrollTop = maxSize;
            shrink.scrollLeft = maxSize;
            shrink.scrollTop = maxSize;
        };
        var onScroll = function() {
            resizer._reset();
            handler();
        };
        addListener(expand, "scroll", onScroll.bind(expand, "expand"));
        addListener(shrink, "scroll", onScroll.bind(shrink, "shrink"));
        return resizer;
    }
    // https://davidwalsh.name/detect-node-insertion
    function watchForRender(node, handler) {
        var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
        var proxy = expando.renderProxy = function(e) {
            if (e.animationName === CSS_RENDER_ANIMATION) handler();
        };
        helpers$1.each(ANIMATION_START_EVENTS, function(type) {
            addListener(node, type, proxy);
        });
        // #4737: Chrome might skip the CSS animation when the CSS_RENDER_MONITOR class
        // is removed then added back immediately (same animation frame?). Accessing the
        // `offsetParent` property will force a reflow and re-evaluate the CSS animation.
        // https://gist.github.com/paulirish/5d52fb081b3570c81e3a#box-metrics
        // https://github.com/chartjs/Chart.js/issues/4737
        expando.reflow = !!node.offsetParent;
        node.classList.add(CSS_RENDER_MONITOR);
    }
    function unwatchForRender(node) {
        var expando = node[EXPANDO_KEY] || {};
        var proxy = expando.renderProxy;
        if (proxy) {
            helpers$1.each(ANIMATION_START_EVENTS, function(type) {
                removeListener(node, type, proxy);
            });
            delete expando.renderProxy;
        }
        node.classList.remove(CSS_RENDER_MONITOR);
    }
    function addResizeListener(node, listener, chart) {
        var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
        // Let's keep track of this added resizer and thus avoid DOM query when removing it.
        var resizer = expando.resizer = createResizer(throttled(function() {
            if (expando.resizer) {
                var container = chart.options.maintainAspectRatio && node.parentNode;
                var w = container ? container.clientWidth : 0;
                listener(createEvent("resize", chart));
                if (container && container.clientWidth < w && chart.canvas) // If the container size shrank during chart resize, let's assume
                // scrollbar appeared. So we resize again with the scrollbar visible -
                // effectively making chart smaller and the scrollbar hidden again.
                // Because we are inside `throttled`, and currently `ticking`, scroll
                // events are ignored during this whole 2 resize process.
                // If we assumed wrong and something else happened, we are resizing
                // twice in a frame (potential performance issue)
                listener(createEvent("resize", chart));
            }
        }));
        // The resizer needs to be attached to the node parent, so we first need to be
        // sure that `node` is attached to the DOM before injecting the resizer element.
        watchForRender(node, function() {
            if (expando.resizer) {
                var container = node.parentNode;
                if (container && container !== resizer.parentNode) container.insertBefore(resizer, container.firstChild);
                // The container size might have changed, let's reset the resizer state.
                resizer._reset();
            }
        });
    }
    function removeResizeListener(node) {
        var expando = node[EXPANDO_KEY] || {};
        var resizer = expando.resizer;
        delete expando.resizer;
        unwatchForRender(node);
        if (resizer && resizer.parentNode) resizer.parentNode.removeChild(resizer);
    }
    /**
 * Injects CSS styles inline if the styles are not already present.
 * @param {HTMLDocument|ShadowRoot} rootNode - the node to contain the <style>.
 * @param {string} css - the CSS to be injected.
 */ function injectCSS(rootNode, css) {
        // https://stackoverflow.com/q/3922139
        var expando = rootNode[EXPANDO_KEY] || (rootNode[EXPANDO_KEY] = {});
        if (!expando.containsStyles) {
            expando.containsStyles = true;
            css = "/* Chart.js */\n" + css;
            var style = document.createElement("style");
            style.setAttribute("type", "text/css");
            style.appendChild(document.createTextNode(css));
            rootNode.appendChild(style);
        }
    }
    var platform_dom$2 = {
        /**
	 * When `true`, prevents the automatic injection of the stylesheet required to
	 * correctly detect when the chart is added to the DOM and then resized. This
	 * switch has been added to allow external stylesheet (`dist/Chart(.min)?.js`)
	 * to be manually imported to make this library compatible with any CSP.
	 * See https://github.com/chartjs/Chart.js/issues/5208
	 */ disableCSSInjection: false,
        /**
	 * This property holds whether this platform is enabled for the current environment.
	 * Currently used by platform.js to select the proper implementation.
	 * @private
	 */ _enabled: typeof window !== "undefined" && typeof document !== "undefined",
        /**
	 * Initializes resources that depend on platform options.
	 * @param {HTMLCanvasElement} canvas - The Canvas element.
	 * @private
	 */ _ensureLoaded: function(canvas) {
            if (!this.disableCSSInjection) {
                // If the canvas is in a shadow DOM, then the styles must also be inserted
                // into the same shadow DOM.
                // https://github.com/chartjs/Chart.js/issues/5763
                var root = canvas.getRootNode ? canvas.getRootNode() : document;
                var targetNode = root.host ? root : document.head;
                injectCSS(targetNode, stylesheet);
            }
        },
        acquireContext: function(item, config) {
            if (typeof item === "string") item = document.getElementById(item);
            else if (item.length) // Support for array based queries (such as jQuery)
            item = item[0];
            if (item && item.canvas) // Support for any object associated to a canvas (including a context2d)
            item = item.canvas;
            // To prevent canvas fingerprinting, some add-ons undefine the getContext
            // method, for example: https://github.com/kkapsner/CanvasBlocker
            // https://github.com/chartjs/Chart.js/issues/2807
            var context = item && item.getContext && item.getContext("2d");
            // `instanceof HTMLCanvasElement/CanvasRenderingContext2D` fails when the item is
            // inside an iframe or when running in a protected environment. We could guess the
            // types from their toString() value but let's keep things flexible and assume it's
            // a sufficient condition if the item has a context2D which has item as `canvas`.
            // https://github.com/chartjs/Chart.js/issues/3887
            // https://github.com/chartjs/Chart.js/issues/4102
            // https://github.com/chartjs/Chart.js/issues/4152
            if (context && context.canvas === item) {
                // Load platform resources on first chart creation, to make it possible to
                // import the library before setting platform options.
                this._ensureLoaded(item);
                initCanvas(item, config);
                return context;
            }
            return null;
        },
        releaseContext: function(context) {
            var canvas = context.canvas;
            if (!canvas[EXPANDO_KEY]) return;
            var initial = canvas[EXPANDO_KEY].initial;
            [
                "height",
                "width"
            ].forEach(function(prop) {
                var value = initial[prop];
                if (helpers$1.isNullOrUndef(value)) canvas.removeAttribute(prop);
                else canvas.setAttribute(prop, value);
            });
            helpers$1.each(initial.style || {}, function(value, key) {
                canvas.style[key] = value;
            });
            // The canvas render size might have been changed (and thus the state stack discarded),
            // we can't use save() and restore() to restore the initial state. So make sure that at
            // least the canvas context is reset to the default state by setting the canvas width.
            // https://www.w3.org/TR/2011/WD-html5-20110525/the-canvas-element.html
            // eslint-disable-next-line no-self-assign
            canvas.width = canvas.width;
            delete canvas[EXPANDO_KEY];
        },
        addEventListener: function(chart, type, listener) {
            var canvas = chart.canvas;
            if (type === "resize") {
                // Note: the resize event is not supported on all browsers.
                addResizeListener(canvas, listener, chart);
                return;
            }
            var expando = listener[EXPANDO_KEY] || (listener[EXPANDO_KEY] = {});
            var proxies = expando.proxies || (expando.proxies = {});
            var proxy = proxies[chart.id + "_" + type] = function(event) {
                listener(fromNativeEvent(event, chart));
            };
            addListener(canvas, type, proxy);
        },
        removeEventListener: function(chart, type, listener) {
            var canvas = chart.canvas;
            if (type === "resize") {
                // Note: the resize event is not supported on all browsers.
                removeResizeListener(canvas);
                return;
            }
            var expando = listener[EXPANDO_KEY] || {};
            var proxies = expando.proxies || {};
            var proxy = proxies[chart.id + "_" + type];
            if (!proxy) return;
            removeListener(canvas, type, proxy);
        }
    };
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use EventTarget.addEventListener instead.
 * EventTarget.addEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
 * @function Chart.helpers.addEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers$1.addEvent = addListener;
    /**
 * Provided for backward compatibility, use EventTarget.removeEventListener instead.
 * EventTarget.removeEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener
 * @function Chart.helpers.removeEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers$1.removeEvent = removeListener;
    // @TODO Make possible to select another platform at build time.
    var implementation = platform_dom$2._enabled ? platform_dom$2 : platform_basic;
    /**
 * @namespace Chart.platform
 * @see https://chartjs.gitbooks.io/proposals/content/Platform.html
 * @since 2.4.0
 */ var platform = helpers$1.extend({
        /**
	 * @since 2.7.0
	 */ initialize: function() {},
        /**
	 * Called at chart construction time, returns a context2d instance implementing
	 * the [W3C Canvas 2D Context API standard]{@link https://www.w3.org/TR/2dcontext/}.
	 * @param {*} item - The native item from which to acquire context (platform specific)
	 * @param {object} options - The chart options
	 * @returns {CanvasRenderingContext2D} context2d instance
	 */ acquireContext: function() {},
        /**
	 * Called at chart destruction time, releases any resources associated to the context
	 * previously returned by the acquireContext() method.
	 * @param {CanvasRenderingContext2D} context - The context2d instance
	 * @returns {boolean} true if the method succeeded, else false
	 */ releaseContext: function() {},
        /**
	 * Registers the specified listener on the given chart.
	 * @param {Chart} chart - Chart from which to listen for event
	 * @param {string} type - The ({@link IEvent}) type to listen for
	 * @param {function} listener - Receives a notification (an object that implements
	 * the {@link IEvent} interface) when an event of the specified type occurs.
	 */ addEventListener: function() {},
        /**
	 * Removes the specified listener previously registered with addEventListener.
	 * @param {Chart} chart - Chart from which to remove the listener
	 * @param {string} type - The ({@link IEvent}) type to remove
	 * @param {function} listener - The listener function to remove from the event target.
	 */ removeEventListener: function() {}
    }, implementation);
    core_defaults._set("global", {
        plugins: {}
    });
    /**
 * The plugin service singleton
 * @namespace Chart.plugins
 * @since 2.1.0
 */ var core_plugins = {
        /**
	 * Globally registered plugins.
	 * @private
	 */ _plugins: [],
        /**
	 * This identifier is used to invalidate the descriptors cache attached to each chart
	 * when a global plugin is registered or unregistered. In this case, the cache ID is
	 * incremented and descriptors are regenerated during following API calls.
	 * @private
	 */ _cacheId: 0,
        /**
	 * Registers the given plugin(s) if not already registered.
	 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
	 */ register: function(plugins) {
            var p = this._plugins;
            [].concat(plugins).forEach(function(plugin) {
                if (p.indexOf(plugin) === -1) p.push(plugin);
            });
            this._cacheId++;
        },
        /**
	 * Unregisters the given plugin(s) only if registered.
	 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
	 */ unregister: function(plugins) {
            var p = this._plugins;
            [].concat(plugins).forEach(function(plugin) {
                var idx = p.indexOf(plugin);
                if (idx !== -1) p.splice(idx, 1);
            });
            this._cacheId++;
        },
        /**
	 * Remove all registered plugins.
	 * @since 2.1.5
	 */ clear: function() {
            this._plugins = [];
            this._cacheId++;
        },
        /**
	 * Returns the number of registered plugins?
	 * @returns {number}
	 * @since 2.1.5
	 */ count: function() {
            return this._plugins.length;
        },
        /**
	 * Returns all registered plugin instances.
	 * @returns {IPlugin[]} array of plugin objects.
	 * @since 2.1.5
	 */ getAll: function() {
            return this._plugins;
        },
        /**
	 * Calls enabled plugins for `chart` on the specified hook and with the given args.
	 * This method immediately returns as soon as a plugin explicitly returns false. The
	 * returned value can be used, for instance, to interrupt the current action.
	 * @param {Chart} chart - The chart instance for which plugins should be called.
	 * @param {string} hook - The name of the plugin method to call (e.g. 'beforeUpdate').
	 * @param {Array} [args] - Extra arguments to apply to the hook call.
	 * @returns {boolean} false if any of the plugins return false, else returns true.
	 */ notify: function(chart, hook, args) {
            var descriptors = this.descriptors(chart);
            var ilen = descriptors.length;
            var i, descriptor, plugin, params, method;
            for(i = 0; i < ilen; ++i){
                descriptor = descriptors[i];
                plugin = descriptor.plugin;
                method = plugin[hook];
                if (typeof method === "function") {
                    params = [
                        chart
                    ].concat(args || []);
                    params.push(descriptor.options);
                    if (method.apply(plugin, params) === false) return false;
                }
            }
            return true;
        },
        /**
	 * Returns descriptors of enabled plugins for the given chart.
	 * @returns {object[]} [{ plugin, options }]
	 * @private
	 */ descriptors: function(chart) {
            var cache = chart.$plugins || (chart.$plugins = {});
            if (cache.id === this._cacheId) return cache.descriptors;
            var plugins = [];
            var descriptors = [];
            var config = chart && chart.config || {};
            var options = config.options && config.options.plugins || {};
            this._plugins.concat(config.plugins || []).forEach(function(plugin) {
                var idx = plugins.indexOf(plugin);
                if (idx !== -1) return;
                var id = plugin.id;
                var opts = options[id];
                if (opts === false) return;
                if (opts === true) opts = helpers$1.clone(core_defaults.global.plugins[id]);
                plugins.push(plugin);
                descriptors.push({
                    plugin: plugin,
                    options: opts || {}
                });
            });
            cache.descriptors = descriptors;
            cache.id = this._cacheId;
            return descriptors;
        },
        /**
	 * Invalidates cache for the given chart: descriptors hold a reference on plugin option,
	 * but in some cases, this reference can be changed by the user when updating options.
	 * https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
	 * @private
	 */ _invalidate: function(chart) {
            delete chart.$plugins;
        }
    };
    var core_scaleService = {
        // Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
        // use the new chart options to grab the correct scale
        constructors: {},
        // Use a registration function so that we can move to an ES6 map when we no longer need to support
        // old browsers
        // Scale config defaults
        defaults: {},
        registerScaleType: function(type, scaleConstructor, scaleDefaults) {
            this.constructors[type] = scaleConstructor;
            this.defaults[type] = helpers$1.clone(scaleDefaults);
        },
        getScaleConstructor: function(type) {
            return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
        },
        getScaleDefaults: function(type) {
            // Return the scale defaults merged with the global settings so that we always use the latest ones
            return this.defaults.hasOwnProperty(type) ? helpers$1.merge(Object.create(null), [
                core_defaults.scale,
                this.defaults[type]
            ]) : {};
        },
        updateScaleDefaults: function(type, additions) {
            var me = this;
            if (me.defaults.hasOwnProperty(type)) me.defaults[type] = helpers$1.extend(me.defaults[type], additions);
        },
        addScalesToLayout: function(chart) {
            // Adds each scale to the chart.boxes array to be sized accordingly
            helpers$1.each(chart.scales, function(scale) {
                // Set ILayoutItem parameters for backwards compatibility
                scale.fullWidth = scale.options.fullWidth;
                scale.position = scale.options.position;
                scale.weight = scale.options.weight;
                core_layouts.addBox(chart, scale);
            });
        }
    };
    var valueOrDefault$8 = helpers$1.valueOrDefault;
    var getRtlHelper = helpers$1.rtl.getRtlAdapter;
    core_defaults._set("global", {
        tooltips: {
            enabled: true,
            custom: null,
            mode: "nearest",
            position: "average",
            intersect: true,
            backgroundColor: "rgba(0,0,0,0.8)",
            titleFontStyle: "bold",
            titleSpacing: 2,
            titleMarginBottom: 6,
            titleFontColor: "#fff",
            titleAlign: "left",
            bodySpacing: 2,
            bodyFontColor: "#fff",
            bodyAlign: "left",
            footerFontStyle: "bold",
            footerSpacing: 2,
            footerMarginTop: 6,
            footerFontColor: "#fff",
            footerAlign: "left",
            yPadding: 6,
            xPadding: 6,
            caretPadding: 2,
            caretSize: 5,
            cornerRadius: 6,
            multiKeyBackground: "#fff",
            displayColors: true,
            borderColor: "rgba(0,0,0,0)",
            borderWidth: 0,
            callbacks: {
                // Args are: (tooltipItems, data)
                beforeTitle: helpers$1.noop,
                title: function(tooltipItems, data) {
                    var title = "";
                    var labels = data.labels;
                    var labelCount = labels ? labels.length : 0;
                    if (tooltipItems.length > 0) {
                        var item = tooltipItems[0];
                        if (item.label) title = item.label;
                        else if (item.xLabel) title = item.xLabel;
                        else if (labelCount > 0 && item.index < labelCount) title = labels[item.index];
                    }
                    return title;
                },
                afterTitle: helpers$1.noop,
                // Args are: (tooltipItems, data)
                beforeBody: helpers$1.noop,
                // Args are: (tooltipItem, data)
                beforeLabel: helpers$1.noop,
                label: function(tooltipItem, data) {
                    var label = data.datasets[tooltipItem.datasetIndex].label || "";
                    if (label) label += ": ";
                    if (!helpers$1.isNullOrUndef(tooltipItem.value)) label += tooltipItem.value;
                    else label += tooltipItem.yLabel;
                    return label;
                },
                labelColor: function(tooltipItem, chart) {
                    var meta = chart.getDatasetMeta(tooltipItem.datasetIndex);
                    var activeElement = meta.data[tooltipItem.index];
                    var view = activeElement._view;
                    return {
                        borderColor: view.borderColor,
                        backgroundColor: view.backgroundColor
                    };
                },
                labelTextColor: function() {
                    return this._options.bodyFontColor;
                },
                afterLabel: helpers$1.noop,
                // Args are: (tooltipItems, data)
                afterBody: helpers$1.noop,
                // Args are: (tooltipItems, data)
                beforeFooter: helpers$1.noop,
                footer: helpers$1.noop,
                afterFooter: helpers$1.noop
            }
        }
    });
    var positioners = {
        /**
	 * Average mode places the tooltip at the average position of the elements shown
	 * @function Chart.Tooltip.positioners.average
	 * @param elements {ChartElement[]} the elements being displayed in the tooltip
	 * @returns {object} tooltip position
	 */ average: function(elements) {
            if (!elements.length) return false;
            var i, len;
            var x = 0;
            var y = 0;
            var count = 0;
            for(i = 0, len = elements.length; i < len; ++i){
                var el = elements[i];
                if (el && el.hasValue()) {
                    var pos = el.tooltipPosition();
                    x += pos.x;
                    y += pos.y;
                    ++count;
                }
            }
            return {
                x: x / count,
                y: y / count
            };
        },
        /**
	 * Gets the tooltip position nearest of the item nearest to the event position
	 * @function Chart.Tooltip.positioners.nearest
	 * @param elements {Chart.Element[]} the tooltip elements
	 * @param eventPosition {object} the position of the event in canvas coordinates
	 * @returns {object} the tooltip position
	 */ nearest: function(elements, eventPosition) {
            var x = eventPosition.x;
            var y = eventPosition.y;
            var minDistance = Number.POSITIVE_INFINITY;
            var i, len, nearestElement;
            for(i = 0, len = elements.length; i < len; ++i){
                var el = elements[i];
                if (el && el.hasValue()) {
                    var center = el.getCenterPoint();
                    var d = helpers$1.distanceBetweenPoints(eventPosition, center);
                    if (d < minDistance) {
                        minDistance = d;
                        nearestElement = el;
                    }
                }
            }
            if (nearestElement) {
                var tp = nearestElement.tooltipPosition();
                x = tp.x;
                y = tp.y;
            }
            return {
                x: x,
                y: y
            };
        }
    };
    // Helper to push or concat based on if the 2nd parameter is an array or not
    function pushOrConcat(base, toPush) {
        if (toPush) {
            if (helpers$1.isArray(toPush)) // base = base.concat(toPush);
            Array.prototype.push.apply(base, toPush);
            else base.push(toPush);
        }
        return base;
    }
    /**
 * Returns array of strings split by newline
 * @param {string} value - The value to split by newline.
 * @returns {string[]} value if newline present - Returned from String split() method
 * @function
 */ function splitNewlines(str) {
        if ((typeof str === "string" || str instanceof String) && str.indexOf("\n") > -1) return str.split("\n");
        return str;
    }
    /**
 * Private helper to create a tooltip item model
 * @param element - the chart element (point, arc, bar) to create the tooltip item for
 * @return new tooltip item
 */ function createTooltipItem(element) {
        var xScale = element._xScale;
        var yScale = element._yScale || element._scale; // handle radar || polarArea charts
        var index = element._index;
        var datasetIndex = element._datasetIndex;
        var controller = element._chart.getDatasetMeta(datasetIndex).controller;
        var indexScale = controller._getIndexScale();
        var valueScale = controller._getValueScale();
        return {
            xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : "",
            yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : "",
            label: indexScale ? "" + indexScale.getLabelForIndex(index, datasetIndex) : "",
            value: valueScale ? "" + valueScale.getLabelForIndex(index, datasetIndex) : "",
            index: index,
            datasetIndex: datasetIndex,
            x: element._model.x,
            y: element._model.y
        };
    }
    /**
 * Helper to get the reset model for the tooltip
 * @param tooltipOpts {object} the tooltip options
 */ function getBaseModel(tooltipOpts) {
        var globalDefaults = core_defaults.global;
        return {
            // Positioning
            xPadding: tooltipOpts.xPadding,
            yPadding: tooltipOpts.yPadding,
            xAlign: tooltipOpts.xAlign,
            yAlign: tooltipOpts.yAlign,
            // Drawing direction and text direction
            rtl: tooltipOpts.rtl,
            textDirection: tooltipOpts.textDirection,
            // Body
            bodyFontColor: tooltipOpts.bodyFontColor,
            _bodyFontFamily: valueOrDefault$8(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
            _bodyFontStyle: valueOrDefault$8(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
            _bodyAlign: tooltipOpts.bodyAlign,
            bodyFontSize: valueOrDefault$8(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
            bodySpacing: tooltipOpts.bodySpacing,
            // Title
            titleFontColor: tooltipOpts.titleFontColor,
            _titleFontFamily: valueOrDefault$8(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
            _titleFontStyle: valueOrDefault$8(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
            titleFontSize: valueOrDefault$8(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
            _titleAlign: tooltipOpts.titleAlign,
            titleSpacing: tooltipOpts.titleSpacing,
            titleMarginBottom: tooltipOpts.titleMarginBottom,
            // Footer
            footerFontColor: tooltipOpts.footerFontColor,
            _footerFontFamily: valueOrDefault$8(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
            _footerFontStyle: valueOrDefault$8(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
            footerFontSize: valueOrDefault$8(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
            _footerAlign: tooltipOpts.footerAlign,
            footerSpacing: tooltipOpts.footerSpacing,
            footerMarginTop: tooltipOpts.footerMarginTop,
            // Appearance
            caretSize: tooltipOpts.caretSize,
            cornerRadius: tooltipOpts.cornerRadius,
            backgroundColor: tooltipOpts.backgroundColor,
            opacity: 0,
            legendColorBackground: tooltipOpts.multiKeyBackground,
            displayColors: tooltipOpts.displayColors,
            borderColor: tooltipOpts.borderColor,
            borderWidth: tooltipOpts.borderWidth
        };
    }
    /**
 * Get the size of the tooltip
 */ function getTooltipSize(tooltip, model) {
        var ctx = tooltip._chart.ctx;
        var height = model.yPadding * 2; // Tooltip Padding
        var width = 0;
        // Count of all lines in the body
        var body = model.body;
        var combinedBodyLength = body.reduce(function(count, bodyItem) {
            return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
        }, 0);
        combinedBodyLength += model.beforeBody.length + model.afterBody.length;
        var titleLineCount = model.title.length;
        var footerLineCount = model.footer.length;
        var titleFontSize = model.titleFontSize;
        var bodyFontSize = model.bodyFontSize;
        var footerFontSize = model.footerFontSize;
        height += titleLineCount * titleFontSize; // Title Lines
        height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0; // Title Line Spacing
        height += titleLineCount ? model.titleMarginBottom : 0; // Title's bottom Margin
        height += combinedBodyLength * bodyFontSize; // Body Lines
        height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0; // Body Line Spacing
        height += footerLineCount ? model.footerMarginTop : 0; // Footer Margin
        height += footerLineCount * footerFontSize; // Footer Lines
        height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0; // Footer Line Spacing
        // Title width
        var widthPadding = 0;
        var maxLineWidth = function(line) {
            width = Math.max(width, ctx.measureText(line).width + widthPadding);
        };
        ctx.font = helpers$1.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
        helpers$1.each(model.title, maxLineWidth);
        // Body width
        ctx.font = helpers$1.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
        helpers$1.each(model.beforeBody.concat(model.afterBody), maxLineWidth);
        // Body lines may include some extra width due to the color box
        widthPadding = model.displayColors ? bodyFontSize + 2 : 0;
        helpers$1.each(body, function(bodyItem) {
            helpers$1.each(bodyItem.before, maxLineWidth);
            helpers$1.each(bodyItem.lines, maxLineWidth);
            helpers$1.each(bodyItem.after, maxLineWidth);
        });
        // Reset back to 0
        widthPadding = 0;
        // Footer width
        ctx.font = helpers$1.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
        helpers$1.each(model.footer, maxLineWidth);
        // Add padding
        width += 2 * model.xPadding;
        return {
            width: width,
            height: height
        };
    }
    /**
 * Helper to get the alignment of a tooltip given the size
 */ function determineAlignment(tooltip, size) {
        var model = tooltip._model;
        var chart = tooltip._chart;
        var chartArea = tooltip._chart.chartArea;
        var xAlign = "center";
        var yAlign = "center";
        if (model.y < size.height) yAlign = "top";
        else if (model.y > chart.height - size.height) yAlign = "bottom";
        var lf, rf; // functions to determine left, right alignment
        var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
        var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
        var midX = (chartArea.left + chartArea.right) / 2;
        var midY = (chartArea.top + chartArea.bottom) / 2;
        if (yAlign === "center") {
            lf = function(x) {
                return x <= midX;
            };
            rf = function(x) {
                return x > midX;
            };
        } else {
            lf = function(x) {
                return x <= size.width / 2;
            };
            rf = function(x) {
                return x >= chart.width - size.width / 2;
            };
        }
        olf = function(x) {
            return x + size.width + model.caretSize + model.caretPadding > chart.width;
        };
        orf = function(x) {
            return x - size.width - model.caretSize - model.caretPadding < 0;
        };
        yf = function(y) {
            return y <= midY ? "top" : "bottom";
        };
        if (lf(model.x)) {
            xAlign = "left";
            // Is tooltip too wide and goes over the right side of the chart.?
            if (olf(model.x)) {
                xAlign = "center";
                yAlign = yf(model.y);
            }
        } else if (rf(model.x)) {
            xAlign = "right";
            // Is tooltip too wide and goes outside left edge of canvas?
            if (orf(model.x)) {
                xAlign = "center";
                yAlign = yf(model.y);
            }
        }
        var opts = tooltip._options;
        return {
            xAlign: opts.xAlign ? opts.xAlign : xAlign,
            yAlign: opts.yAlign ? opts.yAlign : yAlign
        };
    }
    /**
 * Helper to get the location a tooltip needs to be placed at given the initial position (via the vm) and the size and alignment
 */ function getBackgroundPoint(vm, size, alignment, chart) {
        // Background Position
        var x = vm.x;
        var y = vm.y;
        var caretSize = vm.caretSize;
        var caretPadding = vm.caretPadding;
        var cornerRadius = vm.cornerRadius;
        var xAlign = alignment.xAlign;
        var yAlign = alignment.yAlign;
        var paddingAndSize = caretSize + caretPadding;
        var radiusAndPadding = cornerRadius + caretPadding;
        if (xAlign === "right") x -= size.width;
        else if (xAlign === "center") {
            x -= size.width / 2;
            if (x + size.width > chart.width) x = chart.width - size.width;
            if (x < 0) x = 0;
        }
        if (yAlign === "top") y += paddingAndSize;
        else if (yAlign === "bottom") y -= size.height + paddingAndSize;
        else y -= size.height / 2;
        if (yAlign === "center") {
            if (xAlign === "left") x += paddingAndSize;
            else if (xAlign === "right") x -= paddingAndSize;
        } else if (xAlign === "left") x -= radiusAndPadding;
        else if (xAlign === "right") x += radiusAndPadding;
        return {
            x: x,
            y: y
        };
    }
    function getAlignedX(vm, align) {
        return align === "center" ? vm.x + vm.width / 2 : align === "right" ? vm.x + vm.width - vm.xPadding : vm.x + vm.xPadding;
    }
    /**
 * Helper to build before and after body lines
 */ function getBeforeAfterBodyLines(callback) {
        return pushOrConcat([], splitNewlines(callback));
    }
    var exports$4 = core_element.extend({
        initialize: function() {
            this._model = getBaseModel(this._options);
            this._lastActive = [];
        },
        // Get the title
        // Args are: (tooltipItem, data)
        getTitle: function() {
            var me = this;
            var opts = me._options;
            var callbacks = opts.callbacks;
            var beforeTitle = callbacks.beforeTitle.apply(me, arguments);
            var title = callbacks.title.apply(me, arguments);
            var afterTitle = callbacks.afterTitle.apply(me, arguments);
            var lines = [];
            lines = pushOrConcat(lines, splitNewlines(beforeTitle));
            lines = pushOrConcat(lines, splitNewlines(title));
            lines = pushOrConcat(lines, splitNewlines(afterTitle));
            return lines;
        },
        // Args are: (tooltipItem, data)
        getBeforeBody: function() {
            return getBeforeAfterBodyLines(this._options.callbacks.beforeBody.apply(this, arguments));
        },
        // Args are: (tooltipItem, data)
        getBody: function(tooltipItems, data) {
            var me = this;
            var callbacks = me._options.callbacks;
            var bodyItems = [];
            helpers$1.each(tooltipItems, function(tooltipItem) {
                var bodyItem = {
                    before: [],
                    lines: [],
                    after: []
                };
                pushOrConcat(bodyItem.before, splitNewlines(callbacks.beforeLabel.call(me, tooltipItem, data)));
                pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
                pushOrConcat(bodyItem.after, splitNewlines(callbacks.afterLabel.call(me, tooltipItem, data)));
                bodyItems.push(bodyItem);
            });
            return bodyItems;
        },
        // Args are: (tooltipItem, data)
        getAfterBody: function() {
            return getBeforeAfterBodyLines(this._options.callbacks.afterBody.apply(this, arguments));
        },
        // Get the footer and beforeFooter and afterFooter lines
        // Args are: (tooltipItem, data)
        getFooter: function() {
            var me = this;
            var callbacks = me._options.callbacks;
            var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
            var footer = callbacks.footer.apply(me, arguments);
            var afterFooter = callbacks.afterFooter.apply(me, arguments);
            var lines = [];
            lines = pushOrConcat(lines, splitNewlines(beforeFooter));
            lines = pushOrConcat(lines, splitNewlines(footer));
            lines = pushOrConcat(lines, splitNewlines(afterFooter));
            return lines;
        },
        update: function(changed) {
            var me = this;
            var opts = me._options;
            // Need to regenerate the model because its faster than using extend and it is necessary due to the optimization in Chart.Element.transition
            // that does _view = _model if ease === 1. This causes the 2nd tooltip update to set properties in both the view and model at the same time
            // which breaks any animations.
            var existingModel = me._model;
            var model = me._model = getBaseModel(opts);
            var active = me._active;
            var data = me._data;
            // In the case where active.length === 0 we need to keep these at existing values for good animations
            var alignment = {
                xAlign: existingModel.xAlign,
                yAlign: existingModel.yAlign
            };
            var backgroundPoint = {
                x: existingModel.x,
                y: existingModel.y
            };
            var tooltipSize = {
                width: existingModel.width,
                height: existingModel.height
            };
            var tooltipPosition = {
                x: existingModel.caretX,
                y: existingModel.caretY
            };
            var i, len;
            if (active.length) {
                model.opacity = 1;
                var labelColors = [];
                var labelTextColors = [];
                tooltipPosition = positioners[opts.position].call(me, active, me._eventPosition);
                var tooltipItems = [];
                for(i = 0, len = active.length; i < len; ++i)tooltipItems.push(createTooltipItem(active[i]));
                // If the user provided a filter function, use it to modify the tooltip items
                if (opts.filter) tooltipItems = tooltipItems.filter(function(a) {
                    return opts.filter(a, data);
                });
                // If the user provided a sorting function, use it to modify the tooltip items
                if (opts.itemSort) tooltipItems = tooltipItems.sort(function(a, b) {
                    return opts.itemSort(a, b, data);
                });
                // Determine colors for boxes
                helpers$1.each(tooltipItems, function(tooltipItem) {
                    labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
                    labelTextColors.push(opts.callbacks.labelTextColor.call(me, tooltipItem, me._chart));
                });
                // Build the Text Lines
                model.title = me.getTitle(tooltipItems, data);
                model.beforeBody = me.getBeforeBody(tooltipItems, data);
                model.body = me.getBody(tooltipItems, data);
                model.afterBody = me.getAfterBody(tooltipItems, data);
                model.footer = me.getFooter(tooltipItems, data);
                // Initial positioning and colors
                model.x = tooltipPosition.x;
                model.y = tooltipPosition.y;
                model.caretPadding = opts.caretPadding;
                model.labelColors = labelColors;
                model.labelTextColors = labelTextColors;
                // data points
                model.dataPoints = tooltipItems;
                // We need to determine alignment of the tooltip
                tooltipSize = getTooltipSize(this, model);
                alignment = determineAlignment(this, tooltipSize);
                // Final Size and Position
                backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment, me._chart);
            } else model.opacity = 0;
            model.xAlign = alignment.xAlign;
            model.yAlign = alignment.yAlign;
            model.x = backgroundPoint.x;
            model.y = backgroundPoint.y;
            model.width = tooltipSize.width;
            model.height = tooltipSize.height;
            // Point where the caret on the tooltip points to
            model.caretX = tooltipPosition.x;
            model.caretY = tooltipPosition.y;
            me._model = model;
            if (changed && opts.custom) opts.custom.call(me, model);
            return me;
        },
        drawCaret: function(tooltipPoint, size) {
            var ctx = this._chart.ctx;
            var vm = this._view;
            var caretPosition = this.getCaretPosition(tooltipPoint, size, vm);
            ctx.lineTo(caretPosition.x1, caretPosition.y1);
            ctx.lineTo(caretPosition.x2, caretPosition.y2);
            ctx.lineTo(caretPosition.x3, caretPosition.y3);
        },
        getCaretPosition: function(tooltipPoint, size, vm) {
            var x1, x2, x3, y1, y2, y3;
            var caretSize = vm.caretSize;
            var cornerRadius = vm.cornerRadius;
            var xAlign = vm.xAlign;
            var yAlign = vm.yAlign;
            var ptX = tooltipPoint.x;
            var ptY = tooltipPoint.y;
            var width = size.width;
            var height = size.height;
            if (yAlign === "center") {
                y2 = ptY + height / 2;
                if (xAlign === "left") {
                    x1 = ptX;
                    x2 = x1 - caretSize;
                    x3 = x1;
                    y1 = y2 + caretSize;
                    y3 = y2 - caretSize;
                } else {
                    x1 = ptX + width;
                    x2 = x1 + caretSize;
                    x3 = x1;
                    y1 = y2 - caretSize;
                    y3 = y2 + caretSize;
                }
            } else {
                if (xAlign === "left") {
                    x2 = ptX + cornerRadius + caretSize;
                    x1 = x2 - caretSize;
                    x3 = x2 + caretSize;
                } else if (xAlign === "right") {
                    x2 = ptX + width - cornerRadius - caretSize;
                    x1 = x2 - caretSize;
                    x3 = x2 + caretSize;
                } else {
                    x2 = vm.caretX;
                    x1 = x2 - caretSize;
                    x3 = x2 + caretSize;
                }
                if (yAlign === "top") {
                    y1 = ptY;
                    y2 = y1 - caretSize;
                    y3 = y1;
                } else {
                    y1 = ptY + height;
                    y2 = y1 + caretSize;
                    y3 = y1;
                    // invert drawing order
                    var tmp = x3;
                    x3 = x1;
                    x1 = tmp;
                }
            }
            return {
                x1: x1,
                x2: x2,
                x3: x3,
                y1: y1,
                y2: y2,
                y3: y3
            };
        },
        drawTitle: function(pt, vm, ctx) {
            var title = vm.title;
            var length = title.length;
            var titleFontSize, titleSpacing, i;
            if (length) {
                var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
                pt.x = getAlignedX(vm, vm._titleAlign);
                ctx.textAlign = rtlHelper.textAlign(vm._titleAlign);
                ctx.textBaseline = "middle";
                titleFontSize = vm.titleFontSize;
                titleSpacing = vm.titleSpacing;
                ctx.fillStyle = vm.titleFontColor;
                ctx.font = helpers$1.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);
                for(i = 0; i < length; ++i){
                    ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFontSize / 2);
                    pt.y += titleFontSize + titleSpacing; // Line Height and spacing
                    if (i + 1 === length) pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
                }
            }
        },
        drawBody: function(pt, vm, ctx) {
            var bodyFontSize = vm.bodyFontSize;
            var bodySpacing = vm.bodySpacing;
            var bodyAlign = vm._bodyAlign;
            var body = vm.body;
            var drawColorBoxes = vm.displayColors;
            var xLinePadding = 0;
            var colorX = drawColorBoxes ? getAlignedX(vm, "left") : 0;
            var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
            var fillLineOfText = function(line) {
                ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyFontSize / 2);
                pt.y += bodyFontSize + bodySpacing;
            };
            var bodyItem, textColor, labelColors, lines, i, j, ilen, jlen;
            var bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
            ctx.textAlign = bodyAlign;
            ctx.textBaseline = "middle";
            ctx.font = helpers$1.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);
            pt.x = getAlignedX(vm, bodyAlignForCalculation);
            // Before body lines
            ctx.fillStyle = vm.bodyFontColor;
            helpers$1.each(vm.beforeBody, fillLineOfText);
            xLinePadding = drawColorBoxes && bodyAlignForCalculation !== "right" ? bodyAlign === "center" ? bodyFontSize / 2 + 1 : bodyFontSize + 2 : 0;
            // Draw body lines now
            for(i = 0, ilen = body.length; i < ilen; ++i){
                bodyItem = body[i];
                textColor = vm.labelTextColors[i];
                labelColors = vm.labelColors[i];
                ctx.fillStyle = textColor;
                helpers$1.each(bodyItem.before, fillLineOfText);
                lines = bodyItem.lines;
                for(j = 0, jlen = lines.length; j < jlen; ++j){
                    // Draw Legend-like boxes if needed
                    if (drawColorBoxes) {
                        var rtlColorX = rtlHelper.x(colorX);
                        // Fill a white rect so that colours merge nicely if the opacity is < 1
                        ctx.fillStyle = vm.legendColorBackground;
                        ctx.fillRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);
                        // Border
                        ctx.lineWidth = 1;
                        ctx.strokeStyle = labelColors.borderColor;
                        ctx.strokeRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);
                        // Inner square
                        ctx.fillStyle = labelColors.backgroundColor;
                        ctx.fillRect(rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), bodyFontSize - 2), pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
                        ctx.fillStyle = textColor;
                    }
                    fillLineOfText(lines[j]);
                }
                helpers$1.each(bodyItem.after, fillLineOfText);
            }
            // Reset back to 0 for after body
            xLinePadding = 0;
            // After body lines
            helpers$1.each(vm.afterBody, fillLineOfText);
            pt.y -= bodySpacing; // Remove last body spacing
        },
        drawFooter: function(pt, vm, ctx) {
            var footer = vm.footer;
            var length = footer.length;
            var footerFontSize, i;
            if (length) {
                var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
                pt.x = getAlignedX(vm, vm._footerAlign);
                pt.y += vm.footerMarginTop;
                ctx.textAlign = rtlHelper.textAlign(vm._footerAlign);
                ctx.textBaseline = "middle";
                footerFontSize = vm.footerFontSize;
                ctx.fillStyle = vm.footerFontColor;
                ctx.font = helpers$1.fontString(footerFontSize, vm._footerFontStyle, vm._footerFontFamily);
                for(i = 0; i < length; ++i){
                    ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFontSize / 2);
                    pt.y += footerFontSize + vm.footerSpacing;
                }
            }
        },
        drawBackground: function(pt, vm, ctx, tooltipSize) {
            ctx.fillStyle = vm.backgroundColor;
            ctx.strokeStyle = vm.borderColor;
            ctx.lineWidth = vm.borderWidth;
            var xAlign = vm.xAlign;
            var yAlign = vm.yAlign;
            var x = pt.x;
            var y = pt.y;
            var width = tooltipSize.width;
            var height = tooltipSize.height;
            var radius = vm.cornerRadius;
            ctx.beginPath();
            ctx.moveTo(x + radius, y);
            if (yAlign === "top") this.drawCaret(pt, tooltipSize);
            ctx.lineTo(x + width - radius, y);
            ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
            if (yAlign === "center" && xAlign === "right") this.drawCaret(pt, tooltipSize);
            ctx.lineTo(x + width, y + height - radius);
            ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
            if (yAlign === "bottom") this.drawCaret(pt, tooltipSize);
            ctx.lineTo(x + radius, y + height);
            ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
            if (yAlign === "center" && xAlign === "left") this.drawCaret(pt, tooltipSize);
            ctx.lineTo(x, y + radius);
            ctx.quadraticCurveTo(x, y, x + radius, y);
            ctx.closePath();
            ctx.fill();
            if (vm.borderWidth > 0) ctx.stroke();
        },
        draw: function() {
            var ctx = this._chart.ctx;
            var vm = this._view;
            if (vm.opacity === 0) return;
            var tooltipSize = {
                width: vm.width,
                height: vm.height
            };
            var pt = {
                x: vm.x,
                y: vm.y
            };
            // IE11/Edge does not like very small opacities, so snap to 0
            var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;
            // Truthy/falsey value for empty tooltip
            var hasTooltipContent = vm.title.length || vm.beforeBody.length || vm.body.length || vm.afterBody.length || vm.footer.length;
            if (this._options.enabled && hasTooltipContent) {
                ctx.save();
                ctx.globalAlpha = opacity;
                // Draw Background
                this.drawBackground(pt, vm, ctx, tooltipSize);
                // Draw Title, Body, and Footer
                pt.y += vm.yPadding;
                helpers$1.rtl.overrideTextDirection(ctx, vm.textDirection);
                // Titles
                this.drawTitle(pt, vm, ctx);
                // Body
                this.drawBody(pt, vm, ctx);
                // Footer
                this.drawFooter(pt, vm, ctx);
                helpers$1.rtl.restoreTextDirection(ctx, vm.textDirection);
                ctx.restore();
            }
        },
        /**
	 * Handle an event
	 * @private
	 * @param {IEvent} event - The event to handle
	 * @returns {boolean} true if the tooltip changed
	 */ handleEvent: function(e) {
            var me = this;
            var options = me._options;
            var changed = false;
            me._lastActive = me._lastActive || [];
            // Find Active Elements for tooltips
            if (e.type === "mouseout") me._active = [];
            else {
                me._active = me._chart.getElementsAtEventForMode(e, options.mode, options);
                if (options.reverse) me._active.reverse();
            }
            // Remember Last Actives
            changed = !helpers$1.arrayEquals(me._active, me._lastActive);
            // Only handle target event on tooltip change
            if (changed) {
                me._lastActive = me._active;
                if (options.enabled || options.custom) {
                    me._eventPosition = {
                        x: e.x,
                        y: e.y
                    };
                    me.update(true);
                    me.pivot();
                }
            }
            return changed;
        }
    });
    /**
 * @namespace Chart.Tooltip.positioners
 */ var positioners_1 = positioners;
    var core_tooltip = exports$4;
    core_tooltip.positioners = positioners_1;
    var valueOrDefault$9 = helpers$1.valueOrDefault;
    core_defaults._set("global", {
        elements: {},
        events: [
            "mousemove",
            "mouseout",
            "click",
            "touchstart",
            "touchmove"
        ],
        hover: {
            onHover: null,
            mode: "nearest",
            intersect: true,
            animationDuration: 400
        },
        onClick: null,
        maintainAspectRatio: true,
        responsive: true,
        responsiveAnimationDuration: 0
    });
    /**
 * Recursively merge the given config objects representing the `scales` option
 * by incorporating scale defaults in `xAxes` and `yAxes` array items, then
 * returns a deep copy of the result, thus doesn't alter inputs.
 */ function mergeScaleConfig() {
        return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
            merger: function(key, target, source, options) {
                if (key === "xAxes" || key === "yAxes") {
                    var slen = source[key].length;
                    var i, type, scale;
                    if (!target[key]) target[key] = [];
                    for(i = 0; i < slen; ++i){
                        scale = source[key][i];
                        type = valueOrDefault$9(scale.type, key === "xAxes" ? "category" : "linear");
                        if (i >= target[key].length) target[key].push({});
                        if (!target[key][i].type || scale.type && scale.type !== target[key][i].type) // new/untyped scale or type changed: let's apply the new defaults
                        // then merge source scale to correctly overwrite the defaults.
                        helpers$1.merge(target[key][i], [
                            core_scaleService.getScaleDefaults(type),
                            scale
                        ]);
                        else // scales type are the same
                        helpers$1.merge(target[key][i], scale);
                    }
                } else helpers$1._merger(key, target, source, options);
            }
        });
    }
    /**
 * Recursively merge the given config objects as the root options by handling
 * default scale options for the `scales` and `scale` properties, then returns
 * a deep copy of the result, thus doesn't alter inputs.
 */ function mergeConfig() {
        return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
            merger: function(key, target, source, options) {
                var tval = target[key] || Object.create(null);
                var sval = source[key];
                if (key === "scales") // scale config merging is complex. Add our own function here for that
                target[key] = mergeScaleConfig(tval, sval);
                else if (key === "scale") // used in polar area & radar charts since there is only one scale
                target[key] = helpers$1.merge(tval, [
                    core_scaleService.getScaleDefaults(sval.type),
                    sval
                ]);
                else helpers$1._merger(key, target, source, options);
            }
        });
    }
    function initConfig(config) {
        config = config || Object.create(null);
        // Do NOT use mergeConfig for the data object because this method merges arrays
        // and so would change references to labels and datasets, preventing data updates.
        var data = config.data = config.data || {};
        data.datasets = data.datasets || [];
        data.labels = data.labels || [];
        config.options = mergeConfig(core_defaults.global, core_defaults[config.type], config.options || {});
        return config;
    }
    function updateConfig(chart) {
        var newOptions = chart.options;
        helpers$1.each(chart.scales, function(scale) {
            core_layouts.removeBox(chart, scale);
        });
        newOptions = mergeConfig(core_defaults.global, core_defaults[chart.config.type], newOptions);
        chart.options = chart.config.options = newOptions;
        chart.ensureScalesHaveIDs();
        chart.buildOrUpdateScales();
        // Tooltip
        chart.tooltip._options = newOptions.tooltips;
        chart.tooltip.initialize();
    }
    function nextAvailableScaleId(axesOpts, prefix, index) {
        var id;
        var hasId = function(obj) {
            return obj.id === id;
        };
        do id = prefix + index++;
        while (helpers$1.findIndex(axesOpts, hasId) >= 0);
        return id;
    }
    function positionIsHorizontal(position) {
        return position === "top" || position === "bottom";
    }
    function compare2Level(l1, l2) {
        return function(a, b) {
            return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
        };
    }
    var Chart = function(item, config) {
        this.construct(item, config);
        return this;
    };
    helpers$1.extend(Chart.prototype, /** @lends Chart */ {
        /**
	 * @private
	 */ construct: function(item, config) {
            var me = this;
            config = initConfig(config);
            var context = platform.acquireContext(item, config);
            var canvas = context && context.canvas;
            var height = canvas && canvas.height;
            var width = canvas && canvas.width;
            me.id = helpers$1.uid();
            me.ctx = context;
            me.canvas = canvas;
            me.config = config;
            me.width = width;
            me.height = height;
            me.aspectRatio = height ? width / height : null;
            me.options = config.options;
            me._bufferedRender = false;
            me._layers = [];
            /**
		 * Provided for backward compatibility, Chart and Chart.Controller have been merged,
		 * the "instance" still need to be defined since it might be called from plugins.
		 * @prop Chart#chart
		 * @deprecated since version 2.6.0
		 * @todo remove at version 3
		 * @private
		 */ me.chart = me;
            me.controller = me; // chart.chart.controller #inception
            // Add the chart instance to the global namespace
            Chart.instances[me.id] = me;
            // Define alias to the config data: `chart.data === chart.config.data`
            Object.defineProperty(me, "data", {
                get: function() {
                    return me.config.data;
                },
                set: function(value) {
                    me.config.data = value;
                }
            });
            if (!context || !canvas) {
                // The given item is not a compatible context2d element, let's return before finalizing
                // the chart initialization but after setting basic chart / controller properties that
                // can help to figure out that the chart is not valid (e.g chart.canvas !== null);
                // https://github.com/chartjs/Chart.js/issues/2807
                console.error("Failed to create chart: can't acquire context from the given item");
                return;
            }
            me.initialize();
            me.update();
        },
        /**
	 * @private
	 */ initialize: function() {
            var me = this;
            // Before init plugin notification
            core_plugins.notify(me, "beforeInit");
            helpers$1.retinaScale(me, me.options.devicePixelRatio);
            me.bindEvents();
            if (me.options.responsive) // Initial resize before chart draws (must be silent to preserve initial animations).
            me.resize(true);
            me.initToolTip();
            // After init plugin notification
            core_plugins.notify(me, "afterInit");
            return me;
        },
        clear: function() {
            helpers$1.canvas.clear(this);
            return this;
        },
        stop: function() {
            // Stops any current animation loop occurring
            core_animations.cancelAnimation(this);
            return this;
        },
        resize: function(silent) {
            var me = this;
            var options = me.options;
            var canvas = me.canvas;
            var aspectRatio = options.maintainAspectRatio && me.aspectRatio || null;
            // the canvas render width and height will be casted to integers so make sure that
            // the canvas display style uses the same integer values to avoid blurring effect.
            // Set to 0 instead of canvas.size because the size defaults to 300x150 if the element is collapsed
            var newWidth = Math.max(0, Math.floor(helpers$1.getMaximumWidth(canvas)));
            var newHeight = Math.max(0, Math.floor(aspectRatio ? newWidth / aspectRatio : helpers$1.getMaximumHeight(canvas)));
            if (me.width === newWidth && me.height === newHeight) return;
            canvas.width = me.width = newWidth;
            canvas.height = me.height = newHeight;
            canvas.style.width = newWidth + "px";
            canvas.style.height = newHeight + "px";
            helpers$1.retinaScale(me, options.devicePixelRatio);
            if (!silent) {
                // Notify any plugins about the resize
                var newSize = {
                    width: newWidth,
                    height: newHeight
                };
                core_plugins.notify(me, "resize", [
                    newSize
                ]);
                // Notify of resize
                if (options.onResize) options.onResize(me, newSize);
                me.stop();
                me.update({
                    duration: options.responsiveAnimationDuration
                });
            }
        },
        ensureScalesHaveIDs: function() {
            var options = this.options;
            var scalesOptions = options.scales || {};
            var scaleOptions = options.scale;
            helpers$1.each(scalesOptions.xAxes, function(xAxisOptions, index) {
                if (!xAxisOptions.id) xAxisOptions.id = nextAvailableScaleId(scalesOptions.xAxes, "x-axis-", index);
            });
            helpers$1.each(scalesOptions.yAxes, function(yAxisOptions, index) {
                if (!yAxisOptions.id) yAxisOptions.id = nextAvailableScaleId(scalesOptions.yAxes, "y-axis-", index);
            });
            if (scaleOptions) scaleOptions.id = scaleOptions.id || "scale";
        },
        /**
	 * Builds a map of scale ID to scale object for future lookup.
	 */ buildOrUpdateScales: function() {
            var me = this;
            var options = me.options;
            var scales = me.scales || {};
            var items = [];
            var updated = Object.keys(scales).reduce(function(obj, id) {
                obj[id] = false;
                return obj;
            }, {});
            if (options.scales) items = items.concat((options.scales.xAxes || []).map(function(xAxisOptions) {
                return {
                    options: xAxisOptions,
                    dtype: "category",
                    dposition: "bottom"
                };
            }), (options.scales.yAxes || []).map(function(yAxisOptions) {
                return {
                    options: yAxisOptions,
                    dtype: "linear",
                    dposition: "left"
                };
            }));
            if (options.scale) items.push({
                options: options.scale,
                dtype: "radialLinear",
                isDefault: true,
                dposition: "chartArea"
            });
            helpers$1.each(items, function(item) {
                var scaleOptions = item.options;
                var id = scaleOptions.id;
                var scaleType = valueOrDefault$9(scaleOptions.type, item.dtype);
                if (positionIsHorizontal(scaleOptions.position) !== positionIsHorizontal(item.dposition)) scaleOptions.position = item.dposition;
                updated[id] = true;
                var scale = null;
                if (id in scales && scales[id].type === scaleType) {
                    scale = scales[id];
                    scale.options = scaleOptions;
                    scale.ctx = me.ctx;
                    scale.chart = me;
                } else {
                    var scaleClass = core_scaleService.getScaleConstructor(scaleType);
                    if (!scaleClass) return;
                    scale = new scaleClass({
                        id: id,
                        type: scaleType,
                        options: scaleOptions,
                        ctx: me.ctx,
                        chart: me
                    });
                    scales[scale.id] = scale;
                }
                scale.mergeTicksOptions();
                // TODO(SB): I think we should be able to remove this custom case (options.scale)
                // and consider it as a regular scale part of the "scales"" map only! This would
                // make the logic easier and remove some useless? custom code.
                if (item.isDefault) me.scale = scale;
            });
            // clear up discarded scales
            helpers$1.each(updated, function(hasUpdated, id) {
                if (!hasUpdated) delete scales[id];
            });
            me.scales = scales;
            core_scaleService.addScalesToLayout(this);
        },
        buildOrUpdateControllers: function() {
            var me = this;
            var newControllers = [];
            var datasets = me.data.datasets;
            var i, ilen;
            for(i = 0, ilen = datasets.length; i < ilen; i++){
                var dataset = datasets[i];
                var meta = me.getDatasetMeta(i);
                var type = dataset.type || me.config.type;
                if (meta.type && meta.type !== type) {
                    me.destroyDatasetMeta(i);
                    meta = me.getDatasetMeta(i);
                }
                meta.type = type;
                meta.order = dataset.order || 0;
                meta.index = i;
                if (meta.controller) {
                    meta.controller.updateIndex(i);
                    meta.controller.linkScales();
                } else {
                    var ControllerClass = controllers[meta.type];
                    if (ControllerClass === undefined) throw new Error('"' + meta.type + '" is not a chart type.');
                    meta.controller = new ControllerClass(me, i);
                    newControllers.push(meta.controller);
                }
            }
            return newControllers;
        },
        /**
	 * Reset the elements of all datasets
	 * @private
	 */ resetElements: function() {
            var me = this;
            helpers$1.each(me.data.datasets, function(dataset, datasetIndex) {
                me.getDatasetMeta(datasetIndex).controller.reset();
            }, me);
        },
        /**
	* Resets the chart back to it's state before the initial animation
	*/ reset: function() {
            this.resetElements();
            this.tooltip.initialize();
        },
        update: function(config) {
            var me = this;
            var i, ilen;
            if (!config || typeof config !== "object") // backwards compatibility
            config = {
                duration: config,
                lazy: arguments[1]
            };
            updateConfig(me);
            // plugins options references might have change, let's invalidate the cache
            // https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
            core_plugins._invalidate(me);
            if (core_plugins.notify(me, "beforeUpdate") === false) return;
            // In case the entire data object changed
            me.tooltip._data = me.data;
            // Make sure dataset controllers are updated and new controllers are reset
            var newControllers = me.buildOrUpdateControllers();
            // Make sure all dataset controllers have correct meta data counts
            for(i = 0, ilen = me.data.datasets.length; i < ilen; i++)me.getDatasetMeta(i).controller.buildOrUpdateElements();
            me.updateLayout();
            // Can only reset the new controllers after the scales have been updated
            if (me.options.animation && me.options.animation.duration) helpers$1.each(newControllers, function(controller) {
                controller.reset();
            });
            me.updateDatasets();
            // Need to reset tooltip in case it is displayed with elements that are removed
            // after update.
            me.tooltip.initialize();
            // Last active contains items that were previously in the tooltip.
            // When we reset the tooltip, we need to clear it
            me.lastActive = [];
            // Do this before render so that any plugins that need final scale updates can use it
            core_plugins.notify(me, "afterUpdate");
            me._layers.sort(compare2Level("z", "_idx"));
            if (me._bufferedRender) me._bufferedRequest = {
                duration: config.duration,
                easing: config.easing,
                lazy: config.lazy
            };
            else me.render(config);
        },
        /**
	 * Updates the chart layout unless a plugin returns `false` to the `beforeLayout`
	 * hook, in which case, plugins will not be called on `afterLayout`.
	 * @private
	 */ updateLayout: function() {
            var me = this;
            if (core_plugins.notify(me, "beforeLayout") === false) return;
            core_layouts.update(this, this.width, this.height);
            me._layers = [];
            helpers$1.each(me.boxes, function(box) {
                // _configure is called twice, once in core.scale.update and once here.
                // Here the boxes are fully updated and at their final positions.
                if (box._configure) box._configure();
                me._layers.push.apply(me._layers, box._layers());
            }, me);
            me._layers.forEach(function(item, index) {
                item._idx = index;
            });
            /**
		 * Provided for backward compatibility, use `afterLayout` instead.
		 * @method IPlugin#afterScaleUpdate
		 * @deprecated since version 2.5.0
		 * @todo remove at version 3
		 * @private
		 */ core_plugins.notify(me, "afterScaleUpdate");
            core_plugins.notify(me, "afterLayout");
        },
        /**
	 * Updates all datasets unless a plugin returns `false` to the `beforeDatasetsUpdate`
	 * hook, in which case, plugins will not be called on `afterDatasetsUpdate`.
	 * @private
	 */ updateDatasets: function() {
            var me = this;
            if (core_plugins.notify(me, "beforeDatasetsUpdate") === false) return;
            for(var i = 0, ilen = me.data.datasets.length; i < ilen; ++i)me.updateDataset(i);
            core_plugins.notify(me, "afterDatasetsUpdate");
        },
        /**
	 * Updates dataset at index unless a plugin returns `false` to the `beforeDatasetUpdate`
	 * hook, in which case, plugins will not be called on `afterDatasetUpdate`.
	 * @private
	 */ updateDataset: function(index) {
            var me = this;
            var meta = me.getDatasetMeta(index);
            var args = {
                meta: meta,
                index: index
            };
            if (core_plugins.notify(me, "beforeDatasetUpdate", [
                args
            ]) === false) return;
            meta.controller._update();
            core_plugins.notify(me, "afterDatasetUpdate", [
                args
            ]);
        },
        render: function(config) {
            var me = this;
            if (!config || typeof config !== "object") // backwards compatibility
            config = {
                duration: config,
                lazy: arguments[1]
            };
            var animationOptions = me.options.animation;
            var duration = valueOrDefault$9(config.duration, animationOptions && animationOptions.duration);
            var lazy = config.lazy;
            if (core_plugins.notify(me, "beforeRender") === false) return;
            var onComplete = function(animation) {
                core_plugins.notify(me, "afterRender");
                helpers$1.callback(animationOptions && animationOptions.onComplete, [
                    animation
                ], me);
            };
            if (animationOptions && duration) {
                var animation = new core_animation({
                    numSteps: duration / 16.66,
                    easing: config.easing || animationOptions.easing,
                    render: function(chart, animationObject) {
                        var easingFunction = helpers$1.easing.effects[animationObject.easing];
                        var currentStep = animationObject.currentStep;
                        var stepDecimal = currentStep / animationObject.numSteps;
                        chart.draw(easingFunction(stepDecimal), stepDecimal, currentStep);
                    },
                    onAnimationProgress: animationOptions.onProgress,
                    onAnimationComplete: onComplete
                });
                core_animations.addAnimation(me, animation, duration, lazy);
            } else {
                me.draw();
                // See https://github.com/chartjs/Chart.js/issues/3781
                onComplete(new core_animation({
                    numSteps: 0,
                    chart: me
                }));
            }
            return me;
        },
        draw: function(easingValue) {
            var me = this;
            var i, layers;
            me.clear();
            if (helpers$1.isNullOrUndef(easingValue)) easingValue = 1;
            me.transition(easingValue);
            if (me.width <= 0 || me.height <= 0) return;
            if (core_plugins.notify(me, "beforeDraw", [
                easingValue
            ]) === false) return;
            // Because of plugin hooks (before/afterDatasetsDraw), datasets can't
            // currently be part of layers. Instead, we draw
            // layers <= 0 before(default, backward compat), and the rest after
            layers = me._layers;
            for(i = 0; i < layers.length && layers[i].z <= 0; ++i)layers[i].draw(me.chartArea);
            me.drawDatasets(easingValue);
            // Rest of layers
            for(; i < layers.length; ++i)layers[i].draw(me.chartArea);
            me._drawTooltip(easingValue);
            core_plugins.notify(me, "afterDraw", [
                easingValue
            ]);
        },
        /**
	 * @private
	 */ transition: function(easingValue) {
            var me = this;
            for(var i = 0, ilen = (me.data.datasets || []).length; i < ilen; ++i)if (me.isDatasetVisible(i)) me.getDatasetMeta(i).controller.transition(easingValue);
            me.tooltip.transition(easingValue);
        },
        /**
	 * @private
	 */ _getSortedDatasetMetas: function(filterVisible) {
            var me = this;
            var datasets = me.data.datasets || [];
            var result = [];
            var i, ilen;
            for(i = 0, ilen = datasets.length; i < ilen; ++i)if (!filterVisible || me.isDatasetVisible(i)) result.push(me.getDatasetMeta(i));
            result.sort(compare2Level("order", "index"));
            return result;
        },
        /**
	 * @private
	 */ _getSortedVisibleDatasetMetas: function() {
            return this._getSortedDatasetMetas(true);
        },
        /**
	 * Draws all datasets unless a plugin returns `false` to the `beforeDatasetsDraw`
	 * hook, in which case, plugins will not be called on `afterDatasetsDraw`.
	 * @private
	 */ drawDatasets: function(easingValue) {
            var me = this;
            var metasets, i;
            if (core_plugins.notify(me, "beforeDatasetsDraw", [
                easingValue
            ]) === false) return;
            metasets = me._getSortedVisibleDatasetMetas();
            for(i = metasets.length - 1; i >= 0; --i)me.drawDataset(metasets[i], easingValue);
            core_plugins.notify(me, "afterDatasetsDraw", [
                easingValue
            ]);
        },
        /**
	 * Draws dataset at index unless a plugin returns `false` to the `beforeDatasetDraw`
	 * hook, in which case, plugins will not be called on `afterDatasetDraw`.
	 * @private
	 */ drawDataset: function(meta, easingValue) {
            var me = this;
            var args = {
                meta: meta,
                index: meta.index,
                easingValue: easingValue
            };
            if (core_plugins.notify(me, "beforeDatasetDraw", [
                args
            ]) === false) return;
            meta.controller.draw(easingValue);
            core_plugins.notify(me, "afterDatasetDraw", [
                args
            ]);
        },
        /**
	 * Draws tooltip unless a plugin returns `false` to the `beforeTooltipDraw`
	 * hook, in which case, plugins will not be called on `afterTooltipDraw`.
	 * @private
	 */ _drawTooltip: function(easingValue) {
            var me = this;
            var tooltip = me.tooltip;
            var args = {
                tooltip: tooltip,
                easingValue: easingValue
            };
            if (core_plugins.notify(me, "beforeTooltipDraw", [
                args
            ]) === false) return;
            tooltip.draw();
            core_plugins.notify(me, "afterTooltipDraw", [
                args
            ]);
        },
        /**
	 * Get the single element that was clicked on
	 * @return An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
	 */ getElementAtEvent: function(e) {
            return core_interaction.modes.single(this, e);
        },
        getElementsAtEvent: function(e) {
            return core_interaction.modes.label(this, e, {
                intersect: true
            });
        },
        getElementsAtXAxis: function(e) {
            return core_interaction.modes["x-axis"](this, e, {
                intersect: true
            });
        },
        getElementsAtEventForMode: function(e, mode, options) {
            var method = core_interaction.modes[mode];
            if (typeof method === "function") return method(this, e, options);
            return [];
        },
        getDatasetAtEvent: function(e) {
            return core_interaction.modes.dataset(this, e, {
                intersect: true
            });
        },
        getDatasetMeta: function(datasetIndex) {
            var me = this;
            var dataset = me.data.datasets[datasetIndex];
            if (!dataset._meta) dataset._meta = {};
            var meta = dataset._meta[me.id];
            if (!meta) meta = dataset._meta[me.id] = {
                type: null,
                data: [],
                dataset: null,
                controller: null,
                hidden: null,
                xAxisID: null,
                yAxisID: null,
                order: dataset.order || 0,
                index: datasetIndex
            };
            return meta;
        },
        getVisibleDatasetCount: function() {
            var count = 0;
            for(var i = 0, ilen = this.data.datasets.length; i < ilen; ++i)if (this.isDatasetVisible(i)) count++;
            return count;
        },
        isDatasetVisible: function(datasetIndex) {
            var meta = this.getDatasetMeta(datasetIndex);
            // meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
            // the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
            return typeof meta.hidden === "boolean" ? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
        },
        generateLegend: function() {
            return this.options.legendCallback(this);
        },
        /**
	 * @private
	 */ destroyDatasetMeta: function(datasetIndex) {
            var id = this.id;
            var dataset = this.data.datasets[datasetIndex];
            var meta = dataset._meta && dataset._meta[id];
            if (meta) {
                meta.controller.destroy();
                delete dataset._meta[id];
            }
        },
        destroy: function() {
            var me = this;
            var canvas = me.canvas;
            var i, ilen;
            me.stop();
            // dataset controllers need to cleanup associated data
            for(i = 0, ilen = me.data.datasets.length; i < ilen; ++i)me.destroyDatasetMeta(i);
            if (canvas) {
                me.unbindEvents();
                helpers$1.canvas.clear(me);
                platform.releaseContext(me.ctx);
                me.canvas = null;
                me.ctx = null;
            }
            core_plugins.notify(me, "destroy");
            delete Chart.instances[me.id];
        },
        toBase64Image: function() {
            return this.canvas.toDataURL.apply(this.canvas, arguments);
        },
        initToolTip: function() {
            var me = this;
            me.tooltip = new core_tooltip({
                _chart: me,
                _chartInstance: me,
                _data: me.data,
                _options: me.options.tooltips
            }, me);
        },
        /**
	 * @private
	 */ bindEvents: function() {
            var me = this;
            var listeners = me._listeners = {};
            var listener = function() {
                me.eventHandler.apply(me, arguments);
            };
            helpers$1.each(me.options.events, function(type) {
                platform.addEventListener(me, type, listener);
                listeners[type] = listener;
            });
            // Elements used to detect size change should not be injected for non responsive charts.
            // See https://github.com/chartjs/Chart.js/issues/2210
            if (me.options.responsive) {
                listener = function() {
                    me.resize();
                };
                platform.addEventListener(me, "resize", listener);
                listeners.resize = listener;
            }
        },
        /**
	 * @private
	 */ unbindEvents: function() {
            var me = this;
            var listeners = me._listeners;
            if (!listeners) return;
            delete me._listeners;
            helpers$1.each(listeners, function(listener, type) {
                platform.removeEventListener(me, type, listener);
            });
        },
        updateHoverStyle: function(elements, mode, enabled) {
            var prefix = enabled ? "set" : "remove";
            var element, i, ilen;
            for(i = 0, ilen = elements.length; i < ilen; ++i){
                element = elements[i];
                if (element) this.getDatasetMeta(element._datasetIndex).controller[prefix + "HoverStyle"](element);
            }
            if (mode === "dataset") this.getDatasetMeta(elements[0]._datasetIndex).controller["_" + prefix + "DatasetHoverStyle"]();
        },
        /**
	 * @private
	 */ eventHandler: function(e) {
            var me = this;
            var tooltip = me.tooltip;
            if (core_plugins.notify(me, "beforeEvent", [
                e
            ]) === false) return;
            // Buffer any update calls so that renders do not occur
            me._bufferedRender = true;
            me._bufferedRequest = null;
            var changed = me.handleEvent(e);
            // for smooth tooltip animations issue #4989
            // the tooltip should be the source of change
            // Animation check workaround:
            // tooltip._start will be null when tooltip isn't animating
            if (tooltip) changed = tooltip._start ? tooltip.handleEvent(e) : changed | tooltip.handleEvent(e);
            core_plugins.notify(me, "afterEvent", [
                e
            ]);
            var bufferedRequest = me._bufferedRequest;
            if (bufferedRequest) // If we have an update that was triggered, we need to do a normal render
            me.render(bufferedRequest);
            else if (changed && !me.animating) {
                // If entering, leaving, or changing elements, animate the change via pivot
                me.stop();
                // We only need to render at this point. Updating will cause scales to be
                // recomputed generating flicker & using more memory than necessary.
                me.render({
                    duration: me.options.hover.animationDuration,
                    lazy: true
                });
            }
            me._bufferedRender = false;
            me._bufferedRequest = null;
            return me;
        },
        /**
	 * Handle an event
	 * @private
	 * @param {IEvent} event the event to handle
	 * @return {boolean} true if the chart needs to re-render
	 */ handleEvent: function(e) {
            var me = this;
            var options = me.options || {};
            var hoverOptions = options.hover;
            var changed = false;
            me.lastActive = me.lastActive || [];
            // Find Active Elements for hover and tooltips
            if (e.type === "mouseout") me.active = [];
            else me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
            // Invoke onHover hook
            // Need to call with native event here to not break backwards compatibility
            helpers$1.callback(options.onHover || options.hover.onHover, [
                e.native,
                me.active
            ], me);
            if (e.type === "mouseup" || e.type === "click") {
                if (options.onClick) // Use e.native here for backwards compatibility
                options.onClick.call(me, e.native, me.active);
            }
            // Remove styling for last active (even if it may still be active)
            if (me.lastActive.length) me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
            // Built in hover styling
            if (me.active.length && hoverOptions.mode) me.updateHoverStyle(me.active, hoverOptions.mode, true);
            changed = !helpers$1.arrayEquals(me.active, me.lastActive);
            // Remember Last Actives
            me.lastActive = me.active;
            return changed;
        }
    });
    /**
 * NOTE(SB) We actually don't use this container anymore but we need to keep it
 * for backward compatibility. Though, it can still be useful for plugins that
 * would need to work on multiple charts?!
 */ Chart.instances = {};
    var core_controller = Chart;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart instead.
 * @class Chart.Controller
 * @deprecated since version 2.6
 * @todo remove at version 3
 * @private
 */ Chart.Controller = Chart;
    /**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart
 * @deprecated since version 2.8
 * @todo remove at version 3
 * @private
 */ Chart.types = {};
    /**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.helpers.configMerge
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */ helpers$1.configMerge = mergeConfig;
    /**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.helpers.scaleMerge
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */ helpers$1.scaleMerge = mergeScaleConfig;
    var core_helpers = function() {
        // -- Basic js utility methods
        helpers$1.where = function(collection, filterCallback) {
            if (helpers$1.isArray(collection) && Array.prototype.filter) return collection.filter(filterCallback);
            var filtered = [];
            helpers$1.each(collection, function(item) {
                if (filterCallback(item)) filtered.push(item);
            });
            return filtered;
        };
        helpers$1.findIndex = Array.prototype.findIndex ? function(array, callback, scope) {
            return array.findIndex(callback, scope);
        } : function(array, callback, scope) {
            scope = scope === undefined ? array : scope;
            for(var i = 0, ilen = array.length; i < ilen; ++i){
                if (callback.call(scope, array[i], i, array)) return i;
            }
            return -1;
        };
        helpers$1.findNextWhere = function(arrayToSearch, filterCallback, startIndex) {
            // Default to start of the array
            if (helpers$1.isNullOrUndef(startIndex)) startIndex = -1;
            for(var i = startIndex + 1; i < arrayToSearch.length; i++){
                var currentItem = arrayToSearch[i];
                if (filterCallback(currentItem)) return currentItem;
            }
        };
        helpers$1.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex) {
            // Default to end of the array
            if (helpers$1.isNullOrUndef(startIndex)) startIndex = arrayToSearch.length;
            for(var i = startIndex - 1; i >= 0; i--){
                var currentItem = arrayToSearch[i];
                if (filterCallback(currentItem)) return currentItem;
            }
        };
        // -- Math methods
        helpers$1.isNumber = function(n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
        };
        helpers$1.almostEquals = function(x, y, epsilon) {
            return Math.abs(x - y) < epsilon;
        };
        helpers$1.almostWhole = function(x, epsilon) {
            var rounded = Math.round(x);
            return rounded - epsilon <= x && rounded + epsilon >= x;
        };
        helpers$1.max = function(array) {
            return array.reduce(function(max, value) {
                if (!isNaN(value)) return Math.max(max, value);
                return max;
            }, Number.NEGATIVE_INFINITY);
        };
        helpers$1.min = function(array) {
            return array.reduce(function(min, value) {
                if (!isNaN(value)) return Math.min(min, value);
                return min;
            }, Number.POSITIVE_INFINITY);
        };
        helpers$1.sign = Math.sign ? function(x) {
            return Math.sign(x);
        } : function(x) {
            x = +x; // convert to a number
            if (x === 0 || isNaN(x)) return x;
            return x > 0 ? 1 : -1;
        };
        helpers$1.toRadians = function(degrees) {
            return degrees * (Math.PI / 180);
        };
        helpers$1.toDegrees = function(radians) {
            return radians * (180 / Math.PI);
        };
        /**
	 * Returns the number of decimal places
	 * i.e. the number of digits after the decimal point, of the value of this Number.
	 * @param {number} x - A number.
	 * @returns {number} The number of decimal places.
	 * @private
	 */ helpers$1._decimalPlaces = function(x) {
            if (!helpers$1.isFinite(x)) return;
            var e = 1;
            var p = 0;
            while(Math.round(x * e) / e !== x){
                e *= 10;
                p++;
            }
            return p;
        };
        // Gets the angle from vertical upright to the point about a centre.
        helpers$1.getAngleFromPoint = function(centrePoint, anglePoint) {
            var distanceFromXCenter = anglePoint.x - centrePoint.x;
            var distanceFromYCenter = anglePoint.y - centrePoint.y;
            var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
            var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
            if (angle < -0.5 * Math.PI) angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
            return {
                angle: angle,
                distance: radialDistanceFromCenter
            };
        };
        helpers$1.distanceBetweenPoints = function(pt1, pt2) {
            return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
        };
        /**
	 * Provided for backward compatibility, not available anymore
	 * @function Chart.helpers.aliasPixel
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 */ helpers$1.aliasPixel = function(pixelWidth) {
            return pixelWidth % 2 === 0 ? 0 : 0.5;
        };
        /**
	 * Returns the aligned pixel value to avoid anti-aliasing blur
	 * @param {Chart} chart - The chart instance.
	 * @param {number} pixel - A pixel value.
	 * @param {number} width - The width of the element.
	 * @returns {number} The aligned pixel value.
	 * @private
	 */ helpers$1._alignPixel = function(chart, pixel, width) {
            var devicePixelRatio = chart.currentDevicePixelRatio;
            var halfWidth = width / 2;
            return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
        };
        helpers$1.splineCurve = function(firstPoint, middlePoint, afterPoint, t) {
            // Props to Rob Spencer at scaled innovation for his post on splining between points
            // http://scaledinnovation.com/analytics/splines/aboutSplines.html
            // This function must also respect "skipped" points
            var previous = firstPoint.skip ? middlePoint : firstPoint;
            var current = middlePoint;
            var next = afterPoint.skip ? middlePoint : afterPoint;
            var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
            var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));
            var s01 = d01 / (d01 + d12);
            var s12 = d12 / (d01 + d12);
            // If all points are the same, s01 & s02 will be inf
            s01 = isNaN(s01) ? 0 : s01;
            s12 = isNaN(s12) ? 0 : s12;
            var fa = t * s01; // scaling factor for triangle Ta
            var fb = t * s12;
            return {
                previous: {
                    x: current.x - fa * (next.x - previous.x),
                    y: current.y - fa * (next.y - previous.y)
                },
                next: {
                    x: current.x + fb * (next.x - previous.x),
                    y: current.y + fb * (next.y - previous.y)
                }
            };
        };
        helpers$1.EPSILON = Number.EPSILON || 1e-14;
        helpers$1.splineCurveMonotone = function(points) {
            // This function calculates Bézier control points in a similar way than |splineCurve|,
            // but preserves monotonicity of the provided data and ensures no local extremums are added
            // between the dataset discrete points due to the interpolation.
            // See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
            var pointsWithTangents = (points || []).map(function(point) {
                return {
                    model: point._model,
                    deltaK: 0,
                    mK: 0
                };
            });
            // Calculate slopes (deltaK) and initialize tangents (mK)
            var pointsLen = pointsWithTangents.length;
            var i, pointBefore, pointCurrent, pointAfter;
            for(i = 0; i < pointsLen; ++i){
                pointCurrent = pointsWithTangents[i];
                if (pointCurrent.model.skip) continue;
                pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
                pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
                if (pointAfter && !pointAfter.model.skip) {
                    var slopeDeltaX = pointAfter.model.x - pointCurrent.model.x;
                    // In the case of two points that appear at the same x pixel, slopeDeltaX is 0
                    pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
                }
                if (!pointBefore || pointBefore.model.skip) pointCurrent.mK = pointCurrent.deltaK;
                else if (!pointAfter || pointAfter.model.skip) pointCurrent.mK = pointBefore.deltaK;
                else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) pointCurrent.mK = 0;
                else pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
            }
            // Adjust tangents to ensure monotonic properties
            var alphaK, betaK, tauK, squaredMagnitude;
            for(i = 0; i < pointsLen - 1; ++i){
                pointCurrent = pointsWithTangents[i];
                pointAfter = pointsWithTangents[i + 1];
                if (pointCurrent.model.skip || pointAfter.model.skip) continue;
                if (helpers$1.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
                    pointCurrent.mK = pointAfter.mK = 0;
                    continue;
                }
                alphaK = pointCurrent.mK / pointCurrent.deltaK;
                betaK = pointAfter.mK / pointCurrent.deltaK;
                squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
                if (squaredMagnitude <= 9) continue;
                tauK = 3 / Math.sqrt(squaredMagnitude);
                pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
                pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
            }
            // Compute control points
            var deltaX;
            for(i = 0; i < pointsLen; ++i){
                pointCurrent = pointsWithTangents[i];
                if (pointCurrent.model.skip) continue;
                pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
                pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
                if (pointBefore && !pointBefore.model.skip) {
                    deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
                    pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
                    pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
                }
                if (pointAfter && !pointAfter.model.skip) {
                    deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
                    pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
                    pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
                }
            }
        };
        helpers$1.nextItem = function(collection, index, loop) {
            if (loop) return index >= collection.length - 1 ? collection[0] : collection[index + 1];
            return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
        };
        helpers$1.previousItem = function(collection, index, loop) {
            if (loop) return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
            return index <= 0 ? collection[0] : collection[index - 1];
        };
        // Implementation of the nice number algorithm used in determining where axis labels will go
        helpers$1.niceNum = function(range, round) {
            var exponent = Math.floor(helpers$1.log10(range));
            var fraction = range / Math.pow(10, exponent);
            var niceFraction;
            if (round) {
                if (fraction < 1.5) niceFraction = 1;
                else if (fraction < 3) niceFraction = 2;
                else if (fraction < 7) niceFraction = 5;
                else niceFraction = 10;
            } else if (fraction <= 1.0) niceFraction = 1;
            else if (fraction <= 2) niceFraction = 2;
            else if (fraction <= 5) niceFraction = 5;
            else niceFraction = 10;
            return niceFraction * Math.pow(10, exponent);
        };
        // Request animation polyfill - https://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
        helpers$1.requestAnimFrame = function() {
            if (typeof window === "undefined") return function(callback) {
                callback();
            };
            return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function(callback) {
                return window.setTimeout(callback, 1000 / 60);
            };
        }();
        // -- DOM methods
        helpers$1.getRelativePosition = function(evt, chart) {
            var mouseX, mouseY;
            var e = evt.originalEvent || evt;
            var canvas = evt.target || evt.srcElement;
            var boundingRect = canvas.getBoundingClientRect();
            var touches = e.touches;
            if (touches && touches.length > 0) {
                mouseX = touches[0].clientX;
                mouseY = touches[0].clientY;
            } else {
                mouseX = e.clientX;
                mouseY = e.clientY;
            }
            // Scale mouse coordinates into canvas coordinates
            // by following the pattern laid out by 'jerryj' in the comments of
            // https://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
            var paddingLeft = parseFloat(helpers$1.getStyle(canvas, "padding-left"));
            var paddingTop = parseFloat(helpers$1.getStyle(canvas, "padding-top"));
            var paddingRight = parseFloat(helpers$1.getStyle(canvas, "padding-right"));
            var paddingBottom = parseFloat(helpers$1.getStyle(canvas, "padding-bottom"));
            var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
            var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;
            // We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
            // the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
            mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / width * canvas.width / chart.currentDevicePixelRatio);
            mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / height * canvas.height / chart.currentDevicePixelRatio);
            return {
                x: mouseX,
                y: mouseY
            };
        };
        // Private helper function to convert max-width/max-height values that may be percentages into a number
        function parseMaxStyle(styleValue, node, parentProperty) {
            var valueInPixels;
            if (typeof styleValue === "string") {
                valueInPixels = parseInt(styleValue, 10);
                if (styleValue.indexOf("%") !== -1) // percentage * size in dimension
                valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
            } else valueInPixels = styleValue;
            return valueInPixels;
        }
        /**
	 * Returns if the given value contains an effective constraint.
	 * @private
	 */ function isConstrainedValue(value) {
            return value !== undefined && value !== null && value !== "none";
        }
        /**
	 * Returns the max width or height of the given DOM node in a cross-browser compatible fashion
	 * @param {HTMLElement} domNode - the node to check the constraint on
	 * @param {string} maxStyle - the style that defines the maximum for the direction we are using ('max-width' / 'max-height')
	 * @param {string} percentageProperty - property of parent to use when calculating width as a percentage
	 * @see {@link https://www.nathanaeljones.com/blog/2013/reading-max-width-cross-browser}
	 */ function getConstraintDimension(domNode, maxStyle, percentageProperty) {
            var view = document.defaultView;
            var parentNode = helpers$1._getParentNode(domNode);
            var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
            var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
            var hasCNode = isConstrainedValue(constrainedNode);
            var hasCContainer = isConstrainedValue(constrainedContainer);
            var infinity = Number.POSITIVE_INFINITY;
            if (hasCNode || hasCContainer) return Math.min(hasCNode ? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity, hasCContainer ? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
            return "none";
        }
        // returns Number or undefined if no constraint
        helpers$1.getConstraintWidth = function(domNode) {
            return getConstraintDimension(domNode, "max-width", "clientWidth");
        };
        // returns Number or undefined if no constraint
        helpers$1.getConstraintHeight = function(domNode) {
            return getConstraintDimension(domNode, "max-height", "clientHeight");
        };
        /**
	 * @private
 	 */ helpers$1._calculatePadding = function(container, padding, parentDimension) {
            padding = helpers$1.getStyle(container, padding);
            return padding.indexOf("%") > -1 ? parentDimension * parseInt(padding, 10) / 100 : parseInt(padding, 10);
        };
        /**
	 * @private
	 */ helpers$1._getParentNode = function(domNode) {
            var parent = domNode.parentNode;
            if (parent && parent.toString() === "[object ShadowRoot]") parent = parent.host;
            return parent;
        };
        helpers$1.getMaximumWidth = function(domNode) {
            var container = helpers$1._getParentNode(domNode);
            if (!container) return domNode.clientWidth;
            var clientWidth = container.clientWidth;
            var paddingLeft = helpers$1._calculatePadding(container, "padding-left", clientWidth);
            var paddingRight = helpers$1._calculatePadding(container, "padding-right", clientWidth);
            var w = clientWidth - paddingLeft - paddingRight;
            var cw = helpers$1.getConstraintWidth(domNode);
            return isNaN(cw) ? w : Math.min(w, cw);
        };
        helpers$1.getMaximumHeight = function(domNode) {
            var container = helpers$1._getParentNode(domNode);
            if (!container) return domNode.clientHeight;
            var clientHeight = container.clientHeight;
            var paddingTop = helpers$1._calculatePadding(container, "padding-top", clientHeight);
            var paddingBottom = helpers$1._calculatePadding(container, "padding-bottom", clientHeight);
            var h = clientHeight - paddingTop - paddingBottom;
            var ch = helpers$1.getConstraintHeight(domNode);
            return isNaN(ch) ? h : Math.min(h, ch);
        };
        helpers$1.getStyle = function(el, property) {
            return el.currentStyle ? el.currentStyle[property] : document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
        };
        helpers$1.retinaScale = function(chart, forceRatio) {
            var pixelRatio = chart.currentDevicePixelRatio = forceRatio || typeof window !== "undefined" && window.devicePixelRatio || 1;
            if (pixelRatio === 1) return;
            var canvas = chart.canvas;
            var height = chart.height;
            var width = chart.width;
            canvas.height = height * pixelRatio;
            canvas.width = width * pixelRatio;
            chart.ctx.scale(pixelRatio, pixelRatio);
            // If no style has been set on the canvas, the render size is used as display size,
            // making the chart visually bigger, so let's enforce it to the "correct" values.
            // See https://github.com/chartjs/Chart.js/issues/3575
            if (!canvas.style.height && !canvas.style.width) {
                canvas.style.height = height + "px";
                canvas.style.width = width + "px";
            }
        };
        // -- Canvas methods
        helpers$1.fontString = function(pixelSize, fontStyle, fontFamily) {
            return fontStyle + " " + pixelSize + "px " + fontFamily;
        };
        helpers$1.longestText = function(ctx, font, arrayOfThings, cache) {
            cache = cache || {};
            var data = cache.data = cache.data || {};
            var gc = cache.garbageCollect = cache.garbageCollect || [];
            if (cache.font !== font) {
                data = cache.data = {};
                gc = cache.garbageCollect = [];
                cache.font = font;
            }
            ctx.font = font;
            var longest = 0;
            var ilen = arrayOfThings.length;
            var i, j, jlen, thing, nestedThing;
            for(i = 0; i < ilen; i++){
                thing = arrayOfThings[i];
                // Undefined strings and arrays should not be measured
                if (thing !== undefined && thing !== null && helpers$1.isArray(thing) !== true) longest = helpers$1.measureText(ctx, data, gc, longest, thing);
                else if (helpers$1.isArray(thing)) // if it is an array lets measure each element
                // to do maybe simplify this function a bit so we can do this more recursively?
                for(j = 0, jlen = thing.length; j < jlen; j++){
                    nestedThing = thing[j];
                    // Undefined strings and arrays should not be measured
                    if (nestedThing !== undefined && nestedThing !== null && !helpers$1.isArray(nestedThing)) longest = helpers$1.measureText(ctx, data, gc, longest, nestedThing);
                }
            }
            var gcLen = gc.length / 2;
            if (gcLen > arrayOfThings.length) {
                for(i = 0; i < gcLen; i++)delete data[gc[i]];
                gc.splice(0, gcLen);
            }
            return longest;
        };
        helpers$1.measureText = function(ctx, data, gc, longest, string) {
            var textWidth = data[string];
            if (!textWidth) {
                textWidth = data[string] = ctx.measureText(string).width;
                gc.push(string);
            }
            if (textWidth > longest) longest = textWidth;
            return longest;
        };
        /**
	 * @deprecated
	 */ helpers$1.numberOfLabelLines = function(arrayOfThings) {
            var numberOfLines = 1;
            helpers$1.each(arrayOfThings, function(thing) {
                if (helpers$1.isArray(thing)) {
                    if (thing.length > numberOfLines) numberOfLines = thing.length;
                }
            });
            return numberOfLines;
        };
        helpers$1.color = !chartjsColor ? function(value) {
            console.error("Color.js not found!");
            return value;
        } : function(value) {
            /* global CanvasGradient */ if (value instanceof CanvasGradient) value = core_defaults.global.defaultColor;
            return chartjsColor(value);
        };
        helpers$1.getHoverColor = function(colorValue) {
            /* global CanvasPattern */ return colorValue instanceof CanvasPattern || colorValue instanceof CanvasGradient ? colorValue : helpers$1.color(colorValue).saturate(0.5).darken(0.1).rgbString();
        };
    };
    function abstract() {
        throw new Error("This method is not implemented: either no adapter can be found or an incomplete integration was provided.");
    }
    /**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */ /**
 * Currently supported unit string values.
 * @typedef {('millisecond'|'second'|'minute'|'hour'|'day'|'week'|'month'|'quarter'|'year')}
 * @memberof Chart._adapters._date
 * @name Unit
 */ /**
 * @class
 */ function DateAdapter(options) {
        this.options = options || {};
    }
    helpers$1.extend(DateAdapter.prototype, /** @lends DateAdapter */ {
        /**
	 * Returns a map of time formats for the supported formatting units defined
	 * in Unit as well as 'datetime' representing a detailed date/time string.
	 * @returns {{string: string}}
	 */ formats: abstract,
        /**
	 * Parses the given `value` and return the associated timestamp.
	 * @param {any} value - the value to parse (usually comes from the data)
	 * @param {string} [format] - the expected data format
	 * @returns {(number|null)}
	 * @function
	 */ parse: abstract,
        /**
	 * Returns the formatted date in the specified `format` for a given `timestamp`.
	 * @param {number} timestamp - the timestamp to format
	 * @param {string} format - the date/time token
	 * @return {string}
	 * @function
	 */ format: abstract,
        /**
	 * Adds the specified `amount` of `unit` to the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {number} amount - the amount to add
	 * @param {Unit} unit - the unit as string
	 * @return {number}
	 * @function
	 */ add: abstract,
        /**
	 * Returns the number of `unit` between the given timestamps.
	 * @param {number} max - the input timestamp (reference)
	 * @param {number} min - the timestamp to substract
	 * @param {Unit} unit - the unit as string
	 * @return {number}
	 * @function
	 */ diff: abstract,
        /**
	 * Returns start of `unit` for the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {Unit} unit - the unit as string
	 * @param {number} [weekday] - the ISO day of the week with 1 being Monday
	 * and 7 being Sunday (only needed if param *unit* is `isoWeek`).
	 * @function
	 */ startOf: abstract,
        /**
	 * Returns end of `unit` for the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {Unit} unit - the unit as string
	 * @function
	 */ endOf: abstract,
        // DEPRECATIONS
        /**
	 * Provided for backward compatibility for scale.getValueForPixel(),
	 * this method should be overridden only by the moment adapter.
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */ _create: function(value) {
            return value;
        }
    });
    DateAdapter.override = function(members) {
        helpers$1.extend(DateAdapter.prototype, members);
    };
    var _date = DateAdapter;
    var core_adapters = {
        _date: _date
    };
    /**
 * Namespace to hold static tick generation functions
 * @namespace Chart.Ticks
 */ var core_ticks = {
        /**
	 * Namespace to hold formatters for different types of ticks
	 * @namespace Chart.Ticks.formatters
	 */ formatters: {
            /**
		 * Formatter for value labels
		 * @method Chart.Ticks.formatters.values
		 * @param value the value to display
		 * @return {string|string[]} the label to display
		 */ values: function(value) {
                return helpers$1.isArray(value) ? value : "" + value;
            },
            /**
		 * Formatter for linear numeric ticks
		 * @method Chart.Ticks.formatters.linear
		 * @param tickValue {number} the value to be formatted
		 * @param index {number} the position of the tickValue parameter in the ticks array
		 * @param ticks {number[]} the list of ticks being converted
		 * @return {string} string representation of the tickValue parameter
		 */ linear: function(tickValue, index, ticks) {
                // If we have lots of ticks, don't use the ones
                var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];
                // If we have a number like 2.5 as the delta, figure out how many decimal places we need
                if (Math.abs(delta) > 1) {
                    if (tickValue !== Math.floor(tickValue)) // not an integer
                    delta = tickValue - Math.floor(tickValue);
                }
                var logDelta = helpers$1.log10(Math.abs(delta));
                var tickString = "";
                if (tickValue !== 0) {
                    var maxTick = Math.max(Math.abs(ticks[0]), Math.abs(ticks[ticks.length - 1]));
                    if (maxTick < 1e-4) {
                        var logTick = helpers$1.log10(Math.abs(tickValue));
                        var numExponential = Math.floor(logTick) - Math.floor(logDelta);
                        numExponential = Math.max(Math.min(numExponential, 20), 0);
                        tickString = tickValue.toExponential(numExponential);
                    } else {
                        var numDecimal = -1 * Math.floor(logDelta);
                        numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
                        tickString = tickValue.toFixed(numDecimal);
                    }
                } else tickString = "0"; // never show decimal places for 0
                return tickString;
            },
            logarithmic: function(tickValue, index, ticks) {
                var remain = tickValue / Math.pow(10, Math.floor(helpers$1.log10(tickValue)));
                if (tickValue === 0) return "0";
                else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) return tickValue.toExponential();
                return "";
            }
        }
    };
    var isArray = helpers$1.isArray;
    var isNullOrUndef = helpers$1.isNullOrUndef;
    var valueOrDefault$a = helpers$1.valueOrDefault;
    var valueAtIndexOrDefault = helpers$1.valueAtIndexOrDefault;
    core_defaults._set("scale", {
        display: true,
        position: "left",
        offset: false,
        // grid line settings
        gridLines: {
            display: true,
            color: "rgba(0,0,0,0.1)",
            lineWidth: 1,
            drawBorder: true,
            drawOnChartArea: true,
            drawTicks: true,
            tickMarkLength: 10,
            zeroLineWidth: 1,
            zeroLineColor: "rgba(0,0,0,0.25)",
            zeroLineBorderDash: [],
            zeroLineBorderDashOffset: 0.0,
            offsetGridLines: false,
            borderDash: [],
            borderDashOffset: 0.0
        },
        // scale label
        scaleLabel: {
            // display property
            display: false,
            // actual label
            labelString: "",
            // top/bottom padding
            padding: {
                top: 4,
                bottom: 4
            }
        },
        // label settings
        ticks: {
            beginAtZero: false,
            minRotation: 0,
            maxRotation: 50,
            mirror: false,
            padding: 0,
            reverse: false,
            display: true,
            autoSkip: true,
            autoSkipPadding: 0,
            labelOffset: 0,
            // We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
            callback: core_ticks.formatters.values,
            minor: {},
            major: {}
        }
    });
    /** Returns a new array containing numItems from arr */ function sample(arr, numItems) {
        var result = [];
        var increment = arr.length / numItems;
        var i = 0;
        var len = arr.length;
        for(; i < len; i += increment)result.push(arr[Math.floor(i)]);
        return result;
    }
    function getPixelForGridLine(scale, index, offsetGridLines) {
        var length = scale.getTicks().length;
        var validIndex = Math.min(index, length - 1);
        var lineValue = scale.getPixelForTick(validIndex);
        var start = scale._startPixel;
        var end = scale._endPixel;
        var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.
        var offset;
        if (offsetGridLines) {
            if (length === 1) offset = Math.max(lineValue - start, end - lineValue);
            else if (index === 0) offset = (scale.getPixelForTick(1) - lineValue) / 2;
            else offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
            lineValue += validIndex < index ? offset : -offset;
            // Return undefined if the pixel is out of the range
            if (lineValue < start - epsilon || lineValue > end + epsilon) return;
        }
        return lineValue;
    }
    function garbageCollect(caches, length) {
        helpers$1.each(caches, function(cache) {
            var gc = cache.gc;
            var gcLen = gc.length / 2;
            var i;
            if (gcLen > length) {
                for(i = 0; i < gcLen; ++i)delete cache.data[gc[i]];
                gc.splice(0, gcLen);
            }
        });
    }
    /**
 * Returns {width, height, offset} objects for the first, last, widest, highest tick
 * labels where offset indicates the anchor point offset from the top in pixels.
 */ function computeLabelSizes(ctx, tickFonts, ticks, caches) {
        var length = ticks.length;
        var widths = [];
        var heights = [];
        var offsets = [];
        var widestLabelSize = 0;
        var highestLabelSize = 0;
        var i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel, widest, highest;
        for(i = 0; i < length; ++i){
            label = ticks[i].label;
            tickFont = ticks[i].major ? tickFonts.major : tickFonts.minor;
            ctx.font = fontString = tickFont.string;
            cache = caches[fontString] = caches[fontString] || {
                data: {},
                gc: []
            };
            lineHeight = tickFont.lineHeight;
            width = height = 0;
            // Undefined labels and arrays should not be measured
            if (!isNullOrUndef(label) && !isArray(label)) {
                width = helpers$1.measureText(ctx, cache.data, cache.gc, width, label);
                height = lineHeight;
            } else if (isArray(label)) // if it is an array let's measure each element
            for(j = 0, jlen = label.length; j < jlen; ++j){
                nestedLabel = label[j];
                // Undefined labels and arrays should not be measured
                if (!isNullOrUndef(nestedLabel) && !isArray(nestedLabel)) {
                    width = helpers$1.measureText(ctx, cache.data, cache.gc, width, nestedLabel);
                    height += lineHeight;
                }
            }
            widths.push(width);
            heights.push(height);
            offsets.push(lineHeight / 2);
            widestLabelSize = Math.max(width, widestLabelSize);
            highestLabelSize = Math.max(height, highestLabelSize);
        }
        garbageCollect(caches, length);
        widest = widths.indexOf(widestLabelSize);
        highest = heights.indexOf(highestLabelSize);
        function valueAt(idx) {
            return {
                width: widths[idx] || 0,
                height: heights[idx] || 0,
                offset: offsets[idx] || 0
            };
        }
        return {
            first: valueAt(0),
            last: valueAt(length - 1),
            widest: valueAt(widest),
            highest: valueAt(highest)
        };
    }
    function getTickMarkLength(options) {
        return options.drawTicks ? options.tickMarkLength : 0;
    }
    function getScaleLabelHeight(options) {
        var font, padding;
        if (!options.display) return 0;
        font = helpers$1.options._parseFont(options);
        padding = helpers$1.options.toPadding(options.padding);
        return font.lineHeight + padding.height;
    }
    function parseFontOptions(options, nestedOpts) {
        return helpers$1.extend(helpers$1.options._parseFont({
            fontFamily: valueOrDefault$a(nestedOpts.fontFamily, options.fontFamily),
            fontSize: valueOrDefault$a(nestedOpts.fontSize, options.fontSize),
            fontStyle: valueOrDefault$a(nestedOpts.fontStyle, options.fontStyle),
            lineHeight: valueOrDefault$a(nestedOpts.lineHeight, options.lineHeight)
        }), {
            color: helpers$1.options.resolve([
                nestedOpts.fontColor,
                options.fontColor,
                core_defaults.global.defaultFontColor
            ])
        });
    }
    function parseTickFontOptions(options) {
        var minor = parseFontOptions(options, options.minor);
        var major = options.major.enabled ? parseFontOptions(options, options.major) : minor;
        return {
            minor: minor,
            major: major
        };
    }
    function nonSkipped(ticksToFilter) {
        var filtered = [];
        var item, index, len;
        for(index = 0, len = ticksToFilter.length; index < len; ++index){
            item = ticksToFilter[index];
            if (typeof item._index !== "undefined") filtered.push(item);
        }
        return filtered;
    }
    function getEvenSpacing(arr) {
        var len = arr.length;
        var i, diff;
        if (len < 2) return false;
        for(diff = arr[0], i = 1; i < len; ++i){
            if (arr[i] - arr[i - 1] !== diff) return false;
        }
        return diff;
    }
    function calculateSpacing(majorIndices, ticks, axisLength, ticksLimit) {
        var evenMajorSpacing = getEvenSpacing(majorIndices);
        var spacing = (ticks.length - 1) / ticksLimit;
        var factors, factor, i, ilen;
        // If the major ticks are evenly spaced apart, place the minor ticks
        // so that they divide the major ticks into even chunks
        if (!evenMajorSpacing) return Math.max(spacing, 1);
        factors = helpers$1.math._factorize(evenMajorSpacing);
        for(i = 0, ilen = factors.length - 1; i < ilen; i++){
            factor = factors[i];
            if (factor > spacing) return factor;
        }
        return Math.max(spacing, 1);
    }
    function getMajorIndices(ticks) {
        var result = [];
        var i, ilen;
        for(i = 0, ilen = ticks.length; i < ilen; i++)if (ticks[i].major) result.push(i);
        return result;
    }
    function skipMajors(ticks, majorIndices, spacing) {
        var count = 0;
        var next = majorIndices[0];
        var i, tick;
        spacing = Math.ceil(spacing);
        for(i = 0; i < ticks.length; i++){
            tick = ticks[i];
            if (i === next) {
                tick._index = i;
                count++;
                next = majorIndices[count * spacing];
            } else delete tick.label;
        }
    }
    function skip(ticks, spacing, majorStart, majorEnd) {
        var start = valueOrDefault$a(majorStart, 0);
        var end = Math.min(valueOrDefault$a(majorEnd, ticks.length), ticks.length);
        var count = 0;
        var length, i, tick, next;
        spacing = Math.ceil(spacing);
        if (majorEnd) {
            length = majorEnd - majorStart;
            spacing = length / Math.floor(length / spacing);
        }
        next = start;
        while(next < 0){
            count++;
            next = Math.round(start + count * spacing);
        }
        for(i = Math.max(start, 0); i < end; i++){
            tick = ticks[i];
            if (i === next) {
                tick._index = i;
                count++;
                next = Math.round(start + count * spacing);
            } else delete tick.label;
        }
    }
    var Scale = core_element.extend({
        zeroLineIndex: 0,
        /**
	 * Get the padding needed for the scale
	 * @method getPadding
	 * @private
	 * @returns {Padding} the necessary padding
	 */ getPadding: function() {
            var me = this;
            return {
                left: me.paddingLeft || 0,
                top: me.paddingTop || 0,
                right: me.paddingRight || 0,
                bottom: me.paddingBottom || 0
            };
        },
        /**
	 * Returns the scale tick objects ({label, major})
	 * @since 2.7
	 */ getTicks: function() {
            return this._ticks;
        },
        /**
	* @private
	*/ _getLabels: function() {
            var data = this.chart.data;
            return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
        },
        // These methods are ordered by lifecyle. Utilities then follow.
        // Any function defined here is inherited by all scale types.
        // Any function can be extended by the scale type
        /**
	 * Provided for backward compatibility, not available anymore
	 * @function Chart.Scale.mergeTicksOptions
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 */ mergeTicksOptions: function() {
        // noop
        },
        beforeUpdate: function() {
            helpers$1.callback(this.options.beforeUpdate, [
                this
            ]);
        },
        /**
	 * @param {number} maxWidth - the max width in pixels
	 * @param {number} maxHeight - the max height in pixels
	 * @param {object} margins - the space between the edge of the other scales and edge of the chart
	 *   This space comes from two sources:
	 *     - padding - space that's required to show the labels at the edges of the scale
	 *     - thickness of scales or legends in another orientation
	 */ update: function(maxWidth, maxHeight, margins) {
            var me = this;
            var tickOpts = me.options.ticks;
            var sampleSize = tickOpts.sampleSize;
            var i, ilen, labels, ticks, samplingEnabled;
            // Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
            me.beforeUpdate();
            // Absorb the master measurements
            me.maxWidth = maxWidth;
            me.maxHeight = maxHeight;
            me.margins = helpers$1.extend({
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            }, margins);
            me._ticks = null;
            me.ticks = null;
            me._labelSizes = null;
            me._maxLabelLines = 0;
            me.longestLabelWidth = 0;
            me.longestTextCache = me.longestTextCache || {};
            me._gridLineItems = null;
            me._labelItems = null;
            // Dimensions
            me.beforeSetDimensions();
            me.setDimensions();
            me.afterSetDimensions();
            // Data min/max
            me.beforeDataLimits();
            me.determineDataLimits();
            me.afterDataLimits();
            // Ticks - `this.ticks` is now DEPRECATED!
            // Internal ticks are now stored as objects in the PRIVATE `this._ticks` member
            // and must not be accessed directly from outside this class. `this.ticks` being
            // around for long time and not marked as private, we can't change its structure
            // without unexpected breaking changes. If you need to access the scale ticks,
            // use scale.getTicks() instead.
            me.beforeBuildTicks();
            // New implementations should return an array of objects but for BACKWARD COMPAT,
            // we still support no return (`this.ticks` internally set by calling this method).
            ticks = me.buildTicks() || [];
            // Allow modification of ticks in callback.
            ticks = me.afterBuildTicks(ticks) || ticks;
            // Ensure ticks contains ticks in new tick format
            if ((!ticks || !ticks.length) && me.ticks) {
                ticks = [];
                for(i = 0, ilen = me.ticks.length; i < ilen; ++i)ticks.push({
                    value: me.ticks[i],
                    major: false
                });
            }
            me._ticks = ticks;
            // Compute tick rotation and fit using a sampled subset of labels
            // We generally don't need to compute the size of every single label for determining scale size
            samplingEnabled = sampleSize < ticks.length;
            labels = me._convertTicksToLabels(samplingEnabled ? sample(ticks, sampleSize) : ticks);
            // _configure is called twice, once here, once from core.controller.updateLayout.
            // Here we haven't been positioned yet, but dimensions are correct.
            // Variables set in _configure are needed for calculateTickRotation, and
            // it's ok that coordinates are not correct there, only dimensions matter.
            me._configure();
            // Tick Rotation
            me.beforeCalculateTickRotation();
            me.calculateTickRotation();
            me.afterCalculateTickRotation();
            me.beforeFit();
            me.fit();
            me.afterFit();
            // Auto-skip
            me._ticksToDraw = tickOpts.display && (tickOpts.autoSkip || tickOpts.source === "auto") ? me._autoSkip(ticks) : ticks;
            if (samplingEnabled) // Generate labels using all non-skipped ticks
            labels = me._convertTicksToLabels(me._ticksToDraw);
            me.ticks = labels; // BACKWARD COMPATIBILITY
            // IMPORTANT: after this point, we consider that `this.ticks` will NEVER change!
            me.afterUpdate();
            // TODO(v3): remove minSize as a public property and return value from all layout boxes. It is unused
            // make maxWidth and maxHeight private
            return me.minSize;
        },
        /**
	 * @private
	 */ _configure: function() {
            var me = this;
            var reversePixels = me.options.ticks.reverse;
            var startPixel, endPixel;
            if (me.isHorizontal()) {
                startPixel = me.left;
                endPixel = me.right;
            } else {
                startPixel = me.top;
                endPixel = me.bottom;
                // by default vertical scales are from bottom to top, so pixels are reversed
                reversePixels = !reversePixels;
            }
            me._startPixel = startPixel;
            me._endPixel = endPixel;
            me._reversePixels = reversePixels;
            me._length = endPixel - startPixel;
        },
        afterUpdate: function() {
            helpers$1.callback(this.options.afterUpdate, [
                this
            ]);
        },
        //
        beforeSetDimensions: function() {
            helpers$1.callback(this.options.beforeSetDimensions, [
                this
            ]);
        },
        setDimensions: function() {
            var me = this;
            // Set the unconstrained dimension before label rotation
            if (me.isHorizontal()) {
                // Reset position before calculating rotation
                me.width = me.maxWidth;
                me.left = 0;
                me.right = me.width;
            } else {
                me.height = me.maxHeight;
                // Reset position before calculating rotation
                me.top = 0;
                me.bottom = me.height;
            }
            // Reset padding
            me.paddingLeft = 0;
            me.paddingTop = 0;
            me.paddingRight = 0;
            me.paddingBottom = 0;
        },
        afterSetDimensions: function() {
            helpers$1.callback(this.options.afterSetDimensions, [
                this
            ]);
        },
        // Data limits
        beforeDataLimits: function() {
            helpers$1.callback(this.options.beforeDataLimits, [
                this
            ]);
        },
        determineDataLimits: helpers$1.noop,
        afterDataLimits: function() {
            helpers$1.callback(this.options.afterDataLimits, [
                this
            ]);
        },
        //
        beforeBuildTicks: function() {
            helpers$1.callback(this.options.beforeBuildTicks, [
                this
            ]);
        },
        buildTicks: helpers$1.noop,
        afterBuildTicks: function(ticks) {
            var me = this;
            // ticks is empty for old axis implementations here
            if (isArray(ticks) && ticks.length) return helpers$1.callback(me.options.afterBuildTicks, [
                me,
                ticks
            ]);
            // Support old implementations (that modified `this.ticks` directly in buildTicks)
            me.ticks = helpers$1.callback(me.options.afterBuildTicks, [
                me,
                me.ticks
            ]) || me.ticks;
            return ticks;
        },
        beforeTickToLabelConversion: function() {
            helpers$1.callback(this.options.beforeTickToLabelConversion, [
                this
            ]);
        },
        convertTicksToLabels: function() {
            var me = this;
            // Convert ticks to strings
            var tickOpts = me.options.ticks;
            me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback, this);
        },
        afterTickToLabelConversion: function() {
            helpers$1.callback(this.options.afterTickToLabelConversion, [
                this
            ]);
        },
        //
        beforeCalculateTickRotation: function() {
            helpers$1.callback(this.options.beforeCalculateTickRotation, [
                this
            ]);
        },
        calculateTickRotation: function() {
            var me = this;
            var options = me.options;
            var tickOpts = options.ticks;
            var numTicks = me.getTicks().length;
            var minRotation = tickOpts.minRotation || 0;
            var maxRotation = tickOpts.maxRotation;
            var labelRotation = minRotation;
            var labelSizes, maxLabelWidth, maxLabelHeight, maxWidth, tickWidth, maxHeight, maxLabelDiagonal;
            if (!me._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !me.isHorizontal()) {
                me.labelRotation = minRotation;
                return;
            }
            labelSizes = me._getLabelSizes();
            maxLabelWidth = labelSizes.widest.width;
            maxLabelHeight = labelSizes.highest.height - labelSizes.highest.offset;
            // Estimate the width of each grid based on the canvas width, the maximum
            // label width and the number of tick intervals
            maxWidth = Math.min(me.maxWidth, me.chart.width - maxLabelWidth);
            tickWidth = options.offset ? me.maxWidth / numTicks : maxWidth / (numTicks - 1);
            // Allow 3 pixels x2 padding either side for label readability
            if (maxLabelWidth + 6 > tickWidth) {
                tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
                maxHeight = me.maxHeight - getTickMarkLength(options.gridLines) - tickOpts.padding - getScaleLabelHeight(options.scaleLabel);
                maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
                labelRotation = helpers$1.toDegrees(Math.min(Math.asin(Math.min((labelSizes.highest.height + 6) / tickWidth, 1)), Math.asin(Math.min(maxHeight / maxLabelDiagonal, 1)) - Math.asin(maxLabelHeight / maxLabelDiagonal)));
                labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
            }
            me.labelRotation = labelRotation;
        },
        afterCalculateTickRotation: function() {
            helpers$1.callback(this.options.afterCalculateTickRotation, [
                this
            ]);
        },
        //
        beforeFit: function() {
            helpers$1.callback(this.options.beforeFit, [
                this
            ]);
        },
        fit: function() {
            var me = this;
            // Reset
            var minSize = me.minSize = {
                width: 0,
                height: 0
            };
            var chart = me.chart;
            var opts = me.options;
            var tickOpts = opts.ticks;
            var scaleLabelOpts = opts.scaleLabel;
            var gridLineOpts = opts.gridLines;
            var display = me._isVisible();
            var isBottom = opts.position === "bottom";
            var isHorizontal = me.isHorizontal();
            // Width
            if (isHorizontal) minSize.width = me.maxWidth;
            else if (display) minSize.width = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
            // height
            if (!isHorizontal) minSize.height = me.maxHeight; // fill all the height
            else if (display) minSize.height = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
            // Don't bother fitting the ticks if we are not showing the labels
            if (tickOpts.display && display) {
                var tickFonts = parseTickFontOptions(tickOpts);
                var labelSizes = me._getLabelSizes();
                var firstLabelSize = labelSizes.first;
                var lastLabelSize = labelSizes.last;
                var widestLabelSize = labelSizes.widest;
                var highestLabelSize = labelSizes.highest;
                var lineSpace = tickFonts.minor.lineHeight * 0.4;
                var tickPadding = tickOpts.padding;
                if (isHorizontal) {
                    // A horizontal axis is more constrained by the height.
                    var isRotated = me.labelRotation !== 0;
                    var angleRadians = helpers$1.toRadians(me.labelRotation);
                    var cosRotation = Math.cos(angleRadians);
                    var sinRotation = Math.sin(angleRadians);
                    var labelHeight = sinRotation * widestLabelSize.width + cosRotation * (highestLabelSize.height - (isRotated ? highestLabelSize.offset : 0)) + (isRotated ? 0 : lineSpace); // padding
                    minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight + tickPadding);
                    var offsetLeft = me.getPixelForTick(0) - me.left;
                    var offsetRight = me.right - me.getPixelForTick(me.getTicks().length - 1);
                    var paddingLeft, paddingRight;
                    // Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned
                    // which means that the right padding is dominated by the font height
                    if (isRotated) {
                        paddingLeft = isBottom ? cosRotation * firstLabelSize.width + sinRotation * firstLabelSize.offset : sinRotation * (firstLabelSize.height - firstLabelSize.offset);
                        paddingRight = isBottom ? sinRotation * (lastLabelSize.height - lastLabelSize.offset) : cosRotation * lastLabelSize.width + sinRotation * lastLabelSize.offset;
                    } else {
                        paddingLeft = firstLabelSize.width / 2;
                        paddingRight = lastLabelSize.width / 2;
                    }
                    // Adjust padding taking into account changes in offsets
                    // and add 3 px to move away from canvas edges
                    me.paddingLeft = Math.max((paddingLeft - offsetLeft) * me.width / (me.width - offsetLeft), 0) + 3;
                    me.paddingRight = Math.max((paddingRight - offsetRight) * me.width / (me.width - offsetRight), 0) + 3;
                } else {
                    // A vertical axis is more constrained by the width. Labels are the
                    // dominant factor here, so get that length first and account for padding
                    var labelWidth = tickOpts.mirror ? 0 : // use lineSpace for consistency with horizontal axis
                    // tickPadding is not implemented for horizontal
                    widestLabelSize.width + tickPadding + lineSpace;
                    minSize.width = Math.min(me.maxWidth, minSize.width + labelWidth);
                    me.paddingTop = firstLabelSize.height / 2;
                    me.paddingBottom = lastLabelSize.height / 2;
                }
            }
            me.handleMargins();
            if (isHorizontal) {
                me.width = me._length = chart.width - me.margins.left - me.margins.right;
                me.height = minSize.height;
            } else {
                me.width = minSize.width;
                me.height = me._length = chart.height - me.margins.top - me.margins.bottom;
            }
        },
        /**
	 * Handle margins and padding interactions
	 * @private
	 */ handleMargins: function() {
            var me = this;
            if (me.margins) {
                me.margins.left = Math.max(me.paddingLeft, me.margins.left);
                me.margins.top = Math.max(me.paddingTop, me.margins.top);
                me.margins.right = Math.max(me.paddingRight, me.margins.right);
                me.margins.bottom = Math.max(me.paddingBottom, me.margins.bottom);
            }
        },
        afterFit: function() {
            helpers$1.callback(this.options.afterFit, [
                this
            ]);
        },
        // Shared Methods
        isHorizontal: function() {
            var pos = this.options.position;
            return pos === "top" || pos === "bottom";
        },
        isFullWidth: function() {
            return this.options.fullWidth;
        },
        // Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
        getRightValue: function(rawValue) {
            // Null and undefined values first
            if (isNullOrUndef(rawValue)) return NaN;
            // isNaN(object) returns true, so make sure NaN is checking for a number; Discard Infinite values
            if ((typeof rawValue === "number" || rawValue instanceof Number) && !isFinite(rawValue)) return NaN;
            // If it is in fact an object, dive in one more level
            if (rawValue) {
                if (this.isHorizontal()) {
                    if (rawValue.x !== undefined) return this.getRightValue(rawValue.x);
                } else if (rawValue.y !== undefined) return this.getRightValue(rawValue.y);
            }
            // Value is good, return it
            return rawValue;
        },
        _convertTicksToLabels: function(ticks) {
            var me = this;
            var labels, i, ilen;
            me.ticks = ticks.map(function(tick) {
                return tick.value;
            });
            me.beforeTickToLabelConversion();
            // New implementations should return the formatted tick labels but for BACKWARD
            // COMPAT, we still support no return (`this.ticks` internally changed by calling
            // this method and supposed to contain only string values).
            labels = me.convertTicksToLabels(ticks) || me.ticks;
            me.afterTickToLabelConversion();
            // BACKWARD COMPAT: synchronize `_ticks` with labels (so potentially `this.ticks`)
            for(i = 0, ilen = ticks.length; i < ilen; ++i)ticks[i].label = labels[i];
            return labels;
        },
        /**
	 * @private
	 */ _getLabelSizes: function() {
            var me = this;
            var labelSizes = me._labelSizes;
            if (!labelSizes) {
                me._labelSizes = labelSizes = computeLabelSizes(me.ctx, parseTickFontOptions(me.options.ticks), me.getTicks(), me.longestTextCache);
                me.longestLabelWidth = labelSizes.widest.width;
            }
            return labelSizes;
        },
        /**
	 * @private
	 */ _parseValue: function(value) {
            var start, end, min, max;
            if (isArray(value)) {
                start = +this.getRightValue(value[0]);
                end = +this.getRightValue(value[1]);
                min = Math.min(start, end);
                max = Math.max(start, end);
            } else {
                value = +this.getRightValue(value);
                start = undefined;
                end = value;
                min = value;
                max = value;
            }
            return {
                min: min,
                max: max,
                start: start,
                end: end
            };
        },
        /**
	* @private
	*/ _getScaleLabel: function(rawValue) {
            var v = this._parseValue(rawValue);
            if (v.start !== undefined) return "[" + v.start + ", " + v.end + "]";
            return +this.getRightValue(rawValue);
        },
        /**
	 * Used to get the value to display in the tooltip for the data at the given index
	 * @param index
	 * @param datasetIndex
	 */ getLabelForIndex: helpers$1.noop,
        /**
	 * Returns the location of the given data point. Value can either be an index or a numerical value
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 * @param value
	 * @param index
	 * @param datasetIndex
	 */ getPixelForValue: helpers$1.noop,
        /**
	 * Used to get the data value from a given pixel. This is the inverse of getPixelForValue
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 * @param pixel
	 */ getValueForPixel: helpers$1.noop,
        /**
	 * Returns the location of the tick at the given index
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */ getPixelForTick: function(index) {
            var me = this;
            var offset = me.options.offset;
            var numTicks = me._ticks.length;
            var tickWidth = 1 / Math.max(numTicks - (offset ? 0 : 1), 1);
            return index < 0 || index > numTicks - 1 ? null : me.getPixelForDecimal(index * tickWidth + (offset ? tickWidth / 2 : 0));
        },
        /**
	 * Utility for getting the pixel location of a percentage of scale
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */ getPixelForDecimal: function(decimal) {
            var me = this;
            if (me._reversePixels) decimal = 1 - decimal;
            return me._startPixel + decimal * me._length;
        },
        getDecimalForPixel: function(pixel) {
            var decimal = (pixel - this._startPixel) / this._length;
            return this._reversePixels ? 1 - decimal : decimal;
        },
        /**
	 * Returns the pixel for the minimum chart value
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */ getBasePixel: function() {
            return this.getPixelForValue(this.getBaseValue());
        },
        getBaseValue: function() {
            var me = this;
            var min = me.min;
            var max = me.max;
            return me.beginAtZero ? 0 : min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
        },
        /**
	 * Returns a subset of ticks to be plotted to avoid overlapping labels.
	 * @private
	 */ _autoSkip: function(ticks) {
            var me = this;
            var tickOpts = me.options.ticks;
            var axisLength = me._length;
            var ticksLimit = tickOpts.maxTicksLimit || axisLength / me._tickSize() + 1;
            var majorIndices = tickOpts.major.enabled ? getMajorIndices(ticks) : [];
            var numMajorIndices = majorIndices.length;
            var first = majorIndices[0];
            var last = majorIndices[numMajorIndices - 1];
            var i, ilen, spacing, avgMajorSpacing;
            // If there are too many major ticks to display them all
            if (numMajorIndices > ticksLimit) {
                skipMajors(ticks, majorIndices, numMajorIndices / ticksLimit);
                return nonSkipped(ticks);
            }
            spacing = calculateSpacing(majorIndices, ticks, axisLength, ticksLimit);
            if (numMajorIndices > 0) {
                for(i = 0, ilen = numMajorIndices - 1; i < ilen; i++)skip(ticks, spacing, majorIndices[i], majorIndices[i + 1]);
                avgMajorSpacing = numMajorIndices > 1 ? (last - first) / (numMajorIndices - 1) : null;
                skip(ticks, spacing, helpers$1.isNullOrUndef(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
                skip(ticks, spacing, last, helpers$1.isNullOrUndef(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
                return nonSkipped(ticks);
            }
            skip(ticks, spacing);
            return nonSkipped(ticks);
        },
        /**
	 * @private
	 */ _tickSize: function() {
            var me = this;
            var optionTicks = me.options.ticks;
            // Calculate space needed by label in axis direction.
            var rot = helpers$1.toRadians(me.labelRotation);
            var cos = Math.abs(Math.cos(rot));
            var sin = Math.abs(Math.sin(rot));
            var labelSizes = me._getLabelSizes();
            var padding = optionTicks.autoSkipPadding || 0;
            var w = labelSizes ? labelSizes.widest.width + padding : 0;
            var h = labelSizes ? labelSizes.highest.height + padding : 0;
            // Calculate space needed for 1 tick in axis direction.
            return me.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
        },
        /**
	 * @private
	 */ _isVisible: function() {
            var me = this;
            var chart = me.chart;
            var display = me.options.display;
            var i, ilen, meta;
            if (display !== "auto") return !!display;
            // When 'auto', the scale is visible if at least one associated dataset is visible.
            for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                meta = chart.getDatasetMeta(i);
                if (meta.xAxisID === me.id || meta.yAxisID === me.id) return true;
            }
            return false;
        },
        /**
	 * @private
	 */ _computeGridLineItems: function(chartArea) {
            var me = this;
            var chart = me.chart;
            var options = me.options;
            var gridLines = options.gridLines;
            var position = options.position;
            var offsetGridLines = gridLines.offsetGridLines;
            var isHorizontal = me.isHorizontal();
            var ticks = me._ticksToDraw;
            var ticksLength = ticks.length + (offsetGridLines ? 1 : 0);
            var tl = getTickMarkLength(gridLines);
            var items = [];
            var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
            var axisHalfWidth = axisWidth / 2;
            var alignPixel = helpers$1._alignPixel;
            var alignBorderValue = function(pixel) {
                return alignPixel(chart, pixel, axisWidth);
            };
            var borderValue, i, tick, lineValue, alignedLineValue;
            var tx1, ty1, tx2, ty2, x1, y1, x2, y2, lineWidth, lineColor, borderDash, borderDashOffset;
            if (position === "top") {
                borderValue = alignBorderValue(me.bottom);
                ty1 = me.bottom - tl;
                ty2 = borderValue - axisHalfWidth;
                y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
                y2 = chartArea.bottom;
            } else if (position === "bottom") {
                borderValue = alignBorderValue(me.top);
                y1 = chartArea.top;
                y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
                ty1 = borderValue + axisHalfWidth;
                ty2 = me.top + tl;
            } else if (position === "left") {
                borderValue = alignBorderValue(me.right);
                tx1 = me.right - tl;
                tx2 = borderValue - axisHalfWidth;
                x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
                x2 = chartArea.right;
            } else {
                borderValue = alignBorderValue(me.left);
                x1 = chartArea.left;
                x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
                tx1 = borderValue + axisHalfWidth;
                tx2 = me.left + tl;
            }
            for(i = 0; i < ticksLength; ++i){
                tick = ticks[i] || {};
                // autoskipper skipped this tick (#4635)
                if (isNullOrUndef(tick.label) && i < ticks.length) continue;
                if (i === me.zeroLineIndex && options.offset === offsetGridLines) {
                    // Draw the first index specially
                    lineWidth = gridLines.zeroLineWidth;
                    lineColor = gridLines.zeroLineColor;
                    borderDash = gridLines.zeroLineBorderDash || [];
                    borderDashOffset = gridLines.zeroLineBorderDashOffset || 0.0;
                } else {
                    lineWidth = valueAtIndexOrDefault(gridLines.lineWidth, i, 1);
                    lineColor = valueAtIndexOrDefault(gridLines.color, i, "rgba(0,0,0,0.1)");
                    borderDash = gridLines.borderDash || [];
                    borderDashOffset = gridLines.borderDashOffset || 0.0;
                }
                lineValue = getPixelForGridLine(me, tick._index || i, offsetGridLines);
                // Skip if the pixel is out of the range
                if (lineValue === undefined) continue;
                alignedLineValue = alignPixel(chart, lineValue, lineWidth);
                if (isHorizontal) tx1 = tx2 = x1 = x2 = alignedLineValue;
                else ty1 = ty2 = y1 = y2 = alignedLineValue;
                items.push({
                    tx1: tx1,
                    ty1: ty1,
                    tx2: tx2,
                    ty2: ty2,
                    x1: x1,
                    y1: y1,
                    x2: x2,
                    y2: y2,
                    width: lineWidth,
                    color: lineColor,
                    borderDash: borderDash,
                    borderDashOffset: borderDashOffset
                });
            }
            items.ticksLength = ticksLength;
            items.borderValue = borderValue;
            return items;
        },
        /**
	 * @private
	 */ _computeLabelItems: function() {
            var me = this;
            var options = me.options;
            var optionTicks = options.ticks;
            var position = options.position;
            var isMirrored = optionTicks.mirror;
            var isHorizontal = me.isHorizontal();
            var ticks = me._ticksToDraw;
            var fonts = parseTickFontOptions(optionTicks);
            var tickPadding = optionTicks.padding;
            var tl = getTickMarkLength(options.gridLines);
            var rotation = -helpers$1.toRadians(me.labelRotation);
            var items = [];
            var i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
            if (position === "top") {
                y = me.bottom - tl - tickPadding;
                textAlign = !rotation ? "center" : "left";
            } else if (position === "bottom") {
                y = me.top + tl + tickPadding;
                textAlign = !rotation ? "center" : "right";
            } else if (position === "left") {
                x = me.right - (isMirrored ? 0 : tl) - tickPadding;
                textAlign = isMirrored ? "left" : "right";
            } else {
                x = me.left + (isMirrored ? 0 : tl) + tickPadding;
                textAlign = isMirrored ? "right" : "left";
            }
            for(i = 0, ilen = ticks.length; i < ilen; ++i){
                tick = ticks[i];
                label = tick.label;
                // autoskipper skipped this tick (#4635)
                if (isNullOrUndef(label)) continue;
                pixel = me.getPixelForTick(tick._index || i) + optionTicks.labelOffset;
                font = tick.major ? fonts.major : fonts.minor;
                lineHeight = font.lineHeight;
                lineCount = isArray(label) ? label.length : 1;
                if (isHorizontal) {
                    x = pixel;
                    textOffset = position === "top" ? ((!rotation ? 0.5 : 1) - lineCount) * lineHeight : (!rotation ? 0.5 : 0) * lineHeight;
                } else {
                    y = pixel;
                    textOffset = (1 - lineCount) * lineHeight / 2;
                }
                items.push({
                    x: x,
                    y: y,
                    rotation: rotation,
                    label: label,
                    font: font,
                    textOffset: textOffset,
                    textAlign: textAlign
                });
            }
            return items;
        },
        /**
	 * @private
	 */ _drawGrid: function(chartArea) {
            var me = this;
            var gridLines = me.options.gridLines;
            if (!gridLines.display) return;
            var ctx = me.ctx;
            var chart = me.chart;
            var alignPixel = helpers$1._alignPixel;
            var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
            var items = me._gridLineItems || (me._gridLineItems = me._computeGridLineItems(chartArea));
            var width, color, i, ilen, item;
            for(i = 0, ilen = items.length; i < ilen; ++i){
                item = items[i];
                width = item.width;
                color = item.color;
                if (width && color) {
                    ctx.save();
                    ctx.lineWidth = width;
                    ctx.strokeStyle = color;
                    if (ctx.setLineDash) {
                        ctx.setLineDash(item.borderDash);
                        ctx.lineDashOffset = item.borderDashOffset;
                    }
                    ctx.beginPath();
                    if (gridLines.drawTicks) {
                        ctx.moveTo(item.tx1, item.ty1);
                        ctx.lineTo(item.tx2, item.ty2);
                    }
                    if (gridLines.drawOnChartArea) {
                        ctx.moveTo(item.x1, item.y1);
                        ctx.lineTo(item.x2, item.y2);
                    }
                    ctx.stroke();
                    ctx.restore();
                }
            }
            if (axisWidth) {
                // Draw the line at the edge of the axis
                var firstLineWidth = axisWidth;
                var lastLineWidth = valueAtIndexOrDefault(gridLines.lineWidth, items.ticksLength - 1, 1);
                var borderValue = items.borderValue;
                var x1, x2, y1, y2;
                if (me.isHorizontal()) {
                    x1 = alignPixel(chart, me.left, firstLineWidth) - firstLineWidth / 2;
                    x2 = alignPixel(chart, me.right, lastLineWidth) + lastLineWidth / 2;
                    y1 = y2 = borderValue;
                } else {
                    y1 = alignPixel(chart, me.top, firstLineWidth) - firstLineWidth / 2;
                    y2 = alignPixel(chart, me.bottom, lastLineWidth) + lastLineWidth / 2;
                    x1 = x2 = borderValue;
                }
                ctx.lineWidth = axisWidth;
                ctx.strokeStyle = valueAtIndexOrDefault(gridLines.color, 0);
                ctx.beginPath();
                ctx.moveTo(x1, y1);
                ctx.lineTo(x2, y2);
                ctx.stroke();
            }
        },
        /**
	 * @private
	 */ _drawLabels: function() {
            var me = this;
            var optionTicks = me.options.ticks;
            if (!optionTicks.display) return;
            var ctx = me.ctx;
            var items = me._labelItems || (me._labelItems = me._computeLabelItems());
            var i, j, ilen, jlen, item, tickFont, label, y;
            for(i = 0, ilen = items.length; i < ilen; ++i){
                item = items[i];
                tickFont = item.font;
                // Make sure we draw text in the correct color and font
                ctx.save();
                ctx.translate(item.x, item.y);
                ctx.rotate(item.rotation);
                ctx.font = tickFont.string;
                ctx.fillStyle = tickFont.color;
                ctx.textBaseline = "middle";
                ctx.textAlign = item.textAlign;
                label = item.label;
                y = item.textOffset;
                if (isArray(label)) for(j = 0, jlen = label.length; j < jlen; ++j){
                    // We just make sure the multiline element is a string here..
                    ctx.fillText("" + label[j], 0, y);
                    y += tickFont.lineHeight;
                }
                else ctx.fillText(label, 0, y);
                ctx.restore();
            }
        },
        /**
	 * @private
	 */ _drawTitle: function() {
            var me = this;
            var ctx = me.ctx;
            var options = me.options;
            var scaleLabel = options.scaleLabel;
            if (!scaleLabel.display) return;
            var scaleLabelFontColor = valueOrDefault$a(scaleLabel.fontColor, core_defaults.global.defaultFontColor);
            var scaleLabelFont = helpers$1.options._parseFont(scaleLabel);
            var scaleLabelPadding = helpers$1.options.toPadding(scaleLabel.padding);
            var halfLineHeight = scaleLabelFont.lineHeight / 2;
            var position = options.position;
            var rotation = 0;
            var scaleLabelX, scaleLabelY;
            if (me.isHorizontal()) {
                scaleLabelX = me.left + me.width / 2; // midpoint of the width
                scaleLabelY = position === "bottom" ? me.bottom - halfLineHeight - scaleLabelPadding.bottom : me.top + halfLineHeight + scaleLabelPadding.top;
            } else {
                var isLeft = position === "left";
                scaleLabelX = isLeft ? me.left + halfLineHeight + scaleLabelPadding.top : me.right - halfLineHeight - scaleLabelPadding.top;
                scaleLabelY = me.top + me.height / 2;
                rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
            }
            ctx.save();
            ctx.translate(scaleLabelX, scaleLabelY);
            ctx.rotate(rotation);
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            ctx.fillStyle = scaleLabelFontColor; // render in correct colour
            ctx.font = scaleLabelFont.string;
            ctx.fillText(scaleLabel.labelString, 0, 0);
            ctx.restore();
        },
        draw: function(chartArea) {
            var me = this;
            if (!me._isVisible()) return;
            me._drawGrid(chartArea);
            me._drawTitle();
            me._drawLabels();
        },
        /**
	 * @private
	 */ _layers: function() {
            var me = this;
            var opts = me.options;
            var tz = opts.ticks && opts.ticks.z || 0;
            var gz = opts.gridLines && opts.gridLines.z || 0;
            if (!me._isVisible() || tz === gz || me.draw !== me._draw) // backward compatibility: draw has been overridden by custom scale
            return [
                {
                    z: tz,
                    draw: function() {
                        me.draw.apply(me, arguments);
                    }
                }
            ];
            return [
                {
                    z: gz,
                    draw: function() {
                        me._drawGrid.apply(me, arguments);
                        me._drawTitle.apply(me, arguments);
                    }
                },
                {
                    z: tz,
                    draw: function() {
                        me._drawLabels.apply(me, arguments);
                    }
                }
            ];
        },
        /**
	 * @private
	 */ _getMatchingVisibleMetas: function(type) {
            var me = this;
            var isHorizontal = me.isHorizontal();
            return me.chart._getSortedVisibleDatasetMetas().filter(function(meta) {
                return (!type || meta.type === type) && (isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id);
            });
        }
    });
    Scale.prototype._draw = Scale.prototype.draw;
    var core_scale = Scale;
    var isNullOrUndef$1 = helpers$1.isNullOrUndef;
    var defaultConfig = {
        position: "bottom"
    };
    var scale_category = core_scale.extend({
        determineDataLimits: function() {
            var me = this;
            var labels = me._getLabels();
            var ticksOpts = me.options.ticks;
            var min = ticksOpts.min;
            var max = ticksOpts.max;
            var minIndex = 0;
            var maxIndex = labels.length - 1;
            var findIndex;
            if (min !== undefined) {
                // user specified min value
                findIndex = labels.indexOf(min);
                if (findIndex >= 0) minIndex = findIndex;
            }
            if (max !== undefined) {
                // user specified max value
                findIndex = labels.indexOf(max);
                if (findIndex >= 0) maxIndex = findIndex;
            }
            me.minIndex = minIndex;
            me.maxIndex = maxIndex;
            me.min = labels[minIndex];
            me.max = labels[maxIndex];
        },
        buildTicks: function() {
            var me = this;
            var labels = me._getLabels();
            var minIndex = me.minIndex;
            var maxIndex = me.maxIndex;
            // If we are viewing some subset of labels, slice the original array
            me.ticks = minIndex === 0 && maxIndex === labels.length - 1 ? labels : labels.slice(minIndex, maxIndex + 1);
        },
        getLabelForIndex: function(index, datasetIndex) {
            var me = this;
            var chart = me.chart;
            if (chart.getDatasetMeta(datasetIndex).controller._getValueScaleId() === me.id) return me.getRightValue(chart.data.datasets[datasetIndex].data[index]);
            return me._getLabels()[index];
        },
        _configure: function() {
            var me = this;
            var offset = me.options.offset;
            var ticks = me.ticks;
            core_scale.prototype._configure.call(me);
            if (!me.isHorizontal()) // For backward compatibility, vertical category scale reverse is inverted.
            me._reversePixels = !me._reversePixels;
            if (!ticks) return;
            me._startValue = me.minIndex - (offset ? 0.5 : 0);
            me._valueRange = Math.max(ticks.length - (offset ? 0 : 1), 1);
        },
        // Used to get data value locations.  Value can either be an index or a numerical value
        getPixelForValue: function(value, index, datasetIndex) {
            var me = this;
            var valueCategory, labels, idx;
            if (!isNullOrUndef$1(index) && !isNullOrUndef$1(datasetIndex)) value = me.chart.data.datasets[datasetIndex].data[index];
            // If value is a data object, then index is the index in the data array,
            // not the index of the scale. We need to change that.
            if (!isNullOrUndef$1(value)) valueCategory = me.isHorizontal() ? value.x : value.y;
            if (valueCategory !== undefined || value !== undefined && isNaN(index)) {
                labels = me._getLabels();
                value = helpers$1.valueOrDefault(valueCategory, value);
                idx = labels.indexOf(value);
                index = idx !== -1 ? idx : index;
                if (isNaN(index)) index = value;
            }
            return me.getPixelForDecimal((index - me._startValue) / me._valueRange);
        },
        getPixelForTick: function(index) {
            var ticks = this.ticks;
            return index < 0 || index > ticks.length - 1 ? null : this.getPixelForValue(ticks[index], index + this.minIndex);
        },
        getValueForPixel: function(pixel) {
            var me = this;
            var value = Math.round(me._startValue + me.getDecimalForPixel(pixel) * me._valueRange);
            return Math.min(Math.max(value, 0), me.ticks.length - 1);
        },
        getBasePixel: function() {
            return this.bottom;
        }
    });
    // INTERNAL: static default options, registered in src/index.js
    var _defaults = defaultConfig;
    scale_category._defaults = _defaults;
    var noop = helpers$1.noop;
    var isNullOrUndef$2 = helpers$1.isNullOrUndef;
    /**
 * Generate a set of linear ticks
 * @param generationOptions the options used to generate the ticks
 * @param dataRange the range of the data
 * @returns {number[]} array of tick values
 */ function generateTicks(generationOptions, dataRange) {
        var ticks = [];
        // To get a "nice" value for the tick spacing, we will use the appropriately named
        // "nice number" algorithm. See https://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
        // for details.
        var MIN_SPACING = 1e-14;
        var stepSize = generationOptions.stepSize;
        var unit = stepSize || 1;
        var maxNumSpaces = generationOptions.maxTicks - 1;
        var min = generationOptions.min;
        var max = generationOptions.max;
        var precision = generationOptions.precision;
        var rmin = dataRange.min;
        var rmax = dataRange.max;
        var spacing = helpers$1.niceNum((rmax - rmin) / maxNumSpaces / unit) * unit;
        var factor, niceMin, niceMax, numSpaces;
        // Beyond MIN_SPACING floating point numbers being to lose precision
        // such that we can't do the math necessary to generate ticks
        if (spacing < MIN_SPACING && isNullOrUndef$2(min) && isNullOrUndef$2(max)) return [
            rmin,
            rmax
        ];
        numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
        if (numSpaces > maxNumSpaces) // If the calculated num of spaces exceeds maxNumSpaces, recalculate it
        spacing = helpers$1.niceNum(numSpaces * spacing / maxNumSpaces / unit) * unit;
        if (stepSize || isNullOrUndef$2(precision)) // If a precision is not specified, calculate factor based on spacing
        factor = Math.pow(10, helpers$1._decimalPlaces(spacing));
        else {
            // If the user specified a precision, round to that number of decimal places
            factor = Math.pow(10, precision);
            spacing = Math.ceil(spacing * factor) / factor;
        }
        niceMin = Math.floor(rmin / spacing) * spacing;
        niceMax = Math.ceil(rmax / spacing) * spacing;
        // If min, max and stepSize is set and they make an evenly spaced scale use it.
        if (stepSize) {
            // If very close to our whole number, use it.
            if (!isNullOrUndef$2(min) && helpers$1.almostWhole(min / spacing, spacing / 1000)) niceMin = min;
            if (!isNullOrUndef$2(max) && helpers$1.almostWhole(max / spacing, spacing / 1000)) niceMax = max;
        }
        numSpaces = (niceMax - niceMin) / spacing;
        // If very close to our rounded value, use it.
        if (helpers$1.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) numSpaces = Math.round(numSpaces);
        else numSpaces = Math.ceil(numSpaces);
        niceMin = Math.round(niceMin * factor) / factor;
        niceMax = Math.round(niceMax * factor) / factor;
        ticks.push(isNullOrUndef$2(min) ? niceMin : min);
        for(var j = 1; j < numSpaces; ++j)ticks.push(Math.round((niceMin + j * spacing) * factor) / factor);
        ticks.push(isNullOrUndef$2(max) ? niceMax : max);
        return ticks;
    }
    var scale_linearbase = core_scale.extend({
        getRightValue: function(value) {
            if (typeof value === "string") return +value;
            return core_scale.prototype.getRightValue.call(this, value);
        },
        handleTickRangeOptions: function() {
            var me = this;
            var opts = me.options;
            var tickOpts = opts.ticks;
            // If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
            // do nothing since that would make the chart weird. If the user really wants a weird chart
            // axis, they can manually override it
            if (tickOpts.beginAtZero) {
                var minSign = helpers$1.sign(me.min);
                var maxSign = helpers$1.sign(me.max);
                if (minSign < 0 && maxSign < 0) // move the top up to 0
                me.max = 0;
                else if (minSign > 0 && maxSign > 0) // move the bottom down to 0
                me.min = 0;
            }
            var setMin = tickOpts.min !== undefined || tickOpts.suggestedMin !== undefined;
            var setMax = tickOpts.max !== undefined || tickOpts.suggestedMax !== undefined;
            if (tickOpts.min !== undefined) me.min = tickOpts.min;
            else if (tickOpts.suggestedMin !== undefined) {
                if (me.min === null) me.min = tickOpts.suggestedMin;
                else me.min = Math.min(me.min, tickOpts.suggestedMin);
            }
            if (tickOpts.max !== undefined) me.max = tickOpts.max;
            else if (tickOpts.suggestedMax !== undefined) {
                if (me.max === null) me.max = tickOpts.suggestedMax;
                else me.max = Math.max(me.max, tickOpts.suggestedMax);
            }
            if (setMin !== setMax) // We set the min or the max but not both.
            // So ensure that our range is good
            // Inverted or 0 length range can happen when
            // ticks.min is set, and no datasets are visible
            {
                if (me.min >= me.max) {
                    if (setMin) me.max = me.min + 1;
                    else me.min = me.max - 1;
                }
            }
            if (me.min === me.max) {
                me.max++;
                if (!tickOpts.beginAtZero) me.min--;
            }
        },
        getTickLimit: function() {
            var me = this;
            var tickOpts = me.options.ticks;
            var stepSize = tickOpts.stepSize;
            var maxTicksLimit = tickOpts.maxTicksLimit;
            var maxTicks;
            if (stepSize) maxTicks = Math.ceil(me.max / stepSize) - Math.floor(me.min / stepSize) + 1;
            else {
                maxTicks = me._computeTickLimit();
                maxTicksLimit = maxTicksLimit || 11;
            }
            if (maxTicksLimit) maxTicks = Math.min(maxTicksLimit, maxTicks);
            return maxTicks;
        },
        _computeTickLimit: function() {
            return Number.POSITIVE_INFINITY;
        },
        handleDirectionalChanges: noop,
        buildTicks: function() {
            var me = this;
            var opts = me.options;
            var tickOpts = opts.ticks;
            // Figure out what the max number of ticks we can support it is based on the size of
            // the axis area. For now, we say that the minimum tick spacing in pixels must be 40
            // We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
            // the graph. Make sure we always have at least 2 ticks
            var maxTicks = me.getTickLimit();
            maxTicks = Math.max(2, maxTicks);
            var numericGeneratorOptions = {
                maxTicks: maxTicks,
                min: tickOpts.min,
                max: tickOpts.max,
                precision: tickOpts.precision,
                stepSize: helpers$1.valueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
            };
            var ticks = me.ticks = generateTicks(numericGeneratorOptions, me);
            me.handleDirectionalChanges();
            // At this point, we need to update our max and min given the tick values since we have expanded the
            // range of the scale
            me.max = helpers$1.max(ticks);
            me.min = helpers$1.min(ticks);
            if (tickOpts.reverse) {
                ticks.reverse();
                me.start = me.max;
                me.end = me.min;
            } else {
                me.start = me.min;
                me.end = me.max;
            }
        },
        convertTicksToLabels: function() {
            var me = this;
            me.ticksAsNumbers = me.ticks.slice();
            me.zeroLineIndex = me.ticks.indexOf(0);
            core_scale.prototype.convertTicksToLabels.call(me);
        },
        _configure: function() {
            var me = this;
            var ticks = me.getTicks();
            var start = me.min;
            var end = me.max;
            var offset;
            core_scale.prototype._configure.call(me);
            if (me.options.offset && ticks.length) {
                offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
                start -= offset;
                end += offset;
            }
            me._startValue = start;
            me._endValue = end;
            me._valueRange = end - start;
        }
    });
    var defaultConfig$1 = {
        position: "left",
        ticks: {
            callback: core_ticks.formatters.linear
        }
    };
    var DEFAULT_MIN = 0;
    var DEFAULT_MAX = 1;
    function getOrCreateStack(stacks, stacked, meta) {
        var key = [
            meta.type,
            // we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
            stacked === undefined && meta.stack === undefined ? meta.index : "",
            meta.stack
        ].join(".");
        if (stacks[key] === undefined) stacks[key] = {
            pos: [],
            neg: []
        };
        return stacks[key];
    }
    function stackData(scale, stacks, meta, data) {
        var opts = scale.options;
        var stacked = opts.stacked;
        var stack = getOrCreateStack(stacks, stacked, meta);
        var pos = stack.pos;
        var neg = stack.neg;
        var ilen = data.length;
        var i, value;
        for(i = 0; i < ilen; ++i){
            value = scale._parseValue(data[i]);
            if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) continue;
            pos[i] = pos[i] || 0;
            neg[i] = neg[i] || 0;
            if (opts.relativePoints) pos[i] = 100;
            else if (value.min < 0 || value.max < 0) neg[i] += value.min;
            else pos[i] += value.max;
        }
    }
    function updateMinMax(scale, meta, data) {
        var ilen = data.length;
        var i, value;
        for(i = 0; i < ilen; ++i){
            value = scale._parseValue(data[i]);
            if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) continue;
            scale.min = Math.min(scale.min, value.min);
            scale.max = Math.max(scale.max, value.max);
        }
    }
    var scale_linear = scale_linearbase.extend({
        determineDataLimits: function() {
            var me = this;
            var opts = me.options;
            var chart = me.chart;
            var datasets = chart.data.datasets;
            var metasets = me._getMatchingVisibleMetas();
            var hasStacks = opts.stacked;
            var stacks = {};
            var ilen = metasets.length;
            var i, meta, data, values;
            me.min = Number.POSITIVE_INFINITY;
            me.max = Number.NEGATIVE_INFINITY;
            if (hasStacks === undefined) for(i = 0; !hasStacks && i < ilen; ++i){
                meta = metasets[i];
                hasStacks = meta.stack !== undefined;
            }
            for(i = 0; i < ilen; ++i){
                meta = metasets[i];
                data = datasets[meta.index].data;
                if (hasStacks) stackData(me, stacks, meta, data);
                else updateMinMax(me, meta, data);
            }
            helpers$1.each(stacks, function(stackValues) {
                values = stackValues.pos.concat(stackValues.neg);
                me.min = Math.min(me.min, helpers$1.min(values));
                me.max = Math.max(me.max, helpers$1.max(values));
            });
            me.min = helpers$1.isFinite(me.min) && !isNaN(me.min) ? me.min : DEFAULT_MIN;
            me.max = helpers$1.isFinite(me.max) && !isNaN(me.max) ? me.max : DEFAULT_MAX;
            // Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
            me.handleTickRangeOptions();
        },
        // Returns the maximum number of ticks based on the scale dimension
        _computeTickLimit: function() {
            var me = this;
            var tickFont;
            if (me.isHorizontal()) return Math.ceil(me.width / 40);
            tickFont = helpers$1.options._parseFont(me.options.ticks);
            return Math.ceil(me.height / tickFont.lineHeight);
        },
        // Called after the ticks are built. We need
        handleDirectionalChanges: function() {
            if (!this.isHorizontal()) // We are in a vertical orientation. The top value is the highest. So reverse the array
            this.ticks.reverse();
        },
        getLabelForIndex: function(index, datasetIndex) {
            return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
        },
        // Utils
        getPixelForValue: function(value) {
            var me = this;
            return me.getPixelForDecimal((+me.getRightValue(value) - me._startValue) / me._valueRange);
        },
        getValueForPixel: function(pixel) {
            return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
        },
        getPixelForTick: function(index) {
            var ticks = this.ticksAsNumbers;
            if (index < 0 || index > ticks.length - 1) return null;
            return this.getPixelForValue(ticks[index]);
        }
    });
    // INTERNAL: static default options, registered in src/index.js
    var _defaults$1 = defaultConfig$1;
    scale_linear._defaults = _defaults$1;
    var valueOrDefault$b = helpers$1.valueOrDefault;
    var log10 = helpers$1.math.log10;
    /**
 * Generate a set of logarithmic ticks
 * @param generationOptions the options used to generate the ticks
 * @param dataRange the range of the data
 * @returns {number[]} array of tick values
 */ function generateTicks$1(generationOptions, dataRange) {
        var ticks = [];
        var tickVal = valueOrDefault$b(generationOptions.min, Math.pow(10, Math.floor(log10(dataRange.min))));
        var endExp = Math.floor(log10(dataRange.max));
        var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
        var exp, significand;
        if (tickVal === 0) {
            exp = Math.floor(log10(dataRange.minNotZero));
            significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));
            ticks.push(tickVal);
            tickVal = significand * Math.pow(10, exp);
        } else {
            exp = Math.floor(log10(tickVal));
            significand = Math.floor(tickVal / Math.pow(10, exp));
        }
        var precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
        do {
            ticks.push(tickVal);
            ++significand;
            if (significand === 10) {
                significand = 1;
                ++exp;
                precision = exp >= 0 ? 1 : precision;
            }
            tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
        }while (exp < endExp || exp === endExp && significand < endSignificand);
        var lastTick = valueOrDefault$b(generationOptions.max, tickVal);
        ticks.push(lastTick);
        return ticks;
    }
    var defaultConfig$2 = {
        position: "left",
        // label settings
        ticks: {
            callback: core_ticks.formatters.logarithmic
        }
    };
    // TODO(v3): change this to positiveOrDefault
    function nonNegativeOrDefault(value, defaultValue) {
        return helpers$1.isFinite(value) && value >= 0 ? value : defaultValue;
    }
    var scale_logarithmic = core_scale.extend({
        determineDataLimits: function() {
            var me = this;
            var opts = me.options;
            var chart = me.chart;
            var datasets = chart.data.datasets;
            var isHorizontal = me.isHorizontal();
            function IDMatches(meta) {
                return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
            }
            var datasetIndex, meta, value, data, i, ilen;
            // Calculate Range
            me.min = Number.POSITIVE_INFINITY;
            me.max = Number.NEGATIVE_INFINITY;
            me.minNotZero = Number.POSITIVE_INFINITY;
            var hasStacks = opts.stacked;
            if (hasStacks === undefined) for(datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++){
                meta = chart.getDatasetMeta(datasetIndex);
                if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) && meta.stack !== undefined) {
                    hasStacks = true;
                    break;
                }
            }
            if (opts.stacked || hasStacks) {
                var valuesPerStack = {};
                for(datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++){
                    meta = chart.getDatasetMeta(datasetIndex);
                    var key = [
                        meta.type,
                        // we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
                        opts.stacked === undefined && meta.stack === undefined ? datasetIndex : "",
                        meta.stack
                    ].join(".");
                    if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
                        if (valuesPerStack[key] === undefined) valuesPerStack[key] = [];
                        data = datasets[datasetIndex].data;
                        for(i = 0, ilen = data.length; i < ilen; i++){
                            var values = valuesPerStack[key];
                            value = me._parseValue(data[i]);
                            // invalid, hidden and negative values are ignored
                            if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) continue;
                            values[i] = values[i] || 0;
                            values[i] += value.max;
                        }
                    }
                }
                helpers$1.each(valuesPerStack, function(valuesForType) {
                    if (valuesForType.length > 0) {
                        var minVal = helpers$1.min(valuesForType);
                        var maxVal = helpers$1.max(valuesForType);
                        me.min = Math.min(me.min, minVal);
                        me.max = Math.max(me.max, maxVal);
                    }
                });
            } else for(datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++){
                meta = chart.getDatasetMeta(datasetIndex);
                if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
                    data = datasets[datasetIndex].data;
                    for(i = 0, ilen = data.length; i < ilen; i++){
                        value = me._parseValue(data[i]);
                        // invalid, hidden and negative values are ignored
                        if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) continue;
                        me.min = Math.min(value.min, me.min);
                        me.max = Math.max(value.max, me.max);
                        if (value.min !== 0) me.minNotZero = Math.min(value.min, me.minNotZero);
                    }
                }
            }
            me.min = helpers$1.isFinite(me.min) ? me.min : null;
            me.max = helpers$1.isFinite(me.max) ? me.max : null;
            me.minNotZero = helpers$1.isFinite(me.minNotZero) ? me.minNotZero : null;
            // Common base implementation to handle ticks.min, ticks.max
            this.handleTickRangeOptions();
        },
        handleTickRangeOptions: function() {
            var me = this;
            var tickOpts = me.options.ticks;
            var DEFAULT_MIN = 1;
            var DEFAULT_MAX = 10;
            me.min = nonNegativeOrDefault(tickOpts.min, me.min);
            me.max = nonNegativeOrDefault(tickOpts.max, me.max);
            if (me.min === me.max) {
                if (me.min !== 0 && me.min !== null) {
                    me.min = Math.pow(10, Math.floor(log10(me.min)) - 1);
                    me.max = Math.pow(10, Math.floor(log10(me.max)) + 1);
                } else {
                    me.min = DEFAULT_MIN;
                    me.max = DEFAULT_MAX;
                }
            }
            if (me.min === null) me.min = Math.pow(10, Math.floor(log10(me.max)) - 1);
            if (me.max === null) me.max = me.min !== 0 ? Math.pow(10, Math.floor(log10(me.min)) + 1) : DEFAULT_MAX;
            if (me.minNotZero === null) {
                if (me.min > 0) me.minNotZero = me.min;
                else if (me.max < 1) me.minNotZero = Math.pow(10, Math.floor(log10(me.max)));
                else me.minNotZero = DEFAULT_MIN;
            }
        },
        buildTicks: function() {
            var me = this;
            var tickOpts = me.options.ticks;
            var reverse = !me.isHorizontal();
            var generationOptions = {
                min: nonNegativeOrDefault(tickOpts.min),
                max: nonNegativeOrDefault(tickOpts.max)
            };
            var ticks = me.ticks = generateTicks$1(generationOptions, me);
            // At this point, we need to update our max and min given the tick values since we have expanded the
            // range of the scale
            me.max = helpers$1.max(ticks);
            me.min = helpers$1.min(ticks);
            if (tickOpts.reverse) {
                reverse = !reverse;
                me.start = me.max;
                me.end = me.min;
            } else {
                me.start = me.min;
                me.end = me.max;
            }
            if (reverse) ticks.reverse();
        },
        convertTicksToLabels: function() {
            this.tickValues = this.ticks.slice();
            core_scale.prototype.convertTicksToLabels.call(this);
        },
        // Get the correct tooltip label
        getLabelForIndex: function(index, datasetIndex) {
            return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
        },
        getPixelForTick: function(index) {
            var ticks = this.tickValues;
            if (index < 0 || index > ticks.length - 1) return null;
            return this.getPixelForValue(ticks[index]);
        },
        /**
	 * Returns the value of the first tick.
	 * @param {number} value - The minimum not zero value.
	 * @return {number} The first tick value.
	 * @private
	 */ _getFirstTickValue: function(value) {
            var exp = Math.floor(log10(value));
            var significand = Math.floor(value / Math.pow(10, exp));
            return significand * Math.pow(10, exp);
        },
        _configure: function() {
            var me = this;
            var start = me.min;
            var offset = 0;
            core_scale.prototype._configure.call(me);
            if (start === 0) {
                start = me._getFirstTickValue(me.minNotZero);
                offset = valueOrDefault$b(me.options.ticks.fontSize, core_defaults.global.defaultFontSize) / me._length;
            }
            me._startValue = log10(start);
            me._valueOffset = offset;
            me._valueRange = (log10(me.max) - log10(start)) / (1 - offset);
        },
        getPixelForValue: function(value) {
            var me = this;
            var decimal = 0;
            value = +me.getRightValue(value);
            if (value > me.min && value > 0) decimal = (log10(value) - me._startValue) / me._valueRange + me._valueOffset;
            return me.getPixelForDecimal(decimal);
        },
        getValueForPixel: function(pixel) {
            var me = this;
            var decimal = me.getDecimalForPixel(pixel);
            return decimal === 0 && me.min === 0 ? 0 : Math.pow(10, me._startValue + (decimal - me._valueOffset) * me._valueRange);
        }
    });
    // INTERNAL: static default options, registered in src/index.js
    var _defaults$2 = defaultConfig$2;
    scale_logarithmic._defaults = _defaults$2;
    var valueOrDefault$c = helpers$1.valueOrDefault;
    var valueAtIndexOrDefault$1 = helpers$1.valueAtIndexOrDefault;
    var resolve$4 = helpers$1.options.resolve;
    var defaultConfig$3 = {
        display: true,
        // Boolean - Whether to animate scaling the chart from the centre
        animate: true,
        position: "chartArea",
        angleLines: {
            display: true,
            color: "rgba(0,0,0,0.1)",
            lineWidth: 1,
            borderDash: [],
            borderDashOffset: 0.0
        },
        gridLines: {
            circular: false
        },
        // label settings
        ticks: {
            // Boolean - Show a backdrop to the scale label
            showLabelBackdrop: true,
            // String - The colour of the label backdrop
            backdropColor: "rgba(255,255,255,0.75)",
            // Number - The backdrop padding above & below the label in pixels
            backdropPaddingY: 2,
            // Number - The backdrop padding to the side of the label in pixels
            backdropPaddingX: 2,
            callback: core_ticks.formatters.linear
        },
        pointLabels: {
            // Boolean - if true, show point labels
            display: true,
            // Number - Point label font size in pixels
            fontSize: 10,
            // Function - Used to convert point labels
            callback: function(label) {
                return label;
            }
        }
    };
    function getTickBackdropHeight(opts) {
        var tickOpts = opts.ticks;
        if (tickOpts.display && opts.display) return valueOrDefault$c(tickOpts.fontSize, core_defaults.global.defaultFontSize) + tickOpts.backdropPaddingY * 2;
        return 0;
    }
    function measureLabelSize(ctx, lineHeight, label) {
        if (helpers$1.isArray(label)) return {
            w: helpers$1.longestText(ctx, ctx.font, label),
            h: label.length * lineHeight
        };
        return {
            w: ctx.measureText(label).width,
            h: lineHeight
        };
    }
    function determineLimits(angle, pos, size, min, max) {
        if (angle === min || angle === max) return {
            start: pos - size / 2,
            end: pos + size / 2
        };
        else if (angle < min || angle > max) return {
            start: pos - size,
            end: pos
        };
        return {
            start: pos,
            end: pos + size
        };
    }
    /**
 * Helper function to fit a radial linear scale with point labels
 */ function fitWithPointLabels(scale) {
        // Right, this is really confusing and there is a lot of maths going on here
        // The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
        //
        // Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
        //
        // Solution:
        //
        // We assume the radius of the polygon is half the size of the canvas at first
        // at each index we check if the text overlaps.
        //
        // Where it does, we store that angle and that index.
        //
        // After finding the largest index and angle we calculate how much we need to remove
        // from the shape radius to move the point inwards by that x.
        //
        // We average the left and right distances to get the maximum shape radius that can fit in the box
        // along with labels.
        //
        // Once we have that, we can find the centre point for the chart, by taking the x text protrusion
        // on each side, removing that from the size, halving it and adding the left x protrusion width.
        //
        // This will mean we have a shape fitted to the canvas, as large as it can be with the labels
        // and position it in the most space efficient manner
        //
        // https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif
        var plFont = helpers$1.options._parseFont(scale.options.pointLabels);
        // Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
        // Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
        var furthestLimits = {
            l: 0,
            r: scale.width,
            t: 0,
            b: scale.height - scale.paddingTop
        };
        var furthestAngles = {};
        var i, textSize, pointPosition;
        scale.ctx.font = plFont.string;
        scale._pointLabelSizes = [];
        var valueCount = scale.chart.data.labels.length;
        for(i = 0; i < valueCount; i++){
            pointPosition = scale.getPointPosition(i, scale.drawingArea + 5);
            textSize = measureLabelSize(scale.ctx, plFont.lineHeight, scale.pointLabels[i]);
            scale._pointLabelSizes[i] = textSize;
            // Add quarter circle to make degree 0 mean top of circle
            var angleRadians = scale.getIndexAngle(i);
            var angle = helpers$1.toDegrees(angleRadians) % 360;
            var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
            var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
            if (hLimits.start < furthestLimits.l) {
                furthestLimits.l = hLimits.start;
                furthestAngles.l = angleRadians;
            }
            if (hLimits.end > furthestLimits.r) {
                furthestLimits.r = hLimits.end;
                furthestAngles.r = angleRadians;
            }
            if (vLimits.start < furthestLimits.t) {
                furthestLimits.t = vLimits.start;
                furthestAngles.t = angleRadians;
            }
            if (vLimits.end > furthestLimits.b) {
                furthestLimits.b = vLimits.end;
                furthestAngles.b = angleRadians;
            }
        }
        scale.setReductions(scale.drawingArea, furthestLimits, furthestAngles);
    }
    function getTextAlignForAngle(angle) {
        if (angle === 0 || angle === 180) return "center";
        else if (angle < 180) return "left";
        return "right";
    }
    function fillText(ctx, text, position, lineHeight) {
        var y = position.y + lineHeight / 2;
        var i, ilen;
        if (helpers$1.isArray(text)) for(i = 0, ilen = text.length; i < ilen; ++i){
            ctx.fillText(text[i], position.x, y);
            y += lineHeight;
        }
        else ctx.fillText(text, position.x, y);
    }
    function adjustPointPositionForLabelHeight(angle, textSize, position) {
        if (angle === 90 || angle === 270) position.y -= textSize.h / 2;
        else if (angle > 270 || angle < 90) position.y -= textSize.h;
    }
    function drawPointLabels(scale) {
        var ctx = scale.ctx;
        var opts = scale.options;
        var pointLabelOpts = opts.pointLabels;
        var tickBackdropHeight = getTickBackdropHeight(opts);
        var outerDistance = scale.getDistanceFromCenterForValue(opts.ticks.reverse ? scale.min : scale.max);
        var plFont = helpers$1.options._parseFont(pointLabelOpts);
        ctx.save();
        ctx.font = plFont.string;
        ctx.textBaseline = "middle";
        for(var i = scale.chart.data.labels.length - 1; i >= 0; i--){
            // Extra pixels out for some label spacing
            var extra = i === 0 ? tickBackdropHeight / 2 : 0;
            var pointLabelPosition = scale.getPointPosition(i, outerDistance + extra + 5);
            // Keep this in loop since we may support array properties here
            var pointLabelFontColor = valueAtIndexOrDefault$1(pointLabelOpts.fontColor, i, core_defaults.global.defaultFontColor);
            ctx.fillStyle = pointLabelFontColor;
            var angleRadians = scale.getIndexAngle(i);
            var angle = helpers$1.toDegrees(angleRadians);
            ctx.textAlign = getTextAlignForAngle(angle);
            adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
            fillText(ctx, scale.pointLabels[i], pointLabelPosition, plFont.lineHeight);
        }
        ctx.restore();
    }
    function drawRadiusLine(scale, gridLineOpts, radius, index) {
        var ctx = scale.ctx;
        var circular = gridLineOpts.circular;
        var valueCount = scale.chart.data.labels.length;
        var lineColor = valueAtIndexOrDefault$1(gridLineOpts.color, index - 1);
        var lineWidth = valueAtIndexOrDefault$1(gridLineOpts.lineWidth, index - 1);
        var pointPosition;
        if (!circular && !valueCount || !lineColor || !lineWidth) return;
        ctx.save();
        ctx.strokeStyle = lineColor;
        ctx.lineWidth = lineWidth;
        if (ctx.setLineDash) {
            ctx.setLineDash(gridLineOpts.borderDash || []);
            ctx.lineDashOffset = gridLineOpts.borderDashOffset || 0.0;
        }
        ctx.beginPath();
        if (circular) // Draw circular arcs between the points
        ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
        else {
            // Draw straight lines connecting each index
            pointPosition = scale.getPointPosition(0, radius);
            ctx.moveTo(pointPosition.x, pointPosition.y);
            for(var i = 1; i < valueCount; i++){
                pointPosition = scale.getPointPosition(i, radius);
                ctx.lineTo(pointPosition.x, pointPosition.y);
            }
        }
        ctx.closePath();
        ctx.stroke();
        ctx.restore();
    }
    function numberOrZero(param) {
        return helpers$1.isNumber(param) ? param : 0;
    }
    var scale_radialLinear = scale_linearbase.extend({
        setDimensions: function() {
            var me = this;
            // Set the unconstrained dimension before label rotation
            me.width = me.maxWidth;
            me.height = me.maxHeight;
            me.paddingTop = getTickBackdropHeight(me.options) / 2;
            me.xCenter = Math.floor(me.width / 2);
            me.yCenter = Math.floor((me.height - me.paddingTop) / 2);
            me.drawingArea = Math.min(me.height - me.paddingTop, me.width) / 2;
        },
        determineDataLimits: function() {
            var me = this;
            var chart = me.chart;
            var min = Number.POSITIVE_INFINITY;
            var max = Number.NEGATIVE_INFINITY;
            helpers$1.each(chart.data.datasets, function(dataset, datasetIndex) {
                if (chart.isDatasetVisible(datasetIndex)) {
                    var meta = chart.getDatasetMeta(datasetIndex);
                    helpers$1.each(dataset.data, function(rawValue, index) {
                        var value = +me.getRightValue(rawValue);
                        if (isNaN(value) || meta.data[index].hidden) return;
                        min = Math.min(value, min);
                        max = Math.max(value, max);
                    });
                }
            });
            me.min = min === Number.POSITIVE_INFINITY ? 0 : min;
            me.max = max === Number.NEGATIVE_INFINITY ? 0 : max;
            // Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
            me.handleTickRangeOptions();
        },
        // Returns the maximum number of ticks based on the scale dimension
        _computeTickLimit: function() {
            return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
        },
        convertTicksToLabels: function() {
            var me = this;
            scale_linearbase.prototype.convertTicksToLabels.call(me);
            // Point labels
            me.pointLabels = me.chart.data.labels.map(function() {
                var label = helpers$1.callback(me.options.pointLabels.callback, arguments, me);
                return label || label === 0 ? label : "";
            });
        },
        getLabelForIndex: function(index, datasetIndex) {
            return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
        },
        fit: function() {
            var me = this;
            var opts = me.options;
            if (opts.display && opts.pointLabels.display) fitWithPointLabels(me);
            else me.setCenterPoint(0, 0, 0, 0);
        },
        /**
	 * Set radius reductions and determine new radius and center point
	 * @private
	 */ setReductions: function(largestPossibleRadius, furthestLimits, furthestAngles) {
            var me = this;
            var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
            var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
            var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
            var radiusReductionBottom = -Math.max(furthestLimits.b - (me.height - me.paddingTop), 0) / Math.cos(furthestAngles.b);
            radiusReductionLeft = numberOrZero(radiusReductionLeft);
            radiusReductionRight = numberOrZero(radiusReductionRight);
            radiusReductionTop = numberOrZero(radiusReductionTop);
            radiusReductionBottom = numberOrZero(radiusReductionBottom);
            me.drawingArea = Math.min(Math.floor(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2), Math.floor(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
            me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
        },
        setCenterPoint: function(leftMovement, rightMovement, topMovement, bottomMovement) {
            var me = this;
            var maxRight = me.width - rightMovement - me.drawingArea;
            var maxLeft = leftMovement + me.drawingArea;
            var maxTop = topMovement + me.drawingArea;
            var maxBottom = me.height - me.paddingTop - bottomMovement - me.drawingArea;
            me.xCenter = Math.floor((maxLeft + maxRight) / 2 + me.left);
            me.yCenter = Math.floor((maxTop + maxBottom) / 2 + me.top + me.paddingTop);
        },
        getIndexAngle: function(index) {
            var chart = this.chart;
            var angleMultiplier = 360 / chart.data.labels.length;
            var options = chart.options || {};
            var startAngle = options.startAngle || 0;
            // Start from the top instead of right, so remove a quarter of the circle
            var angle = (index * angleMultiplier + startAngle) % 360;
            return (angle < 0 ? angle + 360 : angle) * Math.PI * 2 / 360;
        },
        getDistanceFromCenterForValue: function(value) {
            var me = this;
            if (helpers$1.isNullOrUndef(value)) return NaN;
            // Take into account half font size + the yPadding of the top value
            var scalingFactor = me.drawingArea / (me.max - me.min);
            if (me.options.ticks.reverse) return (me.max - value) * scalingFactor;
            return (value - me.min) * scalingFactor;
        },
        getPointPosition: function(index, distanceFromCenter) {
            var me = this;
            var thisAngle = me.getIndexAngle(index) - Math.PI / 2;
            return {
                x: Math.cos(thisAngle) * distanceFromCenter + me.xCenter,
                y: Math.sin(thisAngle) * distanceFromCenter + me.yCenter
            };
        },
        getPointPositionForValue: function(index, value) {
            return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
        },
        getBasePosition: function(index) {
            var me = this;
            var min = me.min;
            var max = me.max;
            return me.getPointPositionForValue(index || 0, me.beginAtZero ? 0 : min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0);
        },
        /**
	 * @private
	 */ _drawGrid: function() {
            var me = this;
            var ctx = me.ctx;
            var opts = me.options;
            var gridLineOpts = opts.gridLines;
            var angleLineOpts = opts.angleLines;
            var lineWidth = valueOrDefault$c(angleLineOpts.lineWidth, gridLineOpts.lineWidth);
            var lineColor = valueOrDefault$c(angleLineOpts.color, gridLineOpts.color);
            var i, offset, position;
            if (opts.pointLabels.display) drawPointLabels(me);
            if (gridLineOpts.display) helpers$1.each(me.ticks, function(label, index) {
                if (index !== 0) {
                    offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
                    drawRadiusLine(me, gridLineOpts, offset, index);
                }
            });
            if (angleLineOpts.display && lineWidth && lineColor) {
                ctx.save();
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = lineColor;
                if (ctx.setLineDash) {
                    ctx.setLineDash(resolve$4([
                        angleLineOpts.borderDash,
                        gridLineOpts.borderDash,
                        []
                    ]));
                    ctx.lineDashOffset = resolve$4([
                        angleLineOpts.borderDashOffset,
                        gridLineOpts.borderDashOffset,
                        0.0
                    ]);
                }
                for(i = me.chart.data.labels.length - 1; i >= 0; i--){
                    offset = me.getDistanceFromCenterForValue(opts.ticks.reverse ? me.min : me.max);
                    position = me.getPointPosition(i, offset);
                    ctx.beginPath();
                    ctx.moveTo(me.xCenter, me.yCenter);
                    ctx.lineTo(position.x, position.y);
                    ctx.stroke();
                }
                ctx.restore();
            }
        },
        /**
	 * @private
	 */ _drawLabels: function() {
            var me = this;
            var ctx = me.ctx;
            var opts = me.options;
            var tickOpts = opts.ticks;
            if (!tickOpts.display) return;
            var startAngle = me.getIndexAngle(0);
            var tickFont = helpers$1.options._parseFont(tickOpts);
            var tickFontColor = valueOrDefault$c(tickOpts.fontColor, core_defaults.global.defaultFontColor);
            var offset, width;
            ctx.save();
            ctx.font = tickFont.string;
            ctx.translate(me.xCenter, me.yCenter);
            ctx.rotate(startAngle);
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            helpers$1.each(me.ticks, function(label, index) {
                if (index === 0 && !tickOpts.reverse) return;
                offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
                if (tickOpts.showLabelBackdrop) {
                    width = ctx.measureText(label).width;
                    ctx.fillStyle = tickOpts.backdropColor;
                    ctx.fillRect(-width / 2 - tickOpts.backdropPaddingX, -offset - tickFont.size / 2 - tickOpts.backdropPaddingY, width + tickOpts.backdropPaddingX * 2, tickFont.size + tickOpts.backdropPaddingY * 2);
                }
                ctx.fillStyle = tickFontColor;
                ctx.fillText(label, 0, -offset);
            });
            ctx.restore();
        },
        /**
	 * @private
	 */ _drawTitle: helpers$1.noop
    });
    // INTERNAL: static default options, registered in src/index.js
    var _defaults$3 = defaultConfig$3;
    scale_radialLinear._defaults = _defaults$3;
    var deprecated$1 = helpers$1._deprecated;
    var resolve$5 = helpers$1.options.resolve;
    var valueOrDefault$d = helpers$1.valueOrDefault;
    // Integer constants are from the ES6 spec.
    var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
    var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;
    var INTERVALS = {
        millisecond: {
            common: true,
            size: 1,
            steps: 1000
        },
        second: {
            common: true,
            size: 1000,
            steps: 60
        },
        minute: {
            common: true,
            size: 60000,
            steps: 60
        },
        hour: {
            common: true,
            size: 3600000,
            steps: 24
        },
        day: {
            common: true,
            size: 86400000,
            steps: 30
        },
        week: {
            common: false,
            size: 604800000,
            steps: 4
        },
        month: {
            common: true,
            size: 2.628e9,
            steps: 12
        },
        quarter: {
            common: false,
            size: 7.884e9,
            steps: 4
        },
        year: {
            common: true,
            size: 3.154e10
        }
    };
    var UNITS = Object.keys(INTERVALS);
    function sorter(a, b) {
        return a - b;
    }
    function arrayUnique(items) {
        var hash = {};
        var out = [];
        var i, ilen, item;
        for(i = 0, ilen = items.length; i < ilen; ++i){
            item = items[i];
            if (!hash[item]) {
                hash[item] = true;
                out.push(item);
            }
        }
        return out;
    }
    function getMin(options) {
        return helpers$1.valueOrDefault(options.time.min, options.ticks.min);
    }
    function getMax(options) {
        return helpers$1.valueOrDefault(options.time.max, options.ticks.max);
    }
    /**
 * Returns an array of {time, pos} objects used to interpolate a specific `time` or position
 * (`pos`) on the scale, by searching entries before and after the requested value. `pos` is
 * a decimal between 0 and 1: 0 being the start of the scale (left or top) and 1 the other
 * extremity (left + width or top + height). Note that it would be more optimized to directly
 * store pre-computed pixels, but the scale dimensions are not guaranteed at the time we need
 * to create the lookup table. The table ALWAYS contains at least two items: min and max.
 *
 * @param {number[]} timestamps - timestamps sorted from lowest to highest.
 * @param {string} distribution - If 'linear', timestamps will be spread linearly along the min
 * and max range, so basically, the table will contains only two items: {min, 0} and {max, 1}.
 * If 'series', timestamps will be positioned at the same distance from each other. In this
 * case, only timestamps that break the time linearity are registered, meaning that in the
 * best case, all timestamps are linear, the table contains only min and max.
 */ function buildLookupTable(timestamps, min, max, distribution) {
        if (distribution === "linear" || !timestamps.length) return [
            {
                time: min,
                pos: 0
            },
            {
                time: max,
                pos: 1
            }
        ];
        var table = [];
        var items = [
            min
        ];
        var i, ilen, prev, curr, next;
        for(i = 0, ilen = timestamps.length; i < ilen; ++i){
            curr = timestamps[i];
            if (curr > min && curr < max) items.push(curr);
        }
        items.push(max);
        for(i = 0, ilen = items.length; i < ilen; ++i){
            next = items[i + 1];
            prev = items[i - 1];
            curr = items[i];
            // only add points that breaks the scale linearity
            if (prev === undefined || next === undefined || Math.round((next + prev) / 2) !== curr) table.push({
                time: curr,
                pos: i / (ilen - 1)
            });
        }
        return table;
    }
    // @see adapted from https://www.anujgakhar.com/2014/03/01/binary-search-in-javascript/
    function lookup(table, key, value) {
        var lo = 0;
        var hi = table.length - 1;
        var mid, i0, i1;
        while(lo >= 0 && lo <= hi){
            mid = lo + hi >> 1;
            i0 = table[mid - 1] || null;
            i1 = table[mid];
            if (!i0) // given value is outside table (before first item)
            return {
                lo: null,
                hi: i1
            };
            else if (i1[key] < value) lo = mid + 1;
            else if (i0[key] > value) hi = mid - 1;
            else return {
                lo: i0,
                hi: i1
            };
        }
        // given value is outside table (after last item)
        return {
            lo: i1,
            hi: null
        };
    }
    /**
 * Linearly interpolates the given source `value` using the table items `skey` values and
 * returns the associated `tkey` value. For example, interpolate(table, 'time', 42, 'pos')
 * returns the position for a timestamp equal to 42. If value is out of bounds, values at
 * index [0, 1] or [n - 1, n] are used for the interpolation.
 */ function interpolate$1(table, skey, sval, tkey) {
        var range = lookup(table, skey, sval);
        // Note: the lookup table ALWAYS contains at least 2 items (min and max)
        var prev = !range.lo ? table[0] : !range.hi ? table[table.length - 2] : range.lo;
        var next = !range.lo ? table[1] : !range.hi ? table[table.length - 1] : range.hi;
        var span = next[skey] - prev[skey];
        var ratio = span ? (sval - prev[skey]) / span : 0;
        var offset = (next[tkey] - prev[tkey]) * ratio;
        return prev[tkey] + offset;
    }
    function toTimestamp(scale, input) {
        var adapter = scale._adapter;
        var options = scale.options.time;
        var parser = options.parser;
        var format = parser || options.format;
        var value = input;
        if (typeof parser === "function") value = parser(value);
        // Only parse if its not a timestamp already
        if (!helpers$1.isFinite(value)) value = typeof format === "string" ? adapter.parse(value, format) : adapter.parse(value);
        if (value !== null) return +value;
        // Labels are in an incompatible format and no `parser` has been provided.
        // The user might still use the deprecated `format` option for parsing.
        if (!parser && typeof format === "function") {
            value = format(input);
            // `format` could return something else than a timestamp, if so, parse it
            if (!helpers$1.isFinite(value)) value = adapter.parse(value);
        }
        return value;
    }
    function parse(scale, input) {
        if (helpers$1.isNullOrUndef(input)) return null;
        var options = scale.options.time;
        var value = toTimestamp(scale, scale.getRightValue(input));
        if (value === null) return value;
        if (options.round) value = +scale._adapter.startOf(value, options.round);
        return value;
    }
    /**
 * Figures out what unit results in an appropriate number of auto-generated ticks
 */ function determineUnitForAutoTicks(minUnit, min, max, capacity) {
        var ilen = UNITS.length;
        var i, interval, factor;
        for(i = UNITS.indexOf(minUnit); i < ilen - 1; ++i){
            interval = INTERVALS[UNITS[i]];
            factor = interval.steps ? interval.steps : MAX_INTEGER;
            if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) return UNITS[i];
        }
        return UNITS[ilen - 1];
    }
    /**
 * Figures out what unit to format a set of ticks with
 */ function determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
        var i, unit;
        for(i = UNITS.length - 1; i >= UNITS.indexOf(minUnit); i--){
            unit = UNITS[i];
            if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) return unit;
        }
        return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
    }
    function determineMajorUnit(unit) {
        for(var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i){
            if (INTERVALS[UNITS[i]].common) return UNITS[i];
        }
    }
    /**
 * Generates a maximum of `capacity` timestamps between min and max, rounded to the
 * `minor` unit using the given scale time `options`.
 * Important: this method can return ticks outside the min and max range, it's the
 * responsibility of the calling code to clamp values if needed.
 */ function generate(scale, min, max, capacity) {
        var adapter = scale._adapter;
        var options = scale.options;
        var timeOpts = options.time;
        var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, capacity);
        var stepSize = resolve$5([
            timeOpts.stepSize,
            timeOpts.unitStepSize,
            1
        ]);
        var weekday = minor === "week" ? timeOpts.isoWeekday : false;
        var first = min;
        var ticks = [];
        var time;
        // For 'week' unit, handle the first day of week option
        if (weekday) first = +adapter.startOf(first, "isoWeek", weekday);
        // Align first ticks on unit
        first = +adapter.startOf(first, weekday ? "day" : minor);
        // Prevent browser from freezing in case user options request millions of milliseconds
        if (adapter.diff(max, min, minor) > 100000 * stepSize) throw min + " and " + max + " are too far apart with stepSize of " + stepSize + " " + minor;
        for(time = first; time < max; time = +adapter.add(time, stepSize, minor))ticks.push(time);
        if (time === max || options.bounds === "ticks") ticks.push(time);
        return ticks;
    }
    /**
 * Returns the start and end offsets from edges in the form of {start, end}
 * where each value is a relative width to the scale and ranges between 0 and 1.
 * They add extra margins on the both sides by scaling down the original scale.
 * Offsets are added when the `offset` option is true.
 */ function computeOffsets(table, ticks, min, max, options) {
        var start = 0;
        var end = 0;
        var first, last;
        if (options.offset && ticks.length) {
            first = interpolate$1(table, "time", ticks[0], "pos");
            if (ticks.length === 1) start = 1 - first;
            else start = (interpolate$1(table, "time", ticks[1], "pos") - first) / 2;
            last = interpolate$1(table, "time", ticks[ticks.length - 1], "pos");
            if (ticks.length === 1) end = last;
            else end = (last - interpolate$1(table, "time", ticks[ticks.length - 2], "pos")) / 2;
        }
        return {
            start: start,
            end: end,
            factor: 1 / (start + 1 + end)
        };
    }
    function setMajorTicks(scale, ticks, map, majorUnit) {
        var adapter = scale._adapter;
        var first = +adapter.startOf(ticks[0].value, majorUnit);
        var last = ticks[ticks.length - 1].value;
        var major, index;
        for(major = first; major <= last; major = +adapter.add(major, 1, majorUnit)){
            index = map[major];
            if (index >= 0) ticks[index].major = true;
        }
        return ticks;
    }
    function ticksFromTimestamps(scale, values, majorUnit) {
        var ticks = [];
        var map = {};
        var ilen = values.length;
        var i, value;
        for(i = 0; i < ilen; ++i){
            value = values[i];
            map[value] = i;
            ticks.push({
                value: value,
                major: false
            });
        }
        // We set the major ticks separately from the above loop because calling startOf for every tick
        // is expensive when there is a large number of ticks
        return ilen === 0 || !majorUnit ? ticks : setMajorTicks(scale, ticks, map, majorUnit);
    }
    var defaultConfig$4 = {
        position: "bottom",
        /**
	 * Data distribution along the scale:
	 * - 'linear': data are spread according to their time (distances can vary),
	 * - 'series': data are spread at the same distance from each other.
	 * @see https://github.com/chartjs/Chart.js/pull/4507
	 * @since 2.7.0
	 */ distribution: "linear",
        /**
	 * Scale boundary strategy (bypassed by min/max time options)
	 * - `data`: make sure data are fully visible, ticks outside are removed
	 * - `ticks`: make sure ticks are fully visible, data outside are truncated
	 * @see https://github.com/chartjs/Chart.js/pull/4556
	 * @since 2.7.0
	 */ bounds: "data",
        adapters: {},
        time: {
            parser: false,
            unit: false,
            round: false,
            displayFormat: false,
            isoWeekday: false,
            minUnit: "millisecond",
            displayFormats: {}
        },
        ticks: {
            autoSkip: false,
            /**
		 * Ticks generation input values:
		 * - 'auto': generates "optimal" ticks based on scale size and time options.
		 * - 'data': generates ticks from data (including labels from data {t|x|y} objects).
		 * - 'labels': generates ticks from user given `data.labels` values ONLY.
		 * @see https://github.com/chartjs/Chart.js/pull/4507
		 * @since 2.7.0
		 */ source: "auto",
            major: {
                enabled: false
            }
        }
    };
    var scale_time = core_scale.extend({
        initialize: function() {
            this.mergeTicksOptions();
            core_scale.prototype.initialize.call(this);
        },
        update: function() {
            var me = this;
            var options = me.options;
            var time = options.time || (options.time = {});
            var adapter = me._adapter = new core_adapters._date(options.adapters.date);
            // DEPRECATIONS: output a message only one time per update
            deprecated$1("time scale", time.format, "time.format", "time.parser");
            deprecated$1("time scale", time.min, "time.min", "ticks.min");
            deprecated$1("time scale", time.max, "time.max", "ticks.max");
            // Backward compatibility: before introducing adapter, `displayFormats` was
            // supposed to contain *all* unit/string pairs but this can't be resolved
            // when loading the scale (adapters are loaded afterward), so let's populate
            // missing formats on update
            helpers$1.mergeIf(time.displayFormats, adapter.formats());
            return core_scale.prototype.update.apply(me, arguments);
        },
        /**
	 * Allows data to be referenced via 't' attribute
	 */ getRightValue: function(rawValue) {
            if (rawValue && rawValue.t !== undefined) rawValue = rawValue.t;
            return core_scale.prototype.getRightValue.call(this, rawValue);
        },
        determineDataLimits: function() {
            var me = this;
            var chart = me.chart;
            var adapter = me._adapter;
            var options = me.options;
            var unit = options.time.unit || "day";
            var min = MAX_INTEGER;
            var max = MIN_INTEGER;
            var timestamps = [];
            var datasets = [];
            var labels = [];
            var i, j, ilen, jlen, data, timestamp, labelsAdded;
            var dataLabels = me._getLabels();
            for(i = 0, ilen = dataLabels.length; i < ilen; ++i)labels.push(parse(me, dataLabels[i]));
            for(i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                data = chart.data.datasets[i].data;
                // Let's consider that all data have the same format.
                if (helpers$1.isObject(data[0])) {
                    datasets[i] = [];
                    for(j = 0, jlen = data.length; j < jlen; ++j){
                        timestamp = parse(me, data[j]);
                        timestamps.push(timestamp);
                        datasets[i][j] = timestamp;
                    }
                } else {
                    datasets[i] = labels.slice(0);
                    if (!labelsAdded) {
                        timestamps = timestamps.concat(labels);
                        labelsAdded = true;
                    }
                }
            } else datasets[i] = [];
            if (labels.length) {
                min = Math.min(min, labels[0]);
                max = Math.max(max, labels[labels.length - 1]);
            }
            if (timestamps.length) {
                timestamps = ilen > 1 ? arrayUnique(timestamps).sort(sorter) : timestamps.sort(sorter);
                min = Math.min(min, timestamps[0]);
                max = Math.max(max, timestamps[timestamps.length - 1]);
            }
            min = parse(me, getMin(options)) || min;
            max = parse(me, getMax(options)) || max;
            // In case there is no valid min/max, set limits based on unit time option
            min = min === MAX_INTEGER ? +adapter.startOf(Date.now(), unit) : min;
            max = max === MIN_INTEGER ? +adapter.endOf(Date.now(), unit) + 1 : max;
            // Make sure that max is strictly higher than min (required by the lookup table)
            me.min = Math.min(min, max);
            me.max = Math.max(min + 1, max);
            // PRIVATE
            me._table = [];
            me._timestamps = {
                data: timestamps,
                datasets: datasets,
                labels: labels
            };
        },
        buildTicks: function() {
            var me = this;
            var min = me.min;
            var max = me.max;
            var options = me.options;
            var tickOpts = options.ticks;
            var timeOpts = options.time;
            var timestamps = me._timestamps;
            var ticks = [];
            var capacity = me.getLabelCapacity(min);
            var source = tickOpts.source;
            var distribution = options.distribution;
            var i, ilen, timestamp;
            if (source === "data" || source === "auto" && distribution === "series") timestamps = timestamps.data;
            else if (source === "labels") timestamps = timestamps.labels;
            else timestamps = generate(me, min, max, capacity);
            if (options.bounds === "ticks" && timestamps.length) {
                min = timestamps[0];
                max = timestamps[timestamps.length - 1];
            }
            // Enforce limits with user min/max options
            min = parse(me, getMin(options)) || min;
            max = parse(me, getMax(options)) || max;
            // Remove ticks outside the min/max range
            for(i = 0, ilen = timestamps.length; i < ilen; ++i){
                timestamp = timestamps[i];
                if (timestamp >= min && timestamp <= max) ticks.push(timestamp);
            }
            me.min = min;
            me.max = max;
            // PRIVATE
            // determineUnitForFormatting relies on the number of ticks so we don't use it when
            // autoSkip is enabled because we don't yet know what the final number of ticks will be
            me._unit = timeOpts.unit || (tickOpts.autoSkip ? determineUnitForAutoTicks(timeOpts.minUnit, me.min, me.max, capacity) : determineUnitForFormatting(me, ticks.length, timeOpts.minUnit, me.min, me.max));
            me._majorUnit = !tickOpts.major.enabled || me._unit === "year" ? undefined : determineMajorUnit(me._unit);
            me._table = buildLookupTable(me._timestamps.data, min, max, distribution);
            me._offsets = computeOffsets(me._table, ticks, min, max, options);
            if (tickOpts.reverse) ticks.reverse();
            return ticksFromTimestamps(me, ticks, me._majorUnit);
        },
        getLabelForIndex: function(index, datasetIndex) {
            var me = this;
            var adapter = me._adapter;
            var data = me.chart.data;
            var timeOpts = me.options.time;
            var label = data.labels && index < data.labels.length ? data.labels[index] : "";
            var value = data.datasets[datasetIndex].data[index];
            if (helpers$1.isObject(value)) label = me.getRightValue(value);
            if (timeOpts.tooltipFormat) return adapter.format(toTimestamp(me, label), timeOpts.tooltipFormat);
            if (typeof label === "string") return label;
            return adapter.format(toTimestamp(me, label), timeOpts.displayFormats.datetime);
        },
        /**
	 * Function to format an individual tick mark
	 * @private
	 */ tickFormatFunction: function(time, index, ticks, format) {
            var me = this;
            var adapter = me._adapter;
            var options = me.options;
            var formats = options.time.displayFormats;
            var minorFormat = formats[me._unit];
            var majorUnit = me._majorUnit;
            var majorFormat = formats[majorUnit];
            var tick = ticks[index];
            var tickOpts = options.ticks;
            var major = majorUnit && majorFormat && tick && tick.major;
            var label = adapter.format(time, format ? format : major ? majorFormat : minorFormat);
            var nestedTickOpts = major ? tickOpts.major : tickOpts.minor;
            var formatter = resolve$5([
                nestedTickOpts.callback,
                nestedTickOpts.userCallback,
                tickOpts.callback,
                tickOpts.userCallback
            ]);
            return formatter ? formatter(label, index, ticks) : label;
        },
        convertTicksToLabels: function(ticks) {
            var labels = [];
            var i, ilen;
            for(i = 0, ilen = ticks.length; i < ilen; ++i)labels.push(this.tickFormatFunction(ticks[i].value, i, ticks));
            return labels;
        },
        /**
	 * @private
	 */ getPixelForOffset: function(time) {
            var me = this;
            var offsets = me._offsets;
            var pos = interpolate$1(me._table, "time", time, "pos");
            return me.getPixelForDecimal((offsets.start + pos) * offsets.factor);
        },
        getPixelForValue: function(value, index, datasetIndex) {
            var me = this;
            var time = null;
            if (index !== undefined && datasetIndex !== undefined) time = me._timestamps.datasets[datasetIndex][index];
            if (time === null) time = parse(me, value);
            if (time !== null) return me.getPixelForOffset(time);
        },
        getPixelForTick: function(index) {
            var ticks = this.getTicks();
            return index >= 0 && index < ticks.length ? this.getPixelForOffset(ticks[index].value) : null;
        },
        getValueForPixel: function(pixel) {
            var me = this;
            var offsets = me._offsets;
            var pos = me.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
            var time = interpolate$1(me._table, "pos", pos, "time");
            // DEPRECATION, we should return time directly
            return me._adapter._create(time);
        },
        /**
	 * @private
	 */ _getLabelSize: function(label) {
            var me = this;
            var ticksOpts = me.options.ticks;
            var tickLabelWidth = me.ctx.measureText(label).width;
            var angle = helpers$1.toRadians(me.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
            var cosRotation = Math.cos(angle);
            var sinRotation = Math.sin(angle);
            var tickFontSize = valueOrDefault$d(ticksOpts.fontSize, core_defaults.global.defaultFontSize);
            return {
                w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
                h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
            };
        },
        /**
	 * Crude approximation of what the label width might be
	 * @private
	 */ getLabelWidth: function(label) {
            return this._getLabelSize(label).w;
        },
        /**
	 * @private
	 */ getLabelCapacity: function(exampleTime) {
            var me = this;
            var timeOpts = me.options.time;
            var displayFormats = timeOpts.displayFormats;
            // pick the longest format (milliseconds) for guestimation
            var format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
            var exampleLabel = me.tickFormatFunction(exampleTime, 0, ticksFromTimestamps(me, [
                exampleTime
            ], me._majorUnit), format);
            var size = me._getLabelSize(exampleLabel);
            var capacity = Math.floor(me.isHorizontal() ? me.width / size.w : me.height / size.h);
            if (me.options.offset) capacity--;
            return capacity > 0 ? capacity : 1;
        }
    });
    // INTERNAL: static default options, registered in src/index.js
    var _defaults$4 = defaultConfig$4;
    scale_time._defaults = _defaults$4;
    var scales = {
        category: scale_category,
        linear: scale_linear,
        logarithmic: scale_logarithmic,
        radialLinear: scale_radialLinear,
        time: scale_time
    };
    var FORMATS = {
        datetime: "MMM D, YYYY, h:mm:ss a",
        millisecond: "h:mm:ss.SSS a",
        second: "h:mm:ss a",
        minute: "h:mm a",
        hour: "hA",
        day: "MMM D",
        week: "ll",
        month: "MMM YYYY",
        quarter: "[Q]Q - YYYY",
        year: "YYYY"
    };
    core_adapters._date.override(typeof moment === "function" ? {
        _id: "moment",
        formats: function() {
            return FORMATS;
        },
        parse: function(value, format) {
            if (typeof value === "string" && typeof format === "string") value = moment(value, format);
            else if (!(value instanceof moment)) value = moment(value);
            return value.isValid() ? value.valueOf() : null;
        },
        format: function(time, format) {
            return moment(time).format(format);
        },
        add: function(time, amount, unit) {
            return moment(time).add(amount, unit).valueOf();
        },
        diff: function(max, min, unit) {
            return moment(max).diff(moment(min), unit);
        },
        startOf: function(time, unit, weekday) {
            time = moment(time);
            if (unit === "isoWeek") return time.isoWeekday(weekday).valueOf();
            return time.startOf(unit).valueOf();
        },
        endOf: function(time, unit) {
            return moment(time).endOf(unit).valueOf();
        },
        // DEPRECATIONS
        /**
	 * Provided for backward compatibility with scale.getValueForPixel().
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */ _create: function(time) {
            return moment(time);
        }
    } : {});
    core_defaults._set("global", {
        plugins: {
            filler: {
                propagate: true
            }
        }
    });
    var mappers = {
        dataset: function(source) {
            var index = source.fill;
            var chart = source.chart;
            var meta = chart.getDatasetMeta(index);
            var visible = meta && chart.isDatasetVisible(index);
            var points = visible && meta.dataset._children || [];
            var length = points.length || 0;
            return !length ? null : function(point, i) {
                return i < length && points[i]._view || null;
            };
        },
        boundary: function(source) {
            var boundary = source.boundary;
            var x = boundary ? boundary.x : null;
            var y = boundary ? boundary.y : null;
            if (helpers$1.isArray(boundary)) return function(point, i) {
                return boundary[i];
            };
            return function(point) {
                return {
                    x: x === null ? point.x : x,
                    y: y === null ? point.y : y
                };
            };
        }
    };
    // @todo if (fill[0] === '#')
    function decodeFill(el, index, count) {
        var model = el._model || {};
        var fill = model.fill;
        var target;
        if (fill === undefined) fill = !!model.backgroundColor;
        if (fill === false || fill === null) return false;
        if (fill === true) return "origin";
        target = parseFloat(fill, 10);
        if (isFinite(target) && Math.floor(target) === target) {
            if (fill[0] === "-" || fill[0] === "+") target = index + target;
            if (target === index || target < 0 || target >= count) return false;
            return target;
        }
        switch(fill){
            // compatibility
            case "bottom":
                return "start";
            case "top":
                return "end";
            case "zero":
                return "origin";
            // supported boundaries
            case "origin":
            case "start":
            case "end":
                return fill;
            // invalid fill values
            default:
                return false;
        }
    }
    function computeLinearBoundary(source) {
        var model = source.el._model || {};
        var scale = source.el._scale || {};
        var fill = source.fill;
        var target = null;
        var horizontal;
        if (isFinite(fill)) return null;
        // Backward compatibility: until v3, we still need to support boundary values set on
        // the model (scaleTop, scaleBottom and scaleZero) because some external plugins and
        // controllers might still use it (e.g. the Smith chart).
        if (fill === "start") target = model.scaleBottom === undefined ? scale.bottom : model.scaleBottom;
        else if (fill === "end") target = model.scaleTop === undefined ? scale.top : model.scaleTop;
        else if (model.scaleZero !== undefined) target = model.scaleZero;
        else if (scale.getBasePixel) target = scale.getBasePixel();
        if (target !== undefined && target !== null) {
            if (target.x !== undefined && target.y !== undefined) return target;
            if (helpers$1.isFinite(target)) {
                horizontal = scale.isHorizontal();
                return {
                    x: horizontal ? target : null,
                    y: horizontal ? null : target
                };
            }
        }
        return null;
    }
    function computeCircularBoundary(source) {
        var scale = source.el._scale;
        var options = scale.options;
        var length = scale.chart.data.labels.length;
        var fill = source.fill;
        var target = [];
        var start, end, center, i, point;
        if (!length) return null;
        start = options.ticks.reverse ? scale.max : scale.min;
        end = options.ticks.reverse ? scale.min : scale.max;
        center = scale.getPointPositionForValue(0, start);
        for(i = 0; i < length; ++i){
            point = fill === "start" || fill === "end" ? scale.getPointPositionForValue(i, fill === "start" ? start : end) : scale.getBasePosition(i);
            if (options.gridLines.circular) {
                point.cx = center.x;
                point.cy = center.y;
                point.angle = scale.getIndexAngle(i) - Math.PI / 2;
            }
            target.push(point);
        }
        return target;
    }
    function computeBoundary(source) {
        var scale = source.el._scale || {};
        if (scale.getPointPositionForValue) return computeCircularBoundary(source);
        return computeLinearBoundary(source);
    }
    function resolveTarget(sources, index, propagate) {
        var source = sources[index];
        var fill = source.fill;
        var visited = [
            index
        ];
        var target;
        if (!propagate) return fill;
        while(fill !== false && visited.indexOf(fill) === -1){
            if (!isFinite(fill)) return fill;
            target = sources[fill];
            if (!target) return false;
            if (target.visible) return fill;
            visited.push(fill);
            fill = target.fill;
        }
        return false;
    }
    function createMapper(source) {
        var fill = source.fill;
        var type = "dataset";
        if (fill === false) return null;
        if (!isFinite(fill)) type = "boundary";
        return mappers[type](source);
    }
    function isDrawable(point) {
        return point && !point.skip;
    }
    function drawArea(ctx, curve0, curve1, len0, len1) {
        var i, cx, cy, r;
        if (!len0 || !len1) return;
        // building first area curve (normal)
        ctx.moveTo(curve0[0].x, curve0[0].y);
        for(i = 1; i < len0; ++i)helpers$1.canvas.lineTo(ctx, curve0[i - 1], curve0[i]);
        if (curve1[0].angle !== undefined) {
            cx = curve1[0].cx;
            cy = curve1[0].cy;
            r = Math.sqrt(Math.pow(curve1[0].x - cx, 2) + Math.pow(curve1[0].y - cy, 2));
            for(i = len1 - 1; i > 0; --i)ctx.arc(cx, cy, r, curve1[i].angle, curve1[i - 1].angle, true);
            return;
        }
        // joining the two area curves
        ctx.lineTo(curve1[len1 - 1].x, curve1[len1 - 1].y);
        // building opposite area curve (reverse)
        for(i = len1 - 1; i > 0; --i)helpers$1.canvas.lineTo(ctx, curve1[i], curve1[i - 1], true);
    }
    function doFill(ctx, points, mapper, view, color, loop) {
        var count = points.length;
        var span = view.spanGaps;
        var curve0 = [];
        var curve1 = [];
        var len0 = 0;
        var len1 = 0;
        var i, ilen, index, p0, p1, d0, d1, loopOffset;
        ctx.beginPath();
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i % count;
            p0 = points[index]._view;
            p1 = mapper(p0, index, view);
            d0 = isDrawable(p0);
            d1 = isDrawable(p1);
            if (loop && loopOffset === undefined && d0) {
                loopOffset = i + 1;
                ilen = count + loopOffset;
            }
            if (d0 && d1) {
                len0 = curve0.push(p0);
                len1 = curve1.push(p1);
            } else if (len0 && len1) {
                if (!span) {
                    drawArea(ctx, curve0, curve1, len0, len1);
                    len0 = len1 = 0;
                    curve0 = [];
                    curve1 = [];
                } else {
                    if (d0) curve0.push(p0);
                    if (d1) curve1.push(p1);
                }
            }
        }
        drawArea(ctx, curve0, curve1, len0, len1);
        ctx.closePath();
        ctx.fillStyle = color;
        ctx.fill();
    }
    var plugin_filler = {
        id: "filler",
        afterDatasetsUpdate: function(chart, options) {
            var count = (chart.data.datasets || []).length;
            var propagate = options.propagate;
            var sources = [];
            var meta, i, el, source;
            for(i = 0; i < count; ++i){
                meta = chart.getDatasetMeta(i);
                el = meta.dataset;
                source = null;
                if (el && el._model && el instanceof elements.Line) source = {
                    visible: chart.isDatasetVisible(i),
                    fill: decodeFill(el, i, count),
                    chart: chart,
                    el: el
                };
                meta.$filler = source;
                sources.push(source);
            }
            for(i = 0; i < count; ++i){
                source = sources[i];
                if (!source) continue;
                source.fill = resolveTarget(sources, i, propagate);
                source.boundary = computeBoundary(source);
                source.mapper = createMapper(source);
            }
        },
        beforeDatasetsDraw: function(chart) {
            var metasets = chart._getSortedVisibleDatasetMetas();
            var ctx = chart.ctx;
            var meta, i, el, view, points, mapper, color;
            for(i = metasets.length - 1; i >= 0; --i){
                meta = metasets[i].$filler;
                if (!meta || !meta.visible) continue;
                el = meta.el;
                view = el._view;
                points = el._children || [];
                mapper = meta.mapper;
                color = view.backgroundColor || core_defaults.global.defaultColor;
                if (mapper && color && points.length) {
                    helpers$1.canvas.clipArea(ctx, chart.chartArea);
                    doFill(ctx, points, mapper, view, color, el._loop);
                    helpers$1.canvas.unclipArea(ctx);
                }
            }
        }
    };
    var getRtlHelper$1 = helpers$1.rtl.getRtlAdapter;
    var noop$1 = helpers$1.noop;
    var valueOrDefault$e = helpers$1.valueOrDefault;
    core_defaults._set("global", {
        legend: {
            display: true,
            position: "top",
            align: "center",
            fullWidth: true,
            reverse: false,
            weight: 1000,
            // a callback that will handle
            onClick: function(e, legendItem) {
                var index = legendItem.datasetIndex;
                var ci = this.chart;
                var meta = ci.getDatasetMeta(index);
                // See controller.isDatasetVisible comment
                meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;
                // We hid a dataset ... rerender the chart
                ci.update();
            },
            onHover: null,
            onLeave: null,
            labels: {
                boxWidth: 40,
                padding: 10,
                // Generates labels shown in the legend
                // Valid properties to return:
                // text : text to display
                // fillStyle : fill of coloured box
                // strokeStyle: stroke of coloured box
                // hidden : if this legend item refers to a hidden item
                // lineCap : cap style for line
                // lineDash
                // lineDashOffset :
                // lineJoin :
                // lineWidth :
                generateLabels: function(chart) {
                    var datasets = chart.data.datasets;
                    var options = chart.options.legend || {};
                    var usePointStyle = options.labels && options.labels.usePointStyle;
                    return chart._getSortedDatasetMetas().map(function(meta) {
                        var style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
                        return {
                            text: datasets[meta.index].label,
                            fillStyle: style.backgroundColor,
                            hidden: !chart.isDatasetVisible(meta.index),
                            lineCap: style.borderCapStyle,
                            lineDash: style.borderDash,
                            lineDashOffset: style.borderDashOffset,
                            lineJoin: style.borderJoinStyle,
                            lineWidth: style.borderWidth,
                            strokeStyle: style.borderColor,
                            pointStyle: style.pointStyle,
                            rotation: style.rotation,
                            // Below is extra data used for toggling the datasets
                            datasetIndex: meta.index
                        };
                    }, this);
                }
            }
        },
        legendCallback: function(chart) {
            var list = document.createElement("ul");
            var datasets = chart.data.datasets;
            var i, ilen, listItem, listItemSpan;
            list.setAttribute("class", chart.id + "-legend");
            for(i = 0, ilen = datasets.length; i < ilen; i++){
                listItem = list.appendChild(document.createElement("li"));
                listItemSpan = listItem.appendChild(document.createElement("span"));
                listItemSpan.style.backgroundColor = datasets[i].backgroundColor;
                if (datasets[i].label) listItem.appendChild(document.createTextNode(datasets[i].label));
            }
            return list.outerHTML;
        }
    });
    /**
 * Helper function to get the box width based on the usePointStyle option
 * @param {object} labelopts - the label options on the legend
 * @param {number} fontSize - the label font size
 * @return {number} width of the color box area
 */ function getBoxWidth(labelOpts, fontSize) {
        return labelOpts.usePointStyle && labelOpts.boxWidth > fontSize ? fontSize : labelOpts.boxWidth;
    }
    /**
 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
 */ var Legend = core_element.extend({
        initialize: function(config) {
            var me = this;
            helpers$1.extend(me, config);
            // Contains hit boxes for each dataset (in dataset order)
            me.legendHitBoxes = [];
            /**
 		 * @private
 		 */ me._hoveredItem = null;
            // Are we in doughnut mode which has a different data type
            me.doughnutMode = false;
        },
        // These methods are ordered by lifecycle. Utilities then follow.
        // Any function defined here is inherited by all legend types.
        // Any function can be extended by the legend type
        beforeUpdate: noop$1,
        update: function(maxWidth, maxHeight, margins) {
            var me = this;
            // Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
            me.beforeUpdate();
            // Absorb the master measurements
            me.maxWidth = maxWidth;
            me.maxHeight = maxHeight;
            me.margins = margins;
            // Dimensions
            me.beforeSetDimensions();
            me.setDimensions();
            me.afterSetDimensions();
            // Labels
            me.beforeBuildLabels();
            me.buildLabels();
            me.afterBuildLabels();
            // Fit
            me.beforeFit();
            me.fit();
            me.afterFit();
            //
            me.afterUpdate();
            return me.minSize;
        },
        afterUpdate: noop$1,
        //
        beforeSetDimensions: noop$1,
        setDimensions: function() {
            var me = this;
            // Set the unconstrained dimension before label rotation
            if (me.isHorizontal()) {
                // Reset position before calculating rotation
                me.width = me.maxWidth;
                me.left = 0;
                me.right = me.width;
            } else {
                me.height = me.maxHeight;
                // Reset position before calculating rotation
                me.top = 0;
                me.bottom = me.height;
            }
            // Reset padding
            me.paddingLeft = 0;
            me.paddingTop = 0;
            me.paddingRight = 0;
            me.paddingBottom = 0;
            // Reset minSize
            me.minSize = {
                width: 0,
                height: 0
            };
        },
        afterSetDimensions: noop$1,
        //
        beforeBuildLabels: noop$1,
        buildLabels: function() {
            var me = this;
            var labelOpts = me.options.labels || {};
            var legendItems = helpers$1.callback(labelOpts.generateLabels, [
                me.chart
            ], me) || [];
            if (labelOpts.filter) legendItems = legendItems.filter(function(item) {
                return labelOpts.filter(item, me.chart.data);
            });
            if (me.options.reverse) legendItems.reverse();
            me.legendItems = legendItems;
        },
        afterBuildLabels: noop$1,
        //
        beforeFit: noop$1,
        fit: function() {
            var me = this;
            var opts = me.options;
            var labelOpts = opts.labels;
            var display = opts.display;
            var ctx = me.ctx;
            var labelFont = helpers$1.options._parseFont(labelOpts);
            var fontSize = labelFont.size;
            // Reset hit boxes
            var hitboxes = me.legendHitBoxes = [];
            var minSize = me.minSize;
            var isHorizontal = me.isHorizontal();
            if (isHorizontal) {
                minSize.width = me.maxWidth; // fill all the width
                minSize.height = display ? 10 : 0;
            } else {
                minSize.width = display ? 10 : 0;
                minSize.height = me.maxHeight; // fill all the height
            }
            // Increase sizes here
            if (!display) {
                me.width = minSize.width = me.height = minSize.height = 0;
                return;
            }
            ctx.font = labelFont.string;
            if (isHorizontal) {
                // Labels
                // Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
                var lineWidths = me.lineWidths = [
                    0
                ];
                var totalHeight = 0;
                ctx.textAlign = "left";
                ctx.textBaseline = "middle";
                helpers$1.each(me.legendItems, function(legendItem, i) {
                    var boxWidth = getBoxWidth(labelOpts, fontSize);
                    var width = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
                    if (i === 0 || lineWidths[lineWidths.length - 1] + width + 2 * labelOpts.padding > minSize.width) {
                        totalHeight += fontSize + labelOpts.padding;
                        lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
                    }
                    // Store the hitbox width and height here. Final position will be updated in `draw`
                    hitboxes[i] = {
                        left: 0,
                        top: 0,
                        width: width,
                        height: fontSize
                    };
                    lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
                });
                minSize.height += totalHeight;
            } else {
                var vPadding = labelOpts.padding;
                var columnWidths = me.columnWidths = [];
                var columnHeights = me.columnHeights = [];
                var totalWidth = labelOpts.padding;
                var currentColWidth = 0;
                var currentColHeight = 0;
                helpers$1.each(me.legendItems, function(legendItem, i) {
                    var boxWidth = getBoxWidth(labelOpts, fontSize);
                    var itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
                    // If too tall, go to new column
                    if (i > 0 && currentColHeight + fontSize + 2 * vPadding > minSize.height) {
                        totalWidth += currentColWidth + labelOpts.padding;
                        columnWidths.push(currentColWidth); // previous column width
                        columnHeights.push(currentColHeight);
                        currentColWidth = 0;
                        currentColHeight = 0;
                    }
                    // Get max width
                    currentColWidth = Math.max(currentColWidth, itemWidth);
                    currentColHeight += fontSize + vPadding;
                    // Store the hitbox width and height here. Final position will be updated in `draw`
                    hitboxes[i] = {
                        left: 0,
                        top: 0,
                        width: itemWidth,
                        height: fontSize
                    };
                });
                totalWidth += currentColWidth;
                columnWidths.push(currentColWidth);
                columnHeights.push(currentColHeight);
                minSize.width += totalWidth;
            }
            me.width = minSize.width;
            me.height = minSize.height;
        },
        afterFit: noop$1,
        // Shared Methods
        isHorizontal: function() {
            return this.options.position === "top" || this.options.position === "bottom";
        },
        // Actually draw the legend on the canvas
        draw: function() {
            var me = this;
            var opts = me.options;
            var labelOpts = opts.labels;
            var globalDefaults = core_defaults.global;
            var defaultColor = globalDefaults.defaultColor;
            var lineDefault = globalDefaults.elements.line;
            var legendHeight = me.height;
            var columnHeights = me.columnHeights;
            var legendWidth = me.width;
            var lineWidths = me.lineWidths;
            if (!opts.display) return;
            var rtlHelper = getRtlHelper$1(opts.rtl, me.left, me.minSize.width);
            var ctx = me.ctx;
            var fontColor = valueOrDefault$e(labelOpts.fontColor, globalDefaults.defaultFontColor);
            var labelFont = helpers$1.options._parseFont(labelOpts);
            var fontSize = labelFont.size;
            var cursor;
            // Canvas setup
            ctx.textAlign = rtlHelper.textAlign("left");
            ctx.textBaseline = "middle";
            ctx.lineWidth = 0.5;
            ctx.strokeStyle = fontColor; // for strikethrough effect
            ctx.fillStyle = fontColor; // render in correct colour
            ctx.font = labelFont.string;
            var boxWidth = getBoxWidth(labelOpts, fontSize);
            var hitboxes = me.legendHitBoxes;
            // current position
            var drawLegendBox = function(x, y, legendItem) {
                if (isNaN(boxWidth) || boxWidth <= 0) return;
                // Set the ctx for the box
                ctx.save();
                var lineWidth = valueOrDefault$e(legendItem.lineWidth, lineDefault.borderWidth);
                ctx.fillStyle = valueOrDefault$e(legendItem.fillStyle, defaultColor);
                ctx.lineCap = valueOrDefault$e(legendItem.lineCap, lineDefault.borderCapStyle);
                ctx.lineDashOffset = valueOrDefault$e(legendItem.lineDashOffset, lineDefault.borderDashOffset);
                ctx.lineJoin = valueOrDefault$e(legendItem.lineJoin, lineDefault.borderJoinStyle);
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = valueOrDefault$e(legendItem.strokeStyle, defaultColor);
                if (ctx.setLineDash) // IE 9 and 10 do not support line dash
                ctx.setLineDash(valueOrDefault$e(legendItem.lineDash, lineDefault.borderDash));
                if (labelOpts && labelOpts.usePointStyle) {
                    // Recalculate x and y for drawPoint() because its expecting
                    // x and y to be center of figure (instead of top left)
                    var radius = boxWidth * Math.SQRT2 / 2;
                    var centerX = rtlHelper.xPlus(x, boxWidth / 2);
                    var centerY = y + fontSize / 2;
                    // Draw pointStyle as legend symbol
                    helpers$1.canvas.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY, legendItem.rotation);
                } else {
                    // Draw box as legend symbol
                    ctx.fillRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
                    if (lineWidth !== 0) ctx.strokeRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
                }
                ctx.restore();
            };
            var fillText = function(x, y, legendItem, textWidth) {
                var halfFontSize = fontSize / 2;
                var xLeft = rtlHelper.xPlus(x, boxWidth + halfFontSize);
                var yMiddle = y + halfFontSize;
                ctx.fillText(legendItem.text, xLeft, yMiddle);
                if (legendItem.hidden) {
                    // Strikethrough the text if hidden
                    ctx.beginPath();
                    ctx.lineWidth = 2;
                    ctx.moveTo(xLeft, yMiddle);
                    ctx.lineTo(rtlHelper.xPlus(xLeft, textWidth), yMiddle);
                    ctx.stroke();
                }
            };
            var alignmentOffset = function(dimension, blockSize) {
                switch(opts.align){
                    case "start":
                        return labelOpts.padding;
                    case "end":
                        return dimension - blockSize;
                    default:
                        return (dimension - blockSize + labelOpts.padding) / 2;
                }
            };
            // Horizontal
            var isHorizontal = me.isHorizontal();
            if (isHorizontal) cursor = {
                x: me.left + alignmentOffset(legendWidth, lineWidths[0]),
                y: me.top + labelOpts.padding,
                line: 0
            };
            else cursor = {
                x: me.left + labelOpts.padding,
                y: me.top + alignmentOffset(legendHeight, columnHeights[0]),
                line: 0
            };
            helpers$1.rtl.overrideTextDirection(me.ctx, opts.textDirection);
            var itemHeight = fontSize + labelOpts.padding;
            helpers$1.each(me.legendItems, function(legendItem, i) {
                var textWidth = ctx.measureText(legendItem.text).width;
                var width = boxWidth + fontSize / 2 + textWidth;
                var x = cursor.x;
                var y = cursor.y;
                rtlHelper.setWidth(me.minSize.width);
                // Use (me.left + me.minSize.width) and (me.top + me.minSize.height)
                // instead of me.right and me.bottom because me.width and me.height
                // may have been changed since me.minSize was calculated
                if (isHorizontal) {
                    if (i > 0 && x + width + labelOpts.padding > me.left + me.minSize.width) {
                        y = cursor.y += itemHeight;
                        cursor.line++;
                        x = cursor.x = me.left + alignmentOffset(legendWidth, lineWidths[cursor.line]);
                    }
                } else if (i > 0 && y + itemHeight > me.top + me.minSize.height) {
                    x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
                    cursor.line++;
                    y = cursor.y = me.top + alignmentOffset(legendHeight, columnHeights[cursor.line]);
                }
                var realX = rtlHelper.x(x);
                drawLegendBox(realX, y, legendItem);
                hitboxes[i].left = rtlHelper.leftForLtr(realX, hitboxes[i].width);
                hitboxes[i].top = y;
                // Fill the actual label
                fillText(realX, y, legendItem, textWidth);
                if (isHorizontal) cursor.x += width + labelOpts.padding;
                else cursor.y += itemHeight;
            });
            helpers$1.rtl.restoreTextDirection(me.ctx, opts.textDirection);
        },
        /**
	 * @private
	 */ _getLegendItemAt: function(x, y) {
            var me = this;
            var i, hitBox, lh;
            if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
                // See if we are touching one of the dataset boxes
                lh = me.legendHitBoxes;
                for(i = 0; i < lh.length; ++i){
                    hitBox = lh[i];
                    if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) // Touching an element
                    return me.legendItems[i];
                }
            }
            return null;
        },
        /**
	 * Handle an event
	 * @private
	 * @param {IEvent} event - The event to handle
	 */ handleEvent: function(e) {
            var me = this;
            var opts = me.options;
            var type = e.type === "mouseup" ? "click" : e.type;
            var hoveredItem;
            if (type === "mousemove") {
                if (!opts.onHover && !opts.onLeave) return;
            } else if (type === "click") {
                if (!opts.onClick) return;
            } else return;
            // Chart event already has relative position in it
            hoveredItem = me._getLegendItemAt(e.x, e.y);
            if (type === "click") {
                if (hoveredItem && opts.onClick) // use e.native for backwards compatibility
                opts.onClick.call(me, e.native, hoveredItem);
            } else {
                if (opts.onLeave && hoveredItem !== me._hoveredItem) {
                    if (me._hoveredItem) opts.onLeave.call(me, e.native, me._hoveredItem);
                    me._hoveredItem = hoveredItem;
                }
                if (opts.onHover && hoveredItem) // use e.native for backwards compatibility
                opts.onHover.call(me, e.native, hoveredItem);
            }
        }
    });
    function createNewLegendAndAttach(chart, legendOpts) {
        var legend = new Legend({
            ctx: chart.ctx,
            options: legendOpts,
            chart: chart
        });
        core_layouts.configure(chart, legend, legendOpts);
        core_layouts.addBox(chart, legend);
        chart.legend = legend;
    }
    var plugin_legend = {
        id: "legend",
        /**
	 * Backward compatibility: since 2.1.5, the legend is registered as a plugin, making
	 * Chart.Legend obsolete. To avoid a breaking change, we export the Legend as part of
	 * the plugin, which one will be re-exposed in the chart.js file.
	 * https://github.com/chartjs/Chart.js/pull/2640
	 * @private
	 */ _element: Legend,
        beforeInit: function(chart) {
            var legendOpts = chart.options.legend;
            if (legendOpts) createNewLegendAndAttach(chart, legendOpts);
        },
        beforeUpdate: function(chart) {
            var legendOpts = chart.options.legend;
            var legend = chart.legend;
            if (legendOpts) {
                helpers$1.mergeIf(legendOpts, core_defaults.global.legend);
                if (legend) {
                    core_layouts.configure(chart, legend, legendOpts);
                    legend.options = legendOpts;
                } else createNewLegendAndAttach(chart, legendOpts);
            } else if (legend) {
                core_layouts.removeBox(chart, legend);
                delete chart.legend;
            }
        },
        afterEvent: function(chart, e) {
            var legend = chart.legend;
            if (legend) legend.handleEvent(e);
        }
    };
    var noop$2 = helpers$1.noop;
    core_defaults._set("global", {
        title: {
            display: false,
            fontStyle: "bold",
            fullWidth: true,
            padding: 10,
            position: "top",
            text: "",
            weight: 2000 // by default greater than legend (1000) to be above
        }
    });
    /**
 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
 */ var Title = core_element.extend({
        initialize: function(config) {
            var me = this;
            helpers$1.extend(me, config);
            // Contains hit boxes for each dataset (in dataset order)
            me.legendHitBoxes = [];
        },
        // These methods are ordered by lifecycle. Utilities then follow.
        beforeUpdate: noop$2,
        update: function(maxWidth, maxHeight, margins) {
            var me = this;
            // Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
            me.beforeUpdate();
            // Absorb the master measurements
            me.maxWidth = maxWidth;
            me.maxHeight = maxHeight;
            me.margins = margins;
            // Dimensions
            me.beforeSetDimensions();
            me.setDimensions();
            me.afterSetDimensions();
            // Labels
            me.beforeBuildLabels();
            me.buildLabels();
            me.afterBuildLabels();
            // Fit
            me.beforeFit();
            me.fit();
            me.afterFit();
            //
            me.afterUpdate();
            return me.minSize;
        },
        afterUpdate: noop$2,
        //
        beforeSetDimensions: noop$2,
        setDimensions: function() {
            var me = this;
            // Set the unconstrained dimension before label rotation
            if (me.isHorizontal()) {
                // Reset position before calculating rotation
                me.width = me.maxWidth;
                me.left = 0;
                me.right = me.width;
            } else {
                me.height = me.maxHeight;
                // Reset position before calculating rotation
                me.top = 0;
                me.bottom = me.height;
            }
            // Reset padding
            me.paddingLeft = 0;
            me.paddingTop = 0;
            me.paddingRight = 0;
            me.paddingBottom = 0;
            // Reset minSize
            me.minSize = {
                width: 0,
                height: 0
            };
        },
        afterSetDimensions: noop$2,
        //
        beforeBuildLabels: noop$2,
        buildLabels: noop$2,
        afterBuildLabels: noop$2,
        //
        beforeFit: noop$2,
        fit: function() {
            var me = this;
            var opts = me.options;
            var minSize = me.minSize = {};
            var isHorizontal = me.isHorizontal();
            var lineCount, textSize;
            if (!opts.display) {
                me.width = minSize.width = me.height = minSize.height = 0;
                return;
            }
            lineCount = helpers$1.isArray(opts.text) ? opts.text.length : 1;
            textSize = lineCount * helpers$1.options._parseFont(opts).lineHeight + opts.padding * 2;
            me.width = minSize.width = isHorizontal ? me.maxWidth : textSize;
            me.height = minSize.height = isHorizontal ? textSize : me.maxHeight;
        },
        afterFit: noop$2,
        // Shared Methods
        isHorizontal: function() {
            var pos = this.options.position;
            return pos === "top" || pos === "bottom";
        },
        // Actually draw the title block on the canvas
        draw: function() {
            var me = this;
            var ctx = me.ctx;
            var opts = me.options;
            if (!opts.display) return;
            var fontOpts = helpers$1.options._parseFont(opts);
            var lineHeight = fontOpts.lineHeight;
            var offset = lineHeight / 2 + opts.padding;
            var rotation = 0;
            var top = me.top;
            var left = me.left;
            var bottom = me.bottom;
            var right = me.right;
            var maxWidth, titleX, titleY;
            ctx.fillStyle = helpers$1.valueOrDefault(opts.fontColor, core_defaults.global.defaultFontColor); // render in correct colour
            ctx.font = fontOpts.string;
            // Horizontal
            if (me.isHorizontal()) {
                titleX = left + (right - left) / 2; // midpoint of the width
                titleY = top + offset;
                maxWidth = right - left;
            } else {
                titleX = opts.position === "left" ? left + offset : right - offset;
                titleY = top + (bottom - top) / 2;
                maxWidth = bottom - top;
                rotation = Math.PI * (opts.position === "left" ? -0.5 : 0.5);
            }
            ctx.save();
            ctx.translate(titleX, titleY);
            ctx.rotate(rotation);
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            var text = opts.text;
            if (helpers$1.isArray(text)) {
                var y = 0;
                for(var i = 0; i < text.length; ++i){
                    ctx.fillText(text[i], 0, y, maxWidth);
                    y += lineHeight;
                }
            } else ctx.fillText(text, 0, 0, maxWidth);
            ctx.restore();
        }
    });
    function createNewTitleBlockAndAttach(chart, titleOpts) {
        var title = new Title({
            ctx: chart.ctx,
            options: titleOpts,
            chart: chart
        });
        core_layouts.configure(chart, title, titleOpts);
        core_layouts.addBox(chart, title);
        chart.titleBlock = title;
    }
    var plugin_title = {
        id: "title",
        /**
	 * Backward compatibility: since 2.1.5, the title is registered as a plugin, making
	 * Chart.Title obsolete. To avoid a breaking change, we export the Title as part of
	 * the plugin, which one will be re-exposed in the chart.js file.
	 * https://github.com/chartjs/Chart.js/pull/2640
	 * @private
	 */ _element: Title,
        beforeInit: function(chart) {
            var titleOpts = chart.options.title;
            if (titleOpts) createNewTitleBlockAndAttach(chart, titleOpts);
        },
        beforeUpdate: function(chart) {
            var titleOpts = chart.options.title;
            var titleBlock = chart.titleBlock;
            if (titleOpts) {
                helpers$1.mergeIf(titleOpts, core_defaults.global.title);
                if (titleBlock) {
                    core_layouts.configure(chart, titleBlock, titleOpts);
                    titleBlock.options = titleOpts;
                } else createNewTitleBlockAndAttach(chart, titleOpts);
            } else if (titleBlock) {
                core_layouts.removeBox(chart, titleBlock);
                delete chart.titleBlock;
            }
        }
    };
    var plugins = {};
    var filler = plugin_filler;
    var legend = plugin_legend;
    var title = plugin_title;
    plugins.filler = filler;
    plugins.legend = legend;
    plugins.title = title;
    /**
 * @namespace Chart
 */ core_controller.helpers = helpers$1;
    // @todo dispatch these helpers into appropriated helpers/helpers.* file and write unit tests!
    core_helpers();
    core_controller._adapters = core_adapters;
    core_controller.Animation = core_animation;
    core_controller.animationService = core_animations;
    core_controller.controllers = controllers;
    core_controller.DatasetController = core_datasetController;
    core_controller.defaults = core_defaults;
    core_controller.Element = core_element;
    core_controller.elements = elements;
    core_controller.Interaction = core_interaction;
    core_controller.layouts = core_layouts;
    core_controller.platform = platform;
    core_controller.plugins = core_plugins;
    core_controller.Scale = core_scale;
    core_controller.scaleService = core_scaleService;
    core_controller.Ticks = core_ticks;
    core_controller.Tooltip = core_tooltip;
    // Register built-in scales
    core_controller.helpers.each(scales, function(scale, type) {
        core_controller.scaleService.registerScaleType(type, scale, scale._defaults);
    });
    // Load to register built-in adapters (as side effects)
    // Loading built-in plugins
    for(var k in plugins)if (plugins.hasOwnProperty(k)) core_controller.plugins.register(plugins[k]);
    core_controller.platform.initialize();
    var src = core_controller;
    if (typeof window !== "undefined") window.Chart = core_controller;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Chart
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */ core_controller.Chart = core_controller;
    /**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Legend
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */ core_controller.Legend = plugins.legend._element;
    /**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Title
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */ core_controller.Title = plugins.title._element;
    /**
 * Provided for backward compatibility, use Chart.plugins instead
 * @namespace Chart.pluginService
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */ core_controller.pluginService = core_controller.plugins;
    /**
 * Provided for backward compatibility, inheriting from Chart.PlugingBase has no
 * effect, instead simply create/register plugins via plain JavaScript objects.
 * @interface Chart.PluginBase
 * @deprecated since version 2.5.0
 * @todo remove at version 3
 * @private
 */ core_controller.PluginBase = core_controller.Element.extend({});
    /**
 * Provided for backward compatibility, use Chart.helpers.canvas instead.
 * @namespace Chart.canvasHelpers
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */ core_controller.canvasHelpers = core_controller.helpers.canvas;
    /**
 * Provided for backward compatibility, use Chart.layouts instead.
 * @namespace Chart.layoutService
 * @deprecated since version 2.7.3
 * @todo remove at version 3
 * @private
 */ core_controller.layoutService = core_controller.layouts;
    /**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.LinearScaleBase
 * @deprecated since version 2.8
 * @todo remove at version 3
 * @private
 */ core_controller.LinearScaleBase = scale_linearbase;
    /**
 * Provided for backward compatibility, instead we should create a new Chart
 * by setting the type in the config (`new Chart(id, {type: '{chart-type}'}`).
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 */ core_controller.helpers.each([
        "Bar",
        "Bubble",
        "Doughnut",
        "Line",
        "PolarArea",
        "Radar",
        "Scatter"
    ], function(klass) {
        core_controller[klass] = function(ctx, cfg) {
            return new core_controller(ctx, core_controller.helpers.merge(cfg || {}, {
                type: klass.charAt(0).toLowerCase() + klass.slice(1)
            }));
        };
    });
    return src;
});

});
parcelRegister("YChVI", function(module, exports) {
//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    "use strict";
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === "[object Object]";
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, "toString")) a.toString = b.toString;
        if (hasOwnProp(b, "valueOf")) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m), parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            }), isNowValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
            if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
            else return isNowValid;
        }
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) console.warn("Deprecation warning: " + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = "";
                    if (typeof arguments[i] === "object") {
                        arg += "\n[" + i + "] ";
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ": " + arguments[0][key] + ", ";
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this["_" + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar["sameElse"];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === "string") func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, "");
        return input.replace(/\\/g, "");
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = "", i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") return tok.slice(1);
            return tok;
        }).join("");
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = "Invalid date";
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace("%d", number);
    }
    var defaultRelativeTime = {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        w: "a week",
        ww: "%d weeks",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? "future" : "past"];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {};
    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + "s"] = aliases[shorthand] = unit;
    }
    function normalizeUnits(units) {
        return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {};
    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        return mom.isValid() ? mom._d["get" + (mom._isUTC ? "UTC" : "") + unit]() : NaN;
    }
    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === "FullYear" && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                value = toInt(value);
                mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](value, mom.month(), daysInMonth(value, mom.month()));
            } else mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](value);
        }
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === "object") {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === "string") token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken("M", [
        "MM",
        2
    ], "Mo", function() {
        return this.month() + 1;
    });
    addFormatToken("MMM", 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken("MMMM", 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // ALIASES
    addUnitAlias("month", "M");
    // PRIORITY
    addUnitPriority("month", 8);
    // PARSING
    addRegexToken("M", match1to2);
    addRegexToken("MM", match1to2, match2);
    addRegexToken("MMM", function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken("MMMM", function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        "M",
        "MM"
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        "MMM",
        "MMMM"
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months["standalone"];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? "format" : "standalone"][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? "format" : "standalone"][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, "").toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "MMM") {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === "MMM") {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp("^" + this.months(mom, "").replace(".", "") + "$", "i");
                this._shortMonthsParse[i] = new RegExp("^" + this.monthsShort(mom, "").replace(".", "") + "$", "i");
            }
            if (!strict && !this._monthsParse[i]) {
                regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
                this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "MMMM" && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === "MMM" && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        var dayOfMonth;
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === "string") {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d["set" + (mom._isUTC ? "UTC" : "") + "Month"](value, dayOfMonth);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, "Month");
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, "_monthsShortRegex")) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, "_monthsRegex")) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortPieces.push(this.monthsShort(mom, ""));
            longPieces.push(this.months(mom, ""));
            mixedPieces.push(this.months(mom, ""));
            mixedPieces.push(this.monthsShort(mom, ""));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for(i = 0; i < 12; i++){
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for(i = 0; i < 24; i++)mixedPieces[i] = regexEscape(mixedPieces[i]);
        this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._monthsShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken("Y", 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : "+" + y;
    });
    addFormatToken(0, [
        "YY",
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        "YYYY",
        4
    ], 0, "year");
    addFormatToken(0, [
        "YYYYY",
        5
    ], 0, "year");
    addFormatToken(0, [
        "YYYYYY",
        6,
        true
    ], 0, "year");
    // ALIASES
    addUnitAlias("year", "y");
    // PRIORITIES
    addUnitPriority("year", 1);
    // PARSING
    addRegexToken("Y", matchSigned);
    addRegexToken("YY", match1to2, match2);
    addRegexToken("YYYY", match1to4, match4);
    addRegexToken("YYYYY", match1to6, match6);
    addRegexToken("YYYYYY", match1to6, match6);
    addParseToken([
        "YYYYY",
        "YYYYYY"
    ], YEAR);
    addParseToken("YYYY", function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken("YY", function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken("Y", function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet("FullYear", true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken("w", [
        "ww",
        2
    ], "wo", "week");
    addFormatToken("W", [
        "WW",
        2
    ], "Wo", "isoWeek");
    // ALIASES
    addUnitAlias("week", "w");
    addUnitAlias("isoWeek", "W");
    // PRIORITIES
    addUnitPriority("week", 5);
    addUnitPriority("isoWeek", 5);
    // PARSING
    addRegexToken("w", match1to2);
    addRegexToken("ww", match1to2, match2);
    addRegexToken("W", match1to2);
    addRegexToken("WW", match1to2, match2);
    addWeekParseToken([
        "w",
        "ww",
        "W",
        "WW"
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    // FORMATTING
    addFormatToken("d", 0, "do", "day");
    addFormatToken("dd", 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken("ddd", 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken("dddd", 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken("e", 0, 0, "weekday");
    addFormatToken("E", 0, 0, "isoWeekday");
    // ALIASES
    addUnitAlias("day", "d");
    addUnitAlias("weekday", "e");
    addUnitAlias("isoWeekday", "E");
    // PRIORITY
    addUnitPriority("day", 11);
    addUnitPriority("weekday", 11);
    addUnitPriority("isoWeekday", 11);
    // PARSING
    addRegexToken("d", match1to2);
    addRegexToken("e", match1to2);
    addRegexToken("E", match1to2);
    addRegexToken("dd", function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken("ddd", function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken("dddd", function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        "dd",
        "ddd",
        "dddd"
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        "d",
        "e",
        "E"
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== "string") return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === "number") return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === "string") return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? "format" : "standalone"];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, "").toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, "").toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp("^" + this.weekdays(mom, "").replace(".", "\\.?") + "$", "i");
                this._shortWeekdaysParse[i] = new RegExp("^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$", "i");
                this._minWeekdaysParse[i] = new RegExp("^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$", "i");
            }
            if (!this._weekdaysParse[i]) {
                regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
                this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "dd" && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, "d");
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, "d");
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysRegex")) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysShortRegex")) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysMinRegex")) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ""));
            shortp = regexEscape(this.weekdaysShort(mom, ""));
            longp = regexEscape(this.weekdays(mom, ""));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._weekdaysShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
        this._weekdaysMinStrictRegex = new RegExp("^(" + minPieces.join("|") + ")", "i");
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken("H", [
        "HH",
        2
    ], 0, "hour");
    addFormatToken("h", [
        "hh",
        2
    ], 0, hFormat);
    addFormatToken("k", [
        "kk",
        2
    ], 0, kFormat);
    addFormatToken("hmm", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken("hmmss", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken("Hmm", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken("Hmmss", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem("a", true);
    meridiem("A", false);
    // ALIASES
    addUnitAlias("hour", "h");
    // PRIORITY
    addUnitPriority("hour", 13);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken("a", matchMeridiem);
    addRegexToken("A", matchMeridiem);
    addRegexToken("H", match1to2);
    addRegexToken("h", match1to2);
    addRegexToken("k", match1to2);
    addRegexToken("HH", match1to2, match2);
    addRegexToken("hh", match1to2, match2);
    addRegexToken("kk", match1to2, match2);
    addRegexToken("hmm", match3to4);
    addRegexToken("hmmss", match5to6);
    addRegexToken("Hmm", match3to4);
    addRegexToken("Hmmss", match5to6);
    addParseToken([
        "H",
        "HH"
    ], HOUR);
    addParseToken([
        "k",
        "kk"
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        "a",
        "A"
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        "h",
        "hh"
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("Hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken("Hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + "").toLowerCase().charAt(0) === "p";
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet("Hours", true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? "pm" : "PM";
        else return isLower ? "am" : "AM";
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace("_", "-") : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split("-");
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split("-") : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join("-"));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        return name.match("^[^/\\\\]*$") != null;
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire("./locale/" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== "undefined" && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn("Locale " + key + " not found. Did you forget to load it?");
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            "YYYYYY-MM-DD",
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            "YYYY-MM-DD",
            /\d{4}-\d\d-\d\d/
        ],
        [
            "GGGG-[W]WW-E",
            /\d{4}-W\d\d-\d/
        ],
        [
            "GGGG-[W]WW",
            /\d{4}-W\d\d/,
            false
        ],
        [
            "YYYY-DDD",
            /\d{4}-\d{3}/
        ],
        [
            "YYYY-MM",
            /\d{4}-\d\d/,
            false
        ],
        [
            "YYYYYYMMDD",
            /[+-]\d{10}/
        ],
        [
            "YYYYMMDD",
            /\d{8}/
        ],
        [
            "GGGG[W]WWE",
            /\d{4}W\d{3}/
        ],
        [
            "GGGG[W]WW",
            /\d{4}W\d{2}/,
            false
        ],
        [
            "YYYYDDD",
            /\d{7}/
        ],
        [
            "YYYYMM",
            /\d{6}/,
            false
        ],
        [
            "YYYY",
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            "HH:mm:ss.SSSS",
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            "HH:mm:ss,SSSS",
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            "HH:mm:ss",
            /\d\d:\d\d:\d\d/
        ],
        [
            "HH:mm",
            /\d\d:\d\d/
        ],
        [
            "HHmmss.SSSS",
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            "HHmmss,SSSS",
            /\d\d\d\d\d\d,\d+/
        ],
        [
            "HHmmss",
            /\d\d\d\d\d\d/
        ],
        [
            "HHmm",
            /\d\d\d\d/
        ],
        [
            "HH",
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || " ") + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = "Z";
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? " UTC" : ""));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = "" + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, "d");
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === "") return createInvalid({
            nullInput: true
        });
        if (typeof input === "string") config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === "string") configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isBefore", args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isAfter", args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        "year",
        "quarter",
        "month",
        "week",
        "day",
        "hour",
        "minute",
        "second",
        "millisecond"
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = "+";
            if (offset < 0) {
                offset = -offset;
                sign = "-";
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset("Z", ":");
    offset("ZZ", "");
    // PARSING
    addRegexToken("Z", matchShortOffset);
    addRegexToken("ZZ", matchShortOffset);
    addParseToken([
        "Z",
        "ZZ"
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || "").match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + "").match(chunkOffset) || [
            "-",
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === "+" ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === "string") {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, "m");
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, "m"), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== "string") input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), "m");
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === "string") {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, "_locale")) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, "_isValid")) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(",", "."));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, "M").isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, "M");
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). " + "See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.");
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, "Month") + months * isAdding);
        if (days) set$1(mom, "Date", get(mom, "Date") + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
    function isString(input) {
        return typeof input === "string" || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "years",
            "year",
            "y",
            "months",
            "month",
            "M",
            "days",
            "day",
            "d",
            "dates",
            "date",
            "D",
            "hours",
            "hour",
            "h",
            "minutes",
            "minute",
            "m",
            "seconds",
            "second",
            "s",
            "milliseconds",
            "millisecond",
            "ms"
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "sameDay",
            "nextDay",
            "lastDay",
            "nextWeek",
            "lastWeek",
            "sameElse"
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, "days", true);
        return diff < -6 ? "sameElse" : diff < -1 ? "lastWeek" : diff < 0 ? "lastDay" : diff < 1 ? "sameDay" : diff < 2 ? "nextDay" : diff < 7 ? "nextWeek" : "sameElse";
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf("day"), format = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || "()";
        return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case "year":
                output = monthDiff(this, that) / 12;
                break;
            case "month":
                output = monthDiff(this, that);
                break;
            case "quarter":
                output = monthDiff(this, that) / 3;
                break;
            case "second":
                output = (this - that) / 1e3;
                break; // 1000
            case "minute":
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case "hour":
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case "day":
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case "week":
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
    hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    function toString() {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ");
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace("Z", formatMoment(m, "Z"));
        }
        return formatMoment(m, utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
        var func = "moment", zone = "", prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
            zone = "Z";
        }
        prefix = "[" + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
        datetime = "-MM-DD[T]HH:mm:ss.SSS";
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year(), 0, 1);
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case "month":
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case "hour":
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case "minute":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case "second":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case "month":
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case "hour":
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case "minute":
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case "second":
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken("N", 0, 0, "eraAbbr");
    addFormatToken("NN", 0, 0, "eraAbbr");
    addFormatToken("NNN", 0, 0, "eraAbbr");
    addFormatToken("NNNN", 0, 0, "eraName");
    addFormatToken("NNNNN", 0, 0, "eraNarrow");
    addFormatToken("y", [
        "y",
        1
    ], "yo", "eraYear");
    addFormatToken("y", [
        "yy",
        2
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyy",
        3
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyyy",
        4
    ], 0, "eraYear");
    addRegexToken("N", matchEraAbbr);
    addRegexToken("NN", matchEraAbbr);
    addRegexToken("NNN", matchEraAbbr);
    addRegexToken("NNNN", matchEraName);
    addRegexToken("NNNNN", matchEraNarrow);
    addParseToken([
        "N",
        "NN",
        "NNN",
        "NNNN",
        "NNNNN"
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken("y", matchUnsigned);
    addRegexToken("yy", matchUnsigned);
    addRegexToken("yyy", matchUnsigned);
    addRegexToken("yyyy", matchUnsigned);
    addRegexToken("yo", matchEraYearOrdinal);
    addParseToken([
        "y",
        "yy",
        "yyy",
        "yyyy"
    ], YEAR);
    addParseToken([
        "yo"
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale("en")._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case "string":
                    // truncate time
                    date = hooks(eras[i].since).startOf("day");
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case "undefined":
                    eras[i].until = Infinity;
                    break;
                case "string":
                    // truncate time
                    date = hooks(eras[i].until).startOf("day").valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case "N":
                case "NN":
                case "NNN":
                    if (abbr === eraName) return eras[i];
                    break;
                case "NNNN":
                    if (name === eraName) return eras[i];
                    break;
                case "NNNNN":
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return "";
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return "";
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return "";
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNameRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, "_erasAbbrRegex")) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNarrowRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));
            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }
        this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
        this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
        this._erasNarrowRegex = new RegExp("^(" + narrowPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken(0, [
        "gg",
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        "GG",
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken("gggg", "weekYear");
    addWeekYearFormatToken("ggggg", "weekYear");
    addWeekYearFormatToken("GGGG", "isoWeekYear");
    addWeekYearFormatToken("GGGGG", "isoWeekYear");
    // ALIASES
    addUnitAlias("weekYear", "gg");
    addUnitAlias("isoWeekYear", "GG");
    // PRIORITY
    addUnitPriority("weekYear", 1);
    addUnitPriority("isoWeekYear", 1);
    // PARSING
    addRegexToken("G", matchSigned);
    addRegexToken("g", matchSigned);
    addRegexToken("GG", match1to2, match2);
    addRegexToken("gg", match1to2, match2);
    addRegexToken("GGGG", match1to4, match4);
    addRegexToken("gggg", match1to4, match4);
    addRegexToken("GGGGG", match1to6, match6);
    addRegexToken("ggggg", match1to6, match6);
    addWeekParseToken([
        "gggg",
        "ggggg",
        "GGGG",
        "GGGGG"
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        "gg",
        "GG"
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken("Q", 0, "Qo", "quarter");
    // ALIASES
    addUnitAlias("quarter", "Q");
    // PRIORITY
    addUnitPriority("quarter", 7);
    // PARSING
    addRegexToken("Q", match1);
    addParseToken("Q", function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken("D", [
        "DD",
        2
    ], "Do", "date");
    // ALIASES
    addUnitAlias("date", "D");
    // PRIORITY
    addUnitPriority("date", 9);
    // PARSING
    addRegexToken("D", match1to2);
    addRegexToken("DD", match1to2, match2);
    addRegexToken("Do", function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        "D",
        "DD"
    ], DATE);
    addParseToken("Do", function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet("Date", true);
    // FORMATTING
    addFormatToken("DDD", [
        "DDDD",
        3
    ], "DDDo", "dayOfYear");
    // ALIASES
    addUnitAlias("dayOfYear", "DDD");
    // PRIORITY
    addUnitPriority("dayOfYear", 4);
    // PARSING
    addRegexToken("DDD", match1to3);
    addRegexToken("DDDD", match3);
    addParseToken([
        "DDD",
        "DDDD"
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
    }
    // FORMATTING
    addFormatToken("m", [
        "mm",
        2
    ], 0, "minute");
    // ALIASES
    addUnitAlias("minute", "m");
    // PRIORITY
    addUnitPriority("minute", 14);
    // PARSING
    addRegexToken("m", match1to2);
    addRegexToken("mm", match1to2, match2);
    addParseToken([
        "m",
        "mm"
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet("Minutes", false);
    // FORMATTING
    addFormatToken("s", [
        "ss",
        2
    ], 0, "second");
    // ALIASES
    addUnitAlias("second", "s");
    // PRIORITY
    addUnitPriority("second", 15);
    // PARSING
    addRegexToken("s", match1to2);
    addRegexToken("ss", match1to2, match2);
    addParseToken([
        "s",
        "ss"
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet("Seconds", false);
    // FORMATTING
    addFormatToken("S", 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        "SS",
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        "SSS",
        3
    ], 0, "millisecond");
    addFormatToken(0, [
        "SSSS",
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        "SSSSS",
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        "SSSSSS",
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        "SSSSSSS",
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        "SSSSSSSS",
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        "SSSSSSSSS",
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // ALIASES
    addUnitAlias("millisecond", "ms");
    // PRIORITY
    addUnitPriority("millisecond", 16);
    // PARSING
    addRegexToken("S", match1to3, match1);
    addRegexToken("SS", match1to3, match2);
    addRegexToken("SSS", match1to3, match3);
    var token, getSetMillisecond;
    for(token = "SSSS"; token.length <= 9; token += "S")addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(("0." + input) * 1000);
    }
    for(token = "S"; token.length <= 9; token += "S")addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet("Milliseconds", false);
    // FORMATTING
    addFormatToken("z", 0, 0, "zoneAbbr");
    addFormatToken("zz", 0, 0, "zoneName");
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? "UTC" : "";
    }
    function getZoneName() {
        return this._isUTC ? "Coordinated Universal Time" : "";
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== "undefined" && Symbol.for != null) proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
        return "Moment<" + this.format() + ">";
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate("dates accessor is deprecated. Use date instead.", getSetDayOfMonth);
    proto.months = deprecate("months accessor is deprecated. Use month instead", getSetMonth);
    proto.years = deprecate("years accessor is deprecated. Use year instead", getSetYear);
    proto.zone = deprecate("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", getSetZone);
    proto.isDSTShifted = deprecate("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || "";
        if (index != null) return get$1(format, index, field, "month");
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, "month");
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === "boolean") {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, "day");
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, "day");
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, "months");
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, "monthsShort");
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdays");
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysShort");
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysMin");
    }
    getSetGlobalLocale("en", {
        eras: [
            {
                since: "0001-01-01",
                until: Infinity,
                offset: 1,
                name: "Anno Domini",
                narrow: "AD",
                abbr: "AD"
            },
            {
                since: "0000-12-31",
                until: -Infinity,
                offset: 1,
                name: "Before Christ",
                narrow: "BC",
                abbr: "BC"
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate("moment.lang is deprecated. Use moment.locale instead.", getSetGlobalLocale);
    hooks.langData = deprecate("moment.langData is deprecated. Use moment.localeData instead.", getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === "month" || units === "quarter" || units === "year") {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case "month":
                    return months;
                case "quarter":
                    return months / 3;
                case "year":
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case "week":
                    return days / 7 + milliseconds / 6048e5;
                case "day":
                    return days + milliseconds / 864e5;
                case "hour":
                    return days * 24 + milliseconds / 36e5;
                case "minute":
                    return days * 1440 + milliseconds / 6e4;
                case "second":
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case "millisecond":
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error("Unknown unit " + units);
            }
        }
    }
    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) return NaN;
        return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y");
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + "s"]() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as("s")), minutes = round(duration.as("m")), hours = round(duration.as("h")), days = round(duration.as("d")), months = round(duration.as("M")), weeks = round(duration.as("w")), years = round(duration.as("y")), a = seconds <= thresholds.ss && [
            "s",
            seconds
        ] || seconds < thresholds.s && [
            "ss",
            seconds
        ] || minutes <= 1 && [
            "m"
        ] || minutes < thresholds.m && [
            "mm",
            minutes
        ] || hours <= 1 && [
            "h"
        ] || hours < thresholds.h && [
            "hh",
            hours
        ] || days <= 1 && [
            "d"
        ] || days < thresholds.d && [
            "dd",
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            "w"
        ] || weeks < thresholds.w && [
            "ww",
            weeks
        ];
        a = a || months <= 1 && [
            "M"
        ] || months < thresholds.M && [
            "MM",
            months
        ] || years <= 1 && [
            "y"
        ] || [
            "yy",
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === "function") {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === "s") thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === "object") {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === "boolean") withSuffix = argWithSuffix;
        if (typeof argThresholds === "object") {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return "P0D";
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, "") : "";
        totalSign = total < 0 ? "-" : "";
        ymSign = sign(this._months) !== sign(total) ? "-" : "";
        daysSign = sign(this._days) !== sign(total) ? "-" : "";
        hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
        return totalSign + "P" + (years ? ymSign + years + "Y" : "") + (months ? ymSign + months + "M" : "") + (days ? daysSign + days + "D" : "") + (hours || minutes || seconds ? "T" : "") + (hours ? hmsSign + hours + "H" : "") + (minutes ? hmsSign + minutes + "M" : "") + (seconds ? hmsSign + s + "S" : "");
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken("X", 0, 0, "unix");
    addFormatToken("x", 0, 0, "valueOf");
    // PARSING
    addRegexToken("x", matchSigned);
    addRegexToken("X", matchTimestamp);
    addParseToken("X", function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken("x", function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = "2.29.4";
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
        DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
        DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
        DATE: "YYYY-MM-DD",
        TIME: "HH:mm",
        TIME_SECONDS: "HH:mm:ss",
        TIME_MS: "HH:mm:ss.SSS",
        WEEK: "GGGG-[W]WW",
        MONTH: "YYYY-MM"
    };
    return hooks;
});

});


parcelRegister("6EtAI", function(module, exports) {
// Get the chart variable

var $fF4Ij = parcelRequire("fF4Ij");
var $4d7d6eac15e3c386$require$Chart = $fF4Ij;
$4d7d6eac15e3c386$require$Chart = typeof $4d7d6eac15e3c386$require$Chart === "function" ? $4d7d6eac15e3c386$require$Chart : window.Chart;
// Configure plugin namespace
$4d7d6eac15e3c386$require$Chart.Annotation = $4d7d6eac15e3c386$require$Chart.Annotation || {};
$4d7d6eac15e3c386$require$Chart.Annotation.drawTimeOptions = {
    afterDraw: "afterDraw",
    afterDatasetsDraw: "afterDatasetsDraw",
    beforeDatasetsDraw: "beforeDatasetsDraw"
};
$4d7d6eac15e3c386$require$Chart.Annotation.defaults = {
    drawTime: "afterDatasetsDraw",
    dblClickSpeed: 350,
    events: [],
    annotations: []
};
$4d7d6eac15e3c386$require$Chart.Annotation.labelDefaults = {
    backgroundColor: "rgba(0,0,0,0.8)",
    fontFamily: $4d7d6eac15e3c386$require$Chart.defaults.global.defaultFontFamily,
    fontSize: $4d7d6eac15e3c386$require$Chart.defaults.global.defaultFontSize,
    fontStyle: "bold",
    fontColor: "#fff",
    xPadding: 6,
    yPadding: 6,
    cornerRadius: 6,
    position: "center",
    xAdjust: 0,
    yAdjust: 0,
    enabled: false,
    content: null
};

$4d7d6eac15e3c386$require$Chart.Annotation.Element = (parcelRequire("lO9O2"))($4d7d6eac15e3c386$require$Chart);


$4d7d6eac15e3c386$require$Chart.Annotation.types = {
    line: (parcelRequire("lFRfm"))($4d7d6eac15e3c386$require$Chart),
    box: (parcelRequire("bz8Yx"))($4d7d6eac15e3c386$require$Chart)
};

var $4d7d6eac15e3c386$var$annotationPlugin = (parcelRequire("8WmmG"))($4d7d6eac15e3c386$require$Chart);
module.exports = $4d7d6eac15e3c386$var$annotationPlugin;
$4d7d6eac15e3c386$require$Chart.pluginService.register($4d7d6eac15e3c386$var$annotationPlugin);

});
parcelRegister("lO9O2", function(module, exports) {
module.exports = function(Chart) {
    var chartHelpers = Chart.helpers;
    var AnnotationElement = Chart.Element.extend({
        initialize: function() {
            this.hidden = false;
            this.hovering = false;
            this._model = chartHelpers.clone(this._model) || {};
            this.setDataLimits();
        },
        destroy: function() {},
        setDataLimits: function() {},
        configure: function() {},
        inRange: function() {},
        getCenterPoint: function() {},
        getWidth: function() {},
        getHeight: function() {},
        getArea: function() {},
        draw: function() {}
    });
    return AnnotationElement;
};

});

parcelRegister("lFRfm", function(module, exports) {
// Line Annotation implementation

module.exports = function(Chart) {
    var chartHelpers = Chart.helpers;
    var helpers = (parcelRequire("hqlDU"))(Chart);
    var horizontalKeyword = "horizontal";
    var verticalKeyword = "vertical";
    var LineAnnotation = Chart.Annotation.Element.extend({
        setDataLimits: function() {
            var model = this._model;
            var options = this.options;
            // Set the data range for this annotation
            model.ranges = {};
            model.ranges[options.scaleID] = {
                min: options.value,
                max: options.endValue || options.value
            };
        },
        configure: function() {
            var model = this._model;
            var options = this.options;
            var chartInstance = this.chartInstance;
            var ctx = chartInstance.chart.ctx;
            var scale = chartInstance.scales[options.scaleID];
            var pixel, endPixel;
            if (scale) {
                pixel = helpers.isValid(options.value) ? scale.getPixelForValue(options.value) : NaN;
                endPixel = helpers.isValid(options.endValue) ? scale.getPixelForValue(options.endValue) : pixel;
            }
            if (isNaN(pixel)) return;
            var chartArea = chartInstance.chartArea;
            // clip annotations to the chart area
            model.clip = {
                x1: chartArea.left,
                x2: chartArea.right,
                y1: chartArea.top,
                y2: chartArea.bottom
            };
            if (this.options.mode == horizontalKeyword) {
                model.x1 = chartArea.left;
                model.x2 = chartArea.right;
                model.y1 = pixel;
                model.y2 = endPixel;
            } else {
                model.y1 = chartArea.top;
                model.y2 = chartArea.bottom;
                model.x1 = pixel;
                model.x2 = endPixel;
            }
            model.line = new LineFunction(model);
            model.mode = options.mode;
            // Figure out the label:
            model.labelBackgroundColor = options.label.backgroundColor;
            model.labelFontFamily = options.label.fontFamily;
            model.labelFontSize = options.label.fontSize;
            model.labelFontStyle = options.label.fontStyle;
            model.labelFontColor = options.label.fontColor;
            model.labelXPadding = options.label.xPadding;
            model.labelYPadding = options.label.yPadding;
            model.labelCornerRadius = options.label.cornerRadius;
            model.labelPosition = options.label.position;
            model.labelXAdjust = options.label.xAdjust;
            model.labelYAdjust = options.label.yAdjust;
            model.labelEnabled = options.label.enabled;
            model.labelContent = options.label.content;
            ctx.font = chartHelpers.fontString(model.labelFontSize, model.labelFontStyle, model.labelFontFamily);
            var textWidth = ctx.measureText(model.labelContent).width;
            var textHeight = ctx.measureText("M").width;
            var labelPosition = calculateLabelPosition(model, textWidth, textHeight, model.labelXPadding, model.labelYPadding);
            model.labelX = labelPosition.x - model.labelXPadding;
            model.labelY = labelPosition.y - model.labelYPadding;
            model.labelWidth = textWidth + 2 * model.labelXPadding;
            model.labelHeight = textHeight + 2 * model.labelYPadding;
            model.borderColor = options.borderColor;
            model.borderWidth = options.borderWidth;
            model.borderDash = options.borderDash || [];
            model.borderDashOffset = options.borderDashOffset || 0;
        },
        inRange: function(mouseX, mouseY) {
            var model = this._model;
            return(// On the line
            model.line && model.line.intersects(mouseX, mouseY, this.getHeight()) || // On the label
            model.labelEnabled && model.labelContent && mouseX >= model.labelX && mouseX <= model.labelX + model.labelWidth && mouseY >= model.labelY && mouseY <= model.labelY + model.labelHeight);
        },
        getCenterPoint: function() {
            return {
                x: (this._model.x2 + this._model.x1) / 2,
                y: (this._model.y2 + this._model.y1) / 2
            };
        },
        getWidth: function() {
            return Math.abs(this._model.right - this._model.left);
        },
        getHeight: function() {
            return this._model.borderWidth || 1;
        },
        getArea: function() {
            return Math.sqrt(Math.pow(this.getWidth(), 2) + Math.pow(this.getHeight(), 2));
        },
        draw: function() {
            var view = this._view;
            var ctx = this.chartInstance.chart.ctx;
            if (!view.clip) return;
            ctx.save();
            // Canvas setup
            ctx.beginPath();
            ctx.rect(view.clip.x1, view.clip.y1, view.clip.x2 - view.clip.x1, view.clip.y2 - view.clip.y1);
            ctx.clip();
            ctx.lineWidth = view.borderWidth;
            ctx.strokeStyle = view.borderColor;
            if (ctx.setLineDash) ctx.setLineDash(view.borderDash);
            ctx.lineDashOffset = view.borderDashOffset;
            // Draw
            ctx.beginPath();
            ctx.moveTo(view.x1, view.y1);
            ctx.lineTo(view.x2, view.y2);
            ctx.stroke();
            if (view.labelEnabled && view.labelContent) {
                ctx.beginPath();
                ctx.rect(view.clip.x1, view.clip.y1, view.clip.x2 - view.clip.x1, view.clip.y2 - view.clip.y1);
                ctx.clip();
                ctx.fillStyle = view.labelBackgroundColor;
                // Draw the tooltip
                chartHelpers.drawRoundedRectangle(ctx, view.labelX, view.labelY, view.labelWidth, view.labelHeight, view.labelCornerRadius // radius
                );
                ctx.fill();
                // Draw the text
                ctx.font = chartHelpers.fontString(view.labelFontSize, view.labelFontStyle, view.labelFontFamily);
                ctx.fillStyle = view.labelFontColor;
                ctx.textAlign = "center";
                ctx.textBaseline = "middle";
                ctx.fillText(view.labelContent, view.labelX + view.labelWidth / 2, view.labelY + view.labelHeight / 2);
            }
            ctx.restore();
        }
    });
    function LineFunction(view) {
        // Describe the line in slope-intercept form (y = mx + b).
        // Note that the axes are rotated 90° CCW, which causes the
        // x- and y-axes to be swapped.
        var m = (view.x2 - view.x1) / (view.y2 - view.y1);
        var b = view.x1 || 0;
        this.m = m;
        this.b = b;
        this.getX = function(y) {
            // Coordinates are relative to the origin of the canvas
            return m * (y - view.y1) + b;
        };
        this.getY = function(x) {
            return (x - b) / m + view.y1;
        };
        this.intersects = function(x, y, epsilon) {
            epsilon = epsilon || 0.001;
            var dy = this.getY(x), dx = this.getX(y);
            return (!isFinite(dy) || Math.abs(y - dy) < epsilon) && (!isFinite(dx) || Math.abs(x - dx) < epsilon);
        };
    }
    function calculateLabelPosition(view, width, height, padWidth, padHeight) {
        var line = view.line;
        var ret = {}, xa = 0, ya = 0;
        switch(true){
            // top align
            case view.mode == verticalKeyword && view.labelPosition == "top":
                ya = padHeight + view.labelYAdjust;
                xa = width / 2 + view.labelXAdjust;
                ret.y = view.y1 + ya;
                ret.x = (isFinite(line.m) ? line.getX(ret.y) : view.x1) - xa;
                break;
            // bottom align
            case view.mode == verticalKeyword && view.labelPosition == "bottom":
                ya = height + padHeight + view.labelYAdjust;
                xa = width / 2 + view.labelXAdjust;
                ret.y = view.y2 - ya;
                ret.x = (isFinite(line.m) ? line.getX(ret.y) : view.x1) - xa;
                break;
            // left align
            case view.mode == horizontalKeyword && view.labelPosition == "left":
                xa = padWidth + view.labelXAdjust;
                ya = -(height / 2) + view.labelYAdjust;
                ret.x = view.x1 + xa;
                ret.y = line.getY(ret.x) + ya;
                break;
            // right align
            case view.mode == horizontalKeyword && view.labelPosition == "right":
                xa = width + padWidth + view.labelXAdjust;
                ya = -(height / 2) + view.labelYAdjust;
                ret.x = view.x2 - xa;
                ret.y = line.getY(ret.x) + ya;
                break;
            // center align
            default:
                ret.x = (view.x1 + view.x2 - width) / 2 + view.labelXAdjust;
                ret.y = (view.y1 + view.y2 - height) / 2 + view.labelYAdjust;
        }
        return ret;
    }
    return LineAnnotation;
};

});
parcelRegister("hqlDU", function(module, exports) {
function $caf5a72a2c1da63e$var$noop() {}
function $caf5a72a2c1da63e$var$elements(chartInstance) {
    // Turn the elements object into an array of elements
    var elements = chartInstance.annotation.elements;
    return Object.keys(elements).map(function(id) {
        return elements[id];
    });
}
function $caf5a72a2c1da63e$var$objectId() {
    return Math.random().toString(36).substr(2, 6);
}
function $caf5a72a2c1da63e$var$isValid(rawValue) {
    if (rawValue === null || typeof rawValue === "undefined") return false;
    else if (typeof rawValue === "number") return isFinite(rawValue);
    else return !!rawValue;
}
function $caf5a72a2c1da63e$var$decorate(obj, prop, func) {
    var prefix = "$";
    if (!obj[prefix + prop]) {
        if (obj[prop]) {
            obj[prefix + prop] = obj[prop].bind(obj);
            obj[prop] = function() {
                var args = [
                    obj[prefix + prop]
                ].concat(Array.prototype.slice.call(arguments));
                return func.apply(obj, args);
            };
        } else obj[prop] = function() {
            var args = [
                undefined
            ].concat(Array.prototype.slice.call(arguments));
            return func.apply(obj, args);
        };
    }
}
function $caf5a72a2c1da63e$var$callEach(fns, method) {
    fns.forEach(function(fn) {
        (method ? fn[method] : fn)();
    });
}
function $caf5a72a2c1da63e$var$getEventHandlerName(eventName) {
    return "on" + eventName[0].toUpperCase() + eventName.substring(1);
}
function $caf5a72a2c1da63e$var$createMouseEvent(type, previousEvent) {
    try {
        return new MouseEvent(type, previousEvent);
    } catch (exception) {
        try {
            var m = document.createEvent("MouseEvent");
            m.initMouseEvent(type, previousEvent.canBubble, previousEvent.cancelable, previousEvent.view, previousEvent.detail, previousEvent.screenX, previousEvent.screenY, previousEvent.clientX, previousEvent.clientY, previousEvent.ctrlKey, previousEvent.altKey, previousEvent.shiftKey, previousEvent.metaKey, previousEvent.button, previousEvent.relatedTarget);
            return m;
        } catch (exception2) {
            var e = document.createEvent("Event");
            e.initEvent(type, previousEvent.canBubble, previousEvent.cancelable);
            return e;
        }
    }
}
module.exports = function(Chart) {
    var chartHelpers = Chart.helpers;
    function initConfig(config) {
        config = chartHelpers.configMerge(Chart.Annotation.defaults, config);
        if (chartHelpers.isArray(config.annotations)) config.annotations.forEach(function(annotation) {
            annotation.label = chartHelpers.configMerge(Chart.Annotation.labelDefaults, annotation.label);
        });
        return config;
    }
    function getScaleLimits(scaleId, annotations, scaleMin, scaleMax) {
        var ranges = annotations.filter(function(annotation) {
            return !!annotation._model.ranges[scaleId];
        }).map(function(annotation) {
            return annotation._model.ranges[scaleId];
        });
        var min = ranges.map(function(range) {
            return Number(range.min);
        }).reduce(function(a, b) {
            return isFinite(b) && !isNaN(b) && b < a ? b : a;
        }, scaleMin);
        var max = ranges.map(function(range) {
            return Number(range.max);
        }).reduce(function(a, b) {
            return isFinite(b) && !isNaN(b) && b > a ? b : a;
        }, scaleMax);
        return {
            min: min,
            max: max
        };
    }
    function adjustScaleRange(scale) {
        // Adjust the scale range to include annotation values
        var range = getScaleLimits(scale.id, $caf5a72a2c1da63e$var$elements(scale.chart), scale.min, scale.max);
        if (typeof scale.options.ticks.min === "undefined" && typeof scale.options.ticks.suggestedMin === "undefined") scale.min = range.min;
        if (typeof scale.options.ticks.max === "undefined" && typeof scale.options.ticks.suggestedMax === "undefined") scale.max = range.max;
        if (scale.handleTickRangeOptions) scale.handleTickRangeOptions();
    }
    function getNearestItems(annotations, position) {
        var minDistance = Number.POSITIVE_INFINITY;
        return annotations.filter(function(element) {
            return element.inRange(position.x, position.y);
        }).reduce(function(nearestItems, element) {
            var center = element.getCenterPoint();
            var distance = chartHelpers.distanceBetweenPoints(position, center);
            if (distance < minDistance) {
                nearestItems = [
                    element
                ];
                minDistance = distance;
            } else if (distance === minDistance) // Can have multiple items at the same distance in which case we sort by size
            nearestItems.push(element);
            return nearestItems;
        }, []).sort(function(a, b) {
            // If there are multiple elements equally close,
            // sort them by size, then by index
            var sizeA = a.getArea(), sizeB = b.getArea();
            return sizeA > sizeB || sizeA < sizeB ? sizeA - sizeB : a._index - b._index;
        }).slice(0, 1)[0]; // return only the top item
    }
    return {
        initConfig: initConfig,
        elements: $caf5a72a2c1da63e$var$elements,
        callEach: $caf5a72a2c1da63e$var$callEach,
        noop: $caf5a72a2c1da63e$var$noop,
        objectId: $caf5a72a2c1da63e$var$objectId,
        isValid: $caf5a72a2c1da63e$var$isValid,
        decorate: $caf5a72a2c1da63e$var$decorate,
        adjustScaleRange: adjustScaleRange,
        getNearestItems: getNearestItems,
        getEventHandlerName: $caf5a72a2c1da63e$var$getEventHandlerName,
        createMouseEvent: $caf5a72a2c1da63e$var$createMouseEvent
    };
};

});


parcelRegister("bz8Yx", function(module, exports) {
// Box Annotation implementation

module.exports = function(Chart) {
    var helpers = (parcelRequire("hqlDU"))(Chart);
    var BoxAnnotation = Chart.Annotation.Element.extend({
        setDataLimits: function() {
            var model = this._model;
            var options = this.options;
            var chartInstance = this.chartInstance;
            var xScale = chartInstance.scales[options.xScaleID];
            var yScale = chartInstance.scales[options.yScaleID];
            var chartArea = chartInstance.chartArea;
            // Set the data range for this annotation
            model.ranges = {};
            if (!chartArea) return;
            var min = 0;
            var max = 0;
            if (xScale) {
                min = helpers.isValid(options.xMin) ? options.xMin : xScale.getPixelForValue(chartArea.left);
                max = helpers.isValid(options.xMax) ? options.xMax : xScale.getPixelForValue(chartArea.right);
                model.ranges[options.xScaleID] = {
                    min: Math.min(min, max),
                    max: Math.max(min, max)
                };
            }
            if (yScale) {
                min = helpers.isValid(options.yMin) ? options.yMin : yScale.getPixelForValue(chartArea.bottom);
                max = helpers.isValid(options.yMax) ? options.yMax : yScale.getPixelForValue(chartArea.top);
                model.ranges[options.yScaleID] = {
                    min: Math.min(min, max),
                    max: Math.max(min, max)
                };
            }
        },
        configure: function() {
            var model = this._model;
            var options = this.options;
            var chartInstance = this.chartInstance;
            var xScale = chartInstance.scales[options.xScaleID];
            var yScale = chartInstance.scales[options.yScaleID];
            var chartArea = chartInstance.chartArea;
            // clip annotations to the chart area
            model.clip = {
                x1: chartArea.left,
                x2: chartArea.right,
                y1: chartArea.top,
                y2: chartArea.bottom
            };
            var left = chartArea.left, top = chartArea.top, right = chartArea.right, bottom = chartArea.bottom;
            var min, max;
            if (xScale) {
                min = helpers.isValid(options.xMin) ? xScale.getPixelForValue(options.xMin) : chartArea.left;
                max = helpers.isValid(options.xMax) ? xScale.getPixelForValue(options.xMax) : chartArea.right;
                left = Math.min(min, max);
                right = Math.max(min, max);
            }
            if (yScale) {
                min = helpers.isValid(options.yMin) ? yScale.getPixelForValue(options.yMin) : chartArea.bottom;
                max = helpers.isValid(options.yMax) ? yScale.getPixelForValue(options.yMax) : chartArea.top;
                top = Math.min(min, max);
                bottom = Math.max(min, max);
            }
            // Ensure model has rect coordinates
            model.left = left;
            model.top = top;
            model.right = right;
            model.bottom = bottom;
            // Stylistic options
            model.borderColor = options.borderColor;
            model.borderWidth = options.borderWidth;
            model.backgroundColor = options.backgroundColor;
        },
        inRange: function(mouseX, mouseY) {
            var model = this._model;
            return model && mouseX >= model.left && mouseX <= model.right && mouseY >= model.top && mouseY <= model.bottom;
        },
        getCenterPoint: function() {
            var model = this._model;
            return {
                x: (model.right + model.left) / 2,
                y: (model.bottom + model.top) / 2
            };
        },
        getWidth: function() {
            var model = this._model;
            return Math.abs(model.right - model.left);
        },
        getHeight: function() {
            var model = this._model;
            return Math.abs(model.bottom - model.top);
        },
        getArea: function() {
            return this.getWidth() * this.getHeight();
        },
        draw: function() {
            var view = this._view;
            var ctx = this.chartInstance.chart.ctx;
            ctx.save();
            // Canvas setup
            ctx.beginPath();
            ctx.rect(view.clip.x1, view.clip.y1, view.clip.x2 - view.clip.x1, view.clip.y2 - view.clip.y1);
            ctx.clip();
            ctx.lineWidth = view.borderWidth;
            ctx.strokeStyle = view.borderColor;
            ctx.fillStyle = view.backgroundColor;
            // Draw
            var width = view.right - view.left, height = view.bottom - view.top;
            ctx.fillRect(view.left, view.top, width, height);
            ctx.strokeRect(view.left, view.top, width, height);
            ctx.restore();
        }
    });
    return BoxAnnotation;
};

});

parcelRegister("8WmmG", function(module, exports) {


module.exports = function(Chart) {
    var chartHelpers = Chart.helpers;
    var helpers = (parcelRequire("hqlDU"))(Chart);
    var events = (parcelRequire("64ZQc"))(Chart);
    var annotationTypes = Chart.Annotation.types;
    function setAfterDataLimitsHook(axisOptions) {
        helpers.decorate(axisOptions, "afterDataLimits", function(previous, scale) {
            if (previous) previous(scale);
            helpers.adjustScaleRange(scale);
        });
    }
    function draw(drawTime) {
        return function(chartInstance, easingDecimal) {
            var defaultDrawTime = chartInstance.annotation.options.drawTime;
            helpers.elements(chartInstance).filter(function(element) {
                return drawTime === (element.options.drawTime || defaultDrawTime);
            }).forEach(function(element) {
                element.transition(easingDecimal).draw();
            });
        };
    }
    return {
        beforeInit: function(chartInstance) {
            var chartOptions = chartInstance.options;
            // Initialize chart instance plugin namespace
            var ns = chartInstance.annotation = {
                elements: {},
                options: helpers.initConfig(chartOptions.annotation || {}),
                onDestroy: [],
                firstRun: true,
                supported: false
            };
            // Add the annotation scale adjuster to each scale's afterDataLimits hook
            chartInstance.ensureScalesHaveIDs();
            if (chartOptions.scales) {
                ns.supported = true;
                chartHelpers.each(chartOptions.scales.xAxes, setAfterDataLimitsHook);
                chartHelpers.each(chartOptions.scales.yAxes, setAfterDataLimitsHook);
            }
        },
        beforeUpdate: function(chartInstance) {
            var ns = chartInstance.annotation;
            if (!ns.supported) return;
            if (!ns.firstRun) ns.options = helpers.initConfig(chartInstance.options.annotation || {});
            else ns.firstRun = false;
            var elementIds = [];
            // Add new elements, or update existing ones
            ns.options.annotations.forEach(function(annotation) {
                var id = annotation.id || helpers.objectId();
                // No element with that ID exists, and it's a valid annotation type
                if (!ns.elements[id] && annotationTypes[annotation.type]) {
                    var cls = annotationTypes[annotation.type];
                    var element = new cls({
                        id: id,
                        options: annotation,
                        chartInstance: chartInstance
                    });
                    element.initialize();
                    ns.elements[id] = element;
                    annotation.id = id;
                    elementIds.push(id);
                } else if (ns.elements[id]) // Nothing to do for update, since the element config references
                // the same object that exists in the chart annotation config
                elementIds.push(id);
            });
            // Delete removed elements
            Object.keys(ns.elements).forEach(function(id) {
                if (elementIds.indexOf(id) === -1) {
                    ns.elements[id].destroy();
                    delete ns.elements[id];
                }
            });
        },
        afterScaleUpdate: function(chartInstance) {
            helpers.elements(chartInstance).forEach(function(element) {
                element.configure();
            });
        },
        beforeDatasetsDraw: draw("beforeDatasetsDraw"),
        afterDatasetsDraw: draw("afterDatasetsDraw"),
        afterDraw: draw("afterDraw"),
        afterInit: function(chartInstance) {
            // Detect and intercept events that happen on an annotation element
            var watchFor = chartInstance.annotation.options.events;
            if (chartHelpers.isArray(watchFor) && watchFor.length > 0) {
                var canvas = chartInstance.chart.canvas;
                var eventHandler = events.dispatcher.bind(chartInstance);
                events.collapseHoverEvents(watchFor).forEach(function(eventName) {
                    chartHelpers.addEvent(canvas, eventName, eventHandler);
                    chartInstance.annotation.onDestroy.push(function() {
                        chartHelpers.removeEvent(canvas, eventName, eventHandler);
                    });
                });
            }
        },
        destroy: function(chartInstance) {
            var deregisterers = chartInstance.annotation.onDestroy;
            while(deregisterers.length > 0)deregisterers.pop()();
        }
    };
};

});
parcelRegister("64ZQc", function(module, exports) {

module.exports = function(Chart) {
    var chartHelpers = Chart.helpers;
    var helpers = (parcelRequire("hqlDU"))(Chart);
    function collapseHoverEvents(events) {
        var hover = false;
        var filteredEvents = events.filter(function(eventName) {
            switch(eventName){
                case "mouseenter":
                case "mouseover":
                case "mouseout":
                case "mouseleave":
                    hover = true;
                    return false;
                default:
                    return true;
            }
        });
        if (hover && filteredEvents.indexOf("mousemove") === -1) filteredEvents.push("mousemove");
        return filteredEvents;
    }
    function dispatcher(e) {
        var ns = this.annotation;
        var elements = helpers.elements(this);
        var position = chartHelpers.getRelativePosition(e, this.chart);
        var element = helpers.getNearestItems(elements, position);
        var events = collapseHoverEvents(ns.options.events);
        var dblClickSpeed = ns.options.dblClickSpeed;
        var eventHandlers = [];
        var eventHandlerName = helpers.getEventHandlerName(e.type);
        var options = (element || {}).options;
        // Detect hover events
        if (e.type === "mousemove") {
            if (element && !element.hovering) // hover started
            [
                "mouseenter",
                "mouseover"
            ].forEach(function(eventName) {
                var eventHandlerName = helpers.getEventHandlerName(eventName);
                var hoverEvent = helpers.createMouseEvent(eventName, e); // recreate the event to match the handler
                element.hovering = true;
                if (typeof options[eventHandlerName] === "function") eventHandlers.push([
                    options[eventHandlerName],
                    hoverEvent,
                    element
                ]);
            });
            else if (!element) // hover ended
            elements.forEach(function(element) {
                if (element.hovering) {
                    element.hovering = false;
                    var options = element.options;
                    [
                        "mouseout",
                        "mouseleave"
                    ].forEach(function(eventName) {
                        var eventHandlerName = helpers.getEventHandlerName(eventName);
                        var hoverEvent = helpers.createMouseEvent(eventName, e); // recreate the event to match the handler
                        if (typeof options[eventHandlerName] === "function") eventHandlers.push([
                            options[eventHandlerName],
                            hoverEvent,
                            element
                        ]);
                    });
                }
            });
        }
        // Suppress duplicate click events during a double click
        // 1. click -> 2. click -> 3. dblclick
        //
        // 1: wait dblClickSpeed ms, then fire click
        // 2: cancel (1) if it is waiting then wait dblClickSpeed ms then fire click, else fire click immediately
        // 3: cancel (1) or (2) if waiting, then fire dblclick 
        if (element && events.indexOf("dblclick") > -1 && typeof options.onDblclick === "function") {
            if (e.type === "click" && typeof options.onClick === "function") {
                clearTimeout(element.clickTimeout);
                element.clickTimeout = setTimeout(function() {
                    delete element.clickTimeout;
                    options.onClick.call(element, e);
                }, dblClickSpeed);
                e.stopImmediatePropagation();
                e.preventDefault();
                return;
            } else if (e.type === "dblclick" && element.clickTimeout) {
                clearTimeout(element.clickTimeout);
                delete element.clickTimeout;
            }
        }
        // Dispatch the event to the usual handler, but only if we haven't substituted it
        if (element && typeof options[eventHandlerName] === "function" && eventHandlers.length === 0) eventHandlers.push([
            options[eventHandlerName],
            e,
            element
        ]);
        if (eventHandlers.length > 0) {
            e.stopImmediatePropagation();
            e.preventDefault();
            eventHandlers.forEach(function(eventHandler) {
                // [handler, event, element]
                eventHandler[0].call(eventHandler[2], eventHandler[1]);
            });
        }
    }
    return {
        dispatcher: dispatcher,
        collapseHoverEvents: collapseHoverEvents
    };
};

});



parcelRegister("l1VEz", function(module, exports) {
var $f4f669b5fcda5fb9$var$webAudioPeakMeter = function() {
    "use strict";
    var options = {
        borderSize: 2,
        fontSize: 9,
        backgroundColor: "black",
        tickColor: "#ddd",
        gradient: [
            "red 1%",
            "#ff0 16%",
            "lime 45%",
            "#080 100%"
        ],
        dbRange: 48,
        dbTickSize: 6,
        maskTransition: "height 0.1s"
    };
    var tickWidth;
    var elementWidth;
    var elementHeight;
    var meterHeight;
    var meterWidth;
    var meterTop;
    var vertical = true;
    var channelCount = 1;
    var channelMasks = [];
    var channelPeaks = [];
    var channelPeakLabels = [];
    var getBaseLog = function(x, y) {
        return Math.log(y) / Math.log(x);
    };
    var dbFromFloat = function(floatVal) {
        return getBaseLog(10, floatVal) * 20;
    };
    var setOptions = function(userOptions) {
        for(var k in userOptions)options[k] = userOptions[k];
        tickWidth = options.fontSize * 2.0;
        meterTop = options.fontSize * 1.5 + options.borderSize;
    };
    var createMeterNode = function(sourceNode, audioCtx) {
        var c = sourceNode.channelCount;
        var meterNode = audioCtx.createScriptProcessor(2048, c, c);
        sourceNode.connect(meterNode);
        meterNode.connect(audioCtx.destination);
        return meterNode;
    };
    var createContainerDiv = function(parent) {
        var meterElement = document.createElement("div");
        meterElement.style.position = "relative";
        meterElement.style.width = elementWidth + "px";
        meterElement.style.height = elementHeight + "px";
        meterElement.style.backgroundColor = options.backgroundColor;
        parent.appendChild(meterElement);
        return meterElement;
    };
    var createMeter = function(domElement, meterNode, optionsOverrides) {
        setOptions(optionsOverrides);
        elementWidth = domElement.clientWidth;
        elementHeight = domElement.clientHeight;
        var meterElement = createContainerDiv(domElement);
        if (elementWidth > elementHeight) vertical = false;
        meterHeight = elementHeight - meterTop - options.borderSize;
        meterWidth = elementWidth - tickWidth - options.borderSize;
        createTicks(meterElement);
        createRainbow(meterElement, meterWidth, meterHeight, meterTop, tickWidth);
        channelCount = meterNode.channelCount;
        var channelWidth = meterWidth / channelCount;
        var channelLeft = tickWidth;
        for(var i = 0; i < channelCount; i++){
            createChannelMask(meterElement, options.borderSize, meterTop, channelLeft, false);
            channelMasks[i] = createChannelMask(meterElement, channelWidth, meterTop, channelLeft, options.maskTransition);
            channelPeaks[i] = 0.0;
            channelPeakLabels[i] = createPeakLabel(meterElement, channelWidth, channelLeft);
            channelLeft += channelWidth;
        }
        meterNode.onaudioprocess = updateMeter;
        meterElement.addEventListener("click", function() {
            for(var i = 0; i < channelCount; i++){
                channelPeaks[i] = 0.0;
                channelPeakLabels[i].textContent = "-\u221E";
            }
        }, false);
    };
    var createTicks = function(parent) {
        var numTicks = Math.floor(options.dbRange / options.dbTickSize);
        var dbTickLabel = 0;
        var dbTickTop = options.fontSize + options.borderSize;
        for(var i = 0; i < numTicks; i++){
            var dbTick = document.createElement("div");
            parent.appendChild(dbTick);
            dbTick.style.width = tickWidth + "px";
            dbTick.style.textAlign = "right";
            dbTick.style.color = options.tickColor;
            dbTick.style.fontSize = options.fontSize + "px";
            dbTick.style.position = "absolute";
            dbTick.style.top = dbTickTop + "px";
            dbTick.textContent = dbTickLabel + "";
            dbTickLabel -= options.dbTickSize;
            dbTickTop += meterHeight / numTicks;
        }
    };
    var createRainbow = function(parent, width, height, top, left) {
        var rainbow = document.createElement("div");
        parent.appendChild(rainbow);
        rainbow.style.width = width + "px";
        rainbow.style.height = height + "px";
        rainbow.style.position = "absolute";
        rainbow.style.top = top + "px";
        rainbow.style.left = left + "px";
        var gradientStyle = "linear-gradient(" + options.gradient.join(", ") + ")";
        rainbow.style.backgroundImage = gradientStyle;
        return rainbow;
    };
    var createPeakLabel = function(parent, width, left) {
        var label = document.createElement("div");
        parent.appendChild(label);
        label.style.width = width + "px";
        label.style.textAlign = "center";
        label.style.color = options.tickColor;
        label.style.fontSize = options.fontSize + "px";
        label.style.position = "absolute";
        label.style.top = options.borderSize + "px";
        label.style.left = left + "px";
        label.textContent = "-\u221E";
        return label;
    };
    var createChannelMask = function(parent, width, top, left, transition) {
        var channelMask = document.createElement("div");
        parent.appendChild(channelMask);
        channelMask.style.width = width + "px";
        channelMask.style.height = meterHeight + "px";
        channelMask.style.position = "absolute";
        channelMask.style.top = top + "px";
        channelMask.style.left = left + "px";
        channelMask.style.backgroundColor = options.backgroundColor;
        if (transition) channelMask.style.transition = options.maskTransition;
        return channelMask;
    };
    var maskSize = function(floatVal) {
        if (floatVal === 0.0) return meterHeight;
        else {
            var d = options.dbRange * -1;
            var returnVal = Math.floor(dbFromFloat(floatVal) * meterHeight / d);
            if (returnVal > meterHeight) return meterHeight;
            else return returnVal;
        }
    };
    var updateMeter = function(audioProcessingEvent) {
        var inputBuffer = audioProcessingEvent.inputBuffer;
        var i;
        var channelData = [];
        var channelMaxes = [];
        for(i = 0; i < channelCount; i++){
            channelData[i] = inputBuffer.getChannelData(i);
            channelMaxes[i] = 0.0;
        }
        for(var sample = 0; sample < inputBuffer.length; sample++){
            for(i = 0; i < channelCount; i++)if (Math.abs(channelData[i][sample]) > channelMaxes[i]) channelMaxes[i] = Math.abs(channelData[i][sample]);
        }
        for(i = 0; i < channelCount; i++){
            var thisMaskSize = maskSize(channelMaxes[i], meterHeight);
            channelMasks[i].style.height = thisMaskSize + "px";
            if (channelMaxes[i] > channelPeaks[i]) {
                channelPeaks[i] = channelMaxes[i];
                var labelText = dbFromFloat(channelPeaks[i]).toFixed(1);
                channelPeakLabels[i].textContent = labelText;
            }
        }
    };
    return {
        createMeterNode: createMeterNode,
        createMeter: createMeter
    };
}();
module.exports = $f4f669b5fcda5fb9$var$webAudioPeakMeter;

});


parcelRegister("71oKe", function(module, exports) {

var $jwUJU = parcelRequire("jwUJU");

var $33ozY = parcelRequire("33ozY");

var $iqYmi = parcelRequire("iqYmi");
EntityModule.registerInitializer(function(node) {
    $51cbd22bd6464c2f$export$12d4796d2d741b40(node);
});
function $51cbd22bd6464c2f$export$12d4796d2d741b40(node) {
    $(".js-asset-tracking-button", node).each($51cbd22bd6464c2f$var$initializeAssetTrackingButton);
}
function $51cbd22bd6464c2f$var$initializeAssetTrackingButton(index, node) {
    node.addEventListener("click", $51cbd22bd6464c2f$var$showAssetTrackingModal);
}
function $51cbd22bd6464c2f$var$initializeUrlFields(node) {
    $(".url-field", node).each($51cbd22bd6464c2f$var$initializeUrlField);
    $("[data-action='remove-item']", node).each($51cbd22bd6464c2f$var$initializeRemoveButton);
}
function $51cbd22bd6464c2f$var$initializeUrlField(index, node) {
    node.addEventListener("blur", $51cbd22bd6464c2f$var$validateUrlField);
}
function $51cbd22bd6464c2f$var$initializeRemoveButton(index, node) {
    node.addEventListener("click", $51cbd22bd6464c2f$var$evaluateAssetTrackingForm);
}
function $51cbd22bd6464c2f$var$evaluateAssetTrackingForm() {
    const $form = $("#assetTrackingForm");
    const $submitButton = $form.find("button[type='submit']");
    $submitButton.attr("disabled", $form.find(".is-invalid").length > 0);
    $("[role='tabpanel']", $form).each((i, node)=>{
        const $node = $(node);
        const tabPanelId = $node.attr("id");
        const $tabHeader = $(`a[href='#${tabPanelId}'][role='tab']`);
        if ($node.find(".is-invalid").length === 0) {
            $tabHeader.removeClass("text-danger");
            $tabHeader.find("i").remove();
        } else if ($tabHeader.find(".fa-exclamation-circle").length === 0) {
            $tabHeader.addClass("text-danger");
            $tabHeader.prepend('<i class="fas fa-exclamation-circle fa-xs mr-1"></i>');
        }
    });
}
function $51cbd22bd6464c2f$var$validateUrlField() {
    const $this = $(this);
    const value = $this.val();
    const required = $this.attr("required") !== undefined;
    //TODO can't we just check if this an actually valid url, we have a lot of support for URL parsing in JS
    const valid = required ? value && value.startsWith("https://") : !value || value.startsWith("https://");
    $this.parent().find(".invalid-feedback").remove();
    if (!valid) {
        $this.addClass("is-invalid");
        $this.after(`<div class="invalid-feedback">${(0, $33ozY.default).t("asset-tracking.tabs.url-field.error")}</div>`);
    } else $this.removeClass("is-invalid");
    $51cbd22bd6464c2f$var$evaluateAssetTrackingForm();
}
function $51cbd22bd6464c2f$var$showAssetTrackingModal(e) {
    const $this = $(this);
    const $parent = $this.parent();
    const assetId = $this.attr("data-asset-id");
    const dataPropertyId = $parent.attr("data-em-property-id");
    const blade = $(".asset-details-blade-wrapper").get(0);
    const campaignAssetId = blade != null ? blade.getAttribute("data-campaign-asset-id") : null;
    const paramSuffix = campaignAssetId != null ? "&campaignAssetId=" + campaignAssetId : "";
    const entityPrefix = dataPropertyId.substring(0, dataPropertyId.lastIndexOf("/"));
    fetch("/manager/asset-tracking-modal?assetId=" + assetId + paramSuffix).then((data)=>data.text()).then((data)=>{
        $("#modal .modal-dialog").addClass("modal-xl modal-tracking-detail");
        $("#modal .modal-content").html(data);
        $("#modal").modal("show");
        EntityModule.initializeFormElements($("#modal"));
        //make sure the last element is always in view
        $("button[data-action=add-item]").on("click", function(e) {
            const $this = $(this);
            const $collectionActions = $this.closest(".embedded-collection-actions");
            const $collectionItems = $collectionActions.siblings(".embedded-collection-items");
            const $lastItem = $collectionItems.find(".embedded-collection-item-data").last();
            $lastItem.get(0).scrollIntoView({
                behavior: "smooth",
                block: "end"
            });
        });
        const $assetTrackingForm = $("#assetTrackingForm");
        $assetTrackingForm.on("submit", function(e) {
            e.preventDefault();
            e.stopPropagation();
            const $this = $(this);
            const formData = new FormData(document.querySelector("#assetTrackingForm"));
            fetch($this.attr("action"), {
                method: "post",
                headers: {
                    "X-XSRF-Token": (0, $jwUJU.getCookie)("XSRF-TOKEN")
                },
                body: formData
            }).then((0, $jwUJU.convertResponseToJson)).then((data)=>{
                if (data.success) {
                    $("#modal").modal("hide");
                    $.each(data.properties, function(propertyName, propertyData) {
                        (0, $iqYmi.updatePropertyData)(entityPrefix + "/" + propertyName, propertyData);
                    });
                } else {
                    const errors = data.errors.trackingData;
                    const assetTrackingFormErrors = $("#assetTrackingFormErrors");
                    assetTrackingFormErrors.empty();
                    //only display the first error
                    if (errors.length > 0) assetTrackingFormErrors.append('<i class="fas fa-exclamation-triangle mr-2"></i>' + (0, $33ozY.default).t(errors[0].code));
                }
            }).catch((0, $jwUJU.handleError));
        });
        $51cbd22bd6464c2f$var$initializeUrlFields($assetTrackingForm);
        $("[data-action='add-item']", $assetTrackingForm).on("click", ()=>{
            $(".url-field:last", $assetTrackingForm).focus();
            $51cbd22bd6464c2f$var$initializeUrlFields($assetTrackingForm);
        });
        $("[data-toggle='tab']", $assetTrackingForm).on("shown.bs.tab", ()=>{
            // eslint-disable-next-line no-undef
            autosize.update($("#assetTrackingForm textarea"));
        });
    });
}

});

parcelRegister("5CGf6", function(module, exports) {
EntityModule.registerInitializer(function(node) {
    $418144e0ac07fa7e$export$cc1b6f08ea76f1b1(node);
});
function $418144e0ac07fa7e$export$cc1b6f08ea76f1b1(node) {
    $(".js-warning-modal", node).off().on("click", function(event) {
        $418144e0ac07fa7e$var$warningModal($(this).attr("data-text-warning"));
    });
}
function $418144e0ac07fa7e$var$warningModal(text) {
    $("#warningModal .modal-body-content").html(text);
    $("#warningModal").modal("show");
}

});

parcelRegister("7KoNM", function(module, exports) {

$parcel$export(module.exports, "initializeSigningButton", () => $5a401168562ced7d$export$41da6dafa9502a3d);

var $33ozY = parcelRequire("33ozY");

var $bg8Ty = parcelRequire("bg8Ty");
function $5a401168562ced7d$export$41da6dafa9502a3d() {
    $("#sign-sales-order-btn").on("click", function(event) {
        event.preventDefault();
        const campaignId = $(this).data("campaign-id");
        const salesOrderId = $(this).data("sales-order-id");
        $("#signingLoadingModal").modal("hide");
        $.ajax({
            type: "POST",
            url: `/manager/campaigns/${campaignId}/salesorder/${salesOrderId}/sign`,
            headers: {
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest"
            },
            success: function(response) {
                $("#signingLoadingModal").modal("hide");
                window.location.href = decodeURI(response);
            },
            error: function(xhr) {
                console.error("AJAX Error:", xhr.status, xhr.responseText);
                $("#signingLoadingModal").modal("hide");
                if (xhr.status === 409) try {
                    const conflictResponse = JSON.parse(xhr.responseText);
                    console.log("Conflict response:", conflictResponse); // TODO: Remove this line after testing
                    if (conflictResponse.expires_in && conflictResponse.expires_in.includes("Another user is already viewing")) {
                        console.log("Showing conflict modal"); // TODO: Remove this line after testing
                        $("#signingConflictModal").modal("show");
                        return;
                    }
                } catch (e) {
                    console.error("Error parsing conflict response:", e);
                }
                (0, $bg8Ty.showErrorModal)((0, $33ozY.default).t(xhr.responseText));
            }
        });
    });
}

});

parcelRegister("g49wf", function(module, exports) {
EntityModule.registerInitializer(function(node) {
    $bb24675c03089392$var$initializeNavMenu();
});
function $bb24675c03089392$var$initializeNavMenu() {
    document.querySelectorAll(".top-nav .top-nav-2-opener").forEach((el)=>{
        const anchor = el.querySelector("a");
        anchor.removeEventListener("click", $bb24675c03089392$var$toggleTopNav2);
        anchor.addEventListener("click", $bb24675c03089392$var$toggleTopNav2);
    });
    $("a").mousedown(function(e) {
        e.preventDefault();
    });
}
function $bb24675c03089392$var$toggleTopNav2(e) {
    const topNav2 = document.querySelector(".top-nav-2");
    e.preventDefault();
    topNav2.classList.toggle("visible");
}

});



parcelRequire("lbIEO");

var $jwUJU = parcelRequire("jwUJU");

var $4k8rO = parcelRequire("4k8rO");
EntityModule.registerInitializer(function(node) {
    $("#loginForm").removeAttr("disabled").off().submit(function() {
        (0, $4k8rO.showSpinnerCenter)("#loginNext");
        (0, $4k8rO.showSpinnerCenter)("#login");
    });
    $("#emailSubmission").off().click(function(e) {
        e.preventDefault();
        const emailDetails = $(this).closest("form").serialize();
        $a60ddfba76ddadb0$var$register(emailDetails);
    });
    $(".TogglePassword").click(function() {
        $(this).toggleClass("fa-eye fa-eye-slash");
        var input = $("#password");
        if (input.attr("type") === "password") input.attr("type", "text");
        else input.attr("type", "password");
    });
});
function $a60ddfba76ddadb0$var$register(emailDetails) {
    $a60ddfba76ddadb0$var$postAndRender(`/register?state=EMAIL_REQUIRED`, emailDetails, "#registrationLandingModal");
}
function $a60ddfba76ddadb0$var$postAndRender(url, body, selector, callback) {
    fetch(url, {
        method: "post",
        redirect: "follow",
        headers: (0, $jwUJU.getTokenSafeHeaders)(),
        body: body
    }).then((0, $jwUJU.convertResponseToTextWithoutSettingRedirectUrl)).then((html)=>{
        const requestedContent = $(html).find(selector).html();
        $(selector).html(requestedContent);
        if (typeof callback !== "undefined") callback();
        EntityModule.initializeFormElements($(selector));
    }).catch((0, $jwUJU.handleError));
}
function $a60ddfba76ddadb0$var$attachRegistrationFormSubmit() {
    $("#emailSubmission").off().click(function(e) {
        e.preventDefault();
        const emailDetails = $(this).closest("form").serialize();
        $a60ddfba76ddadb0$var$register(emailDetails);
    });
}
function $a60ddfba76ddadb0$var$register(emailDetails) {
    (0, $4k8rO.showSpinner)("#emailSubmission");
    fetch(`/register?state=EMAIL_REQUIRED`, {
        method: "post",
        redirect: "follow",
        headers: {
            "X-XSRF-Token": (0, $jwUJU.getCookie)("XSRF-TOKEN"),
            "Content-Type": "application/x-www-form-urlencoded",
            "Accept-Language": navigator.language
        },
        body: emailDetails
    }).then((0, $jwUJU.convertResponseToText)).then((html)=>{
        (0, $4k8rO.hideSpinner)("#emailSubmission");
        const requestedContent = $(html).find("#registrationLandingModal").html();
        $("#registrationLandingModal").html(requestedContent);
        EntityModule.initializeFormElements($("#registrationLandingModal"));
        $a60ddfba76ddadb0$var$attachRegistrationFormSubmit();
    }).catch((0, $jwUJU.handleError));
}

})();
//# sourceMappingURL=landingpage.js.map
